var Zw = Object.defineProperty;
var Nw = (t, e, r) => e in t ? Zw(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var q = (t, e, r) => (Nw(t, typeof e != "symbol" ? e + "" : e, r), r);
import { ref as u5, computed as g5, unref as Z5, getCurrentScope as Bw, onScopeDispose as Rw, getCurrentInstance as Bi, onMounted as J1, nextTick as CL, watch as g1, watchEffect as Ri, defineComponent as J5, reactive as un, pushScopeId as V0, popScopeId as W0, openBlock as G, createElementBlock as J, normalizeClass as N5, renderSlot as d1, createElementVNode as w, withDirectives as ne, vShow as zt, createBlock as sr, resolveDynamicComponent as Tl, toRefs as ht, onUnmounted as SL, Fragment as Be, Teleport as Hw, normalizeStyle as Xe, createVNode as s5, isRef as T0, createCommentVNode as _1, withCtx as Je, withKeys as Ol, Transition as DL, withModifiers as _4, toDisplayString as y5, mergeProps as zl, vModelText as f4, renderList as G0, h as C5, useSlots as EL, onBeforeUnmount as Dn, vModelDynamic as Fw, createTextVNode as O0, createStaticVNode as Le, useCssVars as jw, resolveComponent as IL, onBeforeMount as Uw, defineAsyncComponent as Yw, createApp as Vw } from "vue";
var I1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function TL(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var it = {};
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var x9;
(function(t) {
  (function(e) {
    var r = typeof I1 == "object" ? I1 : typeof self == "object" ? self : typeof this == "object" ? this : Function("return this;")(), n = L(t);
    typeof r.Reflect > "u" ? r.Reflect = t : n = L(r.Reflect, n), e(n);
    function L(i, l) {
      return function(s, c) {
        typeof i[s] != "function" && Object.defineProperty(i, s, { configurable: !0, writable: !0, value: c }), l && l(s, c);
      };
    }
  })(function(e) {
    var r = Object.prototype.hasOwnProperty, n = typeof Symbol == "function", L = n && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", i = n && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", l = typeof Object.create == "function", s = { __proto__: [] } instanceof Array, c = !l && !s, h = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: l ? function() {
        return z1(/* @__PURE__ */ Object.create(null));
      } : s ? function() {
        return z1({ __proto__: null });
      } : function() {
        return z1({});
      },
      has: c ? function(z, N) {
        return r.call(z, N);
      } : function(z, N) {
        return N in z;
      },
      get: c ? function(z, N) {
        return r.call(z, N) ? z[N] : void 0;
      } : function(z, N) {
        return z[N];
      }
    }, f = Object.getPrototypeOf(Function), g = typeof process == "object" && process.env && process.env.REFLECT_METADATA_USE_MAP_POLYFILL === "true", m = !g && typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : O1(), b = !g && typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : x1(), k = !g && typeof WeakMap == "function" ? WeakMap : U1(), x = new k();
    function D(z, N, j, Q) {
      if (f5(j)) {
        if (!Ue(z))
          throw new TypeError();
        if (!n5(N))
          throw new TypeError();
        return K(z, N);
      } else {
        if (!Ue(z))
          throw new TypeError();
        if (!I5(N))
          throw new TypeError();
        if (!I5(Q) && !f5(Q) && !e1(Q))
          throw new TypeError();
        return e1(Q) && (Q = void 0), j = a1(j), r5(z, N, j, Q);
      }
    }
    e("decorate", D);
    function M(z, N) {
      function j(Q, i5) {
        if (!I5(Q))
          throw new TypeError();
        if (!f5(i5) && !e5(i5))
          throw new TypeError();
        M5(z, N, Q, i5);
      }
      return j;
    }
    e("metadata", M);
    function E(z, N, j, Q) {
      if (!I5(j))
        throw new TypeError();
      return f5(Q) || (Q = a1(Q)), M5(z, N, j, Q);
    }
    e("defineMetadata", E);
    function S(z, N, j) {
      if (!I5(N))
        throw new TypeError();
      return f5(j) || (j = a1(j)), V(z, N, j);
    }
    e("hasMetadata", S);
    function C(z, N, j) {
      if (!I5(N))
        throw new TypeError();
      return f5(j) || (j = a1(j)), l5(z, N, j);
    }
    e("hasOwnMetadata", C);
    function P(z, N, j) {
      if (!I5(N))
        throw new TypeError();
      return f5(j) || (j = a1(j)), d5(z, N, j);
    }
    e("getMetadata", P);
    function A(z, N, j) {
      if (!I5(N))
        throw new TypeError();
      return f5(j) || (j = a1(j)), m5(z, N, j);
    }
    e("getOwnMetadata", A);
    function Z(z, N) {
      if (!I5(z))
        throw new TypeError();
      return f5(N) || (N = a1(N)), _5(z, N);
    }
    e("getMetadataKeys", Z);
    function B(z, N) {
      if (!I5(z))
        throw new TypeError();
      return f5(N) || (N = a1(N)), $5(z, N);
    }
    e("getOwnMetadataKeys", B);
    function U(z, N, j) {
      if (!I5(N))
        throw new TypeError();
      f5(j) || (j = a1(j));
      var Q = a5(
        N,
        j,
        /*Create*/
        !1
      );
      if (f5(Q) || !Q.delete(z))
        return !1;
      if (Q.size > 0)
        return !0;
      var i5 = x.get(N);
      return i5.delete(j), i5.size > 0 || x.delete(N), !0;
    }
    e("deleteMetadata", U);
    function K(z, N) {
      for (var j = z.length - 1; j >= 0; --j) {
        var Q = z[j], i5 = Q(N);
        if (!f5(i5) && !e1(i5)) {
          if (!n5(i5))
            throw new TypeError();
          N = i5;
        }
      }
      return N;
    }
    function r5(z, N, j, Q) {
      for (var i5 = z.length - 1; i5 >= 0; --i5) {
        var n1 = z[i5], b5 = n1(N, j, Q);
        if (!f5(b5) && !e1(b5)) {
          if (!I5(b5))
            throw new TypeError();
          Q = b5;
        }
      }
      return Q;
    }
    function a5(z, N, j) {
      var Q = x.get(z);
      if (f5(Q)) {
        if (!j)
          return;
        Q = new m(), x.set(z, Q);
      }
      var i5 = Q.get(N);
      if (f5(i5)) {
        if (!j)
          return;
        i5 = new m(), Q.set(N, i5);
      }
      return i5;
    }
    function V(z, N, j) {
      var Q = l5(z, N, j);
      if (Q)
        return !0;
      var i5 = S1(N);
      return e1(i5) ? !1 : V(z, i5, j);
    }
    function l5(z, N, j) {
      var Q = a5(
        N,
        j,
        /*Create*/
        !1
      );
      return f5(Q) ? !1 : f1(Q.has(z));
    }
    function d5(z, N, j) {
      var Q = l5(z, N, j);
      if (Q)
        return m5(z, N, j);
      var i5 = S1(N);
      if (!e1(i5))
        return d5(z, i5, j);
    }
    function m5(z, N, j) {
      var Q = a5(
        N,
        j,
        /*Create*/
        !1
      );
      if (!f5(Q))
        return Q.get(z);
    }
    function M5(z, N, j, Q) {
      var i5 = a5(
        j,
        Q,
        /*Create*/
        !0
      );
      i5.set(z, N);
    }
    function _5(z, N) {
      var j = $5(z, N), Q = S1(z);
      if (Q === null)
        return j;
      var i5 = _5(Q, N);
      if (i5.length <= 0)
        return j;
      if (j.length <= 0)
        return i5;
      for (var n1 = new b(), b5 = [], T5 = 0, p5 = j; T5 < p5.length; T5++) {
        var H5 = p5[T5], F5 = n1.has(H5);
        F5 || (n1.add(H5), b5.push(H5));
      }
      for (var Me = 0, Hr = i5; Me < Hr.length; Me++) {
        var H5 = Hr[Me], F5 = n1.has(H5);
        F5 || (n1.add(H5), b5.push(H5));
      }
      return b5;
    }
    function $5(z, N) {
      var j = [], Q = a5(
        z,
        N,
        /*Create*/
        !1
      );
      if (f5(Q))
        return j;
      for (var i5 = Q.keys(), n1 = w5(i5), b5 = 0; ; ) {
        var T5 = r1(n1);
        if (!T5)
          return j.length = b5, j;
        var p5 = P5(T5);
        try {
          j[b5] = p5;
        } catch (H5) {
          try {
            j1(n1);
          } finally {
            throw H5;
          }
        }
        b5++;
      }
    }
    function E5(z) {
      if (z === null)
        return 1;
      switch (typeof z) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return z === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function f5(z) {
      return z === void 0;
    }
    function e1(z) {
      return z === null;
    }
    function C1(z) {
      return typeof z == "symbol";
    }
    function I5(z) {
      return typeof z == "object" ? z !== null : typeof z == "function";
    }
    function R5(z, N) {
      switch (E5(z)) {
        case 0:
          return z;
        case 1:
          return z;
        case 2:
          return z;
        case 3:
          return z;
        case 4:
          return z;
        case 5:
          return z;
      }
      var j = N === 3 ? "string" : N === 5 ? "number" : "default", Q = o5(z, L);
      if (Q !== void 0) {
        var i5 = Q.call(z, j);
        if (I5(i5))
          throw new TypeError();
        return i5;
      }
      return L1(z, j === "default" ? "number" : j);
    }
    function L1(z, N) {
      if (N === "string") {
        var j = z.toString;
        if (W(j)) {
          var Q = j.call(z);
          if (!I5(Q))
            return Q;
        }
        var i5 = z.valueOf;
        if (W(i5)) {
          var Q = i5.call(z);
          if (!I5(Q))
            return Q;
        }
      } else {
        var i5 = z.valueOf;
        if (W(i5)) {
          var Q = i5.call(z);
          if (!I5(Q))
            return Q;
        }
        var n1 = z.toString;
        if (W(n1)) {
          var Q = n1.call(z);
          if (!I5(Q))
            return Q;
        }
      }
      throw new TypeError();
    }
    function f1(z) {
      return !!z;
    }
    function t1(z) {
      return "" + z;
    }
    function a1(z) {
      var N = R5(
        z,
        3
        /* String */
      );
      return C1(N) ? N : t1(N);
    }
    function Ue(z) {
      return Array.isArray ? Array.isArray(z) : z instanceof Object ? z instanceof Array : Object.prototype.toString.call(z) === "[object Array]";
    }
    function W(z) {
      return typeof z == "function";
    }
    function n5(z) {
      return typeof z == "function";
    }
    function e5(z) {
      switch (E5(z)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function o5(z, N) {
      var j = z[N];
      if (j != null) {
        if (!W(j))
          throw new TypeError();
        return j;
      }
    }
    function w5(z) {
      var N = o5(z, i);
      if (!W(N))
        throw new TypeError();
      var j = N.call(z);
      if (!I5(j))
        throw new TypeError();
      return j;
    }
    function P5(z) {
      return z.value;
    }
    function r1(z) {
      var N = z.next();
      return N.done ? !1 : N;
    }
    function j1(z) {
      var N = z.return;
      N && N.call(z);
    }
    function S1(z) {
      var N = Object.getPrototypeOf(z);
      if (typeof z != "function" || z === f || N !== f)
        return N;
      var j = z.prototype, Q = j && Object.getPrototypeOf(j);
      if (Q == null || Q === Object.prototype)
        return N;
      var i5 = Q.constructor;
      return typeof i5 != "function" || i5 === z ? N : i5;
    }
    function O1() {
      var z = {}, N = [], j = (
        /** @class */
        function() {
          function b5(T5, p5, H5) {
            this._index = 0, this._keys = T5, this._values = p5, this._selector = H5;
          }
          return b5.prototype["@@iterator"] = function() {
            return this;
          }, b5.prototype[i] = function() {
            return this;
          }, b5.prototype.next = function() {
            var T5 = this._index;
            if (T5 >= 0 && T5 < this._keys.length) {
              var p5 = this._selector(this._keys[T5], this._values[T5]);
              return T5 + 1 >= this._keys.length ? (this._index = -1, this._keys = N, this._values = N) : this._index++, { value: p5, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, b5.prototype.throw = function(T5) {
            throw this._index >= 0 && (this._index = -1, this._keys = N, this._values = N), T5;
          }, b5.prototype.return = function(T5) {
            return this._index >= 0 && (this._index = -1, this._keys = N, this._values = N), { value: T5, done: !0 };
          }, b5;
        }()
      );
      return (
        /** @class */
        function() {
          function b5() {
            this._keys = [], this._values = [], this._cacheKey = z, this._cacheIndex = -2;
          }
          return Object.defineProperty(b5.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), b5.prototype.has = function(T5) {
            return this._find(
              T5,
              /*insert*/
              !1
            ) >= 0;
          }, b5.prototype.get = function(T5) {
            var p5 = this._find(
              T5,
              /*insert*/
              !1
            );
            return p5 >= 0 ? this._values[p5] : void 0;
          }, b5.prototype.set = function(T5, p5) {
            var H5 = this._find(
              T5,
              /*insert*/
              !0
            );
            return this._values[H5] = p5, this;
          }, b5.prototype.delete = function(T5) {
            var p5 = this._find(
              T5,
              /*insert*/
              !1
            );
            if (p5 >= 0) {
              for (var H5 = this._keys.length, F5 = p5 + 1; F5 < H5; F5++)
                this._keys[F5 - 1] = this._keys[F5], this._values[F5 - 1] = this._values[F5];
              return this._keys.length--, this._values.length--, T5 === this._cacheKey && (this._cacheKey = z, this._cacheIndex = -2), !0;
            }
            return !1;
          }, b5.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = z, this._cacheIndex = -2;
          }, b5.prototype.keys = function() {
            return new j(this._keys, this._values, Q);
          }, b5.prototype.values = function() {
            return new j(this._keys, this._values, i5);
          }, b5.prototype.entries = function() {
            return new j(this._keys, this._values, n1);
          }, b5.prototype["@@iterator"] = function() {
            return this.entries();
          }, b5.prototype[i] = function() {
            return this.entries();
          }, b5.prototype._find = function(T5, p5) {
            return this._cacheKey !== T5 && (this._cacheIndex = this._keys.indexOf(this._cacheKey = T5)), this._cacheIndex < 0 && p5 && (this._cacheIndex = this._keys.length, this._keys.push(T5), this._values.push(void 0)), this._cacheIndex;
          }, b5;
        }()
      );
      function Q(b5, T5) {
        return b5;
      }
      function i5(b5, T5) {
        return T5;
      }
      function n1(b5, T5) {
        return [b5, T5];
      }
    }
    function x1() {
      return (
        /** @class */
        function() {
          function z() {
            this._map = new m();
          }
          return Object.defineProperty(z.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), z.prototype.has = function(N) {
            return this._map.has(N);
          }, z.prototype.add = function(N) {
            return this._map.set(N, N), this;
          }, z.prototype.delete = function(N) {
            return this._map.delete(N);
          }, z.prototype.clear = function() {
            this._map.clear();
          }, z.prototype.keys = function() {
            return this._map.keys();
          }, z.prototype.values = function() {
            return this._map.values();
          }, z.prototype.entries = function() {
            return this._map.entries();
          }, z.prototype["@@iterator"] = function() {
            return this.keys();
          }, z.prototype[i] = function() {
            return this.keys();
          }, z;
        }()
      );
    }
    function U1() {
      var z = 16, N = h.create(), j = Q();
      return (
        /** @class */
        function() {
          function p5() {
            this._key = Q();
          }
          return p5.prototype.has = function(H5) {
            var F5 = i5(
              H5,
              /*create*/
              !1
            );
            return F5 !== void 0 ? h.has(F5, this._key) : !1;
          }, p5.prototype.get = function(H5) {
            var F5 = i5(
              H5,
              /*create*/
              !1
            );
            return F5 !== void 0 ? h.get(F5, this._key) : void 0;
          }, p5.prototype.set = function(H5, F5) {
            var Me = i5(
              H5,
              /*create*/
              !0
            );
            return Me[this._key] = F5, this;
          }, p5.prototype.delete = function(H5) {
            var F5 = i5(
              H5,
              /*create*/
              !1
            );
            return F5 !== void 0 ? delete F5[this._key] : !1;
          }, p5.prototype.clear = function() {
            this._key = Q();
          }, p5;
        }()
      );
      function Q() {
        var p5;
        do
          p5 = "@@WeakMap@@" + T5();
        while (h.has(N, p5));
        return N[p5] = !0, p5;
      }
      function i5(p5, H5) {
        if (!r.call(p5, j)) {
          if (!H5)
            return;
          Object.defineProperty(p5, j, { value: h.create() });
        }
        return p5[j];
      }
      function n1(p5, H5) {
        for (var F5 = 0; F5 < H5; ++F5)
          p5[F5] = Math.random() * 255 | 0;
        return p5;
      }
      function b5(p5) {
        return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(p5)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(p5)) : n1(new Uint8Array(p5), p5) : n1(new Array(p5), p5);
      }
      function T5() {
        var p5 = b5(z);
        p5[6] = p5[6] & 79 | 64, p5[8] = p5[8] & 191 | 128;
        for (var H5 = "", F5 = 0; F5 < z; ++F5) {
          var Me = p5[F5];
          (F5 === 4 || F5 === 6 || F5 === 8) && (H5 += "-"), Me < 16 && (H5 += "0"), H5 += Me.toString(16).toLowerCase();
        }
        return H5;
      }
    }
    function z1(z) {
      return z.__ = void 0, delete z.__, z;
    }
  });
})(x9 || (x9 = {}));
var Or = {};
Object.defineProperty(Or, "__esModule", { value: !0 });
class Ww {
  /**
   * Called by the IoC Container when some configuration is changed on the Container binding.
   * @param _source The source type that has its configuration changed.
   */
  reset(e) {
  }
  /**
   * Called by the IoC Container when the the target type is bound to this scope
   * @param _source The source type that is bound to that scope.
   */
  init(e) {
  }
  /**
   * Called by the IoC Container when the the target type is unbound to this scope
   * @param _source The source type that is unbound to that scope.
   */
  finish(e) {
  }
}
Or.Scope = Ww;
class Gw {
}
Or.BuildContext = Gw;
var V4 = {}, q0 = {};
Object.defineProperty(q0, "__esModule", { value: !0 });
const K2 = "__BuildContext", qw = "ioc_wrapper";
class Ot {
  static instrumentConstructor(e) {
    let r;
    return r = class extends e {
      constructor(...L) {
        super(...L), Ot.assertInstantiable();
      }
    }, r.__parent = e, r;
  }
  static blockInstantiation(e) {
    Ot.instantiationsBlocked = e;
  }
  static unblockInstantiation() {
    const e = Ot.instantiationsBlocked;
    return Ot.instantiationsBlocked = !1, e;
  }
  static getConstructorFromType(e) {
    let r = e;
    if (this.hasNamedConstructor(r))
      return r;
    for (r = r.__parent; r; ) {
      if (this.hasNamedConstructor(r))
        return r;
      r = r.__parent;
    }
    throw TypeError("Can not identify the base Type for requested target " + e.toString());
  }
  static checkType(e) {
    if (!e)
      throw new TypeError("Invalid type requested to IoC container. Type is not defined.");
  }
  static checkName(e) {
    if (!e)
      throw new TypeError("Invalid name requested to IoC container. Name is not defined.");
  }
  static injectContext(e, r) {
    e[K2] = r;
  }
  static removeContext(e) {
    delete e[K2];
  }
  static injectProperty(e, r, n, L) {
    const i = `__${r}`;
    Object.defineProperty(e.prototype, r, {
      enumerable: !0,
      get: function() {
        const l = this[K2] || e[K2];
        return this[i] ? this[i] : this[i] = L(n, l);
      },
      set: function(l) {
        this[i] = l;
      }
    });
  }
  static injectValueProperty(e, r, n, L) {
    const i = `__${r}`;
    Object.defineProperty(e.prototype, r, {
      enumerable: !0,
      get: function() {
        return this[i] ? this[i] : this[i] = L(n);
      },
      set: function(l) {
        this[i] = l;
      }
    });
  }
  static hasNamedConstructor(e) {
    if (e.name)
      return e.name !== "ioc_wrapper";
    try {
      const r = e.prototype.constructor.toString().match(this.constructorNameRegEx)[1];
      return r && r !== qw;
    } catch {
    }
    return !1;
  }
  static assertInstantiable() {
    if (Ot.instantiationsBlocked)
      throw new TypeError("Can not instantiate it. The instantiation is blocked for this class. Ask Container for it, using Container.get");
  }
}
q0.InjectorHandler = Ot;
Ot.constructorNameRegEx = /function (\w*)/;
Ot.instantiationsBlocked = !0;
var K0 = {}, Kw = "Expected a function", Pl = "__lodash_hash_undefined__", Al = 1 / 0, Jw = "[object Function]", Qw = "[object GeneratorFunction]", Xw = "[object Symbol]", eb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, tb = /^\w*$/, rb = /^\./, nb = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ob = /[\\^$.*+?()[\]{}|]/g, ib = /\\(\\)?/g, Lb = /^\[object .+?Constructor\]$/, ab = typeof I1 == "object" && I1 && I1.Object === Object && I1, sb = typeof self == "object" && self && self.Object === Object && self, OL = ab || sb || Function("return this")();
function lb(t, e) {
  return t == null ? void 0 : t[e];
}
function ub(t) {
  var e = !1;
  if (t != null && typeof t.toString != "function")
    try {
      e = !!(t + "");
    } catch {
    }
  return e;
}
var cb = Array.prototype, hb = Function.prototype, $l = Object.prototype, W6 = OL["__core-js_shared__"], k9 = function() {
  var t = /[^.]+$/.exec(W6 && W6.keys && W6.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}(), Zl = hb.toString, zL = $l.hasOwnProperty, Nl = $l.toString, db = RegExp(
  "^" + Zl.call(zL).replace(ob, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), M9 = OL.Symbol, fb = cb.splice, pb = Bl(OL, "Map"), z0 = Bl(Object, "create"), _9 = M9 ? M9.prototype : void 0, C9 = _9 ? _9.toString : void 0;
function Sr(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function gb() {
  this.__data__ = z0 ? z0(null) : {};
}
function mb(t) {
  return this.has(t) && delete this.__data__[t];
}
function vb(t) {
  var e = this.__data__;
  if (z0) {
    var r = e[t];
    return r === Pl ? void 0 : r;
  }
  return zL.call(e, t) ? e[t] : void 0;
}
function yb(t) {
  var e = this.__data__;
  return z0 ? e[t] !== void 0 : zL.call(e, t);
}
function wb(t, e) {
  var r = this.__data__;
  return r[t] = z0 && e === void 0 ? Pl : e, this;
}
Sr.prototype.clear = gb;
Sr.prototype.delete = mb;
Sr.prototype.get = vb;
Sr.prototype.has = yb;
Sr.prototype.set = wb;
function En(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function bb() {
  this.__data__ = [];
}
function xb(t) {
  var e = this.__data__, r = W4(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : fb.call(e, r, 1), !0;
}
function kb(t) {
  var e = this.__data__, r = W4(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function Mb(t) {
  return W4(this.__data__, t) > -1;
}
function _b(t, e) {
  var r = this.__data__, n = W4(r, t);
  return n < 0 ? r.push([t, e]) : r[n][1] = e, this;
}
En.prototype.clear = bb;
En.prototype.delete = xb;
En.prototype.get = kb;
En.prototype.has = Mb;
En.prototype.set = _b;
function zr(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function Cb() {
  this.__data__ = {
    hash: new Sr(),
    map: new (pb || En)(),
    string: new Sr()
  };
}
function Sb(t) {
  return G4(this, t).delete(t);
}
function Db(t) {
  return G4(this, t).get(t);
}
function Eb(t) {
  return G4(this, t).has(t);
}
function Ib(t, e) {
  return G4(this, t).set(t, e), this;
}
zr.prototype.clear = Cb;
zr.prototype.delete = Sb;
zr.prototype.get = Db;
zr.prototype.has = Eb;
zr.prototype.set = Ib;
function W4(t, e) {
  for (var r = t.length; r--; )
    if (Hb(t[r][0], e))
      return r;
  return -1;
}
function Tb(t, e) {
  e = Ab(e, t) ? [e] : Pb(e);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[Bb(e[r++])];
  return r && r == n ? t : void 0;
}
function Ob(t) {
  if (!Hl(t) || Zb(t))
    return !1;
  var e = Fb(t) || ub(t) ? db : Lb;
  return e.test(Rb(t));
}
function zb(t) {
  if (typeof t == "string")
    return t;
  if (AL(t))
    return C9 ? C9.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -Al ? "-0" : e;
}
function Pb(t) {
  return Rl(t) ? t : Nb(t);
}
function G4(t, e) {
  var r = t.__data__;
  return $b(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function Bl(t, e) {
  var r = lb(t, e);
  return Ob(r) ? r : void 0;
}
function Ab(t, e) {
  if (Rl(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || AL(t) ? !0 : tb.test(t) || !eb.test(t) || e != null && t in Object(e);
}
function $b(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function Zb(t) {
  return !!k9 && k9 in t;
}
var Nb = PL(function(t) {
  t = Ub(t);
  var e = [];
  return rb.test(t) && e.push(""), t.replace(nb, function(r, n, L, i) {
    e.push(L ? i.replace(ib, "$1") : n || r);
  }), e;
});
function Bb(t) {
  if (typeof t == "string" || AL(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -Al ? "-0" : e;
}
function Rb(t) {
  if (t != null) {
    try {
      return Zl.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
function PL(t, e) {
  if (typeof t != "function" || e && typeof e != "function")
    throw new TypeError(Kw);
  var r = function() {
    var n = arguments, L = e ? e.apply(this, n) : n[0], i = r.cache;
    if (i.has(L))
      return i.get(L);
    var l = t.apply(this, n);
    return r.cache = i.set(L, l), l;
  };
  return r.cache = new (PL.Cache || zr)(), r;
}
PL.Cache = zr;
function Hb(t, e) {
  return t === e || t !== t && e !== e;
}
var Rl = Array.isArray;
function Fb(t) {
  var e = Hl(t) ? Nl.call(t) : "";
  return e == Jw || e == Qw;
}
function Hl(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function jb(t) {
  return !!t && typeof t == "object";
}
function AL(t) {
  return typeof t == "symbol" || jb(t) && Nl.call(t) == Xw;
}
function Ub(t) {
  return t == null ? "" : zb(t);
}
function Yb(t, e, r) {
  var n = t == null ? void 0 : Tb(t, e);
  return n === void 0 ? r : n;
}
var Vb = Yb, Wb = "Expected a function", Fl = "__lodash_hash_undefined__", jl = 1 / 0, Gb = 9007199254740991, qb = "[object Function]", Kb = "[object GeneratorFunction]", Jb = "[object Symbol]", Qb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Xb = /^\w*$/, ex = /^\./, tx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, rx = /[\\^$.*+?()[\]{}|]/g, nx = /\\(\\)?/g, ox = /^\[object .+?Constructor\]$/, ix = /^(?:0|[1-9]\d*)$/, Lx = typeof I1 == "object" && I1 && I1.Object === Object && I1, ax = typeof self == "object" && self && self.Object === Object && self, $L = Lx || ax || Function("return this")();
function sx(t, e) {
  return t == null ? void 0 : t[e];
}
function lx(t) {
  var e = !1;
  if (t != null && typeof t.toString != "function")
    try {
      e = !!(t + "");
    } catch {
    }
  return e;
}
var ux = Array.prototype, cx = Function.prototype, Ul = Object.prototype, G6 = $L["__core-js_shared__"], S9 = function() {
  var t = /[^.]+$/.exec(G6 && G6.keys && G6.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}(), Yl = cx.toString, q4 = Ul.hasOwnProperty, Vl = Ul.toString, hx = RegExp(
  "^" + Yl.call(q4).replace(rx, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), D9 = $L.Symbol, dx = ux.splice, fx = Wl($L, "Map"), P0 = Wl(Object, "create"), E9 = D9 ? D9.prototype : void 0, I9 = E9 ? E9.toString : void 0;
function Dr(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function px() {
  this.__data__ = P0 ? P0(null) : {};
}
function gx(t) {
  return this.has(t) && delete this.__data__[t];
}
function mx(t) {
  var e = this.__data__;
  if (P0) {
    var r = e[t];
    return r === Fl ? void 0 : r;
  }
  return q4.call(e, t) ? e[t] : void 0;
}
function vx(t) {
  var e = this.__data__;
  return P0 ? e[t] !== void 0 : q4.call(e, t);
}
function yx(t, e) {
  var r = this.__data__;
  return r[t] = P0 && e === void 0 ? Fl : e, this;
}
Dr.prototype.clear = px;
Dr.prototype.delete = gx;
Dr.prototype.get = mx;
Dr.prototype.has = vx;
Dr.prototype.set = yx;
function In(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function wx() {
  this.__data__ = [];
}
function bx(t) {
  var e = this.__data__, r = K4(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : dx.call(e, r, 1), !0;
}
function xx(t) {
  var e = this.__data__, r = K4(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function kx(t) {
  return K4(this.__data__, t) > -1;
}
function Mx(t, e) {
  var r = this.__data__, n = K4(r, t);
  return n < 0 ? r.push([t, e]) : r[n][1] = e, this;
}
In.prototype.clear = wx;
In.prototype.delete = bx;
In.prototype.get = xx;
In.prototype.has = kx;
In.prototype.set = Mx;
function Pr(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function _x() {
  this.__data__ = {
    hash: new Dr(),
    map: new (fx || In)(),
    string: new Dr()
  };
}
function Cx(t) {
  return J4(this, t).delete(t);
}
function Sx(t) {
  return J4(this, t).get(t);
}
function Dx(t) {
  return J4(this, t).has(t);
}
function Ex(t, e) {
  return J4(this, t).set(t, e), this;
}
Pr.prototype.clear = _x;
Pr.prototype.delete = Cx;
Pr.prototype.get = Sx;
Pr.prototype.has = Dx;
Pr.prototype.set = Ex;
function Ix(t, e, r) {
  var n = t[e];
  (!(q4.call(t, e) && Gl(n, r)) || r === void 0 && !(e in t)) && (t[e] = r);
}
function K4(t, e) {
  for (var r = t.length; r--; )
    if (Gl(t[r][0], e))
      return r;
  return -1;
}
function Tx(t) {
  if (!C4(t) || Nx(t))
    return !1;
  var e = Fx(t) || lx(t) ? hx : ox;
  return e.test(Hx(t));
}
function Ox(t, e, r, n) {
  if (!C4(t))
    return t;
  e = $x(e, t) ? [e] : Px(e);
  for (var L = -1, i = e.length, l = i - 1, s = t; s != null && ++L < i; ) {
    var c = Rx(e[L]), h = r;
    if (L != l) {
      var f = s[c];
      h = n ? n(f, c, s) : void 0, h === void 0 && (h = C4(f) ? f : Ax(e[L + 1]) ? [] : {});
    }
    Ix(s, c, h), s = s[c];
  }
  return t;
}
function zx(t) {
  if (typeof t == "string")
    return t;
  if (NL(t))
    return I9 ? I9.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -jl ? "-0" : e;
}
function Px(t) {
  return ql(t) ? t : Bx(t);
}
function J4(t, e) {
  var r = t.__data__;
  return Zx(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function Wl(t, e) {
  var r = sx(t, e);
  return Tx(r) ? r : void 0;
}
function Ax(t, e) {
  return e = e ?? Gb, !!e && (typeof t == "number" || ix.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function $x(t, e) {
  if (ql(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || NL(t) ? !0 : Xb.test(t) || !Qb.test(t) || e != null && t in Object(e);
}
function Zx(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function Nx(t) {
  return !!S9 && S9 in t;
}
var Bx = ZL(function(t) {
  t = Ux(t);
  var e = [];
  return ex.test(t) && e.push(""), t.replace(tx, function(r, n, L, i) {
    e.push(L ? i.replace(nx, "$1") : n || r);
  }), e;
});
function Rx(t) {
  if (typeof t == "string" || NL(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -jl ? "-0" : e;
}
function Hx(t) {
  if (t != null) {
    try {
      return Yl.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
function ZL(t, e) {
  if (typeof t != "function" || e && typeof e != "function")
    throw new TypeError(Wb);
  var r = function() {
    var n = arguments, L = e ? e.apply(this, n) : n[0], i = r.cache;
    if (i.has(L))
      return i.get(L);
    var l = t.apply(this, n);
    return r.cache = i.set(L, l), l;
  };
  return r.cache = new (ZL.Cache || Pr)(), r;
}
ZL.Cache = Pr;
function Gl(t, e) {
  return t === e || t !== t && e !== e;
}
var ql = Array.isArray;
function Fx(t) {
  var e = C4(t) ? Vl.call(t) : "";
  return e == qb || e == Kb;
}
function C4(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function jx(t) {
  return !!t && typeof t == "object";
}
function NL(t) {
  return typeof t == "symbol" || jx(t) && Vl.call(t) == Jb;
}
function Ux(t) {
  return t == null ? "" : zx(t);
}
function Yx(t, e, r) {
  return t == null ? t : Ox(t, e, r);
}
var Vx = Yx;
Object.defineProperty(K0, "__esModule", { value: !0 });
const Gt = q0, Wx = Or, Gx = Vb, qx = Vx;
class BL {
  constructor(e, r, n) {
    this.source = e, this.instanceFactory = r, this.valueFactory = n;
  }
  to(e) {
    Gt.InjectorHandler.checkType(e);
    const r = Gt.InjectorHandler.getConstructorFromType(e);
    return this.targetSource = r, this.source === r ? this.factory((n) => {
      const L = this.getParameters(n), i = this.decoratedConstructor || e;
      return L ? new i(...L) : new i();
    }) : this.factory((n) => this.instanceFactory(e, n)), this;
  }
  factory(e) {
    return this.iocFactory = (r) => {
      const n = Gt.InjectorHandler.unblockInstantiation(), L = this.decoratedConstructor || this.targetSource || this.source;
      Gt.InjectorHandler.injectContext(L, r);
      const i = e(r);
      return Gt.InjectorHandler.removeContext(L), Gt.InjectorHandler.injectContext(i, r), Gt.InjectorHandler.blockInstantiation(n), i;
    }, this.iocScope && this.iocScope.reset(this.source), this;
  }
  scope(e) {
    return this.iocScope && this.iocScope !== e && this.iocScope.finish(this.source), this.iocScope = e, this.iocScope && this.iocScope.init(this.source), this;
  }
  withParams(...e) {
    return this.paramTypes = e, this;
  }
  instrumentConstructor() {
    const e = Gt.InjectorHandler.instrumentConstructor(this.source);
    return this.decoratedConstructor = e, this.source.constructor = e, this;
  }
  getInstance(e) {
    return this.iocScope || this.scope(Wx.Scope.Local), this.iocScope.resolve(this.iocFactory, this.source, e);
  }
  clone() {
    const e = new BL(this.source, this.instanceFactory, this.valueFactory);
    return e.iocFactory = this.iocFactory, e.iocScope = this.iocScope, e.targetSource = this.targetSource, e.paramTypes = this.paramTypes, e.decoratedConstructor = this.decoratedConstructor, e;
  }
  getParameters(e) {
    return this.paramTypes ? this.paramTypes.map((r) => typeof r == "string" || r instanceof String ? this.valueFactory(r) : this.instanceFactory(r, e)) : null;
  }
}
K0.IoCBindConfig = BL;
class RL {
  constructor(e) {
    this.name = e;
  }
  to(e) {
    return this.path ? (this.value = this.value || {}, qx(this.value, this.path, e)) : this.value = e, this;
  }
  getValue() {
    return this.path ? Gx(this.value, this.path) : this.value;
  }
  clone() {
    const e = new RL(this.name);
    return e.path = this.path, e.value = this.value, e;
  }
}
K0.IoCBindValueConfig = RL;
class b0 {
  constructor(e, r) {
    this.name = e, this.path = r;
  }
  static parse(e) {
    const r = e.indexOf(".");
    if (r < 0)
      return new b0(e);
    if (r === 0)
      throw new TypeError(`Invalid value [${e}] passed to Container.bindName`);
    return r + 1 < e.length ? new b0(e.substring(0, r), e.substring(r + 1)) : new b0(e.substring(0, r));
  }
}
K0.PropertyPath = b0;
var HL = {};
Object.defineProperty(HL, "__esModule", { value: !0 });
class Kx {
  constructor() {
    this.defaultNamespace = new T9(null), this.namespaces = /* @__PURE__ */ new Map();
  }
  get(e) {
    let r;
    return this.currentNamespace && (r = this.currentNamespace.get(e), r) ? r : this.defaultNamespace.get(e);
  }
  set(e, r) {
    (this.currentNamespace || this.defaultNamespace).set(e, r);
  }
  getValue(e) {
    let r;
    return this.currentNamespace && (r = this.currentNamespace.getValue(e), r) ? r : this.defaultNamespace.getValue(e);
  }
  setValue(e, r) {
    (this.currentNamespace || this.defaultNamespace).setValue(e, r);
  }
  selectNamespace(e) {
    if (e) {
      let r = this.namespaces.get(e);
      r || (r = new T9(e), this.namespaces.set(e, r)), this.currentNamespace = r;
    } else
      this.currentNamespace = null;
  }
  removeNamespace(e) {
    const r = this.namespaces.get(e);
    r && (this.currentNamespace && r.name === this.currentNamespace.name && (this.currentNamespace = null), r.clear(), this.namespaces.delete(e));
  }
  selectedNamespace() {
    return this.currentNamespace ? this.currentNamespace.name : null;
  }
}
HL.ContainerNamespaces = Kx;
class T9 {
  constructor(e) {
    this.bindings = /* @__PURE__ */ new Map(), this.values = /* @__PURE__ */ new Map(), this.name = e;
  }
  get(e) {
    return this.bindings.get(e);
  }
  set(e, r) {
    r.namespace = this.name, this.bindings.set(e, r);
  }
  getValue(e) {
    return this.values.get(e);
  }
  setValue(e, r) {
    r.namespace = this.name, this.values.set(e, r);
  }
  clear() {
    this.bindings.clear(), this.values.clear();
  }
}
Object.defineProperty(V4, "__esModule", { value: !0 });
const xr = q0, q6 = K0, Jx = HL;
class u1 {
  static bind(e, r = !1) {
    xr.InjectorHandler.checkType(e);
    const n = xr.InjectorHandler.getConstructorFromType(e);
    let L = u1.namespaces.get(n);
    return L ? !r && L.namespace !== u1.namespaces.selectedNamespace() && (L = L.clone(), u1.namespaces.set(n, L)) : (L = new q6.IoCBindConfig(n, u1.get, u1.getValue), L.to(e), u1.namespaces.set(n, L)), L;
  }
  static bindName(e, r = !1) {
    xr.InjectorHandler.checkName(e);
    const n = q6.PropertyPath.parse(e);
    let L = u1.namespaces.getValue(n.name);
    return L ? !r && L.namespace !== u1.namespaces.selectedNamespace() && (L = L.clone(), u1.namespaces.setValue(n.name, L)) : (L = new q6.IoCBindValueConfig(n.name), u1.namespaces.setValue(n.name, L)), L.path = n.path, L;
  }
  static get(e, r) {
    const n = u1.bind(e, !0);
    return n.iocFactory || n.to(n.source), n.getInstance(r);
  }
  static getValue(e) {
    return u1.bindName(e, !0).getValue();
  }
  static getType(e) {
    xr.InjectorHandler.checkType(e);
    const r = xr.InjectorHandler.getConstructorFromType(e), n = u1.namespaces.get(r);
    if (!n)
      throw new TypeError(`The type ${e.name} hasn't been registered with the IOC Container`);
    return n.targetSource || n.source;
  }
  static namespace(e) {
    return u1.namespaces.selectNamespace(e), {
      remove: () => {
        e && u1.namespaces.removeNamespace(e);
      }
    };
  }
  static selectedNamespace() {
    return u1.namespaces.selectedNamespace();
  }
  static injectProperty(e, r, n) {
    xr.InjectorHandler.injectProperty(e, r, n, u1.get);
  }
  static injectValueProperty(e, r, n) {
    xr.InjectorHandler.injectValueProperty(e, r, n, u1.getValue);
  }
  /**
   * Create a temporary namespace. Useful for testing.
   */
  static snapshot() {
    const e = `_snapshot-${u1.snapshotsCount++}`, r = u1.namespace(e);
    return {
      restore: () => r.remove(),
      select: () => u1.namespace(e)
    };
  }
}
V4.IoCContainer = u1;
u1.namespaces = new Jx.ContainerNamespaces();
u1.snapshotsCount = 0;
var J0 = {};
Object.defineProperty(J0, "__esModule", { value: !0 });
const Qx = q0, FL = Or;
class Xx extends FL.Scope {
  resolve(e, r, n) {
    return e(n);
  }
}
J0.LocalScope = Xx;
class sn extends FL.Scope {
  resolve(e, r, n) {
    let L = sn.instances.get(r);
    return L || (L = e(n), sn.instances.set(r, L)), L;
  }
  reset(e) {
    sn.instances.delete(Qx.InjectorHandler.getConstructorFromType(e));
  }
  init(e) {
    this.reset(e);
  }
  finish(e) {
    this.reset(e);
  }
}
J0.SingletonScope = sn;
sn.instances = /* @__PURE__ */ new Map();
class ek extends FL.Scope {
  resolve(e, r, n) {
    return this.ensureContext(n), n.build(r, e);
  }
  ensureContext(e) {
    if (!e)
      throw new TypeError("IoC Container can not handle this request. When using @InRequestScope in any dependent type, you should be askking to Container to create the instances through Container.get and not calling the type constructor directly.");
  }
}
J0.RequestScope = ek;
var $t = {};
Object.defineProperty($t, "__esModule", { value: !0 });
const Zt = V4, Kl = Or;
function tk(t) {
  Zt.IoCContainer.bind(t).scope(Kl.Scope.Request);
}
$t.InRequestScope = tk;
function rk(t) {
  Zt.IoCContainer.bind(t).scope(Kl.Scope.Singleton);
}
$t.Singleton = rk;
function nk(t) {
  return Zt.IoCContainer.bind(t).instrumentConstructor().decoratedConstructor;
}
$t.OnlyInstantiableByContainer = nk;
function ok(t) {
  return (e) => {
    Zt.IoCContainer.bind(e).scope(t);
  };
}
$t.Scoped = ok;
function ik(t) {
  return (e) => {
    Zt.IoCContainer.bind(e).factory(t);
  };
}
$t.Factory = ik;
function Lk(...t) {
  if (t.length === 2 || t.length === 3 && typeof t[2] > "u")
    return sk.apply(this, t);
  if (t.length === 3 && typeof t[2] == "number")
    return lk.apply(this, t);
  throw new TypeError("Invalid @Inject Decorator declaration.");
}
$t.Inject = Lk;
function ak(t) {
  return (...e) => {
    if (e.length === 2 || e.length === 3 && typeof e[2] > "u") {
      const r = [...e, t].filter((n) => !!n);
      return uk.apply(this, r);
    } else if (e.length === 3 && typeof e[2] == "number")
      return ck.apply(this, [...e, t]);
    throw new TypeError("Invalid @InjectValue Decorator declaration.");
  };
}
$t.InjectValue = ak;
function sk(t, e) {
  let r = Reflect.getMetadata("design:type", t, e);
  r || (r = Reflect.getMetadata("design:type", t.constructor, e)), Zt.IoCContainer.injectProperty(t.constructor, e, r);
}
function lk(t, e, r) {
  if (!e) {
    const n = Zt.IoCContainer.bind(t);
    n.paramTypes = n.paramTypes || [];
    const L = Reflect.getMetadata("design:paramtypes", t);
    n.paramTypes.unshift(L[r]);
  }
}
function uk(t, e, r) {
  Zt.IoCContainer.injectValueProperty(t.constructor, e, r);
}
function ck(t, e, r, n) {
  if (!e) {
    const L = Zt.IoCContainer.bind(t);
    L.paramTypes = L.paramTypes || [], L.paramTypes.unshift(n);
  }
}
Object.defineProperty(it, "__esModule", { value: !0 });
const Tn = Or;
it.Scope = Tn.Scope;
it.BuildContext = Tn.BuildContext;
const Ke = V4, jL = J0;
var Ar = $t;
it.Inject = Ar.Inject;
it.Factory = Ar.Factory;
var Q4 = it.Singleton = Ar.Singleton;
it.Scoped = Ar.Scoped;
it.OnlyInstantiableByContainer = Ar.OnlyInstantiableByContainer;
it.InRequestScope = Ar.InRequestScope;
it.InjectValue = Ar.InjectValue;
Tn.Scope.Local = new jL.LocalScope();
Tn.Scope.Singleton = new jL.SingletonScope();
Tn.Scope.Request = new jL.RequestScope();
class It {
  /**
   * Add a dependency to the Container. If this type is already present, just return its associated
   * configuration object.
   * Example of usage:
   *
   * ```
   * Container.bind(PersonDAO).to(ProgrammerDAO).scope(Scope.Singleton);
   * ```
   * @param source The type that will be bound to the Container
   * @return a container configuration
   */
  static bind(e) {
    return Ke.IoCContainer.bind(e);
  }
  /**
   * Retrieve an object from the container. It will resolve all dependencies and apply any type replacement
   * before return the object.
   * If there is no declared dependency to the given source type, an implicity bind is performed to this type.
   * @param source The dependency type to resolve
   * @return an object resolved for the given source type;
   */
  static get(e) {
    return Ke.IoCContainer.get(e, new hk());
  }
  /**
   * Retrieve a type associated with the type provided from the container
   * @param source The dependency type to resolve
   * @return an object resolved for the given source type;
   */
  static getType(e) {
    return Ke.IoCContainer.getType(e);
  }
  /**
   *
   * @param name
   */
  static bindName(e) {
    return Ke.IoCContainer.bindName(e);
  }
  /**
   * Retrieve a constant from the container.
   * @param name The name of the constant used to identify these binding
   * @return the constant value
   */
  static getValue(e) {
    return Ke.IoCContainer.getValue(e);
  }
  /**
   * Select the current namespace to work.
   * @param name The namespace name, or null to select the default namespace
   */
  static namespace(e) {
    return Ke.IoCContainer.namespace(e);
  }
  /**
   * An alias to namespace method.
   * @param name The namespace name, or null to select the default namespace
   */
  static environment(e) {
    return It.namespace(e);
  }
  /**
   * Store the state for a specified binding.  Can then be restored later.   Useful for testing.
   * @param source The dependency type
   */
  // _args is here to ensure backward compatibility
  static snapshot(e) {
    return Ke.IoCContainer.snapshot();
  }
  /**
   * Import an array of configurations to the Container
   * @param configurations
   */
  static configure(...e) {
    e.forEach((r) => {
      r.bind ? It.configureType(r) : r.bindName ? It.configureConstant(r) : (r.env || r.namespace) && It.configureNamespace(r);
    });
  }
  static configureNamespace(e) {
    const r = Ke.IoCContainer.selectedNamespace(), n = e.env || e.namespace;
    Object.keys(n).forEach((L) => {
      It.namespace(L);
      const i = n[L];
      It.configure(...i);
    }), It.namespace(r);
  }
  static configureConstant(e) {
    const r = Ke.IoCContainer.bindName(e.bindName);
    r && e.to && r.to(e.to);
  }
  static configureType(e) {
    const r = Ke.IoCContainer.bind(e.bind);
    r && (e.to ? r.to(e.to) : e.factory && r.factory(e.factory), e.scope && r.scope(e.scope), e.withParams && r.withParams(e.withParams));
  }
}
var Er = it.Container = It;
class hk extends Tn.BuildContext {
  constructor() {
    super(...arguments), this.context = /* @__PURE__ */ new Map();
  }
  build(e, r) {
    let n = this.context.get(e);
    return n || (n = r(this), this.context.set(e, n)), n;
  }
  resolve(e) {
    return Ke.IoCContainer.get(e, this);
  }
}
var dk = Object.defineProperty, fk = (t, e, r) => e in t ? dk(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, X = (t, e, r) => (fk(t, typeof e != "symbol" ? e + "" : e, r), r);
let pk = class {
  constructor(e, r = !1) {
    if (X(this, "resourceType", "Questionnaire"), X(this, "approvalDate"), X(this, "_approvalDate"), X(this, "code"), X(this, "contact"), X(this, "copyright"), X(this, "_copyright"), X(this, "date"), X(this, "_date"), X(this, "derivedFrom"), X(this, "_derivedFrom"), X(this, "description"), X(this, "_description"), X(this, "effectivePeriod"), X(this, "experimental"), X(this, "_experimental"), X(this, "identifier"), X(this, "item"), X(this, "jurisdiction"), X(this, "lastReviewDate"), X(this, "_lastReviewDate"), X(this, "name"), X(this, "_name"), X(this, "publisher"), X(this, "_publisher"), X(this, "purpose"), X(this, "_purpose"), X(this, "status"), X(this, "_status"), X(this, "subjectType"), X(this, "_subjectType"), X(this, "title"), X(this, "_title"), X(this, "url"), X(this, "_url"), X(this, "useContext"), X(this, "version"), X(this, "_version"), X(this, "contained"), X(this, "extension"), X(this, "modifierExtension"), X(this, "text"), X(this, "id"), X(this, "_id"), X(this, "implicitRules"), X(this, "_implicitRules"), X(this, "language"), X(this, "_language"), X(this, "meta"), !e)
      throw new Error("Questionnaire is required");
    if (!e.status)
      throw new Error("Questionnaire.status is required");
    const { status: n, ...L } = e;
    this.status = n, Object.assign(this, L), r && Object.keys(this).forEach((i) => {
      const l = i;
      this[l] === void 0 && delete this[l];
    });
  }
}, gk = class {
  constructor(e, r = !1) {
    if (X(this, "answerOption"), X(this, "answerValueSet"), X(this, "_answerValueSet"), X(this, "code"), X(this, "definition"), X(this, "_definition"), X(this, "enableBehavior"), X(this, "_enableBehavior"), X(this, "enableWhen"), X(this, "initial"), X(this, "item"), X(this, "linkId"), X(this, "_linkId"), X(this, "maxLength"), X(this, "prefix"), X(this, "_prefix"), X(this, "readOnly"), X(this, "_readOnly"), X(this, "repeats"), X(this, "_repeats"), X(this, "required"), X(this, "_required"), X(this, "text"), X(this, "_text"), X(this, "type"), X(this, "_type"), X(this, "modifierExtension"), X(this, "extension"), X(this, "id"), X(this, "_id"), !e)
      throw new Error("QuestionnaireItem is required");
    if (!e.linkId)
      throw new Error("QuestionnaireItem.linkId is required");
    const { type: n, linkId: L, ...i } = e;
    this.type = n, this.linkId = L, Object.assign(this, i), r && Object.keys(this).forEach((l) => {
      const s = l;
      this[s] === void 0 && delete this[s];
    });
  }
};
const mk = "https://visiontree.com/fhir/form-controls/implant", vk = "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl", yk = "http://hl7.org/fhir/StructureDefinition/maxValue", wk = "http://hl7.org/fhir/StructureDefinition/minValue", bk = "https://visiontree.com/fhir/form-controls/spine";
function $r(t, e) {
  var r;
  return (r = t.extension) == null ? void 0 : r.find((n) => n.url === e);
}
function xk(t) {
  var e, r;
  return (r = (e = t.item) == null ? void 0 : e.find(
    (n) => n.linkId === `${n.linkId}/help` || n.linkId.includes("help")
  )) == null ? void 0 : r.text;
}
function kk(t) {
  return $r(t, mk) !== void 0;
}
function Mk(t) {
  var e;
  const r = $r(t, vk);
  return (e = r == null ? void 0 : r.valueCodeableConcept) == null ? void 0 : e.text;
}
function _k(t) {
  const e = $r(t, yk);
  return e ? e.valueInteger || e.valueDecimal : void 0;
}
function Ck(t) {
  const e = $r(t, wk);
  return e ? e.valueInteger || e.valueDecimal : void 0;
}
function Sk(t) {
  return $r(t, bk) !== void 0;
}
function Dk(t) {
  var e;
  const r = $r(
    t,
    "http://hl7.org/fhir/StructureDefinition/questionnaire-unitOption"
  );
  return (e = r == null ? void 0 : r.valueCoding) == null ? void 0 : e.display;
}
const U25 = {
  getExtensions: $r,
  getHelpText: xk,
  getImplantEnabled: kk,
  getItemControlCodeableConcept: Mk,
  getMaxValue: _k,
  getMinValue: Ck,
  getSpineEnabled: Sk,
  getUnitOption: Dk
}, Y25 = (t) => Array.isArray(t), V25 = (t) => typeof t == "string";
function Ek() {
  this.__data__ = [], this.size = 0;
}
var Ik = Ek;
function Tk(t, e) {
  return t === e || t !== t && e !== e;
}
var X4 = Tk, Ok = X4;
function zk(t, e) {
  for (var r = t.length; r--; )
    if (Ok(t[r][0], e))
      return r;
  return -1;
}
var eo = zk, Pk = eo, Ak = Array.prototype, $k = Ak.splice;
function Zk(t) {
  var e = this.__data__, r = Pk(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : $k.call(e, r, 1), --this.size, !0;
}
var Nk = Zk, Bk = eo;
function Rk(t) {
  var e = this.__data__, r = Bk(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var Hk = Rk, Fk = eo;
function jk(t) {
  return Fk(this.__data__, t) > -1;
}
var Uk = jk, Yk = eo;
function Vk(t, e) {
  var r = this.__data__, n = Yk(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
var Wk = Vk, Gk = Ik, qk = Nk, Kk = Hk, Jk = Uk, Qk = Wk;
function On(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
On.prototype.clear = Gk;
On.prototype.delete = qk;
On.prototype.get = Kk;
On.prototype.has = Jk;
On.prototype.set = Qk;
var to = On, Xk = to;
function eM() {
  this.__data__ = new Xk(), this.size = 0;
}
var tM = eM;
function rM(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var nM = rM;
function oM(t) {
  return this.__data__.get(t);
}
var iM = oM;
function LM(t) {
  return this.__data__.has(t);
}
var aM = LM, sM = typeof I1 == "object" && I1 && I1.Object === Object && I1, Jl = sM, lM = Jl, uM = typeof self == "object" && self && self.Object === Object && self, cM = lM || uM || Function("return this")(), zn = cM, hM = zn, dM = hM.Symbol, Ql = dM, O9 = Ql, Xl = Object.prototype, fM = Xl.hasOwnProperty, pM = Xl.toString, h0 = O9 ? O9.toStringTag : void 0;
function gM(t) {
  var e = fM.call(t, h0), r = t[h0];
  try {
    t[h0] = void 0;
    var n = !0;
  } catch {
  }
  var L = pM.call(t);
  return n && (e ? t[h0] = r : delete t[h0]), L;
}
var mM = gM, vM = Object.prototype, yM = vM.toString;
function wM(t) {
  return yM.call(t);
}
var bM = wM, z9 = Ql, xM = mM, kM = bM, MM = "[object Null]", _M = "[object Undefined]", P9 = z9 ? z9.toStringTag : void 0;
function CM(t) {
  return t == null ? t === void 0 ? _M : MM : P9 && P9 in Object(t) ? xM(t) : kM(t);
}
var ro = CM;
function SM(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Zr = SM, DM = ro, EM = Zr, IM = "[object AsyncFunction]", TM = "[object Function]", OM = "[object GeneratorFunction]", zM = "[object Proxy]";
function PM(t) {
  if (!EM(t))
    return !1;
  var e = DM(t);
  return e == TM || e == OM || e == IM || e == zM;
}
var UL = PM, AM = zn, $M = AM["__core-js_shared__"], ZM = $M, K6 = ZM, A9 = function() {
  var t = /[^.]+$/.exec(K6 && K6.keys && K6.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function NM(t) {
  return !!A9 && A9 in t;
}
var BM = NM, RM = Function.prototype, HM = RM.toString;
function FM(t) {
  if (t != null) {
    try {
      return HM.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var jM = FM, UM = UL, YM = BM, VM = Zr, WM = jM, GM = /[\\^$.*+?()[\]{}|]/g, qM = /^\[object .+?Constructor\]$/, KM = Function.prototype, JM = Object.prototype, QM = KM.toString, XM = JM.hasOwnProperty, e_ = RegExp(
  "^" + QM.call(XM).replace(GM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function t_(t) {
  if (!VM(t) || YM(t))
    return !1;
  var e = UM(t) ? e_ : qM;
  return e.test(WM(t));
}
var r_ = t_;
function n_(t, e) {
  return t == null ? void 0 : t[e];
}
var o_ = n_, i_ = r_, L_ = o_;
function a_(t, e) {
  var r = L_(t, e);
  return i_(r) ? r : void 0;
}
var YL = a_, s_ = YL, l_ = zn, u_ = s_(l_, "Map"), eu = u_, c_ = YL, h_ = c_(Object, "create"), no = h_, $9 = no;
function d_() {
  this.__data__ = $9 ? $9(null) : {}, this.size = 0;
}
var f_ = d_;
function p_(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var g_ = p_, m_ = no, v_ = "__lodash_hash_undefined__", y_ = Object.prototype, w_ = y_.hasOwnProperty;
function b_(t) {
  var e = this.__data__;
  if (m_) {
    var r = e[t];
    return r === v_ ? void 0 : r;
  }
  return w_.call(e, t) ? e[t] : void 0;
}
var x_ = b_, k_ = no, M_ = Object.prototype, __ = M_.hasOwnProperty;
function C_(t) {
  var e = this.__data__;
  return k_ ? e[t] !== void 0 : __.call(e, t);
}
var S_ = C_, D_ = no, E_ = "__lodash_hash_undefined__";
function I_(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = D_ && e === void 0 ? E_ : e, this;
}
var T_ = I_, O_ = f_, z_ = g_, P_ = x_, A_ = S_, $_ = T_;
function Pn(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Pn.prototype.clear = O_;
Pn.prototype.delete = z_;
Pn.prototype.get = P_;
Pn.prototype.has = A_;
Pn.prototype.set = $_;
var Z_ = Pn, Z9 = Z_, N_ = to, B_ = eu;
function R_() {
  this.size = 0, this.__data__ = {
    hash: new Z9(),
    map: new (B_ || N_)(),
    string: new Z9()
  };
}
var H_ = R_;
function F_(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var j_ = F_, U_ = j_;
function Y_(t, e) {
  var r = t.__data__;
  return U_(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var oo = Y_, V_ = oo;
function W_(t) {
  var e = V_(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var G_ = W_, q_ = oo;
function K_(t) {
  return q_(this, t).get(t);
}
var J_ = K_, Q_ = oo;
function X_(t) {
  return Q_(this, t).has(t);
}
var eC = X_, tC = oo;
function rC(t, e) {
  var r = tC(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
var nC = rC, oC = H_, iC = G_, LC = J_, aC = eC, sC = nC;
function An(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
An.prototype.clear = oC;
An.prototype.delete = iC;
An.prototype.get = LC;
An.prototype.has = aC;
An.prototype.set = sC;
var lC = An, uC = to, cC = eu, hC = lC, dC = 200;
function fC(t, e) {
  var r = this.__data__;
  if (r instanceof uC) {
    var n = r.__data__;
    if (!cC || n.length < dC - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new hC(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
var pC = fC, gC = to, mC = tM, vC = nM, yC = iM, wC = aM, bC = pC;
function $n(t) {
  var e = this.__data__ = new gC(t);
  this.size = e.size;
}
$n.prototype.clear = mC;
$n.prototype.delete = vC;
$n.prototype.get = yC;
$n.prototype.has = wC;
$n.prototype.set = bC;
var xC = $n, kC = YL, MC = function() {
  try {
    var t = kC(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), tu = MC, N9 = tu;
function _C(t, e, r) {
  e == "__proto__" && N9 ? N9(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var VL = _C, CC = VL, SC = X4;
function DC(t, e, r) {
  (r !== void 0 && !SC(t[e], r) || r === void 0 && !(e in t)) && CC(t, e, r);
}
var ru = DC;
function EC(t) {
  return function(e, r, n) {
    for (var L = -1, i = Object(e), l = n(e), s = l.length; s--; ) {
      var c = l[t ? s : ++L];
      if (r(i[c], c, i) === !1)
        break;
    }
    return e;
  };
}
var IC = EC, TC = IC, OC = TC(), zC = OC, S4 = { exports: {} };
S4.exports;
(function(t, e) {
  var r = zn, n = e && !e.nodeType && e, L = n && !0 && t && !t.nodeType && t, i = L && L.exports === n, l = i ? r.Buffer : void 0, s = l ? l.allocUnsafe : void 0;
  function c(h, f) {
    if (f)
      return h.slice();
    var g = h.length, m = s ? s(g) : new h.constructor(g);
    return h.copy(m), m;
  }
  t.exports = c;
})(S4, S4.exports);
var PC = S4.exports, AC = zn, $C = AC.Uint8Array, ZC = $C, B9 = ZC;
function NC(t) {
  var e = new t.constructor(t.byteLength);
  return new B9(e).set(new B9(t)), e;
}
var BC = NC, RC = BC;
function HC(t, e) {
  var r = e ? RC(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
}
var FC = HC;
function jC(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var UC = jC, YC = Zr, R9 = Object.create, VC = function() {
  function t() {
  }
  return function(e) {
    if (!YC(e))
      return {};
    if (R9)
      return R9(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}(), WC = VC;
function GC(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var qC = GC, KC = qC, JC = KC(Object.getPrototypeOf, Object), nu = JC, QC = Object.prototype;
function XC(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || QC;
  return t === r;
}
var ou = XC, eS = WC, tS = nu, rS = ou;
function nS(t) {
  return typeof t.constructor == "function" && !rS(t) ? eS(tS(t)) : {};
}
var oS = nS;
function iS(t) {
  return t != null && typeof t == "object";
}
var Q0 = iS, LS = ro, aS = Q0, sS = "[object Arguments]";
function lS(t) {
  return aS(t) && LS(t) == sS;
}
var uS = lS, H9 = uS, cS = Q0, iu = Object.prototype, hS = iu.hasOwnProperty, dS = iu.propertyIsEnumerable, fS = H9(function() {
  return arguments;
}()) ? H9 : function(t) {
  return cS(t) && hS.call(t, "callee") && !dS.call(t, "callee");
}, Lu = fS, pS = Array.isArray, au = pS, gS = 9007199254740991;
function mS(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= gS;
}
var su = mS, vS = UL, yS = su;
function wS(t) {
  return t != null && yS(t.length) && !vS(t);
}
var WL = wS, bS = WL, xS = Q0;
function kS(t) {
  return xS(t) && bS(t);
}
var MS = kS, D4 = { exports: {} };
function _S() {
  return !1;
}
var CS = _S;
D4.exports;
(function(t, e) {
  var r = zn, n = CS, L = e && !e.nodeType && e, i = L && !0 && t && !t.nodeType && t, l = i && i.exports === L, s = l ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, h = c || n;
  t.exports = h;
})(D4, D4.exports);
var lu = D4.exports, SS = ro, DS = nu, ES = Q0, IS = "[object Object]", TS = Function.prototype, OS = Object.prototype, uu = TS.toString, zS = OS.hasOwnProperty, PS = uu.call(Object);
function AS(t) {
  if (!ES(t) || SS(t) != IS)
    return !1;
  var e = DS(t);
  if (e === null)
    return !0;
  var r = zS.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && uu.call(r) == PS;
}
var $S = AS, ZS = ro, NS = su, BS = Q0, RS = "[object Arguments]", HS = "[object Array]", FS = "[object Boolean]", jS = "[object Date]", US = "[object Error]", YS = "[object Function]", VS = "[object Map]", WS = "[object Number]", GS = "[object Object]", qS = "[object RegExp]", KS = "[object Set]", JS = "[object String]", QS = "[object WeakMap]", XS = "[object ArrayBuffer]", eD = "[object DataView]", tD = "[object Float32Array]", rD = "[object Float64Array]", nD = "[object Int8Array]", oD = "[object Int16Array]", iD = "[object Int32Array]", LD = "[object Uint8Array]", aD = "[object Uint8ClampedArray]", sD = "[object Uint16Array]", lD = "[object Uint32Array]", c1 = {};
c1[tD] = c1[rD] = c1[nD] = c1[oD] = c1[iD] = c1[LD] = c1[aD] = c1[sD] = c1[lD] = !0;
c1[RS] = c1[HS] = c1[XS] = c1[FS] = c1[eD] = c1[jS] = c1[US] = c1[YS] = c1[VS] = c1[WS] = c1[GS] = c1[qS] = c1[KS] = c1[JS] = c1[QS] = !1;
function uD(t) {
  return BS(t) && NS(t.length) && !!c1[ZS(t)];
}
var cD = uD;
function hD(t) {
  return function(e) {
    return t(e);
  };
}
var dD = hD, E4 = { exports: {} };
E4.exports;
(function(t, e) {
  var r = Jl, n = e && !e.nodeType && e, L = n && !0 && t && !t.nodeType && t, i = L && L.exports === n, l = i && r.process, s = function() {
    try {
      var c = L && L.require && L.require("util").types;
      return c || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(E4, E4.exports);
var fD = E4.exports, pD = cD, gD = dD, F9 = fD, j9 = F9 && F9.isTypedArray, mD = j9 ? gD(j9) : pD, cu = mD;
function vD(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var hu = vD, yD = VL, wD = X4, bD = Object.prototype, xD = bD.hasOwnProperty;
function kD(t, e, r) {
  var n = t[e];
  (!(xD.call(t, e) && wD(n, r)) || r === void 0 && !(e in t)) && yD(t, e, r);
}
var MD = kD, _D = MD, CD = VL;
function SD(t, e, r, n) {
  var L = !r;
  r || (r = {});
  for (var i = -1, l = e.length; ++i < l; ) {
    var s = e[i], c = n ? n(r[s], t[s], s, r, t) : void 0;
    c === void 0 && (c = t[s]), L ? CD(r, s, c) : _D(r, s, c);
  }
  return r;
}
var DD = SD;
function ED(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var ID = ED, TD = 9007199254740991, OD = /^(?:0|[1-9]\d*)$/;
function zD(t, e) {
  var r = typeof t;
  return e = e ?? TD, !!e && (r == "number" || r != "symbol" && OD.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var du = zD, PD = ID, AD = Lu, $D = au, ZD = lu, ND = du, BD = cu, RD = Object.prototype, HD = RD.hasOwnProperty;
function FD(t, e) {
  var r = $D(t), n = !r && AD(t), L = !r && !n && ZD(t), i = !r && !n && !L && BD(t), l = r || n || L || i, s = l ? PD(t.length, String) : [], c = s.length;
  for (var h in t)
    (e || HD.call(t, h)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (h == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    L && (h == "offset" || h == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (h == "buffer" || h == "byteLength" || h == "byteOffset") || // Skip index properties.
    ND(h, c))) && s.push(h);
  return s;
}
var jD = FD;
function UD(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var YD = UD, VD = Zr, WD = ou, GD = YD, qD = Object.prototype, KD = qD.hasOwnProperty;
function JD(t) {
  if (!VD(t))
    return GD(t);
  var e = WD(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !KD.call(t, n)) || r.push(n);
  return r;
}
var QD = JD, XD = jD, eE = QD, tE = WL;
function rE(t) {
  return tE(t) ? XD(t, !0) : eE(t);
}
var fu = rE, nE = DD, oE = fu;
function iE(t) {
  return nE(t, oE(t));
}
var LE = iE, U9 = ru, aE = PC, sE = FC, lE = UC, uE = oS, Y9 = Lu, V9 = au, cE = MS, hE = lu, dE = UL, fE = Zr, pE = $S, gE = cu, W9 = hu, mE = LE;
function vE(t, e, r, n, L, i, l) {
  var s = W9(t, r), c = W9(e, r), h = l.get(c);
  if (h) {
    U9(t, r, h);
    return;
  }
  var f = i ? i(s, c, r + "", t, e, l) : void 0, g = f === void 0;
  if (g) {
    var m = V9(c), b = !m && hE(c), k = !m && !b && gE(c);
    f = c, m || b || k ? V9(s) ? f = s : cE(s) ? f = lE(s) : b ? (g = !1, f = aE(c, !0)) : k ? (g = !1, f = sE(c, !0)) : f = [] : pE(c) || Y9(c) ? (f = s, Y9(s) ? f = mE(s) : (!fE(s) || dE(s)) && (f = uE(c))) : g = !1;
  }
  g && (l.set(c, f), L(f, c, n, i, l), l.delete(c)), U9(t, r, f);
}
var yE = vE, wE = xC, bE = ru, xE = zC, kE = yE, ME = Zr, _E = fu, CE = hu;
function pu(t, e, r, n, L) {
  t !== e && xE(e, function(i, l) {
    if (L || (L = new wE()), ME(i))
      kE(t, e, l, r, pu, n, L);
    else {
      var s = n ? n(CE(t, l), i, l + "", t, e, L) : void 0;
      s === void 0 && (s = i), bE(t, l, s);
    }
  }, _E);
}
var SE = pu;
function DE(t) {
  return t;
}
var gu = DE;
function EE(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
var IE = EE, TE = IE, G9 = Math.max;
function OE(t, e, r) {
  return e = G9(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, L = -1, i = G9(n.length - e, 0), l = Array(i); ++L < i; )
      l[L] = n[e + L];
    L = -1;
    for (var s = Array(e + 1); ++L < e; )
      s[L] = n[L];
    return s[e] = r(l), TE(t, this, s);
  };
}
var zE = OE;
function PE(t) {
  return function() {
    return t;
  };
}
var AE = PE, $E = AE, q9 = tu, ZE = gu, NE = q9 ? function(t, e) {
  return q9(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: $E(e),
    writable: !0
  });
} : ZE, BE = NE, RE = 800, HE = 16, FE = Date.now;
function jE(t) {
  var e = 0, r = 0;
  return function() {
    var n = FE(), L = HE - (n - r);
    if (r = n, L > 0) {
      if (++e >= RE)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var UE = jE, YE = BE, VE = UE, WE = VE(YE), GE = WE, qE = gu, KE = zE, JE = GE;
function QE(t, e) {
  return JE(KE(t, e, qE), t + "");
}
var XE = QE, eI = X4, tI = WL, rI = du, nI = Zr;
function oI(t, e, r) {
  if (!nI(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? tI(r) && rI(e, r.length) : n == "string" && e in r) ? eI(r[e], t) : !1;
}
var iI = oI, LI = XE, aI = iI;
function sI(t) {
  return LI(function(e, r) {
    var n = -1, L = r.length, i = L > 1 ? r[L - 1] : void 0, l = L > 2 ? r[2] : void 0;
    for (i = t.length > 3 && typeof i == "function" ? (L--, i) : void 0, l && aI(r[0], r[1], l) && (i = L < 3 ? void 0 : i, L = 1), e = Object(e); ++n < L; ) {
      var s = r[n];
      s && t(e, s, n, i);
    }
    return e;
  });
}
var lI = sI, uI = SE, cI = lI, hI = cI(function(t, e, r) {
  uI(t, e, r);
}), dI = hI;
const rn = /* @__PURE__ */ TL(dI), A0 = {
  preferDarkMode: !0,
  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
    "3xl": "1792px"
  },
  light: {
    name: "light",
    "background-color": "#E3E0E0",
    "panel-color": "#fff",
    "text-color": "#000",
    "text-placeholder-color": "#757575",
    "focus-color": "#7d654e",
    "selected-color": "#03B0FF",
    "attention-color": "#F59E0B",
    "success-color": "#05E685",
    "error-color": "#CC382C",
    "border-color": "#E3E0E0,",
    "progress-bar": "#6BD38A",
    "button-background-default-color": "#E3E0E0",
    "button-background-radio-color": "#E3E0E0",
    "button-background-checkbox-color": "#E3E0E0",
    "icon-default-color": "#000000",
    "icon-secondary-color": "#fff",
    "icon-diminished-color": "#000000",
    "icon-hover-default-color": "#F2F0F0",
    "icon-hover-secondary-color": "#aed6be",
    "icon-hover-diminished-color": "#92a689",
    "minimap-background-color": "#fff",
    "minimap-item-border": "#E4E0E0",
    "tooltip-icon-background-color": "#E3E0E0",
    "tooltip-icon-background-hover-color": "#F2F0F0",
    "tooltip-icon-text-color": "#000",
    "tooltip-background-color": "#E3E0E0",
    "tooltip-border-color": "#F2F0F0",
    "calendar-background-color": "#fff",
    "calendar-selected-color": "#E3E0E0",
    "panel-connector-overlay-color": "#E3E0E0",
    "table-active-input-background-color": "#FBFBFB",
    "spine-selected": "#03B0FF",
    "spine-selected-light": "#03B0FF55",
    "spine-primary": "#DDDDDD",
    "spine-secondary": "#BFBFBF",
    "spine-tertiary": "#949494",
    "spine-stroke": "#707070",
    "spine-transparent": "#00000000",
    "spine-selector-selected": "#ffffff",
    "spine-stack-item-selected": "#ffffff"
  },
  dark: {
    name: "dark",
    "background-color": "#1f1f1f",
    "panel-color": "#3b3b3b",
    "text-color": "#FFFFFF",
    "text-placeholder-color": "#FFFFFF",
    "focus-color": "#535353",
    "selected-color": "#03B0FF",
    "attention-color": "#FAA21B",
    "success-color": "#05E685",
    "error-color": "#CC382C",
    "border-color": "#E3E3E3",
    "progress-bar": "#6BD38A",
    "button-background-default-color": "#1f1f1f",
    "button-background-radio-color": "#707070",
    "button-background-checkbox-color": "#707070",
    "icon-default-color": "#e3e3e3",
    "icon-secondary-color": "#4fadf8",
    "icon-diminished-color": "#C1C1C1",
    "icon-hover-default-color": "#c9c7c7",
    "icon-hover-secondary-color": "#83c8ff",
    "icon-hover-diminished-color": "#848484",
    "minimap-background-color": "#1f1f1f",
    "minimap-item-border": "#C9C7C7",
    "tooltip-icon-background-color": "#e3e3e3",
    "tooltip-icon-background-hover-color": "#c9c7c7",
    "tooltip-icon-text-color": "#1f1f1f",
    "tooltip-background-color": "#1f1f1f",
    "tooltip-border-color": "#c9c7c7",
    "calendar-background-color": "#1f1f1f",
    "calendar-selected-color": "#7E7D7D",
    "panel-connector-overlay-color": "#1f1f1f",
    "table-active-input-background-color": "#535353",
    "spine-selected": "#03B0FF",
    "spine-selected-light": "#03B0FF55",
    "spine-primary": "#BABABA",
    "spine-secondary": "#A2A2A2",
    "spine-tertiary": "#808080",
    "spine-stroke": "#888888",
    "spine-transparent": "#00000000",
    "spine-selector-selected": "#ffffff",
    "spine-stack-item-selected": "#ffffff"
  }
};
class fI {
  constructor() {
    q(this, "background-color", "");
    q(this, "panel-color", "");
    q(this, "text-color", "");
    q(this, "text-placeholder-color", "");
    q(this, "focus-color", "");
    q(this, "selected-color", "");
    q(this, "attention-color", "");
    q(this, "success-color", "");
    q(this, "error-color", "");
    q(this, "border-color", "");
    q(this, "progress-bar", "");
    q(this, "button-background-default-color", "");
    q(this, "button-background-radio-color", "");
    q(this, "button-background-checkbox-color", "");
    q(this, "icon-default-color", "");
    q(this, "icon-secondary-color", "");
    q(this, "icon-diminished-color", "");
    q(this, "icon-hover-default-color", "");
    q(this, "icon-hover-secondary-color", "");
    q(this, "icon-hover-diminished-color", "");
    q(this, "icon-tooltip-text-color", "");
    q(this, "minimap-background-color", "");
    q(this, "minimap-item-border", "");
    q(this, "tooltip-icon-background-color", "");
    q(this, "tooltip-icon-background-hover-color", "");
    q(this, "tooltip-icon-text-color", "");
    q(this, "tooltip-background-color", "");
    q(this, "tooltip-border-color", "");
    q(this, "calendar-background-color", "");
    q(this, "calendar-selected-color", "");
    q(this, "panel-connector-overlay-color", "");
    q(this, "table-active-input-background-color", "");
    q(this, "spine-selected", "");
    q(this, "spine-selected-light", "");
    q(this, "spine-primary", "");
    q(this, "spine-secondary", "");
    q(this, "spine-tertiary", "");
    q(this, "spine-stroke", "");
    q(this, "spine-transparent", "");
    q(this, "spine-selector-selected", "");
    q(this, "spine-stack-item-selected", "");
  }
}
const pI = (t) => {
  var n;
  let r;
  return ((n = t == null ? void 0 : t.ui) == null ? void 0 : n.layout) === "proms" ? r = rn(
    {
      log: "silent",
      save: rn(
        {
          methods: ["on-submit"]
        },
        t == null ? void 0 : t.save
      ),
      ui: rn(
        {
          layout: "proms",
          theme: A0,
          promsSettings: {
            questionsPerSection: 3,
            showPromsBackButton: !0
          }
        },
        t == null ? void 0 : t.ui
      )
    },
    t
  ) : r = rn(
    {
      log: "silent",
      save: rn(
        {
          methods: ["on-submit"]
        },
        t == null ? void 0 : t.save
      ),
      ui: rn(
        {
          layout: "clinical",
          theme: A0
        },
        t == null ? void 0 : t.ui
      )
    },
    t
  ), r;
};
var I4 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
I4.exports;
(function(t, e) {
  (function() {
    var r, n = "4.17.21", L = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", s = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", h = 500, f = "__lodash_placeholder__", g = 1, m = 2, b = 4, k = 1, x = 2, D = 1, M = 2, E = 4, S = 8, C = 16, P = 32, A = 64, Z = 128, B = 256, U = 512, K = 30, r5 = "...", a5 = 800, V = 16, l5 = 1, d5 = 2, m5 = 3, M5 = 1 / 0, _5 = 9007199254740991, $5 = 17976931348623157e292, E5 = 0 / 0, f5 = 4294967295, e1 = f5 - 1, C1 = f5 >>> 1, I5 = [
      ["ary", Z],
      ["bind", D],
      ["bindKey", M],
      ["curry", S],
      ["curryRight", C],
      ["flip", U],
      ["partial", P],
      ["partialRight", A],
      ["rearg", B]
    ], R5 = "[object Arguments]", L1 = "[object Array]", f1 = "[object AsyncFunction]", t1 = "[object Boolean]", a1 = "[object Date]", Ue = "[object DOMException]", W = "[object Error]", n5 = "[object Function]", e5 = "[object GeneratorFunction]", o5 = "[object Map]", w5 = "[object Number]", P5 = "[object Null]", r1 = "[object Object]", j1 = "[object Promise]", S1 = "[object Proxy]", O1 = "[object RegExp]", x1 = "[object Set]", U1 = "[object String]", z1 = "[object Symbol]", z = "[object Undefined]", N = "[object WeakMap]", j = "[object WeakSet]", Q = "[object ArrayBuffer]", i5 = "[object DataView]", n1 = "[object Float32Array]", b5 = "[object Float64Array]", T5 = "[object Int8Array]", p5 = "[object Int16Array]", H5 = "[object Int32Array]", F5 = "[object Uint8Array]", Me = "[object Uint8ClampedArray]", Hr = "[object Uint16Array]", Po = "[object Uint32Array]", nd = /\b__p \+= '';/g, od = /\b(__p \+=) '' \+/g, id = /(__e\(.*?\)|\b__t\)) \+\n'';/g, W3 = /&(?:amp|lt|gt|quot|#39);/g, G3 = /[&<>"']/g, Ld = RegExp(W3.source), ad = RegExp(G3.source), sd = /<%-([\s\S]+?)%>/g, ld = /<%([\s\S]+?)%>/g, q3 = /<%=([\s\S]+?)%>/g, ud = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, cd = /^\w*$/, hd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ao = /[\\^$.*+?()[\]{}|]/g, dd = RegExp(Ao.source), $o = /^\s+/, fd = /\s/, pd = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, gd = /\{\n\/\* \[wrapped with (.+)\] \*/, md = /,? & /, vd = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, yd = /[()=,{}\[\]\/\s]/, wd = /\\(\\)?/g, bd = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, K3 = /\w*$/, xd = /^[-+]0x[0-9a-f]+$/i, kd = /^0b[01]+$/i, Md = /^\[object .+?Constructor\]$/, _d = /^0o[0-7]+$/i, Cd = /^(?:0|[1-9]\d*)$/, Sd = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, s2 = /($^)/, Dd = /['\n\r\u2028\u2029\\]/g, l2 = "\\ud800-\\udfff", Ed = "\\u0300-\\u036f", Id = "\\ufe20-\\ufe2f", Td = "\\u20d0-\\u20ff", J3 = Ed + Id + Td, Q3 = "\\u2700-\\u27bf", X3 = "a-z\\xdf-\\xf6\\xf8-\\xff", Od = "\\xac\\xb1\\xd7\\xf7", zd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Pd = "\\u2000-\\u206f", Ad = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ea = "A-Z\\xc0-\\xd6\\xd8-\\xde", ta = "\\ufe0e\\ufe0f", ra = Od + zd + Pd + Ad, Zo = "['’]", $d = "[" + l2 + "]", na = "[" + ra + "]", u2 = "[" + J3 + "]", oa = "\\d+", Zd = "[" + Q3 + "]", ia = "[" + X3 + "]", La = "[^" + l2 + ra + oa + Q3 + X3 + ea + "]", No = "\\ud83c[\\udffb-\\udfff]", Nd = "(?:" + u2 + "|" + No + ")", aa = "[^" + l2 + "]", Bo = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ro = "[\\ud800-\\udbff][\\udc00-\\udfff]", Fr = "[" + ea + "]", sa = "\\u200d", la = "(?:" + ia + "|" + La + ")", Bd = "(?:" + Fr + "|" + La + ")", ua = "(?:" + Zo + "(?:d|ll|m|re|s|t|ve))?", ca = "(?:" + Zo + "(?:D|LL|M|RE|S|T|VE))?", ha = Nd + "?", da = "[" + ta + "]?", Rd = "(?:" + sa + "(?:" + [aa, Bo, Ro].join("|") + ")" + da + ha + ")*", Hd = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fd = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", fa = da + ha + Rd, jd = "(?:" + [Zd, Bo, Ro].join("|") + ")" + fa, Ud = "(?:" + [aa + u2 + "?", u2, Bo, Ro, $d].join("|") + ")", Yd = RegExp(Zo, "g"), Vd = RegExp(u2, "g"), Ho = RegExp(No + "(?=" + No + ")|" + Ud + fa, "g"), Wd = RegExp([
      Fr + "?" + ia + "+" + ua + "(?=" + [na, Fr, "$"].join("|") + ")",
      Bd + "+" + ca + "(?=" + [na, Fr + la, "$"].join("|") + ")",
      Fr + "?" + la + "+" + ua,
      Fr + "+" + ca,
      Fd,
      Hd,
      oa,
      jd
    ].join("|"), "g"), Gd = RegExp("[" + sa + l2 + J3 + ta + "]"), qd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Kd = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Jd = -1, s1 = {};
    s1[n1] = s1[b5] = s1[T5] = s1[p5] = s1[H5] = s1[F5] = s1[Me] = s1[Hr] = s1[Po] = !0, s1[R5] = s1[L1] = s1[Q] = s1[t1] = s1[i5] = s1[a1] = s1[W] = s1[n5] = s1[o5] = s1[w5] = s1[r1] = s1[O1] = s1[x1] = s1[U1] = s1[N] = !1;
    var o1 = {};
    o1[R5] = o1[L1] = o1[Q] = o1[i5] = o1[t1] = o1[a1] = o1[n1] = o1[b5] = o1[T5] = o1[p5] = o1[H5] = o1[o5] = o1[w5] = o1[r1] = o1[O1] = o1[x1] = o1[U1] = o1[z1] = o1[F5] = o1[Me] = o1[Hr] = o1[Po] = !0, o1[W] = o1[n5] = o1[N] = !1;
    var Qd = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Xd = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ef = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, tf = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, rf = parseFloat, nf = parseInt, pa = typeof I1 == "object" && I1 && I1.Object === Object && I1, of = typeof self == "object" && self && self.Object === Object && self, P1 = pa || of || Function("return this")(), Fo = e && !e.nodeType && e, dr = Fo && !0 && t && !t.nodeType && t, ga = dr && dr.exports === Fo, jo = ga && pa.process, _e = function() {
      try {
        var T = dr && dr.require && dr.require("util").types;
        return T || jo && jo.binding && jo.binding("util");
      } catch {
      }
    }(), ma = _e && _e.isArrayBuffer, va = _e && _e.isDate, ya = _e && _e.isMap, wa = _e && _e.isRegExp, ba = _e && _e.isSet, xa = _e && _e.isTypedArray;
    function ae(T, R, $) {
      switch ($.length) {
        case 0:
          return T.call(R);
        case 1:
          return T.call(R, $[0]);
        case 2:
          return T.call(R, $[0], $[1]);
        case 3:
          return T.call(R, $[0], $[1], $[2]);
      }
      return T.apply(R, $);
    }
    function Lf(T, R, $, L5) {
      for (var S5 = -1, G5 = T == null ? 0 : T.length; ++S5 < G5; ) {
        var D1 = T[S5];
        R(L5, D1, $(D1), T);
      }
      return L5;
    }
    function Ce(T, R) {
      for (var $ = -1, L5 = T == null ? 0 : T.length; ++$ < L5 && R(T[$], $, T) !== !1; )
        ;
      return T;
    }
    function af(T, R) {
      for (var $ = T == null ? 0 : T.length; $-- && R(T[$], $, T) !== !1; )
        ;
      return T;
    }
    function ka(T, R) {
      for (var $ = -1, L5 = T == null ? 0 : T.length; ++$ < L5; )
        if (!R(T[$], $, T))
          return !1;
      return !0;
    }
    function Bt(T, R) {
      for (var $ = -1, L5 = T == null ? 0 : T.length, S5 = 0, G5 = []; ++$ < L5; ) {
        var D1 = T[$];
        R(D1, $, T) && (G5[S5++] = D1);
      }
      return G5;
    }
    function c2(T, R) {
      var $ = T == null ? 0 : T.length;
      return !!$ && jr(T, R, 0) > -1;
    }
    function Uo(T, R, $) {
      for (var L5 = -1, S5 = T == null ? 0 : T.length; ++L5 < S5; )
        if ($(R, T[L5]))
          return !0;
      return !1;
    }
    function p1(T, R) {
      for (var $ = -1, L5 = T == null ? 0 : T.length, S5 = Array(L5); ++$ < L5; )
        S5[$] = R(T[$], $, T);
      return S5;
    }
    function Rt(T, R) {
      for (var $ = -1, L5 = R.length, S5 = T.length; ++$ < L5; )
        T[S5 + $] = R[$];
      return T;
    }
    function Yo(T, R, $, L5) {
      var S5 = -1, G5 = T == null ? 0 : T.length;
      for (L5 && G5 && ($ = T[++S5]); ++S5 < G5; )
        $ = R($, T[S5], S5, T);
      return $;
    }
    function sf(T, R, $, L5) {
      var S5 = T == null ? 0 : T.length;
      for (L5 && S5 && ($ = T[--S5]); S5--; )
        $ = R($, T[S5], S5, T);
      return $;
    }
    function Vo(T, R) {
      for (var $ = -1, L5 = T == null ? 0 : T.length; ++$ < L5; )
        if (R(T[$], $, T))
          return !0;
      return !1;
    }
    var lf = Wo("length");
    function uf(T) {
      return T.split("");
    }
    function cf(T) {
      return T.match(vd) || [];
    }
    function Ma(T, R, $) {
      var L5;
      return $(T, function(S5, G5, D1) {
        if (R(S5, G5, D1))
          return L5 = G5, !1;
      }), L5;
    }
    function h2(T, R, $, L5) {
      for (var S5 = T.length, G5 = $ + (L5 ? 1 : -1); L5 ? G5-- : ++G5 < S5; )
        if (R(T[G5], G5, T))
          return G5;
      return -1;
    }
    function jr(T, R, $) {
      return R === R ? kf(T, R, $) : h2(T, _a, $);
    }
    function hf(T, R, $, L5) {
      for (var S5 = $ - 1, G5 = T.length; ++S5 < G5; )
        if (L5(T[S5], R))
          return S5;
      return -1;
    }
    function _a(T) {
      return T !== T;
    }
    function Ca(T, R) {
      var $ = T == null ? 0 : T.length;
      return $ ? qo(T, R) / $ : E5;
    }
    function Wo(T) {
      return function(R) {
        return R == null ? r : R[T];
      };
    }
    function Go(T) {
      return function(R) {
        return T == null ? r : T[R];
      };
    }
    function Sa(T, R, $, L5, S5) {
      return S5(T, function(G5, D1, Q5) {
        $ = L5 ? (L5 = !1, G5) : R($, G5, D1, Q5);
      }), $;
    }
    function df(T, R) {
      var $ = T.length;
      for (T.sort(R); $--; )
        T[$] = T[$].value;
      return T;
    }
    function qo(T, R) {
      for (var $, L5 = -1, S5 = T.length; ++L5 < S5; ) {
        var G5 = R(T[L5]);
        G5 !== r && ($ = $ === r ? G5 : $ + G5);
      }
      return $;
    }
    function Ko(T, R) {
      for (var $ = -1, L5 = Array(T); ++$ < T; )
        L5[$] = R($);
      return L5;
    }
    function ff(T, R) {
      return p1(R, function($) {
        return [$, T[$]];
      });
    }
    function Da(T) {
      return T && T.slice(0, Oa(T) + 1).replace($o, "");
    }
    function se(T) {
      return function(R) {
        return T(R);
      };
    }
    function Jo(T, R) {
      return p1(R, function($) {
        return T[$];
      });
    }
    function Jn(T, R) {
      return T.has(R);
    }
    function Ea(T, R) {
      for (var $ = -1, L5 = T.length; ++$ < L5 && jr(R, T[$], 0) > -1; )
        ;
      return $;
    }
    function Ia(T, R) {
      for (var $ = T.length; $-- && jr(R, T[$], 0) > -1; )
        ;
      return $;
    }
    function pf(T, R) {
      for (var $ = T.length, L5 = 0; $--; )
        T[$] === R && ++L5;
      return L5;
    }
    var gf = Go(Qd), mf = Go(Xd);
    function vf(T) {
      return "\\" + tf[T];
    }
    function yf(T, R) {
      return T == null ? r : T[R];
    }
    function Ur(T) {
      return Gd.test(T);
    }
    function wf(T) {
      return qd.test(T);
    }
    function bf(T) {
      for (var R, $ = []; !(R = T.next()).done; )
        $.push(R.value);
      return $;
    }
    function Qo(T) {
      var R = -1, $ = Array(T.size);
      return T.forEach(function(L5, S5) {
        $[++R] = [S5, L5];
      }), $;
    }
    function Ta(T, R) {
      return function($) {
        return T(R($));
      };
    }
    function Ht(T, R) {
      for (var $ = -1, L5 = T.length, S5 = 0, G5 = []; ++$ < L5; ) {
        var D1 = T[$];
        (D1 === R || D1 === f) && (T[$] = f, G5[S5++] = $);
      }
      return G5;
    }
    function d2(T) {
      var R = -1, $ = Array(T.size);
      return T.forEach(function(L5) {
        $[++R] = L5;
      }), $;
    }
    function xf(T) {
      var R = -1, $ = Array(T.size);
      return T.forEach(function(L5) {
        $[++R] = [L5, L5];
      }), $;
    }
    function kf(T, R, $) {
      for (var L5 = $ - 1, S5 = T.length; ++L5 < S5; )
        if (T[L5] === R)
          return L5;
      return -1;
    }
    function Mf(T, R, $) {
      for (var L5 = $ + 1; L5--; )
        if (T[L5] === R)
          return L5;
      return L5;
    }
    function Yr(T) {
      return Ur(T) ? Cf(T) : lf(T);
    }
    function Ye(T) {
      return Ur(T) ? Sf(T) : uf(T);
    }
    function Oa(T) {
      for (var R = T.length; R-- && fd.test(T.charAt(R)); )
        ;
      return R;
    }
    var _f = Go(ef);
    function Cf(T) {
      for (var R = Ho.lastIndex = 0; Ho.test(T); )
        ++R;
      return R;
    }
    function Sf(T) {
      return T.match(Ho) || [];
    }
    function Df(T) {
      return T.match(Wd) || [];
    }
    var Ef = function T(R) {
      R = R == null ? P1 : Vr.defaults(P1.Object(), R, Vr.pick(P1, Kd));
      var $ = R.Array, L5 = R.Date, S5 = R.Error, G5 = R.Function, D1 = R.Math, Q5 = R.Object, Xo = R.RegExp, If = R.String, Se = R.TypeError, f2 = $.prototype, Tf = G5.prototype, Wr = Q5.prototype, p2 = R["__core-js_shared__"], g2 = Tf.toString, K5 = Wr.hasOwnProperty, Of = 0, za = function() {
        var o = /[^.]+$/.exec(p2 && p2.keys && p2.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), m2 = Wr.toString, zf = g2.call(Q5), Pf = P1._, Af = Xo(
        "^" + g2.call(K5).replace(Ao, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), v2 = ga ? R.Buffer : r, Ft = R.Symbol, y2 = R.Uint8Array, Pa = v2 ? v2.allocUnsafe : r, w2 = Ta(Q5.getPrototypeOf, Q5), Aa = Q5.create, $a = Wr.propertyIsEnumerable, b2 = f2.splice, Za = Ft ? Ft.isConcatSpreadable : r, Qn = Ft ? Ft.iterator : r, fr = Ft ? Ft.toStringTag : r, x2 = function() {
        try {
          var o = yr(Q5, "defineProperty");
          return o({}, "", {}), o;
        } catch {
        }
      }(), $f = R.clearTimeout !== P1.clearTimeout && R.clearTimeout, Zf = L5 && L5.now !== P1.Date.now && L5.now, Nf = R.setTimeout !== P1.setTimeout && R.setTimeout, k2 = D1.ceil, M2 = D1.floor, e6 = Q5.getOwnPropertySymbols, Bf = v2 ? v2.isBuffer : r, Na = R.isFinite, Rf = f2.join, Hf = Ta(Q5.keys, Q5), E1 = D1.max, N1 = D1.min, Ff = L5.now, jf = R.parseInt, Ba = D1.random, Uf = f2.reverse, t6 = yr(R, "DataView"), Xn = yr(R, "Map"), r6 = yr(R, "Promise"), Gr = yr(R, "Set"), e0 = yr(R, "WeakMap"), t0 = yr(Q5, "create"), _2 = e0 && new e0(), qr = {}, Yf = wr(t6), Vf = wr(Xn), Wf = wr(r6), Gf = wr(Gr), qf = wr(e0), C2 = Ft ? Ft.prototype : r, r0 = C2 ? C2.valueOf : r, Ra = C2 ? C2.toString : r;
      function v(o) {
        if (v1(o) && !D5(o) && !(o instanceof j5)) {
          if (o instanceof De)
            return o;
          if (K5.call(o, "__wrapped__"))
            return Hs(o);
        }
        return new De(o);
      }
      var Kr = function() {
        function o() {
        }
        return function(a) {
          if (!m1(a))
            return {};
          if (Aa)
            return Aa(a);
          o.prototype = a;
          var u = new o();
          return o.prototype = r, u;
        };
      }();
      function S2() {
      }
      function De(o, a) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!a, this.__index__ = 0, this.__values__ = r;
      }
      v.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: sd,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: ld,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: q3,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: v
        }
      }, v.prototype = S2.prototype, v.prototype.constructor = v, De.prototype = Kr(S2.prototype), De.prototype.constructor = De;
      function j5(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = f5, this.__views__ = [];
      }
      function Kf() {
        var o = new j5(this.__wrapped__);
        return o.__actions__ = Q1(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = Q1(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = Q1(this.__views__), o;
      }
      function Jf() {
        if (this.__filtered__) {
          var o = new j5(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function Qf() {
        var o = this.__wrapped__.value(), a = this.__dir__, u = D5(o), d = a < 0, p = u ? o.length : 0, y = ug(0, p, this.__views__), _ = y.start, I = y.end, O = I - _, H = d ? I : _ - 1, F = this.__iteratees__, Y = F.length, t5 = 0, h5 = N1(O, this.__takeCount__);
        if (!u || !d && p == O && h5 == O)
          return us(o, this.__actions__);
        var x5 = [];
        e:
          for (; O-- && t5 < h5; ) {
            H += a;
            for (var z5 = -1, k5 = o[H]; ++z5 < Y; ) {
              var B5 = F[z5], Y5 = B5.iteratee, ce = B5.type, W1 = Y5(k5);
              if (ce == d5)
                k5 = W1;
              else if (!W1) {
                if (ce == l5)
                  continue e;
                break e;
              }
            }
            x5[t5++] = k5;
          }
        return x5;
      }
      j5.prototype = Kr(S2.prototype), j5.prototype.constructor = j5;
      function pr(o) {
        var a = -1, u = o == null ? 0 : o.length;
        for (this.clear(); ++a < u; ) {
          var d = o[a];
          this.set(d[0], d[1]);
        }
      }
      function Xf() {
        this.__data__ = t0 ? t0(null) : {}, this.size = 0;
      }
      function ep(o) {
        var a = this.has(o) && delete this.__data__[o];
        return this.size -= a ? 1 : 0, a;
      }
      function tp(o) {
        var a = this.__data__;
        if (t0) {
          var u = a[o];
          return u === c ? r : u;
        }
        return K5.call(a, o) ? a[o] : r;
      }
      function rp(o) {
        var a = this.__data__;
        return t0 ? a[o] !== r : K5.call(a, o);
      }
      function np(o, a) {
        var u = this.__data__;
        return this.size += this.has(o) ? 0 : 1, u[o] = t0 && a === r ? c : a, this;
      }
      pr.prototype.clear = Xf, pr.prototype.delete = ep, pr.prototype.get = tp, pr.prototype.has = rp, pr.prototype.set = np;
      function wt(o) {
        var a = -1, u = o == null ? 0 : o.length;
        for (this.clear(); ++a < u; ) {
          var d = o[a];
          this.set(d[0], d[1]);
        }
      }
      function op() {
        this.__data__ = [], this.size = 0;
      }
      function ip(o) {
        var a = this.__data__, u = D2(a, o);
        if (u < 0)
          return !1;
        var d = a.length - 1;
        return u == d ? a.pop() : b2.call(a, u, 1), --this.size, !0;
      }
      function Lp(o) {
        var a = this.__data__, u = D2(a, o);
        return u < 0 ? r : a[u][1];
      }
      function ap(o) {
        return D2(this.__data__, o) > -1;
      }
      function sp(o, a) {
        var u = this.__data__, d = D2(u, o);
        return d < 0 ? (++this.size, u.push([o, a])) : u[d][1] = a, this;
      }
      wt.prototype.clear = op, wt.prototype.delete = ip, wt.prototype.get = Lp, wt.prototype.has = ap, wt.prototype.set = sp;
      function bt(o) {
        var a = -1, u = o == null ? 0 : o.length;
        for (this.clear(); ++a < u; ) {
          var d = o[a];
          this.set(d[0], d[1]);
        }
      }
      function lp() {
        this.size = 0, this.__data__ = {
          hash: new pr(),
          map: new (Xn || wt)(),
          string: new pr()
        };
      }
      function up(o) {
        var a = R2(this, o).delete(o);
        return this.size -= a ? 1 : 0, a;
      }
      function cp(o) {
        return R2(this, o).get(o);
      }
      function hp(o) {
        return R2(this, o).has(o);
      }
      function dp(o, a) {
        var u = R2(this, o), d = u.size;
        return u.set(o, a), this.size += u.size == d ? 0 : 1, this;
      }
      bt.prototype.clear = lp, bt.prototype.delete = up, bt.prototype.get = cp, bt.prototype.has = hp, bt.prototype.set = dp;
      function gr(o) {
        var a = -1, u = o == null ? 0 : o.length;
        for (this.__data__ = new bt(); ++a < u; )
          this.add(o[a]);
      }
      function fp(o) {
        return this.__data__.set(o, c), this;
      }
      function pp(o) {
        return this.__data__.has(o);
      }
      gr.prototype.add = gr.prototype.push = fp, gr.prototype.has = pp;
      function Ve(o) {
        var a = this.__data__ = new wt(o);
        this.size = a.size;
      }
      function gp() {
        this.__data__ = new wt(), this.size = 0;
      }
      function mp(o) {
        var a = this.__data__, u = a.delete(o);
        return this.size = a.size, u;
      }
      function vp(o) {
        return this.__data__.get(o);
      }
      function yp(o) {
        return this.__data__.has(o);
      }
      function wp(o, a) {
        var u = this.__data__;
        if (u instanceof wt) {
          var d = u.__data__;
          if (!Xn || d.length < L - 1)
            return d.push([o, a]), this.size = ++u.size, this;
          u = this.__data__ = new bt(d);
        }
        return u.set(o, a), this.size = u.size, this;
      }
      Ve.prototype.clear = gp, Ve.prototype.delete = mp, Ve.prototype.get = vp, Ve.prototype.has = yp, Ve.prototype.set = wp;
      function Ha(o, a) {
        var u = D5(o), d = !u && br(o), p = !u && !d && Wt(o), y = !u && !d && !p && en(o), _ = u || d || p || y, I = _ ? Ko(o.length, If) : [], O = I.length;
        for (var H in o)
          (a || K5.call(o, H)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
          (H == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          p && (H == "offset" || H == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          y && (H == "buffer" || H == "byteLength" || H == "byteOffset") || // Skip index properties.
          _t(H, O))) && I.push(H);
        return I;
      }
      function Fa(o) {
        var a = o.length;
        return a ? o[d6(0, a - 1)] : r;
      }
      function bp(o, a) {
        return H2(Q1(o), mr(a, 0, o.length));
      }
      function xp(o) {
        return H2(Q1(o));
      }
      function n6(o, a, u) {
        (u !== r && !We(o[a], u) || u === r && !(a in o)) && xt(o, a, u);
      }
      function n0(o, a, u) {
        var d = o[a];
        (!(K5.call(o, a) && We(d, u)) || u === r && !(a in o)) && xt(o, a, u);
      }
      function D2(o, a) {
        for (var u = o.length; u--; )
          if (We(o[u][0], a))
            return u;
        return -1;
      }
      function kp(o, a, u, d) {
        return jt(o, function(p, y, _) {
          a(d, p, u(p), _);
        }), d;
      }
      function ja(o, a) {
        return o && st(a, T1(a), o);
      }
      function Mp(o, a) {
        return o && st(a, ee(a), o);
      }
      function xt(o, a, u) {
        a == "__proto__" && x2 ? x2(o, a, {
          configurable: !0,
          enumerable: !0,
          value: u,
          writable: !0
        }) : o[a] = u;
      }
      function o6(o, a) {
        for (var u = -1, d = a.length, p = $(d), y = o == null; ++u < d; )
          p[u] = y ? r : N6(o, a[u]);
        return p;
      }
      function mr(o, a, u) {
        return o === o && (u !== r && (o = o <= u ? o : u), a !== r && (o = o >= a ? o : a)), o;
      }
      function Ee(o, a, u, d, p, y) {
        var _, I = a & g, O = a & m, H = a & b;
        if (u && (_ = p ? u(o, d, p, y) : u(o)), _ !== r)
          return _;
        if (!m1(o))
          return o;
        var F = D5(o);
        if (F) {
          if (_ = hg(o), !I)
            return Q1(o, _);
        } else {
          var Y = B1(o), t5 = Y == n5 || Y == e5;
          if (Wt(o))
            return ds(o, I);
          if (Y == r1 || Y == R5 || t5 && !p) {
            if (_ = O || t5 ? {} : Os(o), !I)
              return O ? tg(o, Mp(_, o)) : eg(o, ja(_, o));
          } else {
            if (!o1[Y])
              return p ? o : {};
            _ = dg(o, Y, I);
          }
        }
        y || (y = new Ve());
        var h5 = y.get(o);
        if (h5)
          return h5;
        y.set(o, _), a9(o) ? o.forEach(function(k5) {
          _.add(Ee(k5, a, u, k5, o, y));
        }) : i9(o) && o.forEach(function(k5, B5) {
          _.set(B5, Ee(k5, a, u, B5, o, y));
        });
        var x5 = H ? O ? M6 : k6 : O ? ee : T1, z5 = F ? r : x5(o);
        return Ce(z5 || o, function(k5, B5) {
          z5 && (B5 = k5, k5 = o[B5]), n0(_, B5, Ee(k5, a, u, B5, o, y));
        }), _;
      }
      function _p(o) {
        var a = T1(o);
        return function(u) {
          return Ua(u, o, a);
        };
      }
      function Ua(o, a, u) {
        var d = u.length;
        if (o == null)
          return !d;
        for (o = Q5(o); d--; ) {
          var p = u[d], y = a[p], _ = o[p];
          if (_ === r && !(p in o) || !y(_))
            return !1;
        }
        return !0;
      }
      function Ya(o, a, u) {
        if (typeof o != "function")
          throw new Se(l);
        return u0(function() {
          o.apply(r, u);
        }, a);
      }
      function o0(o, a, u, d) {
        var p = -1, y = c2, _ = !0, I = o.length, O = [], H = a.length;
        if (!I)
          return O;
        u && (a = p1(a, se(u))), d ? (y = Uo, _ = !1) : a.length >= L && (y = Jn, _ = !1, a = new gr(a));
        e:
          for (; ++p < I; ) {
            var F = o[p], Y = u == null ? F : u(F);
            if (F = d || F !== 0 ? F : 0, _ && Y === Y) {
              for (var t5 = H; t5--; )
                if (a[t5] === Y)
                  continue e;
              O.push(F);
            } else
              y(a, Y, d) || O.push(F);
          }
        return O;
      }
      var jt = vs(at), Va = vs(L6, !0);
      function Cp(o, a) {
        var u = !0;
        return jt(o, function(d, p, y) {
          return u = !!a(d, p, y), u;
        }), u;
      }
      function E2(o, a, u) {
        for (var d = -1, p = o.length; ++d < p; ) {
          var y = o[d], _ = a(y);
          if (_ != null && (I === r ? _ === _ && !ue(_) : u(_, I)))
            var I = _, O = y;
        }
        return O;
      }
      function Sp(o, a, u, d) {
        var p = o.length;
        for (u = O5(u), u < 0 && (u = -u > p ? 0 : p + u), d = d === r || d > p ? p : O5(d), d < 0 && (d += p), d = u > d ? 0 : l9(d); u < d; )
          o[u++] = a;
        return o;
      }
      function Wa(o, a) {
        var u = [];
        return jt(o, function(d, p, y) {
          a(d, p, y) && u.push(d);
        }), u;
      }
      function A1(o, a, u, d, p) {
        var y = -1, _ = o.length;
        for (u || (u = pg), p || (p = []); ++y < _; ) {
          var I = o[y];
          a > 0 && u(I) ? a > 1 ? A1(I, a - 1, u, d, p) : Rt(p, I) : d || (p[p.length] = I);
        }
        return p;
      }
      var i6 = ys(), Ga = ys(!0);
      function at(o, a) {
        return o && i6(o, a, T1);
      }
      function L6(o, a) {
        return o && Ga(o, a, T1);
      }
      function I2(o, a) {
        return Bt(a, function(u) {
          return Ct(o[u]);
        });
      }
      function vr(o, a) {
        a = Yt(a, o);
        for (var u = 0, d = a.length; o != null && u < d; )
          o = o[lt(a[u++])];
        return u && u == d ? o : r;
      }
      function qa(o, a, u) {
        var d = a(o);
        return D5(o) ? d : Rt(d, u(o));
      }
      function Y1(o) {
        return o == null ? o === r ? z : P5 : fr && fr in Q5(o) ? lg(o) : xg(o);
      }
      function a6(o, a) {
        return o > a;
      }
      function Dp(o, a) {
        return o != null && K5.call(o, a);
      }
      function Ep(o, a) {
        return o != null && a in Q5(o);
      }
      function Ip(o, a, u) {
        return o >= N1(a, u) && o < E1(a, u);
      }
      function s6(o, a, u) {
        for (var d = u ? Uo : c2, p = o[0].length, y = o.length, _ = y, I = $(y), O = 1 / 0, H = []; _--; ) {
          var F = o[_];
          _ && a && (F = p1(F, se(a))), O = N1(F.length, O), I[_] = !u && (a || p >= 120 && F.length >= 120) ? new gr(_ && F) : r;
        }
        F = o[0];
        var Y = -1, t5 = I[0];
        e:
          for (; ++Y < p && H.length < O; ) {
            var h5 = F[Y], x5 = a ? a(h5) : h5;
            if (h5 = u || h5 !== 0 ? h5 : 0, !(t5 ? Jn(t5, x5) : d(H, x5, u))) {
              for (_ = y; --_; ) {
                var z5 = I[_];
                if (!(z5 ? Jn(z5, x5) : d(o[_], x5, u)))
                  continue e;
              }
              t5 && t5.push(x5), H.push(h5);
            }
          }
        return H;
      }
      function Tp(o, a, u, d) {
        return at(o, function(p, y, _) {
          a(d, u(p), y, _);
        }), d;
      }
      function i0(o, a, u) {
        a = Yt(a, o), o = $s(o, a);
        var d = o == null ? o : o[lt(Te(a))];
        return d == null ? r : ae(d, o, u);
      }
      function Ka(o) {
        return v1(o) && Y1(o) == R5;
      }
      function Op(o) {
        return v1(o) && Y1(o) == Q;
      }
      function zp(o) {
        return v1(o) && Y1(o) == a1;
      }
      function L0(o, a, u, d, p) {
        return o === a ? !0 : o == null || a == null || !v1(o) && !v1(a) ? o !== o && a !== a : Pp(o, a, u, d, L0, p);
      }
      function Pp(o, a, u, d, p, y) {
        var _ = D5(o), I = D5(a), O = _ ? L1 : B1(o), H = I ? L1 : B1(a);
        O = O == R5 ? r1 : O, H = H == R5 ? r1 : H;
        var F = O == r1, Y = H == r1, t5 = O == H;
        if (t5 && Wt(o)) {
          if (!Wt(a))
            return !1;
          _ = !0, F = !1;
        }
        if (t5 && !F)
          return y || (y = new Ve()), _ || en(o) ? Es(o, a, u, d, p, y) : ag(o, a, O, u, d, p, y);
        if (!(u & k)) {
          var h5 = F && K5.call(o, "__wrapped__"), x5 = Y && K5.call(a, "__wrapped__");
          if (h5 || x5) {
            var z5 = h5 ? o.value() : o, k5 = x5 ? a.value() : a;
            return y || (y = new Ve()), p(z5, k5, u, d, y);
          }
        }
        return t5 ? (y || (y = new Ve()), sg(o, a, u, d, p, y)) : !1;
      }
      function Ap(o) {
        return v1(o) && B1(o) == o5;
      }
      function l6(o, a, u, d) {
        var p = u.length, y = p, _ = !d;
        if (o == null)
          return !y;
        for (o = Q5(o); p--; ) {
          var I = u[p];
          if (_ && I[2] ? I[1] !== o[I[0]] : !(I[0] in o))
            return !1;
        }
        for (; ++p < y; ) {
          I = u[p];
          var O = I[0], H = o[O], F = I[1];
          if (_ && I[2]) {
            if (H === r && !(O in o))
              return !1;
          } else {
            var Y = new Ve();
            if (d)
              var t5 = d(H, F, O, o, a, Y);
            if (!(t5 === r ? L0(F, H, k | x, d, Y) : t5))
              return !1;
          }
        }
        return !0;
      }
      function Ja(o) {
        if (!m1(o) || mg(o))
          return !1;
        var a = Ct(o) ? Af : Md;
        return a.test(wr(o));
      }
      function $p(o) {
        return v1(o) && Y1(o) == O1;
      }
      function Zp(o) {
        return v1(o) && B1(o) == x1;
      }
      function Np(o) {
        return v1(o) && W2(o.length) && !!s1[Y1(o)];
      }
      function Qa(o) {
        return typeof o == "function" ? o : o == null ? te : typeof o == "object" ? D5(o) ? ts(o[0], o[1]) : es(o) : w9(o);
      }
      function u6(o) {
        if (!l0(o))
          return Hf(o);
        var a = [];
        for (var u in Q5(o))
          K5.call(o, u) && u != "constructor" && a.push(u);
        return a;
      }
      function Bp(o) {
        if (!m1(o))
          return bg(o);
        var a = l0(o), u = [];
        for (var d in o)
          d == "constructor" && (a || !K5.call(o, d)) || u.push(d);
        return u;
      }
      function c6(o, a) {
        return o < a;
      }
      function Xa(o, a) {
        var u = -1, d = X1(o) ? $(o.length) : [];
        return jt(o, function(p, y, _) {
          d[++u] = a(p, y, _);
        }), d;
      }
      function es(o) {
        var a = C6(o);
        return a.length == 1 && a[0][2] ? Ps(a[0][0], a[0][1]) : function(u) {
          return u === o || l6(u, o, a);
        };
      }
      function ts(o, a) {
        return D6(o) && zs(a) ? Ps(lt(o), a) : function(u) {
          var d = N6(u, o);
          return d === r && d === a ? B6(u, o) : L0(a, d, k | x);
        };
      }
      function T2(o, a, u, d, p) {
        o !== a && i6(a, function(y, _) {
          if (p || (p = new Ve()), m1(y))
            Rp(o, a, _, u, T2, d, p);
          else {
            var I = d ? d(I6(o, _), y, _ + "", o, a, p) : r;
            I === r && (I = y), n6(o, _, I);
          }
        }, ee);
      }
      function Rp(o, a, u, d, p, y, _) {
        var I = I6(o, u), O = I6(a, u), H = _.get(O);
        if (H) {
          n6(o, u, H);
          return;
        }
        var F = y ? y(I, O, u + "", o, a, _) : r, Y = F === r;
        if (Y) {
          var t5 = D5(O), h5 = !t5 && Wt(O), x5 = !t5 && !h5 && en(O);
          F = O, t5 || h5 || x5 ? D5(I) ? F = I : y1(I) ? F = Q1(I) : h5 ? (Y = !1, F = ds(O, !0)) : x5 ? (Y = !1, F = fs(O, !0)) : F = [] : c0(O) || br(O) ? (F = I, br(I) ? F = u9(I) : (!m1(I) || Ct(I)) && (F = Os(O))) : Y = !1;
        }
        Y && (_.set(O, F), p(F, O, d, y, _), _.delete(O)), n6(o, u, F);
      }
      function rs(o, a) {
        var u = o.length;
        if (u)
          return a += a < 0 ? u : 0, _t(a, u) ? o[a] : r;
      }
      function ns(o, a, u) {
        a.length ? a = p1(a, function(y) {
          return D5(y) ? function(_) {
            return vr(_, y.length === 1 ? y[0] : y);
          } : y;
        }) : a = [te];
        var d = -1;
        a = p1(a, se(v5()));
        var p = Xa(o, function(y, _, I) {
          var O = p1(a, function(H) {
            return H(y);
          });
          return { criteria: O, index: ++d, value: y };
        });
        return df(p, function(y, _) {
          return Xp(y, _, u);
        });
      }
      function Hp(o, a) {
        return os(o, a, function(u, d) {
          return B6(o, d);
        });
      }
      function os(o, a, u) {
        for (var d = -1, p = a.length, y = {}; ++d < p; ) {
          var _ = a[d], I = vr(o, _);
          u(I, _) && a0(y, Yt(_, o), I);
        }
        return y;
      }
      function Fp(o) {
        return function(a) {
          return vr(a, o);
        };
      }
      function h6(o, a, u, d) {
        var p = d ? hf : jr, y = -1, _ = a.length, I = o;
        for (o === a && (a = Q1(a)), u && (I = p1(o, se(u))); ++y < _; )
          for (var O = 0, H = a[y], F = u ? u(H) : H; (O = p(I, F, O, d)) > -1; )
            I !== o && b2.call(I, O, 1), b2.call(o, O, 1);
        return o;
      }
      function is(o, a) {
        for (var u = o ? a.length : 0, d = u - 1; u--; ) {
          var p = a[u];
          if (u == d || p !== y) {
            var y = p;
            _t(p) ? b2.call(o, p, 1) : g6(o, p);
          }
        }
        return o;
      }
      function d6(o, a) {
        return o + M2(Ba() * (a - o + 1));
      }
      function jp(o, a, u, d) {
        for (var p = -1, y = E1(k2((a - o) / (u || 1)), 0), _ = $(y); y--; )
          _[d ? y : ++p] = o, o += u;
        return _;
      }
      function f6(o, a) {
        var u = "";
        if (!o || a < 1 || a > _5)
          return u;
        do
          a % 2 && (u += o), a = M2(a / 2), a && (o += o);
        while (a);
        return u;
      }
      function A5(o, a) {
        return T6(As(o, a, te), o + "");
      }
      function Up(o) {
        return Fa(tn(o));
      }
      function Yp(o, a) {
        var u = tn(o);
        return H2(u, mr(a, 0, u.length));
      }
      function a0(o, a, u, d) {
        if (!m1(o))
          return o;
        a = Yt(a, o);
        for (var p = -1, y = a.length, _ = y - 1, I = o; I != null && ++p < y; ) {
          var O = lt(a[p]), H = u;
          if (O === "__proto__" || O === "constructor" || O === "prototype")
            return o;
          if (p != _) {
            var F = I[O];
            H = d ? d(F, O, I) : r, H === r && (H = m1(F) ? F : _t(a[p + 1]) ? [] : {});
          }
          n0(I, O, H), I = I[O];
        }
        return o;
      }
      var Ls = _2 ? function(o, a) {
        return _2.set(o, a), o;
      } : te, Vp = x2 ? function(o, a) {
        return x2(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: H6(a),
          writable: !0
        });
      } : te;
      function Wp(o) {
        return H2(tn(o));
      }
      function Ie(o, a, u) {
        var d = -1, p = o.length;
        a < 0 && (a = -a > p ? 0 : p + a), u = u > p ? p : u, u < 0 && (u += p), p = a > u ? 0 : u - a >>> 0, a >>>= 0;
        for (var y = $(p); ++d < p; )
          y[d] = o[d + a];
        return y;
      }
      function Gp(o, a) {
        var u;
        return jt(o, function(d, p, y) {
          return u = a(d, p, y), !u;
        }), !!u;
      }
      function O2(o, a, u) {
        var d = 0, p = o == null ? d : o.length;
        if (typeof a == "number" && a === a && p <= C1) {
          for (; d < p; ) {
            var y = d + p >>> 1, _ = o[y];
            _ !== null && !ue(_) && (u ? _ <= a : _ < a) ? d = y + 1 : p = y;
          }
          return p;
        }
        return p6(o, a, te, u);
      }
      function p6(o, a, u, d) {
        var p = 0, y = o == null ? 0 : o.length;
        if (y === 0)
          return 0;
        a = u(a);
        for (var _ = a !== a, I = a === null, O = ue(a), H = a === r; p < y; ) {
          var F = M2((p + y) / 2), Y = u(o[F]), t5 = Y !== r, h5 = Y === null, x5 = Y === Y, z5 = ue(Y);
          if (_)
            var k5 = d || x5;
          else
            H ? k5 = x5 && (d || t5) : I ? k5 = x5 && t5 && (d || !h5) : O ? k5 = x5 && t5 && !h5 && (d || !z5) : h5 || z5 ? k5 = !1 : k5 = d ? Y <= a : Y < a;
          k5 ? p = F + 1 : y = F;
        }
        return N1(y, e1);
      }
      function as(o, a) {
        for (var u = -1, d = o.length, p = 0, y = []; ++u < d; ) {
          var _ = o[u], I = a ? a(_) : _;
          if (!u || !We(I, O)) {
            var O = I;
            y[p++] = _ === 0 ? 0 : _;
          }
        }
        return y;
      }
      function ss(o) {
        return typeof o == "number" ? o : ue(o) ? E5 : +o;
      }
      function le(o) {
        if (typeof o == "string")
          return o;
        if (D5(o))
          return p1(o, le) + "";
        if (ue(o))
          return Ra ? Ra.call(o) : "";
        var a = o + "";
        return a == "0" && 1 / o == -M5 ? "-0" : a;
      }
      function Ut(o, a, u) {
        var d = -1, p = c2, y = o.length, _ = !0, I = [], O = I;
        if (u)
          _ = !1, p = Uo;
        else if (y >= L) {
          var H = a ? null : ig(o);
          if (H)
            return d2(H);
          _ = !1, p = Jn, O = new gr();
        } else
          O = a ? [] : I;
        e:
          for (; ++d < y; ) {
            var F = o[d], Y = a ? a(F) : F;
            if (F = u || F !== 0 ? F : 0, _ && Y === Y) {
              for (var t5 = O.length; t5--; )
                if (O[t5] === Y)
                  continue e;
              a && O.push(Y), I.push(F);
            } else
              p(O, Y, u) || (O !== I && O.push(Y), I.push(F));
          }
        return I;
      }
      function g6(o, a) {
        return a = Yt(a, o), o = $s(o, a), o == null || delete o[lt(Te(a))];
      }
      function ls(o, a, u, d) {
        return a0(o, a, u(vr(o, a)), d);
      }
      function z2(o, a, u, d) {
        for (var p = o.length, y = d ? p : -1; (d ? y-- : ++y < p) && a(o[y], y, o); )
          ;
        return u ? Ie(o, d ? 0 : y, d ? y + 1 : p) : Ie(o, d ? y + 1 : 0, d ? p : y);
      }
      function us(o, a) {
        var u = o;
        return u instanceof j5 && (u = u.value()), Yo(a, function(d, p) {
          return p.func.apply(p.thisArg, Rt([d], p.args));
        }, u);
      }
      function m6(o, a, u) {
        var d = o.length;
        if (d < 2)
          return d ? Ut(o[0]) : [];
        for (var p = -1, y = $(d); ++p < d; )
          for (var _ = o[p], I = -1; ++I < d; )
            I != p && (y[p] = o0(y[p] || _, o[I], a, u));
        return Ut(A1(y, 1), a, u);
      }
      function cs(o, a, u) {
        for (var d = -1, p = o.length, y = a.length, _ = {}; ++d < p; ) {
          var I = d < y ? a[d] : r;
          u(_, o[d], I);
        }
        return _;
      }
      function v6(o) {
        return y1(o) ? o : [];
      }
      function y6(o) {
        return typeof o == "function" ? o : te;
      }
      function Yt(o, a) {
        return D5(o) ? o : D6(o, a) ? [o] : Rs(q5(o));
      }
      var qp = A5;
      function Vt(o, a, u) {
        var d = o.length;
        return u = u === r ? d : u, !a && u >= d ? o : Ie(o, a, u);
      }
      var hs = $f || function(o) {
        return P1.clearTimeout(o);
      };
      function ds(o, a) {
        if (a)
          return o.slice();
        var u = o.length, d = Pa ? Pa(u) : new o.constructor(u);
        return o.copy(d), d;
      }
      function w6(o) {
        var a = new o.constructor(o.byteLength);
        return new y2(a).set(new y2(o)), a;
      }
      function Kp(o, a) {
        var u = a ? w6(o.buffer) : o.buffer;
        return new o.constructor(u, o.byteOffset, o.byteLength);
      }
      function Jp(o) {
        var a = new o.constructor(o.source, K3.exec(o));
        return a.lastIndex = o.lastIndex, a;
      }
      function Qp(o) {
        return r0 ? Q5(r0.call(o)) : {};
      }
      function fs(o, a) {
        var u = a ? w6(o.buffer) : o.buffer;
        return new o.constructor(u, o.byteOffset, o.length);
      }
      function ps(o, a) {
        if (o !== a) {
          var u = o !== r, d = o === null, p = o === o, y = ue(o), _ = a !== r, I = a === null, O = a === a, H = ue(a);
          if (!I && !H && !y && o > a || y && _ && O && !I && !H || d && _ && O || !u && O || !p)
            return 1;
          if (!d && !y && !H && o < a || H && u && p && !d && !y || I && u && p || !_ && p || !O)
            return -1;
        }
        return 0;
      }
      function Xp(o, a, u) {
        for (var d = -1, p = o.criteria, y = a.criteria, _ = p.length, I = u.length; ++d < _; ) {
          var O = ps(p[d], y[d]);
          if (O) {
            if (d >= I)
              return O;
            var H = u[d];
            return O * (H == "desc" ? -1 : 1);
          }
        }
        return o.index - a.index;
      }
      function gs(o, a, u, d) {
        for (var p = -1, y = o.length, _ = u.length, I = -1, O = a.length, H = E1(y - _, 0), F = $(O + H), Y = !d; ++I < O; )
          F[I] = a[I];
        for (; ++p < _; )
          (Y || p < y) && (F[u[p]] = o[p]);
        for (; H--; )
          F[I++] = o[p++];
        return F;
      }
      function ms(o, a, u, d) {
        for (var p = -1, y = o.length, _ = -1, I = u.length, O = -1, H = a.length, F = E1(y - I, 0), Y = $(F + H), t5 = !d; ++p < F; )
          Y[p] = o[p];
        for (var h5 = p; ++O < H; )
          Y[h5 + O] = a[O];
        for (; ++_ < I; )
          (t5 || p < y) && (Y[h5 + u[_]] = o[p++]);
        return Y;
      }
      function Q1(o, a) {
        var u = -1, d = o.length;
        for (a || (a = $(d)); ++u < d; )
          a[u] = o[u];
        return a;
      }
      function st(o, a, u, d) {
        var p = !u;
        u || (u = {});
        for (var y = -1, _ = a.length; ++y < _; ) {
          var I = a[y], O = d ? d(u[I], o[I], I, u, o) : r;
          O === r && (O = o[I]), p ? xt(u, I, O) : n0(u, I, O);
        }
        return u;
      }
      function eg(o, a) {
        return st(o, S6(o), a);
      }
      function tg(o, a) {
        return st(o, Is(o), a);
      }
      function P2(o, a) {
        return function(u, d) {
          var p = D5(u) ? Lf : kp, y = a ? a() : {};
          return p(u, o, v5(d, 2), y);
        };
      }
      function Jr(o) {
        return A5(function(a, u) {
          var d = -1, p = u.length, y = p > 1 ? u[p - 1] : r, _ = p > 2 ? u[2] : r;
          for (y = o.length > 3 && typeof y == "function" ? (p--, y) : r, _ && V1(u[0], u[1], _) && (y = p < 3 ? r : y, p = 1), a = Q5(a); ++d < p; ) {
            var I = u[d];
            I && o(a, I, d, y);
          }
          return a;
        });
      }
      function vs(o, a) {
        return function(u, d) {
          if (u == null)
            return u;
          if (!X1(u))
            return o(u, d);
          for (var p = u.length, y = a ? p : -1, _ = Q5(u); (a ? y-- : ++y < p) && d(_[y], y, _) !== !1; )
            ;
          return u;
        };
      }
      function ys(o) {
        return function(a, u, d) {
          for (var p = -1, y = Q5(a), _ = d(a), I = _.length; I--; ) {
            var O = _[o ? I : ++p];
            if (u(y[O], O, y) === !1)
              break;
          }
          return a;
        };
      }
      function rg(o, a, u) {
        var d = a & D, p = s0(o);
        function y() {
          var _ = this && this !== P1 && this instanceof y ? p : o;
          return _.apply(d ? u : this, arguments);
        }
        return y;
      }
      function ws(o) {
        return function(a) {
          a = q5(a);
          var u = Ur(a) ? Ye(a) : r, d = u ? u[0] : a.charAt(0), p = u ? Vt(u, 1).join("") : a.slice(1);
          return d[o]() + p;
        };
      }
      function Qr(o) {
        return function(a) {
          return Yo(v9(m9(a).replace(Yd, "")), o, "");
        };
      }
      function s0(o) {
        return function() {
          var a = arguments;
          switch (a.length) {
            case 0:
              return new o();
            case 1:
              return new o(a[0]);
            case 2:
              return new o(a[0], a[1]);
            case 3:
              return new o(a[0], a[1], a[2]);
            case 4:
              return new o(a[0], a[1], a[2], a[3]);
            case 5:
              return new o(a[0], a[1], a[2], a[3], a[4]);
            case 6:
              return new o(a[0], a[1], a[2], a[3], a[4], a[5]);
            case 7:
              return new o(a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
          }
          var u = Kr(o.prototype), d = o.apply(u, a);
          return m1(d) ? d : u;
        };
      }
      function ng(o, a, u) {
        var d = s0(o);
        function p() {
          for (var y = arguments.length, _ = $(y), I = y, O = Xr(p); I--; )
            _[I] = arguments[I];
          var H = y < 3 && _[0] !== O && _[y - 1] !== O ? [] : Ht(_, O);
          if (y -= H.length, y < u)
            return _s(
              o,
              a,
              A2,
              p.placeholder,
              r,
              _,
              H,
              r,
              r,
              u - y
            );
          var F = this && this !== P1 && this instanceof p ? d : o;
          return ae(F, this, _);
        }
        return p;
      }
      function bs(o) {
        return function(a, u, d) {
          var p = Q5(a);
          if (!X1(a)) {
            var y = v5(u, 3);
            a = T1(a), u = function(I) {
              return y(p[I], I, p);
            };
          }
          var _ = o(a, u, d);
          return _ > -1 ? p[y ? a[_] : _] : r;
        };
      }
      function xs(o) {
        return Mt(function(a) {
          var u = a.length, d = u, p = De.prototype.thru;
          for (o && a.reverse(); d--; ) {
            var y = a[d];
            if (typeof y != "function")
              throw new Se(l);
            if (p && !_ && B2(y) == "wrapper")
              var _ = new De([], !0);
          }
          for (d = _ ? d : u; ++d < u; ) {
            y = a[d];
            var I = B2(y), O = I == "wrapper" ? _6(y) : r;
            O && E6(O[0]) && O[1] == (Z | S | P | B) && !O[4].length && O[9] == 1 ? _ = _[B2(O[0])].apply(_, O[3]) : _ = y.length == 1 && E6(y) ? _[I]() : _.thru(y);
          }
          return function() {
            var H = arguments, F = H[0];
            if (_ && H.length == 1 && D5(F))
              return _.plant(F).value();
            for (var Y = 0, t5 = u ? a[Y].apply(this, H) : F; ++Y < u; )
              t5 = a[Y].call(this, t5);
            return t5;
          };
        });
      }
      function A2(o, a, u, d, p, y, _, I, O, H) {
        var F = a & Z, Y = a & D, t5 = a & M, h5 = a & (S | C), x5 = a & U, z5 = t5 ? r : s0(o);
        function k5() {
          for (var B5 = arguments.length, Y5 = $(B5), ce = B5; ce--; )
            Y5[ce] = arguments[ce];
          if (h5)
            var W1 = Xr(k5), he = pf(Y5, W1);
          if (d && (Y5 = gs(Y5, d, p, h5)), y && (Y5 = ms(Y5, y, _, h5)), B5 -= he, h5 && B5 < H) {
            var w1 = Ht(Y5, W1);
            return _s(
              o,
              a,
              A2,
              k5.placeholder,
              u,
              Y5,
              w1,
              I,
              O,
              H - B5
            );
          }
          var Ge = Y ? u : this, Dt = t5 ? Ge[o] : o;
          return B5 = Y5.length, I ? Y5 = kg(Y5, I) : x5 && B5 > 1 && Y5.reverse(), F && O < B5 && (Y5.length = O), this && this !== P1 && this instanceof k5 && (Dt = z5 || s0(Dt)), Dt.apply(Ge, Y5);
        }
        return k5;
      }
      function ks(o, a) {
        return function(u, d) {
          return Tp(u, o, a(d), {});
        };
      }
      function $2(o, a) {
        return function(u, d) {
          var p;
          if (u === r && d === r)
            return a;
          if (u !== r && (p = u), d !== r) {
            if (p === r)
              return d;
            typeof u == "string" || typeof d == "string" ? (u = le(u), d = le(d)) : (u = ss(u), d = ss(d)), p = o(u, d);
          }
          return p;
        };
      }
      function b6(o) {
        return Mt(function(a) {
          return a = p1(a, se(v5())), A5(function(u) {
            var d = this;
            return o(a, function(p) {
              return ae(p, d, u);
            });
          });
        });
      }
      function Z2(o, a) {
        a = a === r ? " " : le(a);
        var u = a.length;
        if (u < 2)
          return u ? f6(a, o) : a;
        var d = f6(a, k2(o / Yr(a)));
        return Ur(a) ? Vt(Ye(d), 0, o).join("") : d.slice(0, o);
      }
      function og(o, a, u, d) {
        var p = a & D, y = s0(o);
        function _() {
          for (var I = -1, O = arguments.length, H = -1, F = d.length, Y = $(F + O), t5 = this && this !== P1 && this instanceof _ ? y : o; ++H < F; )
            Y[H] = d[H];
          for (; O--; )
            Y[H++] = arguments[++I];
          return ae(t5, p ? u : this, Y);
        }
        return _;
      }
      function Ms(o) {
        return function(a, u, d) {
          return d && typeof d != "number" && V1(a, u, d) && (u = d = r), a = St(a), u === r ? (u = a, a = 0) : u = St(u), d = d === r ? a < u ? 1 : -1 : St(d), jp(a, u, d, o);
        };
      }
      function N2(o) {
        return function(a, u) {
          return typeof a == "string" && typeof u == "string" || (a = Oe(a), u = Oe(u)), o(a, u);
        };
      }
      function _s(o, a, u, d, p, y, _, I, O, H) {
        var F = a & S, Y = F ? _ : r, t5 = F ? r : _, h5 = F ? y : r, x5 = F ? r : y;
        a |= F ? P : A, a &= ~(F ? A : P), a & E || (a &= ~(D | M));
        var z5 = [
          o,
          a,
          p,
          h5,
          Y,
          x5,
          t5,
          I,
          O,
          H
        ], k5 = u.apply(r, z5);
        return E6(o) && Zs(k5, z5), k5.placeholder = d, Ns(k5, o, a);
      }
      function x6(o) {
        var a = D1[o];
        return function(u, d) {
          if (u = Oe(u), d = d == null ? 0 : N1(O5(d), 292), d && Na(u)) {
            var p = (q5(u) + "e").split("e"), y = a(p[0] + "e" + (+p[1] + d));
            return p = (q5(y) + "e").split("e"), +(p[0] + "e" + (+p[1] - d));
          }
          return a(u);
        };
      }
      var ig = Gr && 1 / d2(new Gr([, -0]))[1] == M5 ? function(o) {
        return new Gr(o);
      } : U6;
      function Cs(o) {
        return function(a) {
          var u = B1(a);
          return u == o5 ? Qo(a) : u == x1 ? xf(a) : ff(a, o(a));
        };
      }
      function kt(o, a, u, d, p, y, _, I) {
        var O = a & M;
        if (!O && typeof o != "function")
          throw new Se(l);
        var H = d ? d.length : 0;
        if (H || (a &= ~(P | A), d = p = r), _ = _ === r ? _ : E1(O5(_), 0), I = I === r ? I : O5(I), H -= p ? p.length : 0, a & A) {
          var F = d, Y = p;
          d = p = r;
        }
        var t5 = O ? r : _6(o), h5 = [
          o,
          a,
          u,
          d,
          p,
          F,
          Y,
          y,
          _,
          I
        ];
        if (t5 && wg(h5, t5), o = h5[0], a = h5[1], u = h5[2], d = h5[3], p = h5[4], I = h5[9] = h5[9] === r ? O ? 0 : o.length : E1(h5[9] - H, 0), !I && a & (S | C) && (a &= ~(S | C)), !a || a == D)
          var x5 = rg(o, a, u);
        else
          a == S || a == C ? x5 = ng(o, a, I) : (a == P || a == (D | P)) && !p.length ? x5 = og(o, a, u, d) : x5 = A2.apply(r, h5);
        var z5 = t5 ? Ls : Zs;
        return Ns(z5(x5, h5), o, a);
      }
      function Ss(o, a, u, d) {
        return o === r || We(o, Wr[u]) && !K5.call(d, u) ? a : o;
      }
      function Ds(o, a, u, d, p, y) {
        return m1(o) && m1(a) && (y.set(a, o), T2(o, a, r, Ds, y), y.delete(a)), o;
      }
      function Lg(o) {
        return c0(o) ? r : o;
      }
      function Es(o, a, u, d, p, y) {
        var _ = u & k, I = o.length, O = a.length;
        if (I != O && !(_ && O > I))
          return !1;
        var H = y.get(o), F = y.get(a);
        if (H && F)
          return H == a && F == o;
        var Y = -1, t5 = !0, h5 = u & x ? new gr() : r;
        for (y.set(o, a), y.set(a, o); ++Y < I; ) {
          var x5 = o[Y], z5 = a[Y];
          if (d)
            var k5 = _ ? d(z5, x5, Y, a, o, y) : d(x5, z5, Y, o, a, y);
          if (k5 !== r) {
            if (k5)
              continue;
            t5 = !1;
            break;
          }
          if (h5) {
            if (!Vo(a, function(B5, Y5) {
              if (!Jn(h5, Y5) && (x5 === B5 || p(x5, B5, u, d, y)))
                return h5.push(Y5);
            })) {
              t5 = !1;
              break;
            }
          } else if (!(x5 === z5 || p(x5, z5, u, d, y))) {
            t5 = !1;
            break;
          }
        }
        return y.delete(o), y.delete(a), t5;
      }
      function ag(o, a, u, d, p, y, _) {
        switch (u) {
          case i5:
            if (o.byteLength != a.byteLength || o.byteOffset != a.byteOffset)
              return !1;
            o = o.buffer, a = a.buffer;
          case Q:
            return !(o.byteLength != a.byteLength || !y(new y2(o), new y2(a)));
          case t1:
          case a1:
          case w5:
            return We(+o, +a);
          case W:
            return o.name == a.name && o.message == a.message;
          case O1:
          case U1:
            return o == a + "";
          case o5:
            var I = Qo;
          case x1:
            var O = d & k;
            if (I || (I = d2), o.size != a.size && !O)
              return !1;
            var H = _.get(o);
            if (H)
              return H == a;
            d |= x, _.set(o, a);
            var F = Es(I(o), I(a), d, p, y, _);
            return _.delete(o), F;
          case z1:
            if (r0)
              return r0.call(o) == r0.call(a);
        }
        return !1;
      }
      function sg(o, a, u, d, p, y) {
        var _ = u & k, I = k6(o), O = I.length, H = k6(a), F = H.length;
        if (O != F && !_)
          return !1;
        for (var Y = O; Y--; ) {
          var t5 = I[Y];
          if (!(_ ? t5 in a : K5.call(a, t5)))
            return !1;
        }
        var h5 = y.get(o), x5 = y.get(a);
        if (h5 && x5)
          return h5 == a && x5 == o;
        var z5 = !0;
        y.set(o, a), y.set(a, o);
        for (var k5 = _; ++Y < O; ) {
          t5 = I[Y];
          var B5 = o[t5], Y5 = a[t5];
          if (d)
            var ce = _ ? d(Y5, B5, t5, a, o, y) : d(B5, Y5, t5, o, a, y);
          if (!(ce === r ? B5 === Y5 || p(B5, Y5, u, d, y) : ce)) {
            z5 = !1;
            break;
          }
          k5 || (k5 = t5 == "constructor");
        }
        if (z5 && !k5) {
          var W1 = o.constructor, he = a.constructor;
          W1 != he && "constructor" in o && "constructor" in a && !(typeof W1 == "function" && W1 instanceof W1 && typeof he == "function" && he instanceof he) && (z5 = !1);
        }
        return y.delete(o), y.delete(a), z5;
      }
      function Mt(o) {
        return T6(As(o, r, Us), o + "");
      }
      function k6(o) {
        return qa(o, T1, S6);
      }
      function M6(o) {
        return qa(o, ee, Is);
      }
      var _6 = _2 ? function(o) {
        return _2.get(o);
      } : U6;
      function B2(o) {
        for (var a = o.name + "", u = qr[a], d = K5.call(qr, a) ? u.length : 0; d--; ) {
          var p = u[d], y = p.func;
          if (y == null || y == o)
            return p.name;
        }
        return a;
      }
      function Xr(o) {
        var a = K5.call(v, "placeholder") ? v : o;
        return a.placeholder;
      }
      function v5() {
        var o = v.iteratee || F6;
        return o = o === F6 ? Qa : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function R2(o, a) {
        var u = o.__data__;
        return gg(a) ? u[typeof a == "string" ? "string" : "hash"] : u.map;
      }
      function C6(o) {
        for (var a = T1(o), u = a.length; u--; ) {
          var d = a[u], p = o[d];
          a[u] = [d, p, zs(p)];
        }
        return a;
      }
      function yr(o, a) {
        var u = yf(o, a);
        return Ja(u) ? u : r;
      }
      function lg(o) {
        var a = K5.call(o, fr), u = o[fr];
        try {
          o[fr] = r;
          var d = !0;
        } catch {
        }
        var p = m2.call(o);
        return d && (a ? o[fr] = u : delete o[fr]), p;
      }
      var S6 = e6 ? function(o) {
        return o == null ? [] : (o = Q5(o), Bt(e6(o), function(a) {
          return $a.call(o, a);
        }));
      } : Y6, Is = e6 ? function(o) {
        for (var a = []; o; )
          Rt(a, S6(o)), o = w2(o);
        return a;
      } : Y6, B1 = Y1;
      (t6 && B1(new t6(new ArrayBuffer(1))) != i5 || Xn && B1(new Xn()) != o5 || r6 && B1(r6.resolve()) != j1 || Gr && B1(new Gr()) != x1 || e0 && B1(new e0()) != N) && (B1 = function(o) {
        var a = Y1(o), u = a == r1 ? o.constructor : r, d = u ? wr(u) : "";
        if (d)
          switch (d) {
            case Yf:
              return i5;
            case Vf:
              return o5;
            case Wf:
              return j1;
            case Gf:
              return x1;
            case qf:
              return N;
          }
        return a;
      });
      function ug(o, a, u) {
        for (var d = -1, p = u.length; ++d < p; ) {
          var y = u[d], _ = y.size;
          switch (y.type) {
            case "drop":
              o += _;
              break;
            case "dropRight":
              a -= _;
              break;
            case "take":
              a = N1(a, o + _);
              break;
            case "takeRight":
              o = E1(o, a - _);
              break;
          }
        }
        return { start: o, end: a };
      }
      function cg(o) {
        var a = o.match(gd);
        return a ? a[1].split(md) : [];
      }
      function Ts(o, a, u) {
        a = Yt(a, o);
        for (var d = -1, p = a.length, y = !1; ++d < p; ) {
          var _ = lt(a[d]);
          if (!(y = o != null && u(o, _)))
            break;
          o = o[_];
        }
        return y || ++d != p ? y : (p = o == null ? 0 : o.length, !!p && W2(p) && _t(_, p) && (D5(o) || br(o)));
      }
      function hg(o) {
        var a = o.length, u = new o.constructor(a);
        return a && typeof o[0] == "string" && K5.call(o, "index") && (u.index = o.index, u.input = o.input), u;
      }
      function Os(o) {
        return typeof o.constructor == "function" && !l0(o) ? Kr(w2(o)) : {};
      }
      function dg(o, a, u) {
        var d = o.constructor;
        switch (a) {
          case Q:
            return w6(o);
          case t1:
          case a1:
            return new d(+o);
          case i5:
            return Kp(o, u);
          case n1:
          case b5:
          case T5:
          case p5:
          case H5:
          case F5:
          case Me:
          case Hr:
          case Po:
            return fs(o, u);
          case o5:
            return new d();
          case w5:
          case U1:
            return new d(o);
          case O1:
            return Jp(o);
          case x1:
            return new d();
          case z1:
            return Qp(o);
        }
      }
      function fg(o, a) {
        var u = a.length;
        if (!u)
          return o;
        var d = u - 1;
        return a[d] = (u > 1 ? "& " : "") + a[d], a = a.join(u > 2 ? ", " : " "), o.replace(pd, `{
/* [wrapped with ` + a + `] */
`);
      }
      function pg(o) {
        return D5(o) || br(o) || !!(Za && o && o[Za]);
      }
      function _t(o, a) {
        var u = typeof o;
        return a = a ?? _5, !!a && (u == "number" || u != "symbol" && Cd.test(o)) && o > -1 && o % 1 == 0 && o < a;
      }
      function V1(o, a, u) {
        if (!m1(u))
          return !1;
        var d = typeof a;
        return (d == "number" ? X1(u) && _t(a, u.length) : d == "string" && a in u) ? We(u[a], o) : !1;
      }
      function D6(o, a) {
        if (D5(o))
          return !1;
        var u = typeof o;
        return u == "number" || u == "symbol" || u == "boolean" || o == null || ue(o) ? !0 : cd.test(o) || !ud.test(o) || a != null && o in Q5(a);
      }
      function gg(o) {
        var a = typeof o;
        return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? o !== "__proto__" : o === null;
      }
      function E6(o) {
        var a = B2(o), u = v[a];
        if (typeof u != "function" || !(a in j5.prototype))
          return !1;
        if (o === u)
          return !0;
        var d = _6(u);
        return !!d && o === d[0];
      }
      function mg(o) {
        return !!za && za in o;
      }
      var vg = p2 ? Ct : V6;
      function l0(o) {
        var a = o && o.constructor, u = typeof a == "function" && a.prototype || Wr;
        return o === u;
      }
      function zs(o) {
        return o === o && !m1(o);
      }
      function Ps(o, a) {
        return function(u) {
          return u == null ? !1 : u[o] === a && (a !== r || o in Q5(u));
        };
      }
      function yg(o) {
        var a = Y2(o, function(d) {
          return u.size === h && u.clear(), d;
        }), u = a.cache;
        return a;
      }
      function wg(o, a) {
        var u = o[1], d = a[1], p = u | d, y = p < (D | M | Z), _ = d == Z && u == S || d == Z && u == B && o[7].length <= a[8] || d == (Z | B) && a[7].length <= a[8] && u == S;
        if (!(y || _))
          return o;
        d & D && (o[2] = a[2], p |= u & D ? 0 : E);
        var I = a[3];
        if (I) {
          var O = o[3];
          o[3] = O ? gs(O, I, a[4]) : I, o[4] = O ? Ht(o[3], f) : a[4];
        }
        return I = a[5], I && (O = o[5], o[5] = O ? ms(O, I, a[6]) : I, o[6] = O ? Ht(o[5], f) : a[6]), I = a[7], I && (o[7] = I), d & Z && (o[8] = o[8] == null ? a[8] : N1(o[8], a[8])), o[9] == null && (o[9] = a[9]), o[0] = a[0], o[1] = p, o;
      }
      function bg(o) {
        var a = [];
        if (o != null)
          for (var u in Q5(o))
            a.push(u);
        return a;
      }
      function xg(o) {
        return m2.call(o);
      }
      function As(o, a, u) {
        return a = E1(a === r ? o.length - 1 : a, 0), function() {
          for (var d = arguments, p = -1, y = E1(d.length - a, 0), _ = $(y); ++p < y; )
            _[p] = d[a + p];
          p = -1;
          for (var I = $(a + 1); ++p < a; )
            I[p] = d[p];
          return I[a] = u(_), ae(o, this, I);
        };
      }
      function $s(o, a) {
        return a.length < 2 ? o : vr(o, Ie(a, 0, -1));
      }
      function kg(o, a) {
        for (var u = o.length, d = N1(a.length, u), p = Q1(o); d--; ) {
          var y = a[d];
          o[d] = _t(y, u) ? p[y] : r;
        }
        return o;
      }
      function I6(o, a) {
        if (!(a === "constructor" && typeof o[a] == "function") && a != "__proto__")
          return o[a];
      }
      var Zs = Bs(Ls), u0 = Nf || function(o, a) {
        return P1.setTimeout(o, a);
      }, T6 = Bs(Vp);
      function Ns(o, a, u) {
        var d = a + "";
        return T6(o, fg(d, Mg(cg(d), u)));
      }
      function Bs(o) {
        var a = 0, u = 0;
        return function() {
          var d = Ff(), p = V - (d - u);
          if (u = d, p > 0) {
            if (++a >= a5)
              return arguments[0];
          } else
            a = 0;
          return o.apply(r, arguments);
        };
      }
      function H2(o, a) {
        var u = -1, d = o.length, p = d - 1;
        for (a = a === r ? d : a; ++u < a; ) {
          var y = d6(u, p), _ = o[y];
          o[y] = o[u], o[u] = _;
        }
        return o.length = a, o;
      }
      var Rs = yg(function(o) {
        var a = [];
        return o.charCodeAt(0) === 46 && a.push(""), o.replace(hd, function(u, d, p, y) {
          a.push(p ? y.replace(wd, "$1") : d || u);
        }), a;
      });
      function lt(o) {
        if (typeof o == "string" || ue(o))
          return o;
        var a = o + "";
        return a == "0" && 1 / o == -M5 ? "-0" : a;
      }
      function wr(o) {
        if (o != null) {
          try {
            return g2.call(o);
          } catch {
          }
          try {
            return o + "";
          } catch {
          }
        }
        return "";
      }
      function Mg(o, a) {
        return Ce(I5, function(u) {
          var d = "_." + u[0];
          a & u[1] && !c2(o, d) && o.push(d);
        }), o.sort();
      }
      function Hs(o) {
        if (o instanceof j5)
          return o.clone();
        var a = new De(o.__wrapped__, o.__chain__);
        return a.__actions__ = Q1(o.__actions__), a.__index__ = o.__index__, a.__values__ = o.__values__, a;
      }
      function _g(o, a, u) {
        (u ? V1(o, a, u) : a === r) ? a = 1 : a = E1(O5(a), 0);
        var d = o == null ? 0 : o.length;
        if (!d || a < 1)
          return [];
        for (var p = 0, y = 0, _ = $(k2(d / a)); p < d; )
          _[y++] = Ie(o, p, p += a);
        return _;
      }
      function Cg(o) {
        for (var a = -1, u = o == null ? 0 : o.length, d = 0, p = []; ++a < u; ) {
          var y = o[a];
          y && (p[d++] = y);
        }
        return p;
      }
      function Sg() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var a = $(o - 1), u = arguments[0], d = o; d--; )
          a[d - 1] = arguments[d];
        return Rt(D5(u) ? Q1(u) : [u], A1(a, 1));
      }
      var Dg = A5(function(o, a) {
        return y1(o) ? o0(o, A1(a, 1, y1, !0)) : [];
      }), Eg = A5(function(o, a) {
        var u = Te(a);
        return y1(u) && (u = r), y1(o) ? o0(o, A1(a, 1, y1, !0), v5(u, 2)) : [];
      }), Ig = A5(function(o, a) {
        var u = Te(a);
        return y1(u) && (u = r), y1(o) ? o0(o, A1(a, 1, y1, !0), r, u) : [];
      });
      function Tg(o, a, u) {
        var d = o == null ? 0 : o.length;
        return d ? (a = u || a === r ? 1 : O5(a), Ie(o, a < 0 ? 0 : a, d)) : [];
      }
      function Og(o, a, u) {
        var d = o == null ? 0 : o.length;
        return d ? (a = u || a === r ? 1 : O5(a), a = d - a, Ie(o, 0, a < 0 ? 0 : a)) : [];
      }
      function zg(o, a) {
        return o && o.length ? z2(o, v5(a, 3), !0, !0) : [];
      }
      function Pg(o, a) {
        return o && o.length ? z2(o, v5(a, 3), !0) : [];
      }
      function Ag(o, a, u, d) {
        var p = o == null ? 0 : o.length;
        return p ? (u && typeof u != "number" && V1(o, a, u) && (u = 0, d = p), Sp(o, a, u, d)) : [];
      }
      function Fs(o, a, u) {
        var d = o == null ? 0 : o.length;
        if (!d)
          return -1;
        var p = u == null ? 0 : O5(u);
        return p < 0 && (p = E1(d + p, 0)), h2(o, v5(a, 3), p);
      }
      function js(o, a, u) {
        var d = o == null ? 0 : o.length;
        if (!d)
          return -1;
        var p = d - 1;
        return u !== r && (p = O5(u), p = u < 0 ? E1(d + p, 0) : N1(p, d - 1)), h2(o, v5(a, 3), p, !0);
      }
      function Us(o) {
        var a = o == null ? 0 : o.length;
        return a ? A1(o, 1) : [];
      }
      function $g(o) {
        var a = o == null ? 0 : o.length;
        return a ? A1(o, M5) : [];
      }
      function Zg(o, a) {
        var u = o == null ? 0 : o.length;
        return u ? (a = a === r ? 1 : O5(a), A1(o, a)) : [];
      }
      function Ng(o) {
        for (var a = -1, u = o == null ? 0 : o.length, d = {}; ++a < u; ) {
          var p = o[a];
          d[p[0]] = p[1];
        }
        return d;
      }
      function Ys(o) {
        return o && o.length ? o[0] : r;
      }
      function Bg(o, a, u) {
        var d = o == null ? 0 : o.length;
        if (!d)
          return -1;
        var p = u == null ? 0 : O5(u);
        return p < 0 && (p = E1(d + p, 0)), jr(o, a, p);
      }
      function Rg(o) {
        var a = o == null ? 0 : o.length;
        return a ? Ie(o, 0, -1) : [];
      }
      var Hg = A5(function(o) {
        var a = p1(o, v6);
        return a.length && a[0] === o[0] ? s6(a) : [];
      }), Fg = A5(function(o) {
        var a = Te(o), u = p1(o, v6);
        return a === Te(u) ? a = r : u.pop(), u.length && u[0] === o[0] ? s6(u, v5(a, 2)) : [];
      }), jg = A5(function(o) {
        var a = Te(o), u = p1(o, v6);
        return a = typeof a == "function" ? a : r, a && u.pop(), u.length && u[0] === o[0] ? s6(u, r, a) : [];
      });
      function Ug(o, a) {
        return o == null ? "" : Rf.call(o, a);
      }
      function Te(o) {
        var a = o == null ? 0 : o.length;
        return a ? o[a - 1] : r;
      }
      function Yg(o, a, u) {
        var d = o == null ? 0 : o.length;
        if (!d)
          return -1;
        var p = d;
        return u !== r && (p = O5(u), p = p < 0 ? E1(d + p, 0) : N1(p, d - 1)), a === a ? Mf(o, a, p) : h2(o, _a, p, !0);
      }
      function Vg(o, a) {
        return o && o.length ? rs(o, O5(a)) : r;
      }
      var Wg = A5(Vs);
      function Vs(o, a) {
        return o && o.length && a && a.length ? h6(o, a) : o;
      }
      function Gg(o, a, u) {
        return o && o.length && a && a.length ? h6(o, a, v5(u, 2)) : o;
      }
      function qg(o, a, u) {
        return o && o.length && a && a.length ? h6(o, a, r, u) : o;
      }
      var Kg = Mt(function(o, a) {
        var u = o == null ? 0 : o.length, d = o6(o, a);
        return is(o, p1(a, function(p) {
          return _t(p, u) ? +p : p;
        }).sort(ps)), d;
      });
      function Jg(o, a) {
        var u = [];
        if (!(o && o.length))
          return u;
        var d = -1, p = [], y = o.length;
        for (a = v5(a, 3); ++d < y; ) {
          var _ = o[d];
          a(_, d, o) && (u.push(_), p.push(d));
        }
        return is(o, p), u;
      }
      function O6(o) {
        return o == null ? o : Uf.call(o);
      }
      function Qg(o, a, u) {
        var d = o == null ? 0 : o.length;
        return d ? (u && typeof u != "number" && V1(o, a, u) ? (a = 0, u = d) : (a = a == null ? 0 : O5(a), u = u === r ? d : O5(u)), Ie(o, a, u)) : [];
      }
      function Xg(o, a) {
        return O2(o, a);
      }
      function em(o, a, u) {
        return p6(o, a, v5(u, 2));
      }
      function tm(o, a) {
        var u = o == null ? 0 : o.length;
        if (u) {
          var d = O2(o, a);
          if (d < u && We(o[d], a))
            return d;
        }
        return -1;
      }
      function rm(o, a) {
        return O2(o, a, !0);
      }
      function nm(o, a, u) {
        return p6(o, a, v5(u, 2), !0);
      }
      function om(o, a) {
        var u = o == null ? 0 : o.length;
        if (u) {
          var d = O2(o, a, !0) - 1;
          if (We(o[d], a))
            return d;
        }
        return -1;
      }
      function im(o) {
        return o && o.length ? as(o) : [];
      }
      function Lm(o, a) {
        return o && o.length ? as(o, v5(a, 2)) : [];
      }
      function am(o) {
        var a = o == null ? 0 : o.length;
        return a ? Ie(o, 1, a) : [];
      }
      function sm(o, a, u) {
        return o && o.length ? (a = u || a === r ? 1 : O5(a), Ie(o, 0, a < 0 ? 0 : a)) : [];
      }
      function lm(o, a, u) {
        var d = o == null ? 0 : o.length;
        return d ? (a = u || a === r ? 1 : O5(a), a = d - a, Ie(o, a < 0 ? 0 : a, d)) : [];
      }
      function um(o, a) {
        return o && o.length ? z2(o, v5(a, 3), !1, !0) : [];
      }
      function cm(o, a) {
        return o && o.length ? z2(o, v5(a, 3)) : [];
      }
      var hm = A5(function(o) {
        return Ut(A1(o, 1, y1, !0));
      }), dm = A5(function(o) {
        var a = Te(o);
        return y1(a) && (a = r), Ut(A1(o, 1, y1, !0), v5(a, 2));
      }), fm = A5(function(o) {
        var a = Te(o);
        return a = typeof a == "function" ? a : r, Ut(A1(o, 1, y1, !0), r, a);
      });
      function pm(o) {
        return o && o.length ? Ut(o) : [];
      }
      function gm(o, a) {
        return o && o.length ? Ut(o, v5(a, 2)) : [];
      }
      function mm(o, a) {
        return a = typeof a == "function" ? a : r, o && o.length ? Ut(o, r, a) : [];
      }
      function z6(o) {
        if (!(o && o.length))
          return [];
        var a = 0;
        return o = Bt(o, function(u) {
          if (y1(u))
            return a = E1(u.length, a), !0;
        }), Ko(a, function(u) {
          return p1(o, Wo(u));
        });
      }
      function Ws(o, a) {
        if (!(o && o.length))
          return [];
        var u = z6(o);
        return a == null ? u : p1(u, function(d) {
          return ae(a, r, d);
        });
      }
      var vm = A5(function(o, a) {
        return y1(o) ? o0(o, a) : [];
      }), ym = A5(function(o) {
        return m6(Bt(o, y1));
      }), wm = A5(function(o) {
        var a = Te(o);
        return y1(a) && (a = r), m6(Bt(o, y1), v5(a, 2));
      }), bm = A5(function(o) {
        var a = Te(o);
        return a = typeof a == "function" ? a : r, m6(Bt(o, y1), r, a);
      }), xm = A5(z6);
      function km(o, a) {
        return cs(o || [], a || [], n0);
      }
      function Mm(o, a) {
        return cs(o || [], a || [], a0);
      }
      var _m = A5(function(o) {
        var a = o.length, u = a > 1 ? o[a - 1] : r;
        return u = typeof u == "function" ? (o.pop(), u) : r, Ws(o, u);
      });
      function Gs(o) {
        var a = v(o);
        return a.__chain__ = !0, a;
      }
      function Cm(o, a) {
        return a(o), o;
      }
      function F2(o, a) {
        return a(o);
      }
      var Sm = Mt(function(o) {
        var a = o.length, u = a ? o[0] : 0, d = this.__wrapped__, p = function(y) {
          return o6(y, o);
        };
        return a > 1 || this.__actions__.length || !(d instanceof j5) || !_t(u) ? this.thru(p) : (d = d.slice(u, +u + (a ? 1 : 0)), d.__actions__.push({
          func: F2,
          args: [p],
          thisArg: r
        }), new De(d, this.__chain__).thru(function(y) {
          return a && !y.length && y.push(r), y;
        }));
      });
      function Dm() {
        return Gs(this);
      }
      function Em() {
        return new De(this.value(), this.__chain__);
      }
      function Im() {
        this.__values__ === r && (this.__values__ = s9(this.value()));
        var o = this.__index__ >= this.__values__.length, a = o ? r : this.__values__[this.__index__++];
        return { done: o, value: a };
      }
      function Tm() {
        return this;
      }
      function Om(o) {
        for (var a, u = this; u instanceof S2; ) {
          var d = Hs(u);
          d.__index__ = 0, d.__values__ = r, a ? p.__wrapped__ = d : a = d;
          var p = d;
          u = u.__wrapped__;
        }
        return p.__wrapped__ = o, a;
      }
      function zm() {
        var o = this.__wrapped__;
        if (o instanceof j5) {
          var a = o;
          return this.__actions__.length && (a = new j5(this)), a = a.reverse(), a.__actions__.push({
            func: F2,
            args: [O6],
            thisArg: r
          }), new De(a, this.__chain__);
        }
        return this.thru(O6);
      }
      function Pm() {
        return us(this.__wrapped__, this.__actions__);
      }
      var Am = P2(function(o, a, u) {
        K5.call(o, u) ? ++o[u] : xt(o, u, 1);
      });
      function $m(o, a, u) {
        var d = D5(o) ? ka : Cp;
        return u && V1(o, a, u) && (a = r), d(o, v5(a, 3));
      }
      function Zm(o, a) {
        var u = D5(o) ? Bt : Wa;
        return u(o, v5(a, 3));
      }
      var Nm = bs(Fs), Bm = bs(js);
      function Rm(o, a) {
        return A1(j2(o, a), 1);
      }
      function Hm(o, a) {
        return A1(j2(o, a), M5);
      }
      function Fm(o, a, u) {
        return u = u === r ? 1 : O5(u), A1(j2(o, a), u);
      }
      function qs(o, a) {
        var u = D5(o) ? Ce : jt;
        return u(o, v5(a, 3));
      }
      function Ks(o, a) {
        var u = D5(o) ? af : Va;
        return u(o, v5(a, 3));
      }
      var jm = P2(function(o, a, u) {
        K5.call(o, u) ? o[u].push(a) : xt(o, u, [a]);
      });
      function Um(o, a, u, d) {
        o = X1(o) ? o : tn(o), u = u && !d ? O5(u) : 0;
        var p = o.length;
        return u < 0 && (u = E1(p + u, 0)), G2(o) ? u <= p && o.indexOf(a, u) > -1 : !!p && jr(o, a, u) > -1;
      }
      var Ym = A5(function(o, a, u) {
        var d = -1, p = typeof a == "function", y = X1(o) ? $(o.length) : [];
        return jt(o, function(_) {
          y[++d] = p ? ae(a, _, u) : i0(_, a, u);
        }), y;
      }), Vm = P2(function(o, a, u) {
        xt(o, u, a);
      });
      function j2(o, a) {
        var u = D5(o) ? p1 : Xa;
        return u(o, v5(a, 3));
      }
      function Wm(o, a, u, d) {
        return o == null ? [] : (D5(a) || (a = a == null ? [] : [a]), u = d ? r : u, D5(u) || (u = u == null ? [] : [u]), ns(o, a, u));
      }
      var Gm = P2(function(o, a, u) {
        o[u ? 0 : 1].push(a);
      }, function() {
        return [[], []];
      });
      function qm(o, a, u) {
        var d = D5(o) ? Yo : Sa, p = arguments.length < 3;
        return d(o, v5(a, 4), u, p, jt);
      }
      function Km(o, a, u) {
        var d = D5(o) ? sf : Sa, p = arguments.length < 3;
        return d(o, v5(a, 4), u, p, Va);
      }
      function Jm(o, a) {
        var u = D5(o) ? Bt : Wa;
        return u(o, V2(v5(a, 3)));
      }
      function Qm(o) {
        var a = D5(o) ? Fa : Up;
        return a(o);
      }
      function Xm(o, a, u) {
        (u ? V1(o, a, u) : a === r) ? a = 1 : a = O5(a);
        var d = D5(o) ? bp : Yp;
        return d(o, a);
      }
      function ev(o) {
        var a = D5(o) ? xp : Wp;
        return a(o);
      }
      function tv(o) {
        if (o == null)
          return 0;
        if (X1(o))
          return G2(o) ? Yr(o) : o.length;
        var a = B1(o);
        return a == o5 || a == x1 ? o.size : u6(o).length;
      }
      function rv(o, a, u) {
        var d = D5(o) ? Vo : Gp;
        return u && V1(o, a, u) && (a = r), d(o, v5(a, 3));
      }
      var nv = A5(function(o, a) {
        if (o == null)
          return [];
        var u = a.length;
        return u > 1 && V1(o, a[0], a[1]) ? a = [] : u > 2 && V1(a[0], a[1], a[2]) && (a = [a[0]]), ns(o, A1(a, 1), []);
      }), U2 = Zf || function() {
        return P1.Date.now();
      };
      function ov(o, a) {
        if (typeof a != "function")
          throw new Se(l);
        return o = O5(o), function() {
          if (--o < 1)
            return a.apply(this, arguments);
        };
      }
      function Js(o, a, u) {
        return a = u ? r : a, a = o && a == null ? o.length : a, kt(o, Z, r, r, r, r, a);
      }
      function Qs(o, a) {
        var u;
        if (typeof a != "function")
          throw new Se(l);
        return o = O5(o), function() {
          return --o > 0 && (u = a.apply(this, arguments)), o <= 1 && (a = r), u;
        };
      }
      var P6 = A5(function(o, a, u) {
        var d = D;
        if (u.length) {
          var p = Ht(u, Xr(P6));
          d |= P;
        }
        return kt(o, d, a, u, p);
      }), Xs = A5(function(o, a, u) {
        var d = D | M;
        if (u.length) {
          var p = Ht(u, Xr(Xs));
          d |= P;
        }
        return kt(a, d, o, u, p);
      });
      function e9(o, a, u) {
        a = u ? r : a;
        var d = kt(o, S, r, r, r, r, r, a);
        return d.placeholder = e9.placeholder, d;
      }
      function t9(o, a, u) {
        a = u ? r : a;
        var d = kt(o, C, r, r, r, r, r, a);
        return d.placeholder = t9.placeholder, d;
      }
      function r9(o, a, u) {
        var d, p, y, _, I, O, H = 0, F = !1, Y = !1, t5 = !0;
        if (typeof o != "function")
          throw new Se(l);
        a = Oe(a) || 0, m1(u) && (F = !!u.leading, Y = "maxWait" in u, y = Y ? E1(Oe(u.maxWait) || 0, a) : y, t5 = "trailing" in u ? !!u.trailing : t5);
        function h5(w1) {
          var Ge = d, Dt = p;
          return d = p = r, H = w1, _ = o.apply(Dt, Ge), _;
        }
        function x5(w1) {
          return H = w1, I = u0(B5, a), F ? h5(w1) : _;
        }
        function z5(w1) {
          var Ge = w1 - O, Dt = w1 - H, b9 = a - Ge;
          return Y ? N1(b9, y - Dt) : b9;
        }
        function k5(w1) {
          var Ge = w1 - O, Dt = w1 - H;
          return O === r || Ge >= a || Ge < 0 || Y && Dt >= y;
        }
        function B5() {
          var w1 = U2();
          if (k5(w1))
            return Y5(w1);
          I = u0(B5, z5(w1));
        }
        function Y5(w1) {
          return I = r, t5 && d ? h5(w1) : (d = p = r, _);
        }
        function ce() {
          I !== r && hs(I), H = 0, d = O = p = I = r;
        }
        function W1() {
          return I === r ? _ : Y5(U2());
        }
        function he() {
          var w1 = U2(), Ge = k5(w1);
          if (d = arguments, p = this, O = w1, Ge) {
            if (I === r)
              return x5(O);
            if (Y)
              return hs(I), I = u0(B5, a), h5(O);
          }
          return I === r && (I = u0(B5, a)), _;
        }
        return he.cancel = ce, he.flush = W1, he;
      }
      var iv = A5(function(o, a) {
        return Ya(o, 1, a);
      }), Lv = A5(function(o, a, u) {
        return Ya(o, Oe(a) || 0, u);
      });
      function av(o) {
        return kt(o, U);
      }
      function Y2(o, a) {
        if (typeof o != "function" || a != null && typeof a != "function")
          throw new Se(l);
        var u = function() {
          var d = arguments, p = a ? a.apply(this, d) : d[0], y = u.cache;
          if (y.has(p))
            return y.get(p);
          var _ = o.apply(this, d);
          return u.cache = y.set(p, _) || y, _;
        };
        return u.cache = new (Y2.Cache || bt)(), u;
      }
      Y2.Cache = bt;
      function V2(o) {
        if (typeof o != "function")
          throw new Se(l);
        return function() {
          var a = arguments;
          switch (a.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, a[0]);
            case 2:
              return !o.call(this, a[0], a[1]);
            case 3:
              return !o.call(this, a[0], a[1], a[2]);
          }
          return !o.apply(this, a);
        };
      }
      function sv(o) {
        return Qs(2, o);
      }
      var lv = qp(function(o, a) {
        a = a.length == 1 && D5(a[0]) ? p1(a[0], se(v5())) : p1(A1(a, 1), se(v5()));
        var u = a.length;
        return A5(function(d) {
          for (var p = -1, y = N1(d.length, u); ++p < y; )
            d[p] = a[p].call(this, d[p]);
          return ae(o, this, d);
        });
      }), A6 = A5(function(o, a) {
        var u = Ht(a, Xr(A6));
        return kt(o, P, r, a, u);
      }), n9 = A5(function(o, a) {
        var u = Ht(a, Xr(n9));
        return kt(o, A, r, a, u);
      }), uv = Mt(function(o, a) {
        return kt(o, B, r, r, r, a);
      });
      function cv(o, a) {
        if (typeof o != "function")
          throw new Se(l);
        return a = a === r ? a : O5(a), A5(o, a);
      }
      function hv(o, a) {
        if (typeof o != "function")
          throw new Se(l);
        return a = a == null ? 0 : E1(O5(a), 0), A5(function(u) {
          var d = u[a], p = Vt(u, 0, a);
          return d && Rt(p, d), ae(o, this, p);
        });
      }
      function dv(o, a, u) {
        var d = !0, p = !0;
        if (typeof o != "function")
          throw new Se(l);
        return m1(u) && (d = "leading" in u ? !!u.leading : d, p = "trailing" in u ? !!u.trailing : p), r9(o, a, {
          leading: d,
          maxWait: a,
          trailing: p
        });
      }
      function fv(o) {
        return Js(o, 1);
      }
      function pv(o, a) {
        return A6(y6(a), o);
      }
      function gv() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return D5(o) ? o : [o];
      }
      function mv(o) {
        return Ee(o, b);
      }
      function vv(o, a) {
        return a = typeof a == "function" ? a : r, Ee(o, b, a);
      }
      function yv(o) {
        return Ee(o, g | b);
      }
      function wv(o, a) {
        return a = typeof a == "function" ? a : r, Ee(o, g | b, a);
      }
      function bv(o, a) {
        return a == null || Ua(o, a, T1(a));
      }
      function We(o, a) {
        return o === a || o !== o && a !== a;
      }
      var xv = N2(a6), kv = N2(function(o, a) {
        return o >= a;
      }), br = Ka(function() {
        return arguments;
      }()) ? Ka : function(o) {
        return v1(o) && K5.call(o, "callee") && !$a.call(o, "callee");
      }, D5 = $.isArray, Mv = ma ? se(ma) : Op;
      function X1(o) {
        return o != null && W2(o.length) && !Ct(o);
      }
      function y1(o) {
        return v1(o) && X1(o);
      }
      function _v(o) {
        return o === !0 || o === !1 || v1(o) && Y1(o) == t1;
      }
      var Wt = Bf || V6, Cv = va ? se(va) : zp;
      function Sv(o) {
        return v1(o) && o.nodeType === 1 && !c0(o);
      }
      function Dv(o) {
        if (o == null)
          return !0;
        if (X1(o) && (D5(o) || typeof o == "string" || typeof o.splice == "function" || Wt(o) || en(o) || br(o)))
          return !o.length;
        var a = B1(o);
        if (a == o5 || a == x1)
          return !o.size;
        if (l0(o))
          return !u6(o).length;
        for (var u in o)
          if (K5.call(o, u))
            return !1;
        return !0;
      }
      function Ev(o, a) {
        return L0(o, a);
      }
      function Iv(o, a, u) {
        u = typeof u == "function" ? u : r;
        var d = u ? u(o, a) : r;
        return d === r ? L0(o, a, r, u) : !!d;
      }
      function $6(o) {
        if (!v1(o))
          return !1;
        var a = Y1(o);
        return a == W || a == Ue || typeof o.message == "string" && typeof o.name == "string" && !c0(o);
      }
      function Tv(o) {
        return typeof o == "number" && Na(o);
      }
      function Ct(o) {
        if (!m1(o))
          return !1;
        var a = Y1(o);
        return a == n5 || a == e5 || a == f1 || a == S1;
      }
      function o9(o) {
        return typeof o == "number" && o == O5(o);
      }
      function W2(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= _5;
      }
      function m1(o) {
        var a = typeof o;
        return o != null && (a == "object" || a == "function");
      }
      function v1(o) {
        return o != null && typeof o == "object";
      }
      var i9 = ya ? se(ya) : Ap;
      function Ov(o, a) {
        return o === a || l6(o, a, C6(a));
      }
      function zv(o, a, u) {
        return u = typeof u == "function" ? u : r, l6(o, a, C6(a), u);
      }
      function Pv(o) {
        return L9(o) && o != +o;
      }
      function Av(o) {
        if (vg(o))
          throw new S5(i);
        return Ja(o);
      }
      function $v(o) {
        return o === null;
      }
      function Zv(o) {
        return o == null;
      }
      function L9(o) {
        return typeof o == "number" || v1(o) && Y1(o) == w5;
      }
      function c0(o) {
        if (!v1(o) || Y1(o) != r1)
          return !1;
        var a = w2(o);
        if (a === null)
          return !0;
        var u = K5.call(a, "constructor") && a.constructor;
        return typeof u == "function" && u instanceof u && g2.call(u) == zf;
      }
      var Z6 = wa ? se(wa) : $p;
      function Nv(o) {
        return o9(o) && o >= -_5 && o <= _5;
      }
      var a9 = ba ? se(ba) : Zp;
      function G2(o) {
        return typeof o == "string" || !D5(o) && v1(o) && Y1(o) == U1;
      }
      function ue(o) {
        return typeof o == "symbol" || v1(o) && Y1(o) == z1;
      }
      var en = xa ? se(xa) : Np;
      function Bv(o) {
        return o === r;
      }
      function Rv(o) {
        return v1(o) && B1(o) == N;
      }
      function Hv(o) {
        return v1(o) && Y1(o) == j;
      }
      var Fv = N2(c6), jv = N2(function(o, a) {
        return o <= a;
      });
      function s9(o) {
        if (!o)
          return [];
        if (X1(o))
          return G2(o) ? Ye(o) : Q1(o);
        if (Qn && o[Qn])
          return bf(o[Qn]());
        var a = B1(o), u = a == o5 ? Qo : a == x1 ? d2 : tn;
        return u(o);
      }
      function St(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = Oe(o), o === M5 || o === -M5) {
          var a = o < 0 ? -1 : 1;
          return a * $5;
        }
        return o === o ? o : 0;
      }
      function O5(o) {
        var a = St(o), u = a % 1;
        return a === a ? u ? a - u : a : 0;
      }
      function l9(o) {
        return o ? mr(O5(o), 0, f5) : 0;
      }
      function Oe(o) {
        if (typeof o == "number")
          return o;
        if (ue(o))
          return E5;
        if (m1(o)) {
          var a = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = m1(a) ? a + "" : a;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = Da(o);
        var u = kd.test(o);
        return u || _d.test(o) ? nf(o.slice(2), u ? 2 : 8) : xd.test(o) ? E5 : +o;
      }
      function u9(o) {
        return st(o, ee(o));
      }
      function Uv(o) {
        return o ? mr(O5(o), -_5, _5) : o === 0 ? o : 0;
      }
      function q5(o) {
        return o == null ? "" : le(o);
      }
      var Yv = Jr(function(o, a) {
        if (l0(a) || X1(a)) {
          st(a, T1(a), o);
          return;
        }
        for (var u in a)
          K5.call(a, u) && n0(o, u, a[u]);
      }), c9 = Jr(function(o, a) {
        st(a, ee(a), o);
      }), q2 = Jr(function(o, a, u, d) {
        st(a, ee(a), o, d);
      }), Vv = Jr(function(o, a, u, d) {
        st(a, T1(a), o, d);
      }), Wv = Mt(o6);
      function Gv(o, a) {
        var u = Kr(o);
        return a == null ? u : ja(u, a);
      }
      var qv = A5(function(o, a) {
        o = Q5(o);
        var u = -1, d = a.length, p = d > 2 ? a[2] : r;
        for (p && V1(a[0], a[1], p) && (d = 1); ++u < d; )
          for (var y = a[u], _ = ee(y), I = -1, O = _.length; ++I < O; ) {
            var H = _[I], F = o[H];
            (F === r || We(F, Wr[H]) && !K5.call(o, H)) && (o[H] = y[H]);
          }
        return o;
      }), Kv = A5(function(o) {
        return o.push(r, Ds), ae(h9, r, o);
      });
      function Jv(o, a) {
        return Ma(o, v5(a, 3), at);
      }
      function Qv(o, a) {
        return Ma(o, v5(a, 3), L6);
      }
      function Xv(o, a) {
        return o == null ? o : i6(o, v5(a, 3), ee);
      }
      function ey(o, a) {
        return o == null ? o : Ga(o, v5(a, 3), ee);
      }
      function ty(o, a) {
        return o && at(o, v5(a, 3));
      }
      function ry(o, a) {
        return o && L6(o, v5(a, 3));
      }
      function ny(o) {
        return o == null ? [] : I2(o, T1(o));
      }
      function oy(o) {
        return o == null ? [] : I2(o, ee(o));
      }
      function N6(o, a, u) {
        var d = o == null ? r : vr(o, a);
        return d === r ? u : d;
      }
      function iy(o, a) {
        return o != null && Ts(o, a, Dp);
      }
      function B6(o, a) {
        return o != null && Ts(o, a, Ep);
      }
      var Ly = ks(function(o, a, u) {
        a != null && typeof a.toString != "function" && (a = m2.call(a)), o[a] = u;
      }, H6(te)), ay = ks(function(o, a, u) {
        a != null && typeof a.toString != "function" && (a = m2.call(a)), K5.call(o, a) ? o[a].push(u) : o[a] = [u];
      }, v5), sy = A5(i0);
      function T1(o) {
        return X1(o) ? Ha(o) : u6(o);
      }
      function ee(o) {
        return X1(o) ? Ha(o, !0) : Bp(o);
      }
      function ly(o, a) {
        var u = {};
        return a = v5(a, 3), at(o, function(d, p, y) {
          xt(u, a(d, p, y), d);
        }), u;
      }
      function uy(o, a) {
        var u = {};
        return a = v5(a, 3), at(o, function(d, p, y) {
          xt(u, p, a(d, p, y));
        }), u;
      }
      var cy = Jr(function(o, a, u) {
        T2(o, a, u);
      }), h9 = Jr(function(o, a, u, d) {
        T2(o, a, u, d);
      }), hy = Mt(function(o, a) {
        var u = {};
        if (o == null)
          return u;
        var d = !1;
        a = p1(a, function(y) {
          return y = Yt(y, o), d || (d = y.length > 1), y;
        }), st(o, M6(o), u), d && (u = Ee(u, g | m | b, Lg));
        for (var p = a.length; p--; )
          g6(u, a[p]);
        return u;
      });
      function dy(o, a) {
        return d9(o, V2(v5(a)));
      }
      var fy = Mt(function(o, a) {
        return o == null ? {} : Hp(o, a);
      });
      function d9(o, a) {
        if (o == null)
          return {};
        var u = p1(M6(o), function(d) {
          return [d];
        });
        return a = v5(a), os(o, u, function(d, p) {
          return a(d, p[0]);
        });
      }
      function py(o, a, u) {
        a = Yt(a, o);
        var d = -1, p = a.length;
        for (p || (p = 1, o = r); ++d < p; ) {
          var y = o == null ? r : o[lt(a[d])];
          y === r && (d = p, y = u), o = Ct(y) ? y.call(o) : y;
        }
        return o;
      }
      function gy(o, a, u) {
        return o == null ? o : a0(o, a, u);
      }
      function my(o, a, u, d) {
        return d = typeof d == "function" ? d : r, o == null ? o : a0(o, a, u, d);
      }
      var f9 = Cs(T1), p9 = Cs(ee);
      function vy(o, a, u) {
        var d = D5(o), p = d || Wt(o) || en(o);
        if (a = v5(a, 4), u == null) {
          var y = o && o.constructor;
          p ? u = d ? new y() : [] : m1(o) ? u = Ct(y) ? Kr(w2(o)) : {} : u = {};
        }
        return (p ? Ce : at)(o, function(_, I, O) {
          return a(u, _, I, O);
        }), u;
      }
      function yy(o, a) {
        return o == null ? !0 : g6(o, a);
      }
      function wy(o, a, u) {
        return o == null ? o : ls(o, a, y6(u));
      }
      function by(o, a, u, d) {
        return d = typeof d == "function" ? d : r, o == null ? o : ls(o, a, y6(u), d);
      }
      function tn(o) {
        return o == null ? [] : Jo(o, T1(o));
      }
      function xy(o) {
        return o == null ? [] : Jo(o, ee(o));
      }
      function ky(o, a, u) {
        return u === r && (u = a, a = r), u !== r && (u = Oe(u), u = u === u ? u : 0), a !== r && (a = Oe(a), a = a === a ? a : 0), mr(Oe(o), a, u);
      }
      function My(o, a, u) {
        return a = St(a), u === r ? (u = a, a = 0) : u = St(u), o = Oe(o), Ip(o, a, u);
      }
      function _y(o, a, u) {
        if (u && typeof u != "boolean" && V1(o, a, u) && (a = u = r), u === r && (typeof a == "boolean" ? (u = a, a = r) : typeof o == "boolean" && (u = o, o = r)), o === r && a === r ? (o = 0, a = 1) : (o = St(o), a === r ? (a = o, o = 0) : a = St(a)), o > a) {
          var d = o;
          o = a, a = d;
        }
        if (u || o % 1 || a % 1) {
          var p = Ba();
          return N1(o + p * (a - o + rf("1e-" + ((p + "").length - 1))), a);
        }
        return d6(o, a);
      }
      var Cy = Qr(function(o, a, u) {
        return a = a.toLowerCase(), o + (u ? g9(a) : a);
      });
      function g9(o) {
        return R6(q5(o).toLowerCase());
      }
      function m9(o) {
        return o = q5(o), o && o.replace(Sd, gf).replace(Vd, "");
      }
      function Sy(o, a, u) {
        o = q5(o), a = le(a);
        var d = o.length;
        u = u === r ? d : mr(O5(u), 0, d);
        var p = u;
        return u -= a.length, u >= 0 && o.slice(u, p) == a;
      }
      function Dy(o) {
        return o = q5(o), o && ad.test(o) ? o.replace(G3, mf) : o;
      }
      function Ey(o) {
        return o = q5(o), o && dd.test(o) ? o.replace(Ao, "\\$&") : o;
      }
      var Iy = Qr(function(o, a, u) {
        return o + (u ? "-" : "") + a.toLowerCase();
      }), Ty = Qr(function(o, a, u) {
        return o + (u ? " " : "") + a.toLowerCase();
      }), Oy = ws("toLowerCase");
      function zy(o, a, u) {
        o = q5(o), a = O5(a);
        var d = a ? Yr(o) : 0;
        if (!a || d >= a)
          return o;
        var p = (a - d) / 2;
        return Z2(M2(p), u) + o + Z2(k2(p), u);
      }
      function Py(o, a, u) {
        o = q5(o), a = O5(a);
        var d = a ? Yr(o) : 0;
        return a && d < a ? o + Z2(a - d, u) : o;
      }
      function Ay(o, a, u) {
        o = q5(o), a = O5(a);
        var d = a ? Yr(o) : 0;
        return a && d < a ? Z2(a - d, u) + o : o;
      }
      function $y(o, a, u) {
        return u || a == null ? a = 0 : a && (a = +a), jf(q5(o).replace($o, ""), a || 0);
      }
      function Zy(o, a, u) {
        return (u ? V1(o, a, u) : a === r) ? a = 1 : a = O5(a), f6(q5(o), a);
      }
      function Ny() {
        var o = arguments, a = q5(o[0]);
        return o.length < 3 ? a : a.replace(o[1], o[2]);
      }
      var By = Qr(function(o, a, u) {
        return o + (u ? "_" : "") + a.toLowerCase();
      });
      function Ry(o, a, u) {
        return u && typeof u != "number" && V1(o, a, u) && (a = u = r), u = u === r ? f5 : u >>> 0, u ? (o = q5(o), o && (typeof a == "string" || a != null && !Z6(a)) && (a = le(a), !a && Ur(o)) ? Vt(Ye(o), 0, u) : o.split(a, u)) : [];
      }
      var Hy = Qr(function(o, a, u) {
        return o + (u ? " " : "") + R6(a);
      });
      function Fy(o, a, u) {
        return o = q5(o), u = u == null ? 0 : mr(O5(u), 0, o.length), a = le(a), o.slice(u, u + a.length) == a;
      }
      function jy(o, a, u) {
        var d = v.templateSettings;
        u && V1(o, a, u) && (a = r), o = q5(o), a = q2({}, a, d, Ss);
        var p = q2({}, a.imports, d.imports, Ss), y = T1(p), _ = Jo(p, y), I, O, H = 0, F = a.interpolate || s2, Y = "__p += '", t5 = Xo(
          (a.escape || s2).source + "|" + F.source + "|" + (F === q3 ? bd : s2).source + "|" + (a.evaluate || s2).source + "|$",
          "g"
        ), h5 = "//# sourceURL=" + (K5.call(a, "sourceURL") ? (a.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Jd + "]") + `
`;
        o.replace(t5, function(k5, B5, Y5, ce, W1, he) {
          return Y5 || (Y5 = ce), Y += o.slice(H, he).replace(Dd, vf), B5 && (I = !0, Y += `' +
__e(` + B5 + `) +
'`), W1 && (O = !0, Y += `';
` + W1 + `;
__p += '`), Y5 && (Y += `' +
((__t = (` + Y5 + `)) == null ? '' : __t) +
'`), H = he + k5.length, k5;
        }), Y += `';
`;
        var x5 = K5.call(a, "variable") && a.variable;
        if (!x5)
          Y = `with (obj) {
` + Y + `
}
`;
        else if (yd.test(x5))
          throw new S5(s);
        Y = (O ? Y.replace(nd, "") : Y).replace(od, "$1").replace(id, "$1;"), Y = "function(" + (x5 || "obj") + `) {
` + (x5 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (I ? ", __e = _.escape" : "") + (O ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Y + `return __p
}`;
        var z5 = y9(function() {
          return G5(y, h5 + "return " + Y).apply(r, _);
        });
        if (z5.source = Y, $6(z5))
          throw z5;
        return z5;
      }
      function Uy(o) {
        return q5(o).toLowerCase();
      }
      function Yy(o) {
        return q5(o).toUpperCase();
      }
      function Vy(o, a, u) {
        if (o = q5(o), o && (u || a === r))
          return Da(o);
        if (!o || !(a = le(a)))
          return o;
        var d = Ye(o), p = Ye(a), y = Ea(d, p), _ = Ia(d, p) + 1;
        return Vt(d, y, _).join("");
      }
      function Wy(o, a, u) {
        if (o = q5(o), o && (u || a === r))
          return o.slice(0, Oa(o) + 1);
        if (!o || !(a = le(a)))
          return o;
        var d = Ye(o), p = Ia(d, Ye(a)) + 1;
        return Vt(d, 0, p).join("");
      }
      function Gy(o, a, u) {
        if (o = q5(o), o && (u || a === r))
          return o.replace($o, "");
        if (!o || !(a = le(a)))
          return o;
        var d = Ye(o), p = Ea(d, Ye(a));
        return Vt(d, p).join("");
      }
      function qy(o, a) {
        var u = K, d = r5;
        if (m1(a)) {
          var p = "separator" in a ? a.separator : p;
          u = "length" in a ? O5(a.length) : u, d = "omission" in a ? le(a.omission) : d;
        }
        o = q5(o);
        var y = o.length;
        if (Ur(o)) {
          var _ = Ye(o);
          y = _.length;
        }
        if (u >= y)
          return o;
        var I = u - Yr(d);
        if (I < 1)
          return d;
        var O = _ ? Vt(_, 0, I).join("") : o.slice(0, I);
        if (p === r)
          return O + d;
        if (_ && (I += O.length - I), Z6(p)) {
          if (o.slice(I).search(p)) {
            var H, F = O;
            for (p.global || (p = Xo(p.source, q5(K3.exec(p)) + "g")), p.lastIndex = 0; H = p.exec(F); )
              var Y = H.index;
            O = O.slice(0, Y === r ? I : Y);
          }
        } else if (o.indexOf(le(p), I) != I) {
          var t5 = O.lastIndexOf(p);
          t5 > -1 && (O = O.slice(0, t5));
        }
        return O + d;
      }
      function Ky(o) {
        return o = q5(o), o && Ld.test(o) ? o.replace(W3, _f) : o;
      }
      var Jy = Qr(function(o, a, u) {
        return o + (u ? " " : "") + a.toUpperCase();
      }), R6 = ws("toUpperCase");
      function v9(o, a, u) {
        return o = q5(o), a = u ? r : a, a === r ? wf(o) ? Df(o) : cf(o) : o.match(a) || [];
      }
      var y9 = A5(function(o, a) {
        try {
          return ae(o, r, a);
        } catch (u) {
          return $6(u) ? u : new S5(u);
        }
      }), Qy = Mt(function(o, a) {
        return Ce(a, function(u) {
          u = lt(u), xt(o, u, P6(o[u], o));
        }), o;
      });
      function Xy(o) {
        var a = o == null ? 0 : o.length, u = v5();
        return o = a ? p1(o, function(d) {
          if (typeof d[1] != "function")
            throw new Se(l);
          return [u(d[0]), d[1]];
        }) : [], A5(function(d) {
          for (var p = -1; ++p < a; ) {
            var y = o[p];
            if (ae(y[0], this, d))
              return ae(y[1], this, d);
          }
        });
      }
      function ew(o) {
        return _p(Ee(o, g));
      }
      function H6(o) {
        return function() {
          return o;
        };
      }
      function tw(o, a) {
        return o == null || o !== o ? a : o;
      }
      var rw = xs(), nw = xs(!0);
      function te(o) {
        return o;
      }
      function F6(o) {
        return Qa(typeof o == "function" ? o : Ee(o, g));
      }
      function ow(o) {
        return es(Ee(o, g));
      }
      function iw(o, a) {
        return ts(o, Ee(a, g));
      }
      var Lw = A5(function(o, a) {
        return function(u) {
          return i0(u, o, a);
        };
      }), aw = A5(function(o, a) {
        return function(u) {
          return i0(o, u, a);
        };
      });
      function j6(o, a, u) {
        var d = T1(a), p = I2(a, d);
        u == null && !(m1(a) && (p.length || !d.length)) && (u = a, a = o, o = this, p = I2(a, T1(a)));
        var y = !(m1(u) && "chain" in u) || !!u.chain, _ = Ct(o);
        return Ce(p, function(I) {
          var O = a[I];
          o[I] = O, _ && (o.prototype[I] = function() {
            var H = this.__chain__;
            if (y || H) {
              var F = o(this.__wrapped__), Y = F.__actions__ = Q1(this.__actions__);
              return Y.push({ func: O, args: arguments, thisArg: o }), F.__chain__ = H, F;
            }
            return O.apply(o, Rt([this.value()], arguments));
          });
        }), o;
      }
      function sw() {
        return P1._ === this && (P1._ = Pf), this;
      }
      function U6() {
      }
      function lw(o) {
        return o = O5(o), A5(function(a) {
          return rs(a, o);
        });
      }
      var uw = b6(p1), cw = b6(ka), hw = b6(Vo);
      function w9(o) {
        return D6(o) ? Wo(lt(o)) : Fp(o);
      }
      function dw(o) {
        return function(a) {
          return o == null ? r : vr(o, a);
        };
      }
      var fw = Ms(), pw = Ms(!0);
      function Y6() {
        return [];
      }
      function V6() {
        return !1;
      }
      function gw() {
        return {};
      }
      function mw() {
        return "";
      }
      function vw() {
        return !0;
      }
      function yw(o, a) {
        if (o = O5(o), o < 1 || o > _5)
          return [];
        var u = f5, d = N1(o, f5);
        a = v5(a), o -= f5;
        for (var p = Ko(d, a); ++u < o; )
          a(u);
        return p;
      }
      function ww(o) {
        return D5(o) ? p1(o, lt) : ue(o) ? [o] : Q1(Rs(q5(o)));
      }
      function bw(o) {
        var a = ++Of;
        return q5(o) + a;
      }
      var xw = $2(function(o, a) {
        return o + a;
      }, 0), kw = x6("ceil"), Mw = $2(function(o, a) {
        return o / a;
      }, 1), _w = x6("floor");
      function Cw(o) {
        return o && o.length ? E2(o, te, a6) : r;
      }
      function Sw(o, a) {
        return o && o.length ? E2(o, v5(a, 2), a6) : r;
      }
      function Dw(o) {
        return Ca(o, te);
      }
      function Ew(o, a) {
        return Ca(o, v5(a, 2));
      }
      function Iw(o) {
        return o && o.length ? E2(o, te, c6) : r;
      }
      function Tw(o, a) {
        return o && o.length ? E2(o, v5(a, 2), c6) : r;
      }
      var Ow = $2(function(o, a) {
        return o * a;
      }, 1), zw = x6("round"), Pw = $2(function(o, a) {
        return o - a;
      }, 0);
      function Aw(o) {
        return o && o.length ? qo(o, te) : 0;
      }
      function $w(o, a) {
        return o && o.length ? qo(o, v5(a, 2)) : 0;
      }
      return v.after = ov, v.ary = Js, v.assign = Yv, v.assignIn = c9, v.assignInWith = q2, v.assignWith = Vv, v.at = Wv, v.before = Qs, v.bind = P6, v.bindAll = Qy, v.bindKey = Xs, v.castArray = gv, v.chain = Gs, v.chunk = _g, v.compact = Cg, v.concat = Sg, v.cond = Xy, v.conforms = ew, v.constant = H6, v.countBy = Am, v.create = Gv, v.curry = e9, v.curryRight = t9, v.debounce = r9, v.defaults = qv, v.defaultsDeep = Kv, v.defer = iv, v.delay = Lv, v.difference = Dg, v.differenceBy = Eg, v.differenceWith = Ig, v.drop = Tg, v.dropRight = Og, v.dropRightWhile = zg, v.dropWhile = Pg, v.fill = Ag, v.filter = Zm, v.flatMap = Rm, v.flatMapDeep = Hm, v.flatMapDepth = Fm, v.flatten = Us, v.flattenDeep = $g, v.flattenDepth = Zg, v.flip = av, v.flow = rw, v.flowRight = nw, v.fromPairs = Ng, v.functions = ny, v.functionsIn = oy, v.groupBy = jm, v.initial = Rg, v.intersection = Hg, v.intersectionBy = Fg, v.intersectionWith = jg, v.invert = Ly, v.invertBy = ay, v.invokeMap = Ym, v.iteratee = F6, v.keyBy = Vm, v.keys = T1, v.keysIn = ee, v.map = j2, v.mapKeys = ly, v.mapValues = uy, v.matches = ow, v.matchesProperty = iw, v.memoize = Y2, v.merge = cy, v.mergeWith = h9, v.method = Lw, v.methodOf = aw, v.mixin = j6, v.negate = V2, v.nthArg = lw, v.omit = hy, v.omitBy = dy, v.once = sv, v.orderBy = Wm, v.over = uw, v.overArgs = lv, v.overEvery = cw, v.overSome = hw, v.partial = A6, v.partialRight = n9, v.partition = Gm, v.pick = fy, v.pickBy = d9, v.property = w9, v.propertyOf = dw, v.pull = Wg, v.pullAll = Vs, v.pullAllBy = Gg, v.pullAllWith = qg, v.pullAt = Kg, v.range = fw, v.rangeRight = pw, v.rearg = uv, v.reject = Jm, v.remove = Jg, v.rest = cv, v.reverse = O6, v.sampleSize = Xm, v.set = gy, v.setWith = my, v.shuffle = ev, v.slice = Qg, v.sortBy = nv, v.sortedUniq = im, v.sortedUniqBy = Lm, v.split = Ry, v.spread = hv, v.tail = am, v.take = sm, v.takeRight = lm, v.takeRightWhile = um, v.takeWhile = cm, v.tap = Cm, v.throttle = dv, v.thru = F2, v.toArray = s9, v.toPairs = f9, v.toPairsIn = p9, v.toPath = ww, v.toPlainObject = u9, v.transform = vy, v.unary = fv, v.union = hm, v.unionBy = dm, v.unionWith = fm, v.uniq = pm, v.uniqBy = gm, v.uniqWith = mm, v.unset = yy, v.unzip = z6, v.unzipWith = Ws, v.update = wy, v.updateWith = by, v.values = tn, v.valuesIn = xy, v.without = vm, v.words = v9, v.wrap = pv, v.xor = ym, v.xorBy = wm, v.xorWith = bm, v.zip = xm, v.zipObject = km, v.zipObjectDeep = Mm, v.zipWith = _m, v.entries = f9, v.entriesIn = p9, v.extend = c9, v.extendWith = q2, j6(v, v), v.add = xw, v.attempt = y9, v.camelCase = Cy, v.capitalize = g9, v.ceil = kw, v.clamp = ky, v.clone = mv, v.cloneDeep = yv, v.cloneDeepWith = wv, v.cloneWith = vv, v.conformsTo = bv, v.deburr = m9, v.defaultTo = tw, v.divide = Mw, v.endsWith = Sy, v.eq = We, v.escape = Dy, v.escapeRegExp = Ey, v.every = $m, v.find = Nm, v.findIndex = Fs, v.findKey = Jv, v.findLast = Bm, v.findLastIndex = js, v.findLastKey = Qv, v.floor = _w, v.forEach = qs, v.forEachRight = Ks, v.forIn = Xv, v.forInRight = ey, v.forOwn = ty, v.forOwnRight = ry, v.get = N6, v.gt = xv, v.gte = kv, v.has = iy, v.hasIn = B6, v.head = Ys, v.identity = te, v.includes = Um, v.indexOf = Bg, v.inRange = My, v.invoke = sy, v.isArguments = br, v.isArray = D5, v.isArrayBuffer = Mv, v.isArrayLike = X1, v.isArrayLikeObject = y1, v.isBoolean = _v, v.isBuffer = Wt, v.isDate = Cv, v.isElement = Sv, v.isEmpty = Dv, v.isEqual = Ev, v.isEqualWith = Iv, v.isError = $6, v.isFinite = Tv, v.isFunction = Ct, v.isInteger = o9, v.isLength = W2, v.isMap = i9, v.isMatch = Ov, v.isMatchWith = zv, v.isNaN = Pv, v.isNative = Av, v.isNil = Zv, v.isNull = $v, v.isNumber = L9, v.isObject = m1, v.isObjectLike = v1, v.isPlainObject = c0, v.isRegExp = Z6, v.isSafeInteger = Nv, v.isSet = a9, v.isString = G2, v.isSymbol = ue, v.isTypedArray = en, v.isUndefined = Bv, v.isWeakMap = Rv, v.isWeakSet = Hv, v.join = Ug, v.kebabCase = Iy, v.last = Te, v.lastIndexOf = Yg, v.lowerCase = Ty, v.lowerFirst = Oy, v.lt = Fv, v.lte = jv, v.max = Cw, v.maxBy = Sw, v.mean = Dw, v.meanBy = Ew, v.min = Iw, v.minBy = Tw, v.stubArray = Y6, v.stubFalse = V6, v.stubObject = gw, v.stubString = mw, v.stubTrue = vw, v.multiply = Ow, v.nth = Vg, v.noConflict = sw, v.noop = U6, v.now = U2, v.pad = zy, v.padEnd = Py, v.padStart = Ay, v.parseInt = $y, v.random = _y, v.reduce = qm, v.reduceRight = Km, v.repeat = Zy, v.replace = Ny, v.result = py, v.round = zw, v.runInContext = T, v.sample = Qm, v.size = tv, v.snakeCase = By, v.some = rv, v.sortedIndex = Xg, v.sortedIndexBy = em, v.sortedIndexOf = tm, v.sortedLastIndex = rm, v.sortedLastIndexBy = nm, v.sortedLastIndexOf = om, v.startCase = Hy, v.startsWith = Fy, v.subtract = Pw, v.sum = Aw, v.sumBy = $w, v.template = jy, v.times = yw, v.toFinite = St, v.toInteger = O5, v.toLength = l9, v.toLower = Uy, v.toNumber = Oe, v.toSafeInteger = Uv, v.toString = q5, v.toUpper = Yy, v.trim = Vy, v.trimEnd = Wy, v.trimStart = Gy, v.truncate = qy, v.unescape = Ky, v.uniqueId = bw, v.upperCase = Jy, v.upperFirst = R6, v.each = qs, v.eachRight = Ks, v.first = Ys, j6(v, function() {
        var o = {};
        return at(v, function(a, u) {
          K5.call(v.prototype, u) || (o[u] = a);
        }), o;
      }(), { chain: !1 }), v.VERSION = n, Ce(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        v[o].placeholder = v;
      }), Ce(["drop", "take"], function(o, a) {
        j5.prototype[o] = function(u) {
          u = u === r ? 1 : E1(O5(u), 0);
          var d = this.__filtered__ && !a ? new j5(this) : this.clone();
          return d.__filtered__ ? d.__takeCount__ = N1(u, d.__takeCount__) : d.__views__.push({
            size: N1(u, f5),
            type: o + (d.__dir__ < 0 ? "Right" : "")
          }), d;
        }, j5.prototype[o + "Right"] = function(u) {
          return this.reverse()[o](u).reverse();
        };
      }), Ce(["filter", "map", "takeWhile"], function(o, a) {
        var u = a + 1, d = u == l5 || u == m5;
        j5.prototype[o] = function(p) {
          var y = this.clone();
          return y.__iteratees__.push({
            iteratee: v5(p, 3),
            type: u
          }), y.__filtered__ = y.__filtered__ || d, y;
        };
      }), Ce(["head", "last"], function(o, a) {
        var u = "take" + (a ? "Right" : "");
        j5.prototype[o] = function() {
          return this[u](1).value()[0];
        };
      }), Ce(["initial", "tail"], function(o, a) {
        var u = "drop" + (a ? "" : "Right");
        j5.prototype[o] = function() {
          return this.__filtered__ ? new j5(this) : this[u](1);
        };
      }), j5.prototype.compact = function() {
        return this.filter(te);
      }, j5.prototype.find = function(o) {
        return this.filter(o).head();
      }, j5.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, j5.prototype.invokeMap = A5(function(o, a) {
        return typeof o == "function" ? new j5(this) : this.map(function(u) {
          return i0(u, o, a);
        });
      }), j5.prototype.reject = function(o) {
        return this.filter(V2(v5(o)));
      }, j5.prototype.slice = function(o, a) {
        o = O5(o);
        var u = this;
        return u.__filtered__ && (o > 0 || a < 0) ? new j5(u) : (o < 0 ? u = u.takeRight(-o) : o && (u = u.drop(o)), a !== r && (a = O5(a), u = a < 0 ? u.dropRight(-a) : u.take(a - o)), u);
      }, j5.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, j5.prototype.toArray = function() {
        return this.take(f5);
      }, at(j5.prototype, function(o, a) {
        var u = /^(?:filter|find|map|reject)|While$/.test(a), d = /^(?:head|last)$/.test(a), p = v[d ? "take" + (a == "last" ? "Right" : "") : a], y = d || /^find/.test(a);
        p && (v.prototype[a] = function() {
          var _ = this.__wrapped__, I = d ? [1] : arguments, O = _ instanceof j5, H = I[0], F = O || D5(_), Y = function(B5) {
            var Y5 = p.apply(v, Rt([B5], I));
            return d && t5 ? Y5[0] : Y5;
          };
          F && u && typeof H == "function" && H.length != 1 && (O = F = !1);
          var t5 = this.__chain__, h5 = !!this.__actions__.length, x5 = y && !t5, z5 = O && !h5;
          if (!y && F) {
            _ = z5 ? _ : new j5(this);
            var k5 = o.apply(_, I);
            return k5.__actions__.push({ func: F2, args: [Y], thisArg: r }), new De(k5, t5);
          }
          return x5 && z5 ? o.apply(this, I) : (k5 = this.thru(Y), x5 ? d ? k5.value()[0] : k5.value() : k5);
        });
      }), Ce(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var a = f2[o], u = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", d = /^(?:pop|shift)$/.test(o);
        v.prototype[o] = function() {
          var p = arguments;
          if (d && !this.__chain__) {
            var y = this.value();
            return a.apply(D5(y) ? y : [], p);
          }
          return this[u](function(_) {
            return a.apply(D5(_) ? _ : [], p);
          });
        };
      }), at(j5.prototype, function(o, a) {
        var u = v[a];
        if (u) {
          var d = u.name + "";
          K5.call(qr, d) || (qr[d] = []), qr[d].push({ name: a, func: u });
        }
      }), qr[A2(r, M).name] = [{
        name: "wrapper",
        func: r
      }], j5.prototype.clone = Kf, j5.prototype.reverse = Jf, j5.prototype.value = Qf, v.prototype.at = Sm, v.prototype.chain = Dm, v.prototype.commit = Em, v.prototype.next = Im, v.prototype.plant = Om, v.prototype.reverse = zm, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = Pm, v.prototype.first = v.prototype.head, Qn && (v.prototype[Qn] = Tm), v;
    }, Vr = Ef();
    dr ? ((dr.exports = Vr)._ = Vr, Fo._ = Vr) : P1._ = Vr;
  }).call(I1);
})(I4, I4.exports);
var gI = I4.exports;
const Hi = /* @__PURE__ */ TL(gI);
function mI(t) {
  const e = /* @__PURE__ */ new Map();
  return function r(n) {
    n.forEach((L) => {
      e.set(L.linkId, L), L.items && r(L.items);
    });
  }(t), e;
}
function vI(t) {
  if (!t)
    return {};
  function e(n) {
    const L = {};
    return n.forEach((i) => {
      const l = i.linkId, s = {};
      i.answer && (s.answer = i.answer[0]), i.item && (s.items = { ...e(i.item) }), L[l] = s;
    }), L;
  }
  return { ...e(t.item || []) };
}
function yI(t) {
  return u5(vI(t));
}
function wI(t) {
  if (!t)
    throw new Error("No Form provided");
  const e = {
    resourceType: "QuestionnaireResponse",
    questionnaire: t.key,
    status: "in-progress"
  };
  function r(n, L) {
    const i = [];
    for (const l of Object.entries(L)) {
      const s = l[0], c = l[1];
      if (Hi.isArray(c))
        c.forEach((h) => {
          const f = n.itemMap.get(s), g = {
            linkId: s,
            text: f.text
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
          };
          h.answer && (g.answer = [h.answer]), h.items && (g.item = r(n, h.items)), i.push(g);
        });
      else {
        const h = n.itemMap.get(s), f = {
          linkId: s,
          text: h.text
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
        };
        c.answer && (f.answer = [c.answer]), c.items && (f.item = r(n, c.items)), i.push(f);
      }
    }
    return i;
  }
  return e.item = r(t, t.response.value), e;
}
function bI(t) {
  return t.url || t.id || t.name || t.title || "unknown";
}
const xI = {
  boolean: "valueBoolean",
  choice: "valueCoding",
  decimal: "valueDecimal",
  integer: "valueInteger",
  date: "valueDate",
  dateTime: "valueDateTime",
  string: "valueString",
  time: "valueTime",
  uri: "valueUri",
  Attachment: "valueAttachment",
  Coding: "valueCoding",
  quantity: "valueQuantity"
}, kI = (t) => {
  if (typeof t == "boolean")
    return t;
  switch (t.toLowerCase()) {
    case "true":
      return !0;
    case "false":
      return !1;
    default:
      return;
  }
};
function MI(t, e) {
  return g5(() => {
    if (!e.enableWhen)
      return !0;
    const r = e.enableWhen.map((n) => {
      const { question: L, operator: i } = n, l = t.itemMap.get(L);
      switch (i) {
        case "=":
          if (!Array.isArray(l.responseValue.value)) {
            const s = l.responseValue.value !== void 0;
            return s && n.answerBoolean !== void 0 ? (
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Resolve the next time you touch this
              kI(l.responseValue.value) === n.answerBoolean
            ) : s && n.answerCoding !== void 0 && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            l.responseValue.value.code === n.answerCoding.code;
          }
          return !1;
        default:
          return !0;
      }
    });
    return e.enableBehavior ? e.enableBehavior === "all" ? !r.filter((n) => !n).length : !!r.filter((n) => n).length : r[0];
  });
}
function _I(t, e) {
  return g5({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Resolve the next time you touch this
    get: () => Hi.get(t.response.value, e.selector.value),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
    set: (r) => Hi.set(t.response.value, e.selector.value, r)
  });
}
function CI(t, e) {
  return g5(() => {
    const r = [];
    if (e.parentLinkId) {
      let n = t.itemMap.get(e.parentLinkId);
      for (; n; ) {
        const L = [];
        L.push(n.linkId), n.repeats && n.type === "group" && L.push(n.index.value), L.push("items"), r.unshift(...L), n = n.parentLinkId ? t.itemMap.get(n.parentLinkId) : void 0;
      }
    }
    return r.push(e.linkId), e.type !== "group" && (r.push("answer"), r.push(xI[e.type])), r;
  });
}
function SI(t, e) {
  return g5(() => {
    if (!e.items)
      return !0;
    for (const r of e.items)
      if (r.enabled.value)
        return !0;
    return !1;
  });
}
var GL = { exports: {} }, mu = function(e, r) {
  return function() {
    for (var L = new Array(arguments.length), i = 0; i < L.length; i++)
      L[i] = arguments[i];
    return e.apply(r, L);
  };
}, DI = mu, Nr = Object.prototype.toString;
function qL(t) {
  return Nr.call(t) === "[object Array]";
}
function Fi(t) {
  return typeof t > "u";
}
function EI(t) {
  return t !== null && !Fi(t) && t.constructor !== null && !Fi(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function II(t) {
  return Nr.call(t) === "[object ArrayBuffer]";
}
function TI(t) {
  return typeof FormData < "u" && t instanceof FormData;
}
function OI(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && t.buffer instanceof ArrayBuffer, e;
}
function zI(t) {
  return typeof t == "string";
}
function PI(t) {
  return typeof t == "number";
}
function vu(t) {
  return t !== null && typeof t == "object";
}
function p4(t) {
  if (Nr.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function AI(t) {
  return Nr.call(t) === "[object Date]";
}
function $I(t) {
  return Nr.call(t) === "[object File]";
}
function ZI(t) {
  return Nr.call(t) === "[object Blob]";
}
function yu(t) {
  return Nr.call(t) === "[object Function]";
}
function NI(t) {
  return vu(t) && yu(t.pipe);
}
function BI(t) {
  return typeof URLSearchParams < "u" && t instanceof URLSearchParams;
}
function RI(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function HI() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function KL(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), qL(t))
      for (var r = 0, n = t.length; r < n; r++)
        e.call(null, t[r], r, t);
    else
      for (var L in t)
        Object.prototype.hasOwnProperty.call(t, L) && e.call(null, t[L], L, t);
}
function ji() {
  var t = {};
  function e(L, i) {
    p4(t[i]) && p4(L) ? t[i] = ji(t[i], L) : p4(L) ? t[i] = ji({}, L) : qL(L) ? t[i] = L.slice() : t[i] = L;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    KL(arguments[r], e);
  return t;
}
function FI(t, e, r) {
  return KL(e, function(L, i) {
    r && typeof L == "function" ? t[i] = DI(L, r) : t[i] = L;
  }), t;
}
function jI(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
var ye = {
  isArray: qL,
  isArrayBuffer: II,
  isBuffer: EI,
  isFormData: TI,
  isArrayBufferView: OI,
  isString: zI,
  isNumber: PI,
  isObject: vu,
  isPlainObject: p4,
  isUndefined: Fi,
  isDate: AI,
  isFile: $I,
  isBlob: ZI,
  isFunction: yu,
  isStream: NI,
  isURLSearchParams: BI,
  isStandardBrowserEnv: HI,
  forEach: KL,
  merge: ji,
  extend: FI,
  trim: RI,
  stripBOM: jI
}, nn = ye;
function K9(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var wu = function(e, r, n) {
  if (!r)
    return e;
  var L;
  if (n)
    L = n(r);
  else if (nn.isURLSearchParams(r))
    L = r.toString();
  else {
    var i = [];
    nn.forEach(r, function(c, h) {
      c === null || typeof c > "u" || (nn.isArray(c) ? h = h + "[]" : c = [c], nn.forEach(c, function(g) {
        nn.isDate(g) ? g = g.toISOString() : nn.isObject(g) && (g = JSON.stringify(g)), i.push(K9(h) + "=" + K9(g));
      }));
    }), L = i.join("&");
  }
  if (L) {
    var l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + L;
  }
  return e;
}, UI = ye;
function io() {
  this.handlers = [];
}
io.prototype.use = function(e, r, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
io.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
io.prototype.forEach = function(e) {
  UI.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var YI = io, VI = ye, WI = function(e, r) {
  VI.forEach(e, function(L, i) {
    i !== r && i.toUpperCase() === r.toUpperCase() && (e[r] = L, delete e[i]);
  });
}, bu = function(e, r, n, L, i) {
  return e.config = r, n && (e.code = n), e.request = L, e.response = i, e.isAxiosError = !0, e.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, e;
}, J6, J9;
function xu() {
  if (J9)
    return J6;
  J9 = 1;
  var t = bu;
  return J6 = function(r, n, L, i, l) {
    var s = new Error(r);
    return t(s, n, L, i, l);
  }, J6;
}
var Q6, Q9;
function GI() {
  if (Q9)
    return Q6;
  Q9 = 1;
  var t = xu();
  return Q6 = function(r, n, L) {
    var i = L.config.validateStatus;
    !L.status || !i || i(L.status) ? r(L) : n(t(
      "Request failed with status code " + L.status,
      L.config,
      null,
      L.request,
      L
    ));
  }, Q6;
}
var X6, X9;
function qI() {
  if (X9)
    return X6;
  X9 = 1;
  var t = ye;
  return X6 = t.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(n, L, i, l, s, c) {
          var h = [];
          h.push(n + "=" + encodeURIComponent(L)), t.isNumber(i) && h.push("expires=" + new Date(i).toGMTString()), t.isString(l) && h.push("path=" + l), t.isString(s) && h.push("domain=" + s), c === !0 && h.push("secure"), document.cookie = h.join("; ");
        },
        read: function(n) {
          var L = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return L ? decodeURIComponent(L[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), X6;
}
var ei, e7;
function KI() {
  return e7 || (e7 = 1, ei = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), ei;
}
var ti, t7;
function JI() {
  return t7 || (t7 = 1, ti = function(e, r) {
    return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
  }), ti;
}
var ri, r7;
function QI() {
  if (r7)
    return ri;
  r7 = 1;
  var t = KI(), e = JI();
  return ri = function(n, L) {
    return n && !t(L) ? e(n, L) : L;
  }, ri;
}
var ni, n7;
function XI() {
  if (n7)
    return ni;
  n7 = 1;
  var t = ye, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return ni = function(n) {
    var L = {}, i, l, s;
    return n && t.forEach(n.split(`
`), function(h) {
      if (s = h.indexOf(":"), i = t.trim(h.substr(0, s)).toLowerCase(), l = t.trim(h.substr(s + 1)), i) {
        if (L[i] && e.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? L[i] = (L[i] ? L[i] : []).concat([l]) : L[i] = L[i] ? L[i] + ", " + l : l;
      }
    }), L;
  }, ni;
}
var oi, o7;
function eT() {
  if (o7)
    return oi;
  o7 = 1;
  var t = ye;
  return oi = t.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), L;
      function i(l) {
        var s = l;
        return r && (n.setAttribute("href", s), s = n.href), n.setAttribute("href", s), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return L = i(window.location.href), function(s) {
        var c = t.isString(s) ? i(s) : s;
        return c.protocol === L.protocol && c.host === L.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), oi;
}
var ii, i7;
function L7() {
  if (i7)
    return ii;
  i7 = 1;
  var t = ye, e = GI(), r = qI(), n = wu, L = QI(), i = XI(), l = eT(), s = xu();
  return ii = function(h) {
    return new Promise(function(g, m) {
      var b = h.data, k = h.headers, x = h.responseType;
      t.isFormData(b) && delete k["Content-Type"];
      var D = new XMLHttpRequest();
      if (h.auth) {
        var M = h.auth.username || "", E = h.auth.password ? unescape(encodeURIComponent(h.auth.password)) : "";
        k.Authorization = "Basic " + btoa(M + ":" + E);
      }
      var S = L(h.baseURL, h.url);
      D.open(h.method.toUpperCase(), n(S, h.params, h.paramsSerializer), !0), D.timeout = h.timeout;
      function C() {
        if (D) {
          var A = "getAllResponseHeaders" in D ? i(D.getAllResponseHeaders()) : null, Z = !x || x === "text" || x === "json" ? D.responseText : D.response, B = {
            data: Z,
            status: D.status,
            statusText: D.statusText,
            headers: A,
            config: h,
            request: D
          };
          e(g, m, B), D = null;
        }
      }
      if ("onloadend" in D ? D.onloadend = C : D.onreadystatechange = function() {
        !D || D.readyState !== 4 || D.status === 0 && !(D.responseURL && D.responseURL.indexOf("file:") === 0) || setTimeout(C);
      }, D.onabort = function() {
        D && (m(s("Request aborted", h, "ECONNABORTED", D)), D = null);
      }, D.onerror = function() {
        m(s("Network Error", h, null, D)), D = null;
      }, D.ontimeout = function() {
        var Z = "timeout of " + h.timeout + "ms exceeded";
        h.timeoutErrorMessage && (Z = h.timeoutErrorMessage), m(s(
          Z,
          h,
          h.transitional && h.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          D
        )), D = null;
      }, t.isStandardBrowserEnv()) {
        var P = (h.withCredentials || l(S)) && h.xsrfCookieName ? r.read(h.xsrfCookieName) : void 0;
        P && (k[h.xsrfHeaderName] = P);
      }
      "setRequestHeader" in D && t.forEach(k, function(Z, B) {
        typeof b > "u" && B.toLowerCase() === "content-type" ? delete k[B] : D.setRequestHeader(B, Z);
      }), t.isUndefined(h.withCredentials) || (D.withCredentials = !!h.withCredentials), x && x !== "json" && (D.responseType = h.responseType), typeof h.onDownloadProgress == "function" && D.addEventListener("progress", h.onDownloadProgress), typeof h.onUploadProgress == "function" && D.upload && D.upload.addEventListener("progress", h.onUploadProgress), h.cancelToken && h.cancelToken.promise.then(function(Z) {
        D && (D.abort(), m(Z), D = null);
      }), b || (b = null), D.send(b);
    });
  }, ii;
}
var $1 = ye, a7 = WI, tT = bu, rT = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function s7(t, e) {
  !$1.isUndefined(t) && $1.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function nT() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = L7()), t;
}
function oT(t, e, r) {
  if ($1.isString(t))
    try {
      return (e || JSON.parse)(t), $1.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
var Lo = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: nT(),
  transformRequest: [function(e, r) {
    return a7(r, "Accept"), a7(r, "Content-Type"), $1.isFormData(e) || $1.isArrayBuffer(e) || $1.isBuffer(e) || $1.isStream(e) || $1.isFile(e) || $1.isBlob(e) ? e : $1.isArrayBufferView(e) ? e.buffer : $1.isURLSearchParams(e) ? (s7(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : $1.isObject(e) || r && r["Content-Type"] === "application/json" ? (s7(r, "application/json"), oT(e)) : e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional, n = r && r.silentJSONParsing, L = r && r.forcedJSONParsing, i = !n && this.responseType === "json";
    if (i || L && $1.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (l) {
        if (i)
          throw l.name === "SyntaxError" ? tT(l, this, "E_JSON_PARSE") : l;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  }
};
Lo.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
$1.forEach(["delete", "get", "head"], function(e) {
  Lo.headers[e] = {};
});
$1.forEach(["post", "put", "patch"], function(e) {
  Lo.headers[e] = $1.merge(rT);
});
var JL = Lo, iT = ye, LT = JL, aT = function(e, r, n) {
  var L = this || LT;
  return iT.forEach(n, function(l) {
    e = l.call(L, e, r);
  }), e;
}, Li, l7;
function ku() {
  return l7 || (l7 = 1, Li = function(e) {
    return !!(e && e.__CANCEL__);
  }), Li;
}
var u7 = ye, ai = aT, sT = ku(), lT = JL;
function si(t) {
  t.cancelToken && t.cancelToken.throwIfRequested();
}
var uT = function(e) {
  si(e), e.headers = e.headers || {}, e.data = ai.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = u7.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), u7.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(L) {
      delete e.headers[L];
    }
  );
  var r = e.adapter || lT.adapter;
  return r(e).then(function(L) {
    return si(e), L.data = ai.call(
      e,
      L.data,
      L.headers,
      e.transformResponse
    ), L;
  }, function(L) {
    return sT(L) || (si(e), L && L.response && (L.response.data = ai.call(
      e,
      L.response.data,
      L.response.headers,
      e.transformResponse
    ))), Promise.reject(L);
  });
}, R1 = ye, Mu = function(e, r) {
  r = r || {};
  var n = {}, L = ["url", "method", "data"], i = ["headers", "auth", "proxy", "params"], l = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], s = ["validateStatus"];
  function c(m, b) {
    return R1.isPlainObject(m) && R1.isPlainObject(b) ? R1.merge(m, b) : R1.isPlainObject(b) ? R1.merge({}, b) : R1.isArray(b) ? b.slice() : b;
  }
  function h(m) {
    R1.isUndefined(r[m]) ? R1.isUndefined(e[m]) || (n[m] = c(void 0, e[m])) : n[m] = c(e[m], r[m]);
  }
  R1.forEach(L, function(b) {
    R1.isUndefined(r[b]) || (n[b] = c(void 0, r[b]));
  }), R1.forEach(i, h), R1.forEach(l, function(b) {
    R1.isUndefined(r[b]) ? R1.isUndefined(e[b]) || (n[b] = c(void 0, e[b])) : n[b] = c(void 0, r[b]);
  }), R1.forEach(s, function(b) {
    b in r ? n[b] = c(e[b], r[b]) : b in e && (n[b] = c(void 0, e[b]));
  });
  var f = L.concat(i).concat(l).concat(s), g = Object.keys(e).concat(Object.keys(r)).filter(function(b) {
    return f.indexOf(b) === -1;
  });
  return R1.forEach(g, h), n;
};
const cT = "axios", hT = "0.21.4", dT = "Promise based HTTP client for the browser and node.js", fT = "index.js", pT = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, gT = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, mT = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], vT = "Matt Zabriskie", yT = "MIT", wT = {
  url: "https://github.com/axios/axios/issues"
}, bT = "https://axios-http.com", xT = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, kT = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, MT = "dist/axios.min.js", _T = "dist/axios.min.js", CT = "./index.d.ts", ST = {
  "follow-redirects": "^1.14.0"
}, DT = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], ET = {
  name: cT,
  version: hT,
  description: dT,
  main: fT,
  scripts: pT,
  repository: gT,
  keywords: mT,
  author: vT,
  license: yT,
  bugs: wT,
  homepage: bT,
  devDependencies: xT,
  browser: kT,
  jsdelivr: MT,
  unpkg: _T,
  typings: CT,
  dependencies: ST,
  bundlesize: DT
};
var _u = ET, QL = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  QL[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var c7 = {}, IT = _u.version.split(".");
function Cu(t, e) {
  for (var r = e ? e.split(".") : IT, n = t.split("."), L = 0; L < 3; L++) {
    if (r[L] > n[L])
      return !0;
    if (r[L] < n[L])
      return !1;
  }
  return !1;
}
QL.transitional = function(e, r, n) {
  var L = r && Cu(r);
  function i(l, s) {
    return "[Axios v" + _u.version + "] Transitional option '" + l + "'" + s + (n ? ". " + n : "");
  }
  return function(l, s, c) {
    if (e === !1)
      throw new Error(i(s, " has been removed in " + r));
    return L && !c7[s] && (c7[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(l, s, c) : !0;
  };
};
function TT(t, e, r) {
  if (typeof t != "object")
    throw new TypeError("options must be an object");
  for (var n = Object.keys(t), L = n.length; L-- > 0; ) {
    var i = n[L], l = e[i];
    if (l) {
      var s = t[i], c = s === void 0 || l(s, i, t);
      if (c !== !0)
        throw new TypeError("option " + i + " must be " + c);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + i);
  }
}
var OT = {
  isOlderVersion: Cu,
  assertOptions: TT,
  validators: QL
}, Su = ye, zT = wu, h7 = YI, d7 = uT, ao = Mu, Du = OT, on = Du.validators;
function X0(t) {
  this.defaults = t, this.interceptors = {
    request: new h7(),
    response: new h7()
  };
}
X0.prototype.request = function(e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = ao(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
  var r = e.transitional;
  r !== void 0 && Du.assertOptions(r, {
    silentJSONParsing: on.transitional(on.boolean, "1.0.0"),
    forcedJSONParsing: on.transitional(on.boolean, "1.0.0"),
    clarifyTimeoutError: on.transitional(on.boolean, "1.0.0")
  }, !1);
  var n = [], L = !0;
  this.interceptors.request.forEach(function(m) {
    typeof m.runWhen == "function" && m.runWhen(e) === !1 || (L = L && m.synchronous, n.unshift(m.fulfilled, m.rejected));
  });
  var i = [];
  this.interceptors.response.forEach(function(m) {
    i.push(m.fulfilled, m.rejected);
  });
  var l;
  if (!L) {
    var s = [d7, void 0];
    for (Array.prototype.unshift.apply(s, n), s = s.concat(i), l = Promise.resolve(e); s.length; )
      l = l.then(s.shift(), s.shift());
    return l;
  }
  for (var c = e; n.length; ) {
    var h = n.shift(), f = n.shift();
    try {
      c = h(c);
    } catch (g) {
      f(g);
      break;
    }
  }
  try {
    l = d7(c);
  } catch (g) {
    return Promise.reject(g);
  }
  for (; i.length; )
    l = l.then(i.shift(), i.shift());
  return l;
};
X0.prototype.getUri = function(e) {
  return e = ao(this.defaults, e), zT(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
Su.forEach(["delete", "get", "head", "options"], function(e) {
  X0.prototype[e] = function(r, n) {
    return this.request(ao(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
Su.forEach(["post", "put", "patch"], function(e) {
  X0.prototype[e] = function(r, n, L) {
    return this.request(ao(L || {}, {
      method: e,
      url: r,
      data: n
    }));
  };
});
var PT = X0, li, f7;
function Eu() {
  if (f7)
    return li;
  f7 = 1;
  function t(e) {
    this.message = e;
  }
  return t.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, t.prototype.__CANCEL__ = !0, li = t, li;
}
var ui, p7;
function AT() {
  if (p7)
    return ui;
  p7 = 1;
  var t = Eu();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(l) {
      n = l;
    });
    var L = this;
    r(function(l) {
      L.reason || (L.reason = new t(l), n(L.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.source = function() {
    var n, L = new e(function(l) {
      n = l;
    });
    return {
      token: L,
      cancel: n
    };
  }, ui = e, ui;
}
var ci, g7;
function $T() {
  return g7 || (g7 = 1, ci = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), ci;
}
var hi, m7;
function ZT() {
  return m7 || (m7 = 1, hi = function(e) {
    return typeof e == "object" && e.isAxiosError === !0;
  }), hi;
}
var v7 = ye, NT = mu, g4 = PT, BT = Mu, RT = JL;
function Iu(t) {
  var e = new g4(t), r = NT(g4.prototype.request, e);
  return v7.extend(r, g4.prototype, e), v7.extend(r, e), r;
}
var tt = Iu(RT);
tt.Axios = g4;
tt.create = function(e) {
  return Iu(BT(tt.defaults, e));
};
tt.Cancel = Eu();
tt.CancelToken = AT();
tt.isCancel = ku();
tt.all = function(e) {
  return Promise.all(e);
};
tt.spread = $T();
tt.isAxiosError = ZT();
GL.exports = tt;
GL.exports.default = tt;
var HT = GL.exports, FT = HT;
const Tu = /* @__PURE__ */ TL(FT), W25 = Tu.create(), ln = "light", Ui = "dark", jT = "theme-mode", UT = "--bl-", YT = "--bl-dk-", VT = (t, e) => {
  const r = new fI();
  Object.keys(r).forEach((n) => {
    y7(t, n, ln), y7(t, n, Ui);
  }), Yi(e);
}, Yi = (t) => {
  document.documentElement.setAttribute(jT, t);
}, y7 = (t, e, r) => {
  if (e) {
    let n, L;
    r === ln ? (L = UT, n = t.light[e] !== null && t.light[e] !== void 0 && t.light[e] !== "" ? t.light[e] : A0.light[e]) : (L = YT, n = t.dark[e] !== null && t.dark[e] !== void 0 && t.dark[e] !== "" ? t.dark[e] : A0.dark[e]), document.documentElement.style.setProperty(
      `${L}${e}`,
      n
    );
  }
};
var WT = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, Ou = {}, we = {};
let XL;
const GT = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
we.getSymbolSize = function(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
we.getSymbolTotalCodewords = function(e) {
  return GT[e];
};
we.getBCHDigit = function(t) {
  let e = 0;
  for (; t !== 0; )
    e++, t >>>= 1;
  return e;
};
we.setToSJISFunction = function(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  XL = e;
};
we.isKanjiModeEnabled = function() {
  return typeof XL < "u";
};
we.toSJIS = function(e) {
  return XL(e);
};
var so = {};
(function(t) {
  t.L = { bit: 1 }, t.M = { bit: 0 }, t.Q = { bit: 3 }, t.H = { bit: 2 };
  function e(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "l":
      case "low":
        return t.L;
      case "m":
      case "medium":
        return t.M;
      case "q":
      case "quartile":
        return t.Q;
      case "h":
      case "high":
        return t.H;
      default:
        throw new Error("Unknown EC Level: " + r);
    }
  }
  t.isValid = function(n) {
    return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
  }, t.from = function(n, L) {
    if (t.isValid(n))
      return n;
    try {
      return e(n);
    } catch {
      return L;
    }
  };
})(so);
function zu() {
  this.buffer = [], this.length = 0;
}
zu.prototype = {
  get: function(t) {
    const e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) === 1;
  },
  put: function(t, e) {
    for (let r = 0; r < e; r++)
      this.putBit((t >>> e - r - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(t) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var qT = zu;
function e2(t) {
  if (!t || t < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
}
e2.prototype.set = function(t, e, r, n) {
  const L = t * this.size + e;
  this.data[L] = r, n && (this.reservedBit[L] = !0);
};
e2.prototype.get = function(t, e) {
  return this.data[t * this.size + e];
};
e2.prototype.xor = function(t, e, r) {
  this.data[t * this.size + e] ^= r;
};
e2.prototype.isReserved = function(t, e) {
  return this.reservedBit[t * this.size + e];
};
var KT = e2, Pu = {};
(function(t) {
  const e = we.getSymbolSize;
  t.getRowColCoords = function(n) {
    if (n === 1)
      return [];
    const L = Math.floor(n / 7) + 2, i = e(n), l = i === 145 ? 26 : Math.ceil((i - 13) / (2 * L - 2)) * 2, s = [i - 7];
    for (let c = 1; c < L - 1; c++)
      s[c] = s[c - 1] - l;
    return s.push(6), s.reverse();
  }, t.getPositions = function(n) {
    const L = [], i = t.getRowColCoords(n), l = i.length;
    for (let s = 0; s < l; s++)
      for (let c = 0; c < l; c++)
        s === 0 && c === 0 || // top-left
        s === 0 && c === l - 1 || // bottom-left
        s === l - 1 && c === 0 || L.push([i[s], i[c]]);
    return L;
  };
})(Pu);
var Au = {};
const JT = we.getSymbolSize, w7 = 7;
Au.getPositions = function(e) {
  const r = JT(e);
  return [
    // top-left
    [0, 0],
    // top-right
    [r - w7, 0],
    // bottom-left
    [0, r - w7]
  ];
};
var $u = {};
(function(t) {
  t.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  t.isValid = function(L) {
    return L != null && L !== "" && !isNaN(L) && L >= 0 && L <= 7;
  }, t.from = function(L) {
    return t.isValid(L) ? parseInt(L, 10) : void 0;
  }, t.getPenaltyN1 = function(L) {
    const i = L.size;
    let l = 0, s = 0, c = 0, h = null, f = null;
    for (let g = 0; g < i; g++) {
      s = c = 0, h = f = null;
      for (let m = 0; m < i; m++) {
        let b = L.get(g, m);
        b === h ? s++ : (s >= 5 && (l += e.N1 + (s - 5)), h = b, s = 1), b = L.get(m, g), b === f ? c++ : (c >= 5 && (l += e.N1 + (c - 5)), f = b, c = 1);
      }
      s >= 5 && (l += e.N1 + (s - 5)), c >= 5 && (l += e.N1 + (c - 5));
    }
    return l;
  }, t.getPenaltyN2 = function(L) {
    const i = L.size;
    let l = 0;
    for (let s = 0; s < i - 1; s++)
      for (let c = 0; c < i - 1; c++) {
        const h = L.get(s, c) + L.get(s, c + 1) + L.get(s + 1, c) + L.get(s + 1, c + 1);
        (h === 4 || h === 0) && l++;
      }
    return l * e.N2;
  }, t.getPenaltyN3 = function(L) {
    const i = L.size;
    let l = 0, s = 0, c = 0;
    for (let h = 0; h < i; h++) {
      s = c = 0;
      for (let f = 0; f < i; f++)
        s = s << 1 & 2047 | L.get(h, f), f >= 10 && (s === 1488 || s === 93) && l++, c = c << 1 & 2047 | L.get(f, h), f >= 10 && (c === 1488 || c === 93) && l++;
    }
    return l * e.N3;
  }, t.getPenaltyN4 = function(L) {
    let i = 0;
    const l = L.data.length;
    for (let c = 0; c < l; c++)
      i += L.data[c];
    return Math.abs(Math.ceil(i * 100 / l / 5) - 10) * e.N4;
  };
  function r(n, L, i) {
    switch (n) {
      case t.Patterns.PATTERN000:
        return (L + i) % 2 === 0;
      case t.Patterns.PATTERN001:
        return L % 2 === 0;
      case t.Patterns.PATTERN010:
        return i % 3 === 0;
      case t.Patterns.PATTERN011:
        return (L + i) % 3 === 0;
      case t.Patterns.PATTERN100:
        return (Math.floor(L / 2) + Math.floor(i / 3)) % 2 === 0;
      case t.Patterns.PATTERN101:
        return L * i % 2 + L * i % 3 === 0;
      case t.Patterns.PATTERN110:
        return (L * i % 2 + L * i % 3) % 2 === 0;
      case t.Patterns.PATTERN111:
        return (L * i % 3 + (L + i) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + n);
    }
  }
  t.applyMask = function(L, i) {
    const l = i.size;
    for (let s = 0; s < l; s++)
      for (let c = 0; c < l; c++)
        i.isReserved(c, s) || i.xor(c, s, r(L, c, s));
  }, t.getBestMask = function(L, i) {
    const l = Object.keys(t.Patterns).length;
    let s = 0, c = 1 / 0;
    for (let h = 0; h < l; h++) {
      i(h), t.applyMask(h, L);
      const f = t.getPenaltyN1(L) + t.getPenaltyN2(L) + t.getPenaltyN3(L) + t.getPenaltyN4(L);
      t.applyMask(h, L), f < c && (c = f, s = h);
    }
    return s;
  };
})($u);
var lo = {};
const rr = so, J2 = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], Q2 = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
lo.getBlocksCount = function(e, r) {
  switch (r) {
    case rr.L:
      return J2[(e - 1) * 4 + 0];
    case rr.M:
      return J2[(e - 1) * 4 + 1];
    case rr.Q:
      return J2[(e - 1) * 4 + 2];
    case rr.H:
      return J2[(e - 1) * 4 + 3];
    default:
      return;
  }
};
lo.getTotalCodewordsCount = function(e, r) {
  switch (r) {
    case rr.L:
      return Q2[(e - 1) * 4 + 0];
    case rr.M:
      return Q2[(e - 1) * 4 + 1];
    case rr.Q:
      return Q2[(e - 1) * 4 + 2];
    case rr.H:
      return Q2[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var Zu = {}, uo = {};
const x0 = new Uint8Array(512), T4 = new Uint8Array(256);
(function() {
  let e = 1;
  for (let r = 0; r < 255; r++)
    x0[r] = e, T4[e] = r, e <<= 1, e & 256 && (e ^= 285);
  for (let r = 255; r < 512; r++)
    x0[r] = x0[r - 255];
})();
uo.log = function(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return T4[e];
};
uo.exp = function(e) {
  return x0[e];
};
uo.mul = function(e, r) {
  return e === 0 || r === 0 ? 0 : x0[T4[e] + T4[r]];
};
(function(t) {
  const e = uo;
  t.mul = function(n, L) {
    const i = new Uint8Array(n.length + L.length - 1);
    for (let l = 0; l < n.length; l++)
      for (let s = 0; s < L.length; s++)
        i[l + s] ^= e.mul(n[l], L[s]);
    return i;
  }, t.mod = function(n, L) {
    let i = new Uint8Array(n);
    for (; i.length - L.length >= 0; ) {
      const l = i[0];
      for (let c = 0; c < L.length; c++)
        i[c] ^= e.mul(L[c], l);
      let s = 0;
      for (; s < i.length && i[s] === 0; )
        s++;
      i = i.slice(s);
    }
    return i;
  }, t.generateECPolynomial = function(n) {
    let L = new Uint8Array([1]);
    for (let i = 0; i < n; i++)
      L = t.mul(L, new Uint8Array([1, e.exp(i)]));
    return L;
  };
})(Zu);
const Nu = Zu;
function e3(t) {
  this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
}
e3.prototype.initialize = function(e) {
  this.degree = e, this.genPoly = Nu.generateECPolynomial(this.degree);
};
e3.prototype.encode = function(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const r = new Uint8Array(e.length + this.degree);
  r.set(e);
  const n = Nu.mod(r, this.genPoly), L = this.degree - n.length;
  if (L > 0) {
    const i = new Uint8Array(this.degree);
    return i.set(n, L), i;
  }
  return n;
};
var QT = e3, Bu = {}, lr = {}, t3 = {};
t3.isValid = function(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var gt = {};
const Ru = "[0-9]+", XT = "[A-Z $%*+\\-./:]+";
let $0 = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$0 = $0.replace(/u/g, "\\u");
const eO = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $0 + `)(?:.|[\r
]))+`;
gt.KANJI = new RegExp($0, "g");
gt.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
gt.BYTE = new RegExp(eO, "g");
gt.NUMERIC = new RegExp(Ru, "g");
gt.ALPHANUMERIC = new RegExp(XT, "g");
const tO = new RegExp("^" + $0 + "$"), rO = new RegExp("^" + Ru + "$"), nO = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
gt.testKanji = function(e) {
  return tO.test(e);
};
gt.testNumeric = function(e) {
  return rO.test(e);
};
gt.testAlphanumeric = function(e) {
  return nO.test(e);
};
(function(t) {
  const e = t3, r = gt;
  t.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, t.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, t.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, t.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, t.MIXED = {
    bit: -1
  }, t.getCharCountIndicator = function(i, l) {
    if (!i.ccBits)
      throw new Error("Invalid mode: " + i);
    if (!e.isValid(l))
      throw new Error("Invalid version: " + l);
    return l >= 1 && l < 10 ? i.ccBits[0] : l < 27 ? i.ccBits[1] : i.ccBits[2];
  }, t.getBestModeForData = function(i) {
    return r.testNumeric(i) ? t.NUMERIC : r.testAlphanumeric(i) ? t.ALPHANUMERIC : r.testKanji(i) ? t.KANJI : t.BYTE;
  }, t.toString = function(i) {
    if (i && i.id)
      return i.id;
    throw new Error("Invalid mode");
  }, t.isValid = function(i) {
    return i && i.bit && i.ccBits;
  };
  function n(L) {
    if (typeof L != "string")
      throw new Error("Param is not a string");
    switch (L.toLowerCase()) {
      case "numeric":
        return t.NUMERIC;
      case "alphanumeric":
        return t.ALPHANUMERIC;
      case "kanji":
        return t.KANJI;
      case "byte":
        return t.BYTE;
      default:
        throw new Error("Unknown mode: " + L);
    }
  }
  t.from = function(i, l) {
    if (t.isValid(i))
      return i;
    try {
      return n(i);
    } catch {
      return l;
    }
  };
})(lr);
(function(t) {
  const e = we, r = lo, n = so, L = lr, i = t3, l = 7973, s = e.getBCHDigit(l);
  function c(m, b, k) {
    for (let x = 1; x <= 40; x++)
      if (b <= t.getCapacity(x, k, m))
        return x;
  }
  function h(m, b) {
    return L.getCharCountIndicator(m, b) + 4;
  }
  function f(m, b) {
    let k = 0;
    return m.forEach(function(x) {
      const D = h(x.mode, b);
      k += D + x.getBitsLength();
    }), k;
  }
  function g(m, b) {
    for (let k = 1; k <= 40; k++)
      if (f(m, k) <= t.getCapacity(k, b, L.MIXED))
        return k;
  }
  t.from = function(b, k) {
    return i.isValid(b) ? parseInt(b, 10) : k;
  }, t.getCapacity = function(b, k, x) {
    if (!i.isValid(b))
      throw new Error("Invalid QR Code version");
    typeof x > "u" && (x = L.BYTE);
    const D = e.getSymbolTotalCodewords(b), M = r.getTotalCodewordsCount(b, k), E = (D - M) * 8;
    if (x === L.MIXED)
      return E;
    const S = E - h(x, b);
    switch (x) {
      case L.NUMERIC:
        return Math.floor(S / 10 * 3);
      case L.ALPHANUMERIC:
        return Math.floor(S / 11 * 2);
      case L.KANJI:
        return Math.floor(S / 13);
      case L.BYTE:
      default:
        return Math.floor(S / 8);
    }
  }, t.getBestVersionForData = function(b, k) {
    let x;
    const D = n.from(k, n.M);
    if (Array.isArray(b)) {
      if (b.length > 1)
        return g(b, D);
      if (b.length === 0)
        return 1;
      x = b[0];
    } else
      x = b;
    return c(x.mode, x.getLength(), D);
  }, t.getEncodedBits = function(b) {
    if (!i.isValid(b) || b < 7)
      throw new Error("Invalid QR Code version");
    let k = b << 12;
    for (; e.getBCHDigit(k) - s >= 0; )
      k ^= l << e.getBCHDigit(k) - s;
    return b << 12 | k;
  };
})(Bu);
var Hu = {};
const Vi = we, Fu = 1335, oO = 21522, b7 = Vi.getBCHDigit(Fu);
Hu.getEncodedBits = function(e, r) {
  const n = e.bit << 3 | r;
  let L = n << 10;
  for (; Vi.getBCHDigit(L) - b7 >= 0; )
    L ^= Fu << Vi.getBCHDigit(L) - b7;
  return (n << 10 | L) ^ oO;
};
var ju = {};
const iO = lr;
function cn(t) {
  this.mode = iO.NUMERIC, this.data = t.toString();
}
cn.getBitsLength = function(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
cn.prototype.getLength = function() {
  return this.data.length;
};
cn.prototype.getBitsLength = function() {
  return cn.getBitsLength(this.data.length);
};
cn.prototype.write = function(e) {
  let r, n, L;
  for (r = 0; r + 3 <= this.data.length; r += 3)
    n = this.data.substr(r, 3), L = parseInt(n, 10), e.put(L, 10);
  const i = this.data.length - r;
  i > 0 && (n = this.data.substr(r), L = parseInt(n, 10), e.put(L, i * 3 + 1));
};
var LO = cn;
const aO = lr, di = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function hn(t) {
  this.mode = aO.ALPHANUMERIC, this.data = t;
}
hn.getBitsLength = function(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
hn.prototype.getLength = function() {
  return this.data.length;
};
hn.prototype.getBitsLength = function() {
  return hn.getBitsLength(this.data.length);
};
hn.prototype.write = function(e) {
  let r;
  for (r = 0; r + 2 <= this.data.length; r += 2) {
    let n = di.indexOf(this.data[r]) * 45;
    n += di.indexOf(this.data[r + 1]), e.put(n, 11);
  }
  this.data.length % 2 && e.put(di.indexOf(this.data[r]), 6);
};
var sO = hn, lO = function(e) {
  for (var r = [], n = e.length, L = 0; L < n; L++) {
    var i = e.charCodeAt(L);
    if (i >= 55296 && i <= 56319 && n > L + 1) {
      var l = e.charCodeAt(L + 1);
      l >= 56320 && l <= 57343 && (i = (i - 55296) * 1024 + l - 56320 + 65536, L += 1);
    }
    if (i < 128) {
      r.push(i);
      continue;
    }
    if (i < 2048) {
      r.push(i >> 6 | 192), r.push(i & 63 | 128);
      continue;
    }
    if (i < 55296 || i >= 57344 && i < 65536) {
      r.push(i >> 12 | 224), r.push(i >> 6 & 63 | 128), r.push(i & 63 | 128);
      continue;
    }
    if (i >= 65536 && i <= 1114111) {
      r.push(i >> 18 | 240), r.push(i >> 12 & 63 | 128), r.push(i >> 6 & 63 | 128), r.push(i & 63 | 128);
      continue;
    }
    r.push(239, 191, 189);
  }
  return new Uint8Array(r).buffer;
};
const uO = lO, cO = lr;
function dn(t) {
  this.mode = cO.BYTE, typeof t == "string" && (t = uO(t)), this.data = new Uint8Array(t);
}
dn.getBitsLength = function(e) {
  return e * 8;
};
dn.prototype.getLength = function() {
  return this.data.length;
};
dn.prototype.getBitsLength = function() {
  return dn.getBitsLength(this.data.length);
};
dn.prototype.write = function(t) {
  for (let e = 0, r = this.data.length; e < r; e++)
    t.put(this.data[e], 8);
};
var hO = dn;
const dO = lr, fO = we;
function fn(t) {
  this.mode = dO.KANJI, this.data = t;
}
fn.getBitsLength = function(e) {
  return e * 13;
};
fn.prototype.getLength = function() {
  return this.data.length;
};
fn.prototype.getBitsLength = function() {
  return fn.getBitsLength(this.data.length);
};
fn.prototype.write = function(t) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let r = fO.toSJIS(this.data[e]);
    if (r >= 33088 && r <= 40956)
      r -= 33088;
    else if (r >= 57408 && r <= 60351)
      r -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    r = (r >>> 8 & 255) * 192 + (r & 255), t.put(r, 13);
  }
};
var pO = fn, Uu = { exports: {} };
(function(t) {
  var e = {
    single_source_shortest_paths: function(r, n, L) {
      var i = {}, l = {};
      l[n] = 0;
      var s = e.PriorityQueue.make();
      s.push(n, 0);
      for (var c, h, f, g, m, b, k, x, D; !s.empty(); ) {
        c = s.pop(), h = c.value, g = c.cost, m = r[h] || {};
        for (f in m)
          m.hasOwnProperty(f) && (b = m[f], k = g + b, x = l[f], D = typeof l[f] > "u", (D || x > k) && (l[f] = k, s.push(f, k), i[f] = h));
      }
      if (typeof L < "u" && typeof l[L] > "u") {
        var M = ["Could not find a path from ", n, " to ", L, "."].join("");
        throw new Error(M);
      }
      return i;
    },
    extract_shortest_path_from_predecessor_list: function(r, n) {
      for (var L = [], i = n; i; )
        L.push(i), r[i], i = r[i];
      return L.reverse(), L;
    },
    find_path: function(r, n, L) {
      var i = e.single_source_shortest_paths(r, n, L);
      return e.extract_shortest_path_from_predecessor_list(
        i,
        L
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(r) {
        var n = e.PriorityQueue, L = {}, i;
        r = r || {};
        for (i in n)
          n.hasOwnProperty(i) && (L[i] = n[i]);
        return L.queue = [], L.sorter = r.sorter || n.default_sorter, L;
      },
      default_sorter: function(r, n) {
        return r.cost - n.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(r, n) {
        var L = { value: r, cost: n };
        this.queue.push(L), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  t.exports = e;
})(Uu);
var gO = Uu.exports;
(function(t) {
  const e = lr, r = LO, n = sO, L = hO, i = pO, l = gt, s = we, c = gO;
  function h(M) {
    return unescape(encodeURIComponent(M)).length;
  }
  function f(M, E, S) {
    const C = [];
    let P;
    for (; (P = M.exec(S)) !== null; )
      C.push({
        data: P[0],
        index: P.index,
        mode: E,
        length: P[0].length
      });
    return C;
  }
  function g(M) {
    const E = f(l.NUMERIC, e.NUMERIC, M), S = f(l.ALPHANUMERIC, e.ALPHANUMERIC, M);
    let C, P;
    return s.isKanjiModeEnabled() ? (C = f(l.BYTE, e.BYTE, M), P = f(l.KANJI, e.KANJI, M)) : (C = f(l.BYTE_KANJI, e.BYTE, M), P = []), E.concat(S, C, P).sort(function(Z, B) {
      return Z.index - B.index;
    }).map(function(Z) {
      return {
        data: Z.data,
        mode: Z.mode,
        length: Z.length
      };
    });
  }
  function m(M, E) {
    switch (E) {
      case e.NUMERIC:
        return r.getBitsLength(M);
      case e.ALPHANUMERIC:
        return n.getBitsLength(M);
      case e.KANJI:
        return i.getBitsLength(M);
      case e.BYTE:
        return L.getBitsLength(M);
    }
  }
  function b(M) {
    return M.reduce(function(E, S) {
      const C = E.length - 1 >= 0 ? E[E.length - 1] : null;
      return C && C.mode === S.mode ? (E[E.length - 1].data += S.data, E) : (E.push(S), E);
    }, []);
  }
  function k(M) {
    const E = [];
    for (let S = 0; S < M.length; S++) {
      const C = M[S];
      switch (C.mode) {
        case e.NUMERIC:
          E.push([
            C,
            { data: C.data, mode: e.ALPHANUMERIC, length: C.length },
            { data: C.data, mode: e.BYTE, length: C.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          E.push([
            C,
            { data: C.data, mode: e.BYTE, length: C.length }
          ]);
          break;
        case e.KANJI:
          E.push([
            C,
            { data: C.data, mode: e.BYTE, length: h(C.data) }
          ]);
          break;
        case e.BYTE:
          E.push([
            { data: C.data, mode: e.BYTE, length: h(C.data) }
          ]);
      }
    }
    return E;
  }
  function x(M, E) {
    const S = {}, C = { start: {} };
    let P = ["start"];
    for (let A = 0; A < M.length; A++) {
      const Z = M[A], B = [];
      for (let U = 0; U < Z.length; U++) {
        const K = Z[U], r5 = "" + A + U;
        B.push(r5), S[r5] = { node: K, lastCount: 0 }, C[r5] = {};
        for (let a5 = 0; a5 < P.length; a5++) {
          const V = P[a5];
          S[V] && S[V].node.mode === K.mode ? (C[V][r5] = m(S[V].lastCount + K.length, K.mode) - m(S[V].lastCount, K.mode), S[V].lastCount += K.length) : (S[V] && (S[V].lastCount = K.length), C[V][r5] = m(K.length, K.mode) + 4 + e.getCharCountIndicator(K.mode, E));
        }
      }
      P = B;
    }
    for (let A = 0; A < P.length; A++)
      C[P[A]].end = 0;
    return { map: C, table: S };
  }
  function D(M, E) {
    let S;
    const C = e.getBestModeForData(M);
    if (S = e.from(E, C), S !== e.BYTE && S.bit < C.bit)
      throw new Error('"' + M + '" cannot be encoded with mode ' + e.toString(S) + `.
 Suggested mode is: ` + e.toString(C));
    switch (S === e.KANJI && !s.isKanjiModeEnabled() && (S = e.BYTE), S) {
      case e.NUMERIC:
        return new r(M);
      case e.ALPHANUMERIC:
        return new n(M);
      case e.KANJI:
        return new i(M);
      case e.BYTE:
        return new L(M);
    }
  }
  t.fromArray = function(E) {
    return E.reduce(function(S, C) {
      return typeof C == "string" ? S.push(D(C, null)) : C.data && S.push(D(C.data, C.mode)), S;
    }, []);
  }, t.fromString = function(E, S) {
    const C = g(E, s.isKanjiModeEnabled()), P = k(C), A = x(P, S), Z = c.find_path(A.map, "start", "end"), B = [];
    for (let U = 1; U < Z.length - 1; U++)
      B.push(A.table[Z[U]].node);
    return t.fromArray(b(B));
  }, t.rawSplit = function(E) {
    return t.fromArray(
      g(E, s.isKanjiModeEnabled())
    );
  };
})(ju);
const co = we, fi = so, mO = qT, vO = KT, yO = Pu, wO = Au, Wi = $u, Gi = lo, bO = QT, O4 = Bu, xO = Hu, kO = lr, pi = ju;
function MO(t, e) {
  const r = t.size, n = wO.getPositions(e);
  for (let L = 0; L < n.length; L++) {
    const i = n[L][0], l = n[L][1];
    for (let s = -1; s <= 7; s++)
      if (!(i + s <= -1 || r <= i + s))
        for (let c = -1; c <= 7; c++)
          l + c <= -1 || r <= l + c || (s >= 0 && s <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (s === 0 || s === 6) || s >= 2 && s <= 4 && c >= 2 && c <= 4 ? t.set(i + s, l + c, !0, !0) : t.set(i + s, l + c, !1, !0));
  }
}
function _O(t) {
  const e = t.size;
  for (let r = 8; r < e - 8; r++) {
    const n = r % 2 === 0;
    t.set(r, 6, n, !0), t.set(6, r, n, !0);
  }
}
function CO(t, e) {
  const r = yO.getPositions(e);
  for (let n = 0; n < r.length; n++) {
    const L = r[n][0], i = r[n][1];
    for (let l = -2; l <= 2; l++)
      for (let s = -2; s <= 2; s++)
        l === -2 || l === 2 || s === -2 || s === 2 || l === 0 && s === 0 ? t.set(L + l, i + s, !0, !0) : t.set(L + l, i + s, !1, !0);
  }
}
function SO(t, e) {
  const r = t.size, n = O4.getEncodedBits(e);
  let L, i, l;
  for (let s = 0; s < 18; s++)
    L = Math.floor(s / 3), i = s % 3 + r - 8 - 3, l = (n >> s & 1) === 1, t.set(L, i, l, !0), t.set(i, L, l, !0);
}
function gi(t, e, r) {
  const n = t.size, L = xO.getEncodedBits(e, r);
  let i, l;
  for (i = 0; i < 15; i++)
    l = (L >> i & 1) === 1, i < 6 ? t.set(i, 8, l, !0) : i < 8 ? t.set(i + 1, 8, l, !0) : t.set(n - 15 + i, 8, l, !0), i < 8 ? t.set(8, n - i - 1, l, !0) : i < 9 ? t.set(8, 15 - i - 1 + 1, l, !0) : t.set(8, 15 - i - 1, l, !0);
  t.set(n - 8, 8, 1, !0);
}
function DO(t, e) {
  const r = t.size;
  let n = -1, L = r - 1, i = 7, l = 0;
  for (let s = r - 1; s > 0; s -= 2)
    for (s === 6 && s--; ; ) {
      for (let c = 0; c < 2; c++)
        if (!t.isReserved(L, s - c)) {
          let h = !1;
          l < e.length && (h = (e[l] >>> i & 1) === 1), t.set(L, s - c, h), i--, i === -1 && (l++, i = 7);
        }
      if (L += n, L < 0 || r <= L) {
        L -= n, n = -n;
        break;
      }
    }
}
function EO(t, e, r) {
  const n = new mO();
  r.forEach(function(c) {
    n.put(c.mode.bit, 4), n.put(c.getLength(), kO.getCharCountIndicator(c.mode, t)), c.write(n);
  });
  const L = co.getSymbolTotalCodewords(t), i = Gi.getTotalCodewordsCount(t, e), l = (L - i) * 8;
  for (n.getLengthInBits() + 4 <= l && n.put(0, 4); n.getLengthInBits() % 8 !== 0; )
    n.putBit(0);
  const s = (l - n.getLengthInBits()) / 8;
  for (let c = 0; c < s; c++)
    n.put(c % 2 ? 17 : 236, 8);
  return IO(n, t, e);
}
function IO(t, e, r) {
  const n = co.getSymbolTotalCodewords(e), L = Gi.getTotalCodewordsCount(e, r), i = n - L, l = Gi.getBlocksCount(e, r), s = n % l, c = l - s, h = Math.floor(n / l), f = Math.floor(i / l), g = f + 1, m = h - f, b = new bO(m);
  let k = 0;
  const x = new Array(l), D = new Array(l);
  let M = 0;
  const E = new Uint8Array(t.buffer);
  for (let Z = 0; Z < l; Z++) {
    const B = Z < c ? f : g;
    x[Z] = E.slice(k, k + B), D[Z] = b.encode(x[Z]), k += B, M = Math.max(M, B);
  }
  const S = new Uint8Array(n);
  let C = 0, P, A;
  for (P = 0; P < M; P++)
    for (A = 0; A < l; A++)
      P < x[A].length && (S[C++] = x[A][P]);
  for (P = 0; P < m; P++)
    for (A = 0; A < l; A++)
      S[C++] = D[A][P];
  return S;
}
function TO(t, e, r, n) {
  let L;
  if (Array.isArray(t))
    L = pi.fromArray(t);
  else if (typeof t == "string") {
    let h = e;
    if (!h) {
      const f = pi.rawSplit(t);
      h = O4.getBestVersionForData(f, r);
    }
    L = pi.fromString(t, h || 40);
  } else
    throw new Error("Invalid data");
  const i = O4.getBestVersionForData(L, r);
  if (!i)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = i;
  else if (e < i)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + i + `.
`
    );
  const l = EO(e, r, L), s = co.getSymbolSize(e), c = new vO(s);
  return MO(c, e), _O(c), CO(c, e), gi(c, r, 0), e >= 7 && SO(c, e), DO(c, l), isNaN(n) && (n = Wi.getBestMask(
    c,
    gi.bind(null, c, r)
  )), Wi.applyMask(n, c), gi(c, r, n), {
    modules: c,
    version: e,
    errorCorrectionLevel: r,
    maskPattern: n,
    segments: L
  };
}
Ou.create = function(e, r) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let n = fi.M, L, i;
  return typeof r < "u" && (n = fi.from(r.errorCorrectionLevel, fi.M), L = O4.from(r.version), i = Wi.from(r.maskPattern), r.toSJISFunc && co.setToSJISFunction(r.toSJISFunc)), TO(e, L, n, i);
};
var Yu = {}, r3 = {};
(function(t) {
  function e(r) {
    if (typeof r == "number" && (r = r.toString()), typeof r != "string")
      throw new Error("Color should be defined as hex string");
    let n = r.slice().replace("#", "").split("");
    if (n.length < 3 || n.length === 5 || n.length > 8)
      throw new Error("Invalid hex color: " + r);
    (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(i) {
      return [i, i];
    }))), n.length === 6 && n.push("F", "F");
    const L = parseInt(n.join(""), 16);
    return {
      r: L >> 24 & 255,
      g: L >> 16 & 255,
      b: L >> 8 & 255,
      a: L & 255,
      hex: "#" + n.slice(0, 6).join("")
    };
  }
  t.getOptions = function(n) {
    n || (n = {}), n.color || (n.color = {});
    const L = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, i = n.width && n.width >= 21 ? n.width : void 0, l = n.scale || 4;
    return {
      width: i,
      scale: i ? 4 : l,
      margin: L,
      color: {
        dark: e(n.color.dark || "#000000ff"),
        light: e(n.color.light || "#ffffffff")
      },
      type: n.type,
      rendererOpts: n.rendererOpts || {}
    };
  }, t.getScale = function(n, L) {
    return L.width && L.width >= n + L.margin * 2 ? L.width / (n + L.margin * 2) : L.scale;
  }, t.getImageWidth = function(n, L) {
    const i = t.getScale(n, L);
    return Math.floor((n + L.margin * 2) * i);
  }, t.qrToImageData = function(n, L, i) {
    const l = L.modules.size, s = L.modules.data, c = t.getScale(l, i), h = Math.floor((l + i.margin * 2) * c), f = i.margin * c, g = [i.color.light, i.color.dark];
    for (let m = 0; m < h; m++)
      for (let b = 0; b < h; b++) {
        let k = (m * h + b) * 4, x = i.color.light;
        if (m >= f && b >= f && m < h - f && b < h - f) {
          const D = Math.floor((m - f) / c), M = Math.floor((b - f) / c);
          x = g[s[D * l + M] ? 1 : 0];
        }
        n[k++] = x.r, n[k++] = x.g, n[k++] = x.b, n[k] = x.a;
      }
  };
})(r3);
(function(t) {
  const e = r3;
  function r(L, i, l) {
    L.clearRect(0, 0, i.width, i.height), i.style || (i.style = {}), i.height = l, i.width = l, i.style.height = l + "px", i.style.width = l + "px";
  }
  function n() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  t.render = function(i, l, s) {
    let c = s, h = l;
    typeof c > "u" && (!l || !l.getContext) && (c = l, l = void 0), l || (h = n()), c = e.getOptions(c);
    const f = e.getImageWidth(i.modules.size, c), g = h.getContext("2d"), m = g.createImageData(f, f);
    return e.qrToImageData(m.data, i, c), r(g, h, f), g.putImageData(m, 0, 0), h;
  }, t.renderToDataURL = function(i, l, s) {
    let c = s;
    typeof c > "u" && (!l || !l.getContext) && (c = l, l = void 0), c || (c = {});
    const h = t.render(i, l, c), f = c.type || "image/png", g = c.rendererOpts || {};
    return h.toDataURL(f, g.quality);
  };
})(Yu);
var Vu = {};
const OO = r3;
function x7(t, e) {
  const r = t.a / 255, n = e + '="' + t.hex + '"';
  return r < 1 ? n + " " + e + '-opacity="' + r.toFixed(2).slice(1) + '"' : n;
}
function mi(t, e, r) {
  let n = t + e;
  return typeof r < "u" && (n += " " + r), n;
}
function zO(t, e, r) {
  let n = "", L = 0, i = !1, l = 0;
  for (let s = 0; s < t.length; s++) {
    const c = Math.floor(s % e), h = Math.floor(s / e);
    !c && !i && (i = !0), t[s] ? (l++, s > 0 && c > 0 && t[s - 1] || (n += i ? mi("M", c + r, 0.5 + h + r) : mi("m", L, 0), L = 0, i = !1), c + 1 < e && t[s + 1] || (n += mi("h", l), l = 0)) : L++;
  }
  return n;
}
Vu.render = function(e, r, n) {
  const L = OO.getOptions(r), i = e.modules.size, l = e.modules.data, s = i + L.margin * 2, c = L.color.light.a ? "<path " + x7(L.color.light, "fill") + ' d="M0 0h' + s + "v" + s + 'H0z"/>' : "", h = "<path " + x7(L.color.dark, "stroke") + ' d="' + zO(l, i, L.margin) + '"/>', f = 'viewBox="0 0 ' + s + " " + s + '"', m = '<svg xmlns="http://www.w3.org/2000/svg" ' + (L.width ? 'width="' + L.width + '" height="' + L.width + '" ' : "") + f + ' shape-rendering="crispEdges">' + c + h + `</svg>
`;
  return typeof n == "function" && n(null, m), m;
};
const PO = WT, qi = Ou, Wu = Yu, AO = Vu;
function n3(t, e, r, n, L) {
  const i = [].slice.call(arguments, 1), l = i.length, s = typeof i[l - 1] == "function";
  if (!s && !PO())
    throw new Error("Callback required as last argument");
  if (s) {
    if (l < 2)
      throw new Error("Too few arguments provided");
    l === 2 ? (L = r, r = e, e = n = void 0) : l === 3 && (e.getContext && typeof L > "u" ? (L = n, n = void 0) : (L = n, n = r, r = e, e = void 0));
  } else {
    if (l < 1)
      throw new Error("Too few arguments provided");
    return l === 1 ? (r = e, e = n = void 0) : l === 2 && !e.getContext && (n = r, r = e, e = void 0), new Promise(function(c, h) {
      try {
        const f = qi.create(r, n);
        c(t(f, e, n));
      } catch (f) {
        h(f);
      }
    });
  }
  try {
    const c = qi.create(r, n);
    L(null, t(c, e, n));
  } catch (c) {
    L(c);
  }
}
qi.create;
n3.bind(null, Wu.render);
var G25 = n3.bind(null, Wu.renderToDataURL);
n3.bind(null, function(t, e, r) {
  return AO.render(t, r);
});
const $O = () => {
  const t = (r, n = /* @__PURE__ */ new Map()) => {
    var L;
    return (L = r.items) == null || L.forEach((i) => {
      i.type !== "group" ? n.set(i.linkId, i) : t(i, n);
    }), n;
  }, e = (r, n) => n != null && n.parentLinkId ? e(r, r.get(n.parentLinkId)) + 1 : 0;
  return {
    flattenNestedGroupItems: t,
    getItemLevel: e
  };
}, ZO = {
  code: "en",
  displayText: "English",
  back: "Back",
  next: "Next",
  submit: "Submit",
  formIsIncomplete: "The Form is incomplete",
  yes: "Yes",
  no: "No",
  barcodeScanner: {
    noDevice: "No device available"
  },
  barcodeScannerMobile: {
    connect: "Scan to connect"
  },
  clusterPatientIdentifier: {
    patientIdLabel: "ID"
  },
  clusterSummaryPanel: {
    summary: "Summary",
    upload: "Submit to Registry"
  },
  implantForm: {
    addButtonText: "Add Item",
    clearButtonText: "Clear",
    databaseConnectionError: "Cannot connect to implant lookup database",
    emptyLotError: "LOT cannot be empty",
    selectionsTitle: "Implant Selections",
    repeatDelimiter: "WARNING: Please confirm barcode and LOT number and enter manually",
    udiNotFound: "UDI not found in database",
    unsupportedBarcode: "Unable to parse barcode. Please enter manually. (Unsupported Barcode)"
  },
  mfxPatientIdentifier: {
    saveInProgress: "Saving...",
    saveSuccess: "Saved to registry",
    saveError: "Save failed",
    settings: "Settings",
    darkToggleTitle: "Dark",
    lightToggleTitle: "Light"
  },
  compactSettings: {
    settings: "Settings"
  },
  save: {
    status: "Uploading...",
    successMessage: "Upload successful",
    errorMessage: "Upload failed"
  },
  repeats: {
    addButtonText: "Add item"
  }
}, NO = {
  code: "en-US",
  displayText: "English - US",
  back: "Back",
  next: "Next",
  submit: "Submit",
  formIsIncomplete: "The Form is incomplete",
  yes: "Yes",
  no: "No",
  barcodeScanner: {
    noDevice: "No device available"
  },
  barcodeScannerMobile: {
    connect: "Scan to connect"
  },
  clusterPatientIdentifier: {
    patientIdLabel: "ID"
  },
  clusterSummaryPanel: {
    summary: "Summary",
    upload: "Submit to Registry"
  },
  implantForm: {
    addButtonText: "Add Item",
    clearButtonText: "Clear",
    databaseConnectionError: "Cannot connect to implant lookup database",
    emptyLotError: "LOT cannot be empty",
    selectionsTitle: "Implant Selections",
    repeatDelimiter: "WARNING: Please confirm barcode and LOT number and enter manually",
    udiNotFound: "UDI not found in database",
    unsupportedBarcode: "Unable to parse barcode. Please enter manually. (Unsupported Barcode)"
  },
  mfxPatientIdentifier: {
    saveInProgress: "Saving...",
    saveSuccess: "Saved to registry",
    saveError: "Save failed",
    settings: "Settings",
    darkToggleTitle: "Dark",
    lightToggleTitle: "Light"
  },
  compactSettings: {
    settings: "Settings"
  },
  save: {
    status: "Uploading...",
    successMessage: "Upload successful",
    errorMessage: "Upload failed"
  },
  repeats: {
    addButtonText: "Add item"
  }
}, BO = {
  code: "de",
  displayText: "Deutsch",
  back: "Zurück",
  next: "Weiter",
  submit: "Senden",
  formIsIncomplete: "Das Formular ist Unvollständig",
  yes: "Ja",
  no: "Nein",
  barcodeScanner: {
    noDevice: "Kamera wurde nicht gefunden"
  },
  barcodeScannerMobile: {
    connect: "Zum Verbinden scannen"
  },
  clusterPatientIdentifier: {
    patientIdLabel: "ID"
  },
  clusterSummaryPanel: {
    summary: "Zusammenfassung",
    upload: "Abschließen und Senden an Register"
  },
  implantForm: {
    addButtonText: "Hinzufügen",
    clearButtonText: "Löschen",
    databaseConnectionError: "Kann keine Verbindung zur Datenbank herstellen",
    emptyLotError: "LOT muss befüllt werden",
    repeatDelimiter: "ACHTUNG: Bitte bestätigen Sie Barcode und LOT-Nummer. Bitte geben Sie den Code manuell ein.",
    selectionsTitle: "Implantatauswahl",
    udiNotFound: "UDI wurde in der Datenbank nicht gefunden",
    unsupportedBarcode: "Barcode kann nicht eingelesen werden. Bitte geben Sie den Code manuell ein."
  },
  mfxPatientIdentifier: {
    saveInProgress: "Wird gespeichert...",
    settings: "Einstellungen",
    darkToggleTitle: "Dunkel",
    lightToggleTitle: "Hell"
  },
  compactSettings: {
    settings: "Einstellungen"
  },
  save: {
    status: "Hochladen...",
    successMessage: "Erfolgreich",
    errorMessage: "Fehlgeschlagen"
  },
  repeats: {
    addButtonText: "Hinzufügen"
  }
}, k7 = {
  code: "de-DE",
  displayText: "Deutsch - DE",
  back: "Zurück",
  next: "Weiter",
  submit: "Senden",
  formIsIncomplete: "Das Formular ist Unvollständig",
  yes: "Ja",
  no: "Nein",
  barcodeScanner: {
    noDevice: "Kamera wurde nicht gefunden"
  },
  barcodeScannerMobile: {
    connect: "Zum Verbinden scannen"
  },
  clusterPatientIdentifier: {
    patientIdLabel: "ID"
  },
  clusterSummaryPanel: {
    summary: "Zusammenfassung",
    upload: "Abschließen und Senden an Register"
  },
  implantForm: {
    addButtonText: "Hinzufügen",
    clearButtonText: "Löschen",
    databaseConnectionError: "Kann keine Verbindung zur Datenbank herstellen",
    emptyLotError: "LOT muss befüllt werden",
    repeatDelimiter: "ACHTUNG: Bitte bestätigen Sie Barcode und LOT-Nummer. Bitte geben Sie den Code manuell ein.",
    selectionsTitle: "Implantatauswahl",
    udiNotFound: "UDI wurde in der Datenbank nicht gefunden",
    unsupportedBarcode: "Barcode kann nicht eingelesen werden. Bitte geben Sie den Code manuell ein."
  },
  mfxPatientIdentifier: {
    saveSuccess: "",
    saveError: "",
    saveInProgress: "Wird gespeichert...",
    settings: "Einstellungen",
    darkToggleTitle: "Dunkel",
    lightToggleTitle: "Hell"
  },
  compactSettings: {
    settings: "Einstellungen"
  },
  save: {
    status: "Hochladen...",
    successMessage: "Erfolgreich",
    errorMessage: "Fehlgeschlagen"
  },
  repeats: {
    addButtonText: "Hinzufügen"
  }
}, RO = {
  code: "ja",
  displayText: "日本語",
  back: "帰る",
  next: "次",
  submit: "出す",
  formIsIncomplete: "フォームが不完全です",
  yes: "はい",
  no: "いいえ",
  barcodeScanner: {
    noDevice: "ビデオカメラが見つかりませんでした"
  },
  barcodeScannerMobile: {
    connect: "接続することをスキャンしてください"
  },
  clusterPatientIdentifier: {
    patientIdLabel: "ID"
  },
  clusterSummaryPanel: {
    summary: "大筋",
    upload: " アップロード"
  },
  implantForm: {
    addButtonText: "足す",
    clearButtonText: "キャンセル",
    databaseConnectionError: "データベースに接続できません",
    emptyLotError: "LOT番号を入力してください",
    repeatDelimiter: "バーコードとLOT番号を糺してください。 キーボードで入力してください。",
    selectionsTitle: "インプラントの選択",
    udiNotFound: "UDIがデータベースに見つかりませんでした",
    unsupportedBarcode: "バーコードをパースできませんから、バーコードとLOT番号をキーボードで入力してください。(バーコードがサポートしません)"
  },
  mfxPatientIdentifier: {
    saveSuccess: "",
    saveError: "",
    saveInProgress: "保存をしています",
    settings: "設定",
    darkToggleTitle: "暗い",
    lightToggleTitle: "明るい"
  },
  compactSettings: {
    settings: "設定"
  }
}, m4 = () => {
  const t = [BO, k7, ZO, NO, RO], e = [], r = () => n(), n = (h) => h ? t.filter((f) => f.code === h)[0] : k7, L = (h) => {
    let g = t.filter((m) => h.includes(m.code)).map((m) => ({ text: m.displayText, value: m.code }));
    return g.length === 0 && (g = t.map((m) => ({ text: m.displayText, value: m.code }))), g;
  }, i = (h) => h ? (Object.keys(h).forEach((f) => {
    typeof h[f] == "object" && (Array.isArray(h[f]) ? h[f].forEach((g) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      g.url === "http://hl7.org/fhir/StructureDefinition/translation" ? g.extension.forEach(
        (m) => {
          m.url === "lang" && e.push(m.valueCode);
        }
      ) : i(g);
    }) : i(
      h[f]
    ));
  }), [...new Set(e)]) : [r().code];
  return {
    defaultLanguage: r,
    setTranslation: n,
    getAvailableTranslations: L,
    findTranslationsInFhirQuestionnaire: i,
    translateText: (h, f, g) => g5(() => {
      if (!g)
        return h[f];
      const m = f === "translations" ? f : `_${f}`;
      if (m in h && // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- Resolve the next time you touch this
      // @ts-ignore
      h[m] && // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- Resolve the next time you touch this
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      h[m].extension) {
        let b = "", k = !1;
        for (const x of h[m].extension) {
          if (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            x.url === "http://hl7.org/fhir/StructureDefinition/translation"
          ) {
            for (const D of x.extension)
              if (
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
                D.url === "lang" && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
                D.valueCode.toLowerCase().includes(g.toLowerCase())
              ) {
                b = x.extension.filter(
                  (M) => M.url === "content"
                )[0].valueString, k = !0;
                break;
              }
          }
          if (k)
            break;
        }
        return m === "translations" && (f = "display"), b || h[f];
      }
      return h[f];
    }),
    initTranslationsOnLayoutCreation: (h, f, g, m = !1) => {
      const b = m ? null : window.navigator.language;
      g(b || h || f);
    },
    formatDateByLocale: (h, f) => {
      const g = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };
      return f ? h.toLocaleDateString(f, g) : h.toLocaleDateString(window.navigator.language, g);
    }
  };
};
class o3 extends gk {
  constructor(r, n, L) {
    super(n, !0);
    // eslint-disable-next-line no-use-before-define -- Resolve the next time you touch this
    q(this, "items");
    q(this, "parentLinkId");
    q(this, "itemLevel");
    // computed reactive properties not part of FHIR QuestionnaireItem
    q(this, "index");
    q(this, "isComplete");
    q(this, "enabled");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
    q(this, "responseValue");
    // the value of the answer
    q(this, "selector");
    // lodash _.set _.get selector
    q(this, "visible");
    this.itemLevel = 0, n.item && (this.items = n.item.map((i) => (m4().findTranslationsInFhirQuestionnaire(i).forEach(
      (l) => !r.languageCodes.includes(l) && r.languageCodes.push(l)
    ), new o3(r, i, n.linkId)))), this.parentLinkId = L, this.index = u5(0), this.isComplete = u5(!1), this.enabled = MI(r, this), this.selector = CI(r, this), this.responseValue = _I(r, this), this.visible = SI(r, this), delete this.item;
  }
}
class HO extends pk {
  // mirrors the FHIR QuestionnaireResponse
  constructor(r, n) {
    super(r, !0);
    q(this, "key");
    // unique key for this Form
    q(this, "items");
    // array of top level FormItems
    q(this, "formLanguageCode");
    q(this, "languageCodes");
    q(this, "itemMap");
    // flat lookup map for all FormItems including nested items
    q(this, "response");
    this.key = bI(r), this.languageCodes = [], this.formLanguageCode = r.language, r.language && this.languageCodes.push(r.language), this.items = r.item ? r.item.map((L) => new o3(this, L)) : [], this.itemMap = mI(this.items), this.response = yI(n);
    for (const L of this.itemMap.entries())
      L[1].itemLevel = $O().getItemLevel(
        this.itemMap,
        L[1]
      );
    delete this.item;
  }
}
const Ki = {
  reset: [0, 0],
  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  overline: [53, 55],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
};
function Ji(t, e, r, n = !1) {
  const L = String(e), i = (s, c) => `\x1B[${c[0]}m${s}\x1B[${c[1]}m`, l = (s, c) => c != null && typeof c == "string" ? i(s, Ki[c]) : c != null && Array.isArray(c) ? c.reduce((h, f) => l(h, f), s) : c != null && c[s.trim()] != null ? l(s, c[s.trim()]) : c != null && c["*"] != null ? l(s, c["*"]) : s;
  return L.replace(/{{(.+?)}}/g, (s, c) => {
    var f;
    const h = r[c] != null ? r[c] : n ? "" : s;
    return t.stylePrettyLogs ? l(h, (f = t == null ? void 0 : t.prettyLogStyles) == null ? void 0 : f[c]) + i("", Ki.reset) : h;
  });
}
function Gu(t) {
  const e = /* @__PURE__ */ new Set();
  return JSON.stringify(t, (r, n) => {
    if (typeof n == "object" && n !== null) {
      if (e.has(n))
        return "[Circular]";
      e.add(n);
    }
    return n;
  });
}
function H1(t, e) {
  const r = {
    seen: [],
    stylize: qu
  };
  return e != null && Xu(r, e), an(r.showHidden) && (r.showHidden = !1), an(r.depth) && (r.depth = 2), an(r.colors) && (r.colors = !0), an(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = jO), z4(r, t, r.depth);
}
H1.colors = Ki;
H1.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  regexp: "red"
};
function FO(t) {
  return typeof t == "boolean";
}
function an(t) {
  return t == null;
}
function qu(t) {
  return t;
}
function jO(t, e) {
  var n, L, i, l;
  const r = H1.styles[e];
  return r != null && ((L = (n = H1 == null ? void 0 : H1.colors) == null ? void 0 : n[r]) == null ? void 0 : L[0]) != null && ((l = (i = H1 == null ? void 0 : H1.colors) == null ? void 0 : i[r]) == null ? void 0 : l[1]) != null ? "\x1B[" + H1.colors[r][0] + "m" + t + "\x1B[" + H1.colors[r][1] + "m" : t;
}
function X2(t) {
  return typeof t == "function";
}
function Ku(t) {
  return typeof t == "string";
}
function UO(t) {
  return typeof t == "number";
}
function Ju(t) {
  return t === null;
}
function Qu(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function vi(t) {
  return ho(t) && i3(t) === "[object RegExp]";
}
function ho(t) {
  return typeof t == "object" && t !== null;
}
function yi(t) {
  return ho(t) && (i3(t) === "[object Error]" || t instanceof Error);
}
function M7(t) {
  return ho(t) && i3(t) === "[object Date]";
}
function i3(t) {
  return Object.prototype.toString.call(t);
}
function YO(t) {
  const e = {};
  return t.forEach((r) => {
    e[r] = !0;
  }), e;
}
function VO(t, e, r, n, L) {
  const i = [];
  for (let l = 0, s = e.length; l < s; ++l)
    Qu(e, String(l)) ? i.push(Qi(t, e, r, n, String(l), !0)) : i.push("");
  return L.forEach((l) => {
    l.match(/^\d+$/) || i.push(Qi(t, e, r, n, l, !0));
  }), i;
}
function wi(t) {
  return "[" + Error.prototype.toString.call(t) + "]";
}
function z4(t, e, r = 0) {
  if (t.customInspect && e != null && X2(e) && (e == null ? void 0 : e.inspect) !== H1 && !(e != null && e.constructor && (e == null ? void 0 : e.constructor.prototype) === e)) {
    if (typeof e.inspect != "function" && e.toString != null)
      return e.toString();
    let f = e == null ? void 0 : e.inspect(r, t);
    return Ku(f) || (f = z4(t, f, r)), f;
  }
  const n = Xt(t, e);
  if (n)
    return n;
  let L = Object.keys(e);
  const i = YO(L);
  try {
    t.showHidden && Object.getOwnPropertyNames && (L = Object.getOwnPropertyNames(e));
  } catch {
  }
  if (yi(e) && (L.indexOf("message") >= 0 || L.indexOf("description") >= 0))
    return wi(e);
  if (L.length === 0)
    if (X2(t.stylize)) {
      if (X2(e)) {
        const f = e.name ? ": " + e.name : "";
        return t.stylize("[Function" + f + "]", "special");
      }
      if (vi(e))
        return t.stylize(RegExp.prototype.toString.call(e), "regexp");
      if (M7(e))
        return t.stylize(Date.prototype.toString.call(e), "date");
      if (yi(e))
        return wi(e);
    } else
      return e;
  let l = "", s = !1, c = [`{
`, `
}`];
  if (Array.isArray(e) && (s = !0, c = [`[
`, `
]`]), X2(e) && (l = " [Function" + (e.name ? ": " + e.name : "") + "]"), vi(e) && (l = " " + RegExp.prototype.toString.call(e)), M7(e) && (l = " " + Date.prototype.toUTCString.call(e)), yi(e) && (l = " " + wi(e)), L.length === 0 && (!s || e.length == 0))
    return c[0] + l + c[1];
  if (r < 0)
    return vi(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special");
  t.seen.push(e);
  let h;
  return s ? h = VO(t, e, r, i, L) : h = L.map((f) => Qi(t, e, r, i, f, s)), t.seen.pop(), WO(h, l, c);
}
function Qi(t, e, r, n, L, i) {
  let l, s, c;
  c = { value: void 0 };
  try {
    c.value = e[L];
  } catch {
  }
  try {
    Object.getOwnPropertyDescriptor && (c = Object.getOwnPropertyDescriptor(e, L) || c);
  } catch {
  }
  if (c.get ? c.set ? s = t.stylize("[Getter/Setter]", "special") : s = t.stylize("[Getter]", "special") : c.set && (s = t.stylize("[Setter]", "special")), Qu(n, L) || (l = "[" + L + "]"), s || (t.seen.indexOf(c.value) < 0 ? (Ju(r) ? s = z4(t, c.value, void 0) : s = z4(t, c.value, r - 1), s.indexOf(`
`) > -1 && (i ? s = s.split(`
`).map((h) => "  " + h).join(`
`).substr(2) : s = `
` + s.split(`
`).map((h) => "   " + h).join(`
`))) : s = t.stylize("[Circular]", "special")), an(l)) {
    if (i && L.match(/^\d+$/))
      return s;
    l = JSON.stringify("" + L), l.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (l = l.substr(1, l.length - 2), l = t.stylize(l, "name")) : (l = l.replace(/'/g, "\\'").replace(/\\"/g, "\\'").replace(/(^"|"$)/g, "'"), l = t.stylize(l, "string"));
  }
  return l + ": " + s;
}
function Xt(t, e) {
  if (an(e))
    return t.stylize("undefined", "undefined");
  if (Ku(e)) {
    const r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\\'") + "'";
    return t.stylize(r, "string");
  }
  if (UO(e))
    return t.stylize("" + e, "number");
  if (FO(e))
    return t.stylize("" + e, "boolean");
  if (Ju(e))
    return t.stylize("null", "null");
}
function WO(t, e, r) {
  return r[0] + (e === "" ? "" : e + `
`) + "  " + t.join(`,
  `) + " " + r[1];
}
function Xu(t, e) {
  if (!e || !ho(e))
    return t;
  const r = Object.keys(e);
  let n = r.length;
  for (; n--; )
    t[r[n]] = e[r[n]];
  return t;
}
function GO(t, ...e) {
  const r = {
    seen: [],
    stylize: qu
  };
  t != null && Xu(r, t);
  const n = e[0];
  let L = 0, i = "", l = "";
  if (typeof n == "string") {
    if (e.length === 1)
      return n;
    let s, c = 0;
    for (let h = 0; h < n.length - 1; h++)
      if (n.charCodeAt(h) === 37) {
        const f = n.charCodeAt(++h);
        if (L + 1 !== e.length) {
          switch (f) {
            case 115: {
              const g = e[++L];
              typeof g == "number" || typeof g == "bigint" ? s = Xt(r, g) : typeof g != "object" || g === null ? s = String(g) : s = H1(g, {
                ...t,
                compact: 3,
                colors: !1,
                depth: 0
              });
              break;
            }
            case 106:
              s = Gu(e[++L]);
              break;
            case 100: {
              const g = e[++L];
              typeof g == "bigint" ? s = Xt(r, g) : typeof g == "symbol" ? s = "NaN" : s = Xt(r, g);
              break;
            }
            case 79:
              s = H1(e[++L], t);
              break;
            case 111:
              s = H1(e[++L], {
                ...t,
                showHidden: !0,
                showProxy: !0,
                depth: 4
              });
              break;
            case 105: {
              const g = e[++L];
              typeof g == "bigint" ? s = Xt(r, g) : typeof g == "symbol" ? s = "NaN" : s = Xt(r, parseInt(s));
              break;
            }
            case 102: {
              const g = e[++L];
              typeof g == "symbol" ? s = "NaN" : s = Xt(r, parseInt(g));
              break;
            }
            case 99:
              L += 1, s = "";
              break;
            case 37:
              i += n.slice(c, h), c = h + 1;
              continue;
            default:
              continue;
          }
          c !== h - 1 && (i += n.slice(c, h - 1)), i += s, c = h + 1;
        } else
          f === 37 && (i += n.slice(c, h), c = h + 1);
      }
    c !== 0 && (L++, l = " ", c < n.length && (i += n.slice(c)));
  }
  for (; L < e.length; ) {
    const s = e[L];
    i += l, i += typeof s != "string" ? H1(s, t) : s, l = " ", L++;
  }
  return i;
}
var Il;
const qO = {
  runtime: [typeof window, typeof document].includes("undefined") ? "Generic" : "Browser",
  browser: (Il = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : Il.userAgent
}, KO = /(?:(?:file|https?|global code|[^@]+)@)?(?:file:)?((?:\/[^:/]+){2,})(?::(\d+))?(?::(\d+))?/;
function JO(t, e, r, n, L, i) {
  return Object.assign({}, qO, {
    name: L,
    parentNames: i,
    date: /* @__PURE__ */ new Date(),
    logLevelId: t,
    logLevelName: e,
    path: n ? void 0 : QO(r)
  });
}
function QO(t, e = Error()) {
  var r, n, L;
  return tc((L = (n = (r = e == null ? void 0 : e.stack) == null ? void 0 : r.split(`
`)) == null ? void 0 : n.filter((i) => !i.includes("Error: "))) == null ? void 0 : L[t]);
}
function ec(t) {
  var e, r, n;
  return (n = (r = (e = t == null ? void 0 : t.stack) == null ? void 0 : e.split(`
`)) == null ? void 0 : r.filter((L) => !L.includes("Error: "))) == null ? void 0 : n.reduce((L, i) => (L.push(tc(i)), L), []);
}
function tc(t) {
  const e = globalThis.location.origin, r = {
    fullFilePath: void 0,
    fileName: void 0,
    fileNameWithLine: void 0,
    fileColumn: void 0,
    fileLine: void 0,
    filePath: void 0,
    filePathWithLine: void 0,
    method: void 0
  };
  if (t != null) {
    const n = t.match(KO);
    if (n) {
      r.filePath = n[1].replace(/\?.*$/, ""), r.fullFilePath = `${e}${r.filePath}`;
      const L = r.filePath.split("/");
      r.fileName = L[L.length - 1], r.fileLine = n[2], r.fileColumn = n[3], r.filePathWithLine = `${r.filePath}:${r.fileLine}`, r.fileNameWithLine = `${r.fileName}:${r.fileLine}`;
    }
  }
  return r;
}
function Xi(t) {
  return t instanceof Error;
}
function XO(t, e) {
  return t.reduce((r, n) => (Xi(n) ? r.errors.push(ez(n, e)) : r.args.push(n), r), { args: [], errors: [] });
}
function ez(t, e) {
  const r = ec(t).map((L) => Ji(e, e.prettyErrorStackTemplate, { ...L }, !0)), n = {
    errorName: ` ${t.name} `,
    errorMessage: t.message,
    errorStack: r.join(`
`)
  };
  return Ji(e, e.prettyErrorTemplate, n);
}
function tz(t, e, r, n) {
  const L = (r.length > 0 && e.length > 0 ? `
` : "") + r.join(`
`);
  n.prettyInspectOptions.colors = n.stylePrettyLogs, console.log(t + GO(n.prettyInspectOptions, ...e) + L);
}
function rz(t) {
  console.log(Gu(t));
}
function ze(t, e = 2, r = 0) {
  return t != null && isNaN(t) ? "" : (t = t != null ? t + r : t, e === 2 ? t == null ? "--" : t < 10 ? "0" + t : t.toString() : t == null ? "---" : t < 10 ? "00" + t : t < 100 ? "0" + t : t.toString());
}
class nz {
  constructor(e, r, n = 4) {
    var c, h, f, g, m, b, k;
    this.logObj = r, this.stackDepthLevel = n;
    const L = ![typeof window, typeof document].includes("undefined"), i = Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
    this.runtime = L ? "browser" : i ? "nodejs" : "unknown";
    const l = L ? (((window == null ? void 0 : window.chrome) || window.Intl && (Intl == null ? void 0 : Intl.v8BreakIterator)) && "CSS" in window) != null : !1, s = L ? /^((?!chrome|android).)*safari/i.test(navigator == null ? void 0 : navigator.userAgent) : !1;
    this.stackDepthLevel = s ? 4 : this.stackDepthLevel, this.settings = {
      type: (e == null ? void 0 : e.type) ?? "pretty",
      name: e == null ? void 0 : e.name,
      parentNames: e == null ? void 0 : e.parentNames,
      minLevel: (e == null ? void 0 : e.minLevel) ?? 0,
      argumentsArrayName: e == null ? void 0 : e.argumentsArrayName,
      hideLogPositionForProduction: (e == null ? void 0 : e.hideLogPositionForProduction) ?? !1,
      prettyLogTemplate: (e == null ? void 0 : e.prettyLogTemplate) ?? "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	{{filePathWithLine}}{{nameWithDelimiterPrefix}}	",
      prettyErrorTemplate: (e == null ? void 0 : e.prettyErrorTemplate) ?? `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
      prettyErrorStackTemplate: (e == null ? void 0 : e.prettyErrorStackTemplate) ?? `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
      prettyErrorParentNamesSeparator: (e == null ? void 0 : e.prettyErrorParentNamesSeparator) ?? ":",
      prettyErrorLoggerNameDelimiter: (e == null ? void 0 : e.prettyErrorLoggerNameDelimiter) ?? "	",
      stylePrettyLogs: (e == null ? void 0 : e.stylePrettyLogs) ?? !0,
      prettyLogTimeZone: (e == null ? void 0 : e.prettyLogTimeZone) ?? "UTC",
      prettyLogStyles: (e == null ? void 0 : e.prettyLogStyles) ?? {
        logLevelName: {
          "*": ["bold", "black", "bgWhiteBright", "dim"],
          SILLY: ["bold", "white"],
          TRACE: ["bold", "whiteBright"],
          DEBUG: ["bold", "green"],
          INFO: ["bold", "blue"],
          WARN: ["bold", "yellow"],
          ERROR: ["bold", "red"],
          FATAL: ["bold", "redBright"]
        },
        dateIsoStr: "white",
        filePathWithLine: "white",
        name: ["white", "bold"],
        nameWithDelimiterPrefix: ["white", "bold"],
        nameWithDelimiterSuffix: ["white", "bold"],
        errorName: ["bold", "bgRedBright", "whiteBright"],
        fileName: ["yellow"],
        fileNameWithLine: "white"
      },
      prettyInspectOptions: (e == null ? void 0 : e.prettyInspectOptions) ?? {
        colors: !0,
        compact: !1,
        depth: 1 / 0
      },
      metaProperty: (e == null ? void 0 : e.metaProperty) ?? "_meta",
      maskPlaceholder: (e == null ? void 0 : e.maskPlaceholder) ?? "[***]",
      maskValuesOfKeys: (e == null ? void 0 : e.maskValuesOfKeys) ?? ["password"],
      maskValuesOfKeysCaseInsensitive: (e == null ? void 0 : e.maskValuesOfKeysCaseInsensitive) ?? !1,
      maskValuesRegEx: e == null ? void 0 : e.maskValuesRegEx,
      prefix: [...(e == null ? void 0 : e.prefix) ?? []],
      attachedTransports: [...(e == null ? void 0 : e.attachedTransports) ?? []],
      overwrite: {
        mask: (c = e == null ? void 0 : e.overwrite) == null ? void 0 : c.mask,
        toLogObj: (h = e == null ? void 0 : e.overwrite) == null ? void 0 : h.toLogObj,
        addMeta: (f = e == null ? void 0 : e.overwrite) == null ? void 0 : f.addMeta,
        formatMeta: (g = e == null ? void 0 : e.overwrite) == null ? void 0 : g.formatMeta,
        formatLogObj: (m = e == null ? void 0 : e.overwrite) == null ? void 0 : m.formatLogObj,
        transportFormatted: (b = e == null ? void 0 : e.overwrite) == null ? void 0 : b.transportFormatted,
        transportJSON: (k = e == null ? void 0 : e.overwrite) == null ? void 0 : k.transportJSON
      }
    }, this.settings.stylePrettyLogs = this.settings.stylePrettyLogs && L && !l ? !1 : this.settings.stylePrettyLogs;
  }
  log(e, r, ...n) {
    var g, m, b, k, x, D, M, E, S, C, P, A, Z, B;
    if (e < this.settings.minLevel)
      return;
    const L = [...this.settings.prefix, ...n], i = ((g = this.settings.overwrite) == null ? void 0 : g.mask) != null ? (m = this.settings.overwrite) == null ? void 0 : m.mask(L) : this.settings.maskValuesOfKeys != null && this.settings.maskValuesOfKeys.length > 0 ? this._mask(L) : L, l = this.logObj != null ? this._recursiveCloneAndExecuteFunctions(this.logObj) : void 0, s = ((b = this.settings.overwrite) == null ? void 0 : b.toLogObj) != null ? (k = this.settings.overwrite) == null ? void 0 : k.toLogObj(i, l) : this._toLogObj(i, l), c = ((x = this.settings.overwrite) == null ? void 0 : x.addMeta) != null ? (D = this.settings.overwrite) == null ? void 0 : D.addMeta(s, e, r) : this._addMetaToLogObj(s, e, r);
    let h, f;
    return ((M = this.settings.overwrite) == null ? void 0 : M.formatMeta) != null && (h = (E = this.settings.overwrite) == null ? void 0 : E.formatMeta(c == null ? void 0 : c[this.settings.metaProperty])), ((S = this.settings.overwrite) == null ? void 0 : S.formatLogObj) != null && (f = (C = this.settings.overwrite) == null ? void 0 : C.formatLogObj(i, this.settings)), this.settings.type === "pretty" && (h = h ?? this._prettyFormatLogObjMeta(c == null ? void 0 : c[this.settings.metaProperty]), f = f ?? XO(i, this.settings)), h != null && f != null ? ((P = this.settings.overwrite) == null ? void 0 : P.transportFormatted) != null ? (A = this.settings.overwrite) == null || A.transportFormatted(h, f.args, f.errors, this.settings) : tz(h, f.args, f.errors, this.settings) : ((Z = this.settings.overwrite) == null ? void 0 : Z.transportJSON) != null ? (B = this.settings.overwrite) == null || B.transportJSON(c) : this.settings.type !== "hidden" && rz(c), this.settings.attachedTransports != null && this.settings.attachedTransports.length > 0 && this.settings.attachedTransports.forEach((U) => {
      U(c);
    }), c;
  }
  attachTransport(e) {
    this.settings.attachedTransports.push(e);
  }
  getSubLogger(e, r) {
    var i, l, s;
    const n = {
      ...this.settings,
      ...e,
      parentNames: ((i = this.settings) == null ? void 0 : i.parentNames) != null && ((l = this.settings) == null ? void 0 : l.name) != null ? [...this.settings.parentNames, this.settings.name] : ((s = this.settings) == null ? void 0 : s.name) != null ? [this.settings.name] : void 0,
      prefix: [...this.settings.prefix, ...(e == null ? void 0 : e.prefix) ?? []]
    };
    return new this.constructor(n, r ?? this.logObj, this.stackDepthLevel);
  }
  _mask(e) {
    const r = this.settings.maskValuesOfKeysCaseInsensitive !== !0 ? this.settings.maskValuesOfKeys : this.settings.maskValuesOfKeys.map((n) => n.toLowerCase());
    return e == null ? void 0 : e.map((n) => this._recursiveCloneAndMaskValuesOfKeys(n, r));
  }
  _recursiveCloneAndMaskValuesOfKeys(e, r, n = []) {
    return n.includes(e) ? { ...e } : (typeof e == "object" && e != null && n.push(e), void 0 ? e : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : Array.isArray(e) ? e.map((L) => this._recursiveCloneAndMaskValuesOfKeys(L, r, n)) : e instanceof Date ? new Date(e.getTime()) : Xi(e) ? Object.getOwnPropertyNames(e).reduce((L, i) => {
      var l;
      return L[i] = r.includes(((l = this.settings) == null ? void 0 : l.maskValuesOfKeysCaseInsensitive) !== !0 ? i : i.toLowerCase()) ? this.settings.maskPlaceholder : this._recursiveCloneAndMaskValuesOfKeys(e[i], r, n), L;
    }, this._cloneError(e)) : e != null && typeof e == "object" ? Object.getOwnPropertyNames(e).reduce((L, i) => {
      var l;
      return L[i] = r.includes(((l = this.settings) == null ? void 0 : l.maskValuesOfKeysCaseInsensitive) !== !0 ? i : i.toLowerCase()) ? this.settings.maskPlaceholder : this._recursiveCloneAndMaskValuesOfKeys(e[i], r, n), L;
    }, Object.create(Object.getPrototypeOf(e))) : ((L) => {
      var i, l;
      return (l = (i = this.settings) == null ? void 0 : i.maskValuesRegEx) == null || l.forEach((s) => {
        var c;
        L = (c = L == null ? void 0 : L.toString()) == null ? void 0 : c.replace(s, this.settings.maskPlaceholder);
      }), L;
    })(e));
  }
  _recursiveCloneAndExecuteFunctions(e, r = []) {
    return r.includes(e) ? { ...e } : (typeof e == "object" && r.push(e), Array.isArray(e) ? e.map((n) => this._recursiveCloneAndExecuteFunctions(n, r)) : e instanceof Date ? new Date(e.getTime()) : e && typeof e == "object" ? Object.getOwnPropertyNames(e).reduce((n, L) => (Object.defineProperty(n, L, Object.getOwnPropertyDescriptor(e, L)), n[L] = typeof e[L] == "function" ? e[L]() : this._recursiveCloneAndExecuteFunctions(e[L], r), n), Object.create(Object.getPrototypeOf(e))) : e);
  }
  _toLogObj(e, r = {}) {
    return e = e == null ? void 0 : e.map((n) => Xi(n) ? this._toErrorObject(n) : n), this.settings.argumentsArrayName == null ? e.length === 1 && !Array.isArray(e[0]) && (e[0], void 0) !== !0 && !(e[0] instanceof Date) ? r = typeof e[0] == "object" && e[0] != null ? { ...e[0], ...r } : { 0: e[0], ...r } : r = { ...r, ...e } : r = {
      ...r,
      [this.settings.argumentsArrayName]: e
    }, r;
  }
  _cloneError(e) {
    const r = e.constructor, n = new r(e.message);
    Object.assign(n, e);
    const L = Object.getOwnPropertyNames(n);
    for (const i of L) {
      const l = Object.getOwnPropertyDescriptor(n, i);
      l && (l.writable = !0, Object.defineProperty(n, i, l));
    }
    return n;
  }
  _toErrorObject(e) {
    return {
      nativeError: e,
      name: e.name ?? "Error",
      message: e.message,
      stack: ec(e)
    };
  }
  _addMetaToLogObj(e, r, n) {
    return {
      ...e,
      [this.settings.metaProperty]: JO(r, n, this.stackDepthLevel, this.settings.hideLogPositionForProduction, this.settings.name, this.settings.parentNames)
    };
  }
  _prettyFormatLogObjMeta(e) {
    var l, s, c, h, f, g, m, b, k, x, D, M, E, S, C, P, A, Z, B, U;
    if (e == null)
      return "";
    let r = this.settings.prettyLogTemplate;
    const n = {};
    r.includes("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}") ? r = r.replace("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}", "{{dateIsoStr}}") : this.settings.prettyLogTimeZone === "UTC" ? (n.yyyy = ((l = e == null ? void 0 : e.date) == null ? void 0 : l.getUTCFullYear()) ?? "----", n.mm = ze((s = e == null ? void 0 : e.date) == null ? void 0 : s.getUTCMonth(), 2, 1), n.dd = ze((c = e == null ? void 0 : e.date) == null ? void 0 : c.getUTCDate(), 2), n.hh = ze((h = e == null ? void 0 : e.date) == null ? void 0 : h.getUTCHours(), 2), n.MM = ze((f = e == null ? void 0 : e.date) == null ? void 0 : f.getUTCMinutes(), 2), n.ss = ze((g = e == null ? void 0 : e.date) == null ? void 0 : g.getUTCSeconds(), 2), n.ms = ze((m = e == null ? void 0 : e.date) == null ? void 0 : m.getUTCMilliseconds(), 3)) : (n.yyyy = ((b = e == null ? void 0 : e.date) == null ? void 0 : b.getFullYear()) ?? "----", n.mm = ze((k = e == null ? void 0 : e.date) == null ? void 0 : k.getMonth(), 2, 1), n.dd = ze((x = e == null ? void 0 : e.date) == null ? void 0 : x.getDate(), 2), n.hh = ze((D = e == null ? void 0 : e.date) == null ? void 0 : D.getHours(), 2), n.MM = ze((M = e == null ? void 0 : e.date) == null ? void 0 : M.getMinutes(), 2), n.ss = ze((E = e == null ? void 0 : e.date) == null ? void 0 : E.getSeconds(), 2), n.ms = ze((S = e == null ? void 0 : e.date) == null ? void 0 : S.getMilliseconds(), 3));
    const L = this.settings.prettyLogTimeZone === "UTC" ? e == null ? void 0 : e.date : new Date(((C = e == null ? void 0 : e.date) == null ? void 0 : C.getTime()) - ((P = e == null ? void 0 : e.date) == null ? void 0 : P.getTimezoneOffset()) * 6e4);
    n.rawIsoStr = L == null ? void 0 : L.toISOString(), n.dateIsoStr = L == null ? void 0 : L.toISOString().replace("T", " ").replace("Z", ""), n.logLevelName = e == null ? void 0 : e.logLevelName, n.fileNameWithLine = ((A = e == null ? void 0 : e.path) == null ? void 0 : A.fileNameWithLine) ?? "", n.filePathWithLine = ((Z = e == null ? void 0 : e.path) == null ? void 0 : Z.filePathWithLine) ?? "", n.fullFilePath = ((B = e == null ? void 0 : e.path) == null ? void 0 : B.fullFilePath) ?? "";
    let i = (U = this.settings.parentNames) == null ? void 0 : U.join(this.settings.prettyErrorParentNamesSeparator);
    return i = i != null && (e == null ? void 0 : e.name) != null ? i + this.settings.prettyErrorParentNamesSeparator : void 0, n.name = (e == null ? void 0 : e.name) != null || i != null ? (i ?? "") + (e == null ? void 0 : e.name) : "", n.nameWithDelimiterPrefix = n.name.length > 0 ? this.settings.prettyErrorLoggerNameDelimiter + n.name : "", n.nameWithDelimiterSuffix = n.name.length > 0 ? n.name + this.settings.prettyErrorLoggerNameDelimiter : "", Ji(this.settings, r, n);
  }
}
class oz extends nz {
  constructor(e, r) {
    super(e, r, 5);
  }
  log(e, r, ...n) {
    return super.log(e, r, ...n);
  }
  silly(...e) {
    return super.log(0, "SILLY", ...e);
  }
  trace(...e) {
    return super.log(1, "TRACE", ...e);
  }
  debug(...e) {
    return super.log(2, "DEBUG", ...e);
  }
  info(...e) {
    return super.log(3, "INFO", ...e);
  }
  warn(...e) {
    return super.log(4, "WARN", ...e);
  }
  error(...e) {
    return super.log(5, "ERROR", ...e);
  }
  fatal(...e) {
    return super.log(6, "FATAL", ...e);
  }
  getSubLogger(e, r) {
    return super.getSubLogger(e, r);
  }
}
const iz = new oz({
  prettyErrorParentNamesSeparator: "~",
  prettyLogTemplate: "{{hh}}:{{MM}}:{{ss}}:{{ms}} {{logLevelName}}	[{{name}}]	",
  prettyLogTimeZone: "local"
});
class fo {
  constructor() {
    q(this, "_logger");
    this._logger = iz.getSubLogger({ name: this.constructor.name });
  }
}
var Lz = Object.defineProperty, az = Object.getOwnPropertyDescriptor, sz = (t, e, r, n) => {
  for (var L = n > 1 ? void 0 : n ? az(e, r) : e, i = t.length - 1, l; i >= 0; i--)
    (l = t[i]) && (L = (n ? l(e, r, L) : l(L)) || L);
  return n && L && Lz(e, r, L), L;
};
let P4 = class extends fo {
  constructor() {
    super(...arguments);
    q(this, "_cache", []);
  }
  get plugins() {
    return this._cache;
  }
  add(e) {
    e && (this._logger.debug(`add() - ${e.id}`), this._cache.push(e));
  }
  addAll(e) {
    !e || e.length === 0 || (this._logger.debug(`add() - ${e.length} plugins`), e.forEach((r) => this.add(r)));
  }
};
P4 = sz([
  Q4
], P4);
var lz = Object.defineProperty, uz = Object.getOwnPropertyDescriptor, cz = (t, e, r, n) => {
  for (var L = n > 1 ? void 0 : n ? uz(e, r) : e, i = t.length - 1, l; i >= 0; i--)
    (l = t[i]) && (L = (n ? l(e, r, L) : l(L)) || L);
  return n && L && lz(e, r, L), L;
};
let eL = class extends fo {
  constructor() {
    super(...arguments);
    q(this, "_pluginCache", Er.get(P4));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
  async sendInit() {
    var r;
    const e = {
      forms: [],
      responses: []
    };
    if (this._pluginCache.plugins.length === 0)
      return e;
    if (this._pluginCache.plugins.length > 0) {
      this._logger.debug("sendInit()");
      for (const n of this._pluginCache.plugins)
        await ((r = n.init) == null ? void 0 : r.call(n, e));
    }
    return e;
  }
  async sendSetup(e) {
    var r;
    if (this._pluginCache.plugins.length !== 0) {
      this._logger.debug(`sendSetup() - ${e.key}`);
      for (const n of this._pluginCache.plugins)
        n.setup && (await ((r = n.setup) == null ? void 0 : r.call(n, e)), this._logger.debug(`${n.id}:init() - finished`));
    }
  }
  async sendSave(e) {
    if (this._pluginCache.plugins.length !== 0) {
      this._logger.debug(`sendSave() - ${e.questionnaire}`);
      for (const r of this._pluginCache.plugins)
        r.save && (await r.save(e), this._logger.debug(`${r.id}:save() - finished`));
    }
  }
};
eL = cz([
  Q4
], eL);
var hz = Object.defineProperty, dz = Object.getOwnPropertyDescriptor, fz = (t, e, r, n) => {
  for (var L = n > 1 ? void 0 : n ? dz(e, r) : e, i = t.length - 1, l; i >= 0; i--)
    (l = t[i]) && (L = (n ? l(e, r, L) : l(L)) || L);
  return n && L && hz(e, r, L), L;
};
let Z0 = class extends fo {
  constructor() {
    super(...arguments);
    q(this, "_eventDispatcher", Er.get(eL));
    q(this, "_pluginCache", Er.get(P4));
    q(this, "status", u5("waiting"));
    q(this, "config", u5(null));
    q(this, "_forms", []);
  }
  sync(e, r) {
    this._logger.debug("sync()" + (r ? " - forceInit" : "")), this.config.value = e, r && (this.status.value = "waiting"), this.status.value === "waiting" && (this.status.value = "initializing", this._init());
  }
  get forms() {
    return this._forms;
  }
  async save(e, r = !1) {
    this._logger.debug(`syncedSave() ~ ${e}`);
    const n = this._forms.find((i) => i.key === e);
    if (!n)
      return this._logger.error(`syncedSave() ~ no form found for form ${e}`), !1;
    const L = wI(n);
    L.status = r ? "completed" : "in-progress", console.log(L);
    try {
      return await this._eventDispatcher.sendSave(L), !0;
    } catch {
      return !1;
    }
  }
  async _init() {
    var n, L, i;
    if (!this.config.value) {
      this._logger.error("init() ~ no config found");
      return;
    }
    this._setStatus("initializing"), this._logger.debug(
      `init() ~ { configForms: ${((n = this.config.value.forms) == null ? void 0 : n.sources.length) || 0} configPlugins: ${((L = this.config.value.plugins) == null ? void 0 : L.length) || 0} }`
    ), this._pluginCache.addAll(this.config.value.plugins || []);
    const e = await this._eventDispatcher.sendInit();
    this.config.value.forms && this.config.value.forms.sources.length > 0 && e.forms.push(...this.config.value.forms.sources), this.config.value.forms && this.config.value.forms.responses && this.config.value.forms.responses.length > 0 && e.responses.push(...this.config.value.forms.responses);
    const r = [];
    for (const l of e.forms) {
      const s = new HO(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Resolve the next time you touch this
        l,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
        (i = e.responses) == null ? void 0 : i.find((c) => c.questionnaire === l.url)
      );
      await this._eventDispatcher.sendSetup(s), r.push(s);
    }
    r.length > 0 ? (this.forms.push(...r), this._logger.debug("init() ~ return"), this._setStatus("ready")) : (this._logger.fatal("init() ~ no forms found in configuration or plugins"), this._setStatus("error"));
  }
  _setStatus(e) {
    this._logger.info(`${e.toUpperCase()}`), this.status.value = e;
  }
};
Z0 = fz([
  Q4
], Z0);
var pz = Object.defineProperty, gz = Object.getOwnPropertyDescriptor, mz = (t, e, r, n) => {
  for (var L = n > 1 ? void 0 : n ? gz(e, r) : e, i = t.length - 1, l; i >= 0; i--)
    (l = t[i]) && (L = (n ? l(e, r, L) : l(L)) || L);
  return n && L && pz(e, r, L), L;
};
let tL = class extends fo {
  constructor() {
    super(...arguments);
    q(this, "_engine", Er.get(Z0));
  }
  loadConfig(e) {
    e ? this._logger.debug("loadConfig()") : this._logger.warn("loadConfig() - no config provided"), this._engine.sync(pI(e));
  }
};
tL = mz([
  Q4
], tL);
const vz = (t, e) => {
  const r = t[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((n, L) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(L.bind(null, new Error("Unknown variable dynamic import: " + e)));
  });
};
var _7;
const rc = typeof window < "u", yz = (t) => typeof t == "string", wz = () => {
};
rc && ((_7 = window == null ? void 0 : window.navigator) != null && _7.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function nc(t) {
  return typeof t == "function" ? t() : Z5(t);
}
function bz(t) {
  return t;
}
function xz(t, e) {
  var r;
  if (typeof t == "number")
    return t + e;
  const n = ((r = t.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : r[0]) || "", L = t.slice(n.length), i = parseFloat(n) + e;
  return Number.isNaN(i) ? t : i + L;
}
function oc(t) {
  return Bw() ? (Rw(t), !0) : !1;
}
function kz(t) {
  return typeof t == "function" ? g5(t) : u5(t);
}
function Mz(t, e = !0) {
  Bi() ? J1(t) : e ? t() : CL(t);
}
function _z(t) {
  var e;
  const r = nc(t);
  return (e = r == null ? void 0 : r.$el) != null ? e : r;
}
const L3 = rc ? window : void 0;
function q25(...t) {
  let e, r, n, L;
  if (yz(t[0]) || Array.isArray(t[0]) ? ([r, n, L] = t, e = L3) : [e, r, n, L] = t, !e)
    return wz;
  Array.isArray(r) || (r = [r]), Array.isArray(n) || (n = [n]);
  const i = [], l = () => {
    i.forEach((f) => f()), i.length = 0;
  }, s = (f, g, m, b) => (f.addEventListener(g, m, b), () => f.removeEventListener(g, m, b)), c = g1(() => [_z(e), nc(L)], ([f, g]) => {
    l(), f && i.push(...r.flatMap((m) => n.map((b) => s(f, m, b, g))));
  }, { immediate: !0, flush: "post" }), h = () => {
    c(), l();
  };
  return oc(h), h;
}
function Cz(t, e = !1) {
  const r = u5(), n = () => r.value = !!t();
  return n(), Mz(n, e), r;
}
function d0(t, e = {}) {
  const { window: r = L3 } = e, n = Cz(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let L;
  const i = u5(!1), l = () => {
    L && ("removeEventListener" in L ? L.removeEventListener("change", s) : L.removeListener(s));
  }, s = () => {
    n.value && (l(), L = r.matchMedia(kz(t).value), i.value = L.matches, "addEventListener" in L ? L.addEventListener("change", s) : L.addListener(s));
  };
  return Ri(s), oc(() => l()), i;
}
var Sz = Object.defineProperty, C7 = Object.getOwnPropertySymbols, Dz = Object.prototype.hasOwnProperty, Ez = Object.prototype.propertyIsEnumerable, S7 = (t, e, r) => e in t ? Sz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Iz = (t, e) => {
  for (var r in e || (e = {}))
    Dz.call(e, r) && S7(t, r, e[r]);
  if (C7)
    for (var r of C7(e))
      Ez.call(e, r) && S7(t, r, e[r]);
  return t;
};
function Tz(t, e = {}) {
  function r(s, c) {
    let h = t[s];
    return c != null && (h = xz(h, c)), typeof h == "number" && (h = `${h}px`), h;
  }
  const { window: n = L3 } = e;
  function L(s) {
    return n ? n.matchMedia(s).matches : !1;
  }
  const i = (s) => d0(`(min-width: ${r(s)})`, e), l = Object.keys(t).reduce((s, c) => (Object.defineProperty(s, c, {
    get: () => i(c),
    enumerable: !0,
    configurable: !0
  }), s), {});
  return Iz({
    greater(s) {
      return d0(`(min-width: ${r(s, 0.1)})`, e);
    },
    greaterOrEqual: i,
    smaller(s) {
      return d0(`(max-width: ${r(s, -0.1)})`, e);
    },
    smallerOrEqual(s) {
      return d0(`(max-width: ${r(s)})`, e);
    },
    between(s, c) {
      return d0(`(min-width: ${r(s)}) and (max-width: ${r(c, -0.1)})`, e);
    },
    isGreater(s) {
      return L(`(min-width: ${r(s, 0.1)})`);
    },
    isGreaterOrEqual(s) {
      return L(`(min-width: ${r(s)})`);
    },
    isSmaller(s) {
      return L(`(max-width: ${r(s, -0.1)})`);
    },
    isSmallerOrEqual(s) {
      return L(`(max-width: ${r(s)})`);
    },
    isInBetween(s, c) {
      return L(`(min-width: ${r(s)}) and (max-width: ${r(c, -0.1)})`);
    }
  }, l);
}
const D7 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, E7 = "__vueuse_ssr_handlers__";
D7[E7] = D7[E7] || {};
var I7;
(function(t) {
  t.UP = "UP", t.RIGHT = "RIGHT", t.DOWN = "DOWN", t.LEFT = "LEFT", t.NONE = "NONE";
})(I7 || (I7 = {}));
var Oz = Object.defineProperty, T7 = Object.getOwnPropertySymbols, zz = Object.prototype.hasOwnProperty, Pz = Object.prototype.propertyIsEnumerable, O7 = (t, e, r) => e in t ? Oz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Az = (t, e) => {
  for (var r in e || (e = {}))
    zz.call(e, r) && O7(t, r, e[r]);
  if (T7)
    for (var r of T7(e))
      Pz.call(e, r) && O7(t, r, e[r]);
  return t;
};
const $z = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Az({
  linear: bz
}, $z);
const z7 = "landscape", ic = "portrait";
function Zn(t, e, r) {
  const n = g5({
    get: () => t.value,
    set: (i) => {
      e("update:modelValue", i);
    }
  }), L = g5({
    get: () => r,
    set(i) {
      e("onAdditionalUpdateFormField", i);
    }
  });
  return {
    localValue: n,
    additionalLocalValue: L
  };
}
function Zz() {
  for (var t = 0, e, r, n = ""; t < arguments.length; )
    (e = arguments[t++]) && (r = Lc(e)) && (n && (n += " "), n += r);
  return n;
}
function Lc(t) {
  if (typeof t == "string")
    return t;
  for (var e, r = "", n = 0; n < t.length; n++)
    t[n] && (e = Lc(t[n])) && (r && (r += " "), r += e);
  return r;
}
var a3 = "-";
function Nz(t) {
  var e = Rz(t), r = t.conflictingClassGroups, n = t.conflictingClassGroupModifiers, L = n === void 0 ? {} : n;
  function i(s) {
    var c = s.split(a3);
    return c[0] === "" && c.length !== 1 && c.shift(), ac(c, e) || Bz(s);
  }
  function l(s, c) {
    var h = r[s] || [];
    return c && L[s] ? [].concat(h, L[s]) : h;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: l
  };
}
function ac(t, e) {
  var r;
  if (t.length === 0)
    return e.classGroupId;
  var n = t[0], L = e.nextPart.get(n), i = L ? ac(t.slice(1), L) : void 0;
  if (i)
    return i;
  if (e.validators.length !== 0) {
    var l = t.join(a3);
    return (r = e.validators.find(function(s) {
      var c = s.validator;
      return c(l);
    })) == null ? void 0 : r.classGroupId;
  }
}
var P7 = /^\[(.+)\]$/;
function Bz(t) {
  if (P7.test(t)) {
    var e = P7.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function Rz(t) {
  var e = t.theme, r = t.prefix, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, L = Fz(Object.entries(t.classGroups), r);
  return L.forEach(function(i) {
    var l = i[0], s = i[1];
    rL(s, n, l, e);
  }), n;
}
function rL(t, e, r, n) {
  t.forEach(function(L) {
    if (typeof L == "string") {
      var i = L === "" ? e : A7(e, L);
      i.classGroupId = r;
      return;
    }
    if (typeof L == "function") {
      if (Hz(L)) {
        rL(L(n), e, r, n);
        return;
      }
      e.validators.push({
        validator: L,
        classGroupId: r
      });
      return;
    }
    Object.entries(L).forEach(function(l) {
      var s = l[0], c = l[1];
      rL(c, A7(e, s), r, n);
    });
  });
}
function A7(t, e) {
  var r = t;
  return e.split(a3).forEach(function(n) {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}
function Hz(t) {
  return t.isThemeGetter;
}
function Fz(t, e) {
  return e ? t.map(function(r) {
    var n = r[0], L = r[1], i = L.map(function(l) {
      return typeof l == "string" ? e + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(function(s) {
        var c = s[0], h = s[1];
        return [e + c, h];
      })) : l;
    });
    return [n, i];
  }) : t;
}
function jz(t) {
  if (t < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function L(i, l) {
    r.set(i, l), e++, e > t && (e = 0, n = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var l = r.get(i);
      if (l !== void 0)
        return l;
      if ((l = n.get(i)) !== void 0)
        return L(i, l), l;
    },
    set: function(i, l) {
      r.has(i) ? r.set(i, l) : L(i, l);
    }
  };
}
var sc = "!";
function Uz(t) {
  var e = t.separator || ":", r = e.length === 1, n = e[0], L = e.length;
  return function(i) {
    for (var l = [], s = 0, c = 0, h, f = 0; f < i.length; f++) {
      var g = i[f];
      if (s === 0) {
        if (g === n && (r || i.slice(f, f + L) === e)) {
          l.push(i.slice(c, f)), c = f + L;
          continue;
        }
        if (g === "/") {
          h = f;
          continue;
        }
      }
      g === "[" ? s++ : g === "]" && s--;
    }
    var m = l.length === 0 ? i : i.substring(c), b = m.startsWith(sc), k = b ? m.substring(1) : m, x = h && h > c ? h - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: b,
      baseClassName: k,
      maybePostfixModifierPosition: x
    };
  };
}
function Yz(t) {
  if (t.length <= 1)
    return t;
  var e = [], r = [];
  return t.forEach(function(n) {
    var L = n[0] === "[";
    L ? (e.push.apply(e, r.sort().concat([n])), r = []) : r.push(n);
  }), e.push.apply(e, r.sort()), e;
}
function Vz(t) {
  return {
    cache: jz(t.cacheSize),
    splitModifiers: Uz(t),
    ...Nz(t)
  };
}
var Wz = /\s+/;
function Gz(t, e) {
  var r = e.splitModifiers, n = e.getClassGroupId, L = e.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return t.trim().split(Wz).map(function(l) {
    var s = r(l), c = s.modifiers, h = s.hasImportantModifier, f = s.baseClassName, g = s.maybePostfixModifierPosition, m = n(g ? f.substring(0, g) : f), b = !!g;
    if (!m) {
      if (!g)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (m = n(f), !m)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      b = !1;
    }
    var k = Yz(c).join(":"), x = h ? k + sc : k;
    return {
      isTailwindClass: !0,
      modifierId: x,
      classGroupId: m,
      originalClassName: l,
      hasPostfixModifier: b
    };
  }).reverse().filter(function(l) {
    if (!l.isTailwindClass)
      return !0;
    var s = l.modifierId, c = l.classGroupId, h = l.hasPostfixModifier, f = s + c;
    return i.has(f) ? !1 : (i.add(f), L(c, h).forEach(function(g) {
      return i.add(s + g);
    }), !0);
  }).reverse().map(function(l) {
    return l.originalClassName;
  }).join(" ");
}
function qz() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n, L, i, l = s;
  function s(h) {
    var f = e[0], g = e.slice(1), m = g.reduce(function(b, k) {
      return k(b);
    }, f());
    return n = Vz(m), L = n.cache.get, i = n.cache.set, l = c, c(h);
  }
  function c(h) {
    var f = L(h);
    if (f)
      return f;
    var g = Gz(h, n);
    return i(h, g), g;
  }
  return function() {
    return l(Zz.apply(null, arguments));
  };
}
function l1(t) {
  var e = function(r) {
    return r[t] || [];
  };
  return e.isThemeGetter = !0, e;
}
var lc = /^\[(?:([a-z-]+):)?(.+)\]$/i, Kz = /^\d+\/\d+$/, Jz = /* @__PURE__ */ new Set(["px", "full", "screen"]), Qz = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Xz = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))/, eP = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function qe(t) {
  return _r(t) || Jz.has(t) || Kz.test(t) || er(t);
}
function er(t) {
  return Br(t, "length", LP);
}
function tP(t) {
  return Br(t, "size", uc);
}
function rP(t) {
  return Br(t, "position", uc);
}
function nP(t) {
  return Br(t, "url", aP);
}
function e4(t) {
  return Br(t, "number", _r);
}
function _r(t) {
  return !Number.isNaN(Number(t));
}
function oP(t) {
  return t.endsWith("%") && _r(t.slice(0, -1));
}
function f0(t) {
  return $7(t) || Br(t, "number", $7);
}
function b1(t) {
  return lc.test(t);
}
function p0() {
  return !0;
}
function qt(t) {
  return Qz.test(t);
}
function iP(t) {
  return Br(t, "", sP);
}
function Br(t, e, r) {
  var n = lc.exec(t);
  return n ? n[1] ? n[1] === e : r(n[2]) : !1;
}
function LP(t) {
  return Xz.test(t);
}
function uc() {
  return !1;
}
function aP(t) {
  return t.startsWith("url(");
}
function $7(t) {
  return Number.isInteger(Number(t));
}
function sP(t) {
  return eP.test(t);
}
function lP() {
  var t = l1("colors"), e = l1("spacing"), r = l1("blur"), n = l1("brightness"), L = l1("borderColor"), i = l1("borderRadius"), l = l1("borderSpacing"), s = l1("borderWidth"), c = l1("contrast"), h = l1("grayscale"), f = l1("hueRotate"), g = l1("invert"), m = l1("gap"), b = l1("gradientColorStops"), k = l1("gradientColorStopPositions"), x = l1("inset"), D = l1("margin"), M = l1("opacity"), E = l1("padding"), S = l1("saturate"), C = l1("scale"), P = l1("sepia"), A = l1("skew"), Z = l1("space"), B = l1("translate"), U = function() {
    return ["auto", "contain", "none"];
  }, K = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, r5 = function() {
    return ["auto", e];
  }, a5 = function() {
    return ["", qe];
  }, V = function() {
    return ["auto", _r, b1];
  }, l5 = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, d5 = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, m5 = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, M5 = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, _5 = function() {
    return ["", "0", b1];
  }, $5 = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, E5 = function() {
    return [_r, e4];
  }, f5 = function() {
    return [_r, b1];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [p0],
      spacing: [qe],
      blur: ["none", "", qt, er],
      brightness: E5(),
      borderColor: [t],
      borderRadius: ["none", "", "full", qt, er],
      borderSpacing: [e],
      borderWidth: a5(),
      contrast: E5(),
      grayscale: _5(),
      hueRotate: f5(),
      invert: _5(),
      gap: [e],
      gradientColorStops: [t],
      gradientColorStopPositions: [oP, er],
      inset: r5(),
      margin: r5(),
      opacity: E5(),
      padding: [e],
      saturate: E5(),
      scale: E5(),
      sepia: _5(),
      skew: f5(),
      space: [e],
      translate: [e]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", b1]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [qt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $5()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $5()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(l5(), [b1])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: K()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": K()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": K()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: U()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": U()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": U()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [x]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [x]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [x]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [x]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [x]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [x]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [x]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [x]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [x]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", f0]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [e]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", b1]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: _5()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: _5()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", f0]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [p0]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [f0]
        }, b1]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": V()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": V()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [p0]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [f0]
        }, b1]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": V()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": V()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", b1]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", b1]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(M5())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(M5(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(M5(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [E]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [E]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [E]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [E]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [E]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [E]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [E]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [E]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [E]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [D]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [D]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [D]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [D]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [D]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [D]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [D]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [D]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [D]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Z]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Z]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", qe]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [qt]
        }, qt, er]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", qe]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", qt, er]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", e4]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [p0]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", er]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", _r, e4]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", qe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", b1]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", b1]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [M]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [M]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(d5(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", qe]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", qe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [e]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", er]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", b1]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [M]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(l5(), [rP])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", tP]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, nP]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [k]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [k]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [k]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [b]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [M]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(d5(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [M]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: d5()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [L]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [L]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [L]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [L]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [L]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [L]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [L]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [L]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(d5())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [qe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [qe]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: a5()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [M]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [qe]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", qt, iP]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [p0]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [M]
      }],
      /**
       * Mix Beldn Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": m5()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": m5()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", qt, b1]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [h]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [g]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [P]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [h]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [g]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [M]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [P]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", b1]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: f5()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", b1]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: f5()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", b1]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [f0, b1]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [B]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [B]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", b1]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", b1]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [e]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [e]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [e]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [e]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [e]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [e]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [e]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [e]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [e]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [e]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [e]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [e]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [e]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [e]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [e]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [e]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [e]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [e]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", b1]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [qe, e4]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Qe = /* @__PURE__ */ qz(lP);
const ge = () => ({ toString: (t) => {
  if (typeof t == "string")
    return t;
  let e = "";
  return t && Object.keys(t).forEach((r) => {
    t[r] && (e += r + " ");
  }), e;
} }), uP = { class: "bg-bl-panel-color dark:bg-bl-dk-panel-color border-bl-border-color dark:border-bl-dk-border-color border-[1px] pt-3 pb-3 pr-6 pl-6 rounded-md" }, cP = {
  key: 0,
  class: "border-black border-solid border-b-2 mt-3 mb-3"
}, hP = /* @__PURE__ */ J5({
  __name: "MfxDropdownMenu",
  props: {
    containerClasses: {},
    itemListClasses: {}
  },
  setup(t) {
    const e = t, r = EL(), n = g5(() => !!r.item2), L = g5(() => {
      const g = "dropdownContainer cursor-pointer bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color rounded-full pt-2 pb-2 pr-6 pl-6 text-center";
      return e.containerClasses ? Qe(
        g,
        ge().toString(e.containerClasses)
      ) : g;
    }), i = g5(() => {
      const g = "dropdownItemList noShow";
      return e.itemListClasses ? Qe(g, ge().toString(e.itemListClasses)) : g;
    }), l = u5(null), s = u5(null), c = u5(null), h = () => {
      c.value.classList.toggle("show"), c.value.classList.toggle("noShow"), s.value.classList.toggle("show"), s.value.classList.toggle("noShow");
    }, f = () => {
      const { top: g, height: m, left: b } = (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        l.value.getBoundingClientRect()
      );
      c.value.style.top = `${window.scrollY + g + m}px`, c.value.style.left = `${b}px`;
    };
    return J1(() => {
      window.addEventListener("resize", f), f();
    }), SL(() => {
      window.removeEventListener("resize", f);
    }), (g, m) => (G(), J(Be, null, [
      w("div", {
        ref_key: "refDropdownContainer",
        ref: l,
        class: N5(L.value),
        onClick: h
      }, [
        d1(g.$slots, "title", {}, void 0, !0)
      ], 2),
      w("div", {
        ref_key: "refBlocker",
        ref: s,
        class: "blocker noShow",
        onClick: h
      }, null, 512),
      w("div", {
        ref_key: "refDropdownItemList",
        ref: c,
        class: N5(i.value)
      }, [
        w("div", uP, [
          d1(g.$slots, "default", {}, void 0, !0),
          n.value ? (G(), J("div", cP)) : _1("", !0),
          d1(g.$slots, "item2", {}, void 0, !0),
          d1(g.$slots, "item3", {}, void 0, !0),
          d1(g.$slots, "item4", {}, void 0, !0)
        ])
      ], 2)
    ], 64));
  }
}), U5 = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [n, L] of e)
    r[n] = L;
  return r;
}, K25 = /* @__PURE__ */ U5(hP, [["__scopeId", "data-v-ea3627ff"]]), dP = J5({
  name: "IconBase",
  props: {
    iconName: {
      type: String,
      default: "box"
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    },
    viewBox: {
      type: String,
      default: "0 0 15 15"
    },
    preserveAspectRatio: {
      type: String,
      default: "xMidYMid meet"
    }
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  methods: {
    clickHandler() {
      this.$emit("click");
    }
  }
}), fP = ["width", "height", "viewBox", "aria-labelledby", "preserveAspectRatio"], pP = ["id"], gP = ["fill"];
function mP(t, e, r, n, L, i) {
  return G(), J("svg", {
    class: "cursor-pointer",
    xmlns: "http://www.w3.org/2000/svg",
    width: t.width,
    height: t.height,
    viewBox: t.viewBox,
    "aria-labelledby": t.iconName,
    preserveAspectRatio: t.preserveAspectRatio,
    role: "presentation",
    onClick: e[0] || (e[0] = (...l) => t.clickHandler && t.clickHandler(...l))
  }, [
    w("title", {
      id: t.iconName,
      lang: "en"
    }, y5(t.iconName) + " icon", 9, pP),
    w("g", { fill: t.iconColor }, [
      d1(t.$slots, "default", {}, void 0, !0)
    ], 8, gP)
  ], 8, fP);
}
const cc = /* @__PURE__ */ U5(dP, [["render", mP], ["__scopeId", "data-v-491991b3"]]), vP = {}, yP = { d: "M15.4,7.5h-2a5.4,5.4,0,0,0-4.9-5V.5A.5.5,0,0,0,8,0a.5.5,0,0,0-.5.5v2a5.4,5.4,0,0,0-5,5H.5A.5.5,0,0,0,0,8a.5.5,0,0,0,.5.5h2a5.4,5.4,0,0,0,5,4.9v2a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-2a5.4,5.4,0,0,0,4.9-4.9h2a.5.5,0,0,0,.5-.5A.5.5,0,0,0,15.4,7.5Zm-3,0H8.5v-4A4.5,4.5,0,0,1,12.4,7.5Zm-4.9-4v4h-4A4.5,4.5,0,0,1,7.5,3.5Zm-4,5h4v3.9A4.5,4.5,0,0,1,3.5,8.5Zm5,3.9V8.5h3.9A4.5,4.5,0,0,1,8.5,12.4Z" };
function wP(t, e) {
  return G(), J("path", yP);
}
const bP = /* @__PURE__ */ U5(vP, [["render", wP]]), xP = (t) => (V0("data-v-24224c0c"), t = t(), W0(), t), kP = { class: "relative flex justify-center mt-0.5" }, MP = ["disabled", "name", "value", "checked"], _P = /* @__PURE__ */ xP(() => /* @__PURE__ */ w("svg", {
  viewBox: "0 0 16 16",
  class: "fill-black dark:fill-bl-dk-panel-color absolute hidden w-4 h-4",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ w("circle", {
    cx: "8",
    cy: "8",
    r: "4"
  })
], -1)), CP = { class: "relative flex justify-center mt-0.5" }, SP = ["disabled", "name", "value", "checked"], DP = {
  name: "MfxRadioButton"
}, EP = /* @__PURE__ */ J5({
  ...DP,
  props: {
    name: { default: "radio" },
    text: { default: "radio" },
    value: { default: "radio" },
    modelValue: { default: "" },
    type: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    horizontal: { type: Boolean, default: !1 },
    selected: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, { modelValue: n } = ht(r), { localValue: L } = Zn(n, e), i = g5(
      () => L.value && L.value === r.value
    );
    return (l, s) => (G(), J("label", {
      class: N5(["items-center text-sm leading-5 space-x-2 cursor-pointer", l.horizontal ? "inline-flex mr-6" : "flex"])
    }, [
      l.type === "default" ? (G(), J(Be, { key: 0 }, [
        w("div", kP, [
          w("input", {
            type: "radio",
            class: "bg-bl-button-background-radio-color dark:bg-bl-dk-button-background-radio-color border-transparent rounded-full text-bl-button-background-radio-color dark:text-bl-dk-button-background-radio-color focus:ring-0 focus:ring-transparent",
            disabled: l.disabled,
            name: l.name,
            value: l.value,
            checked: i.value || !1,
            onChange: s[0] || (s[0] = (c) => e("update:modelValue", c.target.value))
          }, null, 40, MP),
          _P
        ]),
        w("span", {
          class: N5([
            i.value ? "selection-shadow" : "font-medium",
            l.text === "" ? "hidden" : ""
          ])
        }, y5(l.text), 3)
      ], 64)) : (G(), J(Be, { key: 1 }, [
        w("div", CP, [
          w("input", {
            type: "radio",
            class: "toggle-input bg-gray-light border-transparent rounded-full text-gray-light focus:ring-0 focus:ring-transparent",
            disabled: l.disabled,
            name: l.name,
            value: l.value,
            checked: i.value || !1,
            onChange: s[1] || (s[1] = (c) => e("update:modelValue", c.target.value))
          }, null, 40, SP),
          s5(cc, {
            class: "toggle-icon",
            "view-box": "0 0 16 16",
            height: "16px",
            width: "16px"
          }, {
            default: Je(() => [
              s5(bP)
            ]),
            _: 1
          })
        ]),
        w("span", {
          class: N5(["toggle-text text-gray-900", [
            i.value ? "selection-shadow" : "font-medium",
            l.text === "" ? "hidden" : ""
          ]])
        }, y5(l.text), 3)
      ], 64))
    ], 2));
  }
}), bi = /* @__PURE__ */ U5(EP, [["__scopeId", "data-v-24224c0c"]]), IP = {
  name: "MfxPanel"
}, J25 = /* @__PURE__ */ J5({
  ...IP,
  props: {
    isActive: { type: Boolean, default: !0 },
    noRightBottomBorder: { type: Boolean, default: !1 },
    noRightTopBorder: { type: Boolean, default: !1 },
    classes: { default: void 0 }
  },
  setup(t) {
    const e = t, r = g5(() => {
      const n = {
        "bg-bl-panel-color": !0,
        "dark:bg-bl-dk-panel-color": !0,
        "rounded-panel": !0,
        "shadow-md": !0,
        "p-5": !0,
        "rounded-br-none": e.noRightBottomBorder,
        "rounded-tr-none": e.noRightTopBorder
      };
      let L = ge().toString(n);
      return e.classes && (L = Qe(
        L,
        ge().toString(e.classes)
      )), L;
    });
    return (n, L) => (G(), J("div", {
      class: N5(r.value)
    }, [
      d1(n.$slots, "default")
    ], 2));
  }
}), TP = (t) => (V0("data-v-688830a3"), t = t(), W0(), t), OP = ["data-min", "data-max", "data-step"], zP = /* @__PURE__ */ TP(() => /* @__PURE__ */ w("span", { class: "drag-image" }, "x", -1)), PP = { class: "flex items-center" }, AP = ["onClick"], $P = ["name", "value"], ZP = {
  name: "MfxSlider"
}, NP = /* @__PURE__ */ J5({
  ...ZP,
  props: {
    modelValue: { default: "" },
    name: { default: "" },
    min: { default: 0 },
    max: { default: 1 },
    step: { default: 1 },
    theme: { default: "desert" },
    snap: { type: Boolean, default: !0 },
    values: { default: () => [] },
    checkedValue: { default: 0 },
    notApplicable: { default: () => ({ enabled: !0, label: "-" }) },
    noLabel: { type: Boolean, default: !1 },
    sliderType: { default: "numbers" },
    vertical: { type: Boolean, default: !1 },
    gradientData: { default: () => ({}) }
  },
  emits: [
    "update:modelValue",
    "update:colorModel",
    "update:trackPosition"
  ],
  setup(t, { expose: e, emit: r }) {
    const n = t, {
      modelValue: L,
      notApplicable: i,
      min: l,
      max: s,
      step: c,
      theme: h,
      snap: f,
      values: g,
      checkedValue: m,
      sliderType: b,
      vertical: k,
      gradientData: x
    } = ht(n), { localValue: D } = Zn(L, r), M = u5(null), E = u5([]), S = u5(), C = u5(), P = u5(), A = u5(""), Z = u5(0), B = u5({
      // Refer to stylesheet for the gradient configuration minus alpha channel. Minimum of 2 colors.
      // noTheme doesn't use 161, 161, 161 as defined in stylesheet to force the original thumb color.
      noTheme: [
        {
          from: 0,
          color: [112, 112, 112]
        },
        {
          from: 100,
          color: [112, 112, 112]
        }
      ],
      desert: [
        {
          from: 0,
          color: [112, 112, 112]
        },
        {
          from: 5,
          color: [189, 221, 9]
        },
        {
          from: 40,
          color: [255, 231, 22]
        },
        {
          from: 60,
          color: [250, 162, 27]
        },
        {
          from: 90,
          color: [249, 25, 25]
        },
        {
          from: 100,
          color: [124, 8, 8]
        }
      ],
      skinColor: [
        { from: 0, color: [241, 206, 182] },
        { from: 50, color: [167, 125, 91] },
        { from: 100, color: [95, 43, 6] }
      ]
    }), U = u5(null), K = u5(), r5 = u5({}), a5 = u5(), V = () => {
      const { width: W, height: n5 } = S.value.getBoundingClientRect();
      if (!W || !n5)
        return;
      const e5 = document.createElement("canvas").getContext("2d");
      e5.canvas.width = W, e5.canvas.height = n5;
      const o5 = e5.createLinearGradient(0, 0, W, n5);
      B.value[h.value].forEach((w5) => {
        o5.addColorStop(
          w5.from / 100,
          `rgb(${w5.color[0]}, ${w5.color[1]}, ${w5.color[2]})`
        );
      }), e5.fillStyle = o5, e5.fillRect(0, 0, W, n5), C.value = e5.getImageData(0, 0, W, n5).data, P.value = W;
    }, l5 = (W) => {
      const { offsetX: n5 } = W;
      if (n5 > 0) {
        const e5 = d5(
          P.value,
          n5,
          C.value
        );
        e5.red !== void 0 && (A.value = `#${[e5.red, e5.green, e5.blue].map((o5) => o5.toString(16).padStart(2, "0")).join("")}`, r("update:colorModel", A.value), r("update:trackPosition", Z.value));
        return;
      }
      A.value = `#${[112, 112, 112].map((e5) => e5.toString(16).padStart(2, "0")).join("")}`, r("update:colorModel", A.value), r("update:trackPosition", Z.value);
    }, d5 = (W, n5, e5) => {
      const o5 = W * n5 * 4;
      return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        red: e5[o5],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        green: e5[o5 + 1],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        blue: e5[o5 + 2],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        alpha: e5[o5 + 3]
      };
    }, m5 = (W) => {
      t1(W, !0);
    }, M5 = (W) => {
      a1(W, !1);
    }, _5 = (W) => {
      L1(W, !0);
    }, $5 = (W) => {
      W && (W.addEventListener("touchstart", m5, { passive: !0 }), W.addEventListener("touchend", M5, { passive: !0 }), W.addEventListener("touchmove", _5, { passive: !0 }));
    }, E5 = (W) => {
      W && (W.removeEventListener("touchstart", m5), W.removeEventListener("touchend", M5), W.removeEventListener("touchmove", _5));
    }, f5 = () => {
      const W = [];
      if (i.value.enabled && W.push(i.value.label), b.value === "color")
        W.push(...g.value);
      else
        for (let n5 = l.value; n5 <= s.value && c.value !== 0; n5 += c.value)
          W.push(n5);
      return W;
    }, e1 = () => {
      var W, n5;
      const e5 = {}, o5 = ((n5 = (W = K.value) == null ? void 0 : W.querySelector(".label")) == null ? void 0 : n5.children) ?? null;
      if (!o5)
        return null;
      for (let w5 = 0; w5 < o5.length; w5++) {
        const P5 = o5[w5].getBoundingClientRect();
        e5[E.value[w5]] = {
          left: P5.left + P5.width / 2,
          top: P5.top + P5.height / 2
        };
      }
      return e5;
    }, C1 = (W) => {
      const n5 = e1(), e5 = [];
      for (const w5 in n5) {
        k.value ? n5[w5] = { ...n5[w5], top: W - n5[w5].top } : n5[w5] = { ...n5[w5], left: W - n5[w5].left };
        const P5 = {
          index: w5,
          value: Math.abs(k.value ? n5[w5].top : n5[w5].left)
        };
        e5.push(P5);
      }
      e5.sort((w5, P5) => w5.value - P5.value);
      const o5 = {
        value: 0,
        positionOffset: 0
      };
      return e5.length > 0 && (o5.value = e5[0].index, o5.positionOffset = (k.value ? n5 && n5[o5.value].top : n5 && n5[o5.value].left) || 0), o5;
    }, I5 = (W, n5) => {
      const e5 = h.value in B.value ? B.value[h.value] : B.value.noTheme, o5 = {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
        first: [],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
        second: []
      };
      W = W < 0 ? 0 : W;
      for (let S1 = 1; S1 < e5.length; S1++)
        if (W >= e5[S1 - 1].from && W < e5[S1].from) {
          o5.first = e5[S1 - 1], o5.second = e5[S1];
          break;
        }
      const w5 = n5 * (o5.first.from / 100), P5 = n5 * (o5.second.from / 100) - w5, r1 = (((n5 * (W / 100) - w5) / P5 * 2 - 1) / 1 + 1) / 2, j1 = 1 - r1;
      return [
        Math.round(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          (o5.second.color && o5.second.color[0]) * r1 + // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          (o5.first.color && o5.first.color[0]) * j1
        ),
        Math.round(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          (o5.second.color && o5.second.color[1]) * r1 + // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          (o5.first.color && o5.first.color[1]) * j1
        ),
        Math.round(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          (o5.second.color && o5.second.color[2]) * r1 + // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          (o5.first.color && o5.first.color[2]) * j1
        )
      ];
    }, R5 = (W) => {
      typeof window.InstallTrigger < "u" && L1(W, !0);
    }, L1 = (W, n5) => {
      var e5;
      if (navigator.userAgent.search("Firefox") !== -1 && W.type === "drag")
        return;
      const o5 = (n1) => window.TouchEvent && n1 instanceof TouchEvent;
      if (!o5(W) && W.screenX === 0)
        return;
      const w5 = (e5 = K.value) == null ? void 0 : e5.querySelector(".track"), P5 = w5 == null ? void 0 : w5.getBoundingClientRect(), r1 = getComputedStyle(w5), j1 = parseInt(
        r1.getPropertyValue("--thumb-dimension")
      ), S1 = parseInt(
        r1.getPropertyValue("--thumb-border-width")
      ), O1 = parseInt(
        r1.getPropertyValue("--thumb-outer-ring")
      ), x1 = f.value || "isJumpByValue" in W, U1 = 2, z1 = (j1 - S1 + O1 * 2) / U1, z = o5(W) ? W.changedTouches[0].pageX : W.pageX, N = o5(W) ? W.changedTouches[0].clientY : W.clientY;
      let j = 0;
      if (x1) {
        const n1 = C1(k.value ? N : z);
        j = k.value ? N - P5.top : z - (Number(n1.positionOffset) || 0) - P5.left, k.value && (N - P5.top < 0 && (j = 0), N - P5.top > P5.height && (j = P5.height + 32)), M.value !== null && Object.keys(r5.value).filter((b5) => b5.startsWith("selected-label-") && // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- Resolve the next time you touch this
        b5 === `selected-label-${M.value}` && r5.value[b5].classList.contains("font-bold")).forEach(
          (b5) => r5.value[b5].classList.remove("font-bold")
        ), M.value = n1.value, r5.value[`selected-label-${M.value}`].classList.add("font-bold");
      } else
        j = k.value ? N - P5.top : z - P5.left, (j - z1 / U1 <= 0 || j + z1 >= P5.width) && (j -= Number(
          C1(k.value ? N : z).positionOffset
        ) - z1 / U1);
      const Q = I5(
        // newPosition in drag event aren't always specific values so adjust its value
        (n5 ? j - z1 / U1 : j) / P5.width * 100,
        P5.width
      ), i5 = `rgba(${Q[0]}, ${Q[1]}, ${Q[2]}, 1)`;
      w5.style.setProperty(
        "--thumb-position",
        `${Math.round(j - z1)}px`
      ), k.value ? (Z.value = j, l5(W), w5.style.setProperty("--thumb-border-color", A.value), U.value = i5) : (w5.style.setProperty("--thumb-border-color", i5), U.value = i5);
    }, f1 = (W) => {
      var n5, e5, o5;
      const w5 = e1();
      L1({
        target: (n5 = K.value) == null ? void 0 : n5.querySelector(".track"),
        pageX: w5 && ((e5 = w5[W]) == null ? void 0 : e5.left) || 0,
        clientY: w5 && ((o5 = w5[W]) == null ? void 0 : o5.top) || 0,
        isJumpByValue: !0
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
      });
    }, t1 = (W, n5) => {
      var e5, o5;
      const w5 = (P5) => P5 instanceof DragEvent;
      if ((e5 = K.value) == null || e5.classList.toggle("slider-dragging", n5), !!w5(W) && W.dataTransfer) {
        const P5 = (o5 = K.value) == null ? void 0 : o5.querySelector(".drag-image");
        P5 && W.dataTransfer.setDragImage(P5, 0, 0);
      }
    }, a1 = (W, n5) => {
      var e5;
      (e5 = K.value) == null || e5.classList.toggle("slider-dragging", n5), L1(W, !0);
    }, Ue = () => {
      var W;
      const n5 = (W = K.value) == null ? void 0 : W.querySelector(".track");
      let e5 = "linear-gradient( 90deg";
      B.value[h.value].forEach((o5) => {
        e5 += `, rgba(${o5.color[0]}, ${o5.color[1]}, ${o5.color[2]}, 1) ${o5.from}%`;
      }), e5 += " )", n5 && n5.style.setProperty("--linear-gradient-background", e5);
    };
    return J1(() => {
      Object.keys(x.value).length && (B.value = x.value), g.value && g.value.length && b.value !== "color" ? E.value = g.value : E.value = f5(), Ue(), CL(() => {
        (D.value || D.value !== null && D.value !== "") && f1(D.value), $5(a5.value), !D.value && m.value && f1(m.value);
      }), setTimeout(() => {
        V();
      }, 1e3);
    }), Dn(() => {
      E5(a5.value);
    }), g1(c, () => {
      E.value = f5();
    }), g1(M, (W) => {
      D.value = W === null || isNaN(Number(W)) ? "" : W;
    }), g1(D, (W) => {
      W ?? f1(W || i.value.label || l.value);
    }), g1(g, (W) => {
      E.value = [...W];
    }), e({
      props: ht(n),
      jumpByValue: f1,
      // eslint-disable-next-line vue/no-ref-object-destructure -- Resolve the next time you touch this
      gradient: B.value,
      // eslint-disable-next-line vue/no-ref-object-destructure -- Resolve the next time you touch this
      selectedValue: M.value
    }), (W, n5) => (G(), J("div", {
      ref_key: "component",
      ref: K,
      class: N5(["slider", [Z5(h), Z5(k) ? "vertical-slider" : ""]]),
      "data-min": Z5(l),
      "data-max": Z5(s),
      "data-step": Z5(c)
    }, [
      zP,
      w("div", PP, [
        Z5(i).enabled ? (G(), J("div", {
          key: 0,
          class: "not-applicable",
          onClick: n5[0] || (n5[0] = (e5) => f1(Z5(i).label))
        }, " ... ")) : _1("", !0),
        w("div", {
          ref_key: "sliderWrapper",
          ref: a5,
          class: "slider__wrapper",
          draggable: "true",
          onClick: n5[1] || (n5[1] = (e5) => L1(e5)),
          onDragstart: n5[2] || (n5[2] = (e5) => t1(e5, !0)),
          onDragend: n5[3] || (n5[3] = (e5) => a1(e5, !1)),
          onDragover: n5[4] || (n5[4] = (e5) => R5(e5)),
          onDrag: n5[5] || (n5[5] = (e5) => L1(e5, !0))
        }, [
          w("div", {
            ref_key: "track",
            ref: S,
            class: N5(["track", {
              "has-not-applicable": Z5(i).enabled,
              "vertical-track": Z5(k)
            }])
          }, null, 2)
        ], 544)
      ]),
      w("div", {
        style: Xe({ opacity: W.noLabel ? 0 : 1 }),
        class: N5(["label", {
          "has-not-applicable": Z5(i).enabled
        }])
      }, [
        (G(!0), J(Be, null, G0(E.value, (e5) => (G(), J("span", {
          key: e5,
          ref_for: !0,
          ref: (o5) => {
            r5.value["selected-label-" + e5] = o5;
          },
          onClick: (o5) => f1(e5)
        }, y5(e5), 9, AP))), 128))
      ], 6),
      w("input", {
        type: "hidden",
        name: W.name,
        value: M.value
      }, null, 8, $P)
    ], 10, OP));
  }
}), Q25 = /* @__PURE__ */ U5(NP, [["__scopeId", "data-v-688830a3"]]), BP = (t) => (V0("data-v-b288f293"), t = t(), W0(), t), RP = { class: "relative flex input-wrapper mr-0.5" }, HP = ["type", "placeholder", "readonly", "disabled", "name", "data-min-width"], FP = /* @__PURE__ */ BP(() => /* @__PURE__ */ w("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, [
  /* @__PURE__ */ w("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, [
    /* @__PURE__ */ w("path", {
      id: "Pfad_7045",
      class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
      "data-name": "Pfad 7045",
      d: "M12.4,5.6,5.9,12.1,3,9,9.4,2.6ZM0,15l5.2-2.4-2.8-3ZM14.7,1.7,13.3.3a1.2,1.2,0,0,0-1.6,0h-.1L11,1h0L10,2.1,12.9,5l.9-.8h0l.8-.8h.1a1.2,1.2,0,0,0,0-1.6Z"
    })
  ])
], -1)), jP = [
  FP
], UP = {
  name: "MfxInputText"
}, YP = /* @__PURE__ */ J5({
  ...UP,
  props: {
    isInlineBlock: { type: Boolean, default: !1 },
    placeholder: { default: "Bitte Eintragen" },
    value: { default: "" },
    modelValue: { default: "" },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    animate: { type: Boolean, default: !1 },
    primary: { type: Boolean, default: !0 },
    minWidth: { default: "144" },
    expandable: { type: Boolean, default: !0 },
    type: { default: "text" },
    hideSvg: { type: Boolean, default: !1 },
    inputClasses: { default: "" },
    name: { default: "" },
    isValid: { type: Function, default: () => !0 }
  },
  emits: ["update:modelValue", "focus", "focus-out"],
  setup(t, { emit: e }) {
    const r = t, { modelValue: n } = ht(r), { localValue: L } = Zn(n, e), i = g5(() => ({
      "bl-input-text": !0,
      "bl-input-text--primary": r.primary,
      "bl-input-text--secondary": !r.primary,
      "bl-input-text--disabled": r.disabled
    })), l = g5(() => {
      const k = r.isInlineBlock ? "bl-input-text relative inline-block" : "bl-input-text flex relative";
      return i.value ? Qe(k, ge().toString(i.value)) : k;
    }), s = g5(() => {
      const k = "border-none text-sm font-bold focus:ring-0 leading-none w-full outline-none bg-transparent p-0";
      return r.inputClasses ? Qe(k, ge().toString(r.inputClasses)) : k;
    }), c = g5(() => ({ "pencil-animate-writing": r.animate }));
    J1(() => {
      var k;
      const x = (k = Bi()) == null ? void 0 : k.vnode.el, D = x == null ? void 0 : x.querySelector("input"), M = D.getAttribute("data-min-width"), E = parseInt(M, 10), S = M.substring(E.toString().length) || "px";
      D.style.width = `${E}${S}`, r.value && (L.value = r.value);
    });
    const h = u5(null), f = (k) => {
      var x, D, M, E;
      const S = (x = Bi()) == null ? void 0 : x.vnode.el, C = k.target, P = S == null ? void 0 : S.classList.contains("bl-input-text--primary"), A = C.getBoundingClientRect().width, Z = getComputedStyle(C), B = C.getAttribute("data-min-width") || r.minWidth, U = parseInt(B, 10);
      let K = U;
      const r5 = B.substring(U.toString().length) || "px", a5 = (h.value || (h.value = document.createElement("canvas"))).getContext("2d");
      if (!a5)
        return;
      a5.font = `${Z.fontWeight} ${Z.fontSize} ${Z.fontFamily}`;
      const V = a5.measureText(C.value).width + parseInt(Z.paddingRight, 10);
      if (V > A) {
        const l5 = Math.floor(
          ((D = C.nextElementSibling) == null ? void 0 : D.getBoundingClientRect().width) || 0
        ), d5 = Math.floor(
          ((E = (M = C.parentElement) == null ? void 0 : M.parentElement) == null ? void 0 : E.getBoundingClientRect().width) || 0
        );
        K = Math.floor(V + l5) < d5 ? V : d5 + (P ? -l5 : 0);
      } else
        V > U && (K = V);
      C.style.width = `${K}${r5}`;
    }, g = (k) => {
      r.expandable && f(k);
      let x = k.target.value;
      r.isValid(x) || (x = "", L.value = "");
    }, m = () => {
      e("focus");
    }, b = () => {
      e("focus-out");
    };
    return (k, x) => (G(), J("div", {
      class: N5(l.value)
    }, [
      w("div", RP, [
        ne(w("input", {
          "onUpdate:modelValue": x[0] || (x[0] = (D) => T0(L) ? L.value = D : null),
          class: N5(s.value),
          type: k.type,
          placeholder: k.placeholder,
          readonly: k.readonly,
          disabled: k.disabled,
          name: k.name,
          "data-min-width": k.minWidth,
          "data-testid": "inputText",
          onInput: g,
          onFocus: m,
          onBlur: b
        }, null, 42, HP), [
          [Fw, Z5(L)]
        ])
      ]),
      k.hideSvg ? _1("", !0) : (G(), J("svg", {
        key: 0,
        class: N5(c.value),
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
      }, jP, 2))
    ], 2));
  }
}), X25 = /* @__PURE__ */ U5(YP, [["__scopeId", "data-v-b288f293"]]);
var oe = "top", Re = "bottom", He = "right", ie = "left", po = "auto", t2 = [oe, Re, He, ie], pn = "start", N0 = "end", VP = "clippingParents", hc = "viewport", g0 = "popper", WP = "reference", Z7 = /* @__PURE__ */ t2.reduce(function(t, e) {
  return t.concat([e + "-" + pn, e + "-" + N0]);
}, []), dc = /* @__PURE__ */ [].concat(t2, [po]).reduce(function(t, e) {
  return t.concat([e, e + "-" + pn, e + "-" + N0]);
}, []), GP = "beforeRead", qP = "read", KP = "afterRead", JP = "beforeMain", QP = "main", XP = "afterMain", eA = "beforeWrite", tA = "write", rA = "afterWrite", nL = [GP, qP, KP, JP, QP, XP, eA, tA, rA];
function dt(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function ve(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Ir(t) {
  var e = ve(t).Element;
  return t instanceof e || t instanceof Element;
}
function me(t) {
  var e = ve(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function s3(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ve(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function nA(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var n = e.styles[r] || {}, L = e.attributes[r] || {}, i = e.elements[r];
    !me(i) || !dt(i) || (Object.assign(i.style, n), Object.keys(L).forEach(function(l) {
      var s = L[l];
      s === !1 ? i.removeAttribute(l) : i.setAttribute(l, s === !0 ? "" : s);
    }));
  });
}
function oA(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var L = e.elements[n], i = e.attributes[n] || {}, l = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : r[n]), s = l.reduce(function(c, h) {
        return c[h] = "", c;
      }, {});
      !me(L) || !dt(L) || (Object.assign(L.style, s), Object.keys(i).forEach(function(c) {
        L.removeAttribute(c);
      }));
    });
  };
}
const iA = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: nA,
  effect: oA,
  requires: ["computeStyles"]
};
function et(t) {
  return t.split("-")[0];
}
var Cr = Math.max, A4 = Math.min, gn = Math.round;
function oL() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function fc() {
  return !/^((?!chrome|android).)*safari/i.test(oL());
}
function mn(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var n = t.getBoundingClientRect(), L = 1, i = 1;
  e && me(t) && (L = t.offsetWidth > 0 && gn(n.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && gn(n.height) / t.offsetHeight || 1);
  var l = Ir(t) ? ve(t) : window, s = l.visualViewport, c = !fc() && r, h = (n.left + (c && s ? s.offsetLeft : 0)) / L, f = (n.top + (c && s ? s.offsetTop : 0)) / i, g = n.width / L, m = n.height / i;
  return {
    width: g,
    height: m,
    top: f,
    right: h + g,
    bottom: f + m,
    left: h,
    x: h,
    y: f
  };
}
function l3(t) {
  var e = mn(t), r = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: n
  };
}
function pc(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && s3(r)) {
    var n = e;
    do {
      if (n && t.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function rt(t) {
  return ve(t).getComputedStyle(t);
}
function LA(t) {
  return ["table", "td", "th"].indexOf(dt(t)) >= 0;
}
function ur(t) {
  return ((Ir(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function go(t) {
  return dt(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (s3(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ur(t)
  );
}
function N7(t) {
  return !me(t) || // https://github.com/popperjs/popper-core/issues/837
  rt(t).position === "fixed" ? null : t.offsetParent;
}
function aA(t) {
  var e = /firefox/i.test(oL()), r = /Trident/i.test(oL());
  if (r && me(t)) {
    var n = rt(t);
    if (n.position === "fixed")
      return null;
  }
  var L = go(t);
  for (s3(L) && (L = L.host); me(L) && ["html", "body"].indexOf(dt(L)) < 0; ) {
    var i = rt(L);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return L;
    L = L.parentNode;
  }
  return null;
}
function r2(t) {
  for (var e = ve(t), r = N7(t); r && LA(r) && rt(r).position === "static"; )
    r = N7(r);
  return r && (dt(r) === "html" || dt(r) === "body" && rt(r).position === "static") ? e : r || aA(t) || e;
}
function u3(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function k0(t, e, r) {
  return Cr(t, A4(e, r));
}
function sA(t, e, r) {
  var n = k0(t, e, r);
  return n > r ? r : n;
}
function gc() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mc(t) {
  return Object.assign({}, gc(), t);
}
function vc(t, e) {
  return e.reduce(function(r, n) {
    return r[n] = t, r;
  }, {});
}
var lA = function(t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, mc(typeof t != "number" ? t : vc(t, t2));
};
function uA(t) {
  var e, r = t.state, n = t.name, L = t.options, i = r.elements.arrow, l = r.modifiersData.popperOffsets, s = et(r.placement), c = u3(s), h = [ie, He].indexOf(s) >= 0, f = h ? "height" : "width";
  if (!(!i || !l)) {
    var g = lA(L.padding, r), m = l3(i), b = c === "y" ? oe : ie, k = c === "y" ? Re : He, x = r.rects.reference[f] + r.rects.reference[c] - l[c] - r.rects.popper[f], D = l[c] - r.rects.reference[c], M = r2(i), E = M ? c === "y" ? M.clientHeight || 0 : M.clientWidth || 0 : 0, S = x / 2 - D / 2, C = g[b], P = E - m[f] - g[k], A = E / 2 - m[f] / 2 + S, Z = k0(C, A, P), B = c;
    r.modifiersData[n] = (e = {}, e[B] = Z, e.centerOffset = Z - A, e);
  }
}
function cA(t) {
  var e = t.state, r = t.options, n = r.element, L = n === void 0 ? "[data-popper-arrow]" : n;
  if (L != null && !(typeof L == "string" && (L = e.elements.popper.querySelector(L), !L))) {
    if (process.env.NODE_ENV !== "production" && (me(L) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !pc(e.elements.popper, L)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = L;
  }
}
const hA = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: uA,
  effect: cA,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function vn(t) {
  return t.split("-")[1];
}
var dA = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function fA(t, e) {
  var r = t.x, n = t.y, L = e.devicePixelRatio || 1;
  return {
    x: gn(r * L) / L || 0,
    y: gn(n * L) / L || 0
  };
}
function B7(t) {
  var e, r = t.popper, n = t.popperRect, L = t.placement, i = t.variation, l = t.offsets, s = t.position, c = t.gpuAcceleration, h = t.adaptive, f = t.roundOffsets, g = t.isFixed, m = l.x, b = m === void 0 ? 0 : m, k = l.y, x = k === void 0 ? 0 : k, D = typeof f == "function" ? f({
    x: b,
    y: x
  }) : {
    x: b,
    y: x
  };
  b = D.x, x = D.y;
  var M = l.hasOwnProperty("x"), E = l.hasOwnProperty("y"), S = ie, C = oe, P = window;
  if (h) {
    var A = r2(r), Z = "clientHeight", B = "clientWidth";
    if (A === ve(r) && (A = ur(r), rt(A).position !== "static" && s === "absolute" && (Z = "scrollHeight", B = "scrollWidth")), A = A, L === oe || (L === ie || L === He) && i === N0) {
      C = Re;
      var U = g && A === P && P.visualViewport ? P.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[Z]
      );
      x -= U - n.height, x *= c ? 1 : -1;
    }
    if (L === ie || (L === oe || L === Re) && i === N0) {
      S = He;
      var K = g && A === P && P.visualViewport ? P.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[B]
      );
      b -= K - n.width, b *= c ? 1 : -1;
    }
  }
  var r5 = Object.assign({
    position: s
  }, h && dA), a5 = f === !0 ? fA({
    x: b,
    y: x
  }, ve(r)) : {
    x: b,
    y: x
  };
  if (b = a5.x, x = a5.y, c) {
    var V;
    return Object.assign({}, r5, (V = {}, V[C] = E ? "0" : "", V[S] = M ? "0" : "", V.transform = (P.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + x + "px)" : "translate3d(" + b + "px, " + x + "px, 0)", V));
  }
  return Object.assign({}, r5, (e = {}, e[C] = E ? x + "px" : "", e[S] = M ? b + "px" : "", e.transform = "", e));
}
function pA(t) {
  var e = t.state, r = t.options, n = r.gpuAcceleration, L = n === void 0 ? !0 : n, i = r.adaptive, l = i === void 0 ? !0 : i, s = r.roundOffsets, c = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var h = rt(e.elements.popper).transitionProperty || "";
    l && ["transform", "top", "right", "bottom", "left"].some(function(g) {
      return h.indexOf(g) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var f = {
    placement: et(e.placement),
    variation: vn(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: L,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, B7(Object.assign({}, f, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: l,
    roundOffsets: c
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, B7(Object.assign({}, f, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const gA = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: pA,
  data: {}
};
var t4 = {
  passive: !0
};
function mA(t) {
  var e = t.state, r = t.instance, n = t.options, L = n.scroll, i = L === void 0 ? !0 : L, l = n.resize, s = l === void 0 ? !0 : l, c = ve(e.elements.popper), h = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && h.forEach(function(f) {
    f.addEventListener("scroll", r.update, t4);
  }), s && c.addEventListener("resize", r.update, t4), function() {
    i && h.forEach(function(f) {
      f.removeEventListener("scroll", r.update, t4);
    }), s && c.removeEventListener("resize", r.update, t4);
  };
}
const vA = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: mA,
  data: {}
};
var yA = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function v4(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return yA[e];
  });
}
var wA = {
  start: "end",
  end: "start"
};
function R7(t) {
  return t.replace(/start|end/g, function(e) {
    return wA[e];
  });
}
function c3(t) {
  var e = ve(t), r = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function h3(t) {
  return mn(ur(t)).left + c3(t).scrollLeft;
}
function bA(t, e) {
  var r = ve(t), n = ur(t), L = r.visualViewport, i = n.clientWidth, l = n.clientHeight, s = 0, c = 0;
  if (L) {
    i = L.width, l = L.height;
    var h = fc();
    (h || !h && e === "fixed") && (s = L.offsetLeft, c = L.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: s + h3(t),
    y: c
  };
}
function xA(t) {
  var e, r = ur(t), n = c3(t), L = (e = t.ownerDocument) == null ? void 0 : e.body, i = Cr(r.scrollWidth, r.clientWidth, L ? L.scrollWidth : 0, L ? L.clientWidth : 0), l = Cr(r.scrollHeight, r.clientHeight, L ? L.scrollHeight : 0, L ? L.clientHeight : 0), s = -n.scrollLeft + h3(t), c = -n.scrollTop;
  return rt(L || r).direction === "rtl" && (s += Cr(r.clientWidth, L ? L.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function d3(t) {
  var e = rt(t), r = e.overflow, n = e.overflowX, L = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + L + n);
}
function yc(t) {
  return ["html", "body", "#document"].indexOf(dt(t)) >= 0 ? t.ownerDocument.body : me(t) && d3(t) ? t : yc(go(t));
}
function M0(t, e) {
  var r;
  e === void 0 && (e = []);
  var n = yc(t), L = n === ((r = t.ownerDocument) == null ? void 0 : r.body), i = ve(n), l = L ? [i].concat(i.visualViewport || [], d3(n) ? n : []) : n, s = e.concat(l);
  return L ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(M0(go(l)))
  );
}
function iL(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function kA(t, e) {
  var r = mn(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function H7(t, e, r) {
  return e === hc ? iL(bA(t, r)) : Ir(e) ? kA(e, r) : iL(xA(ur(t)));
}
function MA(t) {
  var e = M0(go(t)), r = ["absolute", "fixed"].indexOf(rt(t).position) >= 0, n = r && me(t) ? r2(t) : t;
  return Ir(n) ? e.filter(function(L) {
    return Ir(L) && pc(L, n) && dt(L) !== "body";
  }) : [];
}
function _A(t, e, r, n) {
  var L = e === "clippingParents" ? MA(t) : [].concat(e), i = [].concat(L, [r]), l = i[0], s = i.reduce(function(c, h) {
    var f = H7(t, h, n);
    return c.top = Cr(f.top, c.top), c.right = A4(f.right, c.right), c.bottom = A4(f.bottom, c.bottom), c.left = Cr(f.left, c.left), c;
  }, H7(t, l, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function wc(t) {
  var e = t.reference, r = t.element, n = t.placement, L = n ? et(n) : null, i = n ? vn(n) : null, l = e.x + e.width / 2 - r.width / 2, s = e.y + e.height / 2 - r.height / 2, c;
  switch (L) {
    case oe:
      c = {
        x: l,
        y: e.y - r.height
      };
      break;
    case Re:
      c = {
        x: l,
        y: e.y + e.height
      };
      break;
    case He:
      c = {
        x: e.x + e.width,
        y: s
      };
      break;
    case ie:
      c = {
        x: e.x - r.width,
        y: s
      };
      break;
    default:
      c = {
        x: e.x,
        y: e.y
      };
  }
  var h = L ? u3(L) : null;
  if (h != null) {
    var f = h === "y" ? "height" : "width";
    switch (i) {
      case pn:
        c[h] = c[h] - (e[f] / 2 - r[f] / 2);
        break;
      case N0:
        c[h] = c[h] + (e[f] / 2 - r[f] / 2);
        break;
    }
  }
  return c;
}
function B0(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, L = n === void 0 ? t.placement : n, i = r.strategy, l = i === void 0 ? t.strategy : i, s = r.boundary, c = s === void 0 ? VP : s, h = r.rootBoundary, f = h === void 0 ? hc : h, g = r.elementContext, m = g === void 0 ? g0 : g, b = r.altBoundary, k = b === void 0 ? !1 : b, x = r.padding, D = x === void 0 ? 0 : x, M = mc(typeof D != "number" ? D : vc(D, t2)), E = m === g0 ? WP : g0, S = t.rects.popper, C = t.elements[k ? E : m], P = _A(Ir(C) ? C : C.contextElement || ur(t.elements.popper), c, f, l), A = mn(t.elements.reference), Z = wc({
    reference: A,
    element: S,
    strategy: "absolute",
    placement: L
  }), B = iL(Object.assign({}, S, Z)), U = m === g0 ? B : A, K = {
    top: P.top - U.top + M.top,
    bottom: U.bottom - P.bottom + M.bottom,
    left: P.left - U.left + M.left,
    right: U.right - P.right + M.right
  }, r5 = t.modifiersData.offset;
  if (m === g0 && r5) {
    var a5 = r5[L];
    Object.keys(K).forEach(function(V) {
      var l5 = [He, Re].indexOf(V) >= 0 ? 1 : -1, d5 = [oe, Re].indexOf(V) >= 0 ? "y" : "x";
      K[V] += a5[d5] * l5;
    });
  }
  return K;
}
function CA(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, L = r.boundary, i = r.rootBoundary, l = r.padding, s = r.flipVariations, c = r.allowedAutoPlacements, h = c === void 0 ? dc : c, f = vn(n), g = f ? s ? Z7 : Z7.filter(function(k) {
    return vn(k) === f;
  }) : t2, m = g.filter(function(k) {
    return h.indexOf(k) >= 0;
  });
  m.length === 0 && (m = g, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var b = m.reduce(function(k, x) {
    return k[x] = B0(t, {
      placement: x,
      boundary: L,
      rootBoundary: i,
      padding: l
    })[et(x)], k;
  }, {});
  return Object.keys(b).sort(function(k, x) {
    return b[k] - b[x];
  });
}
function SA(t) {
  if (et(t) === po)
    return [];
  var e = v4(t);
  return [R7(t), e, R7(e)];
}
function DA(t) {
  var e = t.state, r = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var L = r.mainAxis, i = L === void 0 ? !0 : L, l = r.altAxis, s = l === void 0 ? !0 : l, c = r.fallbackPlacements, h = r.padding, f = r.boundary, g = r.rootBoundary, m = r.altBoundary, b = r.flipVariations, k = b === void 0 ? !0 : b, x = r.allowedAutoPlacements, D = e.options.placement, M = et(D), E = M === D, S = c || (E || !k ? [v4(D)] : SA(D)), C = [D].concat(S).reduce(function(I5, R5) {
      return I5.concat(et(R5) === po ? CA(e, {
        placement: R5,
        boundary: f,
        rootBoundary: g,
        padding: h,
        flipVariations: k,
        allowedAutoPlacements: x
      }) : R5);
    }, []), P = e.rects.reference, A = e.rects.popper, Z = /* @__PURE__ */ new Map(), B = !0, U = C[0], K = 0; K < C.length; K++) {
      var r5 = C[K], a5 = et(r5), V = vn(r5) === pn, l5 = [oe, Re].indexOf(a5) >= 0, d5 = l5 ? "width" : "height", m5 = B0(e, {
        placement: r5,
        boundary: f,
        rootBoundary: g,
        altBoundary: m,
        padding: h
      }), M5 = l5 ? V ? He : ie : V ? Re : oe;
      P[d5] > A[d5] && (M5 = v4(M5));
      var _5 = v4(M5), $5 = [];
      if (i && $5.push(m5[a5] <= 0), s && $5.push(m5[M5] <= 0, m5[_5] <= 0), $5.every(function(I5) {
        return I5;
      })) {
        U = r5, B = !1;
        break;
      }
      Z.set(r5, $5);
    }
    if (B)
      for (var E5 = k ? 3 : 1, f5 = function(I5) {
        var R5 = C.find(function(L1) {
          var f1 = Z.get(L1);
          if (f1)
            return f1.slice(0, I5).every(function(t1) {
              return t1;
            });
        });
        if (R5)
          return U = R5, "break";
      }, e1 = E5; e1 > 0; e1--) {
        var C1 = f5(e1);
        if (C1 === "break")
          break;
      }
    e.placement !== U && (e.modifiersData[n]._skip = !0, e.placement = U, e.reset = !0);
  }
}
const EA = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: DA,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function F7(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function j7(t) {
  return [oe, He, Re, ie].some(function(e) {
    return t[e] >= 0;
  });
}
function IA(t) {
  var e = t.state, r = t.name, n = e.rects.reference, L = e.rects.popper, i = e.modifiersData.preventOverflow, l = B0(e, {
    elementContext: "reference"
  }), s = B0(e, {
    altBoundary: !0
  }), c = F7(l, n), h = F7(s, L, i), f = j7(c), g = j7(h);
  e.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: h,
    isReferenceHidden: f,
    hasPopperEscaped: g
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": g
  });
}
const TA = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: IA
};
function OA(t, e, r) {
  var n = et(t), L = [ie, oe].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, l = i[0], s = i[1];
  return l = l || 0, s = (s || 0) * L, [ie, He].indexOf(n) >= 0 ? {
    x: s,
    y: l
  } : {
    x: l,
    y: s
  };
}
function zA(t) {
  var e = t.state, r = t.options, n = t.name, L = r.offset, i = L === void 0 ? [0, 0] : L, l = dc.reduce(function(f, g) {
    return f[g] = OA(g, e.rects, i), f;
  }, {}), s = l[e.placement], c = s.x, h = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += c, e.modifiersData.popperOffsets.y += h), e.modifiersData[n] = l;
}
const PA = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: zA
};
function AA(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = wc({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const $A = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: AA,
  data: {}
};
function ZA(t) {
  return t === "x" ? "y" : "x";
}
function NA(t) {
  var e = t.state, r = t.options, n = t.name, L = r.mainAxis, i = L === void 0 ? !0 : L, l = r.altAxis, s = l === void 0 ? !1 : l, c = r.boundary, h = r.rootBoundary, f = r.altBoundary, g = r.padding, m = r.tether, b = m === void 0 ? !0 : m, k = r.tetherOffset, x = k === void 0 ? 0 : k, D = B0(e, {
    boundary: c,
    rootBoundary: h,
    padding: g,
    altBoundary: f
  }), M = et(e.placement), E = vn(e.placement), S = !E, C = u3(M), P = ZA(C), A = e.modifiersData.popperOffsets, Z = e.rects.reference, B = e.rects.popper, U = typeof x == "function" ? x(Object.assign({}, e.rects, {
    placement: e.placement
  })) : x, K = typeof U == "number" ? {
    mainAxis: U,
    altAxis: U
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, U), r5 = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, a5 = {
    x: 0,
    y: 0
  };
  if (A) {
    if (i) {
      var V, l5 = C === "y" ? oe : ie, d5 = C === "y" ? Re : He, m5 = C === "y" ? "height" : "width", M5 = A[C], _5 = M5 + D[l5], $5 = M5 - D[d5], E5 = b ? -B[m5] / 2 : 0, f5 = E === pn ? Z[m5] : B[m5], e1 = E === pn ? -B[m5] : -Z[m5], C1 = e.elements.arrow, I5 = b && C1 ? l3(C1) : {
        width: 0,
        height: 0
      }, R5 = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : gc(), L1 = R5[l5], f1 = R5[d5], t1 = k0(0, Z[m5], I5[m5]), a1 = S ? Z[m5] / 2 - E5 - t1 - L1 - K.mainAxis : f5 - t1 - L1 - K.mainAxis, Ue = S ? -Z[m5] / 2 + E5 + t1 + f1 + K.mainAxis : e1 + t1 + f1 + K.mainAxis, W = e.elements.arrow && r2(e.elements.arrow), n5 = W ? C === "y" ? W.clientTop || 0 : W.clientLeft || 0 : 0, e5 = (V = r5 == null ? void 0 : r5[C]) != null ? V : 0, o5 = M5 + a1 - e5 - n5, w5 = M5 + Ue - e5, P5 = k0(b ? A4(_5, o5) : _5, M5, b ? Cr($5, w5) : $5);
      A[C] = P5, a5[C] = P5 - M5;
    }
    if (s) {
      var r1, j1 = C === "x" ? oe : ie, S1 = C === "x" ? Re : He, O1 = A[P], x1 = P === "y" ? "height" : "width", U1 = O1 + D[j1], z1 = O1 - D[S1], z = [oe, ie].indexOf(M) !== -1, N = (r1 = r5 == null ? void 0 : r5[P]) != null ? r1 : 0, j = z ? U1 : O1 - Z[x1] - B[x1] - N + K.altAxis, Q = z ? O1 + Z[x1] + B[x1] - N - K.altAxis : z1, i5 = b && z ? sA(j, O1, Q) : k0(b ? j : U1, O1, b ? Q : z1);
      A[P] = i5, a5[P] = i5 - O1;
    }
    e.modifiersData[n] = a5;
  }
}
const BA = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: NA,
  requiresIfExists: ["offset"]
};
function RA(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function HA(t) {
  return t === ve(t) || !me(t) ? c3(t) : RA(t);
}
function FA(t) {
  var e = t.getBoundingClientRect(), r = gn(e.width) / t.offsetWidth || 1, n = gn(e.height) / t.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function jA(t, e, r) {
  r === void 0 && (r = !1);
  var n = me(e), L = me(e) && FA(e), i = ur(e), l = mn(t, L, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((dt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  d3(i)) && (s = HA(e)), me(e) ? (c = mn(e, !0), c.x += e.clientLeft, c.y += e.clientTop) : i && (c.x = h3(i))), {
    x: l.left + s.scrollLeft - c.x,
    y: l.top + s.scrollTop - c.y,
    width: l.width,
    height: l.height
  };
}
function UA(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function L(i) {
    r.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(s) {
      if (!r.has(s)) {
        var c = e.get(s);
        c && L(c);
      }
    }), n.push(i);
  }
  return t.forEach(function(i) {
    r.has(i.name) || L(i);
  }), n;
}
function YA(t) {
  var e = UA(t);
  return nL.reduce(function(r, n) {
    return r.concat(e.filter(function(L) {
      return L.phase === n;
    }));
  }, []);
}
function VA(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function Kt(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  return [].concat(r).reduce(function(L, i) {
    return L.replace(/%s/, i);
  }, t);
}
var kr = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', WA = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', U7 = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function GA(t) {
  t.forEach(function(e) {
    [].concat(Object.keys(e), U7).filter(function(r, n, L) {
      return L.indexOf(r) === n;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof e.name != "string" && console.error(Kt(kr, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(Kt(kr, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          nL.indexOf(e.phase) < 0 && console.error(Kt(kr, e.name, '"phase"', "either " + nL.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(Kt(kr, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(Kt(kr, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(Kt(kr, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(Kt(kr, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + U7.map(function(n) {
            return '"' + n + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      e.requires && e.requires.forEach(function(n) {
        t.find(function(L) {
          return L.name === n;
        }) == null && console.error(Kt(WA, String(e.name), n, n));
      });
    });
  });
}
function qA(t, e) {
  var r = /* @__PURE__ */ new Set();
  return t.filter(function(n) {
    var L = e(n);
    if (!r.has(L))
      return r.add(L), !0;
  });
}
function KA(t) {
  var e = t.reduce(function(r, n) {
    var L = r[n.name];
    return r[n.name] = L ? Object.assign({}, L, n, {
      options: Object.assign({}, L.options, n.options),
      data: Object.assign({}, L.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var Y7 = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", JA = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", V7 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function W7() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function QA(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, n = r === void 0 ? [] : r, L = e.defaultOptions, i = L === void 0 ? V7 : L;
  return function(l, s, c) {
    c === void 0 && (c = i);
    var h = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, V7, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], g = !1, m = {
      state: h,
      setOptions: function(x) {
        var D = typeof x == "function" ? x(h.options) : x;
        k(), h.options = Object.assign({}, i, h.options, D), h.scrollParents = {
          reference: Ir(l) ? M0(l) : l.contextElement ? M0(l.contextElement) : [],
          popper: M0(s)
        };
        var M = YA(KA([].concat(n, h.options.modifiers)));
        if (h.orderedModifiers = M.filter(function(U) {
          return U.enabled;
        }), process.env.NODE_ENV !== "production") {
          var E = qA([].concat(M, h.options.modifiers), function(U) {
            var K = U.name;
            return K;
          });
          if (GA(E), et(h.options.placement) === po) {
            var S = h.orderedModifiers.find(function(U) {
              var K = U.name;
              return K === "flip";
            });
            S || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var C = rt(s), P = C.marginTop, A = C.marginRight, Z = C.marginBottom, B = C.marginLeft;
          [P, A, Z, B].some(function(U) {
            return parseFloat(U);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return b(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var x = h.elements, D = x.reference, M = x.popper;
          if (!W7(D, M)) {
            process.env.NODE_ENV !== "production" && console.error(Y7);
            return;
          }
          h.rects = {
            reference: jA(D, r2(M), h.options.strategy === "fixed"),
            popper: l3(M)
          }, h.reset = !1, h.placement = h.options.placement, h.orderedModifiers.forEach(function(U) {
            return h.modifiersData[U.name] = Object.assign({}, U.data);
          });
          for (var E = 0, S = 0; S < h.orderedModifiers.length; S++) {
            if (process.env.NODE_ENV !== "production" && (E += 1, E > 100)) {
              console.error(JA);
              break;
            }
            if (h.reset === !0) {
              h.reset = !1, S = -1;
              continue;
            }
            var C = h.orderedModifiers[S], P = C.fn, A = C.options, Z = A === void 0 ? {} : A, B = C.name;
            typeof P == "function" && (h = P({
              state: h,
              options: Z,
              name: B,
              instance: m
            }) || h);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: VA(function() {
        return new Promise(function(x) {
          m.forceUpdate(), x(h);
        });
      }),
      destroy: function() {
        k(), g = !0;
      }
    };
    if (!W7(l, s))
      return process.env.NODE_ENV !== "production" && console.error(Y7), m;
    m.setOptions(c).then(function(x) {
      !g && c.onFirstUpdate && c.onFirstUpdate(x);
    });
    function b() {
      h.orderedModifiers.forEach(function(x) {
        var D = x.name, M = x.options, E = M === void 0 ? {} : M, S = x.effect;
        if (typeof S == "function") {
          var C = S({
            state: h,
            name: D,
            instance: m,
            options: E
          }), P = function() {
          };
          f.push(C || P);
        }
      });
    }
    function k() {
      f.forEach(function(x) {
        return x();
      }), f = [];
    }
    return m;
  };
}
var XA = [vA, $A, gA, iA, PA, EA, BA, hA, TA], e$ = /* @__PURE__ */ QA({
  defaultModifiers: XA
});
const t$ = Object.defineProperty, r$ = Object.defineProperties, n$ = Object.getOwnPropertyDescriptors, $4 = Object.getOwnPropertySymbols, bc = Object.prototype.hasOwnProperty, xc = Object.prototype.propertyIsEnumerable, G7 = (t, e, r) => e in t ? t$(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r, c5 = (t, e) => {
  for (var r in e || (e = {}))
    bc.call(e, r) && G7(t, r, e[r]);
  if ($4)
    for (var r of $4(e))
      xc.call(e, r) && G7(t, r, e[r]);
  return t;
}, V5 = (t, e) => r$(t, n$(e)), o$ = (t, e) => {
  const r = {};
  for (var n in t)
    bc.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && $4)
    for (var n of $4(t))
      e.indexOf(n) < 0 && xc.call(t, n) && (r[n] = t[n]);
  return r;
};
function ft(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  const e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function F1(t, e) {
  if (e.length < t)
    throw new TypeError(
      t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present"
    );
}
function Nt(t) {
  F1(1, arguments);
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn(
    "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"
  ), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function ut(t, e) {
  F1(2, arguments);
  const r = Nt(t), n = ft(e);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function LL(t, e) {
  F1(2, arguments);
  const r = Nt(t), n = ft(e);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  const L = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + n + 1, 0);
  const l = i.getDate();
  return L >= l ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    L
  ), r);
}
function q7(t, e) {
  F1(2, arguments);
  const r = ft(e);
  return LL(t, r * 12);
}
const r4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, i$ = typeof r4 == "object" && r4 && r4.Object === Object && r4, kc = i$, L$ = kc, a$ = typeof self == "object" && self && self.Object === Object && self, s$ = L$ || a$ || Function("return this")(), mt = s$, l$ = mt, u$ = l$.Symbol, Nn = u$, K7 = Nn, Mc = Object.prototype, c$ = Mc.hasOwnProperty, h$ = Mc.toString, m0 = K7 ? K7.toStringTag : void 0;
function d$(t) {
  const e = c$.call(t, m0), r = t[m0];
  try {
    t[m0] = void 0;
    var n = !0;
  } catch {
  }
  const L = h$.call(t);
  return n && (e ? t[m0] = r : delete t[m0]), L;
}
const f$ = d$, p$ = Object.prototype, g$ = p$.toString;
function m$(t) {
  return g$.call(t);
}
const v$ = m$, J7 = Nn, y$ = f$, w$ = v$, b$ = "[object Null]", x$ = "[object Undefined]", Q7 = J7 ? J7.toStringTag : void 0;
function k$(t) {
  return t == null ? t === void 0 ? x$ : b$ : Q7 && Q7 in Object(t) ? y$(t) : w$(t);
}
const vt = k$;
function M$(t) {
  return t != null && typeof t == "object";
}
const be = M$, _$ = vt, C$ = be, S$ = "[object Boolean]";
function D$(t) {
  return t === !0 || t === !1 || C$(t) && _$(t) == S$;
}
const E$ = D$, I$ = vt, T$ = be, O$ = "[object Number]";
function z$(t) {
  return typeof t == "number" || T$(t) && I$(t) == O$;
}
const _0 = z$, P$ = Array.isArray, xe = P$, A$ = vt, $$ = xe, Z$ = be, N$ = "[object String]";
function B$(t) {
  return typeof t == "string" || !$$(t) && Z$(t) && A$(t) == N$;
}
const nr = B$;
function R$(t) {
  const e = typeof t;
  return t != null && (e == "object" || e == "function");
}
const je = R$, H$ = vt, F$ = je, j$ = "[object AsyncFunction]", U$ = "[object Function]", Y$ = "[object GeneratorFunction]", V$ = "[object Proxy]";
function W$(t) {
  if (!F$(t))
    return !1;
  const e = H$(t);
  return e == U$ || e == Y$ || e == j$ || e == V$;
}
const Pt = W$, G$ = 9007199254740991;
function q$(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= G$;
}
const f3 = q$, K$ = Pt, J$ = f3;
function Q$(t) {
  return t != null && J$(t.length) && !K$(t);
}
const n2 = Q$, X$ = n2, eZ = be;
function tZ(t) {
  return eZ(t) && X$(t);
}
const re = tZ;
function rZ(t) {
  return t === void 0;
}
const nZ = rZ, oZ = vt, iZ = be, LZ = "[object Date]";
function aZ(t) {
  return iZ(t) && oZ(t) == LZ;
}
const sZ = aZ;
function lZ(t) {
  return function(e) {
    return t(e);
  };
}
const mo = lZ, yn = { exports: {} };
(function(t, e) {
  const r = kc, n = e && !e.nodeType && e, L = n && !0 && t && !t.nodeType && t, i = L && L.exports === n && r.process, l = function() {
    try {
      return L && L.require && L.require("util").types || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  t.exports = l;
})(yn, yn.exports);
const uZ = sZ, cZ = mo, X7 = yn.exports, e8 = X7 && X7.isDate, hZ = e8 ? cZ(e8) : uZ, dZ = hZ;
function fZ(t, e, r) {
  return t === t && (r !== void 0 && (t = t <= r ? t : r), e !== void 0 && (t = t >= e ? t : e)), t;
}
const pZ = fZ, gZ = vt, mZ = be, vZ = "[object Symbol]";
function yZ(t) {
  return typeof t == "symbol" || mZ(t) && gZ(t) == vZ;
}
const vo = yZ, t8 = je, wZ = vo, r8 = 0 / 0, bZ = /^\s+|\s+$/g, xZ = /^[-+]0x[0-9a-f]+$/i, kZ = /^0b[01]+$/i, MZ = /^0o[0-7]+$/i, _Z = parseInt;
function CZ(t) {
  if (typeof t == "number")
    return t;
  if (wZ(t))
    return r8;
  if (t8(t)) {
    const r = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = t8(r) ? r + "" : r;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(bZ, "");
  const e = kZ.test(t);
  return e || MZ.test(t) ? _Z(t.slice(2), e ? 2 : 8) : xZ.test(t) ? r8 : +t;
}
const SZ = CZ, DZ = pZ, xi = SZ;
function EZ(t, e, r) {
  return r === void 0 && (r = e, e = void 0), r !== void 0 && (r = xi(r), r = r === r ? r : 0), e !== void 0 && (e = xi(e), e = e === e ? e : 0), DZ(xi(t), e, r);
}
const IZ = EZ, TZ = xe, OZ = vo, zZ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, PZ = /^\w*$/;
function AZ(t, e) {
  if (TZ(t))
    return !1;
  const r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || OZ(t) ? !0 : PZ.test(t) || !zZ.test(t) || e != null && t in Object(e);
}
const p3 = AZ, $Z = mt, ZZ = $Z["__core-js_shared__"], NZ = ZZ, ki = NZ, n8 = function() {
  const t = /[^.]+$/.exec(
    ki && ki.keys && ki.keys.IE_PROTO || ""
  );
  return t ? "Symbol(src)_1." + t : "";
}();
function BZ(t) {
  return !!n8 && n8 in t;
}
const RZ = BZ, HZ = Function.prototype, FZ = HZ.toString;
function jZ(t) {
  if (t != null) {
    try {
      return FZ.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
const _c = jZ, UZ = Pt, YZ = RZ, VZ = je, WZ = _c, GZ = /[\\^$.*+?()[\]{}|]/g, qZ = /^\[object .+?Constructor\]$/, KZ = Function.prototype, JZ = Object.prototype, QZ = KZ.toString, XZ = JZ.hasOwnProperty, eN = RegExp(
  "^" + QZ.call(XZ).replace(GZ, "\\$&").replace(
    /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
    "$1.*?"
  ) + "$"
);
function tN(t) {
  return !VZ(t) || YZ(t) ? !1 : (UZ(t) ? eN : qZ).test(WZ(t));
}
const rN = tN;
function nN(t, e) {
  return t == null ? void 0 : t[e];
}
const oN = nN, iN = rN, LN = oN;
function aN(t, e) {
  const r = LN(t, e);
  return iN(r) ? r : void 0;
}
const Rr = aN, sN = Rr, lN = sN(Object, "create"), yo = lN, o8 = yo;
function uN() {
  this.__data__ = o8 ? o8(null) : {}, this.size = 0;
}
const cN = uN;
function hN(t) {
  const e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
const dN = hN, fN = yo, pN = "__lodash_hash_undefined__", gN = Object.prototype, mN = gN.hasOwnProperty;
function vN(t) {
  const e = this.__data__;
  if (fN) {
    const r = e[t];
    return r === pN ? void 0 : r;
  }
  return mN.call(e, t) ? e[t] : void 0;
}
const yN = vN, wN = yo, bN = Object.prototype, xN = bN.hasOwnProperty;
function kN(t) {
  const e = this.__data__;
  return wN ? e[t] !== void 0 : xN.call(e, t);
}
const MN = kN, _N = yo, CN = "__lodash_hash_undefined__";
function SN(t, e) {
  const r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = _N && e === void 0 ? CN : e, this;
}
const DN = SN, EN = cN, IN = dN, TN = yN, ON = MN, zN = DN;
function Bn(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    const n = t[e];
    this.set(n[0], n[1]);
  }
}
Bn.prototype.clear = EN;
Bn.prototype.delete = IN;
Bn.prototype.get = TN;
Bn.prototype.has = ON;
Bn.prototype.set = zN;
const PN = Bn;
function AN() {
  this.__data__ = [], this.size = 0;
}
const $N = AN;
function ZN(t, e) {
  return t === e || t !== t && e !== e;
}
const Rn = ZN, NN = Rn;
function BN(t, e) {
  let r = t.length;
  for (; r--; )
    if (NN(t[r][0], e))
      return r;
  return -1;
}
const wo = BN, RN = wo, HN = Array.prototype, FN = HN.splice;
function jN(t) {
  const e = this.__data__, r = RN(e, t);
  if (r < 0)
    return !1;
  const n = e.length - 1;
  return r == n ? e.pop() : FN.call(e, r, 1), --this.size, !0;
}
const UN = jN, YN = wo;
function VN(t) {
  const e = this.__data__, r = YN(e, t);
  return r < 0 ? void 0 : e[r][1];
}
const WN = VN, GN = wo;
function qN(t) {
  return GN(this.__data__, t) > -1;
}
const KN = qN, JN = wo;
function QN(t, e) {
  const r = this.__data__, n = JN(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
const XN = QN, eB = $N, tB = UN, rB = WN, nB = KN, oB = XN;
function Hn(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    const n = t[e];
    this.set(n[0], n[1]);
  }
}
Hn.prototype.clear = eB;
Hn.prototype.delete = tB;
Hn.prototype.get = rB;
Hn.prototype.has = nB;
Hn.prototype.set = oB;
const bo = Hn, iB = Rr, LB = mt, aB = iB(LB, "Map"), g3 = aB, i8 = PN, sB = bo, lB = g3;
function uB() {
  this.size = 0, this.__data__ = {
    hash: new i8(),
    map: new (lB || sB)(),
    string: new i8()
  };
}
const cB = uB;
function hB(t) {
  const e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
const dB = hB, fB = dB;
function pB(t, e) {
  const r = t.__data__;
  return fB(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
const xo = pB, gB = xo;
function mB(t) {
  const e = gB(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
const vB = mB, yB = xo;
function wB(t) {
  return yB(this, t).get(t);
}
const bB = wB, xB = xo;
function kB(t) {
  return xB(this, t).has(t);
}
const MB = kB, _B = xo;
function CB(t, e) {
  const r = _B(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
const SB = CB, DB = cB, EB = vB, IB = bB, TB = MB, OB = SB;
function Fn(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    const n = t[e];
    this.set(n[0], n[1]);
  }
}
Fn.prototype.clear = DB;
Fn.prototype.delete = EB;
Fn.prototype.get = IB;
Fn.prototype.has = TB;
Fn.prototype.set = OB;
const m3 = Fn, Cc = m3, zB = "Expected a function";
function v3(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(zB);
  var r = function() {
    const n = arguments, L = e ? e.apply(this, n) : n[0], i = r.cache;
    if (i.has(L))
      return i.get(L);
    const l = t.apply(this, n);
    return r.cache = i.set(L, l) || i, l;
  };
  return r.cache = new (v3.Cache || Cc)(), r;
}
v3.Cache = Cc;
const PB = v3, AB = PB, $B = 500;
function ZB(t) {
  const e = AB(t, function(n) {
    return r.size === $B && r.clear(), n;
  });
  var r = e.cache;
  return e;
}
const NB = ZB, BB = NB, RB = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, HB = /\\(\\)?/g, FB = BB(function(t) {
  const e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(RB, function(r, n, L, i) {
    e.push(L ? i.replace(HB, "$1") : n || r);
  }), e;
}), jB = FB;
function UB(t, e) {
  let r = -1, n = t == null ? 0 : t.length, L = Array(n);
  for (; ++r < n; )
    L[r] = e(t[r], r, t);
  return L;
}
const y3 = UB, L8 = Nn, YB = y3, VB = xe, WB = vo, GB = 1 / 0, a8 = L8 ? L8.prototype : void 0, s8 = a8 ? a8.toString : void 0;
function Sc(t) {
  if (typeof t == "string")
    return t;
  if (VB(t))
    return YB(t, Sc) + "";
  if (WB(t))
    return s8 ? s8.call(t) : "";
  const e = t + "";
  return e == "0" && 1 / t == -GB ? "-0" : e;
}
const qB = Sc, KB = qB;
function JB(t) {
  return t == null ? "" : KB(t);
}
const QB = JB, XB = xe, eR = p3, tR = jB, rR = QB;
function nR(t, e) {
  return XB(t) ? t : eR(t, e) ? [t] : tR(rR(t));
}
const jn = nR, oR = vo, iR = 1 / 0;
function LR(t) {
  if (typeof t == "string" || oR(t))
    return t;
  const e = t + "";
  return e == "0" && 1 / t == -iR ? "-0" : e;
}
const Un = LR, aR = jn, sR = Un;
function lR(t, e) {
  e = aR(e, t);
  let r = 0, n = e.length;
  for (; t != null && r < n; )
    t = t[sR(e[r++])];
  return r && r == n ? t : void 0;
}
const ko = lR, uR = ko;
function cR(t, e, r) {
  const n = t == null ? void 0 : uR(t, e);
  return n === void 0 ? r : n;
}
const R0 = cR, hR = Rr, dR = function() {
  try {
    const t = hR(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), Dc = dR, l8 = Dc;
function fR(t, e, r) {
  e == "__proto__" && l8 ? l8(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
const Mo = fR, pR = Mo, gR = Rn, mR = Object.prototype, vR = mR.hasOwnProperty;
function yR(t, e, r) {
  const n = t[e];
  (!(vR.call(t, e) && gR(n, r)) || r === void 0 && !(e in t)) && pR(t, e, r);
}
const w3 = yR, wR = 9007199254740991, bR = /^(?:0|[1-9]\d*)$/;
function xR(t, e) {
  const r = typeof t;
  return e = e ?? wR, !!e && (r == "number" || r != "symbol" && bR.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
const _o = xR, kR = w3, MR = jn, _R = _o, u8 = je, CR = Un;
function SR(t, e, r, n) {
  if (!u8(t))
    return t;
  e = MR(e, t);
  let L = -1, i = e.length, l = i - 1, s = t;
  for (; s != null && ++L < i; ) {
    let c = CR(e[L]), h = r;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return t;
    if (L != l) {
      const f = s[c];
      h = n ? n(f, c, s) : void 0, h === void 0 && (h = u8(f) ? f : _R(e[L + 1]) ? [] : {});
    }
    kR(s, c, h), s = s[c];
  }
  return t;
}
const Ec = SR, DR = Ec;
function ER(t, e, r) {
  return t == null ? t : DR(t, e, r);
}
const IR = ER;
function TR(t) {
  return function(e, r, n) {
    let L = -1, i = Object(e), l = n(e), s = l.length;
    for (; s--; ) {
      const c = l[t ? s : ++L];
      if (r(i[c], c, i) === !1)
        break;
    }
    return e;
  };
}
const OR = TR, zR = OR, PR = zR(), Ic = PR;
function AR(t, e) {
  let r = -1, n = Array(t);
  for (; ++r < t; )
    n[r] = e(r);
  return n;
}
const $R = AR, ZR = vt, NR = be, BR = "[object Arguments]";
function RR(t) {
  return NR(t) && ZR(t) == BR;
}
const HR = RR, c8 = HR, FR = be, Tc = Object.prototype, jR = Tc.hasOwnProperty, UR = Tc.propertyIsEnumerable, YR = c8(
  function() {
    return arguments;
  }()
) ? c8 : function(t) {
  return FR(t) && jR.call(t, "callee") && !UR.call(t, "callee");
}, Co = YR, wn = { exports: {} };
function VR() {
  return !1;
}
const WR = VR;
(function(t, e) {
  const r = mt, n = WR, L = e && !e.nodeType && e, i = L && !0 && t && !t.nodeType && t, l = i && i.exports === L ? r.Buffer : void 0, s = (l ? l.isBuffer : void 0) || n;
  t.exports = s;
})(wn, wn.exports);
const GR = vt, qR = f3, KR = be, JR = "[object Arguments]", QR = "[object Array]", XR = "[object Boolean]", eH = "[object Date]", tH = "[object Error]", rH = "[object Function]", nH = "[object Map]", oH = "[object Number]", iH = "[object Object]", LH = "[object RegExp]", aH = "[object Set]", sH = "[object String]", lH = "[object WeakMap]", uH = "[object ArrayBuffer]", cH = "[object DataView]", hH = "[object Float32Array]", dH = "[object Float64Array]", fH = "[object Int8Array]", pH = "[object Int16Array]", gH = "[object Int32Array]", mH = "[object Uint8Array]", vH = "[object Uint8ClampedArray]", yH = "[object Uint16Array]", wH = "[object Uint32Array]", h1 = {};
h1[hH] = h1[dH] = h1[fH] = h1[pH] = h1[gH] = h1[mH] = h1[vH] = h1[yH] = h1[wH] = !0;
h1[JR] = h1[QR] = h1[uH] = h1[XR] = h1[cH] = h1[eH] = h1[tH] = h1[rH] = h1[nH] = h1[oH] = h1[iH] = h1[LH] = h1[aH] = h1[sH] = h1[lH] = !1;
function bH(t) {
  return KR(t) && qR(t.length) && !!h1[GR(t)];
}
const xH = bH, kH = xH, MH = mo, h8 = yn.exports, d8 = h8 && h8.isTypedArray, _H = d8 ? MH(d8) : kH, b3 = _H, CH = $R, SH = Co, DH = xe, EH = wn.exports, IH = _o, TH = b3, OH = Object.prototype, zH = OH.hasOwnProperty;
function PH(t, e) {
  const r = DH(t), n = !r && SH(t), L = !r && !n && EH(t), i = !r && !n && !L && TH(t), l = r || n || L || i, s = l ? CH(t.length, String) : [], c = s.length;
  for (const h in t)
    (e || zH.call(t, h)) && !(l && (h == "length" || L && (h == "offset" || h == "parent") || i && (h == "buffer" || h == "byteLength" || h == "byteOffset") || IH(h, c))) && s.push(h);
  return s;
}
const Oc = PH, AH = Object.prototype;
function $H(t) {
  const e = t && t.constructor, r = typeof e == "function" && e.prototype || AH;
  return t === r;
}
const x3 = $H;
function ZH(t, e) {
  return function(r) {
    return t(e(r));
  };
}
const zc = ZH, NH = zc, BH = NH(Object.keys, Object), RH = BH, HH = x3, FH = RH, jH = Object.prototype, UH = jH.hasOwnProperty;
function YH(t) {
  if (!HH(t))
    return FH(t);
  const e = [];
  for (const r in Object(t))
    UH.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
const VH = YH, WH = Oc, GH = VH, qH = n2;
function KH(t) {
  return qH(t) ? WH(t) : GH(t);
}
const Yn = KH, JH = Ic, QH = Yn;
function XH(t, e) {
  return t && JH(t, e, QH);
}
const Pc = XH, eF = bo;
function tF() {
  this.__data__ = new eF(), this.size = 0;
}
const rF = tF;
function nF(t) {
  const e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
const oF = nF;
function iF(t) {
  return this.__data__.get(t);
}
const LF = iF;
function aF(t) {
  return this.__data__.has(t);
}
const sF = aF, lF = bo, uF = g3, cF = m3, hF = 200;
function dF(t, e) {
  let r = this.__data__;
  if (r instanceof lF) {
    const n = r.__data__;
    if (!uF || n.length < hF - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new cF(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
const fF = dF, pF = bo, gF = rF, mF = oF, vF = LF, yF = sF, wF = fF;
function Vn(t) {
  const e = this.__data__ = new pF(t);
  this.size = e.size;
}
Vn.prototype.clear = gF;
Vn.prototype.delete = mF;
Vn.prototype.get = vF;
Vn.prototype.has = yF;
Vn.prototype.set = wF;
const So = Vn, bF = "__lodash_hash_undefined__";
function xF(t) {
  return this.__data__.set(t, bF), this;
}
const kF = xF;
function MF(t) {
  return this.__data__.has(t);
}
const _F = MF, CF = m3, SF = kF, DF = _F;
function Z4(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new CF(); ++e < r; )
    this.add(t[e]);
}
Z4.prototype.add = Z4.prototype.push = SF;
Z4.prototype.has = DF;
const EF = Z4;
function IF(t, e) {
  let r = -1, n = t == null ? 0 : t.length;
  for (; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
const Ac = IF;
function TF(t, e) {
  return t.has(e);
}
const OF = TF, zF = EF, PF = Ac, AF = OF, $F = 1, ZF = 2;
function NF(t, e, r, n, L, i) {
  const l = r & $F, s = t.length, c = e.length;
  if (s != c && !(l && c > s))
    return !1;
  const h = i.get(t), f = i.get(e);
  if (h && f)
    return h == e && f == t;
  let g = -1, m = !0, b = r & ZF ? new zF() : void 0;
  for (i.set(t, e), i.set(e, t); ++g < s; ) {
    var k = t[g], x = e[g];
    if (n)
      var D = l ? n(x, k, g, e, t, i) : n(k, x, g, t, e, i);
    if (D !== void 0) {
      if (D)
        continue;
      m = !1;
      break;
    }
    if (b) {
      if (!PF(e, function(M, E) {
        if (!AF(b, E) && (k === M || L(k, M, r, n, i)))
          return b.push(E);
      })) {
        m = !1;
        break;
      }
    } else if (!(k === x || L(k, x, r, n, i))) {
      m = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), m;
}
const $c = NF, BF = mt, RF = BF.Uint8Array, Zc = RF;
function HF(t) {
  let e = -1, r = Array(t.size);
  return t.forEach(function(n, L) {
    r[++e] = [L, n];
  }), r;
}
const Nc = HF;
function FF(t) {
  let e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
const jF = FF, f8 = Nn, p8 = Zc, UF = Rn, YF = $c, VF = Nc, WF = jF, GF = 1, qF = 2, KF = "[object Boolean]", JF = "[object Date]", QF = "[object Error]", XF = "[object Map]", ej = "[object Number]", tj = "[object RegExp]", rj = "[object Set]", nj = "[object String]", oj = "[object Symbol]", ij = "[object ArrayBuffer]", Lj = "[object DataView]", g8 = f8 ? f8.prototype : void 0, Mi = g8 ? g8.valueOf : void 0;
function aj(t, e, r, n, L, i, l) {
  switch (r) {
    case Lj:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case ij:
      return !(t.byteLength != e.byteLength || !i(new p8(t), new p8(e)));
    case KF:
    case JF:
    case ej:
      return UF(+t, +e);
    case QF:
      return t.name == e.name && t.message == e.message;
    case tj:
    case nj:
      return t == e + "";
    case XF:
      var s = VF;
    case rj:
      var c = n & GF;
      if (s || (s = WF), t.size != e.size && !c)
        return !1;
      var h = l.get(t);
      if (h)
        return h == e;
      n |= qF, l.set(t, e);
      var f = YF(
        s(t),
        s(e),
        n,
        L,
        i,
        l
      );
      return l.delete(t), f;
    case oj:
      if (Mi)
        return Mi.call(t) == Mi.call(e);
  }
  return !1;
}
const sj = aj;
function lj(t, e) {
  let r = -1, n = e.length, L = t.length;
  for (; ++r < n; )
    t[L + r] = e[r];
  return t;
}
const k3 = lj, uj = k3, cj = xe;
function hj(t, e, r) {
  const n = e(t);
  return cj(t) ? n : uj(n, r(t));
}
const Bc = hj;
function dj(t, e) {
  let r = -1, n = t == null ? 0 : t.length, L = 0, i = [];
  for (; ++r < n; ) {
    const l = t[r];
    e(l, r, t) && (i[L++] = l);
  }
  return i;
}
const fj = dj;
function pj() {
  return [];
}
const Rc = pj, gj = fj, mj = Rc, vj = Object.prototype, yj = vj.propertyIsEnumerable, m8 = Object.getOwnPropertySymbols, wj = m8 ? function(t) {
  return t == null ? [] : (t = Object(t), gj(m8(t), function(e) {
    return yj.call(t, e);
  }));
} : mj, M3 = wj, bj = Bc, xj = M3, kj = Yn;
function Mj(t) {
  return bj(t, kj, xj);
}
const Hc = Mj, v8 = Hc, _j = 1, Cj = Object.prototype, Sj = Cj.hasOwnProperty;
function Dj(t, e, r, n, L, i) {
  const l = r & _j, s = v8(t), c = s.length, h = v8(e), f = h.length;
  if (c != f && !l)
    return !1;
  let g = c;
  for (; g--; ) {
    var m = s[g];
    if (!(l ? m in e : Sj.call(e, m)))
      return !1;
  }
  const b = i.get(t), k = i.get(e);
  if (b && k)
    return b == e && k == t;
  let x = !0;
  i.set(t, e), i.set(e, t);
  let D = l;
  for (; ++g < c; ) {
    m = s[g];
    const E = t[m], S = e[m];
    if (n)
      var M = l ? n(S, E, m, e, t, i) : n(E, S, m, t, e, i);
    if (!(M === void 0 ? E === S || L(E, S, r, n, i) : M)) {
      x = !1;
      break;
    }
    D || (D = m == "constructor");
  }
  if (x && !D) {
    const E = t.constructor, S = e.constructor;
    E != S && "constructor" in t && "constructor" in e && !(typeof E == "function" && E instanceof E && typeof S == "function" && S instanceof S) && (x = !1);
  }
  return i.delete(t), i.delete(e), x;
}
const Ej = Dj, Ij = Rr, Tj = mt, Oj = Ij(Tj, "DataView"), zj = Oj, Pj = Rr, Aj = mt, $j = Pj(Aj, "Promise"), Zj = $j, Nj = Rr, Bj = mt, Rj = Nj(Bj, "Set"), Hj = Rj, Fj = Rr, jj = mt, Uj = Fj(jj, "WeakMap"), Yj = Uj, aL = zj, sL = g3, lL = Zj, uL = Hj, cL = Yj, Fc = vt, Wn = _c, y8 = "[object Map]", Vj = "[object Object]", w8 = "[object Promise]", b8 = "[object Set]", x8 = "[object WeakMap]", k8 = "[object DataView]", Wj = Wn(aL), Gj = Wn(sL), qj = Wn(lL), Kj = Wn(uL), Jj = Wn(cL);
let Mr = Fc;
(aL && Mr(new aL(new ArrayBuffer(1))) != k8 || sL && Mr(new sL()) != y8 || lL && Mr(lL.resolve()) != w8 || uL && Mr(new uL()) != b8 || cL && Mr(new cL()) != x8) && (Mr = function(t) {
  const e = Fc(t), r = e == Vj ? t.constructor : void 0, n = r ? Wn(r) : "";
  if (n)
    switch (n) {
      case Wj:
        return k8;
      case Gj:
        return y8;
      case qj:
        return w8;
      case Kj:
        return b8;
      case Jj:
        return x8;
    }
  return e;
});
const o2 = Mr, _i = So, Qj = $c, Xj = sj, eU = Ej, M8 = o2, _8 = xe, C8 = wn.exports, tU = b3, rU = 1, S8 = "[object Arguments]", D8 = "[object Array]", n4 = "[object Object]", nU = Object.prototype, E8 = nU.hasOwnProperty;
function oU(t, e, r, n, L, i) {
  let l = _8(t), s = _8(e), c = l ? D8 : M8(t), h = s ? D8 : M8(e);
  c = c == S8 ? n4 : c, h = h == S8 ? n4 : h;
  let f = c == n4, g = h == n4, m = c == h;
  if (m && C8(t)) {
    if (!C8(e))
      return !1;
    l = !0, f = !1;
  }
  if (m && !f)
    return i || (i = new _i()), l || tU(t) ? Qj(t, e, r, n, L, i) : Xj(t, e, c, r, n, L, i);
  if (!(r & rU)) {
    const b = f && E8.call(t, "__wrapped__"), k = g && E8.call(e, "__wrapped__");
    if (b || k) {
      const x = b ? t.value() : t, D = k ? e.value() : e;
      return i || (i = new _i()), L(x, D, r, n, i);
    }
  }
  return m ? (i || (i = new _i()), eU(t, e, r, n, L, i)) : !1;
}
const iU = oU, LU = iU, I8 = be;
function jc(t, e, r, n, L) {
  return t === e ? !0 : t == null || e == null || !I8(t) && !I8(e) ? t !== t && e !== e : LU(
    t,
    e,
    r,
    n,
    jc,
    L
  );
}
const Uc = jc, aU = So, sU = Uc, lU = 1, uU = 2;
function cU(t, e, r, n) {
  let L = r.length, i = L, l = !n;
  if (t == null)
    return !i;
  for (t = Object(t); L--; ) {
    var s = r[L];
    if (l && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++L < i; ) {
    s = r[L];
    const h = s[0], f = t[h], g = s[1];
    if (l && s[2]) {
      if (f === void 0 && !(h in t))
        return !1;
    } else {
      const m = new aU();
      if (n)
        var c = n(f, g, h, t, e, m);
      if (!(c === void 0 ? sU(
        g,
        f,
        lU | uU,
        n,
        m
      ) : c))
        return !1;
    }
  }
  return !0;
}
const hU = cU, dU = je;
function fU(t) {
  return t === t && !dU(t);
}
const Yc = fU, pU = Yc, gU = Yn;
function mU(t) {
  let e = gU(t), r = e.length;
  for (; r--; ) {
    const n = e[r], L = t[n];
    e[r] = [n, L, pU(L)];
  }
  return e;
}
const vU = mU;
function yU(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
const Vc = yU, wU = hU, bU = vU, xU = Vc;
function kU(t) {
  const e = bU(t);
  return e.length == 1 && e[0][2] ? xU(e[0][0], e[0][1]) : function(r) {
    return r === t || wU(r, t, e);
  };
}
const MU = kU;
function _U(t, e) {
  return t != null && e in Object(t);
}
const CU = _U, SU = jn, DU = Co, EU = xe, IU = _o, TU = f3, OU = Un;
function zU(t, e, r) {
  e = SU(e, t);
  let n = -1, L = e.length, i = !1;
  for (; ++n < L; ) {
    var l = OU(e[n]);
    if (!(i = t != null && r(t, l)))
      break;
    t = t[l];
  }
  return i || ++n != L ? i : (L = t == null ? 0 : t.length, !!L && TU(L) && IU(l, L) && (EU(t) || DU(t)));
}
const Wc = zU, PU = CU, AU = Wc;
function $U(t, e) {
  return t != null && AU(t, e, PU);
}
const Gc = $U, ZU = Uc, NU = R0, BU = Gc, RU = p3, HU = Yc, FU = Vc, jU = Un, UU = 1, YU = 2;
function VU(t, e) {
  return RU(t) && HU(e) ? FU(jU(t), e) : function(r) {
    const n = NU(r, t);
    return n === void 0 && n === e ? BU(r, t) : ZU(
      e,
      n,
      UU | YU
    );
  };
}
const WU = VU;
function GU(t) {
  return t;
}
const _3 = GU;
function qU(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
const KU = qU, JU = ko;
function QU(t) {
  return function(e) {
    return JU(e, t);
  };
}
const XU = QU, eY = KU, tY = XU, rY = p3, nY = Un;
function oY(t) {
  return rY(t) ? eY(nY(t)) : tY(t);
}
const iY = oY, LY = MU, aY = WU, sY = _3, lY = xe, uY = iY;
function cY(t) {
  return typeof t == "function" ? t : t == null ? sY : typeof t == "object" ? lY(t) ? aY(t[0], t[1]) : LY(t) : uY(t);
}
const qc = cY, hY = Mo, dY = Pc, fY = qc;
function pY(t, e) {
  const r = {};
  return e = fY(e), dY(t, function(n, L, i) {
    hY(r, L, e(n, L, i));
  }), r;
}
const gY = pY, mY = y3;
function vY(t, e) {
  return mY(e, function(r) {
    return [r, t[r]];
  });
}
const yY = vY;
function wY(t) {
  let e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = [n, n];
  }), r;
}
const bY = wY, xY = yY, kY = o2, MY = Nc, _Y = bY, CY = "[object Map]", SY = "[object Set]";
function DY(t) {
  return function(e) {
    const r = kY(e);
    return r == CY ? MY(e) : r == SY ? _Y(e) : xY(e, t(e));
  };
}
const EY = DY, IY = EY, TY = Yn, OY = IY(TY), y4 = OY;
function zY(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
const Kc = zY, PY = Kc, T8 = Math.max;
function AY(t, e, r) {
  return e = T8(e === void 0 ? t.length - 1 : e, 0), function() {
    let n = arguments, L = -1, i = T8(n.length - e, 0), l = Array(i);
    for (; ++L < i; )
      l[L] = n[e + L];
    L = -1;
    const s = Array(e + 1);
    for (; ++L < e; )
      s[L] = n[L];
    return s[e] = r(l), PY(t, this, s);
  };
}
const Jc = AY;
function $Y(t) {
  return function() {
    return t;
  };
}
const ZY = $Y, NY = ZY, O8 = Dc, BY = _3, RY = O8 ? function(t, e) {
  return O8(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: NY(e),
    writable: !0
  });
} : BY, HY = RY, FY = 800, jY = 16, UY = Date.now;
function YY(t) {
  let e = 0, r = 0;
  return function() {
    const n = UY(), L = jY - (n - r);
    if (r = n, L > 0) {
      if (++e >= FY)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
const VY = YY, WY = HY, GY = VY, qY = GY(WY), Qc = qY, KY = _3, JY = Jc, QY = Qc;
function XY(t, e) {
  return QY(JY(t, e, KY), t + "");
}
const C3 = XY, eV = Rn, tV = n2, rV = _o, nV = je;
function oV(t, e, r) {
  if (!nV(r))
    return !1;
  const n = typeof e;
  return (n == "number" ? tV(r) && rV(e, r.length) : n == "string" && e in r) ? eV(r[e], t) : !1;
}
const S3 = oV;
function iV(t) {
  const e = [];
  if (t != null)
    for (const r in Object(t))
      e.push(r);
  return e;
}
const LV = iV, aV = je, sV = x3, lV = LV, uV = Object.prototype, cV = uV.hasOwnProperty;
function hV(t) {
  if (!aV(t))
    return lV(t);
  const e = sV(t), r = [];
  for (const n in t)
    n == "constructor" && (e || !cV.call(t, n)) || r.push(n);
  return r;
}
const dV = hV, fV = Oc, pV = dV, gV = n2;
function mV(t) {
  return gV(t) ? fV(t, !0) : pV(t);
}
const Gn = mV, vV = C3, yV = Rn, wV = S3, bV = Gn, Xc = Object.prototype, xV = Xc.hasOwnProperty, kV = vV(function(t, e) {
  t = Object(t);
  let r = -1, n = e.length;
  const L = n > 2 ? e[2] : void 0;
  for (L && wV(e[0], e[1], L) && (n = 1); ++r < n; ) {
    const i = e[r], l = bV(i);
    let s = -1;
    const c = l.length;
    for (; ++s < c; ) {
      const h = l[s], f = t[h];
      (f === void 0 || yV(f, Xc[h]) && !xV.call(t, h)) && (t[h] = i[h]);
    }
  }
  return t;
}), C0 = kV, MV = Mo, _V = Rn;
function CV(t, e, r) {
  (r !== void 0 && !_V(t[e], r) || r === void 0 && !(e in t)) && MV(t, e, r);
}
const eh = CV, N4 = { exports: {} };
(function(t, e) {
  const r = mt, n = e && !e.nodeType && e, L = n && !0 && t && !t.nodeType && t, i = L && L.exports === n ? r.Buffer : void 0, l = i ? i.allocUnsafe : void 0;
  function s(c, h) {
    if (h)
      return c.slice();
    const f = c.length, g = l ? l(f) : new c.constructor(f);
    return c.copy(g), g;
  }
  t.exports = s;
})(N4, N4.exports);
const z8 = Zc;
function SV(t) {
  const e = new t.constructor(t.byteLength);
  return new z8(e).set(new z8(t)), e;
}
const D3 = SV, DV = D3;
function EV(t, e) {
  const r = e ? DV(t.buffer) : t.buffer;
  return new t.constructor(
    r,
    t.byteOffset,
    t.length
  );
}
const th = EV;
function IV(t, e) {
  let r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
const rh = IV, TV = je, P8 = Object.create, OV = function() {
  function t() {
  }
  return function(e) {
    if (!TV(e))
      return {};
    if (P8)
      return P8(e);
    t.prototype = e;
    const r = new t();
    return t.prototype = void 0, r;
  };
}(), zV = OV, PV = zc, AV = PV(Object.getPrototypeOf, Object), E3 = AV, $V = zV, ZV = E3, NV = x3;
function BV(t) {
  return typeof t.constructor == "function" && !NV(t) ? $V(ZV(t)) : {};
}
const nh = BV, RV = vt, HV = E3, FV = be, jV = "[object Object]", UV = Function.prototype, YV = Object.prototype, oh = UV.toString, VV = YV.hasOwnProperty, WV = oh.call(Object);
function GV(t) {
  if (!FV(t) || RV(t) != jV)
    return !1;
  const e = HV(t);
  if (e === null)
    return !0;
  const r = VV.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && oh.call(r) == WV;
}
const ih = GV;
function qV(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
const Lh = qV, KV = w3, JV = Mo;
function QV(t, e, r, n) {
  const L = !r;
  r || (r = {});
  let i = -1, l = e.length;
  for (; ++i < l; ) {
    const s = e[i];
    let c = n ? n(r[s], t[s], s, r, t) : void 0;
    c === void 0 && (c = t[s]), L ? JV(r, s, c) : KV(r, s, c);
  }
  return r;
}
const qn = QV, XV = qn, eW = Gn;
function tW(t) {
  return XV(t, eW(t));
}
const rW = tW, A8 = eh, nW = N4.exports, oW = th, iW = rh, LW = nh, $8 = Co, Z8 = xe, aW = re, sW = wn.exports, lW = Pt, uW = je, cW = ih, hW = b3, N8 = Lh, dW = rW;
function fW(t, e, r, n, L, i, l) {
  const s = N8(t, r), c = N8(e, r), h = l.get(c);
  if (h) {
    A8(t, r, h);
    return;
  }
  let f = i ? i(s, c, r + "", t, e, l) : void 0, g = f === void 0;
  if (g) {
    const m = Z8(c), b = !m && sW(c), k = !m && !b && hW(c);
    f = c, m || b || k ? Z8(s) ? f = s : aW(s) ? f = iW(s) : b ? (g = !1, f = nW(c, !0)) : k ? (g = !1, f = oW(c, !0)) : f = [] : cW(c) || $8(c) ? (f = s, $8(s) ? f = dW(s) : (!uW(s) || lW(s)) && (f = LW(c))) : g = !1;
  }
  g && (l.set(c, f), L(f, c, n, i, l), l.delete(c)), A8(t, r, f);
}
const pW = fW, gW = So, mW = eh, vW = Ic, yW = pW, wW = je, bW = Gn, xW = Lh;
function ah(t, e, r, n, L) {
  t !== e && vW(
    e,
    function(i, l) {
      if (L || (L = new gW()), wW(i))
        yW(
          t,
          e,
          l,
          r,
          ah,
          n,
          L
        );
      else {
        let s = n ? n(
          xW(t, l),
          i,
          l + "",
          t,
          e,
          L
        ) : void 0;
        s === void 0 && (s = i), mW(t, l, s);
      }
    },
    bW
  );
}
const sh = ah, kW = sh, B8 = je;
function lh(t, e, r, n, L, i) {
  return B8(t) && B8(e) && (i.set(e, t), kW(t, e, void 0, lh, i), i.delete(e)), t;
}
const MW = lh, _W = C3, CW = S3;
function SW(t) {
  return _W(function(e, r) {
    let n = -1, L = r.length, i = L > 1 ? r[L - 1] : void 0, l = L > 2 ? r[2] : void 0;
    for (i = t.length > 3 && typeof i == "function" ? (L--, i) : void 0, l && CW(r[0], r[1], l) && (i = L < 3 ? void 0 : i, L = 1), e = Object(e); ++n < L; ) {
      const s = r[n];
      s && t(e, s, n, i);
    }
    return e;
  });
}
const DW = SW, EW = sh, IW = DW, TW = IW(function(t, e, r, n) {
  EW(t, e, r, n);
}), OW = TW, zW = Kc, PW = C3, AW = MW, $W = OW, ZW = PW(function(t) {
  return t.push(void 0, AW), zW($W, void 0, t);
}), I3 = ZW, NW = ko, BW = Ec, RW = jn;
function HW(t, e, r) {
  let n = -1, L = e.length, i = {};
  for (; ++n < L; ) {
    const l = e[n], s = NW(t, l);
    r(s, l) && BW(i, RW(l, t), s);
  }
  return i;
}
const FW = HW, jW = FW, UW = Gc;
function YW(t, e) {
  return jW(t, e, function(r, n) {
    return UW(t, n);
  });
}
const VW = YW, R8 = Nn, WW = Co, GW = xe, H8 = R8 ? R8.isConcatSpreadable : void 0;
function qW(t) {
  return GW(t) || WW(t) || !!(H8 && t && t[H8]);
}
const KW = qW, JW = k3, QW = KW;
function uh(t, e, r, n, L) {
  let i = -1, l = t.length;
  for (r || (r = QW), L || (L = []); ++i < l; ) {
    const s = t[i];
    e > 0 && r(s) ? e > 1 ? uh(s, e - 1, r, n, L) : JW(L, s) : n || (L[L.length] = s);
  }
  return L;
}
const XW = uh, eG = XW;
function tG(t) {
  return t != null && t.length ? eG(t, 1) : [];
}
const rG = tG, nG = rG, oG = Jc, iG = Qc;
function LG(t) {
  return iG(oG(t, void 0, nG), t + "");
}
const ch = LG, aG = VW, sG = ch, lG = sG(function(t, e) {
  return t == null ? {} : aG(t, e);
}), uG = lG;
function cG(t, e) {
  let r = -1, n = t == null ? 0 : t.length;
  for (; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
const hG = cG, dG = qn, fG = Yn;
function pG(t, e) {
  return t && dG(e, fG(e), t);
}
const gG = pG, mG = qn, vG = Gn;
function yG(t, e) {
  return t && mG(e, vG(e), t);
}
const wG = yG, bG = qn, xG = M3;
function kG(t, e) {
  return bG(t, xG(t), e);
}
const MG = kG, _G = k3, CG = E3, SG = M3, DG = Rc, EG = Object.getOwnPropertySymbols, IG = EG ? function(t) {
  const e = [];
  for (; t; )
    _G(e, SG(t)), t = CG(t);
  return e;
} : DG, hh = IG, TG = qn, OG = hh;
function zG(t, e) {
  return TG(t, OG(t), e);
}
const PG = zG, AG = Bc, $G = hh, ZG = Gn;
function NG(t) {
  return AG(t, ZG, $G);
}
const dh = NG, BG = Object.prototype, RG = BG.hasOwnProperty;
function HG(t) {
  const e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && RG.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
const FG = HG, jG = D3;
function UG(t, e) {
  const r = e ? jG(t.buffer) : t.buffer;
  return new t.constructor(
    r,
    t.byteOffset,
    t.byteLength
  );
}
const YG = UG, VG = /\w*$/;
function WG(t) {
  const e = new t.constructor(t.source, VG.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
const GG = WG, F8 = Nn, j8 = F8 ? F8.prototype : void 0, U8 = j8 ? j8.valueOf : void 0;
function qG(t) {
  return U8 ? Object(U8.call(t)) : {};
}
const KG = qG, JG = D3, QG = YG, XG = GG, eq = KG, tq = th, rq = "[object Boolean]", nq = "[object Date]", oq = "[object Map]", iq = "[object Number]", Lq = "[object RegExp]", aq = "[object Set]", sq = "[object String]", lq = "[object Symbol]", uq = "[object ArrayBuffer]", cq = "[object DataView]", hq = "[object Float32Array]", dq = "[object Float64Array]", fq = "[object Int8Array]", pq = "[object Int16Array]", gq = "[object Int32Array]", mq = "[object Uint8Array]", vq = "[object Uint8ClampedArray]", yq = "[object Uint16Array]", wq = "[object Uint32Array]";
function bq(t, e, r) {
  const n = t.constructor;
  switch (e) {
    case uq:
      return JG(t);
    case rq:
    case nq:
      return new n(+t);
    case cq:
      return QG(t, r);
    case hq:
    case dq:
    case fq:
    case pq:
    case gq:
    case mq:
    case vq:
    case yq:
    case wq:
      return tq(t, r);
    case oq:
      return new n();
    case iq:
    case sq:
      return new n(t);
    case Lq:
      return XG(t);
    case aq:
      return new n();
    case lq:
      return eq(t);
  }
}
const xq = bq, kq = o2, Mq = be, _q = "[object Map]";
function Cq(t) {
  return Mq(t) && kq(t) == _q;
}
const Sq = Cq, Dq = Sq, Eq = mo, Y8 = yn.exports, V8 = Y8 && Y8.isMap, Iq = V8 ? Eq(V8) : Dq, Tq = Iq, Oq = o2, zq = be, Pq = "[object Set]";
function Aq(t) {
  return zq(t) && Oq(t) == Pq;
}
const $q = Aq, Zq = $q, Nq = mo, W8 = yn.exports, G8 = W8 && W8.isSet, Bq = G8 ? Nq(G8) : Zq, Rq = Bq, Hq = So, Fq = hG, jq = w3, Uq = gG, Yq = wG, Vq = N4.exports, Wq = rh, Gq = MG, qq = PG, Kq = Hc, Jq = dh, Qq = o2, Xq = FG, eK = xq, tK = nh, rK = xe, nK = wn.exports, oK = Tq, iK = je, LK = Rq, aK = Yn, sK = Gn, lK = 1, uK = 2, cK = 4, fh = "[object Arguments]", hK = "[object Array]", dK = "[object Boolean]", fK = "[object Date]", pK = "[object Error]", ph = "[object Function]", gK = "[object GeneratorFunction]", mK = "[object Map]", vK = "[object Number]", gh = "[object Object]", yK = "[object RegExp]", wK = "[object Set]", bK = "[object String]", xK = "[object Symbol]", kK = "[object WeakMap]", MK = "[object ArrayBuffer]", _K = "[object DataView]", CK = "[object Float32Array]", SK = "[object Float64Array]", DK = "[object Int8Array]", EK = "[object Int16Array]", IK = "[object Int32Array]", TK = "[object Uint8Array]", OK = "[object Uint8ClampedArray]", zK = "[object Uint16Array]", PK = "[object Uint32Array]", i1 = {};
i1[fh] = i1[hK] = i1[MK] = i1[_K] = i1[dK] = i1[fK] = i1[CK] = i1[SK] = i1[DK] = i1[EK] = i1[IK] = i1[mK] = i1[vK] = i1[gh] = i1[yK] = i1[wK] = i1[bK] = i1[xK] = i1[TK] = i1[OK] = i1[zK] = i1[PK] = !0;
i1[pK] = i1[ph] = i1[kK] = !1;
function w4(t, e, r, n, L, i) {
  let l, s = e & lK, c = e & uK, h = e & cK;
  if (r && (l = L ? r(t, n, L, i) : r(t)), l !== void 0)
    return l;
  if (!iK(t))
    return t;
  const f = rK(t);
  if (f) {
    if (l = Xq(t), !s)
      return Wq(t, l);
  } else {
    const b = Qq(t), k = b == ph || b == gK;
    if (nK(t))
      return Vq(t, s);
    if (b == gh || b == fh || k && !L) {
      if (l = c || k ? {} : tK(t), !s)
        return c ? qq(t, Yq(l, t)) : Gq(t, Uq(l, t));
    } else {
      if (!i1[b])
        return L ? t : {};
      l = eK(t, b, s);
    }
  }
  i || (i = new Hq());
  const g = i.get(t);
  if (g)
    return g;
  i.set(t, l), LK(t) ? t.forEach(function(b) {
    l.add(
      w4(b, e, r, b, t, i)
    );
  }) : oK(t) && t.forEach(function(b, k) {
    l.set(
      k,
      w4(b, e, r, k, t, i)
    );
  });
  const m = f ? void 0 : (h ? c ? Jq : Kq : c ? sK : aK)(t);
  return Fq(m || t, function(b, k) {
    m && (k = b, b = t[k]), jq(
      l,
      k,
      w4(b, e, r, k, t, i)
    );
  }), l;
}
const AK = w4;
function $K(t) {
  const e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
const H0 = $K;
function ZK(t, e, r) {
  let n = -1, L = t.length;
  e < 0 && (e = -e > L ? 0 : L + e), r = r > L ? L : r, r < 0 && (r += L), L = e > r ? 0 : r - e >>> 0, e >>>= 0;
  const i = Array(L);
  for (; ++n < L; )
    i[n] = t[n + e];
  return i;
}
const NK = ZK, BK = ko, RK = NK;
function HK(t, e) {
  return e.length < 2 ? t : BK(t, RK(e, 0, -1));
}
const FK = HK, jK = jn, UK = H0, YK = FK, VK = Un;
function WK(t, e) {
  return e = jK(e, t), t = YK(t, e), t == null || delete t[VK(UK(e))];
}
const GK = WK, qK = ih;
function KK(t) {
  return qK(t) ? void 0 : t;
}
const JK = KK, QK = y3, XK = AK, eJ = GK, tJ = jn, rJ = qn, nJ = JK, oJ = ch, iJ = dh, LJ = 1, aJ = 2, sJ = 4, lJ = oJ(function(t, e) {
  let r = {};
  if (t == null)
    return r;
  let n = !1;
  e = QK(e, function(i) {
    return i = tJ(i, t), n || (n = i.length > 1), i;
  }), rJ(t, iJ(t), r), n && (r = XK(
    r,
    LJ | aJ | sJ,
    nJ
  ));
  let L = e.length;
  for (; L--; )
    eJ(r, e[L]);
  return r;
}), hL = lJ, uJ = Object.prototype, cJ = uJ.hasOwnProperty;
function hJ(t, e) {
  return t != null && cJ.call(t, e);
}
const dJ = hJ, fJ = dJ, pJ = Wc;
function gJ(t, e) {
  return t != null && pJ(t, e, fJ);
}
const mh = gJ, mJ = n2;
function vJ(t, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!mJ(r))
      return t(r, n);
    let L = r.length, i = e ? L : -1, l = Object(r);
    for (; (e ? i-- : ++i < L) && n(l[i], i, l) !== !1; )
      ;
    return r;
  };
}
const yJ = vJ, wJ = Pc, bJ = yJ, xJ = bJ(wJ), kJ = xJ;
function MJ(t) {
  return t && t.length ? t[0] : void 0;
}
const vh = MJ, _J = kJ;
function CJ(t, e) {
  let r;
  return _J(t, function(n, L, i) {
    return r = e(n, L, i), !r;
  }), !!r;
}
const SJ = CJ, DJ = Ac, EJ = qc, IJ = SJ, TJ = xe, OJ = S3;
function zJ(t, e, r) {
  const n = TJ(t) ? DJ : IJ;
  return r && OJ(t, e, r) && (e = void 0), n(t, EJ(e));
}
const yh = zJ, PJ = (t) => Object.prototype.toString.call(t).slice(8, -1), ir = (t) => dZ(t) && !isNaN(t.getTime()), Ae = (t) => PJ(t) === "Object", T3 = mh, dL = (t, e) => yh(e, (r) => mh(t, r)), AJ = yh, W5 = (t, e, r = "0") => {
  for (t = t != null ? String(t) : "", e = e || 2; t.length < e; )
    t = `${r}${t}`;
  return t;
}, $J = (...t) => {
  const e = {};
  return t.forEach(
    (r) => Object.entries(r).forEach(([n, L]) => {
      e[n] ? re(e[n]) ? e[n].push(L) : e[n] = [e[n], L] : e[n] = L;
    })
  ), e;
}, pe = (t) => !!(t && t.month && t.year), w0 = (t, e) => !pe(t) || !pe(e) ? !1 : t.year === e.year ? t.month < e.month : t.year < e.year, S0 = (t, e) => !pe(t) || !pe(e) ? !1 : t.year === e.year ? t.month > e.month : t.year > e.year, wh = (t, e, r) => (t || !1) && !w0(t, e) && !S0(t, r), Ci = (t, e) => !t && e || t && !e ? !1 : !t && !e ? !0 : t.month === e.month && t.year === e.year, Tt = ({ month: t, year: e }, r) => {
  const n = r > 0 ? 1 : -1;
  for (let L = 0; L < Math.abs(r); L++)
    t += n, t > 12 ? (t = 1, e++) : t < 1 && (t = 12, e--);
  return {
    month: t,
    year: e
  };
}, ZJ = (t, e) => {
  if (!pe(t) || !pe(e))
    return [];
  const r = [];
  for (; !S0(t, e); )
    r.push(t), t = Tt(t, 1);
  return r;
};
function Si(t, e) {
  const r = ir(t), n = ir(e);
  return !r && !n ? !0 : r !== n ? !1 : t.getTime() === e.getTime();
}
const Pe = (t) => re(t) && t.length > 0, q8 = (t, e, r) => {
  const n = [];
  return r.forEach((L) => {
    const i = L.name || L.toString(), l = L.mixin, s = L.validate;
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      const c = s ? s(t[i]) : t[i];
      e[i] = l && Ae(c) ? c5(c5({}, l), c) : c, n.push(i);
    }
  }), {
    target: e,
    assigned: n.length ? n : null
  };
}, q1 = (t, e, r, n) => {
  t && e && r && t.addEventListener(e, r, n);
}, K1 = (t, e, r, n) => {
  t && e && t.removeEventListener(e, r, n);
}, D0 = (t, e) => !!t && !!e && (t === e || t.contains(e)), bh = (t, e) => {
  (t.key === " " || t.key === "Enter") && (e(t), t.preventDefault());
}, B4 = () => {
  function t() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  }
  return `${t() + t()}-${t()}-${t()}-${t()}-${t()}${t()}${t()}`;
};
function NJ(t) {
  let e = 0, r = 0, n;
  if (t.length === 0)
    return e;
  for (r = 0; r < t.length; r++)
    n = t.charCodeAt(r), e = (e << 5) - e + n, e |= 0;
  return e;
}
const Kn = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [n, L] of e)
    r[n] = L;
  return r;
}, BJ = {
  name: "CustomTransition",
  emits: [
    "before-enter",
    "before-transition",
    "after-enter",
    "after-transition"
  ],
  props: {
    name: String,
    appear: Boolean
  },
  computed: {
    name_() {
      return `vc-${this.name || "none"}`;
    }
  },
  methods: {
    beforeEnter(t) {
      this.$emit("before-enter", t), this.$emit("before-transition", t);
    },
    afterEnter(t) {
      this.$emit("after-enter", t), this.$emit("after-transition", t);
    }
  }
};
function RJ(t, e, r, n, L, i) {
  return G(), sr(
    DL,
    {
      name: i.name_,
      appear: r.appear,
      onBeforeEnter: i.beforeEnter,
      onAfterEnter: i.afterEnter
    },
    {
      default: Je(() => [d1(t.$slots, "default")]),
      _: 3
    },
    8,
    ["name", "appear", "onBeforeEnter", "onAfterEnter"]
  );
}
const xh = /* @__PURE__ */ Kn(BJ, [
  ["render", RJ]
]), fL = {
  name: "Popover",
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  render() {
    return C5(
      "div",
      {
        class: [
          "vc-popover-content-wrapper",
          {
            "is-interactive": this.isInteractive
          }
        ],
        ref: "popover"
      },
      [
        C5(
          xh,
          {
            name: this.transition,
            appear: !0,
            "on-before-enter": this.beforeEnter,
            "on-after-enter": this.afterEnter,
            "on-before-leave": this.beforeLeave,
            "on-after-leave": this.afterLeave
          },
          {
            default: () => this.isVisible ? C5(
              "div",
              {
                tabindex: -1,
                class: [
                  "vc-popover-content",
                  `direction-${this.direction}`,
                  this.contentClass
                ],
                style: this.contentStyle
              },
              [
                this.content,
                C5("span", {
                  class: [
                    "vc-popover-caret",
                    `direction-${this.direction}`,
                    `align-${this.alignment}`
                  ]
                })
              ]
            ) : null
          }
        )
      ]
    );
  },
  props: {
    id: { type: String, required: !0 },
    contentClass: String
  },
  data() {
    return {
      ref: null,
      opts: null,
      data: null,
      transition: "slide-fade",
      transitionTranslate: "15px",
      transitionDuration: "0.15s",
      placement: "bottom",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !1,
      isHovered: !1,
      isFocused: !1,
      showDelay: 0,
      hideDelay: 110,
      autoHide: !1,
      popperEl: null
    };
  },
  computed: {
    content() {
      return Pt(this.$slots.default) && this.$slots.default({
        direction: this.direction,
        alignment: this.alignment,
        data: this.data,
        updateLayout: this.setupPopper,
        hide: (t) => this.hide(t)
      }) || this.$slots.default;
    },
    contentStyle() {
      return {
        "--slide-translate": this.transitionTranslate,
        "--slide-duration": this.transitionDuration
      };
    },
    popperOptions() {
      return {
        placement: this.placement,
        strategy: this.positionFixed ? "fixed" : "absolute",
        modifiers: [
          {
            name: "onUpdate",
            enabled: !0,
            phase: "afterWrite",
            fn: this.onPopperUpdate
          },
          ...this.modifiers || []
        ],
        onFirstUpdate: this.onPopperUpdate
      };
    },
    isVisible() {
      return !!(this.ref && this.content);
    },
    direction() {
      return this.placement && this.placement.split("-")[0] || "bottom";
    },
    alignment() {
      const t = this.direction === "left" || this.direction === "right";
      let e = this.placement.split("-");
      return e = e.length > 1 ? e[1] : "", ["start", "top", "left"].includes(e) ? t ? "top" : "left" : ["end", "bottom", "right"].includes(e) ? t ? "bottom" : "right" : t ? "middle" : "center";
    }
  },
  watch: {
    opts(t, e) {
      e && e.callback && e.callback(
        V5(c5({}, e), {
          completed: !t,
          reason: t ? "Overridden by action" : null
        })
      );
    }
  },
  mounted() {
    this.popoverEl = this.$refs.popover, this.addEvents();
  },
  beforeUnmount() {
    this.destroyPopper(), this.removeEvents(), this.popoverEl = null;
  },
  methods: {
    addEvents() {
      q1(this.popoverEl, "click", this.onClick), q1(this.popoverEl, "mouseover", this.onMouseOver), q1(this.popoverEl, "mouseleave", this.onMouseLeave), q1(this.popoverEl, "focusin", this.onFocusIn), q1(this.popoverEl, "focusout", this.onFocusOut), q1(document, "keydown", this.onDocumentKeydown), q1(document, "click", this.onDocumentClick), q1(document, "show-popover", this.onDocumentShowPopover), q1(document, "hide-popover", this.onDocumentHidePopover), q1(document, "toggle-popover", this.onDocumentTogglePopover), q1(document, "update-popover", this.onDocumentUpdatePopover);
    },
    removeEvents() {
      K1(this.popoverEl, "click", this.onClick), K1(this.popoverEl, "mouseover", this.onMouseOver), K1(this.popoverEl, "mouseleave", this.onMouseLeave), K1(this.popoverEl, "focusin", this.onFocusIn), K1(this.popoverEl, "focusout", this.onFocusOut), K1(document, "keydown", this.onDocumentKeydown), K1(document, "click", this.onDocumentClick), K1(document, "show-popover", this.onDocumentShowPopover), K1(document, "hide-popover", this.onDocumentHidePopover), K1(document, "toggle-popover", this.onDocumentTogglePopover), K1(document, "update-popover", this.onDocumentUpdatePopover);
    },
    onClick(t) {
      t.stopPropagation();
    },
    onMouseOver() {
      this.isHovered = !0, this.isInteractive && this.show();
    },
    onMouseLeave() {
      this.isHovered = !1, this.autoHide && !this.isFocused && (!this.ref || this.ref !== document.activeElement) && this.hide();
    },
    onFocusIn() {
      this.isFocused = !0, this.isInteractive && this.show();
    },
    onFocusOut(t) {
      (!t.relatedTarget || !D0(this.popoverEl, t.relatedTarget)) && (this.isFocused = !1, !this.isHovered && this.autoHide && this.hide());
    },
    onDocumentClick(t) {
      !this.$refs.popover || !this.ref || D0(this.popoverEl, t.target) || D0(this.ref, t.target) || this.hide();
    },
    onDocumentKeydown(t) {
      (t.key === "Esc" || t.key === "Escape") && this.hide();
    },
    onDocumentShowPopover({ detail: t }) {
      !t.id || t.id !== this.id || this.show(t);
    },
    onDocumentHidePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.hide(t);
    },
    onDocumentTogglePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.toggle(t);
    },
    onDocumentUpdatePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.update(t);
    },
    show(t = {}) {
      t.action = "show";
      const e = t.ref || this.ref, r = t.showDelay >= 0 ? t.showDelay : this.showDelay;
      if (!e) {
        t.callback && t.callback({
          completed: !1,
          reason: "Invalid reference element provided"
        });
        return;
      }
      clearTimeout(this.timeout), this.opts = t;
      const n = () => {
        Object.assign(this, hL(t, ["id"])), this.setupPopper(), this.opts = null;
      };
      r > 0 ? this.timeout = setTimeout(() => n(), r) : n();
    },
    hide(t = {}) {
      t.action = "hide";
      const e = t.ref || this.ref, r = t.hideDelay >= 0 ? t.hideDelay : this.hideDelay;
      if (!this.ref || e !== this.ref) {
        t.callback && t.callback(
          V5(c5({}, t), {
            completed: !1,
            reason: this.ref ? "Invalid reference element provided" : "Popover already hidden"
          })
        );
        return;
      }
      const n = () => {
        this.ref = null, this.opts = null;
      };
      clearTimeout(this.timeout), this.opts = t, r > 0 ? this.timeout = setTimeout(n, r) : n();
    },
    toggle(t = {}) {
      this.isVisible && t.ref === this.ref ? this.hide(t) : this.show(t);
    },
    update(t = {}) {
      Object.assign(this, hL(t, ["id"])), this.setupPopper();
    },
    setupPopper() {
      this.$nextTick(() => {
        !this.ref || !this.$refs.popover || (this.popper && this.popper.reference !== this.ref && this.destroyPopper(), this.popper ? this.popper.update() : this.popper = e$(
          this.ref,
          this.popoverEl,
          this.popperOptions
        ));
      });
    },
    onPopperUpdate(t) {
      t.placement ? this.placement = t.placement : t.state && (this.placement = t.state.placement);
    },
    beforeEnter(t) {
      this.$emit("before-show", t);
    },
    afterEnter(t) {
      this.$emit("after-show", t);
    },
    beforeLeave(t) {
      this.$emit("before-hide", t);
    },
    afterLeave(t) {
      this.destroyPopper(), this.$emit("after-hide", t);
    },
    destroyPopper() {
      this.popper && (this.popper.destroy(), this.popper = null);
    }
  }
}, HJ = {
  inject: ["sharedState"],
  computed: {
    masks() {
      return this.sharedState.masks;
    },
    theme() {
      return this.sharedState.theme;
    },
    locale() {
      return this.sharedState.locale;
    },
    dayPopoverId() {
      return this.sharedState.dayPopoverId;
    }
  },
  methods: {
    format(t, e) {
      return this.locale.format(t, e);
    },
    pageForDate(t) {
      return this.locale.getDateParts(this.locale.normalizeDate(t));
    }
  }
}, FJ = ["base", "start", "end", "startEnd"], jJ = [
  "class",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], UJ = {
  color: "blue",
  isDark: !1,
  highlight: {
    base: { fillMode: "light" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  dot: {
    base: { fillMode: "solid" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  bar: {
    base: { fillMode: "solid" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  content: {
    base: {},
    start: {},
    end: {}
  }
};
class K8 {
  constructor(e) {
    Object.assign(this, UJ, e);
  }
  normalizeAttr({ config: e, type: r }) {
    let n = this.color, L = {};
    const i = this[r];
    if (e === !0 || nr(e))
      n = nr(e) ? e : n, L = c5({}, i);
    else if (Ae(e))
      dL(e, FJ) ? L = c5({}, e) : L = {
        base: c5({}, e),
        start: c5({}, e),
        end: c5({}, e)
      };
    else
      return null;
    return C0(L, { start: L.startEnd, end: L.startEnd }, i), y4(L).forEach(([l, s]) => {
      let c = n;
      s === !0 || nr(s) ? (c = nr(s) ? s : c, L[l] = { color: c }) : Ae(s) && (dL(s, jJ) ? L[l] = c5({}, s) : L[l] = {}), T3(L, `${l}.color`) || IR(L, `${l}.color`, c);
    }), L;
  }
  normalizeHighlight(e) {
    const r = this.normalizeAttr({
      config: e,
      type: "highlight"
    });
    return y4(r).forEach(([n, L]) => {
      const i = C0(L, {
        isDark: this.isDark,
        color: this.color
      });
      L.style = c5(
        c5({}, this.getHighlightBgStyle(i)),
        L.style
      ), L.contentStyle = c5(
        c5({}, this.getHighlightContentStyle(i)),
        L.contentStyle
      );
    }), r;
  }
  getHighlightBgStyle({ fillMode: e, color: r, isDark: n }) {
    switch (e) {
      case "outline":
      case "none":
        return {
          backgroundColor: n ? "var(--gray-900)" : "var(--white)",
          border: "2px solid",
          borderColor: n ? `var(--${r}-200)` : `var(--${r}-700)`,
          borderRadius: "var(--rounded-full)"
        };
      case "light":
        return {
          backgroundColor: n ? `var(--${r}-800)` : `var(--${r}-200)`,
          opacity: n ? 0.75 : 1,
          borderRadius: "var(--rounded-full)"
        };
      case "solid":
        return {
          backgroundColor: n ? `var(--${r}-500)` : `var(--${r}-600)`,
          borderRadius: "var(--rounded-full)"
        };
      default:
        return {
          borderRadius: "var(--rounded-full)"
        };
    }
  }
  getHighlightContentStyle({ fillMode: e, color: r, isDark: n }) {
    switch (e) {
      case "outline":
      case "none":
        return {
          fontWeight: "var(--font-bold)",
          color: n ? `var(--${r}-100)` : `var(--${r}-900)`
        };
      case "light":
        return {
          fontWeight: "var(--font-bold)",
          color: n ? `var(--${r}-100)` : `var(--${r}-900)`
        };
      case "solid":
        return {
          fontWeight: "var(--font-bold)",
          color: "var(--white)"
        };
      default:
        return "";
    }
  }
  bgAccentHigh({ color: e, isDark: r }) {
    return {
      backgroundColor: r ? `var(--${e}-500)` : `var(--${e}-600)`
    };
  }
  contentAccent({ color: e, isDark: r }) {
    return e ? {
      fontWeight: "var(--font-bold)",
      color: r ? `var(--${e}-100)` : `var(--${e}-900)`
    } : null;
  }
  normalizeDot(e) {
    return this.normalizeNonHighlight("dot", e, this.bgAccentHigh);
  }
  normalizeBar(e) {
    return this.normalizeNonHighlight("bar", e, this.bgAccentHigh);
  }
  normalizeContent(e) {
    return this.normalizeNonHighlight("content", e, this.contentAccent);
  }
  normalizeNonHighlight(e, r, n) {
    const L = this.normalizeAttr({ type: e, config: r });
    return y4(L).forEach(([i, l]) => {
      C0(l, { isDark: this.isDark, color: this.color }), l.style = c5(
        c5({}, n(l)),
        l.style
      );
    }), L;
  }
}
const b4 = 6e4;
function J8(t) {
  return t.getTime() % b4;
}
function R4(t) {
  const e = new Date(t.getTime()), r = Math.ceil(e.getTimezoneOffset());
  e.setSeconds(0, 0);
  const n = r > 0 ? (b4 + J8(e)) % b4 : J8(e);
  return r * b4 + n;
}
function YJ(t, e) {
  const r = qJ(e);
  return r.formatToParts ? WJ(r, t) : GJ(r, t);
}
const VJ = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function WJ(t, e) {
  const r = t.formatToParts(e), n = [];
  for (let L = 0; L < r.length; L++) {
    const i = VJ[r[L].type];
    i >= 0 && (n[i] = parseInt(r[L].value, 10));
  }
  return n;
}
function GJ(t, e) {
  const r = t.format(e).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
const Di = {};
function qJ(t) {
  if (!Di[t]) {
    const e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Di[t] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Di[t];
}
const Q8 = 36e5, KJ = 6e4, o4 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
  timezoneIANA: /(UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
function X8(t, e) {
  let r, n;
  if (r = o4.timezoneZ.exec(t), r)
    return 0;
  let L;
  if (r = o4.timezoneHH.exec(t), r)
    return L = parseInt(r[2], 10), el() ? (n = L * Q8, r[1] === "+" ? -n : n) : NaN;
  if (r = o4.timezoneHHMM.exec(t), r) {
    L = parseInt(r[2], 10);
    const i = parseInt(r[3], 10);
    return el(L, i) ? (n = L * Q8 + i * KJ, r[1] === "+" ? -n : n) : NaN;
  }
  if (r = o4.timezoneIANA.exec(t), r) {
    const i = YJ(e, t), l = Date.UTC(
      i[0],
      i[1] - 1,
      i[2],
      i[3],
      i[4],
      i[5]
    ), s = e.getTime() - e.getTime() % 1e3;
    return -(l - s);
  }
  return 0;
}
function el(t, e) {
  return !(e != null && (e < 0 || e > 59));
}
const Ei = 36e5, tl = 6e4, JJ = 2, Z1 = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  timezone: /([Z+-].*| UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
function rl(t, e) {
  if (arguments.length < 1)
    throw new TypeError(
      "1 argument required, but only " + arguments.length + " present"
    );
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = e || {}, n = r.additionalDigits == null ? JJ : ft(r.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  const L = QJ(t), i = XJ(L.date, n), l = i.year, s = i.restDateString, c = eQ(s, l);
  if (isNaN(c))
    return /* @__PURE__ */ new Date(NaN);
  if (c) {
    const h = c.getTime();
    let f = 0, g;
    if (L.time && (f = tQ(L.time), isNaN(f)))
      return /* @__PURE__ */ new Date(NaN);
    if (L.timezone || r.timeZone) {
      if (g = X8(
        L.timezone || r.timeZone,
        new Date(h + f)
      ), isNaN(g))
        return /* @__PURE__ */ new Date(NaN);
      if (g = X8(
        L.timezone || r.timeZone,
        new Date(h + f + g)
      ), isNaN(g))
        return /* @__PURE__ */ new Date(NaN);
    } else
      g = R4(new Date(h + f)), g = R4(
        new Date(h + f + g)
      );
    return new Date(h + f + g);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function QJ(t) {
  const e = {}, r = t.split(Z1.dateTimeDelimeter);
  let n;
  if (Z1.plainTime.test(r[0]) ? (e.date = null, n = r[0]) : (e.date = r[0], n = r[1], e.timezone = r[2], Z1.timeZoneDelimeter.test(e.date) && (e.date = t.split(Z1.timeZoneDelimeter)[0], n = t.substr(e.date.length, t.length))), n) {
    const L = Z1.timezone.exec(n);
    L ? (e.time = n.replace(L[1], ""), e.timezone = L[1]) : e.time = n;
  }
  return e;
}
function XJ(t, e) {
  const r = Z1.YYY[e], n = Z1.YYYYY[e];
  let L;
  if (L = Z1.YYYY.exec(t) || n.exec(t), L) {
    const i = L[1];
    return {
      year: parseInt(i, 10),
      restDateString: t.slice(i.length)
    };
  }
  if (L = Z1.YY.exec(t) || r.exec(t), L) {
    const i = L[1];
    return {
      year: parseInt(i, 10) * 100,
      restDateString: t.slice(i.length)
    };
  }
  return {
    year: null
  };
}
function eQ(t, e) {
  if (e === null)
    return null;
  let r, n, L, i;
  if (t.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(e), n;
  if (r = Z1.MM.exec(t), r)
    return n = /* @__PURE__ */ new Date(0), L = parseInt(r[1], 10) - 1, ol(e, L) ? (n.setUTCFullYear(e, L), n) : /* @__PURE__ */ new Date(NaN);
  if (r = Z1.DDD.exec(t), r) {
    n = /* @__PURE__ */ new Date(0);
    const l = parseInt(r[1], 10);
    return oQ(e, l) ? (n.setUTCFullYear(e, 0, l), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Z1.MMDD.exec(t), r) {
    n = /* @__PURE__ */ new Date(0), L = parseInt(r[1], 10) - 1;
    const l = parseInt(r[2], 10);
    return ol(e, L, l) ? (n.setUTCFullYear(e, L, l), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Z1.Www.exec(t), r)
    return i = parseInt(r[1], 10) - 1, il(e, i) ? nl(e, i) : /* @__PURE__ */ new Date(NaN);
  if (r = Z1.WwwD.exec(t), r) {
    i = parseInt(r[1], 10) - 1;
    const l = parseInt(r[2], 10) - 1;
    return il(e, i, l) ? nl(e, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function tQ(t) {
  let e, r, n;
  if (e = Z1.HH.exec(t), e)
    return r = parseFloat(e[1].replace(",", ".")), Ii(r) ? r % 24 * Ei : NaN;
  if (e = Z1.HHMM.exec(t), e)
    return r = parseInt(e[1], 10), n = parseFloat(e[2].replace(",", ".")), Ii(r, n) ? r % 24 * Ei + n * tl : NaN;
  if (e = Z1.HHMMSS.exec(t), e) {
    r = parseInt(e[1], 10), n = parseInt(e[2], 10);
    const L = parseFloat(e[3].replace(",", "."));
    return Ii(r, n, L) ? r % 24 * Ei + n * tl + L * 1e3 : NaN;
  }
  return null;
}
function nl(t, e, r) {
  e = e || 0, r = r || 0;
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4);
  const L = n.getUTCDay() || 7, i = e * 7 + r + 1 - L;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
const rQ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], nQ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function kh(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function ol(t, e, r) {
  if (e < 0 || e > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    const n = kh(t);
    if (n && r > nQ[e] || !n && r > rQ[e])
      return !1;
  }
  return !0;
}
function oQ(t, e) {
  if (e < 1)
    return !1;
  const r = kh(t);
  return !(r && e > 366 || !r && e > 365);
}
function il(t, e, r) {
  return !(e < 0 || e > 52 || r != null && (r < 0 || r > 6));
}
function Ii(t, e, r) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || r != null && (r < 0 || r >= 60));
}
function Tr(t, e) {
  F1(1, arguments);
  const r = e || {}, n = r.locale, L = n && n.options && n.options.weekStartsOn, i = L == null ? 0 : ft(L), l = r.weekStartsOn == null ? i : ft(r.weekStartsOn);
  if (!(l >= 0 && l <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  const s = Nt(t), c = s.getDay(), h = (c < l ? 7 : 0) + c - l;
  return s.setDate(s.getDate() - h), s.setHours(0, 0, 0, 0), s;
}
function H4(t) {
  return F1(1, arguments), Tr(t, {
    weekStartsOn: 1
  });
}
function iQ(t) {
  F1(1, arguments);
  const e = Nt(t), r = e.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const L = H4(n), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const l = H4(i);
  return e.getTime() >= L.getTime() ? r + 1 : e.getTime() >= l.getTime() ? r : r - 1;
}
function LQ(t) {
  F1(1, arguments);
  const e = iQ(t), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), H4(r);
}
const aQ = 6048e5;
function sQ(t) {
  F1(1, arguments);
  const e = Nt(t), r = H4(e).getTime() - LQ(e).getTime();
  return Math.round(r / aQ) + 1;
}
function lQ(t, e) {
  F1(1, arguments);
  const r = Nt(t), n = r.getFullYear(), L = e || {}, i = L.locale, l = i && i.options && i.options.firstWeekContainsDate, s = l == null ? 1 : ft(l), c = L.firstWeekContainsDate == null ? s : ft(L.firstWeekContainsDate);
  if (!(c >= 1 && c <= 7))
    throw new RangeError(
      "firstWeekContainsDate must be between 1 and 7 inclusively"
    );
  const h = /* @__PURE__ */ new Date(0);
  h.setFullYear(n + 1, 0, c), h.setHours(0, 0, 0, 0);
  const f = Tr(h, e), g = /* @__PURE__ */ new Date(0);
  g.setFullYear(n, 0, c), g.setHours(0, 0, 0, 0);
  const m = Tr(g, e);
  return r.getTime() >= f.getTime() ? n + 1 : r.getTime() >= m.getTime() ? n : n - 1;
}
function uQ(t, e) {
  F1(1, arguments);
  const r = e || {}, n = r.locale, L = n && n.options && n.options.firstWeekContainsDate, i = L == null ? 1 : ft(L), l = r.firstWeekContainsDate == null ? i : ft(r.firstWeekContainsDate), s = lQ(t, e), c = /* @__PURE__ */ new Date(0);
  return c.setFullYear(s, 0, l), c.setHours(0, 0, 0, 0), Tr(c, e);
}
const cQ = 6048e5;
function hQ(t, e) {
  F1(1, arguments);
  const r = Nt(t), n = Tr(r, e).getTime() - uQ(r, e).getTime();
  return Math.round(n / cQ) + 1;
}
const dQ = 6048e5;
function fQ(t, e, r) {
  F1(2, arguments);
  const n = Tr(t, r), L = Tr(e, r), i = n.getTime() - R4(n), l = L.getTime() - R4(L);
  return Math.round((i - l) / dQ);
}
function pQ(t) {
  F1(1, arguments);
  const e = Nt(t), r = e.getMonth();
  return e.setFullYear(e.getFullYear(), r + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function gQ(t) {
  F1(1, arguments);
  const e = Nt(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function mQ(t, e) {
  return F1(1, arguments), fQ(
    pQ(t),
    gQ(t),
    e
  ) + 1;
}
const vQ = 24 * 60 * 60 * 1e3;
class k1 {
  constructor(e, { order: r = 0, locale: n, isFullDay: L } = {}) {
    if (this.isDateInfo = !0, this.order = r, this.locale = n instanceof F4 ? n : new F4(n), this.firstDayOfWeek = this.locale.firstDayOfWeek, !Ae(e)) {
      const c = this.locale.normalizeDate(e);
      L ? e = {
        start: c,
        end: c
      } : e = {
        startOn: c,
        endOn: c
      };
    }
    let i = null, l = null;
    if (e.start ? i = this.locale.normalizeDate(
      e.start,
      V5(c5({}, this.opts), {
        time: "00:00:00"
      })
    ) : e.startOn && (i = this.locale.normalizeDate(e.startOn, this.opts)), e.end ? l = this.locale.normalizeDate(
      e.end,
      V5(c5({}, this.opts), {
        time: "23:59:59"
      })
    ) : e.endOn && (l = this.locale.normalizeDate(e.endOn, this.opts)), i && l && i > l) {
      const c = i;
      i = l, l = c;
    } else
      i && e.span >= 1 && (l = ut(i, e.span - 1));
    this.start = i, this.startTime = i ? i.getTime() : NaN, this.end = l, this.endTime = l ? l.getTime() : NaN, this.isDate = this.startTime && this.startTime === this.endTime, this.isRange = !this.isDate;
    const s = q8(e, {}, k1.patternProps);
    if (s.assigned && (this.on = { and: s.target }), e.on) {
      const c = (re(e.on) ? e.on : [e.on]).map((h) => {
        if (Pt(h))
          return h;
        const f = q8(h, {}, k1.patternProps);
        return f.assigned ? f.target : null;
      }).filter((h) => h);
      c.length && (this.on = V5(c5({}, this.on), { or: c }));
    }
    this.isComplex = !!this.on;
  }
  get opts() {
    return {
      order: this.order,
      locale: this.locale
    };
  }
  toDateInfo(e) {
    return e.isDateInfo ? e : new k1(e, this.opts);
  }
  startOfWeek(e) {
    const r = e.getDay() + 1, n = r >= this.firstDayOfWeek ? this.firstDayOfWeek - r : -(7 - (this.firstDayOfWeek - r));
    return ut(e, n);
  }
  diffInDays(e, r) {
    return Math.round((r - e) / vQ);
  }
  diffInWeeks(e, r) {
    return this.diffInDays(this.startOfWeek(e), this.startOfWeek(r));
  }
  diffInYears(e, r) {
    return r.getUTCFullYear() - e.getUTCFullYear();
  }
  diffInMonths(e, r) {
    return this.diffInYears(e, r) * 12 + (r.getMonth() - e.getMonth());
  }
  static get patterns() {
    return {
      dailyInterval: {
        test: (e, r, n) => n.diffInDays(n.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      weeklyInterval: {
        test: (e, r, n) => n.diffInWeeks(n.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      monthlyInterval: {
        test: (e, r, n) => n.diffInMonths(n.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      yearlyInterval: {
        test: () => (e, r, n) => n.diffInYears(n.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      days: {
        validate: (e) => re(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.day) || r.includes(-e.dayFromEnd)
      },
      weekdays: {
        validate: (e) => re(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.weekday)
      },
      ordinalWeekdays: {
        validate: (e) => Object.keys(e).reduce((r, n) => {
          const L = e[n];
          return L && (r[n] = re(L) ? L : [parseInt(L, 10)]), r;
        }, {}),
        test: (e, r) => Object.keys(r).map((n) => parseInt(n, 10)).find(
          (n) => r[n].includes(e.weekday) && (n === e.weekdayOrdinal || n === -e.weekdayOrdinalFromEnd)
        )
      },
      weekends: {
        validate: (e) => e,
        test: (e) => e.weekday === 1 || e.weekday === 7
      },
      workweek: {
        validate: (e) => e,
        test: (e) => e.weekday >= 2 && e.weekday <= 6
      },
      weeks: {
        validate: (e) => re(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.week) || r.includes(-e.weekFromEnd)
      },
      months: {
        validate: (e) => re(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.month)
      },
      years: {
        validate: (e) => re(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.year)
      }
    };
  }
  static get patternProps() {
    return Object.keys(k1.patterns).map((e) => ({
      name: e,
      validate: k1.patterns[e].validate
    }));
  }
  static testConfig(e, r, n) {
    return Pt(e) ? e(r) : Ae(e) ? Object.keys(e).every(
      (L) => k1.patterns[L].test(r, e[L], n)
    ) : null;
  }
  iterateDatesInRange({ start: e, end: r }, n) {
    if (!e || !r || !Pt(n))
      return null;
    e = this.locale.normalizeDate(
      e,
      V5(c5({}, this.opts), {
        time: "00:00:00"
      })
    );
    const L = {
      i: 0,
      date: e,
      day: this.locale.getDateParts(e),
      finished: !1
    };
    let i = null;
    for (; !L.finished && L.date <= r; L.i++)
      i = n(L), L.date = ut(L.date, 1), L.day = this.locale.getDateParts(L.date);
    return i;
  }
  shallowIntersectingRange(e) {
    return this.rangeShallowIntersectingRange(this, this.toDateInfo(e));
  }
  rangeShallowIntersectingRange(e, r) {
    if (!this.dateShallowIntersectsDate(e, r))
      return null;
    const n = e.toRange(), L = r.toRange();
    let i = null, l = null;
    return n.start ? L.start ? i = n.start > L.start ? n.start : L.start : i = n.start : L.start && (i = L.start), n.end ? L.end ? l = n.end < L.end ? n.end : L.end : l = n.end : L.end && (l = L.end), { start: i, end: l };
  }
  intersectsDate(e) {
    const r = this.toDateInfo(e);
    if (!this.shallowIntersectsDate(r))
      return null;
    if (!this.on)
      return this;
    const n = this.rangeShallowIntersectingRange(this, r);
    let L = !1;
    return this.iterateDatesInRange(n, (i) => {
      this.matchesDay(i.day) && (L = L || r.matchesDay(i.day), i.finished = L);
    }), L;
  }
  shallowIntersectsDate(e) {
    return this.dateShallowIntersectsDate(this, this.toDateInfo(e));
  }
  dateShallowIntersectsDate(e, r) {
    return e.isDate ? r.isDate ? e.startTime === r.startTime : this.dateShallowIncludesDate(r, e) : r.isDate ? this.dateShallowIncludesDate(e, r) : !(e.start && r.end && e.start > r.end || e.end && r.start && e.end < r.start);
  }
  includesDate(e) {
    const r = this.toDateInfo(e);
    if (!this.shallowIncludesDate(r))
      return !1;
    if (!this.on)
      return !0;
    const n = this.rangeShallowIntersectingRange(this, r);
    let L = !0;
    return this.iterateDatesInRange(n, (i) => {
      this.matchesDay(i.day) && (L = L && r.matchesDay(i.day), i.finished = !L);
    }), L;
  }
  shallowIncludesDate(e) {
    return this.dateShallowIncludesDate(
      this,
      e.isDate ? e : new k1(e, this.opts)
    );
  }
  dateShallowIncludesDate(e, r) {
    return e.isDate ? r.isDate ? e.startTime === r.startTime : !r.startTime || !r.endTime ? !1 : e.startTime === r.startTime && e.startTime === r.endTime : r.isDate ? !(e.start && r.start < e.start || e.end && r.start > e.end) : !(e.start && (!r.start || r.start < e.start) || e.end && (!r.end || r.end > e.end));
  }
  intersectsDay(e) {
    return this.shallowIntersectsDate(e.range) && this.matchesDay(e) ? this : null;
  }
  matchesDay(e) {
    return this.on ? !(this.on.and && !k1.testConfig(this.on.and, e, this) || this.on.or && !this.on.or.some((r) => k1.testConfig(r, e, this))) : !0;
  }
  toRange() {
    return new k1(
      {
        start: this.start,
        end: this.end
      },
      this.opts
    );
  }
  compare(e) {
    if (this.order !== e.order)
      return this.order - e.order;
    if (this.isDate !== e.isDate)
      return this.isDate ? 1 : -1;
    if (this.isDate)
      return 0;
    const r = this.start - e.start;
    return r !== 0 ? r : this.end - e.end;
  }
}
const Fe = {
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  bg: { dow: 2, L: "D.MM.YYYY" },
  ca: { dow: 2, L: "DD/MM/YYYY" },
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  hr: { dow: 2, L: "DD.MM.YYYY" },
  cs: { dow: 2, L: "DD.MM.YYYY" },
  da: { dow: 2, L: "DD.MM.YYYY" },
  nl: { dow: 2, L: "DD-MM-YYYY" },
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  eo: { dow: 2, L: "YYYY-MM-DD" },
  et: { dow: 2, L: "DD.MM.YYYY" },
  fi: { dow: 2, L: "DD.MM.YYYY" },
  fr: { dow: 2, L: "DD/MM/YYYY" },
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  de: { dow: 2, L: "DD.MM.YYYY" },
  he: { dow: 1, L: "DD.MM.YYYY" },
  id: { dow: 2, L: "DD/MM/YYYY" },
  it: { dow: 2, L: "DD/MM/YYYY" },
  ja: { dow: 1, L: "YYYY年M月D日" },
  ko: { dow: 1, L: "YYYY.MM.DD" },
  lv: { dow: 2, L: "DD.MM.YYYY" },
  lt: { dow: 2, L: "DD.MM.YYYY" },
  mk: { dow: 2, L: "D.MM.YYYY" },
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  pl: { dow: 2, L: "DD.MM.YYYY" },
  pt: { dow: 2, L: "DD/MM/YYYY" },
  ro: { dow: 2, L: "DD.MM.YYYY" },
  ru: { dow: 2, L: "DD.MM.YYYY" },
  sk: { dow: 2, L: "DD.MM.YYYY" },
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  sv: { dow: 2, L: "YYYY-MM-DD" },
  th: { dow: 1, L: "DD/MM/YYYY" },
  tr: { dow: 2, L: "DD.MM.YYYY" },
  uk: { dow: 2, L: "DD.MM.YYYY" },
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
Fe.en = Fe["en-US"];
Fe.es = Fe["es-ES"];
Fe.no = Fe.nb;
Fe.zh = Fe["zh-CN"];
y4(Fe).forEach(([t, { dow: e, L: r }]) => {
  Fe[t] = {
    id: t,
    firstDayOfWeek: e,
    masks: { L: r }
  };
});
const Jt = {
  DATE_TIME: 1,
  DATE: 2,
  TIME: 3
}, yQ = {
  1: ["year", "month", "day", "hours", "minutes", "seconds", "milliseconds"],
  2: ["year", "month", "day"],
  3: ["hours", "minutes", "seconds", "milliseconds"]
}, Ll = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, Qt = /\d\d?/, wQ = /\d{3}/, bQ = /\d{4}/, v0 = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, xQ = /\[([^]*?)\]/gm, al = () => {
}, sl = (t) => (e, r, n) => {
  const L = n[t].indexOf(
    r.charAt(0).toUpperCase() + r.substring(1).toLowerCase()
  );
  ~L && (e.month = L);
}, kQ = ["L", "iso"], G1 = 7, MQ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _Q = [
  { value: 0, label: "00" },
  { value: 1, label: "01" },
  { value: 2, label: "02" },
  { value: 3, label: "03" },
  { value: 4, label: "04" },
  { value: 5, label: "05" },
  { value: 6, label: "06" },
  { value: 7, label: "07" },
  { value: 8, label: "08" },
  { value: 9, label: "09" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" }
], ll = {
  D(t) {
    return t.day;
  },
  DD(t) {
    return W5(t.day);
  },
  Do(t, e) {
    return e.DoFn(t.day);
  },
  d(t) {
    return t.weekday - 1;
  },
  dd(t) {
    return W5(t.weekday - 1);
  },
  W(t, e) {
    return e.dayNamesNarrow[t.weekday - 1];
  },
  WW(t, e) {
    return e.dayNamesShorter[t.weekday - 1];
  },
  WWW(t, e) {
    return e.dayNamesShort[t.weekday - 1];
  },
  WWWW(t, e) {
    return e.dayNames[t.weekday - 1];
  },
  M(t) {
    return t.month;
  },
  MM(t) {
    return W5(t.month);
  },
  MMM(t, e) {
    return e.monthNamesShort[t.month - 1];
  },
  MMMM(t, e) {
    return e.monthNames[t.month - 1];
  },
  YY(t) {
    return String(t.year).substring(2);
  },
  YYYY(t) {
    return W5(t.year, 4);
  },
  h(t) {
    return t.hours % 12 || 12;
  },
  hh(t) {
    return W5(t.hours % 12 || 12);
  },
  H(t) {
    return t.hours;
  },
  HH(t) {
    return W5(t.hours);
  },
  m(t) {
    return t.minutes;
  },
  mm(t) {
    return W5(t.minutes);
  },
  s(t) {
    return t.seconds;
  },
  ss(t) {
    return W5(t.seconds);
  },
  S(t) {
    return Math.round(t.milliseconds / 100);
  },
  SS(t) {
    return W5(Math.round(t.milliseconds / 10), 2);
  },
  SSS(t) {
    return W5(t.milliseconds, 3);
  },
  a(t, e) {
    return t.hours < 12 ? e.amPm[0] : e.amPm[1];
  },
  A(t, e) {
    return t.hours < 12 ? e.amPm[0].toUpperCase() : e.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${W5(Math.floor(Math.abs(e) / 60), 2)}`;
  },
  ZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${W5(
      Math.floor(Math.abs(e) / 60) * 100 + Math.abs(e) % 60,
      4
    )}`;
  },
  ZZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${W5(Math.floor(Math.abs(e) / 60), 2)}:${W5(
      Math.abs(e) % 60,
      2
    )}`;
  }
}, X5 = {
  D: [
    Qt,
    (t, e) => {
      t.day = e;
    }
  ],
  Do: [
    new RegExp(Qt.source + v0.source),
    (t, e) => {
      t.day = parseInt(e, 10);
    }
  ],
  d: [Qt, al],
  W: [v0, al],
  M: [
    Qt,
    (t, e) => {
      t.month = e - 1;
    }
  ],
  MMM: [v0, sl("monthNamesShort")],
  MMMM: [v0, sl("monthNames")],
  YY: [
    Qt,
    (t, e) => {
      const r = +(/* @__PURE__ */ new Date()).getFullYear().toString().substring(0, 2);
      t.year = `${e > 68 ? r - 1 : r}${e}`;
    }
  ],
  YYYY: [
    bQ,
    (t, e) => {
      t.year = e;
    }
  ],
  S: [
    /\d/,
    (t, e) => {
      t.millisecond = e * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (t, e) => {
      t.millisecond = e * 10;
    }
  ],
  SSS: [
    wQ,
    (t, e) => {
      t.millisecond = e;
    }
  ],
  h: [
    Qt,
    (t, e) => {
      t.hour = e;
    }
  ],
  m: [
    Qt,
    (t, e) => {
      t.minute = e;
    }
  ],
  s: [
    Qt,
    (t, e) => {
      t.second = e;
    }
  ],
  a: [
    v0,
    (t, e, r) => {
      const n = e.toLowerCase();
      n === r.amPm[0] ? t.isPm = !1 : n === r.amPm[1] && (t.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (t, e) => {
      e === "Z" && (e = "+00:00");
      const r = `${e}`.match(/([+-]|\d\d)/gi);
      if (r) {
        const n = +(r[1] * 60) + parseInt(r[2], 10);
        t.timezoneOffset = r[0] === "+" ? n : -n;
      }
    }
  ]
};
X5.DD = X5.D;
X5.dd = X5.d;
X5.WWWW = X5.WWW = X5.WW = X5.W;
X5.MM = X5.M;
X5.mm = X5.m;
X5.hh = X5.H = X5.HH = X5.h;
X5.ss = X5.s;
X5.A = X5.a;
X5.ZZZZ = X5.ZZZ = X5.ZZ = X5.Z;
function CQ(t, e) {
  const r = new Intl.DateTimeFormat().resolvedOptions().locale;
  let n;
  nr(t) ? n = t : T3(t, "id") && (n = t.id), n = (n || r).toLowerCase();
  const L = Object.keys(e), i = (s) => L.find((c) => c.toLowerCase() === s);
  n = i(n) || i(n.substring(0, 2)) || r;
  const l = V5(
    c5(c5({}, e["en-IE"]), e[n]),
    { id: n }
  );
  return t = Ae(t) ? I3(t, l) : l, t;
}
class F4 {
  constructor(e, { locales: r = Fe, timezone: n } = {}) {
    const {
      id: L,
      firstDayOfWeek: i,
      masks: l
    } = CQ(e, r);
    this.id = L, this.daysInWeek = G1, this.firstDayOfWeek = IZ(i, 1, G1), this.masks = l, this.timezone = n || void 0, this.dayNames = this.getDayNames("long"), this.dayNamesShort = this.getDayNames("short"), this.dayNamesShorter = this.dayNamesShort.map((s) => s.substring(0, 2)), this.dayNamesNarrow = this.getDayNames("narrow"), this.monthNames = this.getMonthNames("long"), this.monthNamesShort = this.getMonthNames("short"), this.amPm = ["am", "pm"], this.monthData = {}, this.getMonthComps = this.getMonthComps.bind(this), this.parse = this.parse.bind(this), this.format = this.format.bind(this), this.toPage = this.toPage.bind(this);
  }
  format(e, r) {
    if (e = this.normalizeDate(e), !e)
      return "";
    r = this.normalizeMasks(r)[0];
    const n = [];
    r = r.replace(xQ, (l, s) => (n.push(s), "??"));
    const L = /Z$/.test(r) ? "utc" : this.timezone, i = this.getDateParts(e, L);
    return r = r.replace(
      Ll,
      (l) => l in ll ? ll[l](i, this) : l.slice(1, l.length - 1)
    ), r.replace(/\?\?/g, () => n.shift());
  }
  parse(e, r) {
    return this.normalizeMasks(r).map((n) => {
      if (typeof n != "string")
        throw new Error("Invalid mask in fecha.parse");
      let L = e;
      if (L.length > 1e3)
        return !1;
      let i = !0;
      const l = {};
      if (n.replace(Ll, (h) => {
        if (X5[h]) {
          const f = X5[h], g = L.search(f[0]);
          ~g ? L.replace(f[0], (m) => (f[1](l, m, this), L = L.substring(g + m.length), m)) : i = !1;
        }
        return X5[h] ? "" : h.slice(1, h.length - 1);
      }), !i)
        return !1;
      const s = /* @__PURE__ */ new Date();
      l.isPm === !0 && l.hour != null && +l.hour != 12 ? l.hour = +l.hour + 12 : l.isPm === !1 && +l.hour == 12 && (l.hour = 0);
      let c;
      return l.timezoneOffset != null ? (l.minute = +(l.minute || 0) - +l.timezoneOffset, c = new Date(
        Date.UTC(
          l.year || s.getFullYear(),
          l.month || 0,
          l.day || 1,
          l.hour || 0,
          l.minute || 0,
          l.second || 0,
          l.millisecond || 0
        )
      )) : c = this.getDateFromParts({
        year: l.year || s.getFullYear(),
        month: (l.month || 0) + 1,
        day: l.day || 1,
        hours: l.hour || 0,
        minutes: l.minute || 0,
        seconds: l.second || 0,
        milliseconds: l.millisecond || 0
      }), c;
    }).find((n) => n) || new Date(e);
  }
  normalizeMasks(e) {
    return (Pe(e) && e || [
      nr(e) && e || "YYYY-MM-DD"
    ]).map(
      (r) => kQ.reduce(
        (n, L) => n.replace(L, this.masks[L] || ""),
        r
      )
    );
  }
  normalizeDate(e, r = {}) {
    let n = null, { type: L, fillDate: i } = r;
    const { mask: l, patch: s, time: c } = r, h = L === "auto" || !L;
    if (_0(e) ? (L = "number", n = /* @__PURE__ */ new Date(+e)) : nr(e) ? (L = "string", n = e ? this.parse(e, l || "iso") : null) : Ae(e) ? (L = "object", n = this.getDateFromParts(e)) : (L = "date", n = ir(e) ? new Date(e.getTime()) : null), n && s) {
      i = i == null ? /* @__PURE__ */ new Date() : this.normalizeDate(i);
      const f = c5(
        c5({}, this.getDateParts(i)),
        uG(this.getDateParts(n), yQ[s])
      );
      n = this.getDateFromParts(f);
    }
    return h && (r.type = L), n && !isNaN(n.getTime()) ? (c && (n = this.adjustTimeForDate(n, {
      timeAdjust: c
    })), n) : null;
  }
  denormalizeDate(e, { type: r, mask: n } = {}) {
    switch (r) {
      case "number":
        return e ? e.getTime() : NaN;
      case "string":
        return e ? this.format(e, n || "iso") : "";
      default:
        return e ? new Date(e) : null;
    }
  }
  hourIsValid(e, r, n) {
    if (!r)
      return !0;
    if (re(r))
      return r.includes(e);
    if (Ae(r)) {
      const L = r.min || 0, i = r.max || 24;
      return L <= e && i >= e;
    }
    return r(e, n);
  }
  getHourOptions(e, r) {
    return _Q.filter(
      (n) => this.hourIsValid(n.value, e, r)
    );
  }
  getMinuteOptions(e) {
    const r = [];
    e = e > 0 ? e : 1;
    for (let n = 0; n <= 59; n += e)
      r.push({
        value: n,
        label: W5(n, 2)
      });
    return r;
  }
  nearestOptionValue(e, r) {
    if (e == null)
      return e;
    const n = r.reduce((L, i) => {
      if (i.disabled)
        return L;
      if (isNaN(L))
        return i.value;
      const l = Math.abs(L - e);
      return Math.abs(i.value - e) < l ? i.value : L;
    }, NaN);
    return isNaN(n) ? e : n;
  }
  adjustTimeForDate(e, { timeAdjust: r, validHours: n, minuteIncrement: L }) {
    if (!r && !n && !L)
      return e;
    const i = this.getDateParts(e);
    if (r)
      if (r === "now") {
        const l = this.getDateParts(/* @__PURE__ */ new Date());
        i.hours = l.hours, i.minutes = l.minutes, i.seconds = l.seconds, i.milliseconds = l.milliseconds;
      } else {
        const l = /* @__PURE__ */ new Date(`2000-01-01T${r}Z`);
        i.hours = l.getUTCHours(), i.minutes = l.getUTCMinutes(), i.seconds = l.getUTCSeconds(), i.milliseconds = l.getUTCMilliseconds();
      }
    if (n) {
      const l = this.getHourOptions(n, i);
      i.hours = this.nearestOptionValue(i.hours, l);
    }
    if (L) {
      const l = this.getMinuteOptions(L);
      i.minutes = this.nearestOptionValue(i.minutes, l);
    }
    return e = this.getDateFromParts(i), e;
  }
  normalizeDates(e, r) {
    return r = r || {}, r.locale = this, (re(e) ? e : [e]).map((n) => n && (n instanceof k1 ? n : new k1(n, r))).filter((n) => n);
  }
  getDateParts(e, r = this.timezone) {
    if (!e)
      return null;
    let n = e;
    if (r) {
      const S = new Date(
        e.toLocaleString("en-US", { timeZone: r })
      );
      S.setMilliseconds(e.getMilliseconds());
      const C = S.getTime() - e.getTime();
      n = new Date(e.getTime() + C);
    }
    const L = n.getMilliseconds(), i = n.getSeconds(), l = n.getMinutes(), s = n.getHours(), c = n.getMonth() + 1, h = n.getFullYear(), f = this.getMonthComps(c, h), g = n.getDate(), m = f.days - g + 1, b = n.getDay() + 1, k = Math.floor((g - 1) / 7 + 1), x = Math.floor((f.days - g) / 7 + 1), D = Math.ceil(
      (g + Math.abs(f.firstWeekday - f.firstDayOfWeek)) / 7
    ), M = f.weeks - D + 1, E = {
      milliseconds: L,
      seconds: i,
      minutes: l,
      hours: s,
      day: g,
      dayFromEnd: m,
      weekday: b,
      weekdayOrdinal: k,
      weekdayOrdinalFromEnd: x,
      week: D,
      weekFromEnd: M,
      month: c,
      year: h,
      date: e,
      isValid: !0
    };
    return E.timezoneOffset = this.getTimezoneOffset(E), E;
  }
  getDateFromParts(e) {
    if (!e)
      return null;
    const r = /* @__PURE__ */ new Date(), {
      year: n = r.getFullYear(),
      month: L = r.getMonth() + 1,
      day: i = r.getDate(),
      hours: l = 0,
      minutes: s = 0,
      seconds: c = 0,
      milliseconds: h = 0
    } = e;
    if (this.timezone) {
      const f = `${W5(n, 4)}-${W5(L, 2)}-${W5(i, 2)}T${W5(
        l,
        2
      )}:${W5(s, 2)}:${W5(c, 2)}.${W5(h, 3)}`;
      return rl(f, { timeZone: this.timezone });
    }
    return new Date(n, L - 1, i, l, s, c, h);
  }
  getTimezoneOffset(e) {
    const {
      year: r,
      month: n,
      day: L,
      hours: i = 0,
      minutes: l = 0,
      seconds: s = 0,
      milliseconds: c = 0
    } = e;
    let h;
    const f = new Date(Date.UTC(r, n - 1, L, i, l, s, c));
    if (this.timezone) {
      const g = `${W5(r, 4)}-${W5(n, 2)}-${W5(L, 2)}T${W5(
        i,
        2
      )}:${W5(l, 2)}:${W5(s, 2)}.${W5(c, 3)}`;
      h = rl(g, { timeZone: this.timezone });
    } else
      h = new Date(r, n - 1, L, i, l, s, c);
    return (h - f) / 6e4;
  }
  toPage(e, r) {
    return _0(e) ? Tt(r, e) : nr(e) ? this.getDateParts(this.normalizeDate(e)) : ir(e) ? this.getDateParts(e) : Ae(e) ? e : null;
  }
  getMonthDates(e = 2e3) {
    const r = [];
    for (let n = 0; n < 12; n++)
      r.push(new Date(e, n, 15));
    return r;
  }
  getMonthNames(e) {
    const r = new Intl.DateTimeFormat(this.id, {
      month: e,
      timezome: "UTC"
    });
    return this.getMonthDates().map((n) => r.format(n));
  }
  getWeekdayDates(e = this.firstDayOfWeek) {
    const r = [], n = 5 + e - 1;
    for (let L = 0; L < G1; L++)
      r.push(
        this.getDateFromParts({
          year: 2020,
          month: 1,
          day: n + L,
          hours: 12
        })
      );
    return r;
  }
  getDayNames(e) {
    const r = new Intl.DateTimeFormat(this.id, {
      weekday: e,
      timeZone: this.timezone
    });
    return this.getWeekdayDates(1).map((n) => r.format(n));
  }
  getMonthComps(e, r) {
    const n = `${e}-${r}`;
    let L = this.monthData[n];
    if (!L) {
      const i = r % 4 === 0 && r % 100 !== 0 || r % 400 === 0, l = new Date(r, e - 1, 1), s = l.getDay() + 1, c = e === 2 && i ? 29 : MQ[e - 1], h = this.firstDayOfWeek - 1, f = mQ(l, {
        weekStartsOn: h
      }), g = [], m = [];
      for (let b = 0; b < f; b++) {
        const k = ut(l, b * 7);
        g.push(hQ(k, { weekStartsOn: h })), m.push(sQ(k));
      }
      L = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear: i,
        firstWeekday: s,
        days: c,
        weeks: f,
        month: e,
        year: r,
        weeknumbers: g,
        isoWeeknumbers: m
      }, this.monthData[n] = L;
    }
    return L;
  }
  getThisMonthComps() {
    const { month: e, year: r } = this.getDateParts(/* @__PURE__ */ new Date());
    return this.getMonthComps(e, r);
  }
  getPrevMonthComps(e, r) {
    return e === 1 ? this.getMonthComps(12, r - 1) : this.getMonthComps(e - 1, r);
  }
  getNextMonthComps(e, r) {
    return e === 12 ? this.getMonthComps(1, r + 1) : this.getMonthComps(e + 1, r);
  }
  getDayId(e) {
    return this.format(e, "YYYY-MM-DD");
  }
  getCalendarDays({ weeks: e, monthComps: r, prevMonthComps: n, nextMonthComps: L }) {
    const i = [], { firstDayOfWeek: l, firstWeekday: s, isoWeeknumbers: c, weeknumbers: h } = r, f = s + (s < l ? G1 : 0) - l;
    let g = !0, m = !1, b = !1;
    const k = new Intl.DateTimeFormat(this.id, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    let x = n.days - f + 1, D = n.days - x + 1, M = Math.floor((x - 1) / G1 + 1), E = 1, S = n.weeks, C = 1, P = n.month, A = n.year;
    const Z = /* @__PURE__ */ new Date(), B = Z.getDate(), U = Z.getMonth() + 1, K = Z.getFullYear(), r5 = (a5, V, l5) => (d5, m5, M5, _5) => this.normalizeDate({
      year: a5,
      month: V,
      day: l5,
      hours: d5,
      minutes: m5,
      seconds: M5,
      milliseconds: _5
    });
    for (let a5 = 1; a5 <= e; a5++) {
      for (let V = 1, l5 = l; V <= G1; V++, l5 += l5 === G1 ? 1 - G1 : 1) {
        g && l5 === s && (x = 1, D = r.days, M = Math.floor((x - 1) / G1 + 1), E = Math.floor(
          (r.days - x) / G1 + 1
        ), S = 1, C = r.weeks, P = r.month, A = r.year, g = !1, m = !0);
        const d5 = r5(A, P, x), m5 = {
          start: d5(0, 0, 0),
          end: d5(23, 59, 59, 999)
        }, M5 = m5.start, _5 = `${W5(A, 4)}-${W5(P, 2)}-${W5(x, 2)}`, $5 = V, E5 = G1 - V, f5 = h[a5 - 1], e1 = c[a5 - 1], C1 = x === B && P === U && A === K, I5 = m && x === 1, R5 = m && x === r.days, L1 = a5 === 1, f1 = a5 === e, t1 = V === 1, a1 = V === G1;
        i.push({
          id: _5,
          label: x.toString(),
          ariaLabel: k.format(new Date(A, P - 1, x)),
          day: x,
          dayFromEnd: D,
          weekday: l5,
          weekdayPosition: $5,
          weekdayPositionFromEnd: E5,
          weekdayOrdinal: M,
          weekdayOrdinalFromEnd: E,
          week: S,
          weekFromEnd: C,
          weeknumber: f5,
          isoWeeknumber: e1,
          month: P,
          year: A,
          dateFromTime: d5,
          date: M5,
          range: m5,
          isToday: C1,
          isFirstDay: I5,
          isLastDay: R5,
          inMonth: m,
          inPrevMonth: g,
          inNextMonth: b,
          onTop: L1,
          onBottom: f1,
          onLeft: t1,
          onRight: a1,
          classes: [
            `id-${_5}`,
            `day-${x}`,
            `day-from-end-${D}`,
            `weekday-${l5}`,
            `weekday-position-${$5}`,
            `weekday-ordinal-${M}`,
            `weekday-ordinal-from-end-${E}`,
            `week-${S}`,
            `week-from-end-${C}`,
            {
              "is-today": C1,
              "is-first-day": I5,
              "is-last-day": R5,
              "in-month": m,
              "in-prev-month": g,
              "in-next-month": b,
              "on-top": L1,
              "on-bottom": f1,
              "on-left": t1,
              "on-right": a1
            }
          ]
        }), m && R5 ? (m = !1, b = !0, x = 1, D = L.days, M = 1, E = Math.floor(
          (L.days - x) / G1 + 1
        ), S = 1, C = L.weeks, P = L.month, A = L.year) : (x++, D--, M = Math.floor((x - 1) / G1 + 1), E = Math.floor(
          (r.days - x) / G1 + 1
        ));
      }
      S++, C--;
    }
    return i;
  }
}
class Mh {
  constructor({
    key: e,
    hashcode: r,
    highlight: n,
    content: L,
    dot: i,
    bar: l,
    popover: s,
    dates: c,
    excludeDates: h,
    excludeMode: f,
    customData: g,
    order: m,
    pinPage: b
  }, k, x) {
    this.key = nZ(e) ? B4() : e, this.hashcode = r, this.customData = g, this.order = m || 0, this.dateOpts = { order: m, locale: x }, this.pinPage = b, n && (this.highlight = k.normalizeHighlight(n)), L && (this.content = k.normalizeContent(L)), i && (this.dot = k.normalizeDot(i)), l && (this.bar = k.normalizeBar(l)), s && (this.popover = s), this.dates = x.normalizeDates(c, this.dateOpts), this.hasDates = !!Pe(this.dates), this.excludeDates = x.normalizeDates(h, this.dateOpts), this.hasExcludeDates = !!Pe(this.excludeDates), this.excludeMode = f || "intersects", this.hasExcludeDates && !this.hasDates && (this.dates.push(new k1({}, this.dateOpts)), this.hasDates = !0), this.isComplex = AJ(this.dates, (D) => D.isComplex);
  }
  intersectsDate(e) {
    return e = e instanceof k1 ? e : new k1(e, this.dateOpts), !this.excludesDate(e) && (this.dates.find((r) => r.intersectsDate(e)) || !1);
  }
  includesDate(e) {
    return e = e instanceof k1 ? e : new k1(e, this.dateOpts), !this.excludesDate(e) && (this.dates.find((r) => r.includesDate(e)) || !1);
  }
  excludesDate(e) {
    return e = e instanceof k1 ? e : new k1(e, this.dateOpts), this.hasExcludeDates && this.excludeDates.find(
      (r) => this.excludeMode === "intersects" && r.intersectsDate(e) || this.excludeMode === "includes" && r.includesDate(e)
    );
  }
  intersectsDay(e) {
    return !this.excludesDay(e) && (this.dates.find((r) => r.intersectsDay(e)) || !1);
  }
  excludesDay(e) {
    return this.hasExcludeDates && this.excludeDates.find((r) => r.intersectsDay(e));
  }
}
const SQ = 300, DQ = 60, EQ = 80, IQ = {
  maxSwipeTime: SQ,
  minHorizontalSwipeDistance: DQ,
  maxVerticalSwipeDistance: EQ
}, TQ = "MMMM YYYY", OQ = "W", zQ = "MMM", PQ = ["L", "YYYY-MM-DD", "YYYY/MM/DD"], AQ = ["L h:mm A", "YYYY-MM-DD h:mm A", "YYYY/MM/DD h:mm A"], $Q = ["L HH:mm", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"], ZQ = ["h:mm A"], NQ = ["HH:mm"], BQ = "WWW, MMM D, YYYY", RQ = ["L", "YYYY-MM-DD", "YYYY/MM/DD"], HQ = "iso", FQ = "YYYY-MM-DDTHH:mm:ss.SSSZ", jQ = {
  title: TQ,
  weekdays: OQ,
  navMonths: zQ,
  input: PQ,
  inputDateTime: AQ,
  inputDateTime24hr: $Q,
  inputTime: ZQ,
  inputTime24hr: NQ,
  dayPopover: BQ,
  data: RQ,
  model: HQ,
  iso: FQ
}, UQ = "640px", YQ = "768px", VQ = "1024px", WQ = "1280px", GQ = {
  sm: UQ,
  md: YQ,
  lg: VQ,
  xl: WQ
}, qQ = {
  componentPrefix: "v",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: IQ,
  masks: jQ,
  screens: GQ,
  locales: Fe,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      keepVisibleOnInput: !1,
      isInteractive: !0
    }
  }
}, pL = un(qQ), KQ = g5(() => gY(pL.locales, (t) => (t.masks = I3(t.masks, pL.masks), t))), Lr = (t) => window && T3(window.__vcalendar__, t) ? R0(window.__vcalendar__, t) : R0(pL, t), JQ = {
  props: {
    color: {
      type: String,
      default: () => Lr("color")
    },
    isDark: {
      type: Boolean,
      default: () => Lr("isDark")
    },
    firstDayOfWeek: Number,
    masks: Object,
    locale: [String, Object],
    timezone: String,
    minDate: null,
    maxDate: null,
    minDateExact: null,
    maxDateExact: null,
    disabledDates: null,
    availableDates: null,
    theme: null
  },
  computed: {
    $theme() {
      return this.theme instanceof K8 ? this.theme : new K8({
        color: this.color,
        isDark: this.isDark
      });
    },
    $locale() {
      if (this.locale instanceof F4)
        return this.locale;
      const t = Ae(this.locale) ? this.locale : {
        id: this.locale,
        firstDayOfWeek: this.firstDayOfWeek,
        masks: this.masks
      };
      return new F4(t, {
        locales: KQ.value,
        timezone: this.timezone
      });
    },
    disabledDates_() {
      const t = this.normalizeDates(this.disabledDates), { minDate: e, minDateExact: r, maxDate: n, maxDateExact: L } = this;
      if (r || e) {
        const i = r ? this.normalizeDate(r) : this.normalizeDate(e, { time: "00:00:00" });
        t.push({
          start: null,
          end: new Date(i.getTime() - 1e3)
        });
      }
      if (L || n) {
        const i = L ? this.normalizeDate(L) : this.normalizeDate(n, { time: "23:59:59" });
        t.push({
          start: new Date(i.getTime() + 1e3),
          end: null
        });
      }
      return t;
    },
    availableDates_() {
      return this.normalizeDates(this.availableDates);
    },
    disabledAttribute() {
      return new Mh(
        {
          key: "disabled",
          dates: this.disabledDates_,
          excludeDates: this.availableDates_,
          excludeMode: "includes",
          order: 100
        },
        this.$theme,
        this.$locale
      );
    }
  },
  methods: {
    formatDate(t, e) {
      return this.$locale ? this.$locale.format(t, e) : "";
    },
    parseDate(t, e) {
      if (!this.$locale)
        return null;
      const r = this.$locale.parse(t, e);
      return ir(r) ? r : null;
    },
    normalizeDate(t, e) {
      return this.$locale ? this.$locale.normalizeDate(t, e) : t;
    },
    normalizeDates(t) {
      return this.$locale.normalizeDates(t, {
        isFullDay: !0
      });
    },
    pageForDate(t) {
      return this.$locale.getDateParts(this.normalizeDate(t));
    },
    pageForThisMonth() {
      return this.pageForDate(/* @__PURE__ */ new Date());
    }
  }
}, QQ = {
  methods: {
    safeSlot(t, e, r = null) {
      return Pt(this.$slots[t]) ? this.$slots[t](e) : r;
    }
  }
}, Do = HJ, _h = JQ, O3 = QQ, XQ = {
  name: "PopoverRow",
  mixins: [Do],
  props: {
    attribute: Object
  },
  computed: {
    indicator() {
      const { highlight: t, dot: e, bar: r, popover: n } = this.attribute;
      if (n && n.hideIndicator)
        return null;
      if (t) {
        const { color: L, isDark: i } = t.start;
        return {
          style: V5(
            c5(
              {},
              this.theme.bgAccentHigh({
                color: L,
                isDark: !i
              })
            ),
            {
              width: "10px",
              height: "5px",
              borderRadius: "3px"
            }
          )
        };
      }
      if (e) {
        const { color: L, isDark: i } = e.start;
        return {
          style: V5(
            c5(
              {},
              this.theme.bgAccentHigh({
                color: L,
                isDark: !i
              })
            ),
            {
              width: "5px",
              height: "5px",
              borderRadius: "50%"
            }
          )
        };
      }
      if (r) {
        const { color: L, isDark: i } = r.start;
        return {
          style: V5(
            c5(
              {},
              this.theme.bgAccentHigh({
                color: L,
                isDark: !i
              })
            ),
            {
              width: "10px",
              height: "3px"
            }
          )
        };
      }
      return null;
    }
  }
}, eX = { class: "vc-day-popover-row" }, tX = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, rX = { class: "vc-day-popover-row-content" };
function nX(t, e, r, n, L, i) {
  return G(), J("div", eX, [
    i.indicator ? (G(), J("div", tX, [
      w(
        "span",
        {
          style: Xe(i.indicator.style),
          class: N5(i.indicator.class)
        },
        null,
        6
      )
    ])) : _1("", !0),
    w("div", rX, [
      d1(t.$slots, "default", {}, () => [
        O0(
          y5(
            r.attribute.popover ? r.attribute.popover.label : "No content provided"
          ),
          1
        )
      ])
    ])
  ]);
}
const oX = /* @__PURE__ */ Kn(XQ, [
  ["render", nX]
]), i4 = "26px", iX = "0 0 32 32", LX = {
  "left-arrow": {
    viewBox: "0 -1 16 34",
    path: "M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z"
  },
  "right-arrow": {
    viewBox: "-5 -1 16 34",
    path: "M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z"
  }
}, aX = {
  props: ["name"],
  data() {
    return {
      width: i4,
      height: i4,
      viewBox: iX,
      path: "",
      isBaseline: !1
    };
  },
  mounted() {
    this.updateIcon();
  },
  watch: {
    name() {
      this.updateIcon();
    }
  },
  methods: {
    updateIcon() {
      const t = LX[this.name];
      t && (this.width = t.width || i4, this.height = t.height || i4, this.viewBox = t.viewBox, this.path = t.path);
    }
  }
}, sX = ["width", "height", "viewBox"], lX = ["d"];
function uX(t, e, r, n, L, i) {
  return G(), J(
    "svg",
    {
      class: "vc-svg-icon",
      width: L.width,
      height: L.height,
      viewBox: L.viewBox
    },
    [w("path", { d: L.path }, null, 8, lX)],
    8,
    sX
  );
}
const Ch = /* @__PURE__ */ Kn(aX, [
  ["render", uX]
]), Ti = 12, cX = {
  name: "CalendarNav",
  emits: ["input"],
  components: {
    SvgIcon: Ch
  },
  mixins: [Do],
  props: {
    value: { type: Object, default: () => ({ month: 0, year: 0 }) },
    validator: { type: Function, default: () => () => !0 }
  },
  data() {
    return {
      monthMode: !0,
      yearIndex: 0,
      yearGroupIndex: 0,
      onSpaceOrEnter: bh
    };
  },
  computed: {
    month() {
      return this.value && this.value.month || 0;
    },
    year() {
      return this.value && this.value.year || 0;
    },
    title() {
      return this.monthMode ? this.yearIndex : `${this.firstYear} - ${this.lastYear}`;
    },
    monthItems() {
      return this.getMonthItems(this.yearIndex);
    },
    yearItems() {
      return this.getYearItems(this.yearGroupIndex);
    },
    prevItemsEnabled() {
      return this.monthMode ? this.prevMonthItemsEnabled : this.prevYearItemsEnabled;
    },
    nextItemsEnabled() {
      return this.monthMode ? this.nextMonthItemsEnabled : this.nextYearItemsEnabled;
    },
    prevMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex - 1).some((t) => !t.isDisabled);
    },
    nextMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex + 1).some((t) => !t.isDisabled);
    },
    prevYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex - 1).some(
        (t) => !t.isDisabled
      );
    },
    nextYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex + 1).some(
        (t) => !t.isDisabled
      );
    },
    activeItems() {
      return this.monthMode ? this.monthItems : this.yearItems;
    },
    firstYear() {
      return vh(this.yearItems.map((t) => t.year));
    },
    lastYear() {
      return H0(this.yearItems.map((t) => t.year));
    }
  },
  watch: {
    year() {
      this.yearIndex = this.year;
    },
    yearIndex(t) {
      this.yearGroupIndex = this.getYearGroupIndex(t);
    },
    value() {
      this.focusFirstItem();
    }
  },
  created() {
    this.yearIndex = this.year;
  },
  mounted() {
    this.focusFirstItem();
  },
  methods: {
    focusFirstItem() {
      this.$nextTick(() => {
        const t = this.$refs.navContainer.querySelector(
          ".vc-nav-item:not(.is-disabled)"
        );
        t && t.focus();
      });
    },
    getItemClasses({ isActive: t, isCurrent: e, isDisabled: r }) {
      const n = ["vc-nav-item"];
      return t ? n.push("is-active") : e && n.push("is-current"), r && n.push("is-disabled"), n;
    },
    getYearGroupIndex(t) {
      return Math.floor(t / Ti);
    },
    getMonthItems(t) {
      const { month: e, year: r } = this.pageForDate(/* @__PURE__ */ new Date());
      return this.locale.getMonthDates().map((n, L) => {
        const i = L + 1;
        return {
          month: i,
          year: t,
          id: `${t}.${W5(i, 2)}`,
          label: this.locale.format(n, this.masks.navMonths),
          ariaLabel: this.locale.format(n, "MMMM YYYY"),
          isActive: i === this.month && t === this.year,
          isCurrent: i === e && t === r,
          isDisabled: !this.validator({ month: i, year: t }),
          click: () => this.monthClick(i, t)
        };
      });
    },
    getYearItems(t) {
      const { _: e, year: r } = this.pageForDate(/* @__PURE__ */ new Date()), n = t * Ti, L = n + Ti, i = [];
      for (let l = n; l < L; l += 1) {
        let s = !1;
        for (let c = 1; c < 12 && (s = this.validator({ month: c, year: l }), !s); c++)
          ;
        i.push({
          year: l,
          id: l,
          label: l,
          ariaLabel: l,
          isActive: l === this.year,
          isCurrent: l === r,
          isDisabled: !s,
          click: () => this.yearClick(l)
        });
      }
      return i;
    },
    monthClick(t, e) {
      this.validator({ month: t, year: e }) && this.$emit("input", { month: t, year: e });
    },
    yearClick(t) {
      this.yearIndex = t, this.monthMode = !0, this.focusFirstItem();
    },
    toggleMode() {
      this.monthMode = !this.monthMode;
    },
    movePrev() {
      this.prevItemsEnabled && (this.monthMode && this.movePrevYear(), this.movePrevYearGroup());
    },
    moveNext() {
      this.nextItemsEnabled && (this.monthMode && this.moveNextYear(), this.moveNextYearGroup());
    },
    movePrevYear() {
      this.yearIndex--;
    },
    moveNextYear() {
      this.yearIndex++;
    },
    movePrevYearGroup() {
      this.yearGroupIndex--;
    },
    moveNextYearGroup() {
      this.yearGroupIndex++;
    }
  }
}, hX = {
  class: "vc-nav-container",
  ref: "navContainer"
}, dX = { class: "vc-nav-header" }, fX = ["tabindex"], pX = ["tabindex"], gX = { class: "vc-nav-items" }, mX = [
  "data-id",
  "aria-label",
  "tabindex",
  "onClick",
  "onKeydown"
];
function vX(t, e, r, n, L, i) {
  const l = IL("svg-icon");
  return G(), J(
    "div",
    hX,
    [
      w("div", dX, [
        w(
          "span",
          {
            role: "button",
            class: N5([
              "vc-nav-arrow is-left",
              { "is-disabled": !i.prevItemsEnabled }
            ]),
            tabindex: i.prevItemsEnabled ? 0 : void 0,
            onClick: e[0] || (e[0] = (...s) => i.movePrev && i.movePrev(...s)),
            onKeydown: e[1] || (e[1] = (s) => L.onSpaceOrEnter(s, i.movePrev))
          },
          [
            d1(t.$slots, "nav-left-button", {}, () => [
              s5(l, {
                name: "left-arrow",
                width: "20px",
                height: "24px"
              })
            ])
          ],
          42,
          fX
        ),
        w(
          "span",
          {
            role: "button",
            class: "vc-nav-title vc-grid-focus",
            style: { whiteSpace: "nowrap" },
            tabindex: "0",
            onClick: e[2] || (e[2] = (...s) => i.toggleMode && i.toggleMode(...s)),
            onKeydown: e[3] || (e[3] = (s) => L.onSpaceOrEnter(s, i.toggleMode))
          },
          y5(i.title),
          33
        ),
        w(
          "span",
          {
            role: "button",
            class: N5([
              "vc-nav-arrow is-right",
              { "is-disabled": !i.nextItemsEnabled }
            ]),
            tabindex: i.nextItemsEnabled ? 0 : void 0,
            onClick: e[4] || (e[4] = (...s) => i.moveNext && i.moveNext(...s)),
            onKeydown: e[5] || (e[5] = (s) => L.onSpaceOrEnter(s, i.moveNext))
          },
          [
            d1(t.$slots, "nav-right-button", {}, () => [
              s5(l, {
                name: "right-arrow",
                width: "20px",
                height: "24px"
              })
            ])
          ],
          42,
          pX
        )
      ]),
      w("div", gX, [
        (G(!0), J(
          Be,
          null,
          G0(i.activeItems, (s) => (G(), J(
            "span",
            {
              key: s.label,
              role: "button",
              "data-id": s.id,
              "aria-label": s.ariaLabel,
              class: N5(i.getItemClasses(s)),
              tabindex: s.isDisabled ? void 0 : 0,
              onClick: s.click,
              onKeydown: (c) => L.onSpaceOrEnter(c, s.click)
            },
            y5(s.label),
            43,
            mX
          ))),
          128
        ))
      ])
    ],
    512
  );
}
const yX = /* @__PURE__ */ Kn(cX, [
  ["render", vX]
]);
function gL(t) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: t
    })
  );
}
function mL(t) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: t
    })
  );
}
function Sh(t) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: t
    })
  );
}
function wX(t) {
  document && document.dispatchEvent(
    new CustomEvent("update-popover", {
      detail: t
    })
  );
}
function j4(t) {
  const { visibility: e } = t, r = e === "click", n = e === "hover", L = e === "hover-focus", i = e === "focus";
  t.autoHide = !r;
  let l = !1, s = !1;
  const { isRenderFn: c } = t, h = {
    click: c ? "onClick" : "click",
    mousemove: c ? "onMousemove" : "mousemove",
    mouseleave: c ? "onMouseleave" : "mouseleave",
    focusin: c ? "onFocusin" : "focusin",
    focusout: c ? "onFocusout" : "focusout"
  };
  return {
    [h.click](f) {
      r && (t.ref = f.target, Sh(t), f.stopPropagation());
    },
    [h.mousemove](f) {
      t.ref = f.currentTarget, l || (l = !0, (n || L) && gL(t));
    },
    [h.mouseleave](f) {
      t.ref = f.target, l && (l = !1, (n || L && !s) && mL(t));
    },
    [h.focusin](f) {
      t.ref = f.currentTarget, s || (s = !0, (i || L) && gL(t));
    },
    [h.focusout](f) {
      t.ref = f.currentTarget, s && !D0(t.ref, f.relatedTarget) && (s = !1, (i || L && !l) && mL(t));
    }
  };
}
const bX = {
  name: "CalendarDay",
  emits: [
    "dayclick",
    "daymouseenter",
    "daymouseleave",
    "dayfocusin",
    "dayfocusout",
    "daykeydown"
  ],
  mixins: [Do, O3],
  inheritAttrs: !1,
  render() {
    const t = () => this.hasBackgrounds && C5(
      "div",
      {
        class: "vc-highlights vc-day-layer"
      },
      this.backgrounds.map(
        ({ key: L, wrapperClass: i, class: l, style: s }) => C5(
          "div",
          {
            key: L,
            class: i
          },
          [
            C5("div", {
              class: l,
              style: s
            })
          ]
        )
      )
    ), e = () => this.safeSlot("day-content", {
      day: this.day,
      attributes: this.day.attributes,
      attributesMap: this.day.attributesMap,
      dayProps: this.dayContentProps,
      dayEvents: this.dayContentEvents
    }) || C5(
      "span",
      V5(
        c5(
          V5(c5({}, this.dayContentProps), {
            class: this.dayContentClass,
            style: this.dayContentStyle
          }),
          this.dayContentEvents
        ),
        {
          ref: "content"
        }
      ),
      [this.day.label]
    ), r = () => this.hasDots && C5(
      "div",
      {
        class: "vc-day-layer vc-day-box-center-bottom"
      },
      [
        C5(
          "div",
          {
            class: "vc-dots"
          },
          this.dots.map(
            ({ key: L, class: i, style: l }) => C5("span", {
              key: L,
              class: i,
              style: l
            })
          )
        )
      ]
    ), n = () => this.hasBars && C5(
      "div",
      {
        class: "vc-day-layer vc-day-box-center-bottom"
      },
      [
        C5(
          "div",
          {
            class: "vc-bars"
          },
          this.bars.map(
            ({ key: L, class: i, style: l }) => C5("span", {
              key: L,
              class: i,
              style: l
            })
          )
        )
      ]
    );
    return C5(
      "div",
      {
        class: [
          "vc-day",
          ...this.day.classes,
          { "vc-day-box-center-center": !this.$slots["day-content"] },
          { "is-not-in-month": !this.inMonth }
        ]
      },
      [t(), e(), r(), n()]
    );
  },
  inject: ["sharedState"],
  props: {
    day: { type: Object, required: !0 }
  },
  data() {
    return {
      glyphs: {},
      dayContentEvents: {}
    };
  },
  computed: {
    label() {
      return this.day.label;
    },
    startTime() {
      return this.day.range.start.getTime();
    },
    endTime() {
      return this.day.range.end.getTime();
    },
    inMonth() {
      return this.day.inMonth;
    },
    isDisabled() {
      return this.day.isDisabled;
    },
    backgrounds() {
      return this.glyphs.backgrounds;
    },
    hasBackgrounds() {
      return !!Pe(this.backgrounds);
    },
    content() {
      return this.glyphs.content;
    },
    dots() {
      return this.glyphs.dots;
    },
    hasDots() {
      return !!Pe(this.dots);
    },
    bars() {
      return this.glyphs.bars;
    },
    hasBars() {
      return !!Pe(this.bars);
    },
    popovers() {
      return this.glyphs.popovers;
    },
    hasPopovers() {
      return !!Pe(this.popovers);
    },
    dayContentClass() {
      return [
        "vc-day-content vc-focusable",
        { "is-disabled": this.isDisabled },
        R0(H0(this.content), "class") || ""
      ];
    },
    dayContentStyle() {
      return R0(H0(this.content), "style");
    },
    dayContentProps() {
      let t;
      return this.day.isFocusable ? t = "0" : this.day.inMonth && (t = "-1"), {
        tabindex: t,
        "aria-label": this.day.ariaLabel,
        "aria-disabled": this.day.isDisabled ? "true" : "false",
        role: "button"
      };
    },
    dayEvent() {
      return V5(c5({}, this.day), {
        el: this.$refs.content,
        popovers: this.popovers
      });
    }
  },
  watch: {
    theme() {
      this.refresh();
    },
    popovers() {
      this.refreshPopovers();
    },
    "day.shouldRefresh"() {
      this.refresh();
    }
  },
  mounted() {
    this.refreshPopovers(), this.refresh();
  },
  methods: {
    getDayEvent(t) {
      return V5(c5({}, this.dayEvent), {
        event: t
      });
    },
    click(t) {
      this.$emit("dayclick", this.getDayEvent(t));
    },
    mouseenter(t) {
      this.$emit("daymouseenter", this.getDayEvent(t));
    },
    mouseleave(t) {
      this.$emit("daymouseleave", this.getDayEvent(t));
    },
    focusin(t) {
      this.$emit("dayfocusin", this.getDayEvent(t));
    },
    focusout(t) {
      this.$emit("dayfocusout", this.getDayEvent(t));
    },
    keydown(t) {
      this.$emit("daykeydown", this.getDayEvent(t));
    },
    refresh() {
      if (!this.day.shouldRefresh)
        return;
      this.day.shouldRefresh = !1;
      const t = {
        backgrounds: [],
        dots: [],
        bars: [],
        popovers: [],
        content: []
      };
      this.day.attributes = Object.values(this.day.attributesMap || {}).sort(
        (e, r) => e.order - r.order
      ), this.day.attributes.forEach((e) => {
        const { targetDate: r } = e, { isDate: n, isComplex: L, startTime: i, endTime: l } = r, s = this.startTime <= i, c = this.endTime >= l, h = {
          isDate: n,
          isComplex: L,
          onStart: s,
          onEnd: c,
          onStartAndEnd: s && c,
          onStartOrEnd: s || c
        };
        this.processHighlight(e, h, t), this.processNonHighlight(e, "content", h, t.content), this.processNonHighlight(e, "dot", h, t.dots), this.processNonHighlight(e, "bar", h, t.bars), this.processPopover(e, t);
      }), this.glyphs = t;
    },
    processHighlight({ key: t, highlight: e }, { isDate: r, isComplex: n, onStart: L, onEnd: i, onStartAndEnd: l }, { backgrounds: s, content: c }) {
      if (!e)
        return;
      const { base: h, start: f, end: g } = e;
      r || n ? (s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", f.class],
        style: f.style
      }), c.push({
        key: `${t}-content`,
        class: f.contentClass,
        style: f.contentStyle
      })) : l ? (s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", f.class],
        style: f.style
      }), c.push({
        key: `${t}-content`,
        class: f.contentClass,
        style: f.contentStyle
      })) : L ? (s.push({
        key: `${t}-base`,
        wrapperClass: "vc-day-layer vc-day-box-right-center",
        class: ["vc-highlight vc-highlight-base-start", h.class],
        style: h.style
      }), s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", f.class],
        style: f.style
      }), c.push({
        key: `${t}-content`,
        class: f.contentClass,
        style: f.contentStyle
      })) : i ? (s.push({
        key: `${t}-base`,
        wrapperClass: "vc-day-layer vc-day-box-left-center",
        class: ["vc-highlight vc-highlight-base-end", h.class],
        style: h.style
      }), s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", g.class],
        style: g.style
      }), c.push({
        key: `${t}-content`,
        class: g.contentClass,
        style: g.contentStyle
      })) : (s.push({
        key: `${t}-middle`,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight vc-highlight-base-middle", h.class],
        style: h.style
      }), c.push({
        key: `${t}-content`,
        class: h.contentClass,
        style: h.contentStyle
      }));
    },
    processNonHighlight(t, e, { isDate: r, onStart: n, onEnd: L }, i) {
      if (!t[e])
        return;
      const { key: l } = t, s = `vc-${e}`, { base: c, start: h, end: f } = t[e];
      r || n ? i.push({
        key: l,
        class: [s, h.class],
        style: h.style
      }) : L ? i.push({
        key: l,
        class: [s, f.class],
        style: f.style
      }) : i.push({
        key: l,
        class: [s, c.class],
        style: c.style
      });
    },
    processPopover(t, { popovers: e }) {
      const { key: r, customData: n, popover: L } = t;
      if (!L)
        return;
      const i = C0(
        {
          key: r,
          customData: n,
          attribute: t
        },
        c5({}, L),
        {
          visibility: L.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !L.label
        }
      );
      e.splice(0, 0, i);
    },
    refreshPopovers() {
      let t = {};
      Pe(this.popovers) && (t = j4(
        C0(
          { id: this.dayPopoverId, data: this.day, isRenderFn: !0 },
          ...this.popovers
        )
      )), this.dayContentEvents = $J(
        {
          onClick: this.click,
          onMouseenter: this.mouseenter,
          onMouseleave: this.mouseleave,
          onFocusin: this.focusin,
          onFocusout: this.focusout,
          onKeydown: this.keydown
        },
        t
      ), wX({
        id: this.dayPopoverId,
        data: this.day
      });
    }
  }
}, xX = {
  name: "CalendarPane",
  emits: ["update:page", "weeknumberclick"],
  mixins: [Do, O3],
  inheritAttrs: !1,
  render() {
    const t = this.safeSlot("header", this.page) || C5("div", { class: `vc-header align-${this.titlePosition}` }, [
      C5(
        "div",
        c5(
          {
            class: "vc-title"
          },
          this.navPopoverEvents
        ),
        [this.safeSlot("header-title", this.page, this.page.title)]
      )
    ]), e = this.weekdayLabels.map(
      (c, h) => C5(
        "div",
        {
          key: h + 1,
          class: "vc-weekday"
        },
        [c]
      )
    ), r = this.showWeeknumbers_.startsWith("left"), n = this.showWeeknumbers_.startsWith("right");
    r ? e.unshift(
      C5("div", {
        class: "vc-weekday"
      })
    ) : n && e.push(
      C5("div", {
        class: "vc-weekday"
      })
    );
    const L = (c) => C5(
      "div",
      {
        class: ["vc-weeknumber"]
      },
      [
        C5(
          "span",
          {
            class: ["vc-weeknumber-content", `is-${this.showWeeknumbers_}`],
            onClick: (h) => {
              this.$emit("weeknumberclick", {
                weeknumber: c,
                days: this.page.days.filter(
                  (f) => f[this.weeknumberKey] === c
                ),
                event: h
              });
            }
          },
          [c]
        )
      ]
    ), i = [], { daysInWeek: l } = this.locale;
    this.page.days.forEach((c, h) => {
      const f = h % l;
      (r && f === 0 || n && f === l) && i.push(L(c[this.weeknumberKey])), i.push(
        C5(
          bX,
          V5(c5({}, this.$attrs), {
            day: c
          }),
          this.$slots
        )
      ), n && f === l - 1 && i.push(L(c[this.weeknumberKey]));
    });
    const s = C5(
      "div",
      {
        class: {
          "vc-weeks": !0,
          "vc-show-weeknumbers": this.showWeeknumbers_,
          "is-left": r,
          "is-right": n
        }
      },
      [e, i]
    );
    return C5(
      "div",
      {
        class: [
          "vc-pane",
          `row-from-end-${this.rowFromEnd}`,
          `column-from-end-${this.columnFromEnd}`
        ],
        ref: "pane"
      },
      [t, s]
    );
  },
  props: {
    page: Object,
    position: Number,
    row: Number,
    rowFromEnd: Number,
    column: Number,
    columnFromEnd: Number,
    titlePosition: String,
    navVisibility: {
      type: String,
      default: () => Lr("navVisibility")
    },
    showWeeknumbers: [Boolean, String],
    showIsoWeeknumbers: [Boolean, String]
  },
  computed: {
    weeknumberKey() {
      return this.showWeeknumbers ? "weeknumber" : "isoWeeknumber";
    },
    showWeeknumbers_() {
      const t = this.showWeeknumbers || this.showIsoWeeknumbers;
      return t == null ? "" : E$(t) ? t ? "left" : "" : t.startsWith("right") ? this.columnFromEnd > 1 ? "right" : t : this.column > 1 ? "left" : t;
    },
    navPlacement() {
      switch (this.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    },
    navPopoverEvents() {
      const { sharedState: t, navVisibility: e, navPlacement: r, page: n, position: L } = this;
      return j4({
        id: t.navPopoverId,
        visibility: e,
        placement: r,
        modifiers: [
          { name: "flip", options: { fallbackPlacements: ["bottom"] } }
        ],
        data: { page: n, position: L },
        isInteractive: !0,
        isRenderFn: !0
      });
    },
    weekdayLabels() {
      return this.locale.getWeekdayDates().map((t) => this.format(t, this.masks.weekdays));
    }
  }
};
class kX {
  constructor(e, r, n) {
    this.theme = e, this.locale = r, this.map = {}, this.refresh(n, !0);
  }
  destroy() {
    this.theme = null, this.locale = null, this.map = {}, this.list = [], this.pinAttr = null;
  }
  refresh(e, r) {
    const n = {}, L = [];
    let i = null;
    const l = [], s = r ? /* @__PURE__ */ new Set() : new Set(Object.keys(this.map));
    return Pe(e) && e.forEach((c, h) => {
      if (!c || !c.dates)
        return;
      const f = c.key ? c.key.toString() : h.toString(), g = c.order || 0, m = NJ(JSON.stringify(c));
      let b = this.map[f];
      !r && b && b.hashcode === m ? s.delete(f) : (b = new Mh(
        c5(
          {
            key: f,
            order: g,
            hashcode: m
          },
          c
        ),
        this.theme,
        this.locale
      ), l.push(b)), b && b.pinPage && (i = b), n[f] = b, L.push(b);
    }), this.map = n, this.list = L, this.pinAttr = i, { adds: l, deletes: Array.from(s) };
  }
}
const MX = (t, e, {
  maxSwipeTime: r,
  minHorizontalSwipeDistance: n,
  maxVerticalSwipeDistance: L
}) => {
  if (!t || !t.addEventListener || !Pt(e))
    return null;
  let i = 0, l = 0, s = null, c = !1;
  function h(g) {
    const m = g.changedTouches[0];
    i = m.screenX, l = m.screenY, s = (/* @__PURE__ */ new Date()).getTime(), c = !0;
  }
  function f(g) {
    if (!c)
      return;
    c = !1;
    const m = g.changedTouches[0], b = m.screenX - i, k = m.screenY - l;
    if ((/* @__PURE__ */ new Date()).getTime() - s < r && Math.abs(b) >= n && Math.abs(k) <= L) {
      const x = { toLeft: !1, toRight: !1 };
      b < 0 ? x.toLeft = !0 : x.toRight = !0, e(x);
    }
  }
  return q1(t, "touchstart", h, { passive: !0 }), q1(t, "touchend", f, { passive: !0 }), () => {
    K1(t, "touchstart", h), K1(t, "touchend", f);
  };
}, _X = {
  name: "Calendar",
  emits: [
    "dayfocusin",
    "dayfocusout",
    "transition-start",
    "transition-end",
    "update:from-page",
    "update:to-page"
  ],
  render() {
    const t = this.pages.map((L, i) => {
      const l = i + 1, s = Math.ceil((i + 1) / this.columns), c = this.rows - s + 1, h = l % this.columns || this.columns, f = this.columns - h + 1;
      return C5(
        xX,
        V5(c5({}, this.$attrs), {
          key: L.key,
          attributes: this.store,
          page: L,
          position: l,
          row: s,
          rowFromEnd: c,
          column: h,
          columnFromEnd: f,
          titlePosition: this.titlePosition,
          canMove: this.canMove,
          "onUpdate:page": (g) => this.move(g, { position: i + 1 }),
          onDayfocusin: (g) => {
            this.lastFocusedDay = g, this.$emit("dayfocusin", g);
          },
          onDayfocusout: (g) => {
            this.lastFocusedDay = null, this.$emit("dayfocusout", g);
          }
        }),
        this.$slots
      );
    }), e = (L) => {
      const i = () => this.move(L ? -this.step_ : this.step_), l = (c) => bh(c, i), s = L ? !this.canMovePrev : !this.canMoveNext;
      return C5(
        "div",
        {
          class: [
            "vc-arrow",
            `is-${L ? "left" : "right"}`,
            { "is-disabled": s }
          ],
          role: "button",
          onClick: i,
          onKeydown: l
        },
        [
          (L ? this.safeSlot("header-left-button", { click: i }) : this.safeSlot("header-right-button", { click: i })) || C5(Ch, {
            name: L ? "left-arrow" : "right-arrow"
          })
        ]
      );
    }, r = () => C5(
      fL,
      {
        id: this.sharedState.navPopoverId,
        contentClass: "vc-nav-popover-container",
        ref: "navPopover"
      },
      {
        default: ({ data: L }) => {
          const { position: i, page: l } = L;
          return C5(
            yX,
            {
              value: l,
              position: i,
              validator: (s) => this.canMove(s, { position: i }),
              onInput: (s) => this.move(s)
            },
            c5({}, this.$slots)
          );
        }
      }
    ), n = () => C5(
      fL,
      {
        id: this.sharedState.dayPopoverId,
        contentClass: "vc-day-popover-container"
      },
      {
        default: ({ data: L, updateLayout: i, hide: l }) => {
          const s = Object.values(L.attributes).filter(
            (g) => g.popover
          ), c = this.$locale.masks, h = this.formatDate, f = h(L.date, c.dayPopover);
          return this.safeSlot(
            "day-popover",
            {
              day: L,
              attributes: s,
              masks: c,
              format: h,
              dayTitle: f,
              updateLayout: i,
              hide: l
            },
            C5("div", [
              c.dayPopover && C5(
                "div",
                {
                  class: ["vc-day-popover-header"]
                },
                [f]
              ),
              s.map(
                (g) => C5(oX, {
                  key: g.key,
                  attribute: g
                })
              )
            ])
          );
        }
      }
    );
    return C5(
      "div",
      {
        "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year",
        class: [
          "vc-container",
          `vc-${this.$theme.color}`,
          {
            "vc-is-expanded": this.isExpanded,
            "vc-is-dark": this.$theme.isDark
          }
        ],
        onKeydown: this.handleKeydown,
        onMouseup: (L) => L.preventDefault(),
        ref: "container"
      },
      [
        r(),
        C5(
          "div",
          {
            class: [
              "vc-pane-container",
              { "in-transition": this.inTransition }
            ]
          },
          [
            C5(
              xh,
              {
                name: this.transitionName,
                "on-before-enter": () => {
                  this.inTransition = !0;
                },
                "on-after-enter": () => {
                  this.inTransition = !1;
                }
              },
              {
                default: () => C5(
                  "div",
                  V5(c5({}, this.$attrs), {
                    class: "vc-pane-layout",
                    style: {
                      gridTemplateColumns: `repeat(${this.columns}, 1fr)`
                    },
                    key: this.firstPage ? this.firstPage.key : ""
                  }),
                  t
                )
              }
            ),
            C5(
              "div",
              {
                class: [`vc-arrows-container title-${this.titlePosition}`]
              },
              [e(!0), e(!1)]
            ),
            this.$slots.footer && this.$slots.footer()
          ]
        ),
        n()
      ]
    );
  },
  mixins: [_h, O3],
  provide() {
    return {
      sharedState: this.sharedState
    };
  },
  props: {
    rows: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 1
    },
    step: Number,
    titlePosition: {
      type: String,
      default: () => Lr("titlePosition")
    },
    isExpanded: Boolean,
    fromDate: Date,
    toDate: Date,
    fromPage: Object,
    toPage: Object,
    minPage: Object,
    maxPage: Object,
    transition: String,
    attributes: [Object, Array],
    trimWeeks: Boolean,
    disablePageSwipe: Boolean
  },
  data() {
    return {
      pages: [],
      store: null,
      lastFocusedDay: null,
      focusableDay: (/* @__PURE__ */ new Date()).getDate(),
      transitionName: "",
      inTransition: !1,
      sharedState: {
        navPopoverId: B4(),
        dayPopoverId: B4(),
        theme: {},
        masks: {},
        locale: {}
      }
    };
  },
  computed: {
    firstPage() {
      return vh(this.pages);
    },
    lastPage() {
      return H0(this.pages);
    },
    minPage_() {
      return this.minPage || this.pageForDate(this.minDate);
    },
    maxPage_() {
      return this.maxPage || this.pageForDate(this.maxDate);
    },
    count() {
      return this.rows * this.columns;
    },
    step_() {
      return this.step || this.count;
    },
    canMovePrev() {
      return this.canMove(-this.step_);
    },
    canMoveNext() {
      return this.canMove(this.step_);
    }
  },
  watch: {
    $locale() {
      this.refreshLocale(), this.refreshPages({ page: this.firstPage, ignoreCache: !0 }), this.initStore();
    },
    $theme() {
      this.refreshTheme(), this.initStore();
    },
    fromDate() {
      this.refreshPages();
    },
    fromPage(t) {
      const e = this.pages && this.pages[0];
      Ci(t, e) || this.refreshPages();
    },
    toPage(t) {
      const e = this.pages && this.pages[this.pages.length - 1];
      Ci(t, e) || this.refreshPages();
    },
    count() {
      this.refreshPages();
    },
    attributes: {
      handler(t) {
        const { adds: e, deletes: r } = this.store.refresh(t);
        this.refreshAttrs(this.pages, e, r);
      },
      deep: !0
    },
    pages(t) {
      this.refreshAttrs(t, this.store.list, null, !0);
    },
    disabledAttribute() {
      this.refreshDisabledDays();
    },
    lastFocusedDay(t) {
      t && (this.focusableDay = t.day, this.refreshFocusableDays());
    },
    inTransition(t) {
      t ? this.$emit("transition-start") : (this.$emit("transition-end"), this.transitionPromise && (this.transitionPromise.resolve(!0), this.transitionPromise = null));
    }
  },
  created() {
    this.refreshLocale(), this.refreshTheme(), this.initStore(), this.refreshPages();
  },
  mounted() {
    this.disablePageSwipe || (this.removeHandlers = MX(
      this.$refs.container,
      ({ toLeft: t, toRight: e }) => {
        t ? this.moveNext() : e && this.movePrev();
      },
      Lr("touch")
    ));
  },
  beforeUnmount() {
    this.pages = [], this.store.destroy(), this.store = null, this.sharedState = null, this.removeHandlers && this.removeHandlers();
  },
  methods: {
    refreshLocale() {
      this.sharedState.locale = this.$locale, this.sharedState.masks = this.$locale.masks;
    },
    refreshTheme() {
      this.sharedState.theme = this.$theme;
    },
    canMove(t, e = {}) {
      const r = this.firstPage && this.$locale.toPage(t, this.firstPage);
      if (!r)
        return !1;
      let { position: n } = e;
      if (_0(t) && (n = 1), !n)
        if (w0(r, this.firstPage))
          n = -1;
        else if (S0(r, this.lastPage))
          n = 1;
        else
          return !0;
      return Object.assign(
        e,
        this.getTargetPageRange(r, {
          position: n,
          force: !0
        })
      ), ZJ(e.fromPage, e.toPage).some(
        (L) => wh(L, this.minPage_, this.maxPage_)
      );
    },
    movePrev(t) {
      return this.move(-this.step_, t);
    },
    moveNext(t) {
      return this.move(this.step_, t);
    },
    move(t, e = {}) {
      const r = this.canMove(t, e);
      return !e.force && !r ? Promise.reject(
        new Error(`Move target is disabled: ${JSON.stringify(e)}`)
      ) : (this.$refs.navPopover.hide({ hideDelay: 0 }), e.fromPage && !Ci(e.fromPage, this.firstPage) ? this.refreshPages(
        V5(c5({}, e), {
          page: e.fromPage,
          position: 1,
          force: !0
        })
      ) : Promise.resolve(!0));
    },
    focusDate(t, e = {}) {
      return this.move(t, e).then(() => {
        const r = this.$el.querySelector(
          `.id-${this.$locale.getDayId(t)}.in-month .vc-focusable`
        );
        return r ? (r.focus(), Promise.resolve(!0)) : Promise.resolve(!1);
      });
    },
    showPageRange(t, e) {
      let r, n;
      if (ir(t))
        r = this.pageForDate(t);
      else if (Ae(t)) {
        const { month: l, year: s } = t, { from: c, to: h } = t;
        _0(l) && _0(s) ? r = t : (c || h) && (r = ir(c) ? this.pageForDate(c) : c, n = ir(h) ? this.pageForDate(h) : h);
      } else
        return Promise.reject(new Error("Invalid page range provided."));
      const L = this.lastPage;
      let i = r;
      return S0(n, L) && (i = Tt(n, -(this.pages.length - 1))), w0(i, r) && (i = r), this.refreshPages(
        V5(c5({}, e), { page: i })
      );
    },
    getTargetPageRange(t, { position: e, force: r } = {}) {
      let n = null, L = null;
      if (pe(t)) {
        let i = 0;
        e = +e, isNaN(e) || (i = e > 0 ? 1 - e : -(this.count + e)), n = Tt(t, i);
      } else
        n = this.getDefaultInitialPage();
      return L = Tt(n, this.count - 1), r || (w0(n, this.minPage_) ? n = this.minPage_ : S0(L, this.maxPage_) && (n = Tt(this.maxPage_, 1 - this.count)), L = Tt(n, this.count - 1)), { fromPage: n, toPage: L };
    },
    getDefaultInitialPage() {
      let t = this.fromPage || this.pageForDate(this.fromDate);
      if (!pe(t)) {
        const e = this.toPage || this.pageForDate(this.toPage);
        pe(e) && (t = Tt(e, 1 - this.count));
      }
      return pe(t) || (t = this.getPageForAttributes()), pe(t) || (t = this.pageForThisMonth()), t;
    },
    refreshPages({ page: t, position: e = 1, force: r, transition: n, ignoreCache: L } = {}) {
      return new Promise((i, l) => {
        const { fromPage: s, toPage: c } = this.getTargetPageRange(t, {
          position: e,
          force: r
        }), h = [];
        for (let f = 0; f < this.count; f++)
          h.push(this.buildPage(Tt(s, f), L));
        this.refreshDisabledDays(h), this.refreshFocusableDays(h), this.transitionName = this.getPageTransition(
          this.pages[0],
          h[0],
          n
        ), this.pages = h, this.$emit("update:from-page", s), this.$emit("update:to-page", c), this.transitionName && this.transitionName !== "none" ? this.transitionPromise = {
          resolve: i,
          reject: l
        } : i(!0);
      });
    },
    refreshDisabledDays(t) {
      this.getPageDays(t).forEach((e) => {
        e.isDisabled = !!this.disabledAttribute && this.disabledAttribute.intersectsDay(e);
      });
    },
    refreshFocusableDays(t) {
      this.getPageDays(t).forEach((e) => {
        e.isFocusable = e.inMonth && e.day === this.focusableDay;
      });
    },
    getPageDays(t = this.pages) {
      return t.reduce((e, r) => e.concat(r.days), []);
    },
    getPageTransition(t, e, r = this.transition) {
      if (r === "none")
        return r;
      if (r === "fade" || !r && this.count > 1 || !pe(t) || !pe(e))
        return "fade";
      const n = w0(e, t);
      return r === "slide-v" ? n ? "slide-down" : "slide-up" : n ? "slide-right" : "slide-left";
    },
    getPageForAttributes() {
      let t = null;
      const e = this.store.pinAttr;
      if (e && e.hasDates) {
        let [r] = e.dates;
        r = r.start || r.date, t = this.pageForDate(r);
      }
      return t;
    },
    buildPage({ month: t, year: e }, r) {
      const n = `${e.toString()}-${t.toString()}`;
      let L = this.pages.find((i) => i.key === n);
      if (!L || r) {
        const i = new Date(e, t - 1, 15), l = this.$locale.getMonthComps(t, e), s = this.$locale.getPrevMonthComps(t, e), c = this.$locale.getNextMonthComps(t, e);
        L = {
          key: n,
          month: t,
          year: e,
          weeks: this.trimWeeks ? l.weeks : 6,
          title: this.$locale.format(i, this.$locale.masks.title),
          shortMonthLabel: this.$locale.format(i, "MMM"),
          monthLabel: this.$locale.format(i, "MMMM"),
          shortYearLabel: e.toString().substring(2),
          yearLabel: e.toString(),
          monthComps: l,
          prevMonthComps: s,
          nextMonthComps: c,
          canMove: (h) => this.canMove(h),
          move: (h) => this.move(h),
          moveThisMonth: () => this.moveThisMonth(),
          movePrevMonth: () => this.move(s),
          moveNextMonth: () => this.move(c),
          refresh: !0
        }, L.days = this.$locale.getCalendarDays(L);
      }
      return L;
    },
    initStore() {
      this.store = new kX(
        this.$theme,
        this.$locale,
        this.attributes
      ), this.refreshAttrs(this.pages, this.store.list, [], !0);
    },
    refreshAttrs(t = [], e = [], r = [], n) {
      Pe(t) && t.forEach((L) => {
        L.days.forEach((i) => {
          let l = !1, s = {};
          n ? l = !0 : dL(i.attributesMap, r) ? (s = hL(i.attributesMap, r), l = !0) : s = i.attributesMap || {}, e.forEach((c) => {
            const h = c.intersectsDay(i);
            if (h) {
              const f = V5(c5({}, c), {
                targetDate: h
              });
              s[c.key] = f, l = !0;
            }
          }), l && (i.attributesMap = s, i.shouldRefresh = !0);
        });
      });
    },
    handleKeydown(t) {
      const e = this.lastFocusedDay;
      e != null && (e.event = t, this.handleDayKeydown(e));
    },
    handleDayKeydown(t) {
      const { dateFromTime: e, event: r } = t, n = e(12);
      let L = null;
      switch (r.key) {
        case "ArrowLeft": {
          L = ut(n, -1);
          break;
        }
        case "ArrowRight": {
          L = ut(n, 1);
          break;
        }
        case "ArrowUp": {
          L = ut(n, -7);
          break;
        }
        case "ArrowDown": {
          L = ut(n, 7);
          break;
        }
        case "Home": {
          L = ut(n, -t.weekdayPosition + 1);
          break;
        }
        case "End": {
          L = ut(n, t.weekdayPositionFromEnd);
          break;
        }
        case "PageUp": {
          r.altKey ? L = q7(n, -1) : L = LL(n, -1);
          break;
        }
        case "PageDown": {
          r.altKey ? L = q7(n, 1) : L = LL(n, 1);
          break;
        }
      }
      L && (r.preventDefault(), this.focusDate(L).catch());
    }
  }
}, CX = {
  inheritAttrs: !1,
  emits: ["update:modelValue"],
  props: {
    options: Array,
    modelValue: null
  }
}, SX = { class: "vc-select" }, DX = ["value"], EX = ["value", "disabled"], IX = /* @__PURE__ */ w(
  "div",
  { class: "vc-select-arrow" },
  [
    /* @__PURE__ */ w(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20"
      },
      [
        /* @__PURE__ */ w("path", {
          d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        })
      ]
    )
  ],
  -1
);
function TX(t, e, r, n, L, i) {
  return G(), J("div", SX, [
    w(
      "select",
      zl(t.$attrs, {
        value: r.modelValue,
        onChange: e[0] || (e[0] = (l) => t.$emit("update:modelValue", l.target.value))
      }),
      [
        (G(!0), J(
          Be,
          null,
          G0(r.options, (l) => (G(), J(
            "option",
            {
              key: l.value,
              value: l.value,
              disabled: l.disabled
            },
            y5(l.label),
            9,
            EX
          ))),
          128
        ))
      ],
      16,
      DX
    ),
    IX
  ]);
}
const OX = /* @__PURE__ */ Kn(CX, [
  ["render", TX]
]), zX = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], PX = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
], AX = {
  name: "TimePicker",
  components: { TimeSelect: OX },
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: Object, required: !0 },
    locale: { type: Object, required: !0 },
    theme: { type: Object, required: !0 },
    is24hr: { type: Boolean, default: !0 },
    showBorder: Boolean,
    hourOptions: Array,
    minuteOptions: Array
  },
  computed: {
    date() {
      let t = this.locale.normalizeDate(this.modelValue);
      return this.modelValue.hours === 24 && (t = new Date(t.getTime() - 1)), t;
    },
    hours: {
      get() {
        return this.modelValue.hours;
      },
      set(t) {
        this.updateValue(t, this.minutes);
      }
    },
    minutes: {
      get() {
        return this.modelValue.minutes;
      },
      set(t) {
        this.updateValue(this.hours, t);
      }
    },
    isAM: {
      get() {
        return this.modelValue.hours < 12;
      },
      set(t) {
        let e = this.hours;
        t && e >= 12 ? e -= 12 : !t && e < 12 && (e += 12), this.updateValue(e, this.minutes);
      }
    },
    amHourOptions() {
      return zX.filter(
        (t) => this.hourOptions.some((e) => e.value === t.value)
      );
    },
    pmHourOptions() {
      return PX.filter(
        (t) => this.hourOptions.some((e) => e.value === t.value)
      );
    },
    hourOptions_() {
      return this.is24hr ? this.hourOptions : this.isAM ? this.amHourOptions : this.pmHourOptions;
    },
    amDisabled() {
      return !Pe(this.amHourOptions);
    },
    pmDisabled() {
      return !Pe(this.pmHourOptions);
    }
  },
  methods: {
    updateValue(t, e = this.minutes) {
      (t !== this.hours || e !== this.minutes) && this.$emit(
        "update:modelValue",
        V5(c5({}, this.modelValue), {
          hours: t,
          minutes: e,
          seconds: 0,
          milliseconds: 0
        })
      );
    }
  }
}, $X = /* @__PURE__ */ w(
  "div",
  null,
  [
    /* @__PURE__ */ w(
      "svg",
      {
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        viewBox: "0 0 24 24",
        class: "vc-time-icon",
        stroke: "currentColor"
      },
      [
        /* @__PURE__ */ w("path", {
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ]
    )
  ],
  -1
), ZX = { class: "vc-time-content" }, NX = {
  key: 0,
  class: "vc-time-date"
}, BX = { class: "vc-time-weekday" }, RX = { class: "vc-time-month" }, HX = { class: "vc-time-day" }, FX = { class: "vc-time-year" }, jX = { class: "vc-time-select" }, UX = /* @__PURE__ */ w(
  "span",
  { style: { margin: "0 4px" } },
  ":",
  -1
), YX = {
  key: 0,
  class: "vc-am-pm"
};
function VX(t, e, r, n, L, i) {
  const l = IL("time-select");
  return G(), J(
    "div",
    {
      class: N5([
        "vc-time-picker",
        [
          {
            "vc-invalid": !r.modelValue.isValid,
            "vc-bordered": r.showBorder
          }
        ]
      ])
    },
    [
      $X,
      w("div", ZX, [
        i.date ? (G(), J("div", NX, [
          w(
            "span",
            BX,
            y5(r.locale.format(i.date, "WWW")),
            1
          ),
          w(
            "span",
            RX,
            y5(r.locale.format(i.date, "MMM")),
            1
          ),
          w(
            "span",
            HX,
            y5(r.locale.format(i.date, "D")),
            1
          ),
          w(
            "span",
            FX,
            y5(r.locale.format(i.date, "YYYY")),
            1
          )
        ])) : _1("", !0),
        w("div", jX, [
          s5(
            l,
            {
              modelValue: i.hours,
              "onUpdate:modelValue": e[0] || (e[0] = (s) => i.hours = s),
              modelModifiers: { number: !0 },
              options: i.hourOptions_
            },
            null,
            8,
            ["modelValue", "options"]
          ),
          UX,
          s5(
            l,
            {
              modelValue: i.minutes,
              "onUpdate:modelValue": e[1] || (e[1] = (s) => i.minutes = s),
              modelModifiers: { number: !0 },
              options: r.minuteOptions
            },
            null,
            8,
            ["modelValue", "options"]
          ),
          r.is24hr ? _1("", !0) : (G(), J("div", YX, [
            w(
              "button",
              {
                class: N5({
                  active: i.isAM,
                  "vc-disabled": i.amDisabled
                }),
                onClick: e[2] || (e[2] = _4(
                  (s) => i.isAM = !0,
                  ["prevent"]
                )),
                type: "button"
              },
              " AM ",
              2
            ),
            w(
              "button",
              {
                class: N5({
                  active: !i.isAM,
                  "vc-disabled": i.pmDisabled
                }),
                onClick: e[3] || (e[3] = _4(
                  (s) => i.isAM = !1,
                  ["prevent"]
                )),
                type: "button"
              },
              " PM ",
              2
            )
          ]))
        ])
      ])
    ],
    2
  );
}
const WX = /* @__PURE__ */ Kn(AX, [
  ["render", VX]
]), ul = {
  type: "auto",
  mask: "iso",
  timeAdjust: ""
}, GX = [ul, ul], L4 = {
  DATE: "date",
  DATE_TIME: "datetime",
  TIME: "time"
}, de = {
  NONE: 0,
  START: 1,
  END: 2,
  BOTH: 3
}, cl = {
  name: "DatePicker",
  emits: [
    "update:modelValue",
    "drag",
    "dayclick",
    "daykeydown",
    "popover-will-show",
    "popover-did-show",
    "popover-will-hide",
    "popover-did-hide"
  ],
  render() {
    const t = (L, i) => {
      if (!this.$slots.footer)
        return L;
      const l = [L, this.$slots.footer()];
      return i ? C5(i, l) : l;
    }, e = () => {
      if (!this.dateParts)
        return null;
      const L = this.isRange ? this.dateParts : [this.dateParts[0]];
      return C5(
        "div",
        {},
        V5(c5({}, this.$slots), {
          default: () => L.map((i, l) => {
            const s = this.$locale.getHourOptions(
              this.modelConfig_[l].validHours,
              i
            ), c = this.$locale.getMinuteOptions(
              this.modelConfig_[l].minuteIncrement,
              i
            );
            return C5(WX, {
              modelValue: i,
              locale: this.$locale,
              theme: this.$theme,
              is24hr: this.is24hr,
              showBorder: !this.isTime,
              isDisabled: this.isDateTime && !i.isValid || this.isDragging,
              hourOptions: s,
              minuteOptions: c,
              "onUpdate:modelValue": (h) => this.onTimeInput(h, l === 0)
            });
          })
        })
      );
    }, r = () => C5(
      _X,
      V5(c5({}, this.$attrs), {
        attributes: this.attributes_,
        theme: this.$theme,
        locale: this.$locale,
        minDate: this.minDateExact || this.minDate,
        maxDate: this.maxDateExact || this.maxDate,
        disabledDates: this.disabledDates,
        availableDates: this.availableDates,
        onDayclick: this.onDayClick,
        onDaykeydown: this.onDayKeydown,
        onDaymouseenter: this.onDayMouseEnter,
        ref: "calendar"
      }),
      V5(c5({}, this.$slots), {
        footer: () => this.isDateTime ? t(e()) : t()
      })
    ), n = () => this.isTime ? C5(
      "div",
      {
        class: [
          "vc-container",
          `vc-${this.$theme.color}`,
          { "vc-is-dark": this.$theme.isDark }
        ]
      },
      t(e(), "div")
    ) : r();
    return this.$slots.default ? C5("div", [
      this.$slots.default(this.slotArgs),
      C5(
        fL,
        {
          id: this.datePickerPopoverId,
          placement: "bottom-start",
          contentClass: `vc-container${this.isDark ? " vc-is-dark" : ""}`,
          onBeforeShow: this.onBeforeShowHandler,
          onAfterShow: this.onAfterShowHandler,
          onBeforeHide: this.onBeforeHideHandler,
          onAfterHide: this.onAfterHideHandler,
          ref: "popover"
        },
        {
          default: n
        }
      )
    ]) : n();
  },
  mixins: [_h],
  props: {
    mode: { type: String, default: L4.DATE },
    modelValue: { type: null, required: !0 },
    modelConfig: { type: Object, default: () => ({}) },
    is24hr: Boolean,
    minuteIncrement: Number,
    isRequired: Boolean,
    isRange: Boolean,
    updateOnInput: {
      type: Boolean,
      default: () => Lr("datePicker.updateOnInput")
    },
    inputDebounce: {
      type: Number,
      default: () => Lr("datePicker.inputDebounce")
    },
    popover: { type: Object, default: () => ({}) },
    dragAttribute: Object,
    selectAttribute: Object,
    attributes: Array,
    validHours: [Object, Array, Function]
  },
  data() {
    return {
      value_: null,
      dateParts: null,
      activeDate: "",
      dragValue: null,
      inputValues: ["", ""],
      updateTimeout: null,
      watchValue: !0,
      datePickerPopoverId: B4()
    };
  },
  computed: {
    isDate() {
      return this.mode.toLowerCase() === L4.DATE;
    },
    isDateTime() {
      return this.mode.toLowerCase() === L4.DATE_TIME;
    },
    isTime() {
      return this.mode.toLowerCase() === L4.TIME;
    },
    isDragging() {
      return !!this.dragValue;
    },
    modelConfig_() {
      return this.normalizeConfig(this.modelConfig, GX);
    },
    inputMask() {
      const t = this.$locale.masks;
      return this.isTime ? this.is24hr ? t.inputTime24hr : t.inputTime : this.isDateTime ? this.is24hr ? t.inputDateTime24hr : t.inputDateTime : this.$locale.masks.input;
    },
    inputMaskHasTime() {
      return /[Hh]/g.test(this.inputMask);
    },
    inputMaskHasDate() {
      return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask);
    },
    inputMaskPatch() {
      if (this.inputMaskHasTime && this.inputMaskHasDate)
        return Jt.DATE_TIME;
      if (this.inputMaskHasDate)
        return Jt.DATE;
      if (this.inputMaskHasTime)
        return Jt.TIME;
    },
    slotArgs() {
      const {
        isRange: t,
        isDragging: e,
        updateValue: r,
        showPopover: n,
        hidePopover: L,
        togglePopover: i
      } = this, l = t ? {
        start: this.inputValues[0],
        end: this.inputValues[1]
      } : this.inputValues[0], s = [!0, !1].map(
        (h) => c5(
          {
            input: this.onInputInput(h),
            change: this.onInputChange(h),
            keyup: this.onInputKeyup
          },
          j4(
            V5(c5({}, this.popover_), {
              id: this.datePickerPopoverId,
              callback: (f) => {
                f.action === "show" && f.completed && this.onInputShow(h);
              }
            })
          )
        )
      ), c = t ? {
        start: s[0],
        end: s[1]
      } : s[0];
      return {
        inputValue: l,
        inputEvents: c,
        isDragging: e,
        updateValue: r,
        showPopover: n,
        hidePopover: L,
        togglePopover: i,
        getPopoverTriggerEvents: j4
      };
    },
    popover_() {
      return I3(this.popover, Lr("datePicker.popover"));
    },
    selectAttribute_() {
      if (!this.hasValue(this.value_))
        return null;
      const t = V5(
        c5(
          {
            key: "select-drag"
          },
          this.selectAttribute
        ),
        {
          dates: this.value_,
          pinPage: !0
        }
      ), { dot: e, bar: r, highlight: n, content: L } = t;
      return !e && !r && !n && !L && (t.highlight = !0), t;
    },
    dragAttribute_() {
      if (!this.isRange || !this.hasValue(this.dragValue))
        return null;
      const t = V5(
        c5(
          {
            key: "select-drag"
          },
          this.dragAttribute
        ),
        {
          dates: this.dragValue
        }
      ), { dot: e, bar: r, highlight: n, content: L } = t;
      return !e && !r && !n && !L && (t.highlight = {
        startEnd: {
          fillMode: "outline"
        }
      }), t;
    },
    attributes_() {
      const t = re(this.attributes) ? [...this.attributes] : [];
      return this.dragAttribute_ ? t.push(this.dragAttribute_) : this.selectAttribute_ && t.push(this.selectAttribute_), t;
    }
  },
  watch: {
    inputMask() {
      this.formatInput();
    },
    modelValue(t) {
      this.watchValue && this.forceUpdateValue(t, {
        config: this.modelConfig_,
        formatInput: !0,
        hidePopover: !1
      });
    },
    value_() {
      this.refreshDateParts();
    },
    dragValue() {
      this.refreshDateParts();
    },
    timezone() {
      this.refreshDateParts(), this.forceUpdateValue(this.value_, { formatInput: !0 });
    }
  },
  created() {
    this.value_ = this.normalizeValue(
      this.modelValue,
      this.modelConfig_,
      Jt.DATE_TIME,
      de.BOTH
    ), this.forceUpdateValue(this.modelValue, {
      config: this.modelConfig_,
      formatInput: !0,
      hidePopover: !1
    }), this.refreshDateParts();
  },
  mounted() {
    q1(document, "keydown", this.onDocumentKeyDown), q1(document, "click", this.onDocumentClick);
  },
  beforeUnmount() {
    K1(document, "keydown", this.onDocumentKeyDown), K1(document, "click", this.onDocumentClick);
  },
  methods: {
    onBeforeShowHandler(t) {
      this.$emit("popover-will-show", t);
    },
    onAfterShowHandler(t) {
      this.$emit("popover-did-show", t);
    },
    onBeforeHideHandler(t) {
      this.$emit("popover-will-hide", t);
    },
    onAfterHideHandler(t) {
      this.$emit("popover-did-hide", t);
    },
    getDateParts(t) {
      return this.$locale.getDateParts(t);
    },
    getDateFromParts(t) {
      return this.$locale.getDateFromParts(t);
    },
    refreshDateParts() {
      const t = this.dragValue || this.value_, e = [];
      this.isRange ? (t && t.start ? e.push(this.getDateParts(t.start)) : e.push({}), t && t.end ? e.push(this.getDateParts(t.end)) : e.push({})) : t ? e.push(this.getDateParts(t)) : e.push({}), this.$nextTick(() => this.dateParts = e);
    },
    onDocumentKeyDown(t) {
      this.dragValue && t.key === "Escape" && (this.dragValue = null);
    },
    onDocumentClick(t) {
      document.body.contains(t.target) && !D0(this.$el, t.target) && (this.dragValue = null, this.formatInput());
    },
    onDayClick(t) {
      this.handleDayClick(t), this.$emit("dayclick", t);
    },
    onDayKeydown(t) {
      switch (t.event.key) {
        case " ":
        case "Enter": {
          this.handleDayClick(t), t.event.preventDefault();
          break;
        }
        case "Escape":
          this.hidePopover();
      }
      this.$emit("daykeydown", t);
    },
    handleDayClick(t) {
      const { keepVisibleOnInput: e, visibility: r } = this.popover_, n = {
        patch: Jt.DATE,
        adjustTime: !0,
        formatInput: !0,
        hidePopover: this.isDate && !e && r !== "visible"
      };
      this.isRange ? (this.isDragging ? this.dragTrackingValue.end = t.date : this.dragTrackingValue = c5({}, t.range), n.isDragging = !this.isDragging, n.rangePriority = n.isDragging ? de.NONE : de.BOTH, n.hidePopover = n.hidePopover && !n.isDragging, this.updateValue(this.dragTrackingValue, n)) : (n.clearIfEqual = !this.isRequired, this.updateValue(t.date, n));
    },
    onDayMouseEnter(t) {
      this.isDragging && (this.dragTrackingValue.end = t.date, this.updateValue(this.dragTrackingValue, {
        patch: Jt.DATE,
        adjustTime: !0,
        formatInput: !0,
        hidePriority: !1,
        rangePriority: de.NONE
      }));
    },
    onTimeInput(t, e) {
      let r = null;
      if (this.isRange) {
        const n = e ? t : this.dateParts[0], L = e ? this.dateParts[1] : t;
        r = { start: n, end: L };
      } else
        r = t;
      this.updateValue(r, {
        patch: Jt.TIME,
        rangePriority: e ? de.START : de.END
      }).then(() => this.adjustPageRange(e));
    },
    onInputInput(t) {
      return (e) => {
        this.updateOnInput && this.onInputUpdate(e.target.value, t, {
          formatInput: !1,
          hidePopover: !1,
          debounce: this.inputDebounce
        });
      };
    },
    onInputChange(t) {
      return (e) => {
        this.onInputUpdate(e.target.value, t, {
          formatInput: !0,
          hidePopover: !1
        });
      };
    },
    onInputUpdate(t, e, r) {
      this.inputValues.splice(e ? 0 : 1, 1, t);
      const n = this.isRange ? {
        start: this.inputValues[0],
        end: this.inputValues[1] || this.inputValues[0]
      } : t, L = {
        type: "string",
        mask: this.inputMask
      };
      this.updateValue(
        n,
        V5(c5({}, r), {
          config: L,
          patch: this.inputMaskPatch,
          rangePriority: e ? de.START : de.END
        })
      ).then(() => this.adjustPageRange(e));
    },
    onInputShow(t) {
      this.adjustPageRange(t);
    },
    onInputKeyup(t) {
      t.key === "Escape" && this.updateValue(this.value_, {
        formatInput: !0,
        hidePopover: !0
      });
    },
    updateValue(t, e = {}) {
      return clearTimeout(this.updateTimeout), new Promise((r) => {
        const n = e, { debounce: L } = n, i = o$(n, ["debounce"]);
        L > 0 ? this.updateTimeout = setTimeout(() => {
          this.forceUpdateValue(t, i), r(this.value_);
        }, L) : (this.forceUpdateValue(t, i), r(this.value_));
      });
    },
    normalizeConfig(t, e = this.modelConfig_) {
      return t = re(t) ? t : [t.start || t, t.end || t], e.map(
        (r, n) => c5(
          c5(
            {
              validHours: this.validHours,
              minuteIncrement: this.minuteIncrement
            },
            r
          ),
          t[n]
        )
      );
    },
    forceUpdateValue(t, {
      config: e = this.modelConfig_,
      patch: r = Jt.DATE_TIME,
      clearIfEqual: n = !1,
      formatInput: L = !0,
      hidePopover: i = !1,
      isDragging: l = this.isDragging,
      rangePriority: s = de.BOTH
    } = {}) {
      e = this.normalizeConfig(e);
      let c = this.normalizeValue(
        t,
        e,
        r,
        s
      );
      !c && this.isRequired && (c = this.value_), c = this.adjustTimeForValue(c, e);
      const h = this.valueIsDisabled(c);
      if (h) {
        if (l)
          return;
        c = this.value_, i = !1;
      }
      const f = l ? "dragValue" : "value_";
      let g = !this.valuesAreEqual(this[f], c);
      if (!h && !g && n && (c = null, g = !0), g) {
        this[f] = c, l || (this.dragValue = null);
        const m = this.denormalizeValue(c), b = this.isDragging ? "drag" : "update:modelValue";
        this.watchValue = !1, this.$emit(b, m), this.$nextTick(() => this.watchValue = !0);
      }
      i && this.hidePopover(), L && this.formatInput();
    },
    hasValue(t) {
      return this.isRange ? Ae(t) && !!t.start && !!t.end : !!t;
    },
    normalizeValue(t, e, r, n) {
      if (!this.hasValue(t))
        return null;
      if (this.isRange) {
        const L = {}, i = t.start > t.end ? t.end : t.start;
        L.start = this.normalizeDate(
          i,
          V5(c5({}, e[0]), {
            fillDate: this.value_ && this.value_.start || e[0].fillDate,
            patch: r
          })
        );
        const l = t.start > t.end ? t.start : t.end;
        return L.end = this.normalizeDate(
          l,
          V5(c5({}, e[1]), {
            fillDate: this.value_ && this.value_.end || e[1].fillDate,
            patch: r
          })
        ), this.sortRange(L, n);
      }
      return this.normalizeDate(
        t,
        V5(c5({}, e[0]), {
          fillDate: this.value_ || e[0].fillDate,
          patch: r
        })
      );
    },
    adjustTimeForValue(t, e) {
      return this.hasValue(t) ? this.isRange ? {
        start: this.$locale.adjustTimeForDate(t.start, e[0]),
        end: this.$locale.adjustTimeForDate(t.end, e[1])
      } : this.$locale.adjustTimeForDate(t, e[0]) : null;
    },
    sortRange(t, e = de.NONE) {
      const { start: r, end: n } = t;
      if (r > n)
        switch (e) {
          case de.START:
            return { start: r, end: r };
          case de.END:
            return { start: n, end: n };
          case de.BOTH:
            return { start: n, end: r };
        }
      return { start: r, end: n };
    },
    denormalizeValue(t, e = this.modelConfig_) {
      return this.isRange ? this.hasValue(t) ? {
        start: this.$locale.denormalizeDate(t.start, e[0]),
        end: this.$locale.denormalizeDate(t.end, e[1])
      } : null : this.$locale.denormalizeDate(t, e[0]);
    },
    valuesAreEqual(t, e) {
      if (this.isRange) {
        const r = this.hasValue(t), n = this.hasValue(e);
        return !r && !n ? !0 : r !== n ? !1 : Si(t.start, e.start) && Si(t.end, e.end);
      }
      return Si(t, e);
    },
    valueIsDisabled(t) {
      return this.hasValue(t) && this.disabledAttribute && this.disabledAttribute.intersectsDate(t);
    },
    formatInput() {
      this.$nextTick(() => {
        const t = this.normalizeConfig({
          type: "string",
          mask: this.inputMask
        }), e = this.denormalizeValue(
          this.dragValue || this.value_,
          t
        );
        this.isRange ? this.inputValues = [e && e.start, e && e.end] : this.inputValues = [e, ""];
      });
    },
    showPopover(t = {}) {
      gL(
        V5(
          c5(
            c5(
              {
                ref: this.$el
              },
              this.popover_
            ),
            t
          ),
          {
            isInteractive: !0,
            id: this.datePickerPopoverId
          }
        )
      );
    },
    hidePopover(t = {}) {
      mL(
        V5(
          c5(
            c5(
              {
                hideDelay: 10
              },
              this.showPopover_
            ),
            t
          ),
          {
            id: this.datePickerPopoverId
          }
        )
      );
    },
    togglePopover(t) {
      Sh(
        V5(
          c5(
            c5(
              {
                ref: this.$el
              },
              this.popover_
            ),
            t
          ),
          {
            isInteractive: !0,
            id: this.datePickerPopoverId
          }
        )
      );
    },
    adjustPageRange(t) {
      this.$nextTick(() => {
        const e = this.$refs.calendar, r = this.getPageForValue(t), n = t ? 1 : -1;
        r && e && !wh(r, e.firstPage, e.lastPage) && e.move(r, {
          position: n,
          transition: "fade"
        });
      });
    },
    getPageForValue(t) {
      return this.hasValue(this.value_) ? this.pageForDate(
        this.isRange ? this.value_[t ? "start" : "end"] : this.value_
      ) : null;
    },
    move(t, e) {
      return this.$refs.calendar ? this.$refs.calendar.move(t, e) : Promise.reject(
        new Error("Navigation disabled while calendar is not yet displayed")
      );
    },
    focusDate(t, e) {
      return this.$refs.calendar ? this.$refs.calendar.focusDate(t, e) : Promise.reject(
        new Error("Navigation disabled while calendar is not yet displayed")
      );
    }
  }
}, qX = {}, KX = { d: "M12.7,4.8V15.4a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V4.8a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V14.9H11.7V4.8a.5.5,0,0,1,.5-.5A.5.5,0,0,1,12.7,4.8Zm-8.5,0v8a.5.5,0,0,0,.5.5.6.6,0,0,0,.5-.5v-8a.5.5,0,0,0-.5-.5A.5.5,0,0,0,4.2,4.8Zm3.4,0v8a.5.5,0,0,0,1,0v-8a.5.5,0,1,0-1,0ZM.5,2.7H12.2a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H9.6L8,0H4.8L3.1,1.7H.5a.5.5,0,0,0-.5.5A.5.5,0,0,0,.5,2.7Z" };
function JX(t, e) {
  return G(), J("path", KX);
}
const QX = /* @__PURE__ */ U5(qX, [["render", JX]]), XX = {
  class: "relative stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color fill-bl-panel-color dark:fill-bl-dk-panel-color",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, e55 = /* @__PURE__ */ Le('<g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="icon-calendar" x="0.5" y="1.9" width="15" height="13.58" rx="2"></rect><path d="M13.5,1.4h-1V.6a.7.7,0,0,0-.7-.6h0a.6.6,0,0,0-.6.6v.8H8.6V.6A.6.6,0,0,0,8,0H8a.6.6,0,0,0-.6.6v.8H4.8V.6A.6.6,0,0,0,4.2,0h0a.7.7,0,0,0-.7.6v.8h-1A2.5,2.5,0,0,0,0,3.9v9.6A2.5,2.5,0,0,0,2.5,16h11A2.5,2.5,0,0,0,16,13.5V3.9A2.5,2.5,0,0,0,13.5,1.4ZM15,13.5A1.5,1.5,0,0,1,13.5,15H2.5A1.5,1.5,0,0,1,1,13.5V3.9A1.5,1.5,0,0,1,2.5,2.4h1v.8a.7.7,0,0,0,.7.6h0a.6.6,0,0,0,.6-.6V2.4H7.4v.8a.6.6,0,0,0,.6.6H8a.6.6,0,0,0,.6-.6V2.4h2.6v.8a.6.6,0,0,0,.6.6h0a.7.7,0,0,0,.7-.6V2.4h1A1.5,1.5,0,0,1,15,3.9Z"></path><path d="M4.2,5.6a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.6.6.6,0,0,0,.6-.6A.7.7,0,0,0,4.2,5.6Z"></path><path d="M8,5.6c-.4,0-.6.3-.6.7a.6.6,0,1,0,1.2,0C8.6,5.9,8.4,5.6,8,5.6Z"></path><path d="M11.8,5.6a.7.7,0,0,0-.6.7.6.6,0,0,0,.6.6.7.7,0,0,0,.7-.6A.7.7,0,0,0,11.8,5.6Z"></path><path d="M4.2,8.7a.7.7,0,0,0-.7.6.7.7,0,0,0,.7.7.7.7,0,0,0,.6-.7A.6.6,0,0,0,4.2,8.7Z"></path><path d="M8,8.7a.6.6,0,0,0-.6.6c0,.4.2.7.6.7s.6-.3.6-.7A.6.6,0,0,0,8,8.7Z"></path><path d="M11.8,8.7a.6.6,0,0,0-.6.6.7.7,0,0,0,.6.7.7.7,0,0,0,.7-.7A.7.7,0,0,0,11.8,8.7Z"></path><path d="M4.2,11.8a.7.7,0,0,0-.7.6.7.7,0,0,0,.7.7.7.7,0,0,0,.6-.7A.6.6,0,0,0,4.2,11.8Z"></path><path d="M8,11.8a.6.6,0,0,0-.6.6c0,.4.2.7.6.7s.6-.3.6-.7A.6.6,0,0,0,8,11.8Z"></path><path d="M11.8,11.8a.6.6,0,0,0-.6.6.7.7,0,0,0,.6.7.7.7,0,0,0,.7-.7A.7.7,0,0,0,11.8,11.8Z"></path></g></g>', 1), t55 = [
  e55
], vL = /* @__PURE__ */ J5({
  __name: "IconCalendar",
  props: {
    hide: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, r) => ne((G(), J("svg", XX, t55, 512)), [
      [zt, !e.hide]
    ]);
  }
}), r55 = {}, n55 = { d: "M5.8,12.8.6,7.8a2.1,2.1,0,0,1,0-2.9,1.9,1.9,0,0,1,2.8,0L5.8,7.2,12.6.6a1.9,1.9,0,0,1,2.8,0,1.9,1.9,0,0,1,0,2.8Z" };
function o55(t, e) {
  return G(), J("path", n55);
}
const e45 = /* @__PURE__ */ U5(r55, [["render", o55]]), i55 = /* @__PURE__ */ w("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
}, null, -1), L55 = [
  i55
], a55 = /* @__PURE__ */ J5({
  __name: "IconChevronDown",
  props: {
    invert: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, r = u5(null);
    return g1(
      () => e.invert,
      (n, L) => {
        n !== L && r.value.classList.toggle("inverted");
      }
    ), (n, L) => (G(), J("svg", {
      ref_key: "refSvg",
      ref: r,
      class: "invertible",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, L55, 512));
  }
}), s55 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  viewBox: "0 0 23 23"
}, l55 = {
  id: "Group_990",
  "data-name": "Group 990",
  transform: "translate(-198.994 -796.994)"
}, u55 = {
  id: "Ellipse_140",
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  "data-name": "Ellipse 140",
  cx: "11.5",
  cy: "11.5",
  r: "11.5",
  transform: "translate(198.994 796.994)"
}, c55 = {
  id: "Group_959",
  "data-name": "Group 959",
  transform: "translate(206.543 805.142)"
}, t45 = /* @__PURE__ */ J5({
  __name: "IconChevronDoubleDown",
  props: {
    hideBackground: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, r = g5(
      () => e.hideBackground ? "stroke-bl-text-color dark:stroke-bl-dk-text-color" : "stroke-bl-panel-color dark:stroke-bl-dk-panel-color"
    );
    return (n, L) => (G(), J("svg", s55, [
      w("g", l55, [
        ne(w("circle", u55, null, 512), [
          [zt, !n.hideBackground]
        ]),
        w("g", c55, [
          w("path", {
            id: "Path_3",
            class: N5(r.value),
            "data-name": "Path 3",
            d: "M725.4,810.077l3.951,3.569,3.951-3.569",
            transform: "translate(-725.397 -804.976)",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-width": "2"
          }, null, 2),
          w("path", {
            id: "Path_386",
            class: N5(r.value),
            "data-name": "Path 386",
            d: "M725.4,810.077l3.951,3.569,3.951-3.569",
            transform: "translate(-725.397 -810.077)",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-width": "2"
          }, null, 2)
        ])
      ])
    ]));
  }
}), h55 = {}, d55 = {
  id: "Pfad_7045",
  "data-name": "Pfad 7045",
  d: "M12.4,5.6,5.9,12.1,3,9,9.4,2.6ZM0,15l5.2-2.4-2.8-3ZM14.7,1.7,13.3.3a1.2,1.2,0,0,0-1.6,0h-.1L11,1h0L10,2.1,12.9,5l.9-.8h0l.8-.8h.1a1.2,1.2,0,0,0,0-1.6Z"
};
function f55(t, e) {
  return G(), J("path", d55);
}
const r45 = /* @__PURE__ */ U5(h55, [["render", f55]]), p55 = {}, g55 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, m55 = /* @__PURE__ */ w("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"
}, null, -1), v55 = [
  m55
];
function y55(t, e) {
  return G(), J("svg", g55, v55);
}
const n45 = /* @__PURE__ */ U5(p55, [["render", y55]]), w55 = {}, b55 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "55.372",
  height: "38.491",
  viewBox: "0 0 55.372 38.491"
}, x55 = /* @__PURE__ */ Le('<g id="Group_1059" data-name="Group 1059" transform="translate(0.707 0.707)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1056" data-name="Group 1056" transform="translate(11.691 3.925)"><rect id="Rectangle_204" data-name="Rectangle 204" width="43" height="1" rx="0.5" transform="translate(-0.026 13.721)"></rect><rect id="Rectangle_206" data-name="Rectangle 206" width="43" height="1" rx="0.5" transform="translate(-0.026 27.721)"></rect><rect id="Rectangle_205" data-name="Rectangle 205" width="43" height="1" rx="0.5" transform="translate(-0.026 -0.279)"></rect></g><g id="Group_1048" data-name="Group 1048" transform="translate(0 37.076) rotate(-90)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1025" data-name="Group 1025" transform="translate(22.212 6.525) rotate(-90)"><path id="Path_391" data-name="Path 391" d="M0,3.263,3.263,0,6.525,3.263" transform="translate(6.525 14.864) rotate(180)" fill="none" stroke-linecap="round" stroke-width="1"></path><path id="Path_392" data-name="Path 392" d="M0,14.864V0" transform="translate(3.263)" fill="none" stroke-linecap="round" stroke-width="1"></path></g><g id="Group_1026" data-name="Group 1026" transform="translate(0 6.525) rotate(-90)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><path id="Path_391-2" data-name="Path 391" d="M0,0,3.263,3.263,6.525,0" transform="translate(6.525 3.263) rotate(180)" fill="none" stroke-linecap="round" stroke-width="1"></path><path id="Path_392-2" data-name="Path 392" d="M0,0V14.864" transform="translate(3.263)" fill="none" stroke-linecap="round" stroke-width="1"></path></g></g></g>', 1), k55 = [
  x55
];
function M55(t, e) {
  return G(), J("svg", b55, k55);
}
const _55 = /* @__PURE__ */ U5(w55, [["render", M55]]), C55 = {}, S55 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "55.372",
  height: "28.126",
  viewBox: "0 0 55.372 28.126"
}, D55 = /* @__PURE__ */ Le('<g id="Group_1058" data-name="Group 1058" transform="translate(0.707 0.725)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1057" data-name="Group 1057" transform="translate(11.691 6.015)"><rect id="Rectangle_204" data-name="Rectangle 204" width="43" height="1" rx="0.5" transform="translate(-0.026 6.761)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_206" data-name="Rectangle 206" width="43" height="1" rx="0.5" transform="translate(-0.026 12.761)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_205" data-name="Rectangle 205" width="43" height="1" rx="0.5" transform="translate(-0.026 0.761)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect></g><g id="Group_1051" data-name="Group 1051" transform="translate(0 -0.225)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1027" data-name="Group 1027" transform="translate(6.525 10.76) rotate(180)"><path id="Path_391" data-name="Path 391" d="M0,0,3.263,3.263,6.525,0" transform="translate(6.525 3.263) rotate(180)" stroke-linecap="round" stroke-width="1" fill="none"></path><path id="Path_392" data-name="Path 392" d="M0,0V10.76" transform="translate(3.263)" stroke-linecap="round" stroke-width="1" fill="none"></path></g><g id="Group_1050" data-name="Group 1050" transform="translate(6.525 27.126) rotate(180)"><path id="Path_391-2" data-name="Path 391" d="M0,3.263,3.263,0,6.525,3.263" transform="translate(6.525 10.76) rotate(180)" stroke-linecap="round" stroke-width="1" fill="none"></path><path id="Path_392-2" data-name="Path 392" d="M0,10.76V0" transform="translate(3.263 0)" stroke-linecap="round" stroke-width="1" fill="none"></path></g></g></g>', 1), E55 = [
  D55
];
function I55(t, e) {
  return G(), J("svg", S55, E55);
}
const T55 = /* @__PURE__ */ U5(C55, [["render", I55]]), O55 = {}, z55 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "53",
  height: "19",
  viewBox: "0 0 53 19"
}, P55 = /* @__PURE__ */ Le('<g id="Group_1055" data-name="Group 1055" transform="translate(-0.496 -0.991)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1014" data-name="Group 1014" transform="translate(10.522 1.169)"><rect id="Rectangle_204" data-name="Rectangle 204" width="43" height="2" rx="1" transform="translate(-0.026 7.822)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_206" data-name="Rectangle 206" width="43" height="2" rx="1" transform="translate(-0.026 16.822)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_205" data-name="Rectangle 205" width="43" height="2" rx="1" transform="translate(-0.026 -0.178)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect></g><g id="Group_1046" data-name="Group 1046" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><rect id="Rectangle_207" data-name="Rectangle 207" width="14.096" height="0.01" rx="1" transform="translate(2.5 17.57) rotate(-90)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><circle id="Ellipse_244" data-name="Ellipse 244" cx="2" cy="2" r="2" transform="translate(0.496 0.991)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></circle><circle id="Ellipse_245" data-name="Ellipse 245" cx="2" cy="2" r="2" transform="translate(0.496 15.991)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></circle></g></g>', 1), A55 = [
  P55
];
function $55(t, e) {
  return G(), J("svg", z55, A55);
}
const Z55 = /* @__PURE__ */ U5(O55, [["render", $55]]), N55 = {}, B55 = /* @__PURE__ */ w("path", { d: "M15.6,11.7a1.6,1.6,0,0,0-1.1-.5,1.3,1.3,0,0,0-1,.4L8,16.7,2.5,11.6a1.5,1.5,0,0,0-2.1.1,1.5,1.5,0,0,0,.1,2.1L8,20.7l7.5-6.9A1.5,1.5,0,0,0,15.6,11.7Z" }, null, -1), R55 = /* @__PURE__ */ w("path", { d: "M8,3.5A1.7,1.7,0,0,0,9.8,1.8a1.8,1.8,0,0,0-3.6,0A1.7,1.7,0,0,0,8,3.5Z" }, null, -1), H55 = /* @__PURE__ */ w("circle", {
  cx: "8",
  cy: "6.7",
  r: "1"
}, null, -1), F55 = /* @__PURE__ */ w("circle", {
  cx: "8",
  cy: "11.7",
  r: "1"
}, null, -1), j55 = [
  B55,
  R55,
  H55,
  F55
];
function U55(t, e) {
  return G(), J("g", null, j55);
}
const o45 = /* @__PURE__ */ U5(N55, [["render", U55]]), Y55 = {}, V55 = { d: "M13,6.5A1.5,1.5,0,0,1,11.5,8H8v3.5A1.5,1.5,0,0,1,6.5,13,1.5,1.5,0,0,1,5,11.5V8H1.5A1.5,1.5,0,0,1,0,6.5,1.5,1.5,0,0,1,1.5,5H5V1.5A1.5,1.5,0,0,1,6.5,0,1.5,1.5,0,0,1,8,1.5V5h3.5A1.5,1.5,0,0,1,13,6.5Z" };
function W55(t, e) {
  return G(), J("path", V55);
}
const i45 = /* @__PURE__ */ U5(Y55, [["render", W55]]), G55 = {}, q55 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, K55 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1120.45,571.25L1121.05,573.25L1120.35,576.35L1121.25,579.35L1120.35,581.75L1120.75,583.95L1109.05,583.85L1108.25,604.35L1111.85,609.55L1115.45,613.55L1105.05,616.15L1091.55,615.25L1087.75,612.25L1065.05,612.45L1064.25,612.95L1060.95,610.05L1057.35,609.85L1053.95,610.95L1051.25,612.15L1050.75,608.15L1051.65,602.45L1053.65,596.55L1053.95,593.85L1055.85,588.05L1057.25,585.45L1060.55,581.25L1062.45,578.35L1063.05,573.65L1062.75,569.95L1061.15,567.65L1059.65,563.75L1058.35,559.95L1058.65,558.55L1060.35,556.05L1058.75,549.85L1057.55,545.55L1054.75,541.45L1055.35,540.25L1057.65,539.35L1059.35,539.45L1061.35,538.75L1078.05,538.85L1079.35,543.55L1080.95,547.45L1082.25,549.55L1084.35,552.85L1088.15,552.35L1089.95,551.45L1093.05,552.35L1093.95,550.75L1095.45,547.05L1098.95,546.75L1099.25,545.65L1102.15,545.65L1101.65,547.95L1108.45,547.85L1108.55,551.95L1109.65,554.35L1108.75,558.25L1109.15,562.25L1110.95,564.65L1110.55,572.25L1111.95,571.65L1114.35,571.85L1117.85,570.85L1120.45,571.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1054.55,538.25L1053.05,533.45L1055.35,530.65L1057.05,529.55L1059.15,531.75L1057.15,533.15L1056.15,534.75L1055.95,537.55L1054.55,538.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BJ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1005.95,426.25L1005.75,428.35L1007.05,432.15L1005.95,434.75L1006.55,436.45L1003.75,440.45L1002.05,442.45L1000.95,446.45L1001.15,450.55L1000.85,460.85L996.15,461.65L994.75,457.25L995.05,442.45L993.85,441.15L993.65,437.95L991.65,435.75L989.95,433.85L990.65,430.45L992.65,429.75L993.75,426.95L996.55,426.35L997.75,424.45L999.65,422.55L1001.65,422.55L1005.95,426.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BF" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M987.75,405.25L987.25,408.35L988.05,411.25L991.15,415.45L991.35,418.55L997.85,420.05L997.75,424.45L996.55,426.35L993.75,426.95L992.65,429.75L990.65,430.45L985.75,430.35L983.15,429.85L981.35,430.85L978.85,430.35L969.05,430.65L968.85,434.35L969.65,439.15L965.75,437.55L963.15,437.75L961.15,439.35L958.65,438.05L957.65,435.85L955.15,434.45L954.75,430.75L956.35,428.05L956.15,425.85L960.65,420.55L961.55,416.15L963.05,414.55L965.75,415.45L968.15,414.15L968.95,412.45L973.25,409.65L974.35,407.65L979.65,404.95L982.75,404.05L984.15,405.25L987.75,405.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1126.85,614.95L1128.75,620.05L1129.85,621.25L1131.45,624.95L1137.55,631.95L1139.85,632.65L1139.75,634.95L1141.25,639.05L1145.55,640.05L1148.95,642.95L1140.85,647.65L1135.65,652.45L1133.65,656.75L1131.85,659.15L1128.85,659.65L1127.65,662.75L1127.05,664.75L1123.45,666.15L1118.95,665.85L1116.45,664.05L1114.15,663.35L1111.35,664.75L1109.85,667.85L1107.15,669.75L1104.35,672.65L1100.35,673.35L1099.25,671.05L1099.85,667.15L1096.85,661.05L1095.45,660.05L1096.05,641.35L1101.55,641.15L1102.35,618.25L1106.55,618.05L1115.25,615.75L1117.25,618.45L1120.95,615.95L1122.65,615.95L1125.85,614.45L1126.85,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CF" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1120.55,445.75L1124.45,448.25L1127.55,450.85L1127.65,452.95L1131.55,456.25L1133.95,459.05L1135.35,462.85L1139.65,465.45L1140.55,467.45L1138.75,468.15L1135.05,468.05L1130.85,467.35L1128.75,467.85L1127.85,469.45L1126.05,469.65L1123.85,468.25L1117.55,471.45L1114.95,470.85L1114.15,471.35L1112.55,475.25L1108.25,473.95L1104.15,473.35L1100.55,470.95L1095.85,468.75L1092.85,470.85L1090.65,474.05L1090.15,478.55L1086.55,478.25L1082.65,477.15L1079.35,480.55L1076.35,486.55L1075.75,484.65L1075.45,481.75L1072.85,479.65L1070.75,476.35L1070.25,474.05L1067.55,470.65L1068.05,468.75L1067.45,466.05L1067.85,461.05L1069.25,459.95L1072.05,453.45L1076.65,452.95L1077.65,451.25L1078.65,451.45L1080.05,452.85L1087.15,450.45L1089.55,447.95L1092.45,445.65L1091.85,443.45L1093.45,442.85L1098.95,443.25L1104.15,440.25L1108.15,433.25L1110.95,430.65L1114.55,429.55L1115.25,432.25L1118.55,436.25L1118.55,438.95L1117.75,441.55L1118.15,443.55L1120.05,445.45L1120.55,445.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CI" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M955.15,434.45L957.65,435.85L958.65,438.05L961.15,439.35L963.15,437.75L965.75,437.55L969.65,439.15L971.15,448.35L968.75,453.65L967.25,460.95L969.65,466.45L969.45,469.05L966.85,469.05L962.95,467.85L959.25,467.85L952.55,469.05L948.65,470.85L943.05,473.25L941.95,473.05L942.35,467.75L942.95,466.95L942.75,464.45L940.35,461.75L938.55,461.35L936.95,459.55L938.15,456.65L937.65,453.55L937.85,451.75L938.75,451.75L939.15,448.95L938.75,447.65L939.25,446.75L941.35,446.05L939.95,440.85L938.65,438.25L939.15,436.05L940.25,435.55L941.05,434.95L942.55,435.95L946.95,435.95L947.95,434.15L948.95,434.25L950.55,433.55L951.45,436.25L952.75,435.45L955.15,434.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CM" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1072.05,453.45L1069.25,459.95L1067.85,461.05L1067.45,466.05L1068.05,468.75L1067.55,470.65L1070.25,474.05L1070.75,476.35L1072.85,479.65L1075.45,481.75L1075.75,484.65L1076.35,486.55L1075.95,489.95L1071.45,488.45L1066.85,486.75L1059.75,486.55L1059.05,486.15L1055.65,486.95L1052.25,486.15L1049.55,486.55L1040.25,486.45L1041.15,481.35L1038.85,477.05L1036.25,476.05L1035.15,473.15L1033.65,472.25L1033.75,470.45L1035.15,465.85L1037.85,459.65L1039.45,459.65L1042.85,455.85L1044.95,455.75L1048.15,458.45L1052.05,456.25L1052.55,453.55L1053.85,450.95L1054.65,447.75L1057.65,445.15L1058.75,440.65L1059.95,439.15L1060.75,435.85L1062.15,431.75L1066.85,426.75L1067.15,424.65L1067.75,423.45L1065.45,420.95L1065.65,418.85L1067.15,418.55L1069.45,422.65L1069.95,426.85L1069.75,431.15L1072.95,436.95L1069.75,436.95L1068.15,437.35L1065.55,436.75L1064.35,439.75L1067.75,443.55L1070.25,444.65L1071.05,447.25L1072.85,451.65L1072.05,453.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CD" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1140.55,467.45L1144.05,472.75L1146.65,473.55L1148.15,472.45L1150.75,472.85L1153.85,471.55L1155.25,474.25L1160.35,478.55L1160.05,486.05L1162.35,486.95L1160.45,489.15L1158.35,490.95L1156.15,494.25L1154.95,497.25L1154.65,502.35L1153.35,504.85L1153.25,509.65L1151.65,511.45L1151.45,515.25L1150.65,515.75L1150.05,519.35L1151.45,522.25L1151.55,523.25L1150.35,533.55L1151.85,537.15L1150.85,539.85L1152.65,544.45L1156.05,547.95L1156.75,551.45L1158.35,553.15L1158.05,554.25L1157.15,553.95L1149.45,555.05L1147.95,555.85L1146.25,559.95L1147.45,562.75L1146.35,570.35L1145.45,576.75L1146.95,577.95L1150.85,580.45L1152.45,579.25L1152.65,586.15L1148.35,586.15L1146.15,582.65L1144.15,579.85L1139.85,578.95L1138.65,575.65L1135.15,577.65L1130.75,576.75L1128.85,573.85L1125.35,573.25L1122.65,573.35L1122.35,571.35L1120.45,571.25L1117.85,570.85L1114.35,571.85L1111.95,571.65L1110.55,572.25L1110.95,564.65L1109.15,562.25L1108.75,558.25L1109.65,554.35L1108.55,551.95L1108.45,547.85L1101.65,547.95L1102.15,545.65L1099.25,545.65L1098.95,546.75L1095.45,547.05L1093.95,550.75L1093.05,552.35L1089.95,551.45L1088.15,552.35L1084.35,552.85L1082.25,549.55L1080.95,547.45L1079.35,543.55L1078.05,538.85L1061.35,538.75L1059.35,539.45L1057.65,539.35L1055.35,540.25L1054.55,538.25L1055.95,537.55L1056.15,534.75L1057.15,533.15L1059.15,531.75L1060.65,532.45L1062.65,529.95L1065.75,530.05L1066.05,531.85L1068.15,532.95L1071.55,528.95L1074.85,525.85L1076.25,523.75L1076.15,518.45L1078.65,512.25L1081.25,508.95L1084.95,505.85L1085.65,503.85L1085.75,501.45L1086.65,499.25L1086.35,495.55L1087.05,489.85L1088.15,485.85L1089.85,482.45L1090.15,478.55L1090.65,474.05L1092.85,470.85L1095.85,468.75L1100.55,470.95L1104.15,473.35L1108.25,473.95L1112.55,475.25L1114.15,471.35L1114.95,470.85L1117.55,471.45L1123.85,468.25L1126.05,469.65L1127.85,469.45L1128.75,467.85L1130.85,467.35L1135.05,468.05L1138.75,468.15L1140.55,467.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1090.15,478.55L1089.85,482.45L1088.15,485.85L1087.05,489.85L1086.35,495.55L1086.65,499.25L1085.75,501.45L1085.65,503.85L1084.95,505.85L1081.25,508.95L1078.65,512.25L1076.15,518.45L1076.25,523.75L1074.85,525.85L1071.55,528.95L1068.15,532.95L1066.05,531.85L1065.75,530.05L1062.65,529.95L1060.65,532.45L1059.15,531.75L1057.05,529.55L1055.35,530.65L1053.05,533.45L1048.45,526.65L1052.75,523.05L1050.65,518.85L1052.65,517.25L1056.45,516.45L1056.85,513.55L1059.95,516.65L1064.95,516.95L1066.65,513.95L1067.35,509.65L1066.75,504.65L1064.05,500.85L1066.55,493.35L1065.15,492.15L1060.95,492.65L1059.35,489.35L1059.75,486.55L1066.85,486.75L1071.45,488.45L1075.95,489.95L1076.35,486.55L1079.35,480.55L1082.65,477.15L1086.55,478.25L1090.15,478.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DJ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1228.75,427.45L1226.85,430.95L1225.55,429.75L1224.25,430.25L1221.05,430.15L1220.85,428.15L1220.35,426.35L1222.15,423.35L1224.05,420.55L1226.45,421.15L1228.15,419.55L1229.55,421.55L1229.45,424.15L1226.35,425.75L1228.75,427.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1030.25,263.85L1029.25,267.15L1030.25,273.25L1029.15,278.55L1025.95,282.15L1026.55,286.95L1031.05,290.85L1031.15,292.35L1034.55,294.95L1037.15,306.45L1039.05,312.15L1039.45,315.15L1038.65,320.35L1039.05,323.35L1038.45,326.85L1039.05,330.85L1036.85,333.55L1040.25,338.25L1040.45,340.95L1042.55,344.55L1045.05,343.35L1049.55,346.35L1052.05,350.35L1033.25,362.65L1017.25,375.25L1009.45,378.05L1003.25,378.75L1003.15,374.65L1000.55,373.55L997.05,371.75L995.75,368.75L977.05,354.75L958.45,340.75L937.95,325.15L938.05,323.95L938.15,323.55L938.25,315.95L947.15,311.15L952.55,310.15L957.05,308.45L959.15,305.25L965.55,302.75L965.85,297.95L968.95,297.35L971.45,295.05L978.55,293.95L979.55,291.45L978.15,290.05L976.25,283.25L975.95,279.35L974.05,275.25L979.15,271.75L984.95,270.65L988.25,268.05L993.35,266.05L1002.35,264.95L1011.15,264.45L1013.85,265.35L1018.75,262.85L1024.45,262.75L1026.65,264.25L1030.25,263.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1171.35,300.65L1175.25,310.05L1175.95,311.65L1174.65,314.25L1173.95,319.05L1172.75,322.45L1171.55,323.55L1169.55,321.45L1166.85,318.65L1162.15,309.45L1161.65,310.05L1164.45,316.75L1168.35,323.25L1173.25,333.25L1175.55,336.75L1177.55,340.35L1182.95,347.45L1181.95,348.55L1182.35,352.75L1189.15,358.55L1190.25,359.85L1124.35,359.85L1123.35,336.15L1122.05,313.35L1120.05,308.15L1121.15,304.25L1120.15,301.45L1121.85,298.35L1129.05,298.25L1134.45,299.95L1139.95,301.85L1142.55,302.85L1146.55,300.85L1148.65,299.05L1153.35,298.45L1157.25,299.25L1159.05,302.45L1160.15,300.35L1164.55,301.85L1168.85,302.25L1171.35,300.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ER" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1228.15,419.55L1226.45,421.15L1224.05,420.55L1222.05,418.45L1219.55,414.75L1216.95,412.65L1215.45,410.45L1210.45,407.85L1206.55,407.75L1205.15,406.45L1201.95,407.95L1198.35,405.05L1196.85,409.85L1190.25,408.45L1189.55,405.95L1191.55,396.45L1191.85,392.25L1193.55,390.25L1197.55,389.15L1200.25,385.55L1203.85,392.95L1205.75,398.85L1208.95,401.95L1216.95,408.05L1220.25,411.65L1223.45,415.45L1225.25,417.65L1228.15,419.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ET" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1206.55,407.75L1210.45,407.85L1215.45,410.45L1216.95,412.65L1219.55,414.75L1222.05,418.45L1224.05,420.55L1222.15,423.35L1220.35,426.35L1220.85,428.15L1221.05,430.15L1224.25,430.25L1225.55,429.75L1226.85,430.95L1225.65,433.15L1227.85,436.75L1230.05,439.85L1232.25,442.15L1250.95,449.75L1255.75,449.65L1240.15,468.95L1232.85,469.25L1227.85,473.75L1224.25,473.85L1222.75,475.95L1218.85,475.95L1216.55,473.75L1211.35,476.45L1209.75,479.15L1205.95,478.55L1204.65,477.85L1203.35,478.05L1201.55,477.95L1194.35,472.55L1190.35,472.55L1188.45,470.45L1188.35,466.85L1185.45,465.75L1181.95,458.75L1179.35,457.25L1178.35,454.65L1175.35,451.55L1171.85,451.05L1173.75,447.45L1176.75,447.25L1177.55,445.35L1177.35,440.35L1177.35,439.55L1178.85,432.85L1181.45,431.05L1181.95,428.45L1184.25,423.45L1187.55,420.35L1189.55,413.95L1190.25,408.45L1196.85,409.85L1198.35,405.05L1201.95,407.95L1205.15,406.45L1206.55,407.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1059.75,486.55L1059.35,489.35L1060.95,492.65L1065.15,492.15L1066.55,493.35L1064.05,500.85L1066.75,504.65L1067.35,509.65L1066.65,513.95L1064.95,516.95L1059.95,516.65L1056.85,513.55L1056.45,516.45L1052.65,517.25L1050.65,518.85L1052.75,523.05L1048.45,526.65L1042.65,520.15L1038.95,514.85L1035.45,508.25L1035.65,506.05L1036.95,504.05L1038.25,499.35L1039.45,494.55L1041.35,494.25L1049.55,494.25L1049.55,486.55L1052.25,486.15L1055.65,486.95L1059.05,486.15L1059.75,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GH" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M985.75,430.35L985.35,432.35L987.65,435.65L987.65,440.35L988.25,445.35L989.65,447.75L988.35,453.45L988.85,456.65L990.35,460.75L991.65,463.05L982.75,466.75L979.55,468.95L974.45,470.85L969.45,469.05L969.65,466.45L967.25,460.95L968.75,453.65L971.15,448.35L969.65,439.15L968.85,434.35L969.05,430.65L978.85,430.35L981.35,430.85L983.15,429.85L985.75,430.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GN" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M920.75,421.15L921.05,423.55L921.95,423.55L923.45,422.65L924.35,422.85L925.95,424.55L928.35,425.05L929.85,423.65L931.75,422.75L933.05,421.85L934.15,422.05L935.45,423.45L936.05,425.25L938.35,427.95L937.25,429.55L936.95,431.65L938.15,431.05L938.85,431.75L938.55,433.65L940.25,435.55L939.15,436.05L938.65,438.25L939.95,440.85L941.35,446.05L939.25,446.75L938.75,447.65L939.15,448.95L938.75,451.75L937.85,451.75L936.25,451.55L935.15,454.15L933.55,454.15L932.45,452.75L932.85,450.15L930.45,446.25L929.05,446.95L927.75,447.15L926.25,447.45L926.35,445.15L925.45,443.45L925.65,441.55L924.45,438.85L922.85,436.55L918.35,436.55L917.05,437.75L915.45,437.95L914.45,439.35L913.85,441.05L910.75,443.95L908.35,440.15L906.15,437.65L904.75,436.75L903.35,435.45L902.75,432.65L901.95,431.25L900.25,430.15L902.85,427.05L904.55,427.15L906.05,426.15L907.25,426.05L908.15,425.25L907.75,423.15L908.35,422.45L908.45,420.25L911.15,420.35L915.25,421.85L916.45,421.75L916.85,421.05L919.95,421.55L920.75,421.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GM" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M890.85,416.65L891.65,413.75L897.75,413.65L899.05,412.05L900.85,411.95L903.05,413.55L904.75,413.55L906.65,412.55L907.75,414.35L905.25,415.85L902.85,415.65L900.45,414.35L898.35,415.85L897.35,415.85L895.95,416.75L890.85,416.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M908.45,420.25L908.35,422.45L907.75,423.15L908.15,425.25L907.25,426.05L906.05,426.15L904.55,427.15L902.85,427.05L900.25,430.15L897.35,427.55L894.95,427.05L893.65,425.25L893.75,424.25L892.05,422.95L891.65,421.55L894.65,420.55L896.55,420.75L898.05,419.95L908.45,420.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GQ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1049.55,486.55L1049.55,494.25L1041.35,494.25L1039.45,494.55L1038.35,493.65L1040.25,486.45L1049.55,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KE" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1222.75,475.95L1217.85,483.15L1218.05,506.55L1221.35,511.85L1217.35,514.45L1215.95,517.15L1213.75,517.55L1212.95,522.15L1211.05,524.75L1209.95,528.95L1207.65,531.05L1199.55,524.65L1199.25,520.95L1178.75,507.85L1179.15,503.15L1177.75,500.65L1177.75,500.35L1179.35,497.75L1182.15,493.55L1184.25,488.85L1181.65,481.45L1180.95,478.25L1178.25,473.75L1181.65,469.95L1185.45,465.75L1188.35,466.85L1188.45,470.45L1190.35,472.55L1194.35,472.55L1201.55,477.95L1203.35,478.05L1204.65,477.85L1205.95,478.55L1209.75,479.15L1211.35,476.45L1216.55,473.75L1218.85,475.95L1222.75,475.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LR" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M937.85,451.75L937.65,453.55L938.15,456.65L936.95,459.55L938.55,461.35L940.35,461.75L942.75,464.45L942.95,466.95L942.35,467.75L941.95,473.05L940.45,473.15L934.65,470.05L929.45,465.15L924.65,461.65L920.85,457.55L922.25,455.45L922.55,453.55L925.15,450.15L927.75,447.15L929.05,446.95L930.45,446.25L932.85,450.15L932.45,452.75L933.55,454.15L935.15,454.15L936.25,451.55L937.85,451.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LY" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1121.85,298.35L1120.15,301.45L1121.15,304.25L1120.05,308.15L1122.05,313.35L1123.35,336.15L1124.35,359.85L1124.85,372.65L1118.45,372.65L1118.45,375.35L1095.85,363.05L1073.35,350.75L1067.85,354.25L1064.05,356.65L1060.85,353.15L1052.05,350.35L1049.55,346.35L1045.05,343.35L1042.55,344.55L1040.45,340.95L1040.25,338.25L1036.85,333.55L1039.05,330.85L1038.45,326.85L1039.05,323.35L1038.65,320.35L1039.45,315.15L1039.05,312.15L1037.15,306.45L1039.75,305.05L1040.15,302.25L1039.55,299.65L1043.15,297.15L1044.75,295.05L1047.35,293.25L1047.45,288.35L1053.85,290.55L1056.15,289.95L1060.65,291.05L1067.95,293.95L1070.75,299.65L1075.65,300.85L1083.45,303.55L1089.45,306.75L1091.95,305.05L1094.45,302.15L1092.85,297.25L1094.35,294.05L1098.05,291.05L1101.75,290.25L1109.15,291.55L1111.15,294.35L1113.15,294.45L1114.95,295.55L1120.35,296.25L1121.85,298.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LS" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1138.35,697.15L1136.35,697.85L1132.65,692.85L1135.85,688.85L1138.95,686.35L1141.65,684.95L1143.85,686.95L1145.55,688.95L1143.65,692.05L1142.55,694.15L1139.45,695.15L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M974.05,275.25L975.95,279.35L976.25,283.25L978.15,290.05L979.55,291.45L978.55,293.95L971.45,295.05L968.95,297.35L965.85,297.95L965.55,302.75L959.15,305.25L957.05,308.45L952.55,310.15L947.15,311.15L938.25,315.95L938.15,323.55L937.25,323.55L937.35,326.95L933.95,327.15L932.15,328.65L929.65,328.65L927.65,327.75L923.05,328.45L921.15,333.45L919.35,333.95L916.65,342.05L908.75,348.95L906.75,357.85L904.35,360.75L903.65,363.05L891.15,363.55L891.05,363.55L891.35,360.55L893.55,358.85L895.45,355.45L895.15,353.25L897.15,348.75L900.35,344.65L902.25,343.65L903.85,339.95L904.05,336.45L906.15,332.55L909.95,330.15L913.55,323.65L913.65,323.55L916.55,321.05L921.65,320.35L926.05,315.95L928.85,314.25L933.55,308.85L932.35,300.95L934.55,295.35L935.45,291.95L939.05,287.65L944.45,284.75L948.55,282.05L952.25,275.45L954.05,271.45L957.95,271.55L961.05,274.25L966.15,273.85L971.65,275.25L974.05,275.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1267.15,588.15L1267.55,595.85L1268.85,598.85L1268.15,601.95L1266.95,603.75L1265.35,600.05L1264.15,601.95L1264.95,606.65L1264.25,609.45L1262.55,610.85L1261.85,616.35L1259.15,623.85L1255.75,632.65L1251.45,644.85L1248.55,653.75L1245.45,661.25L1240.85,662.75L1235.75,665.45L1232.75,663.85L1228.55,661.55L1227.35,658.15L1227.35,652.45L1225.85,647.35L1225.65,642.65L1226.95,638.05L1229.55,636.95L1229.75,634.85L1232.65,629.95L1233.45,625.85L1232.35,622.85L1231.55,618.75L1231.45,612.85L1233.65,609.25L1234.65,605.15L1237.45,604.95L1240.65,603.65L1242.85,602.45L1245.25,602.35L1248.65,598.75L1253.55,594.75L1255.35,591.55L1254.75,588.75L1257.15,589.55L1260.45,585.15L1260.75,581.25L1262.75,578.35L1264.55,581.15L1265.95,583.85L1267.15,588.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ML" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1009.45,378.05L1009.55,392.85L1006.45,397.15L1006.05,401.15L1001.05,402.15L993.35,402.65L991.35,404.95L987.75,405.25L984.15,405.25L982.75,404.05L979.65,404.95L974.35,407.65L973.25,409.65L968.95,412.45L968.15,414.15L965.75,415.45L963.05,414.55L961.55,416.15L960.65,420.55L956.15,425.85L956.35,428.05L954.75,430.75L955.15,434.45L952.75,435.45L951.45,436.25L950.55,433.55L948.95,434.25L947.95,434.15L946.95,435.95L942.55,435.95L941.05,434.95L940.25,435.55L938.55,433.65L938.85,431.75L938.15,431.05L936.95,431.65L937.25,429.55L938.35,427.95L936.05,425.25L935.45,423.45L934.15,422.05L933.05,421.85L931.75,422.75L929.85,423.65L928.35,425.05L925.95,424.55L924.35,422.85L923.45,422.65L921.95,423.55L921.05,423.55L920.75,421.15L921.05,419.15L920.55,416.75L918.55,414.95L917.45,411.25L917.25,407.25L919.15,406.05L920.15,402.25L921.95,402.15L925.85,403.95L929.05,402.65L931.15,403.05L932.05,401.65L954.55,401.55L955.85,397.05L954.85,396.25L952.35,368.55L949.95,340.85L958.45,340.75L977.05,354.75L995.75,368.75L997.05,371.75L1000.55,373.55L1003.15,374.65L1003.25,378.75L1009.45,378.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1165.95,672.75L1161.85,672.75L1161.55,669.85L1160.95,666.95L1160.55,664.65L1161.95,657.55L1160.85,652.95L1158.65,643.95L1164.85,636.65L1166.55,632.05L1167.35,631.45L1168.25,627.65L1167.45,625.75L1167.85,620.95L1169.15,616.55L1169.55,608.35L1166.75,606.35L1164.05,605.85L1162.95,604.25L1160.35,602.95L1155.65,603.05L1155.45,600.65L1155.05,596.05L1172.25,590.75L1175.45,593.85L1176.95,593.25L1179.15,594.85L1179.35,597.45L1178.05,600.45L1178.25,604.95L1181.75,608.95L1183.65,604.45L1186.15,603.15L1186.05,594.85L1183.85,590.25L1181.95,588.15L1181.55,588.15L1180.95,580.85L1182.45,574.75L1184.65,574.55L1191.35,576.35L1192.85,575.55L1196.75,575.35L1198.85,573.45L1202.25,573.55L1208.45,571.05L1213.05,567.35L1213.95,570.15L1213.45,576.55L1213.95,582.25L1213.75,592.25L1214.55,595.35L1212.65,599.95L1210.25,604.45L1206.55,608.45L1201.25,610.85L1194.75,613.95L1188.15,620.85L1185.95,622.05L1181.75,626.65L1179.45,628.05L1178.65,632.65L1181.05,637.55L1181.95,641.25L1181.95,643.25L1182.95,642.85L1182.45,649.15L1181.35,652.15L1182.55,653.25L1181.55,655.95L1179.15,658.25L1174.45,660.35L1167.55,663.85L1165.05,666.25L1165.35,668.95L1166.65,669.35L1165.95,672.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MR" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M958.45,340.75L949.95,340.85L952.35,368.55L954.85,396.25L955.85,397.05L954.55,401.55L932.05,401.65L931.15,403.05L929.05,402.65L925.85,403.95L921.95,402.15L920.15,402.25L919.15,406.05L917.25,407.25L913.65,402.85L910.25,398.05L906.65,396.35L903.95,394.55L900.85,394.55L898.05,395.95L895.35,395.45L893.35,397.45L892.95,394.05L894.55,390.85L895.35,384.85L894.95,378.45L894.35,375.25L894.95,372.05L893.55,369.05L890.75,366.25L892.05,364.15L913.75,364.15L912.85,354.85L914.35,351.55L919.55,351.05L919.75,334.55L937.75,334.95L937.95,325.15L958.45,340.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1115.45,613.55L1120.05,612.15L1123.65,612.45L1125.85,613.95L1125.85,614.45L1122.65,615.95L1120.95,615.95L1117.25,618.45L1115.25,615.75L1106.55,618.05L1102.35,618.25L1101.55,641.15L1096.05,641.35L1095.45,660.05L1094.35,683.75L1089.35,687.05L1086.45,687.55L1083.05,686.35L1080.55,685.85L1079.75,683.15L1077.75,681.35L1074.95,684.55L1071.05,679.65L1069.05,675.05L1068.05,668.75L1066.85,664.15L1065.25,654.25L1065.35,646.55L1064.75,643.05L1062.65,640.35L1059.85,635.05L1057.05,627.35L1055.95,623.35L1051.55,617.05L1051.25,612.15L1053.95,610.95L1057.35,609.85L1060.95,610.05L1064.25,612.95L1065.05,612.45L1087.75,612.25L1091.55,615.25L1105.05,616.15L1115.45,613.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NE" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1067.85,354.25L1069.45,364.25L1071.65,365.95L1071.75,367.95L1074.15,370.15L1072.95,372.95L1071.15,385.95L1070.95,394.35L1063.95,400.35L1061.65,408.85L1064.05,411.25L1064.05,415.35L1067.75,415.45L1067.15,418.55L1065.65,418.85L1065.45,420.95L1064.45,421.05L1060.55,414.05L1059.15,413.75L1054.85,417.35L1050.45,415.45L1047.45,415.15L1045.85,416.05L1042.55,415.85L1039.25,418.55L1036.35,418.75L1029.55,415.45L1026.85,416.95L1023.95,416.85L1021.85,414.45L1016.25,412.05L1010.15,412.85L1008.75,414.15L1007.95,417.85L1006.35,420.45L1005.95,426.25L1001.65,422.55L999.65,422.55L997.75,424.45L997.85,420.05L991.35,418.55L991.15,415.45L988.05,411.25L987.25,408.35L987.75,405.25L991.35,404.95L993.35,402.65L1001.05,402.15L1006.05,401.15L1006.45,397.15L1009.55,392.85L1009.45,378.05L1017.25,375.25L1033.25,362.65L1052.05,350.35L1060.85,353.15L1064.05,356.65L1067.85,354.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1065.45,420.95L1067.75,423.45L1067.15,424.65L1066.85,426.75L1062.15,431.75L1060.75,435.85L1059.95,439.15L1058.75,440.65L1057.65,445.15L1054.65,447.75L1053.85,450.95L1052.55,453.55L1052.05,456.25L1048.15,458.45L1044.95,455.75L1042.85,455.85L1039.45,459.65L1037.85,459.65L1035.15,465.85L1033.75,470.45L1027.85,472.75L1025.75,472.45L1023.55,473.85L1019.05,473.75L1015.95,469.65L1014.05,465.05L1010.05,460.85L1000.85,460.85L1001.15,450.55L1000.95,446.45L1002.05,442.45L1003.75,440.45L1006.55,436.45L1005.95,434.75L1007.05,432.15L1005.75,428.35L1005.95,426.25L1006.35,420.45L1007.95,417.85L1008.75,414.15L1010.15,412.85L1016.25,412.05L1021.85,414.45L1023.95,416.85L1026.85,416.95L1029.55,415.45L1036.35,418.75L1039.25,418.55L1042.55,415.85L1045.85,416.05L1047.45,415.15L1050.45,415.45L1054.85,417.35L1059.15,413.75L1060.55,414.05L1064.45,421.05L1065.45,420.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1158.05,508.35L1160.25,511.95L1159.95,515.75L1158.35,516.55L1155.25,516.15L1153.55,519.85L1150.05,519.35L1150.65,515.75L1151.45,515.25L1151.65,511.45L1153.25,509.65L1154.65,510.35L1158.05,508.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EH" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M938.15,323.55L938.05,323.95L937.95,325.15L937.75,334.95L919.75,334.55L919.55,351.05L914.35,351.55L912.85,354.85L913.75,364.15L892.05,364.15L890.75,366.25L891.05,363.55L891.15,363.55L903.65,363.05L904.35,360.75L906.75,357.85L908.75,348.95L916.65,342.05L919.35,333.95L921.15,333.45L923.05,328.45L927.65,327.75L929.65,328.65L932.15,328.65L933.95,327.15L937.35,326.95L937.25,323.55L938.15,323.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SD" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1190.25,408.45L1189.55,413.95L1187.55,420.35L1184.25,423.45L1181.95,428.45L1181.45,431.05L1178.85,432.85L1177.35,439.55L1177.35,440.35L1176.55,440.15L1176.65,436.95L1175.85,434.75L1172.95,432.25L1172.05,427.65L1172.65,422.85L1170.05,422.45L1169.65,423.85L1166.25,424.25L1167.75,426.05L1168.25,429.95L1165.25,433.45L1162.55,438.05L1159.65,438.75L1154.85,435.05L1152.75,436.35L1152.25,438.15L1149.35,439.45L1149.15,440.75L1143.55,440.75L1142.75,439.45L1138.65,439.15L1136.65,440.25L1135.05,439.75L1132.15,435.95L1131.15,434.25L1127.05,435.15L1125.55,438.05L1124.25,443.85L1122.25,445.05L1120.55,445.75L1120.05,445.45L1118.15,443.55L1117.75,441.55L1118.55,438.95L1118.55,436.25L1115.25,432.25L1114.55,429.55L1114.55,427.95L1112.45,426.05L1112.35,422.35L1111.05,419.85L1109.15,420.25L1109.65,417.85L1111.05,415.25L1110.35,412.55L1112.15,410.55L1110.95,409.05L1112.25,405.15L1114.75,400.35L1119.55,400.85L1118.45,375.35L1118.45,372.65L1124.85,372.65L1124.35,359.85L1190.25,359.85L1192.35,366.15L1191.15,367.25L1192.35,373.95L1194.85,381.55L1197.05,383.15L1200.25,385.55L1197.55,389.15L1193.55,390.25L1191.85,392.25L1191.55,396.45L1189.55,405.95L1190.25,408.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SS" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1177.35,440.35L1177.55,445.35L1176.75,447.25L1173.75,447.45L1171.85,451.05L1175.35,451.55L1178.35,454.65L1179.35,457.25L1181.95,458.75L1185.45,465.75L1181.65,469.95L1178.25,473.75L1174.75,476.75L1170.75,476.75L1166.25,478.25L1162.65,476.75L1160.35,478.55L1155.25,474.25L1153.85,471.55L1150.75,472.85L1148.15,472.45L1146.65,473.55L1144.05,472.75L1140.55,467.45L1139.65,465.45L1135.35,462.85L1133.95,459.05L1131.55,456.25L1127.65,452.95L1127.55,450.85L1124.45,448.25L1120.55,445.75L1122.25,445.05L1124.25,443.85L1125.55,438.05L1127.05,435.15L1131.15,434.25L1132.15,435.95L1135.05,439.75L1136.65,440.25L1138.65,439.15L1142.75,439.45L1143.55,440.75L1149.15,440.75L1149.35,439.45L1152.25,438.15L1152.75,436.35L1154.85,435.05L1159.65,438.75L1162.55,438.05L1165.25,433.45L1168.25,429.95L1167.75,426.05L1166.25,424.25L1169.65,423.85L1170.05,422.45L1172.65,422.85L1172.05,427.65L1172.95,432.25L1175.85,434.75L1176.65,436.95L1176.55,440.15L1177.35,440.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SN" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M917.25,407.25L917.45,411.25L918.55,414.95L920.55,416.75L921.05,419.15L920.75,421.15L919.95,421.55L916.85,421.05L916.45,421.75L915.25,421.85L911.15,420.35L908.45,420.25L898.05,419.95L896.55,420.75L894.65,420.55L891.65,421.55L890.85,416.65L895.95,416.75L897.35,415.85L898.35,415.85L900.45,414.35L902.85,415.65L905.25,415.85L907.75,414.35L906.65,412.55L904.75,413.55L903.05,413.55L900.85,411.95L899.05,412.05L897.75,413.65L891.65,413.75L889.35,408.75L886.65,406.55L889.15,405.25L891.95,400.75L893.35,397.45L895.35,395.45L898.05,395.95L900.85,394.55L903.95,394.55L906.65,396.35L910.25,398.05L913.65,402.85L917.25,407.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SL" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M927.75,447.15L925.15,450.15L922.55,453.55L922.25,455.45L920.85,457.55L919.35,457.05L915.35,454.45L912.35,451.05L911.45,448.65L910.75,443.95L913.85,441.05L914.45,439.35L915.45,437.95L917.05,437.75L918.35,436.55L922.85,436.55L924.45,438.85L925.65,441.55L925.45,443.45L926.35,445.15L926.25,447.45L927.75,447.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1160.95,666.95L1161.55,669.85L1161.85,672.75L1160.45,675.55L1157.25,676.25L1154.15,672.75L1154.25,670.55L1155.95,668.15L1156.55,666.25L1158.25,665.85L1160.95,666.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TD" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1118.45,375.35L1119.55,400.85L1114.75,400.35L1112.25,405.15L1110.95,409.05L1112.15,410.55L1110.35,412.55L1111.05,415.25L1109.65,417.85L1109.15,420.25L1111.05,419.85L1112.35,422.35L1112.45,426.05L1114.55,427.95L1114.55,429.55L1110.95,430.65L1108.15,433.25L1104.15,440.25L1098.95,443.25L1093.45,442.85L1091.85,443.45L1092.45,445.65L1089.55,447.95L1087.15,450.45L1080.05,452.85L1078.65,451.45L1077.65,451.25L1076.65,452.95L1072.05,453.45L1072.85,451.65L1071.05,447.25L1070.25,444.65L1067.75,443.55L1064.35,439.75L1065.55,436.75L1068.15,437.35L1069.75,436.95L1072.95,436.95L1069.75,431.15L1069.95,426.85L1069.45,422.65L1067.15,418.55L1067.75,415.45L1064.05,415.35L1064.05,411.25L1061.65,408.85L1063.95,400.35L1070.95,394.35L1071.15,385.95L1072.95,372.95L1074.15,370.15L1071.75,367.95L1071.65,365.95L1069.45,364.25L1067.85,354.25L1073.35,350.75L1095.85,363.05L1118.45,375.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M990.65,430.45L989.95,433.85L991.65,435.75L993.65,437.95L993.85,441.15L995.05,442.45L994.75,457.25L996.15,461.65L991.65,463.05L990.35,460.75L988.85,456.65L988.35,453.45L989.65,447.75L988.25,445.35L987.65,440.35L987.65,435.65L985.35,432.35L985.75,430.35L990.65,430.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TN" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1047.45,288.35L1047.35,293.25L1044.75,295.05L1043.15,297.15L1039.55,299.65L1040.15,302.25L1039.75,305.05L1037.15,306.45L1034.55,294.95L1031.15,292.35L1031.05,290.85L1026.55,286.95L1025.95,282.15L1029.15,278.55L1030.25,273.25L1029.25,267.15L1030.25,263.85L1035.95,261.35L1039.65,262.05L1039.65,265.35L1044.05,262.95L1044.45,264.15L1041.95,267.35L1042.05,270.25L1043.95,271.85L1043.45,277.45L1039.95,280.65L1041.15,284.15L1043.95,284.25L1045.35,287.35L1047.45,288.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1166.25,507.65L1166.05,511.55L1164.95,516.05L1166.55,518.55L1169.05,517.05L1172.35,516.65L1173.05,517.45L1176.35,515.85L1174.05,513.65L1175.95,510.75L1178.75,507.85L1199.25,520.95L1199.55,524.65L1207.65,531.05L1204.85,539.05L1205.15,542.65L1208.65,544.95L1208.85,546.65L1207.15,550.55L1207.45,552.45L1207.05,555.55L1208.85,559.55L1211.05,565.95L1213.05,567.35L1208.45,571.05L1202.25,573.55L1198.85,573.45L1196.75,575.35L1192.85,575.55L1191.35,576.35L1184.65,574.55L1182.45,574.75L1182.55,574.65L1180.75,572.25L1180.45,565.45L1177.55,562.05L1177.15,563.25L1176.15,561.55L1170.65,560.35L1167.45,558.45L1163.85,557.35L1161.65,556.25L1161.35,556.05L1158.65,549.45L1158.25,545.55L1153.75,541.15L1155.15,538.75L1154.05,536.15L1154.25,533.45L1153.25,532.55L1153.55,529.75L1154.15,529.65L1156.15,527.35L1158.45,523.95L1159.85,522.65L1159.85,520.55L1158.65,519.05L1158.35,516.55L1159.95,515.75L1160.25,511.95L1158.05,508.35L1160.05,507.55L1166.25,507.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1178.25,473.75L1180.95,478.25L1181.65,481.45L1184.25,488.85L1182.15,493.55L1179.35,497.75L1177.75,500.35L1177.75,500.65L1177.55,500.25L1174.55,498.95L1172.15,500.55L1168.55,501.45L1165.95,505.15L1166.25,507.65L1160.05,507.55L1158.05,508.35L1154.65,510.35L1153.25,509.65L1153.35,504.85L1154.65,502.35L1154.95,497.25L1156.15,494.25L1158.35,490.95L1160.45,489.15L1162.35,486.95L1160.05,486.05L1160.35,478.55L1162.65,476.75L1166.25,478.25L1170.75,476.75L1174.75,476.75L1178.25,473.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZM" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1161.35,556.05L1161.65,556.25L1163.85,557.35L1167.45,558.45L1170.65,560.35L1173.25,563.25L1174.55,568.65L1173.55,570.35L1172.25,575.55L1173.15,580.95L1171.35,583.15L1169.35,589.15L1172.25,590.75L1155.05,596.05L1155.45,600.65L1151.15,601.55L1147.85,604.05L1147.05,606.25L1145.05,606.85L1139.95,612.05L1136.75,616.25L1134.85,616.35L1133.05,615.65L1126.85,614.95L1125.85,614.45L1125.85,613.95L1123.65,612.45L1120.05,612.15L1115.45,613.55L1111.85,609.55L1108.25,604.35L1109.05,583.85L1120.75,583.95L1120.35,581.75L1121.25,579.35L1120.35,576.35L1121.05,573.25L1120.45,571.25L1122.35,571.35L1122.65,573.35L1125.35,573.25L1128.85,573.85L1130.75,576.75L1135.15,577.65L1138.65,575.65L1139.85,578.95L1144.15,579.85L1146.15,582.65L1148.35,586.15L1152.65,586.15L1152.45,579.25L1150.85,580.45L1146.95,577.95L1145.45,576.75L1146.35,570.35L1147.45,562.75L1146.25,559.95L1147.95,555.85L1149.45,555.05L1157.15,553.95L1158.05,554.25L1157.75,555.65L1159.65,556.15L1160.85,557.45L1161.85,557.15L1161.35,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1158.65,643.95L1155.75,643.25L1153.85,644.05L1151.15,642.95L1148.95,642.95L1145.55,640.05L1141.25,639.05L1139.75,634.95L1139.85,632.65L1137.55,631.95L1131.45,624.95L1129.85,621.25L1128.75,620.05L1126.85,614.95L1133.05,615.65L1134.85,616.35L1136.75,616.25L1139.95,612.05L1145.05,606.85L1147.05,606.25L1147.85,604.05L1151.15,601.55L1155.45,600.65L1155.65,603.05L1160.35,602.95L1162.95,604.25L1164.05,605.85L1166.75,606.35L1169.55,608.35L1169.15,616.55L1167.85,620.95L1167.45,625.75L1168.25,627.65L1167.35,631.45L1166.55,632.05L1164.85,636.65L1158.65,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SO" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1221.35,511.85L1218.05,506.55L1217.85,483.15L1222.75,475.95L1224.25,473.85L1227.85,473.75L1232.85,469.25L1240.15,468.95L1255.75,449.65L1250.95,449.75L1232.25,442.15L1230.05,439.85L1227.85,436.75L1225.65,433.15L1226.85,430.95L1228.75,427.45L1230.65,428.65L1231.85,431.35L1234.55,434.05L1237.35,434.05L1242.55,432.35L1248.65,431.65L1253.55,429.65L1256.35,429.25L1258.35,428.05L1261.55,427.85L1263.35,427.65L1265.85,426.75L1268.85,426.05L1271.35,423.85L1273.55,423.85L1273.75,425.65L1273.35,429.35L1273.55,432.75L1272.45,435.05L1271.05,442.05L1268.65,449.15L1265.35,457.35L1260.75,466.75L1256.05,473.95L1249.45,482.75L1243.85,487.95L1235.45,494.35L1230.15,499.15L1223.95,506.95L1222.65,510.35L1221.35,511.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1158.65,643.95L1160.85,652.95L1161.95,657.55L1160.55,664.65L1160.95,666.95L1158.25,665.85L1156.55,666.25L1155.95,668.15L1154.25,670.55L1154.15,672.75L1157.25,676.25L1160.45,675.55L1161.85,672.75L1165.95,672.75L1164.25,677.45L1163.25,682.75L1161.55,685.65L1157.55,688.95L1156.45,689.85L1153.85,693.15L1152.05,696.45L1148.55,701.05L1141.85,707.65L1137.75,711.45L1133.45,714.45L1127.55,716.85L1124.85,717.25L1123.95,719.05L1120.75,718.05L1118.05,719.25L1112.35,718.05L1109.05,718.85L1106.85,718.45L1101.05,721.05L1096.45,722.05L1092.95,724.45L1090.55,724.65L1088.45,722.35L1086.65,722.25L1084.45,719.35L1084.15,720.25L1083.55,718.55L1083.85,714.75L1082.35,710.45L1084.15,709.25L1084.25,704.35L1080.95,698.35L1078.55,692.95L1078.55,692.85L1074.95,684.55L1077.75,681.35L1079.75,683.15L1080.55,685.85L1083.05,686.35L1086.45,687.55L1089.35,687.05L1094.35,683.75L1095.45,660.05L1096.85,661.05L1099.85,667.15L1099.25,671.05L1100.35,673.35L1104.35,672.65L1107.15,669.75L1109.85,667.85L1111.35,664.75L1114.15,663.35L1116.45,664.05L1118.95,665.85L1123.45,666.15L1127.05,664.75L1127.65,662.75L1128.85,659.65L1131.85,659.15L1133.65,656.75L1135.65,652.45L1140.85,647.65L1148.95,642.95L1151.15,642.95L1153.85,644.05L1155.75,643.25L1158.65,643.95ZM1138.35,697.15L1139.45,695.15L1142.55,694.15L1143.65,692.05L1145.55,688.95L1143.85,686.95L1141.65,684.95L1138.95,686.35L1135.85,688.85L1132.65,692.85L1136.35,697.85L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), J55 = [
  K55
];
function Q55(t, e) {
  return G(), J("svg", q55, J55);
}
const X55 = /* @__PURE__ */ U5(G55, [["render", Q55]]), e15 = {}, t15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, r15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1601.45,381.15L1597.15,384.25L1592.25,382.25L1591.25,376.75L1593.45,373.85L1599.25,372.05L1602.55,372.15L1604.15,374.65L1602.15,377.45L1601.45,381.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1624.85,184.75L1633.85,189.25L1639.85,195.05L1647.45,195.05L1650.05,192.65L1656.95,190.75L1658.25,196.45L1657.95,198.75L1660.75,205.55L1661.35,211.75L1654.45,210.65L1651.55,212.85L1656.25,218.25L1660.15,225.75L1657.65,225.85L1659.55,229.15L1654.05,225.35L1654.05,228.95L1647.65,231.65L1650.45,235.05L1645.85,234.75L1642.25,232.75L1641.15,237.35L1637.25,240.75L1635.15,244.85L1628.85,246.65L1626.45,249.65L1621.65,251.45L1622.95,248.45L1620.65,245.95L1622.65,241.65L1618.15,238.35L1614.75,240.55L1611.15,245.05L1609.85,249.15L1604.85,249.45L1603.55,252.45L1608.35,256.75L1613.15,257.85L1614.55,260.65L1619.65,262.55L1623.45,257.95L1629.35,260.45L1632.85,260.65L1635.15,263.95L1628.45,265.75L1627.45,269.25L1623.65,272.45L1622.75,276.95L1629.85,280.45L1634.45,286.75L1639.95,292.65L1645.45,297.55L1647.05,302.35L1644.25,304.15L1646.65,307.55L1650.55,309.55L1651.35,314.75L1651.45,319.85L1648.65,320.45L1646.55,327.35L1644.25,335.85L1640.85,343.45L1634.45,349.35L1627.85,354.85L1621.75,355.55L1618.85,358.35L1616.55,356.35L1614.05,359.45L1606.85,362.75L1601.05,363.65L1600.35,370.45L1597.25,370.85L1595.05,366.15L1595.95,363.75L1588.15,361.65L1585.75,362.75L1579.85,361.05L1576.75,358.45L1577.05,354.75L1571.75,353.55L1568.65,351.15L1564.55,354.55L1559.25,355.35L1554.85,355.25L1552.15,356.85L1549.45,357.75L1551.45,365.15L1548.45,364.95L1547.65,363.45L1547.15,360.75L1543.35,362.65L1540.75,361.45L1536.25,359.05L1537.05,353.75L1533.35,352.45L1530.95,346.55L1525.35,347.65L1524.65,340.05L1528.85,334.65L1527.95,329.35L1526.65,324.45L1523.95,322.95L1521.25,319.15L1518.15,319.65L1512.05,318.65L1513.25,315.95L1509.65,311.95L1506.45,314.65L1501.55,313.15L1496.15,317.15L1492.25,321.95L1488.05,322.75L1485.25,321.05L1482.35,320.85L1478.05,319.45L1475.45,321.05L1472.85,325.85L1471.35,320.75L1468.25,322.15L1461.75,321.45L1455.25,320.05L1450.25,317.15L1445.75,315.95L1443.25,312.85L1439.95,311.95L1433.55,307.75L1428.75,305.75L1426.85,307.25L1418.25,302.75L1412.05,298.75L1408.85,291.65L1412.95,292.55L1412.35,289.25L1409.35,285.95L1408.55,280.75L1400.85,273.15L1391.35,270.65L1388.45,265.65L1383.75,262.65L1382.25,260.85L1380.45,257.25L1379.95,254.75L1376.25,253.25L1374.75,253.95L1371.65,247.95L1372.75,246.55L1371.55,245.05L1375.65,242.05L1378.85,240.75L1384.65,241.65L1385.25,237.55L1391.65,236.85L1392.65,234.25L1399.55,230.85L1399.75,229.45L1398.05,225.75L1400.95,224.15L1392.15,213.15L1401.25,210.65L1403.25,209.25L1402.25,197.95L1413.05,200.05L1414.65,197.15L1412.15,190.95L1415.95,190.35L1417.85,186.15L1419.55,185.65L1422.85,190.05L1428.55,193.35L1436.75,195.65L1442.55,200.75L1443.95,208.05L1446.95,210.85L1453.45,211.95L1460.65,212.75L1468.65,216.75L1472.05,217.45L1477.05,223.25L1481.75,227.05L1487.35,226.85L1498.65,228.35L1505.05,227.45L1510.65,228.35L1520.05,232.25L1526.25,232.25L1529.55,234.15L1533.95,230.75L1541.15,228.55L1548.75,228.35L1553.65,226.15L1555.65,222.75L1558.05,220.55L1556.15,218.45L1553.25,216.05L1553.75,211.95L1556.95,212.55L1562.85,213.85L1566.05,210.45L1572.45,208.05L1573.75,203.85L1576.25,202.05L1583.05,201.25L1587.45,201.95L1586.65,199.75L1579.45,195.35L1574.25,193.35L1571.75,195.65L1566.25,194.65L1563.95,195.45L1561.15,192.95L1560.85,186.65L1560.25,181.95L1567.65,184.35L1572.05,180.45L1570.15,177.65L1569.95,171.15L1571.25,169.15L1568.75,165.75L1565.05,164.35L1566.75,161.25L1571.85,160.15L1578.05,159.95L1586.65,161.85L1592.65,164.05L1600.35,170.25L1604.15,172.95L1608.65,176.75L1614.85,182.75L1624.85,184.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1707.75,281.85L1709.35,284.05L1708.05,287.95L1704.95,285.85L1702.85,287.35L1702.95,291.05L1698.65,289.25L1697.45,286.25L1698.75,282.35L1702.15,283.15L1703.15,280.45L1707.75,281.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1732.35,262.65L1732.95,267.75L1735.45,270.95L1734.85,275.45L1729.45,278.45L1720.25,278.85L1715.85,286.25L1711.15,283.75L1708.75,278.95L1700.15,280.35L1695.05,283.35L1688.85,283.55L1696.25,288.25L1697.05,299.15L1694.55,301.85L1690.95,299.35L1690.05,293.55L1685.95,291.75L1681.95,287.35L1686.25,285.35L1687.35,281.25L1691.25,277.95L1693.25,273.55L1702.95,271.65L1709.25,272.95L1709.25,261.55L1714.35,264.65L1718.85,258.25L1720.55,255.75L1719.55,247.95L1714.45,240.75L1714.25,236.75L1719.05,235.55L1727.25,244.45L1730.05,249.55L1728.75,256.05L1732.35,262.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1720.45,217.85L1724.95,219.15L1726.75,216.55L1732.75,223.65L1726.35,225.35L1725.95,231.65L1715.05,227.35L1716.65,234.25L1710.95,234.35L1706.25,228.05L1705.65,223.15L1710.85,222.85L1706.45,214.05L1704.65,209.15L1715.15,215.75L1720.45,217.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KR" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1652.15,258.75L1652.15,258.15L1654.65,258.35L1655.25,255.55L1658.85,255.15L1660.85,254.75L1660.85,253.25L1669.15,260.75L1672.45,264.95L1675.85,272.35L1675.35,275.85L1671.05,277.05L1667.95,279.75L1663.35,280.25L1661.25,276.75L1660.15,271.95L1654.85,265.35L1658.25,264.25L1652.15,258.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MN" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1495.45,180.75L1499.45,179.55L1505.15,178.75L1510.55,179.65L1517.15,182.55L1522.05,185.75L1526.65,185.75L1533.45,186.75L1537.05,185.15L1542.95,184.15L1547.35,179.75L1550.75,180.45L1554.65,182.55L1560.25,181.95L1560.85,186.65L1561.15,192.95L1563.95,195.45L1566.25,194.65L1571.75,195.65L1574.25,193.35L1579.45,195.35L1586.65,199.75L1587.45,201.95L1583.05,201.25L1576.25,202.05L1573.75,203.85L1572.45,208.05L1566.05,210.45L1562.85,213.85L1556.95,212.55L1553.75,211.95L1553.25,216.05L1556.15,218.45L1558.05,220.55L1555.65,222.75L1553.65,226.15L1548.75,228.35L1541.15,228.55L1533.95,230.75L1529.55,234.15L1526.25,232.25L1520.05,232.25L1510.65,228.35L1505.05,227.45L1498.65,228.35L1487.35,226.85L1481.75,227.05L1477.05,223.25L1472.05,217.45L1468.65,216.75L1460.65,212.75L1453.45,211.95L1446.95,210.85L1443.95,208.05L1442.55,200.75L1436.75,195.65L1428.55,193.35L1422.85,190.05L1419.55,185.65L1424.25,184.55L1430.95,179.25L1436.85,176.35L1442.15,178.25L1447.35,178.35L1452.15,181.25L1457.15,181.45L1465.15,183.05L1467.55,178.65L1463.55,175.05L1464.85,168.65L1471.85,171.15L1476.65,171.95L1483.35,173.55L1486.95,178.15L1495.45,180.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KP" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1659.55,229.15L1660.95,230.25L1658.75,229.85L1657.75,232.05L1657.45,234.15L1660.25,238.75L1658.35,240.15L1658.05,241.25L1657.15,243.15L1654.25,244.25L1652.85,245.95L1654.15,248.65L1653.85,249.35L1656.45,250.45L1660.85,253.25L1660.85,254.75L1658.85,255.15L1655.25,255.55L1654.65,258.35L1652.15,258.15L1652.15,258.75L1648.95,257.55L1648.85,258.75L1647.55,259.25L1646.85,258.05L1645.15,257.45L1643.25,256.45L1643.35,253.65L1644.25,252.85L1643.25,251.75L1642.85,248.25L1641.95,247.25L1638.55,246.55L1635.15,244.85L1637.25,240.75L1641.15,237.35L1642.25,232.75L1645.85,234.75L1650.45,235.05L1647.65,231.65L1654.05,228.95L1654.05,225.35L1659.55,229.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TW" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1657.15,354.75L1655.75,360.05L1651.75,354.55L1650.25,349.85L1652.15,343.55L1655.45,338.65L1658.45,340.55L1658.35,344.45L1657.15,354.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), n15 = [
  r15
];
function o15(t, e) {
  return G(), J("svg", t15, n15);
}
const i15 = /* @__PURE__ */ U5(e15, [["render", o15]]), L15 = {}, a15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, s15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g id="AL" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1087.25,227.25L1087.65,228.45L1089.05,227.85L1090.25,229.55L1091.55,230.25L1092.15,232.55L1091.65,234.75L1092.65,237.45L1094.95,238.95L1095.05,240.65L1093.35,241.55L1093.25,243.65L1091.05,246.75L1090.15,246.35L1089.95,244.95L1086.85,242.75L1086.15,239.75L1086.25,235.35L1086.75,233.45L1085.85,232.45L1085.35,230.35L1087.25,227.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AT" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1069.85,190.05L1069.55,190.85L1070.25,192.95L1070.05,195.55L1067.25,195.55L1068.35,196.95L1067.05,200.95L1066.15,202.05L1061.75,202.15L1059.35,203.65L1055.15,203.15L1047.85,201.45L1046.55,199.35L1041.65,200.45L1041.15,201.65L1038.05,200.75L1035.45,200.55L1033.15,199.35L1033.85,197.85L1033.65,196.75L1035.05,196.45L1037.75,198.15L1038.35,196.45L1042.75,196.75L1046.25,195.65L1048.65,195.85L1050.35,197.15L1050.75,196.05L1049.75,191.95L1051.45,191.15L1053.05,188.25L1056.85,190.35L1059.45,187.75L1061.15,187.25L1065.15,189.15L1067.45,188.85L1069.85,190.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1015.75,176.35L1015.35,180.55L1014.05,180.75L1013.65,184.25L1009.25,181.35L1006.75,181.85L1003.25,178.95L1000.85,176.45L998.65,176.35L997.85,174.15L1001.75,172.95L1005.35,173.45L1009.85,172.15L1012.95,174.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BG" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1131.85,220.85L1129.55,223.45L1128.25,227.95L1130.35,231.55L1125.75,230.75L1120.75,232.75L1121.05,235.95L1116.45,236.55L1112.55,234.25L1108.55,236.05L1104.75,235.85L1103.95,231.65L1101.15,229.55L1101.85,228.75L1101.25,227.95L1101.85,225.95L1103.65,223.95L1100.85,221.25L1100.15,218.85L1101.25,217.45L1103.05,220.05L1104.95,219.65L1108.95,220.55L1116.55,220.95L1118.85,219.35L1124.75,217.85L1128.75,220.15L1131.85,220.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BA" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1082.25,213.55L1084.15,213.45L1083.05,216.25L1085.75,218.75L1085.25,221.65L1084.15,221.95L1083.25,222.55L1081.65,224.05L1081.25,227.55L1076.45,225.15L1074.35,222.45L1072.25,221.05L1069.75,218.65L1068.45,216.75L1065.75,213.75L1066.55,211.15L1068.55,212.65L1069.55,211.25L1071.85,211.15L1076.35,212.25L1079.85,212.15L1082.25,213.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BY" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1140.85,161.95L1136.95,161.75L1136.15,162.35L1137.65,164.35L1139.65,168.35L1135.55,168.65L1134.25,170.05L1134.55,173.15L1132.45,172.55L1128.15,172.85L1126.65,171.35L1124.95,172.45L1123.05,171.55L1119.15,171.45L1113.45,169.95L1108.55,169.45L1104.75,169.65L1102.35,171.25L1100.05,171.55L1099.55,168.75L1097.65,165.95L1100.45,164.65L1100.05,162.25L1098.35,159.95L1097.75,157.25L1102.45,157.25L1107.25,154.95L1107.75,151.55L1111.35,149.55L1110.35,146.85L1113.05,145.85L1117.65,143.55L1122.95,145.05L1123.85,146.55L1126.25,145.85L1131.05,147.25L1132.15,150.15L1131.45,151.75L1135.25,155.75L1137.35,156.85L1137.35,157.95L1140.75,159.05L1142.45,160.65L1140.85,161.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CH" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1033.65,196.75L1033.85,197.85L1033.15,199.35L1035.45,200.55L1038.05,200.75L1037.75,203.25L1035.65,204.35L1031.85,203.55L1030.85,206.05L1028.45,206.25L1027.55,205.25L1024.85,207.45L1022.35,207.75L1020.15,206.35L1018.35,203.65L1015.95,204.65L1015.95,201.75L1019.55,198.25L1019.35,196.65L1021.65,197.25L1022.95,196.15L1027.15,196.15L1028.15,194.85L1033.65,196.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CZ" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1058.95,174.45L1061.45,176.45L1065.15,176.95L1064.95,178.65L1067.75,179.95L1068.35,178.35L1071.75,179.05L1072.45,181.05L1076.15,181.35L1078.75,184.45L1077.25,184.45L1076.55,185.55L1075.45,185.85L1075.25,187.25L1074.35,187.55L1074.25,188.15L1072.65,188.75L1070.45,188.65L1069.85,190.05L1067.45,188.85L1065.15,189.15L1061.15,187.25L1059.45,187.75L1056.85,190.35L1053.05,188.25L1050.05,185.65L1047.45,184.15L1046.75,181.45L1045.75,179.65L1049.15,178.35L1050.85,176.75L1054.35,175.55L1055.45,174.35L1056.75,175.05L1058.95,174.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1053.15,158.15L1054.55,161.25L1053.35,162.95L1055.25,165.05L1056.75,168.35L1056.55,170.55L1058.95,174.45L1056.75,175.05L1055.45,174.35L1054.35,175.55L1050.85,176.75L1049.15,178.35L1045.75,179.65L1046.75,181.45L1047.45,184.15L1050.05,185.65L1053.05,188.25L1051.45,191.15L1049.75,191.95L1050.75,196.05L1050.35,197.15L1048.65,195.85L1046.25,195.65L1042.75,196.75L1038.35,196.45L1037.75,198.15L1035.05,196.45L1033.65,196.75L1028.15,194.85L1027.15,196.15L1022.95,196.15L1023.35,191.65L1025.75,187.45L1018.55,186.25L1016.15,184.65L1016.35,181.95L1015.35,180.55L1015.75,176.35L1014.65,169.85L1017.55,169.85L1018.75,167.55L1019.65,161.95L1018.75,159.85L1019.55,158.55L1023.55,158.25L1024.55,159.55L1027.65,156.55L1026.35,154.25L1025.95,150.85L1029.65,151.65L1032.55,150.75L1032.85,153.05L1037.75,154.45L1037.85,156.65L1042.55,155.45L1045.15,153.85L1050.75,156.25L1053.15,158.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1045.35,146.95L1042.95,151.85L1037.75,148.35L1036.85,145.85L1043.65,143.85L1045.35,146.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1032.55,150.75L1029.65,151.65L1025.95,150.85L1023.85,147.45L1023.45,141.35L1024.05,139.65L1025.35,137.85L1029.35,137.55L1030.95,135.85L1034.55,134.15L1034.55,137.25L1033.35,139.25L1034.05,140.85L1036.65,141.75L1035.65,144.05L1034.25,143.45L1031.15,147.75L1032.55,150.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1112.95,123.85L1113.85,124.85L1111.25,128.25L1113.65,133.85L1112.05,135.75L1108.25,135.65L1103.85,133.45L1101.75,132.75L1097.95,133.75L1097.85,130.25L1096.35,131.05L1093.05,128.95L1092.05,125.55L1097.55,123.85L1103.15,123.05L1108.25,123.95L1112.95,123.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="FI" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1103.35,69.35L1103.75,73.15L1111.05,76.85L1108.15,81.05L1114.65,87.35L1112.95,92.15L1117.85,96.35L1116.95,100.15L1124.35,104.05L1123.45,106.95L1120.05,110.35L1112.05,117.75L1104.05,118.25L1096.45,120.35L1089.35,121.65L1086.15,118.45L1081.45,116.55L1081.55,110.75L1078.55,105.55L1080.15,102.15L1083.45,98.65L1092.25,92.45L1094.85,91.25L1093.95,88.85L1087.45,86.25L1085.65,84.05L1083.85,75.55L1076.65,71.85L1070.65,69.15L1072.85,67.75L1077.95,70.55L1083.25,70.35L1087.95,71.65L1091.35,69.25L1092.45,65.25L1098.35,63.45L1104.15,65.55L1103.35,69.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M955.95,157.45L952.45,156.25L949.45,156.35L950.65,153.05L949.75,149.85L953.75,149.55L958.65,153.35L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M971.85,128.75L966.75,135.25L971.45,134.45L976.55,134.45L975.25,139.35L970.95,144.75L975.85,145.05L976.15,145.75L980.35,152.85L983.55,153.85L986.45,160.85L987.85,163.25L993.75,164.35L993.15,168.35L990.75,170.15L992.65,173.35L988.25,176.55L981.75,176.45L973.35,178.25L971.15,176.95L967.85,179.85L963.35,179.15L959.75,181.55L957.25,180.35L964.55,173.85L968.95,172.45L961.35,171.45L960.05,168.95L965.15,167.05L962.65,163.75L963.65,159.75L970.75,160.35L971.55,156.75L968.45,153.05L968.35,152.95L962.65,151.85L961.55,150.25L963.35,147.55L961.85,145.85L959.25,148.75L959.15,142.85L956.95,139.85L958.85,133.65L962.65,128.85L966.25,129.25L971.85,128.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1121.15,239.15L1117.95,238.95L1115.25,238.35L1109.05,239.95L1113.05,243.55L1110.55,244.65L1107.65,244.65L1104.55,241.35L1103.65,242.75L1105.25,246.55L1108.15,249.55L1106.25,250.95L1109.45,253.85L1112.25,255.75L1112.65,259.35L1107.65,257.65L1109.45,260.95L1106.15,261.55L1108.65,267.25L1105.15,267.35L1100.55,264.55L1098.15,259.45L1096.85,255.15L1094.55,252.25L1091.55,248.55L1091.05,246.75L1093.25,243.65L1093.35,241.55L1095.05,240.65L1094.95,238.95L1098.35,238.45L1100.15,237.05L1102.95,237.15L1103.75,236.05L1104.75,235.85L1108.55,236.05L1112.55,234.25L1116.45,236.55L1121.05,235.95L1120.75,232.75L1123.45,234.45L1122.35,238.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HR" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1080.75,206.85L1082.25,209.35L1083.95,211.15L1082.25,213.55L1079.85,212.15L1076.35,212.25L1071.85,211.15L1069.55,211.25L1068.55,212.65L1066.55,211.15L1065.75,213.75L1068.45,216.75L1069.75,218.65L1072.25,221.05L1074.35,222.45L1076.45,225.15L1081.25,227.55L1080.75,228.55L1075.75,226.25L1072.55,223.95L1067.75,222.05L1063.05,217.45L1064.05,216.95L1061.55,214.25L1061.25,212.15L1057.95,211.15L1056.55,213.85L1054.95,211.75L1054.95,209.55L1055.05,209.45L1058.65,209.65L1059.45,208.65L1061.25,209.65L1063.25,209.75L1063.15,208.05L1064.85,207.35L1065.15,204.85L1069.05,203.15L1070.65,203.95L1074.65,206.65L1078.95,207.85L1080.75,206.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HU" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1095.45,191.15L1098.45,192.85L1098.95,194.55L1096.05,195.85L1094.15,200.05L1091.55,204.35L1087.65,205.55L1084.45,205.25L1080.75,206.85L1078.95,207.85L1074.65,206.65L1070.65,203.95L1069.05,203.15L1067.85,201.05L1067.05,200.95L1068.35,196.95L1067.25,195.55L1070.05,195.55L1070.25,192.95L1072.95,194.65L1074.85,195.25L1078.95,194.55L1079.25,193.25L1081.15,193.05L1083.45,192.15L1084.05,192.55L1086.35,191.75L1087.35,190.25L1088.95,189.85L1094.45,191.75L1095.45,191.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M955.95,157.45L956.65,161.85L952.75,167.35L943.95,170.95L937.15,170.05L941.45,163.65L939.35,157.45L946.05,152.65L949.75,149.85L950.65,153.05L949.45,156.35L952.45,156.25L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1067.45,255.65L1065.75,260.75L1066.65,262.65L1065.75,265.95L1061.55,263.55L1058.85,262.85L1051.35,259.65L1051.85,256.35L1058.05,256.95L1063.45,256.25L1067.45,255.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1033.45,236.65L1036.75,241.15L1036.35,249.65L1033.95,249.25L1031.85,251.35L1029.85,249.65L1029.35,241.95L1028.05,238.35L1030.95,238.65L1033.45,236.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1055.15,203.15L1054.75,206.25L1056.15,208.95L1052.05,207.95L1048.15,210.25L1048.55,213.35L1048.05,215.15L1049.95,218.35L1054.95,221.55L1057.85,226.85L1063.95,231.95L1067.95,231.85L1069.35,233.25L1067.95,234.55L1072.75,236.85L1076.75,238.75L1081.45,242.15L1082.05,243.25L1081.25,245.55L1078.15,242.55L1073.55,241.55L1071.65,245.65L1075.55,248.05L1075.15,251.35L1073.05,251.75L1070.55,257.25L1068.35,257.75L1068.25,255.75L1069.15,252.35L1070.25,250.95L1067.95,247.25L1066.15,244.05L1063.95,243.25L1062.15,240.55L1058.75,239.35L1056.35,236.75L1052.55,236.35L1048.25,233.55L1043.35,229.35L1039.65,225.75L1037.75,219.45L1035.15,218.75L1030.95,216.65L1028.65,217.45L1025.75,220.45L1023.65,220.85L1024.15,218.15L1021.35,217.35L1019.85,212.45L1021.55,210.55L1020.05,208.15L1020.15,206.35L1022.35,207.75L1024.85,207.45L1027.55,205.25L1028.45,206.25L1030.85,206.05L1031.85,203.55L1035.65,204.35L1037.75,203.25L1038.05,200.75L1041.15,201.65L1041.65,200.45L1046.55,199.35L1047.85,201.45L1055.15,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LT" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1110.35,146.85L1111.35,149.55L1107.75,151.55L1107.25,154.95L1102.45,157.25L1097.75,157.25L1096.35,155.35L1093.85,154.65L1093.25,153.15L1093.45,151.45L1091.25,150.55L1086.15,149.45L1084.45,144.35L1089.55,142.55L1097.45,142.95L1101.95,142.35L1102.85,143.55L1105.35,143.95L1110.35,146.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LV" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1112.05,135.75L1114.55,137.05L1115.55,139.95L1117.65,143.55L1113.05,145.85L1110.35,146.85L1105.35,143.95L1102.85,143.55L1101.95,142.35L1097.45,142.95L1089.55,142.55L1084.45,144.35L1083.95,139.85L1085.65,136.05L1089.75,134.05L1094.15,138.55L1097.85,138.35L1097.95,133.75L1101.75,132.75L1103.85,133.45L1108.25,135.65L1112.05,135.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MD" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1128.65,209.55L1127.35,206.65L1127.55,203.95L1126.95,201.25L1123.55,197.45L1121.55,194.85L1119.75,193.05L1118.15,192.35L1119.25,191.45L1122.45,190.85L1126.45,192.75L1128.45,193.05L1131.05,194.75L1130.95,196.85L1132.95,197.85L1134.05,200.45L1136.05,202.05L1135.85,203.05L1136.85,203.65L1135.55,204.15L1132.55,203.95L1131.95,203.05L1130.95,203.55L1131.55,204.65L1130.45,206.75L1129.85,208.85L1128.65,209.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MK" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1104.75,235.85L1103.75,236.05L1102.95,237.15L1100.15,237.05L1098.35,238.45L1094.95,238.95L1092.65,237.45L1091.65,234.75L1092.15,232.55L1092.85,232.65L1092.95,231.35L1095.85,230.35L1097.05,230.05L1098.75,229.75L1101.15,229.55L1103.95,231.65L1104.75,235.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ME" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1089.85,226.45L1089.05,227.85L1087.65,228.45L1087.25,227.25L1085.35,230.35L1085.85,232.45L1084.75,231.95L1083.05,229.85L1080.75,228.55L1081.25,227.55L1081.65,224.05L1083.25,222.55L1084.15,221.95L1085.55,223.05L1086.45,223.95L1088.15,224.65L1090.25,225.95L1089.85,226.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1112.95,66.75L1106.55,68.85L1103.35,69.35L1104.15,65.55L1098.35,63.45L1092.45,65.25L1091.35,69.25L1087.95,71.65L1083.25,70.35L1077.95,70.55L1072.85,67.75L1070.65,69.15L1068.05,69.35L1068.15,72.95L1060.15,72.05L1059.55,75.15L1055.55,75.15L1053.25,79.05L1049.85,85.15L1044.15,93.05L1045.95,95.05L1044.65,97.25L1040.35,97.15L1037.95,102.55L1038.95,110.25L1042.05,113.15L1041.25,120.05L1037.85,124.05L1036.05,127.45L1032.75,123.85L1024.15,130.65L1018.05,132.05L1011.55,129.05L1009.75,122.75L1007.75,109.25L1011.75,105.55L1023.05,100.65L1031.15,94.75L1038.35,86.95L1047.25,76.25L1053.65,72.15L1063.95,65.35L1072.45,62.95L1079.15,63.25L1084.35,58.85L1091.75,59.05L1098.75,58.05L1112.45,61.95L1107.55,63.35L1112.95,66.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PL" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1079.15,154.05L1085.05,154.75L1093.85,154.65L1096.35,155.35L1097.75,157.25L1098.35,159.95L1100.05,162.25L1100.45,164.65L1097.65,165.95L1099.55,168.75L1100.05,171.55L1103.25,176.95L1102.95,178.65L1100.65,179.35L1096.85,184.55L1098.45,187.35L1097.35,186.95L1092.35,184.55L1088.85,185.45L1086.45,184.85L1083.65,186.15L1080.95,183.95L1079.05,184.85L1078.75,184.45L1076.15,181.35L1072.45,181.05L1071.75,179.05L1068.35,178.35L1067.75,179.95L1064.95,178.65L1065.15,176.95L1061.45,176.45L1058.95,174.45L1056.55,170.55L1056.75,168.35L1055.25,165.05L1053.35,162.95L1054.55,161.25L1053.15,158.15L1056.25,156.35L1063.35,153.55L1069.15,151.55L1073.95,152.55L1074.55,154.05L1079.15,154.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RO" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1118.15,192.35L1119.75,193.05L1121.55,194.85L1123.55,197.45L1126.95,201.25L1127.55,203.95L1127.35,206.65L1128.65,209.55L1131.05,210.75L1133.35,209.65L1135.75,210.75L1136.15,212.45L1133.85,213.75L1132.25,213.15L1131.85,220.85L1128.75,220.15L1124.75,217.85L1118.85,219.35L1116.55,220.95L1108.95,220.55L1104.95,219.65L1103.05,220.05L1101.25,217.45L1100.25,216.35L1101.25,215.25L1099.95,214.55L1098.45,215.95L1095.35,214.05L1094.65,211.45L1091.45,210.05L1090.65,207.95L1087.65,205.55L1091.55,204.35L1094.15,200.05L1096.05,195.85L1098.95,194.55L1100.95,193.15L1104.15,193.85L1107.35,193.85L1109.85,195.45L1111.45,194.45L1115.05,193.85L1116.05,192.35L1118.15,192.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RS" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1101.25,217.45L1100.15,218.85L1100.85,221.25L1103.65,223.95L1101.85,225.95L1101.25,227.95L1101.85,228.75L1101.15,229.55L1098.75,229.75L1097.05,230.05L1096.75,229.55L1097.35,228.85L1097.75,227.25L1097.05,227.35L1095.95,226.15L1095.05,225.85L1094.25,224.85L1093.25,224.45L1092.45,223.55L1091.55,223.95L1091.05,226.05L1089.85,226.45L1090.25,225.95L1088.15,224.65L1086.45,223.95L1085.55,223.05L1084.15,221.95L1085.25,221.65L1085.75,218.75L1083.05,216.25L1084.15,213.45L1082.25,213.55L1083.95,211.15L1082.25,209.35L1080.75,206.85L1084.45,205.25L1087.65,205.55L1090.65,207.95L1091.45,210.05L1094.65,211.45L1095.35,214.05L1098.45,215.95L1099.95,214.55L1101.25,215.25L1100.25,216.35L1101.25,217.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SK" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1097.35,186.95L1096.15,188.65L1095.45,191.15L1094.45,191.75L1088.95,189.85L1087.35,190.25L1086.35,191.75L1084.05,192.55L1083.45,192.15L1081.15,193.05L1079.25,193.25L1078.95,194.55L1074.85,195.25L1072.95,194.65L1070.25,192.95L1069.55,190.85L1069.85,190.05L1070.45,188.65L1072.65,188.75L1074.25,188.15L1074.35,187.55L1075.25,187.25L1075.45,185.85L1076.55,185.55L1077.25,184.45L1078.75,184.45L1079.05,184.85L1080.95,183.95L1083.65,186.15L1086.45,184.85L1088.85,185.45L1092.35,184.55L1097.35,186.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SI" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1069.05,203.15L1065.15,204.85L1064.85,207.35L1063.15,208.05L1063.25,209.75L1061.25,209.65L1059.45,208.65L1058.65,209.65L1055.05,209.45L1056.15,208.95L1054.75,206.25L1055.15,203.15L1059.35,203.65L1061.75,202.15L1066.15,202.05L1067.05,200.95L1067.85,201.05L1069.05,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1087.45,86.25L1080.45,87.85L1076.95,91.75L1078.25,95.25L1072.05,99.75L1064.25,104.75L1062.15,112.85L1065.85,116.95L1070.65,120.25L1067.35,126.85L1062.75,128.25L1062.15,138.25L1060.05,143.95L1054.35,143.35L1052.15,148.15L1046.65,148.45L1044.75,142.75L1040.25,135.85L1036.05,127.45L1037.85,124.05L1041.25,120.05L1042.05,113.15L1038.95,110.25L1037.95,102.55L1040.35,97.15L1044.65,97.25L1045.95,95.05L1044.15,93.05L1049.85,85.15L1053.25,79.05L1055.55,75.15L1059.55,75.15L1060.15,72.05L1068.15,72.95L1068.05,69.35L1070.65,69.15L1076.65,71.85L1083.85,75.55L1085.65,84.05L1087.45,86.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1121.15,239.15L1122.35,238.45L1123.45,234.45L1120.75,232.75L1125.75,230.75L1130.35,231.55L1131.25,234.05L1136.05,236.05L1135.35,237.65L1129.15,237.95L1127.15,239.95L1123.25,243.35L1121.25,240.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UA" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1156.45,173.85L1158.75,176.55L1158.85,177.75L1165.55,179.95L1169.15,178.95L1172.75,181.85L1175.65,181.75L1183.35,183.75L1183.75,185.65L1182.45,188.85L1184.25,192.35L1183.95,194.45L1179.15,194.85L1176.95,196.65L1177.35,199.35L1173.45,199.85L1170.45,201.95L1165.85,202.25L1161.85,204.65L1162.85,208.55L1165.65,210.05L1170.75,209.65L1170.15,211.95L1164.75,213.05L1158.45,216.65L1155.35,215.35L1156.05,212.45L1150.15,210.55L1150.85,209.35L1155.45,207.25L1153.75,205.85L1145.65,204.25L1144.85,201.85L1140.35,202.65L1139.05,206.15L1135.75,210.75L1133.35,209.65L1131.05,210.75L1128.65,209.55L1129.85,208.85L1130.45,206.75L1131.55,204.65L1130.95,203.55L1131.95,203.05L1132.55,203.95L1135.55,204.15L1136.85,203.65L1135.85,203.05L1136.05,202.05L1134.05,200.45L1132.95,197.85L1130.95,196.85L1131.05,194.75L1128.45,193.05L1126.45,192.75L1122.45,190.85L1119.25,191.45L1118.15,192.35L1116.05,192.35L1115.05,193.85L1111.45,194.45L1109.85,195.45L1107.35,193.85L1104.15,193.85L1100.95,193.15L1098.95,194.55L1098.45,192.85L1095.45,191.15L1096.15,188.65L1097.35,186.95L1098.45,187.35L1096.85,184.55L1100.65,179.35L1102.95,178.65L1103.25,176.95L1100.05,171.55L1102.35,171.25L1104.75,169.65L1108.55,169.45L1113.45,169.95L1119.15,171.45L1123.05,171.55L1124.95,172.45L1126.65,171.35L1128.15,172.85L1132.45,172.55L1134.55,173.15L1134.25,170.05L1135.55,168.65L1139.65,168.35L1141.45,168.55L1142.45,167.15L1143.95,167.45L1148.85,166.85L1152.65,170.35L1151.75,171.65L1152.55,173.55L1156.45,173.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="XK" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1097.05,230.05L1095.85,230.35L1092.95,231.35L1092.85,232.65L1092.15,232.55L1091.55,230.25L1090.25,229.55L1089.05,227.85L1089.85,226.45L1091.05,226.05L1091.55,223.95L1092.45,223.55L1093.25,224.45L1094.25,224.85L1095.05,225.85L1095.95,226.15L1097.05,227.35L1097.75,227.25L1097.35,228.85L1096.75,229.55L1097.05,230.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NL" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1015.75,176.35L1012.95,174.85L1009.85,172.15L1005.35,173.45L1001.75,172.95L1004.25,171.25L1008.25,162.25L1014.75,159.65L1018.75,159.85L1019.65,161.95L1018.75,167.55L1017.55,169.85L1014.65,169.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PT" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M946.15,262.95L943.95,264.55L941.15,263.65L938.45,264.35L939.35,259.35L939.05,255.45L936.65,254.85L935.55,252.45L936.05,248.25L938.25,245.95L938.75,243.35L939.95,239.55L939.95,236.85L939.05,234.55L938.85,232.35L940.75,230.75L942.95,229.85L944.15,232.95L947.15,232.95L948.05,232.15L951.15,232.35L952.45,235.55L950.05,237.25L949.75,242.25L948.95,243.15L948.65,246.25L946.35,246.75L948.35,250.55L946.75,254.75L948.55,256.65L947.75,258.35L945.75,260.75L946.15,262.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1093.85,154.65L1085.05,154.75L1079.15,154.05L1079.85,151.45L1086.15,149.45L1091.25,150.55L1093.45,151.45L1093.25,153.15L1093.85,154.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ES" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M975.85,222.65L977.85,225.05L987.35,227.95L989.25,226.55L995.05,229.45L1000.95,228.65L1001.35,232.35L996.45,236.55L989.85,237.95L989.35,240.05L986.15,243.55L984.15,248.75L986.15,252.45L983.15,255.25L981.95,259.45L977.95,260.75L974.25,265.65L967.45,265.75L962.45,265.65L959.05,267.85L956.95,270.25L954.35,269.75L952.45,267.55L951.05,263.95L946.15,262.95L945.75,260.75L947.75,258.35L948.55,256.65L946.75,254.75L948.35,250.55L946.35,246.75L948.65,246.25L948.95,243.15L949.75,242.25L950.05,237.25L952.45,235.55L951.15,232.35L948.05,232.15L947.15,232.95L944.15,232.95L942.95,229.85L940.75,230.75L938.85,232.35L939.35,227.85L937.35,225.15L944.75,220.55L950.95,221.65L957.85,221.65L963.25,222.75L967.55,222.35L975.85,222.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1034.95,230.65L1033.45,235.55L1031.05,234.25L1029.75,230.05L1030.65,227.65L1033.85,225.25L1034.95,230.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1013.65,184.25L1014.75,184.75L1016.15,184.65L1018.55,186.25L1025.75,187.45L1023.35,191.65L1022.95,196.15L1021.65,197.25L1019.35,196.65L1019.55,198.25L1015.95,201.75L1015.95,204.65L1018.35,203.65L1020.15,206.35L1020.05,208.15L1021.55,210.55L1019.85,212.45L1021.35,217.35L1024.15,218.15L1023.65,220.85L1019.15,224.45L1008.95,222.75L1001.55,224.85L1000.95,228.65L995.05,229.45L989.25,226.55L987.35,227.95L977.85,225.05L975.85,222.65L978.55,218.85L979.55,206.25L974.45,199.65L970.75,196.45L963.15,194.05L962.75,189.45L969.25,188.15L977.55,189.75L976.05,182.65L980.75,185.35L992.15,180.55L993.65,175.45L997.85,174.15L998.65,176.35L1000.85,176.45L1003.25,178.95L1006.75,181.85L1009.25,181.35L1013.65,184.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), l15 = [
  s15
];
function u15(t, e) {
  return G(), J("svg", a15, l15);
}
const c15 = /* @__PURE__ */ U5(L15, [["render", u15]]), h15 = {}, d15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, f15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g id="AE" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1295.45,335.95L1296.75,341.05L1293.95,341.05L1293.95,345.25L1295.05,346.15L1292.65,347.45L1292.85,350.05L1291.55,352.65L1291.55,355.25L1290.55,356.65L1273.65,353.45L1270.95,346.85L1270.65,345.45L1271.55,345.05L1271.95,346.85L1276.15,345.85L1280.75,346.05L1284.15,346.25L1287.45,341.85L1291.15,337.75L1294.15,333.75L1295.45,335.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DZ" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1030.25,263.85L1029.25,267.15L1030.25,273.25L1029.15,278.55L1025.95,282.15L1026.55,286.95L1031.05,290.85L1031.15,292.35L1034.55,294.95L1037.15,306.45L1039.05,312.15L1039.45,315.15L1038.65,320.35L1039.05,323.35L1038.45,326.85L1039.05,330.85L1036.85,333.55L1040.25,338.25L1040.45,340.95L1042.55,344.55L1045.05,343.35L1049.55,346.35L1052.05,350.35L1033.25,362.65L1017.25,375.25L1009.45,378.05L1003.25,378.75L1003.15,374.65L1000.55,373.55L997.05,371.75L995.75,368.75L977.05,354.75L958.45,340.75L937.95,325.15L938.05,323.95L938.15,323.55L938.25,315.95L947.15,311.15L952.55,310.15L957.05,308.45L959.15,305.25L965.55,302.75L965.85,297.95L968.95,297.35L971.45,295.05L978.55,293.95L979.55,291.45L978.15,290.05L976.25,283.25L975.95,279.35L974.05,275.25L979.15,271.75L984.95,270.65L988.25,268.05L993.35,266.05L1002.35,264.95L1011.15,264.45L1013.85,265.35L1018.75,262.85L1024.45,262.75L1026.65,264.25L1030.25,263.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EG" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1171.35,300.65L1175.25,310.05L1175.95,311.65L1174.65,314.25L1173.95,319.05L1172.75,322.45L1171.55,323.55L1169.55,321.45L1166.85,318.65L1162.15,309.45L1161.65,310.05L1164.45,316.75L1168.35,323.25L1173.25,333.25L1175.55,336.75L1177.55,340.35L1182.95,347.45L1181.95,348.55L1182.35,352.75L1189.15,358.55L1190.25,359.85L1124.35,359.85L1123.35,336.15L1122.05,313.35L1120.05,308.15L1121.15,304.25L1120.15,301.45L1121.85,298.35L1129.05,298.25L1134.45,299.95L1139.95,301.85L1142.55,302.85L1146.55,300.85L1148.65,299.05L1153.35,298.45L1157.25,299.25L1159.05,302.45L1160.15,300.35L1164.55,301.85L1168.85,302.25L1171.35,300.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IR" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1228.25,252.45L1230.05,252.25L1235.35,247.55L1237.25,247.05L1239.15,248.95L1237.95,252.05L1241.85,255.45L1243.15,255.05L1245.65,259.85L1250.95,261.15L1255.25,264.35L1262.95,265.45L1270.95,263.75L1271.15,262.25L1275.55,261.05L1278.55,257.35L1282.15,257.55L1284.15,256.35L1288.05,256.95L1294.65,260.25L1298.95,260.95L1306.25,266.55L1310.25,266.85L1311.95,272.15L1311.35,280.15L1310.85,284.85L1313.35,285.85L1311.75,289.35L1314.45,294.45L1315.65,298.55L1319.95,299.65L1321.05,303.75L1317.15,309.55L1320.35,312.95L1323.15,316.85L1328.85,319.65L1329.85,325.25L1332.55,326.35L1333.45,329.25L1325.95,332.65L1324.85,340.05L1314.25,338.15L1308.05,336.65L1301.75,335.85L1298.45,327.95L1295.65,326.85L1291.55,327.95L1286.45,331.05L1279.45,328.95L1273.35,323.95L1267.85,322.15L1263.45,316.05L1258.25,307.55L1255.45,308.55L1251.75,306.45L1250.05,308.95L1246.55,305.55L1246.05,302.15L1244.35,302.15L1244.55,297.45L1241.05,292.65L1233.95,289.05L1229.35,282.95L1229.85,277.95L1232.15,275.75L1231.25,272.05L1227.45,270.05L1222.75,262.45L1218.95,257.35L1219.65,255.35L1216.75,248.05L1220.05,246.15L1221.25,248.65L1224.45,251.55L1228.25,252.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IQ" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1222.75,262.45L1227.45,270.05L1231.25,272.05L1232.15,275.75L1229.85,277.95L1229.35,282.95L1233.95,289.05L1241.05,292.65L1244.55,297.45L1244.35,302.15L1246.05,302.15L1246.55,305.55L1250.05,308.95L1246.75,308.65L1243.05,308.05L1239.75,314.25L1229.55,313.75L1212.75,300.85L1204.15,296.35L1197.35,294.55L1194.25,286.75L1205.25,280.05L1206.25,272.35L1205.05,267.65L1207.75,266.05L1209.85,262.05L1211.95,261.05L1218.25,261.95L1220.35,263.55L1222.75,262.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IL" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1178.35,287.45L1178.75,290.05L1178.15,291.05L1178.25,291.05L1177.55,293.05L1175.45,292.25L1174.75,296.45L1176.25,297.15L1174.95,298.05L1174.85,299.75L1177.35,298.95L1177.75,301.45L1175.95,311.65L1175.25,310.05L1171.35,300.65L1172.75,298.55L1172.35,298.15L1173.45,295.15L1174.05,290.35L1174.65,288.65L1176.55,288.65L1176.95,287.55L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="JO" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1197.35,294.55L1196.45,295.55L1186.05,298.75L1192.05,305.25L1190.45,306.25L1189.75,308.45L1185.65,309.35L1184.55,311.65L1182.45,313.65L1176.25,312.55L1175.95,311.65L1177.75,301.45L1177.35,298.95L1177.95,297.05L1177.55,293.05L1178.25,291.05L1184.55,293.65L1194.25,286.75L1197.35,294.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LB" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1178.35,287.45L1176.95,287.55L1176.55,288.65L1174.75,288.65L1176.05,283.35L1178.25,278.85L1178.25,278.65L1180.75,278.95L1181.95,281.45L1179.25,283.95L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LY" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1121.85,298.35L1120.15,301.45L1121.15,304.25L1120.05,308.15L1122.05,313.35L1123.35,336.15L1124.35,359.85L1124.85,372.65L1118.45,372.65L1118.45,375.35L1095.85,363.05L1073.35,350.75L1067.85,354.25L1064.05,356.65L1060.85,353.15L1052.05,350.35L1049.55,346.35L1045.05,343.35L1042.55,344.55L1040.45,340.95L1040.25,338.25L1036.85,333.55L1039.05,330.85L1038.45,326.85L1039.05,323.35L1038.65,320.35L1039.45,315.15L1039.05,312.15L1037.15,306.45L1039.75,305.05L1040.15,302.25L1039.55,299.65L1043.15,297.15L1044.75,295.05L1047.35,293.25L1047.45,288.35L1053.85,290.55L1056.15,289.95L1060.65,291.05L1067.95,293.95L1070.75,299.65L1075.65,300.85L1083.45,303.55L1089.45,306.75L1091.95,305.05L1094.45,302.15L1092.85,297.25L1094.35,294.05L1098.05,291.05L1101.75,290.25L1109.15,291.55L1111.15,294.35L1113.15,294.45L1114.95,295.55L1120.35,296.25L1121.85,298.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MA" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M974.05,275.25L975.95,279.35L976.25,283.25L978.15,290.05L979.55,291.45L978.55,293.95L971.45,295.05L968.95,297.35L965.85,297.95L965.55,302.75L959.15,305.25L957.05,308.45L952.55,310.15L947.15,311.15L938.25,315.95L938.15,323.55L937.25,323.55L937.35,326.95L933.95,327.15L932.15,328.65L929.65,328.65L927.65,327.75L923.05,328.45L921.15,333.45L919.35,333.95L916.65,342.05L908.75,348.95L906.75,357.85L904.35,360.75L903.65,363.05L891.15,363.55L891.05,363.55L891.35,360.55L893.55,358.85L895.45,355.45L895.15,353.25L897.15,348.75L900.35,344.65L902.25,343.65L903.85,339.95L904.05,336.45L906.15,332.55L909.95,330.15L913.55,323.65L913.65,323.55L916.55,321.05L921.65,320.35L926.05,315.95L928.85,314.25L933.55,308.85L932.35,300.95L934.55,295.35L935.45,291.95L939.05,287.65L944.45,284.75L948.55,282.05L952.25,275.45L954.05,271.45L957.95,271.55L961.05,274.25L966.15,273.85L971.65,275.25L974.05,275.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1283.05,394.15L1280.85,389.65L1275.65,379.05L1291.95,372.65L1294.55,359.85L1291.55,355.25L1291.55,352.65L1292.85,350.05L1292.65,347.45L1295.05,346.15L1293.95,345.25L1293.95,341.05L1296.75,341.05L1299.75,345.45L1303.05,347.75L1307.15,348.65L1310.55,349.75L1313.45,353.45L1315.15,355.55L1317.15,356.45L1317.35,357.85L1315.65,361.65L1314.95,363.45L1312.75,365.55L1311.05,369.95L1308.55,369.55L1307.55,371.15L1306.85,374.35L1307.95,378.65L1307.45,379.45L1304.95,379.45L1301.65,381.85L1301.35,384.95L1300.15,386.35L1296.65,386.25L1294.65,387.85L1294.85,390.45L1292.25,392.25L1289.15,391.65L1285.55,393.85L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PS" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1177.55,293.05L1177.95,297.05L1177.35,298.95L1174.85,299.75L1174.95,298.05L1176.25,297.15L1174.75,296.45L1175.45,292.25L1177.55,293.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="QA" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1269.35,342.95L1267.85,343.45L1266.05,342.15L1265.25,337.45L1266.35,334.15L1267.85,333.45L1269.65,335.45L1270.15,339.15L1269.35,342.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SA" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1239.75,314.25L1244.75,314.85L1246.45,317.95L1250.35,317.75L1253.05,323.35L1255.95,324.75L1257.15,327.05L1261.15,329.75L1261.85,332.35L1261.45,334.55L1262.35,336.65L1264.15,338.45L1265.05,340.55L1266.05,342.15L1267.85,343.45L1269.35,342.95L1270.65,345.45L1270.95,346.85L1273.65,353.45L1290.55,356.65L1291.55,355.25L1294.55,359.85L1291.95,372.65L1275.65,379.05L1259.75,381.55L1254.75,384.45L1251.25,391.15L1248.65,392.25L1247.15,390.15L1245.05,390.45L1239.55,389.75L1238.45,389.15L1232.05,389.25L1230.55,389.85L1228.15,388.25L1226.85,391.35L1227.65,394.05L1225.25,396.15L1224.35,393.35L1222.55,391.45L1222.05,388.85L1218.95,386.55L1215.65,381.15L1213.75,375.95L1209.65,371.55L1207.15,370.45L1203.05,364.35L1202.15,359.95L1202.15,356.15L1198.55,348.95L1195.75,346.45L1192.75,345.15L1190.65,341.45L1190.85,340.05L1189.05,336.65L1187.35,335.25L1184.85,330.45L1181.05,325.35L1177.95,320.95L1175.25,320.95L1175.75,317.45L1175.85,315.15L1176.25,312.55L1182.45,313.65L1184.55,311.65L1185.65,309.35L1189.75,308.45L1190.45,306.25L1192.05,305.25L1186.05,298.75L1196.45,295.55L1197.35,294.55L1204.15,296.35L1212.75,300.85L1229.55,313.75L1239.75,314.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SY" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1194.25,286.75L1184.55,293.65L1178.25,291.05L1178.15,291.05L1178.75,290.05L1178.35,287.45L1179.25,283.95L1181.95,281.45L1180.75,278.95L1178.25,278.65L1177.15,273.75L1178.15,271.05L1179.45,269.65L1180.65,268.25L1180.45,264.75L1182.35,265.95L1187.95,264.15L1190.95,265.35L1195.35,265.35L1201.05,262.95L1203.95,263.05L1209.85,262.05L1207.75,266.05L1205.05,267.65L1206.25,272.35L1205.25,280.05L1194.25,286.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TN" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1047.45,288.35L1047.35,293.25L1044.75,295.05L1043.15,297.15L1039.55,299.65L1040.15,302.25L1039.75,305.05L1037.15,306.45L1034.55,294.95L1031.15,292.35L1031.05,290.85L1026.55,286.95L1025.95,282.15L1029.15,278.55L1030.25,273.25L1029.25,267.15L1030.25,263.85L1035.95,261.35L1039.65,262.05L1039.65,265.35L1044.05,262.95L1044.45,264.15L1041.95,267.35L1042.05,270.25L1043.95,271.85L1043.45,277.45L1039.95,280.65L1041.15,284.15L1043.95,284.25L1045.35,287.35L1047.45,288.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="YE" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1283.05,394.15L1279.05,395.85L1278.15,398.75L1278.15,400.95L1272.75,403.65L1263.95,406.65L1259.25,411.15L1256.75,411.55L1255.05,411.15L1251.85,413.85L1248.35,415.05L1243.65,415.35L1242.25,415.75L1241.15,417.45L1239.65,417.95L1238.85,419.55L1236.05,419.35L1234.35,420.25L1230.35,419.95L1228.75,416.15L1228.75,412.65L1227.75,410.75L1226.45,406.05L1224.65,403.45L1225.75,403.05L1225.05,400.15L1225.65,398.95L1225.25,396.15L1227.65,394.05L1226.85,391.35L1228.15,388.25L1230.55,389.85L1232.05,389.25L1238.45,389.15L1239.55,389.75L1245.05,390.45L1247.15,390.15L1248.65,392.25L1251.25,391.15L1254.75,384.45L1259.75,381.55L1275.65,379.05L1280.85,389.65L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), p15 = [
  f15
];
function g15(t, e) {
  return G(), J("svg", d15, p15);
}
const m15 = /* @__PURE__ */ U5(h15, [["render", g15]]), v15 = {}, y15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, w15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1867.35,544.85L1865.75,545.55L1863.45,543.05L1861.25,538.95L1860.45,534.05L1861.25,533.45L1861.75,535.35L1863.35,536.85L1865.75,540.85L1868.25,543.05L1867.35,544.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1845.95,536.25L1842.95,536.75L1841.95,538.55L1835.75,541.65L1832.65,541.65L1828.15,539.75L1825.05,537.95L1825.65,535.95L1830.65,536.95L1833.85,536.45L1834.85,533.35L1835.75,533.15L1836.05,536.55L1839.25,536.15L1841.05,533.95L1844.35,531.65L1843.95,527.85L1847.35,527.75L1848.45,528.75L1848.05,532.35L1845.95,536.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1782.15,559.65L1783.75,538.65L1784.75,517.75L1794.35,522.15L1804.65,525.85L1808.35,529.15L1811.35,532.35L1811.95,536.15L1821.15,540.15L1822.25,543.55L1817.05,544.25L1817.95,548.55L1822.65,552.75L1825.65,559.55L1828.95,559.35L1828.35,562.15L1832.65,563.25L1830.85,564.45L1836.55,567.15L1835.65,569.05L1831.85,569.45L1830.65,567.85L1825.95,567.05L1820.35,566.15L1816.35,562.05L1813.55,558.45L1811.05,552.85L1803.95,550.05L1799.05,551.85L1795.35,554.05L1795.65,558.75L1791.05,560.95L1787.95,559.85L1782.15,559.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1852.85,529.95L1851.05,531.65L1850.15,527.85L1849.05,525.45L1846.55,523.35L1843.45,520.55L1839.45,518.65L1841.05,517.15L1844.05,518.95L1845.95,520.35L1848.25,521.85L1850.35,524.55L1852.45,526.65L1852.85,529.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1914.45,646.15L1914.25,646.25L1914.05,646.65L1913.65,646.45L1913.85,645.95L1913.95,645.75L1914.25,645.85L1914.45,646.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1918.85,638.35L1918.75,638.45L1918.95,638.85L1919.25,638.85L1919.65,638.65L1919.55,639.25L1919.35,639.45L1919.25,639.85L1918.75,640.15L1918.35,639.95L1918.35,639.85L1918.05,639.55L1918.15,639.35L1917.95,639.15L1918.05,638.75L1917.95,638.35L1918.05,638.35L1918.45,638.45L1918.85,638.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1916.15,634.05L1915.95,634.55L1915.95,634.95L1915.75,635.25L1916.05,635.45L1916.25,635.55L1916.35,635.75L1916.25,635.95L1916.55,636.35L1916.35,636.35L1916.15,636.85L1915.95,637.05L1915.65,636.95L1915.45,636.65L1915.35,636.45L1914.75,636.35L1914.45,635.85L1914.45,635.65L1914.35,635.35L1914.65,635.35L1914.95,635.15L1915.35,634.85L1915.45,634.55L1915.05,634.35L1914.65,634.45L1914.85,634.05L1915.15,633.95L1915.35,634.05L1915.75,633.75L1916.15,634.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1912.75,632.45L1912.45,633.05L1912.35,633.35L1912.65,633.35L1911.95,634.05L1911.85,633.85L1912.15,633.45L1912.35,632.95L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1912.75,632.45L1912.55,632.05L1912.95,632.05L1913.05,632.45L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1898.85,630.05L1899.05,630.15L1899.55,631.05L1899.85,631.35L1900.15,631.25L1900.35,630.95L1901.25,631.45L1901.55,631.95L1902.25,632.55L1902.55,632.95L1902.65,633.25L1903.05,633.65L1903.15,633.85L1903.35,633.85L1903.65,634.15L1904.55,634.35L1904.65,634.65L1904.65,635.05L1904.95,635.45L1905.35,635.55L1905.05,636.05L1905.15,636.25L1905.55,636.75L1905.65,636.75L1906.05,637.25L1905.95,637.65L1906.65,637.85L1907.05,638.35L1907.35,638.35L1907.65,638.55L1908.15,638.95L1908.05,639.25L1908.35,639.25L1908.75,639.75L1909.35,640.15L1909.35,640.35L1909.65,640.45L1909.95,640.75L1909.95,640.95L1910.25,641.55L1910.65,641.95L1910.75,641.85L1911.15,642.45L1911.65,642.55L1911.95,642.85L1911.95,643.25L1912.05,643.65L1912.15,643.75L1911.95,644.35L1911.25,644.75L1911.15,644.45L1910.85,644.55L1910.55,644.85L1909.95,644.05L1909.55,644.05L1909.45,643.85L1909.25,643.85L1909.05,644.15L1908.15,643.25L1907.95,643.25L1907.55,642.75L1907.65,641.95L1906.95,641.95L1906.65,641.75L1906.55,641.55L1906.35,641.45L1906.05,641.45L1906.05,641.15L1905.85,640.65L1905.45,640.75L1904.65,640.25L1904.55,640.05L1904.55,639.75L1904.25,639.95L1903.65,639.65L1903.55,639.25L1903.15,638.95L1902.95,638.45L1902.45,638.35L1902.65,638.15L1902.35,637.85L1902.05,637.75L1901.75,637.05L1901.75,636.65L1901.55,636.35L1901.25,636.35L1901.05,635.75L1901.15,635.55L1900.45,635.15L1900.15,634.95L1899.75,634.35L1900.05,634.15L1899.85,633.95L1899.65,633.65L1899.65,633.15L1899.15,632.85L1899.15,632.25L1898.95,631.95L1899.25,631.95L1899.35,631.65L1899.25,631.45L1898.65,631.45L1898.45,631.15L1898.95,630.45L1898.65,630.15L1898.85,630.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1899.95,630.35L1899.65,630.25L1899.75,629.85L1899.95,630.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1897.65,627.95L1897.45,628.15L1897.35,627.75L1897.55,627.55L1897.65,627.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NR" transform="matrix(8.90109,0,0,8.90109,-15863.1,-4098.13)"><path d="M1932.25,504.55L1932.05,504.55L1931.95,504.25L1932.25,504.25L1932.25,504.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1926.05,575.45L1926.35,575.65L1926.25,576.05L1926.55,576.05L1926.55,576.25L1925.75,576.25L1925.45,575.75L1925.65,575.45L1926.05,575.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1887.75,574.85L1887.95,574.85L1888.95,575.65L1889.45,575.95L1890.35,576.65L1890.25,576.95L1890.05,576.95L1889.85,577.15L1889.65,576.85L1889.55,576.85L1889.35,576.65L1889.25,576.25L1888.85,576.15L1888.85,575.85L1888.55,575.75L1888.45,575.85L1888.25,575.85L1887.35,575.45L1887.15,575.05L1887.45,574.65L1887.75,574.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1924.65,573.35L1924.45,573.65L1924.15,573.45L1924.15,573.25L1924.45,573.05L1924.65,573.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.35,569.45L1922.45,569.55L1922.75,569.55L1922.65,569.95L1922.15,570.15L1921.85,570.15L1921.45,570.25L1921.05,570.85L1920.95,570.55L1920.65,570.65L1920.45,570.45L1920.45,570.15L1920.95,570.05L1920.95,569.85L1921.25,569.45L1921.95,569.55L1922.35,569.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1896.05,566.65L1896.35,566.55L1896.95,566.85L1897.75,567.65L1897.95,567.65L1898.15,567.85L1898.35,567.85L1898.65,568.15L1898.95,568.05L1899.35,568.15L1899.55,568.35L1899.95,568.35L1900.25,568.25L1900.45,568.55L1900.65,569.35L1900.95,569.65L1900.95,570.15L1900.75,570.35L1900.85,570.65L1900.45,570.45L1900.15,570.65L1899.85,570.55L1899.35,570.25L1899.15,570.25L1898.55,570.05L1898.15,569.95L1897.95,569.65L1897.65,569.45L1897.35,569.35L1897.15,569.05L1896.75,568.85L1896.95,568.45L1896.85,568.05L1896.85,567.65L1896.65,567.55L1896.05,567.35L1895.75,567.45L1895.65,567.25L1895.85,566.65L1896.05,566.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1900.05,563.25L1899.95,563.45L1899.95,564.15L1899.75,563.95L1899.75,563.45L1900.05,563.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1897.15,561.45L1897.45,562.35L1897.65,562.75L1897.65,563.15L1897.75,563.65L1897.55,563.95L1897.15,563.25L1897.05,563.55L1896.75,563.05L1896.85,562.05L1896.95,561.85L1896.95,561.55L1897.15,561.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1888.75,561.65L1889.05,561.65L1889.35,561.55L1889.75,561.65L1889.85,561.55L1891.15,561.55L1891.35,561.85L1891.65,561.95L1891.85,562.25L1892.05,562.25L1892.25,562.35L1892.65,562.75L1892.65,563.35L1892.85,563.35L1893.25,563.55L1893.35,563.85L1893.35,564.45L1893.25,564.55L1892.55,564.75L1892.35,564.85L1891.95,564.75L1891.55,564.55L1891.15,564.55L1891.05,564.35L1890.55,564.05L1889.95,564.05L1889.45,564.15L1888.95,564.15L1888.45,564.05L1888.15,563.85L1887.85,563.95L1887.55,563.55L1887.25,563.35L1886.95,562.55L1886.75,562.15L1886.95,561.95L1886.85,561.75L1886.85,561.05L1886.95,560.75L1887.55,560.45L1887.95,560.65L1888.35,561.15L1888.45,561.45L1888.75,561.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1891.05,559.25L1891.55,559.75L1891.25,560.05L1890.95,559.85L1890.95,559.75L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1891.05,559.25L1890.85,559.65L1890.75,559.65L1890.35,559.35L1890.05,559.45L1889.85,559.35L1889.75,559.15L1890.05,559.05L1890.25,558.85L1890.75,558.95L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1884.45,558.75L1884.55,558.95L1884.75,559.05L1884.55,559.45L1884.15,559.65L1883.85,559.25L1884.45,558.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1875.95,556.95L1876.15,557.25L1876.05,557.55L1875.25,557.15L1875.75,556.85L1875.95,556.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1879.35,557.75L1879.05,557.55L1879.15,557.25L1879.45,556.95L1879.45,557.45L1879.55,557.65L1879.35,557.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1878.45,555.95L1878.65,555.85L1879.05,555.85L1879.05,556.05L1878.65,556.35L1878.85,556.55L1878.85,556.85L1878.45,557.25L1878.25,557.35L1877.95,557.25L1877.55,556.85L1877.65,556.25L1877.95,556.15L1878.15,555.75L1878.45,555.65L1878.45,555.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1874.85,556.05L1874.65,556.15L1874.45,556.65L1874.85,557.15L1874.35,556.95L1874.35,556.75L1874.25,556.45L1873.85,556.05L1873.85,555.85L1874.25,555.65L1874.35,555.35L1874.75,555.05L1875.05,555.25L1875.05,555.65L1874.85,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1887.75,555.55L1887.95,555.75L1887.85,555.95L1887.65,555.85L1887.05,555.35L1887.25,554.95L1887.55,554.85L1887.75,555.05L1887.65,555.35L1887.75,555.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1894.25,554.75L1894.65,555.55L1895.25,556.35L1895.25,556.65L1894.85,556.85L1894.85,557.65L1894.95,557.85L1895.15,557.85L1895.35,558.15L1895.85,558.55L1895.95,559.05L1896.05,559.35L1896.25,559.55L1896.05,559.75L1896.35,560.05L1896.25,560.15L1896.35,560.65L1896.15,560.85L1896.45,561.15L1896.55,561.65L1896.75,562.15L1896.75,562.75L1896.65,562.85L1896.35,562.55L1896.05,562.05L1896.05,561.75L1895.75,561.35L1895.35,561.05L1895.05,560.75L1894.55,560.15L1894.15,559.85L1893.85,558.95L1893.65,557.95L1893.45,557.25L1893.45,556.75L1893.35,556.35L1893.75,555.95L1893.65,555.65L1893.15,554.95L1893.05,554.65L1893.15,554.55L1893.55,554.65L1893.75,554.75L1894.05,554.45L1894.25,554.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1873.55,554.45L1873.35,554.05L1873.05,553.75L1873.45,553.75L1873.55,554.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1873.45,553.45L1873.85,553.55L1873.95,553.65L1874.05,554.15L1873.85,554.15L1873.65,553.75L1873.45,553.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1876.55,553.65L1876.45,553.95L1877.15,553.95L1877.55,554.65L1877.55,554.85L1877.75,555.15L1877.85,555.65L1877.65,555.85L1877.65,556.15L1877.05,555.95L1876.85,555.75L1876.55,555.75L1876.15,555.45L1876.05,555.25L1875.95,554.95L1876.35,555.05L1876.05,554.25L1875.95,554.05L1875.45,554.15L1875.25,554.25L1874.85,554.25L1874.55,554.65L1874.15,554.45L1874.15,553.85L1874.35,553.65L1874.75,553.65L1874.75,553.25L1875.15,552.65L1875.55,552.35L1875.85,552.15L1876.25,552.45L1876.45,552.85L1876.35,553.55L1876.55,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1870.65,553.65L1870.55,553.65L1870.35,552.85L1870.45,552.55L1870.45,552.15L1870.65,552.25L1870.75,552.65L1870.75,553.35L1870.65,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1874.05,553.15L1873.75,553.35L1873.65,553.25L1873.25,553.25L1872.95,552.95L1872.75,552.35L1872.85,552.05L1873.15,551.65L1873.65,551.45L1873.85,551.65L1874.15,552.15L1874.15,552.75L1874.05,553.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1871.05,549.65L1871.45,550.15L1871.45,550.25L1872.15,550.65L1872.05,550.95L1871.45,551.65L1871.45,551.95L1871.15,552.05L1871.15,551.65L1870.95,551.65L1870.95,551.25L1870.75,550.85L1870.45,550.65L1870.35,550.35L1870.45,550.05L1870.85,549.65L1871.05,549.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1881.35,549.75L1881.65,549.95L1881.45,550.05L1880.95,550.15L1880.85,549.85L1881.05,549.65L1881.35,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1882.25,549.75L1882.45,549.65L1882.95,549.95L1883.25,550.05L1883.45,550.25L1883.75,550.75L1884.05,550.85L1884.35,551.15L1884.35,551.45L1884.85,551.55L1884.85,551.85L1885.15,551.95L1885.45,551.85L1885.55,551.95L1885.95,552.15L1886.05,552.35L1886.35,552.25L1886.65,552.35L1886.75,552.65L1887.15,552.95L1887.45,553.25L1887.85,553.55L1888.85,554.55L1888.55,554.95L1888.85,555.45L1888.95,556.05L1888.65,555.95L1888.35,555.55L1887.65,554.75L1887.25,554.65L1886.75,554.25L1886.15,554.15L1886.05,553.85L1885.45,553.65L1884.95,553.15L1884.75,553.15L1883.95,552.55L1883.45,552.25L1883.45,552.05L1883.05,551.85L1882.85,551.65L1882.65,551.25L1882.25,550.95L1882.15,550.75L1882.15,550.35L1881.75,549.85L1881.55,549.75L1881.55,549.45L1882.25,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1880.75,549.15L1880.95,549.35L1881.15,549.25L1881.45,549.45L1881.35,549.65L1881.05,549.55L1880.75,549.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1876.25,548.55L1876.75,548.55L1876.55,548.75L1876.25,548.65L1876.25,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1880.55,548.55L1880.35,549.05L1880.25,548.85L1880.55,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1877.85,548.95L1877.35,549.05L1877.15,548.85L1877.45,548.45L1877.75,548.55L1877.85,548.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1865.35,548.05L1865.55,548.35L1865.35,548.55L1865.05,548.45L1864.95,548.35L1865.35,548.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1866.85,546.15L1867.15,546.35L1867.05,546.65L1866.35,546.85L1866.05,546.55L1866.35,545.95L1866.55,545.85L1866.85,546.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1868.55,545.25L1868.55,545.75L1868.35,545.55L1868.35,545.35L1868.55,545.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1871.45,543.75L1871.75,543.85L1872.15,544.35L1872.45,544.55L1872.75,544.65L1873.05,544.95L1873.85,545.35L1874.25,545.85L1874.25,546.25L1874.35,546.85L1874.85,547.35L1875.05,547.35L1875.15,547.75L1875.85,548.05L1876.25,547.95L1876.35,548.05L1876.35,548.35L1876.05,548.45L1875.85,548.75L1875.35,548.55L1874.55,548.15L1874.05,548.15L1873.75,547.75L1873.05,547.35L1871.85,545.35L1871.35,545.05L1870.65,544.35L1870.65,543.65L1870.95,543.45L1871.25,543.55L1871.45,543.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TV" transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1998.15,555.85L1998.15,555.65L1998.25,555.65L1998.25,555.75L1998.15,555.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1931.05,631.05L1930.55,630.85L1930.75,630.45L1931.25,630.35L1931.45,630.75L1931.35,630.95L1931.05,631.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.85,627.25L1929.65,627.25L1929.35,627.15L1928.95,626.65L1928.85,626.25L1928.85,625.85L1929.05,625.65L1929.15,625.25L1929.45,625.15L1929.85,625.15L1929.65,625.45L1929.65,625.95L1930.35,626.45L1930.05,626.75L1929.85,627.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.85,621.35L1930.15,621.35L1930.25,621.55L1929.75,621.65L1929.85,621.95L1930.25,622.15L1930.35,622.45L1930.25,622.85L1929.85,622.95L1929.45,622.65L1929.05,622.65L1928.85,622.45L1928.55,622.25L1928.65,621.85L1928.65,621.55L1928.85,621.05L1929.15,620.65L1929.65,620.65L1929.85,620.75L1929.75,621.15L1929.85,621.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1926.85,613.75L1927.45,613.65L1927.55,613.75L1927.75,614.35L1927.95,614.65L1928.05,614.75L1927.65,615.35L1926.85,615.55L1926.55,615.25L1926.45,614.75L1926.15,614.65L1925.75,614.95L1925.65,614.85L1925.85,614.45L1926.25,614.15L1926.65,613.65L1926.85,613.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.15,609.85L1929.05,609.55L1929.35,609.55L1929.15,609.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.55,607.45L1927.65,607.95L1927.65,608.15L1928.05,608.25L1928.25,608.75L1928.75,608.75L1928.75,609.15L1928.65,609.25L1928.35,608.95L1928.05,608.85L1927.45,609.05L1927.15,608.95L1927.05,608.75L1926.95,608.35L1927.15,607.85L1927.35,607.55L1927.55,607.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1928.45,607.25L1928.35,607.25L1928.25,606.95L1928.45,606.95L1928.45,607.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1928.65,605.85L1928.45,606.05L1927.85,606.05L1927.55,606.15L1927.35,605.95L1926.95,605.85L1926.45,605.45L1926.55,605.25L1927.05,605.05L1927.45,604.95L1927.85,604.65L1927.95,604.35L1928.15,604.35L1928.25,604.65L1928.25,605.25L1928.75,605.65L1928.65,605.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1923.95,604.55L1924.15,604.85L1924.75,605.25L1925.55,606.05L1925.55,606.45L1925.75,606.75L1925.45,606.95L1925.05,607.35L1925.05,607.15L1924.75,607.05L1924.35,607.05L1924.15,607.15L1924.15,607.35L1923.75,607.55L1923.45,607.45L1923.45,606.75L1923.35,606.15L1923.45,605.55L1923.55,605.05L1923.35,604.55L1922.75,604.85L1922.55,604.65L1922.45,604.35L1922.45,604.05L1922.75,603.75L1922.75,603.35L1922.85,603.05L1923.15,602.95L1923.75,603.25L1923.65,603.45L1923.85,603.95L1923.75,604.15L1923.95,604.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1923.35,602.15L1923.05,602.15L1922.55,601.85L1922.55,601.75L1922.75,601.45L1922.95,601.35L1923.45,601.45L1923.35,601.85L1923.35,602.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.85,601.15L1923.25,600.85L1923.35,600.95L1923.45,601.25L1922.95,601.25L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1928.55,603.75L1928.35,603.65L1928.45,602.45L1928.35,602.15L1928.45,601.65L1928.75,600.85L1928.85,600.35L1929.05,600.95L1928.95,601.25L1928.95,602.85L1928.85,603.45L1928.55,603.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.25,600.45L1926.55,600.45L1926.25,600.35L1926.25,600.15L1927.15,599.45L1927.65,599.25L1928.15,599.15L1928.15,599.35L1927.85,599.75L1927.65,600.05L1927.25,600.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.15,599.75L1929.15,599.95L1928.85,599.95L1928.95,599.65L1929.15,598.35L1929.15,598.25L1929.25,597.05L1929.45,597.15L1929.35,598.45L1929.45,598.75L1929.35,599.25L1929.15,599.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.85,601.15L1921.95,601.05L1921.35,601.35L1921.25,601.55L1921.05,601.55L1920.95,600.95L1920.75,600.85L1920.35,599.85L1920.75,599.05L1920.75,598.65L1920.65,598.45L1920.65,597.05L1920.55,596.75L1920.55,596.25L1920.75,595.95L1920.75,595.65L1920.95,595.35L1920.95,595.15L1921.25,595.05L1921.35,595.55L1921.55,595.95L1921.75,596.25L1921.85,597.55L1921.75,598.35L1921.75,598.45L1922.35,598.35L1922.65,598.05L1922.85,597.25L1922.85,597.05L1923.15,596.85L1923.45,596.95L1923.35,597.35L1923.35,598.25L1923.65,598.35L1923.65,598.85L1923.45,598.95L1923.75,599.35L1923.55,599.55L1923.55,600.05L1923.75,600.55L1923.65,600.75L1923.35,600.75L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.05,591.85L1927.45,592.15L1927.35,592.55L1926.85,593.05L1926.25,593.05L1926.25,592.65L1926.35,592.25L1926.55,591.95L1927.05,591.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.65,589.95L1927.35,590.15L1927.15,590.25L1927.15,590.45L1926.95,590.55L1926.95,590.25L1926.75,590.05L1926.65,589.75L1926.75,589.35L1927.35,589.05L1927.45,589.25L1927.55,589.65L1927.55,589.75L1927.65,589.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.65,585.75L1922.55,585.65L1922.65,585.15L1922.85,585.35L1922.65,585.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1988.35,624.15L1988.05,624.25L1988.15,623.85L1988.35,624.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1980.85,622.55L1981.05,622.75L1981.35,622.85L1981.35,623.15L1980.85,623.35L1980.35,623.05L1979.85,623.35L1979.55,623.35L1979.35,623.65L1979.45,623.95L1979.05,623.85L1978.95,624.05L1978.55,623.95L1978.45,624.05L1978.05,623.85L1978.35,623.75L1978.55,623.65L1978.75,623.45L1979.15,623.55L1979.45,623.25L1979.65,622.95L1980.15,622.85L1980.65,622.55L1980.85,622.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1981.75,622.45L1981.55,622.55L1981.35,622.45L1981.55,622.25L1981.75,622.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1987.65,616.35L1987.75,616.85L1987.55,617.45L1987.45,617.25L1987.35,616.85L1987.15,616.85L1987.25,616.35L1987.45,616.25L1987.65,616.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1985.05,614.95L1984.95,614.95L1984.85,614.55L1985.05,614.35L1985.45,614.25L1985.45,614.65L1985.25,614.85L1985.05,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1982.85,612.45L1982.75,612.85L1983.05,613.05L1983.15,613.35L1983.45,613.75L1983.75,613.85L1983.85,614.15L1984.05,614.15L1984.15,614.55L1983.85,615.05L1983.95,615.25L1984.05,615.75L1983.75,615.95L1983.75,616.45L1983.95,616.45L1984.05,616.95L1983.75,617.25L1983.15,617.45L1983.05,617.25L1982.75,617.35L1982.65,617.55L1982.35,617.25L1981.55,617.55L1980.75,618.25L1980.45,618.15L1980.05,618.35L1979.75,618.25L1979.15,618.35L1978.85,618.15L1977.65,617.75L1977.05,617.65L1976.85,617.55L1976.35,617.35L1976.15,616.35L1976.45,615.65L1976.75,615.65L1977.05,615.55L1977.15,615.05L1977.45,614.95L1977.55,614.55L1977.35,614.35L1977.95,613.95L1978.35,613.45L1978.45,613.55L1979.05,613.05L1979.25,613.05L1980.15,612.65L1980.75,612.85L1981.05,612.75L1981.55,612.55L1982.15,612.45L1982.45,612.15L1982.85,612.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1989.15,612.65L1988.95,612.75L1989.15,611.85L1989.55,611.85L1989.45,612.25L1989.15,612.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1977.75,610.65L1977.55,610.95L1977.05,611.25L1977.05,610.95L1977.45,610.55L1977.75,610.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1992.65,610.25L1992.45,610.05L1992.55,609.85L1993.05,609.35L1993.35,608.85L1993.05,609.95L1992.65,610.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1993.65,605.25L1993.25,605.65L1992.45,606.75L1992.15,606.85L1991.45,607.25L1991.25,607.85L1990.85,608.05L1990.65,608.35L1990.55,608.55L1990.85,608.65L1991.45,608.35L1991.85,607.95L1992.05,607.65L1992.65,607.35L1992.95,607.05L1993.55,606.75L1993.55,607.05L1993.05,607.75L1992.85,607.85L1992.95,608.45L1992.65,608.75L1992.35,608.45L1991.95,608.45L1991.45,608.55L1991.05,608.85L1990.35,608.95L1989.35,608.95L1989.85,608.45L1989.45,608.25L1988.85,608.45L1988.45,608.65L1988.45,608.85L1988.15,608.95L1987.95,609.05L1987.85,609.45L1987.65,609.75L1987.35,609.65L1987.35,609.45L1986.95,609.35L1986.55,609.55L1986.35,610.05L1986.05,610.25L1985.75,610.25L1985.75,609.55L1985.55,609.15L1985.65,608.95L1985.55,608.85L1984.95,609.05L1984.95,608.65L1985.35,608.35L1985.45,608.35L1985.35,607.85L1985.65,607.75L1986.15,608.05L1986.75,607.65L1986.95,607.65L1987.25,607.35L1987.45,607.35L1987.75,607.05L1987.75,606.85L1988.55,606.75L1989.75,606.35L1990.15,606.45L1990.65,606.25L1990.85,605.85L1991.05,605.85L1991.25,605.45L1991.65,605.55L1991.75,605.35L1991.95,605.45L1992.95,604.95L1993.05,605.25L1993.25,605.15L1993.45,605.25L1993.75,604.95L1994.25,604.75L1994.35,604.85L1993.85,605.25L1993.65,605.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M118.05,378.55L116.95,379.65L115.75,378.75L116.35,376.95L115.95,374.55L116.45,373.85L117.65,372.85L117.55,371.55L117.95,370.95L118.35,371.05L120.25,372.15L121.15,372.75L121.85,373.55L122.75,375.85L122.55,376.15L120.05,377.55L118.05,378.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M117.35,368.55L115.35,368.95L114.75,367.65L114.25,367.15L114.25,366.75L114.95,366.15L116.75,366.75L117.95,367.75L117.35,368.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M114.35,365.15L114.05,365.85L111.05,365.65L111.65,364.85L114.35,365.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M109.65,364.15L109.25,364.55L108.85,364.45L106.95,364.25L106.65,362.75L106.45,362.55L108.15,361.65L108.55,362.05L109.65,364.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M101.25,359.95L100.45,360.55L98.85,359.45L99.25,358.95L100.25,358.35L101.55,358.45L101.25,359.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), b15 = [
  w15
];
function x15(t, e) {
  return G(), J("svg", y15, b15);
}
const k15 = /* @__PURE__ */ U5(v15, [["render", x15]]), M15 = {}, _15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, C15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M668.35,850.95L665.35,850.75L660.35,850.75L654.35,837.15L657.45,839.95L661.75,844.55L669.55,848.25L676.85,849.75L676.05,852.75L671.65,853.05L668.35,850.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M637.85,643.95L649.15,654.35L653.75,655.35L661.05,660.15L666.95,662.65L668.05,665.45L663.85,675.25L669.65,676.95L675.95,677.95L680.15,676.95L684.45,671.95L684.75,666.35L687.35,665.05L690.55,668.85L690.95,673.95L686.75,677.45L683.45,680.05L678.15,686.35L672.15,695.05L671.65,700.25L671.25,706.85L672.45,713.25L671.55,714.65L671.95,718.75L672.25,722.15L680.05,727.65L680.25,732.05L684.15,734.85L684.45,737.95L681.15,746.15L674.15,749.65L663.95,750.95L657.95,750.25L660.05,754.15L660.15,758.85L661.95,762.05L659.45,764.35L654.35,765.25L648.75,762.85L647.25,764.55L649.75,770.85L653.75,772.75L656.05,770.75L658.55,774.05L654.35,776.05L651.45,780.05L652.65,786.35L652.55,789.75L647.75,789.75L644.75,792.95L644.85,797.75L651.35,802.35L656.55,803.55L656.75,809.25L652.15,812.75L651.55,820.05L648.05,822.45L647.15,825.35L651.35,831.85L655.95,835.35L653.85,835.05L648.95,834.05L636.85,833.25L633.35,829.65L631.45,825.05L628.35,825.45L625.75,823.15L622.65,816.65L625.35,813.85L625.45,809.95L623.65,806.75L624.35,801.35L623.25,793.05L621.45,789.35L623.25,788.15L621.85,785.75L619.05,784.55L619.85,781.85L616.75,779.45L613.05,772.15L614.75,770.85L611.45,763.05L610.65,756.55L610.45,750.85L612.95,748.55L609.65,742.25L608.05,736.45L611.05,732.25L609.65,726.85L611.25,720.65L609.85,714.75L608.25,713.55L603.35,702.45L605.45,695.85L603.75,689.65L604.65,683.75L607.25,677.75L610.55,673.75L608.55,671.25L609.35,669.15L607.75,658.45L613.35,655.35L614.55,648.65L613.65,647.05L617.65,641.25L625.15,642.85L628.85,647.45L630.45,642.25L636.85,642.55L637.85,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BO" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M661.75,630.65L661.45,628.65L656.05,625.35L650.85,625.25L641.25,627.15L639.15,632.75L639.35,636.25L637.85,643.95L636.85,642.55L630.45,642.25L628.85,647.45L625.15,642.85L617.65,641.25L613.65,647.05L609.75,647.95L606.65,639.05L602.95,631.85L604.05,625.65L600.85,622.95L599.65,618.35L596.45,613.95L599.35,607.05L596.45,601.65L597.55,599.45L596.35,597.05L598.25,593.85L597.95,588.45L597.95,583.85L599.05,581.75L593.55,571.35L597.75,571.95L600.65,571.75L601.75,569.85L606.55,567.25L609.45,564.85L616.75,563.75L616.35,568.55L617.25,571.05L616.95,575.35L623.45,581.05L629.85,582.15L632.15,584.55L636.05,585.85L638.55,587.65L642.05,587.65L645.45,589.55L645.95,593.25L647.15,595.15L647.45,597.85L645.75,597.95L648.55,605.45L659.25,605.75L658.75,609.45L659.55,611.95L662.75,613.75L664.45,617.75L663.85,622.85L662.55,625.65L663.35,629.25L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BR" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M665.05,488.85L668.15,489.45L668.75,488.05L667.75,486.85L668.35,484.95L670.65,485.55L673.35,484.85L676.55,486.25L679.05,487.55L680.75,485.85L682.05,486.05L682.85,487.85L685.55,487.45L687.75,484.95L689.55,480.25L692.95,474.35L694.95,474.05L696.25,477.65L699.25,488.85L702.35,489.95L702.45,494.35L698.15,499.65L699.85,501.55L709.95,502.55L710.15,509.05L714.45,504.85L721.55,507.15L731.05,511.05L733.85,514.75L732.95,518.35L739.55,516.35L750.55,519.75L759.05,519.55L767.45,524.85L774.85,532.05L779.25,533.85L784.05,534.15L786.15,536.15L788.15,544.35L789.25,548.25L787.15,558.85L784.45,563.05L776.75,571.95L773.35,579.25L769.35,584.75L767.95,584.95L766.65,589.65L767.55,601.65L766.45,611.55L766.15,615.75L764.55,618.35L764.05,626.95L758.85,635.25L758.35,641.95L754.05,644.65L752.95,648.55L746.95,648.55L738.45,650.95L734.75,653.85L728.75,655.75L722.65,660.85L718.55,667.25L718.25,672.05L719.55,675.55L719.25,682.05L718.45,685.15L715.05,688.75L710.55,700.05L706.55,705.05L703.35,708.15L701.85,714.25L698.95,717.85L696.85,714.25L698.65,711.15L694.85,706.85L690.05,703.25L683.75,699.15L681.85,699.35L675.55,694.35L672.15,695.05L678.15,686.35L683.45,680.05L686.75,677.45L690.95,673.95L690.55,668.85L687.35,665.05L684.75,666.35L685.45,662.65L685.75,658.85L685.45,655.25L683.35,654.15L681.35,655.15L679.25,654.85L678.45,652.45L677.35,646.55L676.15,644.65L672.25,642.85L670.05,644.15L664.15,642.85L663.75,634.15L661.75,630.65L663.35,629.25L662.55,625.65L663.85,622.85L664.45,617.75L662.75,613.75L659.55,611.95L658.75,609.45L659.25,605.75L648.55,605.45L645.75,597.95L647.45,597.85L647.15,595.15L645.95,593.25L645.45,589.55L642.05,587.65L638.55,587.65L636.05,585.85L632.15,584.55L629.85,582.15L623.45,581.05L616.95,575.35L617.25,571.05L616.35,568.55L616.75,563.75L609.45,564.85L606.55,567.25L601.75,569.85L600.65,571.75L597.75,571.95L593.55,571.35L590.35,572.45L587.75,571.75L587.65,562.05L583.25,565.75L578.25,565.65L575.95,562.15L572.15,561.85L573.15,559.05L569.85,555.15L567.25,549.35L568.75,548.25L568.55,545.45L571.95,543.65L571.25,540.15L572.65,537.95L572.95,534.95L579.25,530.55L583.85,529.35L584.65,528.35L589.75,528.65L591.95,511.05L592.05,508.25L591.15,504.65L588.55,502.25L588.65,497.55L591.85,496.55L592.95,497.25L593.15,494.75L589.85,494.05L589.85,490.05L600.85,490.25L602.75,487.95L604.35,490.05L605.35,493.85L606.45,493.05L609.55,496.45L613.95,496.05L615.05,494.05L619.25,492.55L621.65,491.45L622.35,488.75L626.45,486.95L626.15,485.55L621.35,485.05L620.65,480.95L620.95,476.65L618.45,475.05L619.55,474.45L623.65,475.25L628.15,476.85L629.85,475.35L633.95,474.35L640.35,471.95L642.45,469.45L641.75,467.65L644.75,467.45L645.95,468.85L645.15,471.75L647.15,472.65L648.35,475.65L646.75,477.95L645.75,483.35L647.15,486.65L647.45,489.65L650.95,492.65L653.75,492.95L654.35,491.65L656.15,491.35L658.75,490.25L660.55,488.55L663.75,489.15L665.05,488.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CO" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M583.65,425.45L579.95,426.55L578.35,429.75L576.05,431.55L574.25,433.95L573.35,438.55L571.55,442.35L574.45,442.75L575.05,445.65L576.25,447.15L576.55,449.65L575.85,452.05L575.95,453.45L577.35,453.95L578.55,456.15L585.85,455.55L589.15,456.35L592.95,461.95L595.25,461.25L599.35,461.55L602.55,460.85L604.55,461.95L603.35,465.35L602.05,467.55L601.45,472.15L602.55,476.45L604.05,478.35L604.25,479.75L601.35,482.95L603.35,484.35L604.85,486.65L606.45,493.05L605.35,493.85L604.35,490.05L602.75,487.95L600.85,490.25L589.85,490.05L589.85,494.05L593.15,494.75L592.95,497.25L591.85,496.55L588.65,497.55L588.55,502.25L591.15,504.65L592.05,508.25L591.95,511.05L589.75,528.65L586.85,525.25L585.15,525.15L588.65,518.55L584.25,515.55L580.85,516.15L578.75,515.05L575.65,516.75L571.45,515.85L567.95,509.15L565.35,507.55L563.55,504.45L559.75,501.45L558.25,502.05L555.85,500.55L553.05,498.45L551.45,499.45L546.65,498.55L545.25,495.75L544.15,495.85L538.55,492.25L537.85,490.25L539.95,489.75L539.75,486.55L541.15,484.15L543.95,483.75L546.45,479.75L548.65,476.35L546.65,474.85L547.85,471.15L546.75,465.25L548.05,463.55L547.35,458.15L545.15,454.65L546.05,451.55L547.85,452.05L548.95,450.15L547.85,446.35L548.55,445.45L551.45,445.65L555.95,441.15L558.35,440.45L558.45,438.35L559.85,432.85L563.25,429.95L566.75,429.75L567.35,428.45L571.75,428.95L576.35,425.75L578.65,424.35L581.55,421.25L583.55,421.65L584.85,423.35L583.65,425.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EC" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M558.25,502.05L559.05,506.95L557.35,511.05L551.25,517.85L544.55,520.35L541.15,525.95L540.25,530.25L537.15,532.95L534.65,529.65L532.35,528.95L530.05,529.45L529.75,527.15L531.35,525.65L530.65,522.95L533.55,518.15L532.25,515.35L530.15,518.35L526.65,515.45L527.75,513.65L526.75,507.85L528.75,506.85L529.75,502.85L531.85,498.75L531.55,496.15L534.65,494.75L538.55,492.25L544.15,495.85L545.25,495.75L546.65,498.55L551.45,499.45L553.05,498.45L555.85,500.55L558.25,502.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GY" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M662.15,462.75L661.15,468.55L657.65,470.15L657.95,471.65L656.85,475.05L659.25,479.65L661.05,479.65L661.75,483.25L665.05,488.85L663.75,489.15L660.55,488.55L658.75,490.25L656.15,491.35L654.35,491.65L653.75,492.95L650.95,492.65L647.45,489.65L647.15,486.65L645.75,483.35L646.75,477.95L648.35,475.65L647.15,472.65L645.15,471.75L645.95,468.85L644.75,467.45L641.75,467.65L638.05,462.85L639.65,461.05L639.65,458.05L643.15,457.05L644.55,455.85L642.75,453.45L643.25,451.15L647.95,447.35L651.55,449.75L654.85,453.85L654.95,457.25L657.05,457.35L660.05,460.45L662.15,462.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PE" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M589.75,528.65L584.65,528.35L583.85,529.35L579.25,530.55L572.95,534.95L572.65,537.95L571.25,540.15L571.95,543.65L568.55,545.45L568.75,548.25L567.25,549.35L569.85,555.15L573.15,559.05L572.15,561.85L575.95,562.15L578.25,565.65L583.25,565.75L587.65,562.05L587.75,571.75L590.35,572.45L593.55,571.35L599.05,581.75L597.95,583.85L597.95,588.45L598.25,593.85L596.35,597.05L597.55,599.45L596.45,601.65L599.35,607.05L596.45,613.95L595.35,617.25L592.55,618.85L586.65,615.15L585.85,612.55L574.15,606.15L563.45,599.05L558.75,595.15L555.95,589.85L556.75,587.95L551.35,579.55L544.95,567.75L538.95,554.95L536.55,551.95L534.55,547.25L529.95,543.05L525.85,540.45L527.55,537.65L524.55,531.45L526.25,526.95L530.65,522.95L531.35,525.65L529.75,527.15L530.05,529.45L532.35,528.95L534.65,529.65L537.15,532.95L540.25,530.25L541.15,525.95L544.55,520.35L551.25,517.85L557.35,511.05L559.05,506.95L558.25,502.05L559.75,501.45L563.55,504.45L565.35,507.55L567.95,509.15L571.45,515.85L575.65,516.75L578.75,515.05L580.85,516.15L584.25,515.55L588.65,518.55L585.15,525.15L586.85,525.25L589.75,528.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PY" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M661.75,630.65L663.75,634.15L664.15,642.85L670.05,644.15L672.25,642.85L676.15,644.65L677.35,646.55L678.45,652.45L679.25,654.85L681.35,655.15L683.35,654.15L685.45,655.25L685.75,658.85L685.45,662.65L684.75,666.35L684.45,671.95L680.15,676.95L675.95,677.95L669.65,676.95L663.85,675.25L668.05,665.45L666.95,662.65L661.05,660.15L653.75,655.35L649.15,654.35L637.85,643.95L639.35,636.25L639.15,632.75L641.25,627.15L650.85,625.25L656.05,625.35L661.45,628.65L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SR" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M680.25,464.15L677.15,469.65L677.45,474.05L679.65,477.85L678.55,480.55L678.05,483.55L676.55,486.25L673.35,484.85L670.65,485.55L668.35,484.95L667.75,486.85L668.75,488.05L668.15,489.45L665.05,488.85L661.75,483.25L661.05,479.65L659.25,479.65L656.85,475.05L657.95,471.65L657.65,470.15L661.15,468.55L662.15,462.75L668.95,464.05L669.55,462.85L674.15,462.35L680.25,464.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UY" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M698.95,717.85L697.35,721.95L691.95,725.45L687.75,724.15L684.95,724.85L679.45,722.15L675.85,722.35L671.95,718.75L671.55,714.65L672.45,713.25L671.25,706.85L671.65,700.25L672.15,695.05L675.55,694.35L681.85,699.35L683.75,699.15L690.05,703.25L694.85,706.85L698.65,711.15L696.85,714.25L698.95,717.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VE" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M647.95,447.35L643.25,451.15L642.75,453.45L644.55,455.85L643.15,457.05L639.65,458.05L639.65,461.05L638.05,462.85L641.75,467.65L642.45,469.45L640.35,471.95L633.95,474.35L629.85,475.35L628.15,476.85L623.65,475.25L619.55,474.45L618.45,475.05L620.95,476.65L620.65,480.95L621.35,485.05L626.15,485.55L626.45,486.95L622.35,488.75L621.65,491.45L619.25,492.55L615.05,494.05L613.95,496.05L609.55,496.45L606.45,493.05L604.85,486.65L603.35,484.35L601.35,482.95L604.25,479.75L604.05,478.35L602.55,476.45L601.45,472.15L602.05,467.55L603.35,465.35L604.55,461.95L602.55,460.85L599.35,461.55L595.25,461.25L592.95,461.95L589.15,456.35L585.85,455.55L578.55,456.15L577.35,453.95L575.95,453.45L575.85,452.05L576.55,449.65L576.25,447.15L575.05,445.65L574.45,442.75L571.55,442.35L573.35,438.55L574.25,433.95L576.05,431.55L578.35,429.75L579.95,426.55L583.65,425.45L583.45,426.95L580.05,427.75L581.75,430.65L581.45,434.05L578.75,437.75L580.65,442.85L583.15,442.45L584.65,437.75L582.95,435.55L582.95,430.65L590.15,428.05L589.55,425.05L591.65,422.95L593.35,427.55L597.35,427.65L600.75,431.15L600.95,433.35L605.95,433.35L612.05,432.75L615.15,435.55L619.35,436.35L622.65,434.35L622.75,432.75L629.85,432.35L636.55,432.25L631.65,434.15L633.45,437.25L637.95,437.65L642.15,440.85L642.85,445.95L645.75,445.85L647.95,447.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M654.35,837.15L660.35,850.75L665.35,850.75L668.35,850.95L667.85,853.35L664.65,855.25L662.25,855.05L659.15,854.55L654.95,852.75L649.55,851.85L642.05,848.45L635.65,845.25L625.85,838.35L630.45,839.65L639.05,843.75L646.35,845.95L647.55,843.15L647.25,838.95L650.65,836.35L654.35,837.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M613.65,647.05L614.55,648.65L613.35,655.35L607.75,658.45L609.35,669.15L608.55,671.25L610.55,673.75L607.25,677.75L604.65,683.75L603.75,689.65L605.45,695.85L603.35,702.45L608.25,713.55L609.85,714.75L611.25,720.65L609.65,726.85L611.05,732.25L608.05,736.45L609.65,742.25L612.95,748.55L610.45,750.85L610.65,756.55L611.45,763.05L614.75,770.85L613.05,772.15L616.75,779.45L619.85,781.85L619.05,784.55L621.85,785.75L623.25,788.15L621.45,789.35L623.25,793.05L624.35,801.35L623.65,806.75L625.45,809.95L625.35,813.85L622.65,816.65L625.75,823.15L628.35,825.45L631.45,825.05L633.35,829.65L636.85,833.25L648.95,834.05L653.85,835.05L649.55,835.05L647.85,836.55L644.45,838.75L646.15,844.45L644.25,844.55L637.95,842.65L630.45,838.35L622.85,834.85L619.65,830.95L619.35,827.35L615.15,823.15L610.15,812.55L609.95,806.55L613.35,801.75L605.05,799.85L607.75,794.35L605.75,783.85L612.25,786.05L610.45,772.95L606.45,771.25L607.45,779.15L603.95,778.25L602.45,769.25L600.45,757.45L601.55,753.05L598.25,746.85L595.85,739.65L598.05,739.35L598.65,729.05L599.85,718.75L599.95,709.25L596.65,699.55L597.25,694.25L595.15,686.35L596.95,678.55L596.05,666.15L596.05,652.75L596.15,638.45L594.65,627.95L592.55,618.85L595.35,617.25L596.45,613.95L599.65,618.35L600.85,622.95L604.05,625.65L602.95,631.85L606.65,639.05L609.75,647.95L613.65,647.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GF" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M676.55,486.25L678.05,483.45L678.55,480.55L679.55,477.85L677.45,474.05L677.15,469.65L680.25,464.15L682.15,464.85L686.25,466.35L692.15,471.75L692.95,474.35L689.55,480.25L687.75,484.95L685.55,487.45L682.85,487.85L682.05,486.05L680.75,485.85L679.05,487.55L676.55,486.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M692.95,831.05L692.55,830.85L692.05,830.55L691.25,830.25L691.35,829.85L690.65,829.75L690.35,829.65L690.05,829.25L690.25,829.15L691.05,829.45L691.85,829.85L692.35,829.95L692.75,830.05L693.05,829.75L693.15,829.45L693.35,829.55L693.75,829.35L693.85,829.55L694.35,829.55L694.35,829.85L694.65,829.85L695.55,829.65L695.65,829.85L695.95,829.85L696.35,829.75L696.05,829.55L695.95,829.25L696.35,829.25L696.95,829.45L697.05,829.85L696.65,830.35L696.75,830.65L696.55,830.85L696.15,830.85L695.85,831.65L695.55,831.95L695.25,832.55L695.15,832.85L694.65,833.15L694.55,832.95L694.15,832.95L694.15,833.25L693.35,833.15L693.25,833.25L693.55,833.65L693.45,833.75L693.25,834.15L692.85,834.15L692.55,834.55L692.25,834.65L692.05,834.65L691.85,834.35L691.45,834.05L691.45,833.85L690.95,833.85L691.55,834.25L691.15,834.25L690.65,833.95L690.05,833.65L689.75,833.45L689.75,833.25L690.45,833.45L691.05,833.25L690.55,833.05L690.45,832.95L691.35,832.95L691.75,833.05L692.05,833.25L692.05,833.05L692.45,832.95L692.55,832.65L692.15,832.45L691.95,831.95L692.05,831.75L692.65,831.75L692.85,831.85L693.25,831.75L693.15,831.45L692.35,831.45L692.35,831.55L691.95,831.75L691.35,831.75L690.85,831.45L690.85,831.15L691.55,831.35L692.15,831.15L692.45,831.15L692.95,831.05L693.35,831.25L693.35,831.15L692.95,831.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M699.35,829.05L699.95,829.05L700.05,828.95L700.55,828.85L700.95,829.05L701.35,829.35L701.45,829.65L701.45,829.75L700.95,829.85L700.75,829.55L700.55,829.45L700.45,829.75L700.65,829.85L700.75,830.15L701.05,829.95L701.25,830.05L701.35,830.45L701.65,830.55L701.75,830.45L702.25,830.75L702.35,830.35L701.55,830.15L701.65,829.65L701.95,829.45L703.45,829.35L704.15,829.95L704.35,830.05L704.35,830.45L703.75,830.35L703.25,830.15L702.65,830.35L702.95,830.55L703.35,830.65L704.25,830.75L704.55,830.85L704.65,831.05L704.45,831.55L703.95,831.55L703.85,831.65L703.15,831.75L702.65,831.95L702.95,832.15L702.05,832.55L701.65,832.45L701.15,832.55L700.45,832.55L699.85,832.35L699.25,831.95L699.25,832.25L699.55,832.45L700.15,832.65L700.45,832.95L700.65,832.85L701.05,832.95L701.45,833.25L701.25,833.35L701.45,833.85L701.25,833.85L700.95,833.55L700.55,833.45L700.05,833.85L699.85,833.55L699.55,833.35L699.25,833.35L698.75,833.15L698.55,833.25L698.75,833.65L699.05,833.65L699.25,833.85L699.05,833.95L699.75,834.55L699.55,834.65L699.15,834.45L698.85,834.45L698.55,834.15L697.95,833.95L697.85,834.55L698.35,834.65L698.35,834.95L698.25,835.15L697.85,835.05L697.75,834.85L697.25,834.65L697.15,834.45L696.95,834.45L696.55,833.95L696.85,833.55L696.85,833.35L696.45,832.85L696.45,832.65L696.95,832.45L696.85,832.25L697.35,832.15L697.25,831.85L697.85,831.45L698.45,831.25L698.85,831.65L698.85,832.05L699.15,831.95L698.65,831.35L698.75,831.05L698.15,830.85L697.75,830.55L697.85,830.35L698.25,830.55L698.35,830.05L697.65,829.85L697.75,829.55L697.95,829.65L698.25,829.45L698.55,829.45L698.75,829.15L698.45,828.85L698.85,828.85L699.35,829.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), S15 = [
  C15
];
function D15(t, e) {
  return G(), J("svg", _15, S15);
}
const E15 = /* @__PURE__ */ U5(M15, [["render", D15]]), I15 = {}, T15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, O15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1666.75,566.85L1664.35,566.95L1657.25,562.45L1662.65,561.15L1665.45,563.15L1667.25,565.05L1666.75,566.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1691.55,558.15L1692.05,559.45L1691.95,561.35L1687.85,566.15L1682.85,567.55L1682.25,566.85L1682.95,564.65L1685.75,560.75L1691.55,558.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1651.95,553.05L1653.85,554.75L1657.45,554.25L1658.65,556.95L1651.95,558.25L1648.05,559.15L1644.95,559.05L1647.15,555.35L1650.35,555.35L1651.95,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1680.25,553.05L1679.15,556.65L1670.55,558.45L1663.05,557.65L1663.25,555.25L1667.85,553.95L1671.25,555.85L1675.05,555.35L1680.25,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1600.05,544.55L1610.85,545.25L1612.25,542.55L1622.55,545.65L1624.35,549.85L1632.75,551.05L1639.45,554.85L1632.85,557.25L1626.75,554.65L1621.65,554.85L1615.85,554.35L1610.65,553.25L1604.25,550.75L1600.15,550.15L1597.75,550.95L1587.55,548.25L1586.75,545.55L1581.65,545.05L1585.85,538.95L1592.65,539.35L1597.05,541.85L1599.45,542.35L1600.05,544.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1747.95,540.95L1744.75,545.35L1744.55,540.55L1745.65,538.25L1746.95,536.05L1748.15,537.95L1747.95,540.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1706.55,523.25L1704.35,525.45L1700.55,524.25L1699.55,521.45L1705.25,521.15L1706.55,523.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1724.95,520.95L1726.75,525.85L1722.15,523.15L1717.45,522.65L1714.15,523.05L1710.25,522.85L1711.75,519.35L1718.75,519.05L1724.95,520.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1784.75,517.75L1783.75,538.65L1782.15,559.65L1777.55,554.35L1771.95,553.05L1770.45,554.85L1763.25,555.05L1766.05,549.85L1769.75,548.05L1768.75,541.05L1766.45,535.75L1755.75,530.25L1751.15,529.75L1742.85,523.75L1741.05,526.95L1738.85,527.45L1737.75,525.15L1737.85,522.35L1733.65,519.15L1739.85,516.85L1743.85,516.95L1743.45,515.25L1735.15,515.25L1732.95,511.45L1727.95,510.25L1725.65,507.05L1733.25,505.55L1736.15,503.45L1745.25,506.05L1746.15,508.45L1747.45,518.85L1753.15,522.65L1758.15,515.85L1764.75,512.05L1769.75,512.05L1774.55,514.25L1778.65,516.55L1784.75,517.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1695.65,491.95L1691.15,498.35L1686.85,499.55L1681.45,498.35L1671.95,498.65L1667.05,499.55L1666.25,504.45L1671.25,510.15L1674.35,507.25L1684.95,505.05L1684.45,507.95L1681.95,507.05L1679.45,510.85L1674.35,513.35L1679.45,521.55L1678.35,523.75L1683.15,531.15L1682.85,535.35L1679.75,537.25L1677.65,534.95L1680.65,529.75L1674.95,532.25L1673.65,530.45L1674.45,527.95L1670.55,524.15L1671.25,517.95L1667.35,519.85L1667.55,527.35L1667.35,536.55L1663.65,537.45L1661.35,535.65L1663.25,529.75L1662.65,523.55L1660.25,523.45L1658.65,519.05L1661.15,514.85L1662.05,509.75L1665.05,500.05L1666.15,497.45L1670.95,492.65L1675.45,494.55L1682.55,495.45L1689.05,495.15L1694.65,490.55L1695.65,491.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1715.25,493.85L1714.95,499.45L1712.05,498.75L1711.15,502.65L1713.45,506.05L1711.85,506.85L1709.65,502.75L1707.95,494.55L1708.95,489.45L1710.75,487.15L1711.25,490.65L1714.65,491.15L1715.25,493.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1607.25,488.15L1608.25,492.45L1612.15,496.15L1615.85,494.85L1619.45,495.25L1622.75,492.05L1625.45,491.45L1630.85,493.25L1635.45,491.85L1638.05,482.95L1640.15,480.75L1641.85,473.45L1648.35,473.45L1653.35,474.55L1650.35,480.35L1654.75,486.35L1653.85,489.35L1660.25,495.25L1653.55,496.05L1651.75,500.45L1651.95,506.25L1646.45,510.65L1646.05,517.05L1643.55,526.85L1642.85,524.55L1636.25,527.45L1634.15,523.55L1630.15,523.15L1627.35,521.05L1620.55,523.45L1618.65,520.25L1614.85,520.65L1610.25,519.95L1609.65,511.35L1606.85,509.55L1604.15,504.05L1603.35,498.45L1603.95,492.45L1607.25,488.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1584.45,538.65L1578.25,538.75L1573.75,533.45L1566.65,528.15L1564.35,524.25L1560.25,519.05L1557.55,514.25L1553.35,505.25L1548.45,499.85L1546.75,494.35L1544.55,489.35L1539.35,485.35L1536.25,479.85L1531.85,476.25L1525.65,469.15L1525.05,465.85L1528.65,466.15L1537.55,467.35L1542.75,473.65L1547.35,478.05L1550.55,480.65L1556.05,487.55L1561.85,487.65L1566.65,492.05L1570.05,497.45L1574.35,500.45L1572.05,505.65L1575.35,507.85L1577.35,508.05L1578.25,512.55L1580.15,516.05L1584.25,516.65L1586.85,520.75L1585.15,528.75L1584.45,538.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KH" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1589.05,409.85L1590.85,414.15L1590.95,421.85L1581.95,426.85L1584.75,430.65L1578.85,431.15L1574.25,433.75L1569.45,432.85L1566.85,429.45L1563.35,422.85L1561.25,415.05L1564.35,409.75L1571.45,408.55L1576.75,409.45L1581.75,411.95L1583.75,407.55L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LA" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1589.05,409.85L1583.75,407.55L1581.75,411.95L1576.75,409.45L1578.25,406.55L1577.85,401.15L1572.55,395.55L1571.25,389.15L1566.25,383.95L1561.95,383.55L1561.15,385.75L1557.95,385.95L1556.05,384.85L1550.75,388.65L1549.75,382.85L1550.15,376.15L1546.35,375.85L1545.45,371.95L1542.75,369.95L1543.55,367.65L1547.65,363.45L1548.45,364.95L1551.45,365.15L1549.45,357.75L1552.15,356.85L1556.15,361.95L1559.65,367.75L1566.45,367.75L1569.45,373.35L1566.15,375.05L1564.95,377.35L1572.25,381.25L1577.95,388.85L1582.35,394.45L1587.25,398.95L1589.25,403.45L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MM" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1547.65,363.45L1543.55,367.65L1542.75,369.95L1539.75,371.45L1536.95,374.25L1533.05,374.55L1531.55,381.45L1529.35,382.65L1532.85,388.25L1536.95,392.95L1539.85,397.25L1538.45,402.75L1536.65,403.95L1538.45,407.15L1542.75,412.25L1543.75,415.85L1543.95,418.85L1546.65,424.75L1544.05,430.75L1541.85,437.35L1540.95,432.55L1542.25,427.65L1540.05,423.85L1539.85,416.85L1537.25,413.45L1534.55,405.85L1532.55,397.75L1529.45,392.35L1526.25,395.65L1520.45,400.15L1517.15,399.65L1513.55,398.15L1514.45,390.15L1512.45,384.15L1507.15,376.75L1507.45,374.45L1504.05,373.55L1499.45,368.35L1498.35,363.15L1500.45,364.15L1499.85,359.55L1502.35,358.05L1501.35,355.35L1502.35,353.15L1501.45,346.45L1506.05,347.95L1507.65,342.65L1507.35,339.55L1509.35,334.15L1508.45,330.45L1514.65,326.05L1518.85,327.15L1517.45,323.25L1519.15,322.05L1518.15,319.65L1521.25,319.15L1523.95,322.95L1526.65,324.45L1527.95,329.35L1528.85,334.65L1524.65,340.05L1525.35,347.65L1530.95,346.55L1533.35,352.45L1537.05,353.75L1536.25,359.05L1540.75,361.45L1543.35,362.65L1547.15,360.75L1547.65,363.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1563.55,461.15L1564.95,461.75L1568.45,465.65L1570.95,469.95L1571.55,474.25L1571.05,477.15L1571.65,479.35L1572.15,483.15L1574.25,484.95L1576.55,490.65L1576.55,492.75L1572.55,493.25L1567.05,488.45L1560.25,483.35L1559.45,480.05L1556.05,475.75L1555.05,470.45L1552.85,466.95L1553.25,462.25L1551.85,459.55L1552.75,458.45L1557.55,461.25L1558.15,464.55L1561.85,463.75L1563.55,461.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1653.35,474.55L1648.35,473.45L1641.85,473.45L1640.15,480.75L1638.05,482.95L1635.45,491.85L1630.85,493.25L1625.45,491.45L1622.75,492.05L1619.45,495.25L1615.85,494.85L1612.15,496.15L1608.25,492.45L1607.25,488.15L1611.45,490.35L1615.75,489.15L1616.75,483.75L1619.15,482.55L1625.95,481.15L1629.75,476.05L1632.35,472.05L1635.15,475.35L1636.25,473.15L1638.95,473.35L1639.05,469.25L1639.15,466.05L1643.25,461.65L1645.85,456.65L1648.15,456.55L1651.25,459.85L1651.65,462.65L1655.45,464.45L1660.25,466.35L1660.05,468.85L1656.25,469.15L1657.35,472.35L1653.35,474.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1699.75,447.05L1700.65,451.35L1701.25,454.95L1699.65,460.75L1697.15,454.25L1694.75,457.55L1696.85,462.25L1695.45,465.25L1688.55,461.55L1686.65,456.85L1688.15,453.85L1684.35,450.75L1682.75,453.45L1680.15,453.15L1676.15,456.75L1675.15,454.85L1676.95,449.45L1680.35,447.65L1683.25,445.25L1685.45,448.15L1689.65,446.45L1690.35,443.55L1694.35,443.35L1693.55,438.45L1698.45,441.45L1699.15,444.65L1699.75,447.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1685.15,435.05L1683.35,437.15L1681.95,441.25L1680.35,443.15L1676.45,438.75L1677.45,436.95L1678.75,435.15L1678.95,431.25L1682.05,430.85L1681.55,435.15L1685.15,428.95L1685.15,435.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1654.85,441.25L1647.75,447.35L1650.15,442.85L1653.95,438.85L1656.95,434.45L1659.25,428.05L1660.85,433.35L1657.35,436.85L1654.85,441.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1672.35,424.75L1675.95,426.75L1679.45,426.75L1679.65,429.35L1677.35,432.15L1673.95,434.05L1673.45,431.05L1673.55,427.75L1672.35,424.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1692.45,422.95L1694.85,430.15L1690.35,428.45L1690.65,430.65L1692.45,434.55L1689.85,436.05L1689.25,431.45L1687.45,431.15L1686.25,427.25L1689.55,427.75L1689.25,425.35L1685.25,420.45L1690.65,420.55L1692.45,422.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1669.45,417.15L1668.55,422.75L1665.85,419.55L1662.35,414.65L1667.15,414.85L1669.45,417.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1662.95,382.25L1666.75,384.15L1668.15,382.45L1668.95,384.05L1668.55,386.75L1671.15,391.35L1670.55,396.65L1667.65,398.75L1667.55,403.95L1669.55,409.05L1672.55,409.75L1674.95,409.05L1682.45,412.55L1682.35,416.05L1684.45,417.65L1684.15,420.55L1679.45,417.45L1676.95,414.05L1675.75,416.45L1671.75,412.55L1666.75,413.55L1663.75,412.15L1663.65,409.45L1665.25,407.85L1663.35,406.35L1662.95,408.65L1659.65,404.95L1658.35,402.15L1657.25,396.05L1659.85,398.15L1658.75,388.05L1659.55,382.25L1662.95,382.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TH" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1576.75,409.45L1571.45,408.55L1564.35,409.75L1561.25,415.05L1563.35,422.85L1558.05,419.85L1553.25,420.05L1553.55,414.95L1548.65,414.95L1548.85,422.05L1546.65,431.45L1545.25,437.15L1545.95,441.75L1549.65,441.95L1552.35,447.85L1553.65,453.35L1557.05,457.05L1560.45,457.75L1563.55,461.15L1561.85,463.75L1558.15,464.55L1557.55,461.25L1552.75,458.45L1551.85,459.55L1549.55,457.15L1548.35,453.95L1545.15,450.35L1542.25,447.25L1541.55,451.05L1540.25,447.45L1540.65,443.45L1541.85,437.35L1544.05,430.75L1546.65,424.75L1543.95,418.85L1543.75,415.85L1542.75,412.25L1538.45,407.15L1536.65,403.95L1538.45,402.75L1539.85,397.25L1536.95,392.95L1532.85,388.25L1529.35,382.65L1531.55,381.45L1533.05,374.55L1536.95,374.25L1539.75,371.45L1542.75,369.95L1545.45,371.95L1546.35,375.85L1550.15,376.15L1549.75,382.85L1550.75,388.65L1556.05,384.85L1557.95,385.95L1561.15,385.75L1561.95,383.55L1566.25,383.95L1571.25,389.15L1572.55,395.55L1577.85,401.15L1578.25,406.55L1576.75,409.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TL" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1691.95,561.35L1692.05,559.45L1691.55,558.15L1692.35,556.65L1697.25,555.25L1701.25,554.95L1703.05,554.15L1705.15,554.95L1702.95,556.75L1696.85,559.55L1691.95,561.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VN" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1585.75,362.75L1579.25,368.15L1575.55,374.25L1574.95,378.75L1580.25,385.45L1586.75,393.85L1592.45,397.85L1596.55,402.95L1600.55,414.85L1600.95,426.15L1596.65,430.35L1590.55,434.55L1586.35,439.85L1579.75,445.85L1577.45,441.75L1578.65,437.35L1574.25,433.75L1578.85,431.15L1584.75,430.65L1581.95,426.85L1590.95,421.85L1590.85,414.15L1589.05,409.85L1589.25,403.45L1587.25,398.95L1582.35,394.45L1577.95,388.85L1572.25,381.25L1564.95,377.35L1566.15,375.05L1569.45,373.35L1566.45,367.75L1559.65,367.75L1556.15,361.95L1552.15,356.85L1554.85,355.25L1559.25,355.35L1564.55,354.55L1568.65,351.15L1571.75,353.55L1577.05,354.75L1576.75,358.45L1579.85,361.05L1585.75,362.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), z15 = [
  O15
];
function P15(t, e) {
  return G(), J("svg", T15, z15);
}
const A15 = /* @__PURE__ */ U5(I15, [["render", P15]]), $15 = {}, Z15 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, N15 = /* @__PURE__ */ Le('<g transform="matrix(0.32,0,0,0.32,0,0)"><g id="AF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1382.25,260.85L1383.75,262.65L1380.85,263.45L1378.45,264.55L1372.55,265.35L1367.25,266.65L1364.85,269.45L1366.75,272.15L1368.15,275.35L1366.15,278.05L1366.95,280.55L1366.05,282.85L1360.85,282.65L1363.95,286.85L1360.85,288.55L1359.45,292.35L1360.55,296.25L1358.75,298.05L1356.65,297.45L1352.65,298.35L1352.45,300.05L1348.35,300.05L1346.05,303.75L1346.85,309.15L1340.25,311.85L1336.35,311.25L1335.45,312.65L1332.05,311.85L1326.75,312.85L1317.15,309.55L1321.05,303.75L1319.95,299.65L1315.65,298.55L1314.45,294.45L1311.75,289.35L1313.35,285.85L1310.85,284.85L1311.35,280.15L1311.95,272.15L1317.85,274.65L1321.75,273.75L1322.15,270.85L1326.15,269.95L1328.75,267.95L1328.55,262.85L1332.75,261.55L1333.05,259.35L1335.95,261.05L1337.55,261.25L1340.55,261.25L1344.85,262.65L1346.65,263.35L1350.05,261.35L1352.15,262.55L1353.05,259.65L1356.25,259.75L1356.85,258.85L1356.65,256.25L1358.35,254.05L1361.65,255.45L1361.55,257.45L1363.25,257.75L1364.15,263.15L1366.85,265.25L1368.35,263.85L1370.55,263.25L1373.05,260.35L1376.85,260.85L1382.25,260.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1120.45,571.25L1121.05,573.25L1120.35,576.35L1121.25,579.35L1120.35,581.75L1120.75,583.95L1109.05,583.85L1108.25,604.35L1111.85,609.55L1115.45,613.55L1105.05,616.15L1091.55,615.25L1087.75,612.25L1065.05,612.45L1064.25,612.95L1060.95,610.05L1057.35,609.85L1053.95,610.95L1051.25,612.15L1050.75,608.15L1051.65,602.45L1053.65,596.55L1053.95,593.85L1055.85,588.05L1057.25,585.45L1060.55,581.25L1062.45,578.35L1063.05,573.65L1062.75,569.95L1061.15,567.65L1059.65,563.75L1058.35,559.95L1058.65,558.55L1060.35,556.05L1058.75,549.85L1057.55,545.55L1054.75,541.45L1055.35,540.25L1057.65,539.35L1059.35,539.45L1061.35,538.75L1078.05,538.85L1079.35,543.55L1080.95,547.45L1082.25,549.55L1084.35,552.85L1088.15,552.35L1089.95,551.45L1093.05,552.35L1093.95,550.75L1095.45,547.05L1098.95,546.75L1099.25,545.65L1102.15,545.65L1101.65,547.95L1108.45,547.85L1108.55,551.95L1109.65,554.35L1108.75,558.25L1109.15,562.25L1110.95,564.65L1110.55,572.25L1111.95,571.65L1114.35,571.85L1117.85,570.85L1120.45,571.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1054.55,538.25L1053.05,533.45L1055.35,530.65L1057.05,529.55L1059.15,531.75L1057.15,533.15L1056.15,534.75L1055.95,537.55L1054.55,538.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1087.25,227.25L1087.65,228.45L1089.05,227.85L1090.25,229.55L1091.55,230.25L1092.15,232.55L1091.65,234.75L1092.65,237.45L1094.95,238.95L1095.05,240.65L1093.35,241.55L1093.25,243.65L1091.05,246.75L1090.15,246.35L1089.95,244.95L1086.85,242.75L1086.15,239.75L1086.25,235.35L1086.75,233.45L1085.85,232.45L1085.35,230.35L1087.25,227.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1295.45,335.95L1296.75,341.05L1293.95,341.05L1293.95,345.25L1295.05,346.15L1292.65,347.45L1292.85,350.05L1291.55,352.65L1291.55,355.25L1290.55,356.65L1273.65,353.45L1270.95,346.85L1270.65,345.45L1271.55,345.05L1271.95,346.85L1276.15,345.85L1280.75,346.05L1284.15,346.25L1287.45,341.85L1291.15,337.75L1294.15,333.75L1295.45,335.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M668.35,850.95L665.35,850.75L660.35,850.75L654.35,837.15L657.45,839.95L661.75,844.55L669.55,848.25L676.85,849.75L676.05,852.75L671.65,853.05L668.35,850.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M637.85,643.95L649.15,654.35L653.75,655.35L661.05,660.15L666.95,662.65L668.05,665.45L663.85,675.25L669.65,676.95L675.95,677.95L680.15,676.95L684.45,671.95L684.75,666.35L687.35,665.05L690.55,668.85L690.95,673.95L686.75,677.45L683.45,680.05L678.15,686.35L672.15,695.05L671.65,700.25L671.25,706.85L672.45,713.25L671.55,714.65L671.95,718.75L672.25,722.15L680.05,727.65L680.25,732.05L684.15,734.85L684.45,737.95L681.15,746.15L674.15,749.65L663.95,750.95L657.95,750.25L660.05,754.15L660.15,758.85L661.95,762.05L659.45,764.35L654.35,765.25L648.75,762.85L647.25,764.55L649.75,770.85L653.75,772.75L656.05,770.75L658.55,774.05L654.35,776.05L651.45,780.05L652.65,786.35L652.55,789.75L647.75,789.75L644.75,792.95L644.85,797.75L651.35,802.35L656.55,803.55L656.75,809.25L652.15,812.75L651.55,820.05L648.05,822.45L647.15,825.35L651.35,831.85L655.95,835.35L653.85,835.05L648.95,834.05L636.85,833.25L633.35,829.65L631.45,825.05L628.35,825.45L625.75,823.15L622.65,816.65L625.35,813.85L625.45,809.95L623.65,806.75L624.35,801.35L623.25,793.05L621.45,789.35L623.25,788.15L621.85,785.75L619.05,784.55L619.85,781.85L616.75,779.45L613.05,772.15L614.75,770.85L611.45,763.05L610.65,756.55L610.45,750.85L612.95,748.55L609.65,742.25L608.05,736.45L611.05,732.25L609.65,726.85L611.25,720.65L609.85,714.75L608.25,713.55L603.35,702.45L605.45,695.85L603.75,689.65L604.65,683.75L607.25,677.75L610.55,673.75L608.55,671.25L609.35,669.15L607.75,658.45L613.35,655.35L614.55,648.65L613.65,647.05L617.65,641.25L625.15,642.85L628.85,647.45L630.45,642.25L636.85,642.55L637.85,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1230.05,252.25L1228.25,252.45L1225.45,248.75L1225.25,247.75L1222.95,247.75L1221.05,246.05L1220.05,246.15L1217.65,244.35L1213.45,242.75L1213.35,239.65L1212.05,237.45L1219.05,236.45L1220.45,238.05L1222.65,239.15L1221.95,240.75L1225.15,242.95L1224.05,245.05L1226.65,246.75L1229.15,247.75L1230.05,252.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1742.25,762.85L1745.95,765.05L1749.25,764.15L1754.15,762.95L1756.95,763.35L1752.45,770.95L1749.15,773.05L1745.15,778.25L1744.55,776.45L1737.95,780.85L1737.15,780.55L1734.15,780.35L1734.65,774.95L1736.65,770.75L1737.25,765.15L1739.25,762.25L1742.25,762.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1792.75,589.45L1793.95,594.45L1797.95,592.05L1799.35,594.75L1801.65,597.25L1800.55,600.15L1800.75,605.65L1800.95,608.85L1802.25,609.65L1802.65,615.15L1801.45,618.45L1802.25,622.75L1807.65,626.15L1810.85,629.15L1814.05,631.95L1812.95,633.55L1815.25,637.55L1815.75,644.55L1818.35,643.15L1819.85,645.85L1821.45,644.95L1820.75,651.75L1823.65,655.65L1825.55,658.05L1828.35,663.25L1828.35,668.45L1827.35,672.15L1825.55,676.05L1826.25,681.55L1823.75,687.25L1821.65,690.25L1817.85,695.95L1816.35,699.65L1813.25,704.25L1808.25,710.05L1802.75,713.25L1798.35,718.15L1795.05,721.35L1790.65,726.85L1786.95,730.05L1783.05,734.85L1779.95,739.25L1779.15,741.35L1774.85,743.55L1768.75,743.75L1762.45,746.45L1758.65,748.85L1753.85,751.65L1751.15,748.75L1748.55,747.65L1751.15,744.35L1747.65,745.55L1740.45,750.15L1736.85,748.45L1734.45,747.45L1731.65,746.95L1727.55,745.15L1726.25,741.15L1727.75,736.35L1728.15,733.05L1726.75,730.45L1722.05,729.75L1725.25,726.55L1726.15,721.85L1721.45,726.25L1716.15,727.45L1720.65,723.95L1723.15,720.25L1726.65,717.05L1728.25,712.35L1721.45,717.75L1717.15,719.95L1712.85,725.05L1709.85,722.45L1711.55,719.05L1710.15,714.35L1708.35,711.95L1709.95,710.45L1704.65,706.55L1700.85,706.45L1696.85,703.25L1686.95,703.85L1679.05,706.15L1672.15,708.35L1667.15,707.95L1660.15,711.25L1654.85,712.65L1652.55,716.05L1649.55,718.65L1644.85,718.85L1641.25,719.35L1637.05,718.25L1632.85,718.95L1629.05,719.25L1624.55,722.65L1623.05,722.35L1619.65,724.15L1616.25,726.15L1612.45,725.95L1608.95,725.95L1604.85,721.85L1602.45,720.65L1603.95,716.95L1606.85,716.05L1608.35,714.65L1608.95,712.35L1611.25,707.85L1611.95,704.05L1611.25,697.55L1611.45,693.85L1612.85,690.25L1611.95,686.05L1612.25,684.15L1610.55,681.55L1611.25,676.55L1609.35,671.45L1609.25,668.75L1611.05,671.55L1610.55,665.55L1612.85,667.45L1613.95,669.95L1614.55,666.65L1612.95,661.55L1612.85,659.55L1612.05,657.65L1613.35,653.95L1614.85,652.35L1616.15,649.15L1616.25,645.35L1619.35,640.75L1618.95,645.65L1622.05,641.25L1626.95,639.05L1630.15,636.35L1634.85,633.95L1637.45,633.45L1638.85,634.25L1643.65,631.85L1647.15,631.15L1648.25,629.75L1649.75,629.15L1652.85,629.35L1659.05,627.45L1662.55,624.55L1664.55,621.15L1668.45,617.95L1669.15,615.35L1669.85,611.85L1674.75,606.35L1676.15,611.95L1678.75,610.65L1677.25,607.65L1679.55,604.55L1681.75,605.95L1683.25,601.05L1686.75,597.85L1688.55,595.35L1691.45,594.25L1691.85,592.45L1694.15,593.15L1694.55,591.55L1697.15,590.65L1699.95,589.75L1703.65,592.75L1706.25,596.55L1709.75,596.55L1713.25,597.15L1712.55,593.65L1716.05,588.55L1718.75,586.85L1718.15,585.25L1721.05,581.55L1724.75,579.25L1727.45,580.05L1732.35,578.85L1732.65,575.55L1728.75,573.45L1731.85,572.55L1735.45,574.15L1738.15,576.75L1742.65,578.35L1744.35,577.75L1747.65,579.75L1751.15,577.85L1753.15,578.45L1754.65,577.15L1756.85,580.35L1754.85,583.85L1752.35,586.45L1750.45,586.65L1750.75,589.15L1748.55,592.35L1746.05,595.55L1746.25,597.35L1750.05,600.95L1754.05,602.95L1756.55,605.15L1759.85,608.95L1761.45,608.95L1764.05,610.65L1764.55,612.65L1769.45,614.75L1773.55,612.55L1775.35,609.15L1777.05,606.25L1778.35,602.75L1780.95,597.65L1780.75,594.55L1781.45,592.65L1781.35,589.05L1782.75,584.15L1784.05,582.85L1783.45,580.75L1785.25,577.35L1786.75,573.85L1787.15,571.95L1789.45,569.55L1790.75,572.75L1790.65,576.75L1791.95,577.55L1791.85,580.25L1793.45,583.45L1793.35,587.15L1792.75,589.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1069.85,190.05L1069.55,190.85L1070.25,192.95L1070.05,195.55L1067.25,195.55L1068.35,196.95L1067.05,200.95L1066.15,202.05L1061.75,202.15L1059.35,203.65L1055.15,203.15L1047.85,201.45L1046.55,199.35L1041.65,200.45L1041.15,201.65L1038.05,200.75L1035.45,200.55L1033.15,199.35L1033.85,197.85L1033.65,196.75L1035.05,196.45L1037.75,198.15L1038.35,196.45L1042.75,196.75L1046.25,195.65L1048.65,195.85L1050.35,197.15L1050.75,196.05L1049.75,191.95L1051.45,191.15L1053.05,188.25L1056.85,190.35L1059.45,187.75L1061.15,187.25L1065.15,189.15L1067.45,188.85L1069.85,190.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.25,252.45L1224.45,251.55L1221.25,248.65L1220.05,246.15L1221.05,246.05L1222.95,247.75L1225.25,247.75L1225.45,248.75L1228.25,252.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1234.55,235.45L1237.05,232.85L1240.55,236.15L1244.15,240.75L1246.65,241.05L1248.55,242.75L1244.35,243.25L1244.45,248.25L1244.05,250.45L1242.35,251.95L1243.15,255.05L1241.85,255.45L1237.95,252.05L1239.15,248.95L1237.25,247.05L1235.35,247.55L1230.05,252.25L1229.15,247.75L1226.65,246.75L1224.05,245.05L1225.15,242.95L1221.95,240.75L1222.65,239.15L1220.45,238.05L1219.05,236.45L1220.15,235.35L1224.35,237.25L1227.25,237.55L1227.85,236.85L1224.55,233.35L1225.75,232.55L1227.25,232.75L1231.55,236.55L1233.95,237.05L1234.55,235.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1154.15,529.65L1153.55,529.75L1153.55,529.45L1151.55,523.35L1151.55,523.29L1151.45,522.25L1150.05,519.35L1153.55,519.85L1155.25,516.15L1158.35,516.55L1158.65,519.05L1159.85,520.55L1159.85,522.65L1158.45,523.95L1156.15,527.35L1154.15,529.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1015.75,176.35L1015.35,180.55L1014.05,180.75L1013.65,184.25L1009.25,181.35L1006.75,181.85L1003.25,178.95L1000.85,176.45L998.65,176.35L997.85,174.15L1001.75,172.95L1005.35,173.45L1009.85,172.15L1012.95,174.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BJ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1005.95,426.25L1005.75,428.35L1007.05,432.15L1005.95,434.75L1006.55,436.45L1003.75,440.45L1002.05,442.45L1000.95,446.45L1001.15,450.55L1000.85,460.85L996.15,461.65L994.75,457.25L995.05,442.45L993.85,441.15L993.65,437.95L991.65,435.75L989.95,433.85L990.65,430.45L992.65,429.75L993.75,426.95L996.55,426.35L997.75,424.45L999.65,422.55L1001.65,422.55L1005.95,426.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M987.75,405.25L987.25,408.35L988.05,411.25L991.15,415.45L991.35,418.55L997.85,420.05L997.75,424.45L996.55,426.35L993.75,426.95L992.65,429.75L990.65,430.45L985.75,430.35L983.15,429.85L981.35,430.85L978.85,430.35L969.05,430.65L968.85,434.35L969.65,439.15L965.75,437.55L963.15,437.75L961.15,439.35L958.65,438.05L957.65,435.85L955.15,434.45L954.75,430.75L956.35,428.05L956.15,425.85L960.65,420.55L961.55,416.15L963.05,414.55L965.75,415.45L968.15,414.15L968.95,412.45L973.25,409.65L974.35,407.65L979.65,404.95L982.75,404.05L984.15,405.25L987.75,405.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1499.85,359.55L1500.45,364.15L1498.35,363.15L1499.45,368.35L1497.35,365.05L1496.55,361.75L1495.05,358.65L1492.25,354.95L1487.05,354.65L1487.95,357.35L1486.75,360.85L1484.15,359.55L1483.55,360.75L1481.85,360.05L1479.65,359.45L1478.05,354.15L1475.45,349.35L1475.75,345.45L1472.05,343.75L1472.95,341.45L1475.95,339.05L1471.35,335.65L1472.55,331.25L1477.45,334.05L1480.15,334.35L1481.35,338.85L1486.75,339.75L1491.85,339.65L1495.25,340.75L1493.65,346.15L1491.25,346.55L1490.05,350.15L1493.65,353.55L1493.95,349.35L1495.45,349.35L1499.85,359.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1131.85,220.85L1129.55,223.45L1128.25,227.95L1130.35,231.55L1125.75,230.75L1120.75,232.75L1121.05,235.95L1116.45,236.55L1112.55,234.25L1108.55,236.05L1104.75,235.85L1103.95,231.65L1101.15,229.55L1101.85,228.75L1101.25,227.95L1101.85,225.95L1103.65,223.95L1100.85,221.25L1100.15,218.85L1101.25,217.45L1103.05,220.05L1104.95,219.65L1108.95,220.55L1116.55,220.95L1118.85,219.35L1124.75,217.85L1128.75,220.15L1131.85,220.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1082.25,213.55L1084.15,213.45L1083.05,216.25L1085.75,218.75L1085.25,221.65L1084.15,221.95L1083.25,222.55L1081.65,224.05L1081.25,227.55L1076.45,225.15L1074.35,222.45L1072.25,221.05L1069.75,218.65L1068.45,216.75L1065.75,213.75L1066.55,211.15L1068.55,212.65L1069.55,211.25L1071.85,211.15L1076.35,212.25L1079.85,212.15L1082.25,213.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1140.85,161.95L1136.95,161.75L1136.15,162.35L1137.65,164.35L1139.65,168.35L1135.55,168.65L1134.25,170.05L1134.55,173.15L1132.45,172.55L1128.15,172.85L1126.65,171.35L1124.95,172.45L1123.05,171.55L1119.15,171.45L1113.45,169.95L1108.55,169.45L1104.75,169.65L1102.35,171.25L1100.05,171.55L1099.55,168.75L1097.65,165.95L1100.45,164.65L1100.05,162.25L1098.35,159.95L1097.75,157.25L1102.45,157.25L1107.25,154.95L1107.75,151.55L1111.35,149.55L1110.35,146.85L1113.05,145.85L1117.65,143.55L1122.95,145.05L1123.85,146.55L1126.25,145.85L1131.05,147.25L1132.15,150.15L1131.45,151.75L1135.25,155.75L1137.35,156.85L1137.35,157.95L1140.75,159.05L1142.45,160.65L1140.85,161.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M487.05,399.05L485.35,399.05L486.65,391.85L487.35,386.75L487.45,385.75L488.15,385.45L489.05,386.25L491.55,382.35L492.65,382.25L492.55,383.25L493.55,383.25L493.25,385.05L491.95,387.75L492.35,388.75L491.45,391.05L491.75,391.65L490.75,394.95L489.45,396.65L488.35,396.85L487.05,399.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M661.75,630.65L661.45,628.65L656.05,625.35L650.85,625.25L641.25,627.15L639.15,632.75L639.35,636.25L637.85,643.95L636.85,642.55L630.45,642.25L628.85,647.45L625.15,642.85L617.65,641.25L613.65,647.05L609.75,647.95L606.65,639.05L602.95,631.85L604.05,625.65L600.85,622.95L599.65,618.35L596.45,613.95L599.35,607.05L596.45,601.65L597.55,599.45L596.35,597.05L598.25,593.85L597.95,588.45L597.95,583.85L599.05,581.75L593.55,571.35L597.75,571.95L600.65,571.75L601.75,569.85L606.55,567.25L609.45,564.85L616.75,563.75L616.35,568.55L617.25,571.05L616.95,575.35L623.45,581.05L629.85,582.15L632.15,584.55L636.05,585.85L638.55,587.65L642.05,587.65L645.45,589.55L645.95,593.25L647.15,595.15L647.45,597.85L645.75,597.95L648.55,605.45L659.25,605.75L658.75,609.45L659.55,611.95L662.75,613.75L664.45,617.75L663.85,622.85L662.55,625.65L663.35,629.25L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M665.05,488.85L668.15,489.45L668.75,488.05L667.75,486.85L668.35,484.95L670.65,485.55L673.35,484.85L676.55,486.25L679.05,487.55L680.75,485.85L682.05,486.05L682.85,487.85L685.55,487.45L687.75,484.95L689.55,480.25L692.95,474.35L694.95,474.05L696.25,477.65L699.25,488.85L702.35,489.95L702.45,494.35L698.15,499.65L699.85,501.55L709.95,502.55L710.15,509.05L714.45,504.85L721.55,507.15L731.05,511.05L733.85,514.75L732.95,518.35L739.55,516.35L750.55,519.75L759.05,519.55L767.45,524.85L774.85,532.05L779.25,533.85L784.05,534.15L786.15,536.15L788.15,544.35L789.25,548.25L787.15,558.85L784.45,563.05L776.75,571.95L773.35,579.25L769.35,584.75L767.95,584.95L766.65,589.65L767.55,601.65L766.45,611.55L766.15,615.75L764.55,618.35L764.05,626.95L758.85,635.25L758.35,641.95L754.05,644.65L752.95,648.55L746.95,648.55L738.45,650.95L734.75,653.85L728.75,655.75L722.65,660.85L718.55,667.25L718.25,672.05L719.55,675.55L719.25,682.05L718.45,685.15L715.05,688.75L710.55,700.05L706.55,705.05L703.35,708.15L701.85,714.25L698.95,717.85L696.85,714.25L698.65,711.15L694.85,706.85L690.05,703.25L683.75,699.15L681.85,699.35L675.55,694.35L672.15,695.05L678.15,686.35L683.45,680.05L686.75,677.45L690.95,673.95L690.55,668.85L687.35,665.05L684.75,666.35L685.45,662.65L685.75,658.85L685.45,655.25L683.35,654.15L681.35,655.15L679.25,654.85L678.45,652.45L677.35,646.55L676.15,644.65L672.25,642.85L670.05,644.15L664.15,642.85L663.75,634.15L661.75,630.65L663.35,629.25L662.55,625.65L663.85,622.85L664.45,617.75L662.75,613.75L659.55,611.95L658.75,609.45L659.25,605.75L648.55,605.45L645.75,597.95L647.45,597.85L647.15,595.15L645.95,593.25L645.45,589.55L642.05,587.65L638.55,587.65L636.05,585.85L632.15,584.55L629.85,582.15L623.45,581.05L616.95,575.35L617.25,571.05L616.35,568.55L616.75,563.75L609.45,564.85L606.55,567.25L601.75,569.85L600.65,571.75L597.75,571.95L593.55,571.35L590.35,572.45L587.75,571.75L587.65,562.05L583.25,565.75L578.25,565.65L575.95,562.15L572.15,561.85L573.15,559.05L569.85,555.15L567.25,549.35L568.75,548.25L568.55,545.45L571.95,543.65L571.25,540.15L572.65,537.95L572.95,534.95L579.25,530.55L583.85,529.35L584.65,528.35L589.75,528.65L591.95,511.05L592.05,508.25L591.15,504.65L588.55,502.25L588.65,497.55L591.85,496.55L592.95,497.25L593.15,494.75L589.85,494.05L589.85,490.05L600.85,490.25L602.75,487.95L604.35,490.05L605.35,493.85L606.45,493.05L609.55,496.45L613.95,496.05L615.05,494.05L619.25,492.55L621.65,491.45L622.35,488.75L626.45,486.95L626.15,485.55L621.35,485.05L620.65,480.95L620.95,476.65L618.45,475.05L619.55,474.45L623.65,475.25L628.15,476.85L629.85,475.35L633.95,474.35L640.35,471.95L642.45,469.45L641.75,467.65L644.75,467.45L645.95,468.85L645.15,471.75L647.15,472.65L648.35,475.65L646.75,477.95L645.75,483.35L647.15,486.65L647.45,489.65L650.95,492.65L653.75,492.95L654.35,491.65L656.15,491.35L658.75,490.25L660.55,488.55L663.75,489.15L665.05,488.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1632.35,472.05L1634.55,469.65L1639.15,466.05L1639.05,469.25L1638.95,473.35L1636.25,473.15L1635.15,475.35L1632.35,472.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1488.05,322.75L1490.65,324.85L1491.15,328.75L1486.65,328.95L1481.95,328.55L1478.75,329.55L1473.25,327.05L1472.85,325.85L1475.45,321.05L1478.05,319.45L1482.35,320.85L1485.25,321.05L1488.05,322.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1126.85,614.95L1128.75,620.05L1129.85,621.25L1131.45,624.95L1137.55,631.95L1139.85,632.65L1139.75,634.95L1141.25,639.05L1145.55,640.05L1148.95,642.95L1140.85,647.65L1135.65,652.45L1133.65,656.75L1131.85,659.15L1128.85,659.65L1127.65,662.75L1127.05,664.75L1123.45,666.15L1118.95,665.85L1116.45,664.05L1114.15,663.35L1111.35,664.75L1109.85,667.85L1107.15,669.75L1104.35,672.65L1100.35,673.35L1099.25,671.05L1099.85,667.15L1096.85,661.05L1095.45,660.05L1096.05,641.35L1101.55,641.15L1102.35,618.25L1106.55,618.05L1115.25,615.75L1117.25,618.45L1120.95,615.95L1122.65,615.95L1125.85,614.45L1126.85,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1120.55,445.75L1124.45,448.25L1127.55,450.85L1127.65,452.95L1131.55,456.25L1133.95,459.05L1135.35,462.85L1139.65,465.45L1140.55,467.45L1138.75,468.15L1135.05,468.05L1130.85,467.35L1128.75,467.85L1127.85,469.45L1126.05,469.65L1123.85,468.25L1117.55,471.45L1114.95,470.85L1114.15,471.35L1112.55,475.25L1108.25,473.95L1104.15,473.35L1100.55,470.95L1095.85,468.75L1092.85,470.85L1090.65,474.05L1090.15,478.55L1086.55,478.25L1082.65,477.15L1079.35,480.55L1076.35,486.55L1075.75,484.65L1075.45,481.75L1072.85,479.65L1070.75,476.35L1070.25,474.05L1067.55,470.65L1068.05,468.75L1067.45,466.05L1067.85,461.05L1069.25,459.95L1072.05,453.45L1076.65,452.95L1077.65,451.25L1078.65,451.45L1080.05,452.85L1087.15,450.45L1089.55,447.95L1092.45,445.65L1091.85,443.45L1093.45,442.85L1098.95,443.25L1104.15,440.25L1108.15,433.25L1110.95,430.65L1114.55,429.55L1115.25,432.25L1118.55,436.25L1118.55,438.95L1117.75,441.55L1118.15,443.55L1120.05,445.45L1120.55,445.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M665.15,202.85L668.55,203.75L673.25,203.55L669.95,206.15L667.95,206.55L662.45,203.85L661.85,201.75L664.35,199.85L665.15,202.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M679.55,186.85L677.15,186.95L671.35,185.05L667.85,182.05L669.75,181.55L675.65,183.15L679.85,185.75L679.55,186.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M371.65,190.55L368.55,191.45L362.25,188.65L362.25,186.45L359.35,184.25L359.65,182.45L355.35,181.35L355.95,177.95L357.45,176.55L361.55,177.85L363.95,178.85L368.05,179.45L368.25,181.65L368.65,184.55L371.85,187.15L371.65,190.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M710.75,177.05L705.75,182.45L709.65,180.35L712.55,181.75L710.15,183.85L713.95,185.55L716.75,184.05L721.05,185.95L718.25,190.55L722.05,189.45L721.75,192.75L722.25,196.65L718.65,202.25L716.25,202.45L713.35,201.25L715.85,196.15L714.65,195.35L707.35,200.75L704.35,200.55L708.75,197.55L704.35,196.05L698.85,196.45L689.25,196.25L689.05,194.45L692.85,192.15L691.15,190.55L696.55,186.75L704.75,176.85L708.95,173.35L713.95,171.25L716.05,171.45L714.55,173.15L710.75,177.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M350.75,155.65L352.25,156.45L357.25,155.95L350.05,162.85L350.35,167.85L348.45,167.85L347.75,165.05L348.25,162.15L347.45,160.25L348.75,157.55L350.75,155.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M634.15,108.15L630.55,111.15L628.85,110.65L628.75,108.95L629.15,108.55L631.95,106.85L633.65,106.95L634.15,108.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M624.45,104.95L617.25,108.15L614.25,107.95L614.25,106.45L619.25,103.75L625.25,103.85L624.45,104.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M621.35,88.15L620.45,90.65L623.15,89.75L624.65,91.25L628.15,93.25L631.95,94.95L630.55,97.65L634.05,97.25L635.95,99.15L630.95,100.95L625.05,99.55L624.25,96.95L617.95,100.05L609.75,102.95L610.45,99.65L604.15,100.15L609.85,97.35L613.45,92.85L618.55,87.75L621.35,88.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M666.25,79.85L661.35,80.15L662.05,77.45L665.85,74.35L670.15,73.65L672.45,75.15L670.95,77.45L670.05,78.25L666.25,79.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M591.75,69.15L587.65,71.05L583.45,69.45L579.55,69.95L576.15,67.55L581.15,65.85L586.05,63.55L589.05,65.05L590.65,66.05L591.05,67.05L591.75,69.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M644.75,211.75L642.55,208.15L645.45,199.65L643.85,197.85L640.15,198.85L639.05,197.25L633.55,201.95L630.35,206.85L627.55,209.75L625.05,210.75L623.35,211.05L622.25,212.55L612.95,212.55L605.15,212.65L602.45,213.75L595.65,218.15L595.65,218.05L594.75,217.65L592.75,218.55L590.85,219.85L589.05,218.75L584.35,219.55L580.45,220.45L578.55,221.25L576.25,223.35L578.05,224.05L579.75,223.65L580.05,223.65L579.75,225.55L574.95,226.25L572.15,227.05L570.45,228.05L567.85,227.45L566.25,227.75L563.35,229.55L558.75,231.55L556.05,231.15L558.05,228.95L561.75,225.45L565.85,223.35L566.95,221.55L567.85,218.55L571.65,215.05L572.55,211.05L573.65,214.95L577.45,215.85L579.85,213.75L578.45,208.95L577.55,206.95L573.55,205.75L569.75,205.05L565.85,205.05L562.45,204.25L562.05,202.85L560.65,203.75L559.45,203.55L561.35,201.45L559.55,200.65L561.45,198.25L560.25,196.45L561.95,194.65L556.75,193.75L556.65,190.15L555.85,189.35L552.55,189.15L548.45,187.95L546.95,188.75L545.15,190.25L541.85,191.25L538.75,193.75L533.35,192.05L528.95,192.85L525.05,190.95L520.45,189.95L517.15,189.55L516.15,188.55L517.05,185.15L515.35,185.15L514.05,187.55L376.25,187.55L370.85,181.45L369.25,178.75L362.25,176.15L363.55,170.65L367.15,166.95L363.05,164.25L366.15,159.35L364.05,154.95L366.55,151.75L371.65,148.85L374.85,145.05L370.25,141.25L371.65,134.35L372.75,130.15L371.15,127.45L370.35,125.05L370.95,121.95L364.45,123.85L356.85,127.15L356.55,123.35L356.05,120.75L353.25,119.15L349.05,118.95L384.65,86.25L409.25,65.85L415.25,67.15L418.55,69.75L422.25,70.25L428.55,68.05L435.55,66.35L440.85,66.95L449.75,64.65L457.95,63.35L458.15,65.55L462.65,64.25L466.55,61.75L468.65,62.35L470.05,67.15L479.55,63.45L475.65,67.55L481.65,66.65L484.85,65.15L489.45,65.45L493.35,67.65L500.85,69.65L505.55,70.55L509.95,70.25L512.85,73.05L504.35,75.75L510.75,76.85L522.65,76.25L527.05,75.25L528.45,78.55L535.55,75.85L533.45,73.45L537.95,71.65L543.15,71.35L547.05,70.85L549.15,72.15L550.65,75.05L555.65,74.65L560.95,77.15L568.15,76.25L574.15,76.35L576.55,72.95L581.05,72.05L585.95,73.85L581.65,79.05L587.85,74.65L591.05,74.85L597.45,69.35L595.85,66.05L592.95,63.85L598.45,57.95L606.65,54.15L611.15,55.05L613.15,57.35L613.55,63.35L607.75,65.95L614.45,67.05L610.05,72.55L618.95,68.35L621.15,71.85L616.85,75.85L618.15,79.55L625.45,75.65L631.95,70.85L636.65,64.95L642.15,65.35L647.55,66.15L651.15,68.85L649.45,71.55L644.35,74.45L645.25,77.35L642.85,80.05L631.95,83.95L625.45,84.85L622.25,83.15L618.95,85.95L611.55,90.65L608.55,93.15L600.85,96.95L594.35,97.35L589.25,99.75L586.35,103.55L580.65,104.25L571.95,108.95L562.55,115.45L557.55,120.05L552.65,126.95L558.65,127.95L557.15,133.45L556.35,138.05L563.65,136.85L570.65,139.45L573.95,141.75L575.65,144.55L580.55,146.25L584.15,148.75L591.75,149.15L596.55,149.75L592.95,154.95L591.25,161.05L591.35,167.95L595.75,173.85L600.45,171.85L606.05,165.45L608.35,155.85L606.65,152.65L615.65,149.75L623.15,145.55L627.95,141.35L629.65,137.35L629.25,132.25L626.05,127.75L634.95,121.55L635.95,116.25L639.85,107.25L643.65,105.85L650.35,107.45L654.55,108.05L659.05,106.45L662.15,108.45L665.75,111.85L665.95,114.05L673.65,114.55L671.05,119.45L668.75,126.85L672.55,127.85L674.15,131.35L682.35,128.05L689.85,121.45L694.05,118.75L695.15,124.05L697.75,131.55L699.75,138.75L696.35,142.55L701.15,145.95L704.05,149.35L710.95,150.95L713.35,152.85L713.35,158.05L716.75,158.85L717.85,161.15L715.85,168.05L711.55,170.35L707.35,172.55L698.55,174.75L690.65,179.75L682.05,180.85L671.95,179.45L664.65,179.45L659.35,179.85L653.65,184.35L646.25,187.15L636.15,195.35L628.25,201.15L632.95,200.15L643.85,191.85L656.15,186.65L663.75,186.05L667.05,189.15L660.95,193.35L660.35,200.05L660.45,204.85L666.05,207.95L674.65,207.05L681.85,199.95L680.85,204.55L683.35,206.85L675.95,210.95L663.55,214.75L657.75,217.25L650.55,221.85L646.85,221.35L648.35,216.05L658.75,210.75L650.65,210.95L644.75,211.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M538.25,47.95L533.55,50.35L544.05,48.85L546.65,51.45L553.95,48.75L555.75,50.45L553.55,55.55L557.85,53.45L560.65,48.15L564.95,47.35L567.95,48.15L570.15,50.25L567.45,55.35L565.05,59.05L569.25,61.65L574.25,64.25L571.65,66.55L564.55,67.05L565.35,69.05L562.15,71.05L555.45,70.25L549.75,68.75L544.65,69.05L535.15,70.95L523.85,71.75L515.95,72.25L516.25,69.65L512.15,68.25L507.85,68.85L507.25,64.55L510.55,63.95L517.85,63.05L523.35,63.35L529.55,62.35L523.05,61.15L513.95,61.55L508.25,61.45L508.25,59.55L519.95,57.35L513.65,57.45L508.25,56.05L516.05,52.15L521.25,50.05L535.45,46.95L538.25,47.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M577.75,46.45L570.75,49.85L568.45,46.25L570.55,45.45L576.05,45.25L577.75,46.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M686.35,48.05L685.65,49.45L677.45,49.25L672.55,49.95L671.65,49.55L669.55,46.85L671.25,45.05L673.45,44.65L681.85,45.25L686.35,48.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M646.55,47.75L646.85,50.95L654.05,46.85L665.75,44.75L668.05,50.05L664.85,53.45L673.85,51.95L679.15,49.85L685.95,52.45L689.65,54.95L688.55,57.25L696.75,56.05L698.65,59.45L707.05,61.55L709.25,63.65L710.15,68.75L701.05,71.25L708.75,74.85L714.65,76.05L717.95,81.05L724.45,81.45L721.15,85.35L710.25,91.85L706.25,89.45L702.45,84.05L696.55,84.75L694.25,88.05L696.95,91.25L701.45,93.85L702.45,95.35L702.35,101.05L698.75,105.15L694.05,103.55L685.45,99.05L689.05,103.95L691.85,107.45L691.55,109.45L680.65,107.15L673.05,103.75L669.25,101.05L671.65,99.35L666.85,96.45L662.15,93.75L661.25,95.35L648.15,96.25L645.75,94.35L651.15,90.15L659.25,90.05L668.55,89.35L668.35,87.35L671.45,84.55L680.25,79.15L680.65,76.65L680.15,74.85L675.45,72.15L668.35,70.35L671.85,68.95L669.85,65.55L666.45,65.25L664.55,63.45L661.25,65.05L653.35,65.75L639.35,64.55L631.95,62.95L626.05,62.15L624.15,60.25L630.45,57.85L624.75,57.85L628.05,52.55L635.15,47.95L641.15,45.85L652.35,44.45L646.55,47.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M596.15,44.25L599.75,45.35L607.35,44.65L606.85,46.15L600.75,48.65L604.55,50.85L599.35,55.55L590.95,57.55L587.55,57.15L586.65,55.15L580.75,51.15L582.45,49.45L589.85,50.05L588.95,46.75L596.15,44.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M618.75,49.75L610.95,53.65L606.55,53.45L608.35,48.85L610.95,46.35L615.15,44.15L620.35,42.75L628.25,42.95L634.45,44.15L624.35,48.75L618.75,49.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M502.95,56.95L489.45,59.55L490.05,57.25L484.05,54.45L488.45,52.25L495.95,48.45L503.55,45.05L503.95,41.95L517.95,41.15L522.15,42.25L531.65,42.55L533.55,43.95L535.15,46.15L528.65,47.45L514.75,51.05L505.55,54.75L502.95,56.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M628.15,38.55L624.05,40.45L618.85,40.05L615.65,38.75L620.15,36.55L627.05,35.15L628.45,36.95L628.15,38.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M619.35,29.85L619.55,32.15L616.75,34.65L610.95,38.45L604.05,38.95L600.85,38.15L604.25,35.25L597.65,35.55L601.95,31.75L605.75,31.95L613.45,30.25L618.35,30.55L619.35,29.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M579.95,32.45L579.25,34.15L583.65,33.35L587.25,33.55L584.95,36.05L579.85,38.35L565.95,39.15L553.65,41.35L547.65,41.45L549.15,39.85L559.85,37.55L541.95,38.15L537.75,37.25L549.45,32.45L554.85,31.05L563.15,32.75L566.05,35.65L572.15,36.05L572.85,31.35L578.65,29.55L581.75,30.05L579.95,32.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M635.65,28.05L637.95,29.65L645.35,29.65L646.75,31.25L643.95,33.05L647.05,34.15L648.25,35.35L653.15,35.55L658.25,35.95L665.35,34.95L673.45,34.45L679.25,34.85L681.55,36.75L680.55,38.75L676.95,40.15L670.25,41.25L665.95,40.55L654.15,41.35L646.15,41.45L640.55,40.85L631.95,39.25L633.55,36.45L635.65,34.05L634.25,31.85L627.25,31.25L624.65,29.75L628.45,27.75L635.65,28.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M559.95,25.45L554.15,29.15L548.85,30.85L545.05,31.05L535.15,33.15L528.05,33.95L524.45,32.85L536.15,29.15L548.35,26.05L553.85,26.15L559.95,25.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.15,26.05L639.35,26.15L632.75,25.85L633.45,24.55L640.65,24.65L642.25,25.45L641.15,26.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M582.35,25.15L573.55,26.55L570.25,25.05L575.35,23.55L581.35,23.05L585.45,23.75L582.35,25.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M590.15,20.95L584.45,21.85L578.45,21.85L579.45,21.15L585.15,19.85L586.85,20.05L590.15,20.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M636.95,23.45L630.35,24.45L628.75,23.35L629.35,21.65L631.55,19.75L635.95,19.95L637.65,20.25L639.95,21.85L636.95,23.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M623.15,22.25L622.05,24.15L616.75,23.65L612.75,22.15L604.95,21.95L610.25,20.65L607.45,19.55L609.65,17.75L615.75,18.35L623.25,20.05L623.15,22.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M677.25,16.15L679.95,17.65L673.45,18.95L662.85,22.45L656.05,22.75L649.25,22.15L647.65,20.25L649.75,18.65L654.05,17.45L647.45,17.45L645.45,15.95L645.85,14.05L650.75,12.15L654.85,10.85L658.85,10.55L658.55,9.55L666.85,9.35L668.45,11.55L673.15,12.45L677.95,13.35L677.25,16.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M756.45,2.15L765.15,2.45L771.85,2.95L777.05,3.95L775.95,4.95L766.15,6.65L757.15,7.45L753.15,8.35L760.65,8.35L750.15,10.85L743.35,12.05L734.05,15.55L725.95,16.25L722.85,17.25L711.55,17.65L715.95,18.25L712.65,19.05L713.35,21.35L708.35,22.95L701.45,24.25L697.95,26.05L691.35,27.55L690.85,28.65L697.35,28.45L696.25,29.65L683.55,32.55L675.05,31.15L663.35,31.95L658.35,31.35L651.55,31.05L653.65,28.75L661.65,27.65L663.65,24.25L666.25,23.95L673.75,25.95L672.05,22.95L667.15,22.05L672.15,20.25L679.75,19.15L682.55,17.55L679.55,15.85L680.65,13.65L690.05,13.75L692.25,14.25L699.55,12.65L692.25,12.15L679.65,12.45L675.25,11.05L674.45,9.35L671.95,8.15L673.05,6.85L679.05,6.05L683.25,5.95L690.65,5.35L697.45,3.85L701.35,4.05L703.75,5.15L708.75,3.15L713.95,2.55L720.45,2.15L730.85,1.95L732.15,2.35L742.45,1.75L756.45,2.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1033.65,196.75L1033.85,197.85L1033.15,199.35L1035.45,200.55L1038.05,200.75L1037.75,203.25L1035.65,204.35L1031.85,203.55L1030.85,206.05L1028.45,206.25L1027.55,205.25L1024.85,207.45L1022.35,207.75L1020.15,206.35L1018.35,203.65L1015.95,204.65L1015.95,201.75L1019.55,198.25L1019.35,196.65L1021.65,197.25L1022.95,196.15L1027.15,196.15L1028.15,194.85L1033.65,196.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1601.45,381.15L1597.15,384.25L1592.25,382.25L1591.25,376.75L1593.45,373.85L1599.25,372.05L1602.55,372.15L1604.15,374.65L1602.15,377.45L1601.45,381.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1624.85,184.75L1633.85,189.25L1639.85,195.05L1647.45,195.05L1650.05,192.65L1656.95,190.75L1658.25,196.45L1657.95,198.75L1660.75,205.55L1661.35,211.75L1654.45,210.65L1651.55,212.85L1656.25,218.25L1660.15,225.75L1657.65,225.85L1659.55,229.15L1654.05,225.35L1654.05,228.95L1647.65,231.65L1650.45,235.05L1645.85,234.75L1642.25,232.75L1641.15,237.35L1637.25,240.75L1635.15,244.85L1628.85,246.65L1626.45,249.65L1621.65,251.45L1622.95,248.45L1620.65,245.95L1622.65,241.65L1618.15,238.35L1614.75,240.55L1611.15,245.05L1609.85,249.15L1604.85,249.45L1603.55,252.45L1608.35,256.75L1613.15,257.85L1614.55,260.65L1619.65,262.55L1623.45,257.95L1629.35,260.45L1632.85,260.65L1635.15,263.95L1628.45,265.75L1627.45,269.25L1623.65,272.45L1622.75,276.95L1629.85,280.45L1634.45,286.75L1639.95,292.65L1645.45,297.55L1647.05,302.35L1644.25,304.15L1646.65,307.55L1650.55,309.55L1651.35,314.75L1651.45,319.85L1648.65,320.45L1646.55,327.35L1644.25,335.85L1640.85,343.45L1634.45,349.35L1627.85,354.85L1621.75,355.55L1618.85,358.35L1616.55,356.35L1614.05,359.45L1606.85,362.75L1601.05,363.65L1600.35,370.45L1597.25,370.85L1595.05,366.15L1595.95,363.75L1588.15,361.65L1585.75,362.75L1579.85,361.05L1576.75,358.45L1577.05,354.75L1571.75,353.55L1568.65,351.15L1564.55,354.55L1559.25,355.35L1554.85,355.25L1552.15,356.85L1549.45,357.75L1551.45,365.15L1548.45,364.95L1547.65,363.45L1547.15,360.75L1543.35,362.65L1540.75,361.45L1536.25,359.05L1537.05,353.75L1533.35,352.45L1530.95,346.55L1525.35,347.65L1524.65,340.05L1528.85,334.65L1527.95,329.35L1526.65,324.45L1523.95,322.95L1521.25,319.15L1518.15,319.65L1512.05,318.65L1513.25,315.95L1509.65,311.95L1506.45,314.65L1501.55,313.15L1496.15,317.15L1492.25,321.95L1488.05,322.75L1485.25,321.05L1482.35,320.85L1478.05,319.45L1475.45,321.05L1472.85,325.85L1471.35,320.75L1468.25,322.15L1461.75,321.45L1455.25,320.05L1450.25,317.15L1445.75,315.95L1443.25,312.85L1439.95,311.95L1433.55,307.75L1428.75,305.75L1426.85,307.25L1418.25,302.75L1412.05,298.75L1408.85,291.65L1412.95,292.55L1412.35,289.25L1409.35,285.95L1408.55,280.75L1400.85,273.15L1391.35,270.65L1388.45,265.65L1383.75,262.65L1382.25,260.85L1380.45,257.25L1379.95,254.75L1376.25,253.25L1374.75,253.95L1371.65,247.95L1372.75,246.55L1371.55,245.05L1375.65,242.05L1378.85,240.75L1384.65,241.65L1385.25,237.55L1391.65,236.85L1392.65,234.25L1399.55,230.85L1399.75,229.45L1398.05,225.75L1400.95,224.15L1392.15,213.15L1401.25,210.65L1403.25,209.25L1402.25,197.95L1413.05,200.05L1414.65,197.15L1412.15,190.95L1415.95,190.35L1417.85,186.15L1419.55,185.65L1422.85,190.05L1428.55,193.35L1436.75,195.65L1442.55,200.75L1443.95,208.05L1446.95,210.85L1453.45,211.95L1460.65,212.75L1468.65,216.75L1472.05,217.45L1477.05,223.25L1481.75,227.05L1487.35,226.85L1498.65,228.35L1505.05,227.45L1510.65,228.35L1520.05,232.25L1526.25,232.25L1529.55,234.15L1533.95,230.75L1541.15,228.55L1548.75,228.35L1553.65,226.15L1555.65,222.75L1558.05,220.55L1556.15,218.45L1553.25,216.05L1553.75,211.95L1556.95,212.55L1562.85,213.85L1566.05,210.45L1572.45,208.05L1573.75,203.85L1576.25,202.05L1583.05,201.25L1587.45,201.95L1586.65,199.75L1579.45,195.35L1574.25,193.35L1571.75,195.65L1566.25,194.65L1563.95,195.45L1561.15,192.95L1560.85,186.65L1560.25,181.95L1567.65,184.35L1572.05,180.45L1570.15,177.65L1569.95,171.15L1571.25,169.15L1568.75,165.75L1565.05,164.35L1566.75,161.25L1571.85,160.15L1578.05,159.95L1586.65,161.85L1592.65,164.05L1600.35,170.25L1604.15,172.95L1608.65,176.75L1614.85,182.75L1624.85,184.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.15,434.45L957.65,435.85L958.65,438.05L961.15,439.35L963.15,437.75L965.75,437.55L969.65,439.15L971.15,448.35L968.75,453.65L967.25,460.95L969.65,466.45L969.45,469.05L966.85,469.05L962.95,467.85L959.25,467.85L952.55,469.05L948.65,470.85L943.05,473.25L941.95,473.05L942.35,467.75L942.95,466.95L942.75,464.45L940.35,461.75L938.55,461.35L936.95,459.55L938.15,456.65L937.65,453.55L937.85,451.75L938.75,451.75L939.15,448.95L938.75,447.65L939.25,446.75L941.35,446.05L939.95,440.85L938.65,438.25L939.15,436.05L940.25,435.55L941.05,434.95L942.55,435.95L946.95,435.95L947.95,434.15L948.95,434.25L950.55,433.55L951.45,436.25L952.75,435.45L955.15,434.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1072.05,453.45L1069.25,459.95L1067.85,461.05L1067.45,466.05L1068.05,468.75L1067.55,470.65L1070.25,474.05L1070.75,476.35L1072.85,479.65L1075.45,481.75L1075.75,484.65L1076.35,486.55L1075.95,489.95L1071.45,488.45L1066.85,486.75L1059.75,486.55L1059.05,486.15L1055.65,486.95L1052.25,486.15L1049.55,486.55L1040.25,486.45L1041.15,481.35L1038.85,477.05L1036.25,476.05L1035.15,473.15L1033.65,472.25L1033.75,470.45L1035.15,465.85L1037.85,459.65L1039.45,459.65L1042.85,455.85L1044.95,455.75L1048.15,458.45L1052.05,456.25L1052.55,453.55L1053.85,450.95L1054.65,447.75L1057.65,445.15L1058.75,440.65L1059.95,439.15L1060.75,435.85L1062.15,431.75L1066.85,426.75L1067.15,424.65L1067.75,423.45L1065.45,420.95L1065.65,418.85L1067.15,418.55L1069.45,422.65L1069.95,426.85L1069.75,431.15L1072.95,436.95L1069.75,436.95L1068.15,437.35L1065.55,436.75L1064.35,439.75L1067.75,443.55L1070.25,444.65L1071.05,447.25L1072.85,451.65L1072.05,453.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1140.55,467.45L1144.05,472.75L1146.65,473.55L1148.15,472.45L1150.75,472.85L1153.85,471.55L1155.25,474.25L1160.35,478.55L1160.05,486.05L1162.35,486.95L1160.45,489.15L1158.35,490.95L1156.15,494.25L1154.95,497.25L1154.65,502.35L1153.35,504.85L1153.25,509.65L1151.65,511.45L1151.45,515.25L1150.65,515.75L1150.05,519.35L1151.45,522.25L1151.55,523.25L1150.35,533.55L1151.85,537.15L1150.85,539.85L1152.65,544.45L1156.05,547.95L1156.75,551.45L1158.35,553.15L1158.05,554.25L1157.15,553.95L1149.45,555.05L1147.95,555.85L1146.25,559.95L1147.45,562.75L1146.35,570.35L1145.45,576.75L1146.95,577.95L1150.85,580.45L1152.45,579.25L1152.65,586.15L1148.35,586.15L1146.15,582.65L1144.15,579.85L1139.85,578.95L1138.65,575.65L1135.15,577.65L1130.75,576.75L1128.85,573.85L1125.35,573.25L1122.65,573.35L1122.35,571.35L1120.45,571.25L1117.85,570.85L1114.35,571.85L1111.95,571.65L1110.55,572.25L1110.95,564.65L1109.15,562.25L1108.75,558.25L1109.65,554.35L1108.55,551.95L1108.45,547.85L1101.65,547.95L1102.15,545.65L1099.25,545.65L1098.95,546.75L1095.45,547.05L1093.95,550.75L1093.05,552.35L1089.95,551.45L1088.15,552.35L1084.35,552.85L1082.25,549.55L1080.95,547.45L1079.35,543.55L1078.05,538.85L1061.35,538.75L1059.35,539.45L1057.65,539.35L1055.35,540.25L1054.55,538.25L1055.95,537.55L1056.15,534.75L1057.15,533.15L1059.15,531.75L1060.65,532.45L1062.65,529.95L1065.75,530.05L1066.05,531.85L1068.15,532.95L1071.55,528.95L1074.85,525.85L1076.25,523.75L1076.15,518.45L1078.65,512.25L1081.25,508.95L1084.95,505.85L1085.65,503.85L1085.75,501.45L1086.65,499.25L1086.35,495.55L1087.05,489.85L1088.15,485.85L1089.85,482.45L1090.15,478.55L1090.65,474.05L1092.85,470.85L1095.85,468.75L1100.55,470.95L1104.15,473.35L1108.25,473.95L1112.55,475.25L1114.15,471.35L1114.95,470.85L1117.55,471.45L1123.85,468.25L1126.05,469.65L1127.85,469.45L1128.75,467.85L1130.85,467.35L1135.05,468.05L1138.75,468.15L1140.55,467.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1090.15,478.55L1089.85,482.45L1088.15,485.85L1087.05,489.85L1086.35,495.55L1086.65,499.25L1085.75,501.45L1085.65,503.85L1084.95,505.85L1081.25,508.95L1078.65,512.25L1076.15,518.45L1076.25,523.75L1074.85,525.85L1071.55,528.95L1068.15,532.95L1066.05,531.85L1065.75,530.05L1062.65,529.95L1060.65,532.45L1059.15,531.75L1057.05,529.55L1055.35,530.65L1053.05,533.45L1048.45,526.65L1052.75,523.05L1050.65,518.85L1052.65,517.25L1056.45,516.45L1056.85,513.55L1059.95,516.65L1064.95,516.95L1066.65,513.95L1067.35,509.65L1066.75,504.65L1064.05,500.85L1066.55,493.35L1065.15,492.15L1060.95,492.65L1059.35,489.35L1059.75,486.55L1066.85,486.75L1071.45,488.45L1075.95,489.95L1076.35,486.55L1079.35,480.55L1082.65,477.15L1086.55,478.25L1090.15,478.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M583.65,425.45L579.95,426.55L578.35,429.75L576.05,431.55L574.25,433.95L573.35,438.55L571.55,442.35L574.45,442.75L575.05,445.65L576.25,447.15L576.55,449.65L575.85,452.05L575.95,453.45L577.35,453.95L578.55,456.15L585.85,455.55L589.15,456.35L592.95,461.95L595.25,461.25L599.35,461.55L602.55,460.85L604.55,461.95L603.35,465.35L602.05,467.55L601.45,472.15L602.55,476.45L604.05,478.35L604.25,479.75L601.35,482.95L603.35,484.35L604.85,486.65L606.45,493.05L605.35,493.85L604.35,490.05L602.75,487.95L600.85,490.25L589.85,490.05L589.85,494.05L593.15,494.75L592.95,497.25L591.85,496.55L588.65,497.55L588.55,502.25L591.15,504.65L592.05,508.25L591.95,511.05L589.75,528.65L586.85,525.25L585.15,525.15L588.65,518.55L584.25,515.55L580.85,516.15L578.75,515.05L575.65,516.75L571.45,515.85L567.95,509.15L565.35,507.55L563.55,504.45L559.75,501.45L558.25,502.05L555.85,500.55L553.05,498.45L551.45,499.45L546.65,498.55L545.25,495.75L544.15,495.85L538.55,492.25L537.85,490.25L539.95,489.75L539.75,486.55L541.15,484.15L543.95,483.75L546.45,479.75L548.65,476.35L546.65,474.85L547.85,471.15L546.75,465.25L548.05,463.55L547.35,458.15L545.15,454.65L546.05,451.55L547.85,452.05L548.95,450.15L547.85,446.35L548.55,445.45L551.45,445.65L555.95,441.15L558.35,440.45L558.45,438.35L559.85,432.85L563.25,429.95L566.75,429.75L567.35,428.45L571.75,428.95L576.35,425.75L578.65,424.35L581.55,421.25L583.55,421.65L584.85,423.35L583.65,425.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M513.85,430.85L515.05,434.35L517.05,436.95L519.55,439.65L517.35,440.25L517.25,442.85L518.35,443.75L517.45,444.55L517.65,445.65L517.05,446.95L516.75,448.25L513.75,446.85L512.65,445.45L513.35,444.35L513.25,442.95L511.75,441.45L509.55,440.15L507.75,439.35L507.45,437.45L506.05,436.35L506.25,438.15L505.05,439.75L503.85,437.95L502.15,437.25L501.45,436.05L501.55,434.05L502.45,432.05L500.95,431.15L502.35,429.85L503.25,429.05L506.85,430.75L508.15,429.95L509.95,430.45L510.75,431.75L512.45,432.25L513.85,430.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M544.05,354.95L545.95,357.25L551.15,356.55L552.95,358.05L557.15,362.05L560.35,364.95L562.15,364.85L565.35,366.15L564.75,367.95L568.75,368.25L572.65,370.85L571.85,372.35L568.05,373.15L564.25,373.45L560.55,372.95L552.45,373.55L556.65,370.05L554.55,368.35L550.95,367.95L549.25,366.05L548.45,362.45L545.25,362.65L540.25,360.95L538.75,359.55L531.65,358.55L529.85,357.35L532.15,355.75L526.75,355.45L522.35,358.75L520.05,358.85L519.05,360.45L516.25,361.15L513.95,360.45L517.15,358.55L518.65,356.15L521.35,354.75L524.35,353.55L528.65,352.95L530.05,352.15L534.75,352.65L539.15,352.75L544.05,354.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1058.95,174.45L1061.45,176.45L1065.15,176.95L1064.95,178.65L1067.75,179.95L1068.35,178.35L1071.75,179.05L1072.45,181.05L1076.15,181.35L1078.75,184.45L1077.25,184.45L1076.55,185.55L1075.45,185.85L1075.25,187.25L1074.35,187.55L1074.25,188.15L1072.65,188.75L1070.45,188.65L1069.85,190.05L1067.45,188.85L1065.15,189.15L1061.15,187.25L1059.45,187.75L1056.85,190.35L1053.05,188.25L1050.05,185.65L1047.45,184.15L1046.75,181.45L1045.75,179.65L1049.15,178.35L1050.85,176.75L1054.35,175.55L1055.45,174.35L1056.75,175.05L1058.95,174.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1053.15,158.15L1054.55,161.25L1053.35,162.95L1055.25,165.05L1056.75,168.35L1056.55,170.55L1058.95,174.45L1056.75,175.05L1055.45,174.35L1054.35,175.55L1050.85,176.75L1049.15,178.35L1045.75,179.65L1046.75,181.45L1047.45,184.15L1050.05,185.65L1053.05,188.25L1051.45,191.15L1049.75,191.95L1050.75,196.05L1050.35,197.15L1048.65,195.85L1046.25,195.65L1042.75,196.75L1038.35,196.45L1037.75,198.15L1035.05,196.45L1033.65,196.75L1028.15,194.85L1027.15,196.15L1022.95,196.15L1023.35,191.65L1025.75,187.45L1018.55,186.25L1016.15,184.65L1016.35,181.95L1015.35,180.55L1015.75,176.35L1014.65,169.85L1017.55,169.85L1018.75,167.55L1019.65,161.95L1018.75,159.85L1019.55,158.55L1023.55,158.25L1024.55,159.55L1027.65,156.55L1026.35,154.25L1025.95,150.85L1029.65,151.65L1032.55,150.75L1032.85,153.05L1037.75,154.45L1037.85,156.65L1042.55,155.45L1045.15,153.85L1050.75,156.25L1053.15,158.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DJ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.75,427.45L1226.85,430.95L1225.55,429.75L1224.25,430.25L1221.05,430.15L1220.85,428.15L1220.35,426.35L1222.15,423.35L1224.05,420.55L1226.45,421.15L1228.15,419.55L1229.55,421.55L1229.45,424.15L1226.35,425.75L1228.75,427.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1045.35,146.95L1042.95,151.85L1037.75,148.35L1036.85,145.85L1043.65,143.85L1045.35,146.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1032.55,150.75L1029.65,151.65L1025.95,150.85L1023.85,147.45L1023.45,141.35L1024.05,139.65L1025.35,137.85L1029.35,137.55L1030.95,135.85L1034.55,134.15L1034.55,137.25L1033.35,139.25L1034.05,140.85L1036.65,141.75L1035.65,144.05L1034.25,143.45L1031.15,147.75L1032.55,150.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M584.95,385.25L585.25,383.45L583.95,381.55L585.45,380.45L586.15,377.95L586.05,374.55L586.85,373.45L591.15,373.45L594.35,375.05L595.85,374.95L596.55,377.25L599.65,377.05L599.25,378.95L601.75,379.25L604.25,381.55L601.95,384.15L599.35,382.75L596.75,383.05L594.95,382.75L593.85,383.95L591.65,384.35L590.95,382.75L589.05,383.65L586.35,388.05L585.05,387.05L584.95,385.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1030.25,263.85L1029.25,267.15L1030.25,273.25L1029.15,278.55L1025.95,282.15L1026.55,286.95L1031.05,290.85L1031.15,292.35L1034.55,294.95L1037.15,306.45L1039.05,312.15L1039.45,315.15L1038.65,320.35L1039.05,323.35L1038.45,326.85L1039.05,330.85L1036.85,333.55L1040.25,338.25L1040.45,340.95L1042.55,344.55L1045.05,343.35L1049.55,346.35L1052.05,350.35L1033.25,362.65L1017.25,375.25L1009.45,378.05L1003.25,378.75L1003.15,374.65L1000.55,373.55L997.05,371.75L995.75,368.75L977.05,354.75L958.45,340.75L937.95,325.15L938.05,323.95L938.15,323.55L938.25,315.95L947.15,311.15L952.55,310.15L957.05,308.45L959.15,305.25L965.55,302.75L965.85,297.95L968.95,297.35L971.45,295.05L978.55,293.95L979.55,291.45L978.15,290.05L976.25,283.25L975.95,279.35L974.05,275.25L979.15,271.75L984.95,270.65L988.25,268.05L993.35,266.05L1002.35,264.95L1011.15,264.45L1013.85,265.35L1018.75,262.85L1024.45,262.75L1026.65,264.25L1030.25,263.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EC" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M558.25,502.05L559.05,506.95L557.35,511.05L551.25,517.85L544.55,520.35L541.15,525.95L540.25,530.25L537.15,532.95L534.65,529.65L532.35,528.95L530.05,529.45L529.75,527.15L531.35,525.65L530.65,522.95L533.55,518.15L532.25,515.35L530.15,518.35L526.65,515.45L527.75,513.65L526.75,507.85L528.75,506.85L529.75,502.85L531.85,498.75L531.55,496.15L534.65,494.75L538.55,492.25L544.15,495.85L545.25,495.75L546.65,498.55L551.45,499.45L553.05,498.45L555.85,500.55L558.25,502.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1171.35,300.65L1175.25,310.05L1175.95,311.65L1174.65,314.25L1173.95,319.05L1172.75,322.45L1171.55,323.55L1169.55,321.45L1166.85,318.65L1162.15,309.45L1161.65,310.05L1164.45,316.75L1168.35,323.25L1173.25,333.25L1175.55,336.75L1177.55,340.35L1182.95,347.45L1181.95,348.55L1182.35,352.75L1189.15,358.55L1190.25,359.85L1124.35,359.85L1123.35,336.15L1122.05,313.35L1120.05,308.15L1121.15,304.25L1120.15,301.45L1121.85,298.35L1129.05,298.25L1134.45,299.95L1139.95,301.85L1142.55,302.85L1146.55,300.85L1148.65,299.05L1153.35,298.45L1157.25,299.25L1159.05,302.45L1160.15,300.35L1164.55,301.85L1168.85,302.25L1171.35,300.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ER" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.15,419.55L1226.45,421.15L1224.05,420.55L1222.05,418.45L1219.55,414.75L1216.95,412.65L1215.45,410.45L1210.45,407.85L1206.55,407.75L1205.15,406.45L1201.95,407.95L1198.35,405.05L1196.85,409.85L1190.25,408.45L1189.55,405.95L1191.55,396.45L1191.85,392.25L1193.55,390.25L1197.55,389.15L1200.25,385.55L1203.85,392.95L1205.75,398.85L1208.95,401.95L1216.95,408.05L1220.25,411.65L1223.45,415.45L1225.25,417.65L1228.15,419.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1112.95,123.85L1113.85,124.85L1111.25,128.25L1113.65,133.85L1112.05,135.75L1108.25,135.65L1103.85,133.45L1101.75,132.75L1097.95,133.75L1097.85,130.25L1096.35,131.05L1093.05,128.95L1092.05,125.55L1097.55,123.85L1103.15,123.05L1108.25,123.95L1112.95,123.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ET" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1206.55,407.75L1210.45,407.85L1215.45,410.45L1216.95,412.65L1219.55,414.75L1222.05,418.45L1224.05,420.55L1222.15,423.35L1220.35,426.35L1220.85,428.15L1221.05,430.15L1224.25,430.25L1225.55,429.75L1226.85,430.95L1225.65,433.15L1227.85,436.75L1230.05,439.85L1232.25,442.15L1250.95,449.75L1255.75,449.65L1240.15,468.95L1232.85,469.25L1227.85,473.75L1224.25,473.85L1222.75,475.95L1218.85,475.95L1216.55,473.75L1211.35,476.45L1209.75,479.15L1205.95,478.55L1204.65,477.85L1203.35,478.05L1201.55,477.95L1194.35,472.55L1190.35,472.55L1188.45,470.45L1188.35,466.85L1185.45,465.75L1181.95,458.75L1179.35,457.25L1178.35,454.65L1175.35,451.55L1171.85,451.05L1173.75,447.45L1176.75,447.25L1177.55,445.35L1177.35,440.35L1177.35,439.55L1178.85,432.85L1181.45,431.05L1181.95,428.45L1184.25,423.45L1187.55,420.35L1189.55,413.95L1190.25,408.45L1196.85,409.85L1198.35,405.05L1201.95,407.95L1205.15,406.45L1206.55,407.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="FI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1103.35,69.35L1103.75,73.15L1111.05,76.85L1108.15,81.05L1114.65,87.35L1112.95,92.15L1117.85,96.35L1116.95,100.15L1124.35,104.05L1123.45,106.95L1120.05,110.35L1112.05,117.75L1104.05,118.25L1096.45,120.35L1089.35,121.65L1086.15,118.45L1081.45,116.55L1081.55,110.75L1078.55,105.55L1080.15,102.15L1083.45,98.65L1092.25,92.45L1094.85,91.25L1093.95,88.85L1087.45,86.25L1085.65,84.05L1083.85,75.55L1076.65,71.85L1070.65,69.15L1072.85,67.75L1077.95,70.55L1083.25,70.35L1087.95,71.65L1091.35,69.25L1092.45,65.25L1098.35,63.45L1104.15,65.55L1103.35,69.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1059.75,486.55L1059.35,489.35L1060.95,492.65L1065.15,492.15L1066.55,493.35L1064.05,500.85L1066.75,504.65L1067.35,509.65L1066.65,513.95L1064.95,516.95L1059.95,516.65L1056.85,513.55L1056.45,516.45L1052.65,517.25L1050.65,518.85L1052.75,523.05L1048.45,526.65L1042.65,520.15L1038.95,514.85L1035.45,508.25L1035.65,506.05L1036.95,504.05L1038.25,499.35L1039.45,494.55L1041.35,494.25L1049.55,494.25L1049.55,486.55L1052.25,486.15L1055.65,486.95L1059.05,486.15L1059.75,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.95,157.45L952.45,156.25L949.45,156.35L950.65,153.05L949.75,149.85L953.75,149.55L958.65,153.35L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M971.85,128.75L966.75,135.25L971.45,134.45L976.55,134.45L975.25,139.35L970.95,144.75L975.85,145.05L976.15,145.75L980.35,152.85L983.55,153.85L986.45,160.85L987.85,163.25L993.75,164.35L993.15,168.35L990.75,170.15L992.65,173.35L988.25,176.55L981.75,176.45L973.35,178.25L971.15,176.95L967.85,179.85L963.35,179.15L959.75,181.55L957.25,180.35L964.55,173.85L968.95,172.45L961.35,171.45L960.05,168.95L965.15,167.05L962.65,163.75L963.65,159.75L970.75,160.35L971.55,156.75L968.45,153.05L968.35,152.95L962.65,151.85L961.55,150.25L963.35,147.55L961.85,145.85L959.25,148.75L959.15,142.85L956.95,139.85L958.85,133.65L962.65,128.85L966.25,129.25L971.85,128.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1214.95,227.15L1220.05,228.45L1222.15,231.05L1225.75,232.55L1224.55,233.35L1227.85,236.85L1227.25,237.55L1224.35,237.25L1220.15,235.35L1219.05,236.45L1212.05,237.45L1206.45,234.25L1200.95,234.55L1201.25,231.85L1199.15,227.55L1195.75,225.15L1192.75,224.45L1190.55,222.55L1190.95,221.75L1195.55,222.85L1203.25,223.85L1210.85,226.95L1212.05,228.15L1214.95,227.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M985.75,430.35L985.35,432.35L987.65,435.65L987.65,440.35L988.25,445.35L989.65,447.75L988.35,453.45L988.85,456.65L990.35,460.75L991.65,463.05L982.75,466.75L979.55,468.95L974.45,470.85L969.45,469.05L969.65,466.45L967.25,460.95L968.75,453.65L971.15,448.35L969.65,439.15L968.85,434.35L969.05,430.65L978.85,430.35L981.35,430.85L983.15,429.85L985.75,430.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M920.75,421.15L921.05,423.55L921.95,423.55L923.45,422.65L924.35,422.85L925.95,424.55L928.35,425.05L929.85,423.65L931.75,422.75L933.05,421.85L934.15,422.05L935.45,423.45L936.05,425.25L938.35,427.95L937.25,429.55L936.95,431.65L938.15,431.05L938.85,431.75L938.55,433.65L940.25,435.55L939.15,436.05L938.65,438.25L939.95,440.85L941.35,446.05L939.25,446.75L938.75,447.65L939.15,448.95L938.75,451.75L937.85,451.75L936.25,451.55L935.15,454.15L933.55,454.15L932.45,452.75L932.85,450.15L930.45,446.25L929.05,446.95L927.75,447.15L926.25,447.45L926.35,445.15L925.45,443.45L925.65,441.55L924.45,438.85L922.85,436.55L918.35,436.55L917.05,437.75L915.45,437.95L914.45,439.35L913.85,441.05L910.75,443.95L908.35,440.15L906.15,437.65L904.75,436.75L903.35,435.45L902.75,432.65L901.95,431.25L900.25,430.15L902.85,427.05L904.55,427.15L906.05,426.15L907.25,426.05L908.15,425.25L907.75,423.15L908.35,422.45L908.45,420.25L911.15,420.35L915.25,421.85L916.45,421.75L916.85,421.05L919.95,421.55L920.75,421.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M890.85,416.65L891.65,413.75L897.75,413.65L899.05,412.05L900.85,411.95L903.05,413.55L904.75,413.55L906.65,412.55L907.75,414.35L905.25,415.85L902.85,415.65L900.45,414.35L898.35,415.85L897.35,415.85L895.95,416.75L890.85,416.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M908.45,420.25L908.35,422.45L907.75,423.15L908.15,425.25L907.25,426.05L906.05,426.15L904.55,427.15L902.85,427.05L900.25,430.15L897.35,427.55L894.95,427.05L893.65,425.25L893.75,424.25L892.05,422.95L891.65,421.55L894.65,420.55L896.55,420.75L898.05,419.95L908.45,420.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GQ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1049.55,486.55L1049.55,494.25L1041.35,494.25L1039.45,494.55L1038.35,493.65L1040.25,486.45L1049.55,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1111.95,271.85L1115.05,274.05L1119.15,273.65L1123.15,274.05L1123.15,275.25L1125.95,274.45L1125.45,276.35L1117.85,276.85L1117.75,275.85L1111.15,274.55L1111.95,271.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1121.15,239.15L1117.95,238.95L1115.25,238.35L1109.05,239.95L1113.05,243.55L1110.55,244.65L1107.65,244.65L1104.55,241.35L1103.65,242.75L1105.25,246.55L1108.15,249.55L1106.25,250.95L1109.45,253.85L1112.25,255.75L1112.65,259.35L1107.65,257.65L1109.45,260.95L1106.15,261.55L1108.65,267.25L1105.15,267.35L1100.55,264.55L1098.15,259.45L1096.85,255.15L1094.55,252.25L1091.55,248.55L1091.05,246.75L1093.25,243.65L1093.35,241.55L1095.05,240.65L1094.95,238.95L1098.35,238.45L1100.15,237.05L1102.95,237.15L1103.75,236.05L1104.75,235.85L1108.55,236.05L1112.55,234.25L1116.45,236.55L1121.05,235.95L1120.75,232.75L1123.45,234.45L1122.35,238.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M895.55,0.65L915.45,3.65L908.75,5.05L895.75,5.25L877.25,5.65L878.65,6.35L890.95,5.85L900.65,7.25L907.65,6.05L910.05,7.45L905.55,9.85L914.75,8.25L931.85,6.75L941.85,7.55L943.55,9.25L928.75,12.15L926.55,13.15L915.15,13.95L923.25,14.15L918.35,17.35L914.75,20.25L913.55,25.45L917.25,28.65L911.35,28.75L904.85,30.35L911.15,32.95L911.05,37.15L906.85,37.65L910.95,41.95L902.25,42.35L906.25,44.35L904.65,46.15L898.95,46.95L893.45,47.05L897.65,50.45L897.15,52.85L889.85,50.65L887.45,52.05L892.45,53.35L897.05,56.55L897.65,60.85L890.25,61.85L887.55,59.75L883.35,56.75L883.85,60.35L878.45,63.15L889.15,63.35L894.65,63.65L882.75,68.35L870.55,72.65L857.85,74.45L853.25,74.55L848.35,76.65L840.85,82.45L830.65,86.35L827.65,86.65L821.55,87.95L814.95,89.35L810.15,92.75L808.75,96.75L805.35,100.55L796.75,105.15L797.05,109.65L793.45,114.45L789.35,120.15L782.85,120.55L777.85,115.75L768.85,115.65L765.65,112.45L764.85,106.85L760.05,99.65L759.35,95.95L760.85,90.85L757.15,85.75L760.45,81.65L758.55,79.65L765.55,73.25L772.75,71.15L775.35,68.95L778.15,64.75L772.65,66.65L770.05,67.45L765.95,68.15L761.75,66.45L763.25,62.75L766.25,59.95L770.05,59.85L777.65,61.35L772.35,57.95L769.65,56.15L765.25,56.85L762.65,55.55L769.65,50.75L768.35,48.75L767.25,45.25L765.85,39.85L762.25,37.95L763.65,35.85L755.55,32.95L747.85,32.55L737.75,32.75L728.25,33.15L725.15,31.55L721.35,28.45L732.35,26.95L739.95,26.75L725.35,25.45L718.85,23.55L721.05,21.75L736.75,19.55L751.75,17.35L754.55,15.75L746.45,14.15L751.05,12.45L765.75,9.55L771.15,9.15L771.35,7.35L780.35,6.25L791.35,5.65L801.75,5.65L804.55,6.85L815.15,4.65L822.25,6.15L826.85,6.45L833.05,7.75L826.35,5.65L827.95,3.95L840.65,1.75L852.25,1.95L857.35,0.55L869.25,0.25L895.55,0.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M487.35,386.75L486.65,391.85L485.35,399.05L487.05,399.05L488.75,400.25L489.35,399.25L490.85,400.05L488.05,402.55L485.15,404.35L484.65,405.55L484.95,406.85L483.65,408.45L482.25,408.85L482.55,409.65L481.35,410.35L479.35,411.95L479.05,412.85L476.25,411.75L472.75,411.65L470.35,410.35L467.55,407.75L467.95,405.85L468.75,404.35L468.05,403.15L471.35,397.95L478.55,397.95L478.95,395.75L478.15,395.35L477.65,393.95L475.75,392.45L473.95,390.35L476.45,390.25L476.95,386.65L482.15,386.65L487.35,386.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M662.15,462.75L661.15,468.55L657.65,470.15L657.95,471.65L656.85,475.05L659.25,479.65L661.05,479.65L661.75,483.25L665.05,488.85L663.75,489.15L660.55,488.55L658.75,490.25L656.15,491.35L654.35,491.65L653.75,492.95L650.95,492.65L647.45,489.65L647.15,486.65L645.75,483.35L646.75,477.95L648.35,475.65L647.15,472.65L645.15,471.75L645.95,468.85L644.75,467.45L641.75,467.65L638.05,462.85L639.65,461.05L639.65,458.05L643.15,457.05L644.55,455.85L642.75,453.45L643.25,451.15L647.95,447.35L651.55,449.75L654.85,453.85L654.95,457.25L657.05,457.35L660.05,460.45L662.15,462.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M518.85,404.75L516.95,404.65L516.05,405.55L514.05,406.35L512.65,406.35L511.35,407.15L510.25,406.95L509.35,405.95L508.75,406.15L507.85,407.65L507.35,407.55L507.15,408.95L505.05,410.65L503.85,411.45L503.25,412.25L501.75,410.95L500.35,412.65L499.15,412.65L497.85,412.75L497.65,415.95L496.85,415.95L496.05,417.45L494.25,417.75L493.45,415.75L491.75,415.15L492.45,412.55L491.75,411.85L490.55,411.45L488.05,412.15L487.95,411.35L486.35,410.25L485.25,409.05L483.65,408.45L484.95,406.85L484.65,405.55L485.15,404.35L488.05,402.55L490.85,400.05L491.45,400.35L492.75,399.25L494.35,399.15L494.85,399.65L495.75,399.35L498.35,399.95L500.95,399.75L502.75,399.05L503.55,398.35L505.25,398.65L506.55,399.05L508.05,398.95L509.25,398.35L511.75,399.25L512.55,399.45L514.15,400.65L515.65,402.05L517.55,403.05L518.85,404.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1080.75,206.85L1082.25,209.35L1083.95,211.15L1082.25,213.55L1079.85,212.15L1076.35,212.25L1071.85,211.15L1069.55,211.25L1068.55,212.65L1066.55,211.15L1065.75,213.75L1068.45,216.75L1069.75,218.65L1072.25,221.05L1074.35,222.45L1076.45,225.15L1081.25,227.55L1080.75,228.55L1075.75,226.25L1072.55,223.95L1067.75,222.05L1063.05,217.45L1064.05,216.95L1061.55,214.25L1061.25,212.15L1057.95,211.15L1056.55,213.85L1054.95,211.75L1054.95,209.55L1055.05,209.45L1058.65,209.65L1059.45,208.65L1061.25,209.65L1063.25,209.75L1063.15,208.05L1064.85,207.35L1065.15,204.85L1069.05,203.15L1070.65,203.95L1074.65,206.65L1078.95,207.85L1080.75,206.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M586.05,374.55L586.15,377.95L585.45,380.45L583.95,381.55L585.25,383.45L584.95,385.25L581.35,384.15L578.65,384.55L575.25,384.15L572.55,385.35L569.75,383.35L570.45,381.25L575.55,382.15L579.65,382.65L581.85,381.25L579.55,378.45L579.95,375.95L576.45,374.95L577.95,373.25L581.35,373.45L586.05,374.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1095.45,191.15L1098.45,192.85L1098.95,194.55L1096.05,195.85L1094.15,200.05L1091.55,204.35L1087.65,205.55L1084.45,205.25L1080.75,206.85L1078.95,207.85L1074.65,206.65L1070.65,203.95L1069.05,203.15L1067.85,201.05L1067.05,200.95L1068.35,196.95L1067.25,195.55L1070.05,195.55L1070.25,192.95L1072.95,194.65L1074.85,195.25L1078.95,194.55L1079.25,193.25L1081.15,193.05L1083.45,192.15L1084.05,192.55L1086.35,191.75L1087.35,190.25L1088.95,189.85L1094.45,191.75L1095.45,191.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1666.75,566.85L1664.35,566.95L1657.25,562.45L1662.65,561.15L1665.45,563.15L1667.25,565.05L1666.75,566.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1691.55,558.15L1692.05,559.45L1691.95,561.35L1687.85,566.15L1682.85,567.55L1682.25,566.85L1682.95,564.65L1685.75,560.75L1691.55,558.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1651.95,553.05L1653.85,554.75L1657.45,554.25L1658.65,556.95L1651.95,558.25L1648.05,559.15L1644.95,559.05L1647.15,555.35L1650.35,555.35L1651.95,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1680.25,553.05L1679.15,556.65L1670.55,558.45L1663.05,557.65L1663.25,555.25L1667.85,553.95L1671.25,555.85L1675.05,555.35L1680.25,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1600.05,544.55L1610.85,545.25L1612.25,542.55L1622.55,545.65L1624.35,549.85L1632.75,551.05L1639.45,554.85L1632.85,557.25L1626.75,554.65L1621.65,554.85L1615.85,554.35L1610.65,553.25L1604.25,550.75L1600.15,550.15L1597.75,550.95L1587.55,548.25L1586.75,545.55L1581.65,545.05L1585.85,538.95L1592.65,539.35L1597.05,541.85L1599.45,542.35L1600.05,544.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1747.95,540.95L1744.75,545.35L1744.55,540.55L1745.65,538.25L1746.95,536.05L1748.15,537.95L1747.95,540.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1706.55,523.25L1704.35,525.45L1700.55,524.25L1699.55,521.45L1705.25,521.15L1706.55,523.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1724.95,520.95L1726.75,525.85L1722.15,523.15L1717.45,522.65L1714.15,523.05L1710.25,522.85L1711.75,519.35L1718.75,519.05L1724.95,520.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1784.75,517.75L1783.75,538.65L1782.15,559.65L1777.55,554.35L1771.95,553.05L1770.45,554.85L1763.25,555.05L1766.05,549.85L1769.75,548.05L1768.75,541.05L1766.45,535.75L1755.75,530.25L1751.15,529.75L1742.85,523.75L1741.05,526.95L1738.85,527.45L1737.75,525.15L1737.85,522.35L1733.65,519.15L1739.85,516.85L1743.85,516.95L1743.45,515.25L1735.15,515.25L1732.95,511.45L1727.95,510.25L1725.65,507.05L1733.25,505.55L1736.15,503.45L1745.25,506.05L1746.15,508.45L1747.45,518.85L1753.15,522.65L1758.15,515.85L1764.75,512.05L1769.75,512.05L1774.55,514.25L1778.65,516.55L1784.75,517.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1695.65,491.95L1691.15,498.35L1686.85,499.55L1681.45,498.35L1671.95,498.65L1667.05,499.55L1666.25,504.45L1671.25,510.15L1674.35,507.25L1684.95,505.05L1684.45,507.95L1681.95,507.05L1679.45,510.85L1674.35,513.35L1679.45,521.55L1678.35,523.75L1683.15,531.15L1682.85,535.35L1679.75,537.25L1677.65,534.95L1680.65,529.75L1674.95,532.25L1673.65,530.45L1674.45,527.95L1670.55,524.15L1671.25,517.95L1667.35,519.85L1667.55,527.35L1667.35,536.55L1663.65,537.45L1661.35,535.65L1663.25,529.75L1662.65,523.55L1660.25,523.45L1658.65,519.05L1661.15,514.85L1662.05,509.75L1665.05,500.05L1666.15,497.45L1670.95,492.65L1675.45,494.55L1682.55,495.45L1689.05,495.15L1694.65,490.55L1695.65,491.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1715.25,493.85L1714.95,499.45L1712.05,498.75L1711.15,502.65L1713.45,506.05L1711.85,506.85L1709.65,502.75L1707.95,494.55L1708.95,489.45L1710.75,487.15L1711.25,490.65L1714.65,491.15L1715.25,493.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1607.25,488.15L1608.25,492.45L1612.15,496.15L1615.85,494.85L1619.45,495.25L1622.75,492.05L1625.45,491.45L1630.85,493.25L1635.45,491.85L1638.05,482.95L1640.15,480.75L1641.85,473.45L1648.35,473.45L1653.35,474.55L1650.35,480.35L1654.75,486.35L1653.85,489.35L1660.25,495.25L1653.55,496.05L1651.75,500.45L1651.95,506.25L1646.45,510.65L1646.05,517.05L1643.55,526.85L1642.85,524.55L1636.25,527.45L1634.15,523.55L1630.15,523.15L1627.35,521.05L1620.55,523.45L1618.65,520.25L1614.85,520.65L1610.25,519.95L1609.65,511.35L1606.85,509.55L1604.15,504.05L1603.35,498.45L1603.95,492.45L1607.25,488.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1584.45,538.65L1578.25,538.75L1573.75,533.45L1566.65,528.15L1564.35,524.25L1560.25,519.05L1557.55,514.25L1553.35,505.25L1548.45,499.85L1546.75,494.35L1544.55,489.35L1539.35,485.35L1536.25,479.85L1531.85,476.25L1525.65,469.15L1525.05,465.85L1528.65,466.15L1537.55,467.35L1542.75,473.65L1547.35,478.05L1550.55,480.65L1556.05,487.55L1561.85,487.65L1566.65,492.05L1570.05,497.45L1574.35,500.45L1572.05,505.65L1575.35,507.85L1577.35,508.05L1578.25,512.55L1580.15,516.05L1584.25,516.65L1586.85,520.75L1585.15,528.75L1584.45,538.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1426.85,307.25L1424.05,310.25L1423.15,316.25L1428.95,318.65L1434.75,321.75L1442.55,325.35L1450.25,326.25L1454.05,329.45L1458.35,330.05L1465.25,331.55L1469.85,331.45L1469.95,328.95L1468.45,324.85L1468.25,322.15L1471.35,320.75L1472.85,325.85L1473.25,327.05L1478.75,329.55L1481.95,328.55L1486.65,328.95L1491.15,328.75L1490.65,324.85L1488.05,322.75L1492.25,321.95L1496.15,317.15L1501.55,313.15L1506.45,314.65L1509.65,311.95L1513.25,315.95L1512.05,318.65L1518.15,319.65L1519.15,322.05L1517.45,323.25L1518.85,327.15L1514.65,326.05L1508.45,330.45L1509.35,334.15L1507.35,339.55L1507.65,342.65L1506.05,347.95L1501.45,346.45L1502.35,353.15L1501.35,355.35L1502.35,358.05L1499.85,359.55L1495.45,349.35L1493.95,349.35L1493.65,353.55L1490.05,350.15L1491.25,346.55L1493.65,346.15L1495.25,340.75L1491.85,339.65L1486.75,339.75L1481.35,338.85L1480.15,334.35L1477.45,334.05L1472.55,331.25L1471.35,335.65L1475.95,339.05L1472.95,341.45L1472.05,343.75L1475.75,345.45L1475.45,349.35L1478.05,354.15L1479.65,359.45L1479.15,361.85L1475.35,361.75L1468.75,363.05L1469.65,367.85L1467.25,371.65L1459.75,376.05L1454.45,383.55L1450.65,387.65L1445.65,391.85L1445.95,394.75L1443.35,396.35L1438.55,398.65L1435.95,398.95L1434.75,403.85L1436.65,412.25L1437.35,417.55L1435.45,423.65L1436.15,434.55L1433.25,434.85L1430.95,439.75L1432.85,441.95L1427.75,443.75L1426.05,448.05L1423.85,449.95L1418.25,443.95L1415.15,434.95L1412.65,428.45L1410.45,425.45L1407.05,419.25L1405.05,411.25L1403.65,407.25L1397.75,398.45L1394.25,385.95L1391.65,377.75L1390.85,369.95L1389.15,363.95L1381.45,367.85L1377.45,367.05L1369.35,359.25L1371.75,356.95L1369.85,354.45L1362.75,348.95L1365.95,344.65L1378.05,344.65L1376.25,339.15L1372.75,335.95L1371.35,330.95L1367.35,328.15L1372.25,321.35L1378.75,321.85L1383.25,315.15L1385.45,308.65L1389.35,302.15L1388.35,297.55L1392.15,293.85L1387.05,290.75L1384.15,286.35L1380.85,280.75L1382.85,277.95L1391.35,279.55L1397.05,278.55L1400.85,273.15L1408.55,280.75L1409.35,285.95L1412.35,289.25L1412.95,292.55L1408.85,291.65L1412.05,298.75L1418.25,302.75L1426.85,307.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.95,157.45L956.65,161.85L952.75,167.35L943.95,170.95L937.15,170.05L941.45,163.65L939.35,157.45L946.05,152.65L949.75,149.85L950.65,153.05L949.45,156.35L952.45,156.25L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.25,252.45L1230.05,252.25L1235.35,247.55L1237.25,247.05L1239.15,248.95L1237.95,252.05L1241.85,255.45L1243.15,255.05L1245.65,259.85L1250.95,261.15L1255.25,264.35L1262.95,265.45L1270.95,263.75L1271.15,262.25L1275.55,261.05L1278.55,257.35L1282.15,257.55L1284.15,256.35L1288.05,256.95L1294.65,260.25L1298.95,260.95L1306.25,266.55L1310.25,266.85L1311.95,272.15L1311.35,280.15L1310.85,284.85L1313.35,285.85L1311.75,289.35L1314.45,294.45L1315.65,298.55L1319.95,299.65L1321.05,303.75L1317.15,309.55L1320.35,312.95L1323.15,316.85L1328.85,319.65L1329.85,325.25L1332.55,326.35L1333.45,329.25L1325.95,332.65L1324.85,340.05L1314.25,338.15L1308.05,336.65L1301.75,335.85L1298.45,327.95L1295.65,326.85L1291.55,327.95L1286.45,331.05L1279.45,328.95L1273.35,323.95L1267.85,322.15L1263.45,316.05L1258.25,307.55L1255.45,308.55L1251.75,306.45L1250.05,308.95L1246.55,305.55L1246.05,302.15L1244.35,302.15L1244.55,297.45L1241.05,292.65L1233.95,289.05L1229.35,282.95L1229.85,277.95L1232.15,275.75L1231.25,272.05L1227.45,270.05L1222.75,262.45L1218.95,257.35L1219.65,255.35L1216.75,248.05L1220.05,246.15L1221.25,248.65L1224.45,251.55L1228.25,252.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IQ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1222.75,262.45L1227.45,270.05L1231.25,272.05L1232.15,275.75L1229.85,277.95L1229.35,282.95L1233.95,289.05L1241.05,292.65L1244.55,297.45L1244.35,302.15L1246.05,302.15L1246.55,305.55L1250.05,308.95L1246.75,308.65L1243.05,308.05L1239.75,314.25L1229.55,313.75L1212.75,300.85L1204.15,296.35L1197.35,294.55L1194.25,286.75L1205.25,280.05L1206.25,272.35L1205.05,267.65L1207.75,266.05L1209.85,262.05L1211.95,261.05L1218.25,261.95L1220.35,263.55L1222.75,262.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M924.05,83.75L922.65,87.35L927.05,91.15L920.95,95.45L907.85,99.35L903.95,100.45L898.35,99.55L886.45,97.75L891.25,95.25L882.25,92.55L890.15,91.45L890.25,89.75L881.45,88.45L885.05,84.75L891.65,83.95L897.65,87.75L904.65,84.75L909.75,86.25L917.05,83.35L924.05,83.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1178.35,287.45L1178.75,290.05L1178.15,291.05L1178.25,291.05L1177.55,293.05L1175.45,292.25L1174.75,296.45L1176.25,297.15L1174.95,298.05L1174.85,299.75L1177.35,298.95L1177.75,301.45L1175.95,311.65L1175.25,310.05L1171.35,300.65L1172.75,298.55L1172.35,298.15L1173.45,295.15L1174.05,290.35L1174.65,288.65L1176.55,288.65L1176.95,287.55L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1067.45,255.65L1065.75,260.75L1066.65,262.65L1065.75,265.95L1061.55,263.55L1058.85,262.85L1051.35,259.65L1051.85,256.35L1058.05,256.95L1063.45,256.25L1067.45,255.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1033.45,236.65L1036.75,241.15L1036.35,249.65L1033.95,249.25L1031.85,251.35L1029.85,249.65L1029.35,241.95L1028.05,238.35L1030.95,238.65L1033.45,236.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1055.15,203.15L1054.75,206.25L1056.15,208.95L1052.05,207.95L1048.15,210.25L1048.55,213.35L1048.05,215.15L1049.95,218.35L1054.95,221.55L1057.85,226.85L1063.95,231.95L1067.95,231.85L1069.35,233.25L1067.95,234.55L1072.75,236.85L1076.75,238.75L1081.45,242.15L1082.05,243.25L1081.25,245.55L1078.15,242.55L1073.55,241.55L1071.65,245.65L1075.55,248.05L1075.15,251.35L1073.05,251.75L1070.55,257.25L1068.35,257.75L1068.25,255.75L1069.15,252.35L1070.25,250.95L1067.95,247.25L1066.15,244.05L1063.95,243.25L1062.15,240.55L1058.75,239.35L1056.35,236.75L1052.55,236.35L1048.25,233.55L1043.35,229.35L1039.65,225.75L1037.75,219.45L1035.15,218.75L1030.95,216.65L1028.65,217.45L1025.75,220.45L1023.65,220.85L1024.15,218.15L1021.35,217.35L1019.85,212.45L1021.55,210.55L1020.05,208.15L1020.15,206.35L1022.35,207.75L1024.85,207.45L1027.55,205.25L1028.45,206.25L1030.85,206.05L1031.85,203.55L1035.65,204.35L1037.75,203.25L1038.05,200.75L1041.15,201.65L1041.65,200.45L1046.55,199.35L1047.85,201.45L1055.15,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="JM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M555.75,386.35L553.95,387.45L550.95,386.35L548.05,384.05L548.85,382.55L551.25,382.15L552.55,382.35L556.25,382.95L558.95,384.45L559.75,386.25L555.75,386.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="JO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1197.35,294.55L1196.45,295.55L1186.05,298.75L1192.05,305.25L1190.45,306.25L1189.75,308.45L1185.65,309.35L1184.55,311.65L1182.45,313.65L1176.25,312.55L1175.95,311.65L1177.75,301.45L1177.35,298.95L1177.95,297.05L1177.55,293.05L1178.25,291.05L1184.55,293.65L1194.25,286.75L1197.35,294.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1707.75,281.85L1709.35,284.05L1708.05,287.95L1704.95,285.85L1702.85,287.35L1702.95,291.05L1698.65,289.25L1697.45,286.25L1698.75,282.35L1702.15,283.15L1703.15,280.45L1707.75,281.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1732.35,262.65L1732.95,267.75L1735.45,270.95L1734.85,275.45L1729.45,278.45L1720.25,278.85L1715.85,286.25L1711.15,283.75L1708.75,278.95L1700.15,280.35L1695.05,283.35L1688.85,283.55L1696.25,288.25L1697.05,299.15L1694.55,301.85L1690.95,299.35L1690.05,293.55L1685.95,291.75L1681.95,287.35L1686.25,285.35L1687.35,281.25L1691.25,277.95L1693.25,273.55L1702.95,271.65L1709.25,272.95L1709.25,261.55L1714.35,264.65L1718.85,258.25L1720.55,255.75L1719.55,247.95L1714.45,240.75L1714.25,236.75L1719.05,235.55L1727.25,244.45L1730.05,249.55L1728.75,256.05L1732.35,262.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1720.45,217.85L1724.95,219.15L1726.75,216.55L1732.75,223.65L1726.35,225.35L1725.95,231.65L1715.05,227.35L1716.65,234.25L1710.95,234.35L1706.25,228.05L1705.65,223.15L1710.85,222.85L1706.45,214.05L1704.65,209.15L1715.15,215.75L1720.45,217.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1337.55,159.75L1341.95,159.45L1351.15,153.65L1350.35,155.65L1358.75,160.35L1377.05,175.95L1378.15,172.75L1386.55,176.25L1392.75,174.65L1396.05,175.75L1400.15,179.35L1404.15,180.55L1407.45,183.25L1413.45,182.35L1417.85,186.15L1415.95,190.35L1412.15,190.95L1414.65,197.15L1413.05,200.05L1402.25,197.95L1403.25,209.25L1401.25,210.65L1392.15,213.15L1400.95,224.15L1398.05,225.75L1399.75,229.45L1396.25,228.45L1392.85,226.15L1384.95,225.55L1376.35,225.35L1374.75,226.05L1366.55,223.35L1364.05,224.75L1364.55,228.45L1355.35,226.25L1352.25,227.15L1351.95,229.95L1349.35,231.15L1343.95,235.55L1343.05,240.15L1341.05,240.15L1338.75,237.15L1332.05,236.95L1329.55,231.75L1326.95,231.65L1325.45,225.25L1317.85,220.65L1309.25,221.15L1303.55,222.05L1296.95,216.35L1292.15,213.95L1282.95,209.45L1281.85,208.95L1269.85,212.65L1276.05,236.05L1273.45,236.35L1268.65,231.35L1264.75,229.55L1259.15,230.85L1257.35,233.05L1256.75,231.45L1257.35,228.85L1255.85,226.65L1249.35,224.45L1245.65,218.75L1242.45,217.15L1241.85,215.05L1246.95,215.65L1245.95,211.05L1250.05,210.05L1254.75,210.95L1254.05,204.85L1252.15,200.95L1247.15,201.25L1242.45,199.75L1237.35,202.45L1232.95,203.85L1230.15,202.75L1229.95,199.55L1225.65,195.35L1222.05,195.55L1216.75,191.35L1218.45,186.55L1216.65,185.35L1218.85,178.45L1224.85,182.05L1224.25,177.55L1232.35,170.85L1239.95,170.65L1251.95,174.95L1258.55,177.45L1262.95,174.85L1270.65,174.75L1277.95,177.95L1278.75,176.05L1285.75,176.35L1285.95,173.45L1276.55,169.15L1280.05,166.15L1278.55,164.55L1282.55,162.95L1277.45,158.75L1278.85,156.65L1295.85,154.55L1297.55,153.05L1308.45,150.75L1311.55,148.25L1320.65,149.55L1325.05,155.85L1329.35,154.35L1336.45,156.45L1337.55,159.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1222.75,475.95L1217.85,483.15L1218.05,506.55L1221.35,511.85L1217.35,514.45L1215.95,517.15L1213.75,517.55L1212.95,522.15L1211.05,524.75L1209.95,528.95L1207.65,531.05L1199.55,524.65L1199.25,520.95L1178.75,507.85L1179.15,503.15L1177.75,500.65L1177.75,500.35L1179.35,497.75L1182.15,493.55L1184.25,488.85L1181.65,481.45L1180.95,478.25L1178.25,473.75L1181.65,469.95L1185.45,465.75L1188.35,466.85L1188.45,470.45L1190.35,472.55L1194.35,472.55L1201.55,477.95L1203.35,478.05L1204.65,477.85L1205.95,478.55L1209.75,479.15L1211.35,476.45L1216.55,473.75L1218.85,475.95L1222.75,475.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1399.75,229.45L1399.55,230.85L1392.65,234.25L1391.65,236.85L1385.25,237.55L1384.65,241.65L1378.85,240.75L1375.65,242.05L1371.55,245.05L1372.75,246.55L1371.65,247.95L1362.05,248.95L1354.95,246.85L1349.45,247.35L1348.85,243.75L1354.85,244.75L1356.25,242.85L1360.35,243.45L1365.65,238.85L1358.45,235.45L1355.25,237.05L1350.65,234.65L1353.65,230.55L1351.95,229.95L1352.25,227.15L1355.35,226.25L1364.55,228.45L1364.05,224.75L1366.55,223.35L1374.75,226.05L1376.35,225.35L1384.95,225.55L1392.85,226.15L1396.25,228.45L1399.75,229.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1589.05,409.85L1590.85,414.15L1590.95,421.85L1581.95,426.85L1584.75,430.65L1578.85,431.15L1574.25,433.75L1569.45,432.85L1566.85,429.45L1563.35,422.85L1561.25,415.05L1564.35,409.75L1571.45,408.55L1576.75,409.45L1581.75,411.95L1583.75,407.55L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1652.15,258.75L1652.15,258.15L1654.65,258.35L1655.25,255.55L1658.85,255.15L1660.85,254.75L1660.85,253.25L1669.15,260.75L1672.45,264.95L1675.85,272.35L1675.35,275.85L1671.05,277.05L1667.95,279.75L1663.35,280.25L1661.25,276.75L1660.15,271.95L1654.85,265.35L1658.25,264.25L1652.15,258.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1246.75,308.65L1248.25,311.45L1247.95,312.95L1250.35,317.75L1246.45,317.95L1244.75,314.85L1239.75,314.25L1243.05,308.05L1246.75,308.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1589.05,409.85L1583.75,407.55L1581.75,411.95L1576.75,409.45L1578.25,406.55L1577.85,401.15L1572.55,395.55L1571.25,389.15L1566.25,383.95L1561.95,383.55L1561.15,385.75L1557.95,385.95L1556.05,384.85L1550.75,388.65L1549.75,382.85L1550.15,376.15L1546.35,375.85L1545.45,371.95L1542.75,369.95L1543.55,367.65L1547.65,363.45L1548.45,364.95L1551.45,365.15L1549.45,357.75L1552.15,356.85L1556.15,361.95L1559.65,367.75L1566.45,367.75L1569.45,373.35L1566.15,375.05L1564.95,377.35L1572.25,381.25L1577.95,388.85L1582.35,394.45L1587.25,398.95L1589.25,403.45L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LB" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1178.35,287.45L1176.95,287.55L1176.55,288.65L1174.75,288.65L1176.05,283.35L1178.25,278.85L1178.25,278.65L1180.75,278.95L1181.95,281.45L1179.25,283.95L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M937.85,451.75L937.65,453.55L938.15,456.65L936.95,459.55L938.55,461.35L940.35,461.75L942.75,464.45L942.95,466.95L942.35,467.75L941.95,473.05L940.45,473.15L934.65,470.05L929.45,465.15L924.65,461.65L920.85,457.55L922.25,455.45L922.55,453.55L925.15,450.15L927.75,447.15L929.05,446.95L930.45,446.25L932.85,450.15L932.45,452.75L933.55,454.15L935.15,454.15L936.25,451.55L937.85,451.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1121.85,298.35L1120.15,301.45L1121.15,304.25L1120.05,308.15L1122.05,313.35L1123.35,336.15L1124.35,359.85L1124.85,372.65L1118.45,372.65L1118.45,375.35L1095.85,363.05L1073.35,350.75L1067.85,354.25L1064.05,356.65L1060.85,353.15L1052.05,350.35L1049.55,346.35L1045.05,343.35L1042.55,344.55L1040.45,340.95L1040.25,338.25L1036.85,333.55L1039.05,330.85L1038.45,326.85L1039.05,323.35L1038.65,320.35L1039.45,315.15L1039.05,312.15L1037.15,306.45L1039.75,305.05L1040.15,302.25L1039.55,299.65L1043.15,297.15L1044.75,295.05L1047.35,293.25L1047.45,288.35L1053.85,290.55L1056.15,289.95L1060.65,291.05L1067.95,293.95L1070.75,299.65L1075.65,300.85L1083.45,303.55L1089.45,306.75L1091.95,305.05L1094.45,302.15L1092.85,297.25L1094.35,294.05L1098.05,291.05L1101.75,290.25L1109.15,291.55L1111.15,294.35L1113.15,294.45L1114.95,295.55L1120.35,296.25L1121.85,298.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1445.15,461.25L1440.35,462.75L1437.45,457.65L1436.05,448.45L1438.05,438.05L1442.15,441.55L1444.95,446.05L1448.05,452.75L1447.45,459.45L1445.15,461.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1138.35,697.15L1136.35,697.85L1132.65,692.85L1135.85,688.85L1138.95,686.35L1141.65,684.95L1143.85,686.95L1145.55,688.95L1143.65,692.05L1142.55,694.15L1139.45,695.15L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1110.35,146.85L1111.35,149.55L1107.75,151.55L1107.25,154.95L1102.45,157.25L1097.75,157.25L1096.35,155.35L1093.85,154.65L1093.25,153.15L1093.45,151.45L1091.25,150.55L1086.15,149.45L1084.45,144.35L1089.55,142.55L1097.45,142.95L1101.95,142.35L1102.85,143.55L1105.35,143.95L1110.35,146.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1016.15,184.65L1014.75,184.75L1013.65,184.25L1014.05,180.75L1015.35,180.55L1016.35,181.95L1016.15,184.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1112.05,135.75L1114.55,137.05L1115.55,139.95L1117.65,143.55L1113.05,145.85L1110.35,146.85L1105.35,143.95L1102.85,143.55L1101.95,142.35L1097.45,142.95L1089.55,142.55L1084.45,144.35L1083.95,139.85L1085.65,136.05L1089.75,134.05L1094.15,138.55L1097.85,138.35L1097.95,133.75L1101.75,132.75L1103.85,133.45L1108.25,135.65L1112.05,135.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M974.05,275.25L975.95,279.35L976.25,283.25L978.15,290.05L979.55,291.45L978.55,293.95L971.45,295.05L968.95,297.35L965.85,297.95L965.55,302.75L959.15,305.25L957.05,308.45L952.55,310.15L947.15,311.15L938.25,315.95L938.15,323.55L937.25,323.55L937.35,326.95L933.95,327.15L932.15,328.65L929.65,328.65L927.65,327.75L923.05,328.45L921.15,333.45L919.35,333.95L916.65,342.05L908.75,348.95L906.75,357.85L904.35,360.75L903.65,363.05L891.15,363.55L891.05,363.55L891.35,360.55L893.55,358.85L895.45,355.45L895.15,353.25L897.15,348.75L900.35,344.65L902.25,343.65L903.85,339.95L904.05,336.45L906.15,332.55L909.95,330.15L913.55,323.65L913.65,323.55L916.55,321.05L921.65,320.35L926.05,315.95L928.85,314.25L933.55,308.85L932.35,300.95L934.55,295.35L935.45,291.95L939.05,287.65L944.45,284.75L948.55,282.05L952.25,275.45L954.05,271.45L957.95,271.55L961.05,274.25L966.15,273.85L971.65,275.25L974.05,275.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1128.65,209.55L1127.35,206.65L1127.55,203.95L1126.95,201.25L1123.55,197.45L1121.55,194.85L1119.75,193.05L1118.15,192.35L1119.25,191.45L1122.45,190.85L1126.45,192.75L1128.45,193.05L1131.05,194.75L1130.95,196.85L1132.95,197.85L1134.05,200.45L1136.05,202.05L1135.85,203.05L1136.85,203.65L1135.55,204.15L1132.55,203.95L1131.95,203.05L1130.95,203.55L1131.55,204.65L1130.45,206.75L1129.85,208.85L1128.65,209.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1267.15,588.15L1267.55,595.85L1268.85,598.85L1268.15,601.95L1266.95,603.75L1265.35,600.05L1264.15,601.95L1264.95,606.65L1264.25,609.45L1262.55,610.85L1261.85,616.35L1259.15,623.85L1255.75,632.65L1251.45,644.85L1248.55,653.75L1245.45,661.25L1240.85,662.75L1235.75,665.45L1232.75,663.85L1228.55,661.55L1227.35,658.15L1227.35,652.45L1225.85,647.35L1225.65,642.65L1226.95,638.05L1229.55,636.95L1229.75,634.85L1232.65,629.95L1233.45,625.85L1232.35,622.85L1231.55,618.75L1231.45,612.85L1233.65,609.25L1234.65,605.15L1237.45,604.95L1240.65,603.65L1242.85,602.45L1245.25,602.35L1248.65,598.75L1253.55,594.75L1255.35,591.55L1254.75,588.75L1257.15,589.55L1260.45,585.15L1260.75,581.25L1262.75,578.35L1264.55,581.15L1265.95,583.85L1267.15,588.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MX" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M448.55,335.15L450.75,334.95L447.55,340.65L445.75,345.25L443.95,353.85L442.85,356.95L443.25,360.45L444.55,363.65L444.95,368.55L447.95,373.35L448.75,377.05L450.45,380.15L456.15,381.85L458.05,384.55L463.25,382.75L467.55,382.15L471.95,380.95L475.55,379.85L479.45,377.25L481.25,373.55L482.45,368.15L483.65,366.25L487.65,364.55L493.75,363.05L498.65,363.35L502.05,362.75L503.25,364.15L502.65,367.25L499.15,371.05L497.35,374.95L498.25,376.05L497.05,378.85L494.95,383.85L493.75,382.15L491.55,382.35L489.05,386.25L488.15,385.45L487.45,385.75L487.35,386.75L482.15,386.65L476.95,386.65L476.45,390.25L473.95,390.35L475.75,392.45L477.65,393.95L478.15,395.35L478.95,395.75L478.55,397.95L471.35,397.95L468.05,403.15L468.75,404.35L467.95,405.85L467.55,407.75L461.95,400.85L459.35,398.75L454.95,397.05L451.75,397.55L446.95,399.95L444.05,400.55L440.35,398.85L436.25,397.65L431.45,394.75L427.35,393.85L421.45,390.85L417.15,387.75L416.05,386.05L412.95,385.65L407.55,383.65L405.65,380.75L400.25,377.05L398.05,373.05L397.25,369.85L399.15,369.25L398.85,367.45L400.45,365.75L400.85,363.55L399.35,360.65L399.35,358.15L398.05,354.85L394.25,348.45L389.65,343.45L387.75,339.45L383.65,336.85L382.95,335.25L384.65,331.35L382.25,329.85L379.75,326.65L379.55,322.25L376.75,321.65L374.45,318.35L372.75,315.15L373.05,313.15L371.55,308.35L371.25,303.45L372.05,300.95L368.95,298.35L367.05,298.65L364.65,296.95L362.85,299.55L362.75,302.55L361.75,307.45L362.75,310.05L365.55,314.45L365.95,316.05L366.65,316.45L366.75,318.65L367.75,318.55L367.75,322.75L369.05,324.35L369.55,326.65L372.25,329.85L372.65,335.85L373.65,338.65L374.55,341.65L374.25,345.05L376.85,345.25L378.45,348.15L379.95,351.05L379.65,352.25L376.85,354.55L375.85,354.55L375.15,350.65L372.25,346.95L368.85,343.85L366.35,342.25L367.55,337.55L367.45,334.05L365.35,332.05L362.25,329.25L361.35,330.05L360.35,328.35L357.35,326.85L355.15,323.05L355.65,322.65L357.75,322.95L360.45,320.55L361.45,317.65L358.55,313.05L355.95,311.35L355.15,307.35L354.55,303.05L353.75,297.95L353.55,292.15L359.85,291.65L366.95,290.95L366.05,292.25L373.05,295.35L383.95,299.85L399.05,299.85L399.85,297.15L409.25,297.15L410.55,299.45L412.65,301.55L415.05,304.35L415.85,307.65L416.25,311.25L418.55,313.15L422.55,315.05L427.35,310.05L431.85,309.85L435.05,312.45L436.65,316.85L437.55,320.65L439.95,324.25L440.15,328.75L441.05,331.75L444.95,333.75L448.55,335.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1104.75,235.85L1103.75,236.05L1102.95,237.15L1100.15,237.05L1098.35,238.45L1094.95,238.95L1092.65,237.45L1091.65,234.75L1092.15,232.55L1092.85,232.65L1092.95,231.35L1095.85,230.35L1097.05,230.05L1098.75,229.75L1101.15,229.55L1103.95,231.65L1104.75,235.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ML" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1009.45,378.05L1009.55,392.85L1006.45,397.15L1006.05,401.15L1001.05,402.15L993.35,402.65L991.35,404.95L987.75,405.25L984.15,405.25L982.75,404.05L979.65,404.95L974.35,407.65L973.25,409.65L968.95,412.45L968.15,414.15L965.75,415.45L963.05,414.55L961.55,416.15L960.65,420.55L956.15,425.85L956.35,428.05L954.75,430.75L955.15,434.45L952.75,435.45L951.45,436.25L950.55,433.55L948.95,434.25L947.95,434.15L946.95,435.95L942.55,435.95L941.05,434.95L940.25,435.55L938.55,433.65L938.85,431.75L938.15,431.05L936.95,431.65L937.25,429.55L938.35,427.95L936.05,425.25L935.45,423.45L934.15,422.05L933.05,421.85L931.75,422.75L929.85,423.65L928.35,425.05L925.95,424.55L924.35,422.85L923.45,422.65L921.95,423.55L921.05,423.55L920.75,421.15L921.05,419.15L920.55,416.75L918.55,414.95L917.45,411.25L917.25,407.25L919.15,406.05L920.15,402.25L921.95,402.15L925.85,403.95L929.05,402.65L931.15,403.05L932.05,401.65L954.55,401.55L955.85,397.05L954.85,396.25L952.35,368.55L949.95,340.85L958.45,340.75L977.05,354.75L995.75,368.75L997.05,371.75L1000.55,373.55L1003.15,374.65L1003.25,378.75L1009.45,378.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1547.65,363.45L1543.55,367.65L1542.75,369.95L1539.75,371.45L1536.95,374.25L1533.05,374.55L1531.55,381.45L1529.35,382.65L1532.85,388.25L1536.95,392.95L1539.85,397.25L1538.45,402.75L1536.65,403.95L1538.45,407.15L1542.75,412.25L1543.75,415.85L1543.95,418.85L1546.65,424.75L1544.05,430.75L1541.85,437.35L1540.95,432.55L1542.25,427.65L1540.05,423.85L1539.85,416.85L1537.25,413.45L1534.55,405.85L1532.55,397.75L1529.45,392.35L1526.25,395.65L1520.45,400.15L1517.15,399.65L1513.55,398.15L1514.45,390.15L1512.45,384.15L1507.15,376.75L1507.45,374.45L1504.05,373.55L1499.45,368.35L1498.35,363.15L1500.45,364.15L1499.85,359.55L1502.35,358.05L1501.35,355.35L1502.35,353.15L1501.45,346.45L1506.05,347.95L1507.65,342.65L1507.35,339.55L1509.35,334.15L1508.45,330.45L1514.65,326.05L1518.85,327.15L1517.45,323.25L1519.15,322.05L1518.15,319.65L1521.25,319.15L1523.95,322.95L1526.65,324.45L1527.95,329.35L1528.85,334.65L1524.65,340.05L1525.35,347.65L1530.95,346.55L1533.35,352.45L1537.05,353.75L1536.25,359.05L1540.75,361.45L1543.35,362.65L1547.15,360.75L1547.65,363.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ME" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1089.85,226.45L1089.05,227.85L1087.65,228.45L1087.25,227.25L1085.35,230.35L1085.85,232.45L1084.75,231.95L1083.05,229.85L1080.75,228.55L1081.25,227.55L1081.65,224.05L1083.25,222.55L1084.15,221.95L1085.55,223.05L1086.45,223.95L1088.15,224.65L1090.25,225.95L1089.85,226.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1495.45,180.75L1499.45,179.55L1505.15,178.75L1510.55,179.65L1517.15,182.55L1522.05,185.75L1526.65,185.75L1533.45,186.75L1537.05,185.15L1542.95,184.15L1547.35,179.75L1550.75,180.45L1554.65,182.55L1560.25,181.95L1560.85,186.65L1561.15,192.95L1563.95,195.45L1566.25,194.65L1571.75,195.65L1574.25,193.35L1579.45,195.35L1586.65,199.75L1587.45,201.95L1583.05,201.25L1576.25,202.05L1573.75,203.85L1572.45,208.05L1566.05,210.45L1562.85,213.85L1556.95,212.55L1553.75,211.95L1553.25,216.05L1556.15,218.45L1558.05,220.55L1555.65,222.75L1553.65,226.15L1548.75,228.35L1541.15,228.55L1533.95,230.75L1529.55,234.15L1526.25,232.25L1520.05,232.25L1510.65,228.35L1505.05,227.45L1498.65,228.35L1487.35,226.85L1481.75,227.05L1477.05,223.25L1472.05,217.45L1468.65,216.75L1460.65,212.75L1453.45,211.95L1446.95,210.85L1443.95,208.05L1442.55,200.75L1436.75,195.65L1428.55,193.35L1422.85,190.05L1419.55,185.65L1424.25,184.55L1430.95,179.25L1436.85,176.35L1442.15,178.25L1447.35,178.35L1452.15,181.25L1457.15,181.45L1465.15,183.05L1467.55,178.65L1463.55,175.05L1464.85,168.65L1471.85,171.15L1476.65,171.95L1483.35,173.55L1486.95,178.15L1495.45,180.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1165.95,672.75L1161.85,672.75L1161.55,669.85L1160.95,666.95L1160.55,664.65L1161.95,657.55L1160.85,652.95L1158.65,643.95L1164.85,636.65L1166.55,632.05L1167.35,631.45L1168.25,627.65L1167.45,625.75L1167.85,620.95L1169.15,616.55L1169.55,608.35L1166.75,606.35L1164.05,605.85L1162.95,604.25L1160.35,602.95L1155.65,603.05L1155.45,600.65L1155.05,596.05L1172.25,590.75L1175.45,593.85L1176.95,593.25L1179.15,594.85L1179.35,597.45L1178.05,600.45L1178.25,604.95L1181.75,608.95L1183.65,604.45L1186.15,603.15L1186.05,594.85L1183.85,590.25L1181.95,588.15L1181.55,588.15L1180.95,580.85L1182.45,574.75L1184.65,574.55L1191.35,576.35L1192.85,575.55L1196.75,575.35L1198.85,573.45L1202.25,573.55L1208.45,571.05L1213.05,567.35L1213.95,570.15L1213.45,576.55L1213.95,582.25L1213.75,592.25L1214.55,595.35L1212.65,599.95L1210.25,604.45L1206.55,608.45L1201.25,610.85L1194.75,613.95L1188.15,620.85L1185.95,622.05L1181.75,626.65L1179.45,628.05L1178.65,632.65L1181.05,637.55L1181.95,641.25L1181.95,643.25L1182.95,642.85L1182.45,649.15L1181.35,652.15L1182.55,653.25L1181.55,655.95L1179.15,658.25L1174.45,660.35L1167.55,663.85L1165.05,666.25L1165.35,668.95L1166.65,669.35L1165.95,672.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M958.45,340.75L949.95,340.85L952.35,368.55L954.85,396.25L955.85,397.05L954.55,401.55L932.05,401.65L931.15,403.05L929.05,402.65L925.85,403.95L921.95,402.15L920.15,402.25L919.15,406.05L917.25,407.25L913.65,402.85L910.25,398.05L906.65,396.35L903.95,394.55L900.85,394.55L898.05,395.95L895.35,395.45L893.35,397.45L892.95,394.05L894.55,390.85L895.35,384.85L894.95,378.45L894.35,375.25L894.95,372.05L893.55,369.05L890.75,366.25L892.05,364.15L913.75,364.15L912.85,354.85L914.35,351.55L919.55,351.05L919.75,334.55L937.75,334.95L937.95,325.15L958.45,340.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1181.55,588.15L1181.95,588.15L1183.85,590.25L1186.05,594.85L1186.15,603.15L1183.65,604.45L1181.75,608.95L1178.25,604.95L1178.05,600.45L1179.35,597.45L1179.15,594.85L1176.95,593.25L1175.45,593.85L1172.25,590.75L1169.35,589.15L1171.35,583.15L1173.15,580.95L1172.25,575.55L1173.55,570.35L1174.55,568.65L1173.25,563.25L1170.65,560.35L1176.15,561.55L1177.15,563.25L1177.05,564.05L1178.85,568.15L1179.05,575.85L1177.25,579.45L1178.85,584.15L1178.65,586.95L1179.85,588.85L1179.75,591.25L1180.65,592.65L1181.65,591.05L1183.55,593.55L1183.75,592.75L1182.75,589.35L1181.65,589.05L1181.55,588.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1563.55,461.15L1564.95,461.75L1568.45,465.65L1570.95,469.95L1571.55,474.25L1571.05,477.15L1571.65,479.35L1572.15,483.15L1574.25,484.95L1576.55,490.65L1576.55,492.75L1572.55,493.25L1567.05,488.45L1560.25,483.35L1559.45,480.05L1556.05,475.75L1555.05,470.45L1552.85,466.95L1553.25,462.25L1551.85,459.55L1552.75,458.45L1557.55,461.25L1558.15,464.55L1561.85,463.75L1563.55,461.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1653.35,474.55L1648.35,473.45L1641.85,473.45L1640.15,480.75L1638.05,482.95L1635.45,491.85L1630.85,493.25L1625.45,491.45L1622.75,492.05L1619.45,495.25L1615.85,494.85L1612.15,496.15L1608.25,492.45L1607.25,488.15L1611.45,490.35L1615.75,489.15L1616.75,483.75L1619.15,482.55L1625.95,481.15L1629.75,476.05L1632.35,472.05L1635.15,475.35L1636.25,473.15L1638.95,473.35L1639.05,469.25L1639.15,466.05L1643.25,461.65L1645.85,456.65L1648.15,456.55L1651.25,459.85L1651.65,462.65L1655.45,464.45L1660.25,466.35L1660.05,468.85L1656.25,469.15L1657.35,472.35L1653.35,474.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1115.45,613.55L1120.05,612.15L1123.65,612.45L1125.85,613.95L1125.85,614.45L1122.65,615.95L1120.95,615.95L1117.25,618.45L1115.25,615.75L1106.55,618.05L1102.35,618.25L1101.55,641.15L1096.05,641.35L1095.45,660.05L1094.35,683.75L1089.35,687.05L1086.45,687.55L1083.05,686.35L1080.55,685.85L1079.75,683.15L1077.75,681.35L1074.95,684.55L1071.05,679.65L1069.05,675.05L1068.05,668.75L1066.85,664.15L1065.25,654.25L1065.35,646.55L1064.75,643.05L1062.65,640.35L1059.85,635.05L1057.05,627.35L1055.95,623.35L1051.55,617.05L1051.25,612.15L1053.95,610.95L1057.35,609.85L1060.95,610.05L1064.25,612.95L1065.05,612.45L1087.75,612.25L1091.55,615.25L1105.05,616.15L1115.45,613.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1067.85,354.25L1069.45,364.25L1071.65,365.95L1071.75,367.95L1074.15,370.15L1072.95,372.95L1071.15,385.95L1070.95,394.35L1063.95,400.35L1061.65,408.85L1064.05,411.25L1064.05,415.35L1067.75,415.45L1067.15,418.55L1065.65,418.85L1065.45,420.95L1064.45,421.05L1060.55,414.05L1059.15,413.75L1054.85,417.35L1050.45,415.45L1047.45,415.15L1045.85,416.05L1042.55,415.85L1039.25,418.55L1036.35,418.75L1029.55,415.45L1026.85,416.95L1023.95,416.85L1021.85,414.45L1016.25,412.05L1010.15,412.85L1008.75,414.15L1007.95,417.85L1006.35,420.45L1005.95,426.25L1001.65,422.55L999.65,422.55L997.75,424.45L997.85,420.05L991.35,418.55L991.15,415.45L988.05,411.25L987.25,408.35L987.75,405.25L991.35,404.95L993.35,402.65L1001.05,402.15L1006.05,401.15L1006.45,397.15L1009.55,392.85L1009.45,378.05L1017.25,375.25L1033.25,362.65L1052.05,350.35L1060.85,353.15L1064.05,356.65L1067.85,354.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1065.45,420.95L1067.75,423.45L1067.15,424.65L1066.85,426.75L1062.15,431.75L1060.75,435.85L1059.95,439.15L1058.75,440.65L1057.65,445.15L1054.65,447.75L1053.85,450.95L1052.55,453.55L1052.05,456.25L1048.15,458.45L1044.95,455.75L1042.85,455.85L1039.45,459.65L1037.85,459.65L1035.15,465.85L1033.75,470.45L1027.85,472.75L1025.75,472.45L1023.55,473.85L1019.05,473.75L1015.95,469.65L1014.05,465.05L1010.05,460.85L1000.85,460.85L1001.15,450.55L1000.95,446.45L1002.05,442.45L1003.75,440.45L1006.55,436.45L1005.95,434.75L1007.05,432.15L1005.75,428.35L1005.95,426.25L1006.35,420.45L1007.95,417.85L1008.75,414.15L1010.15,412.85L1016.25,412.05L1021.85,414.45L1023.95,416.85L1026.85,416.95L1029.55,415.45L1036.35,418.75L1039.25,418.55L1042.55,415.85L1045.85,416.05L1047.45,415.15L1050.45,415.45L1054.85,417.35L1059.15,413.75L1060.55,414.05L1064.45,421.05L1065.45,420.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M518.85,404.75L518.35,405.45L517.85,406.85L518.25,409.15L516.75,411.35L515.95,413.95L515.45,416.75L515.65,418.45L515.55,421.35L514.65,421.95L513.95,424.75L514.15,426.45L512.95,428.05L513.05,429.75L513.85,430.85L512.45,432.25L510.75,431.75L509.95,430.45L508.15,429.95L506.85,430.75L503.25,429.05L502.35,429.85L500.55,427.85L498.05,425.25L496.95,423.15L494.75,421.05L492.25,418.15L492.95,417.15L493.75,418.15L494.25,417.75L496.05,417.45L496.85,415.95L497.65,415.95L497.85,412.75L499.15,412.65L500.35,412.65L501.75,410.95L503.25,412.25L503.85,411.45L505.05,410.65L507.15,408.95L507.35,407.55L507.85,407.65L508.75,406.15L509.35,405.95L510.25,406.95L511.35,407.15L512.65,406.35L514.05,406.35L516.05,405.55L516.95,404.65L518.85,404.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1112.95,66.75L1106.55,68.85L1103.35,69.35L1104.15,65.55L1098.35,63.45L1092.45,65.25L1091.35,69.25L1087.95,71.65L1083.25,70.35L1077.95,70.55L1072.85,67.75L1070.65,69.15L1068.05,69.35L1068.15,72.95L1060.15,72.05L1059.55,75.15L1055.55,75.15L1053.25,79.05L1049.85,85.15L1044.15,93.05L1045.95,95.05L1044.65,97.25L1040.35,97.15L1037.95,102.55L1038.95,110.25L1042.05,113.15L1041.25,120.05L1037.85,124.05L1036.05,127.45L1032.75,123.85L1024.15,130.65L1018.05,132.05L1011.55,129.05L1009.75,122.75L1007.75,109.25L1011.75,105.55L1023.05,100.65L1031.15,94.75L1038.35,86.95L1047.25,76.25L1053.65,72.15L1063.95,65.35L1072.45,62.95L1079.15,63.25L1084.35,58.85L1091.75,59.05L1098.75,58.05L1112.45,61.95L1107.55,63.35L1112.95,66.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1075.85,24.45L1068.25,26.35L1061.45,25.25L1063.65,24.05L1061.05,22.55L1068.35,21.65L1070.25,23.35L1075.85,24.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1050.25,15.95L1062.85,19.35L1054.25,21.15L1053.05,24.55L1050.05,25.45L1049.15,29.45L1044.75,29.65L1036.25,26.75L1039.25,25.05L1033.55,23.65L1025.85,19.75L1022.65,16.25L1031.95,14.65L1034.25,16.15L1039.25,16.15L1040.25,14.65L1045.45,14.45L1050.25,15.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1074.65,12.95L1082.05,14.45L1077.65,16.85L1067.55,17.35L1056.85,16.55L1055.85,15.35L1050.75,15.35L1046.45,13.35L1056.95,12.15L1062.35,13.15L1065.45,11.85L1074.65,12.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NP" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1468.25,322.15L1468.45,324.85L1469.95,328.95L1469.85,331.45L1465.25,331.55L1458.35,330.05L1454.05,329.45L1450.25,326.25L1442.55,325.35L1434.75,321.75L1428.95,318.65L1423.15,316.25L1424.05,310.25L1426.85,307.25L1428.75,305.75L1433.55,307.75L1439.95,311.95L1443.25,312.85L1445.75,315.95L1450.25,317.15L1455.25,320.05L1461.75,321.45L1468.25,322.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1283.05,394.15L1280.85,389.65L1275.65,379.05L1291.95,372.65L1294.55,359.85L1291.55,355.25L1291.55,352.65L1292.85,350.05L1292.65,347.45L1295.05,346.15L1293.95,345.25L1293.95,341.05L1296.75,341.05L1299.75,345.45L1303.05,347.75L1307.15,348.65L1310.55,349.75L1313.45,353.45L1315.15,355.55L1317.15,356.45L1317.35,357.85L1315.65,361.65L1314.95,363.45L1312.75,365.55L1311.05,369.95L1308.55,369.55L1307.55,371.15L1306.85,374.35L1307.95,378.65L1307.45,379.45L1304.95,379.45L1301.65,381.85L1301.35,384.95L1300.15,386.35L1296.65,386.25L1294.65,387.85L1294.85,390.45L1292.25,392.25L1289.15,391.65L1285.55,393.85L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1295.45,335.95L1294.15,333.75L1295.55,331.65L1296.25,332.15L1296.05,334.85L1295.45,335.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1400.85,273.15L1397.05,278.55L1391.35,279.55L1382.85,277.95L1380.85,280.75L1384.15,286.35L1387.05,290.75L1392.15,293.85L1388.35,297.55L1389.35,302.15L1385.45,308.65L1383.25,315.15L1378.75,321.85L1372.25,321.35L1367.35,328.15L1371.35,330.95L1372.75,335.95L1376.25,339.15L1378.05,344.65L1365.95,344.65L1362.75,348.95L1358.55,347.35L1356.35,342.75L1351.45,337.85L1341.45,339.05L1332.45,339.15L1324.85,340.05L1325.95,332.65L1333.45,329.25L1332.55,326.35L1329.85,325.25L1328.85,319.65L1323.15,316.85L1320.35,312.95L1317.15,309.55L1326.75,312.85L1332.05,311.85L1335.45,312.65L1336.35,311.25L1340.25,311.85L1346.85,309.15L1346.05,303.75L1348.35,300.05L1352.45,300.05L1352.65,298.35L1356.65,297.45L1358.75,298.05L1360.55,296.25L1359.45,292.35L1360.85,288.55L1363.95,286.85L1360.85,282.65L1366.05,282.85L1366.95,280.55L1366.15,278.05L1368.15,275.35L1366.75,272.15L1364.85,269.45L1367.25,266.65L1372.55,265.35L1378.45,264.55L1380.85,263.45L1383.75,262.65L1388.45,265.65L1391.35,270.65L1400.85,273.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M548.55,445.45L547.85,446.35L548.95,450.15L547.85,452.05L546.05,451.55L545.15,454.65L543.35,452.85L542.35,449.35L543.75,447.65L542.35,447.25L541.45,445.15L538.65,443.35L536.25,443.75L534.95,445.95L532.55,447.55L531.35,447.75L530.75,449.15L533.25,452.65L531.65,453.45L530.85,454.35L528.15,454.75L527.35,450.85L526.55,451.95L524.75,451.55L523.75,449.05L521.45,448.55L519.95,447.85L517.55,447.85L517.35,449.25L516.75,448.25L517.05,446.95L517.65,445.65L517.45,444.55L518.35,443.75L517.25,442.85L517.35,440.25L519.55,439.65L521.45,441.95L521.25,443.35L523.45,443.65L524.05,443.05L525.55,444.65L528.35,444.15L530.85,442.55L534.35,441.25L536.35,439.35L539.45,439.75L539.25,440.35L542.35,440.55L544.75,441.75L546.55,443.65L548.55,445.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M589.75,528.65L584.65,528.35L583.85,529.35L579.25,530.55L572.95,534.95L572.65,537.95L571.25,540.15L571.95,543.65L568.55,545.45L568.75,548.25L567.25,549.35L569.85,555.15L573.15,559.05L572.15,561.85L575.95,562.15L578.25,565.65L583.25,565.75L587.65,562.05L587.75,571.75L590.35,572.45L593.55,571.35L599.05,581.75L597.95,583.85L597.95,588.45L598.25,593.85L596.35,597.05L597.55,599.45L596.45,601.65L599.35,607.05L596.45,613.95L595.35,617.25L592.55,618.85L586.65,615.15L585.85,612.55L574.15,606.15L563.45,599.05L558.75,595.15L555.95,589.85L556.75,587.95L551.35,579.55L544.95,567.75L538.95,554.95L536.55,551.95L534.55,547.25L529.95,543.05L525.85,540.45L527.55,537.65L524.55,531.45L526.25,526.95L530.65,522.95L531.35,525.65L529.75,527.15L530.05,529.45L532.35,528.95L534.65,529.65L537.15,532.95L540.25,530.25L541.15,525.95L544.55,520.35L551.25,517.85L557.35,511.05L559.05,506.95L558.25,502.05L559.75,501.45L563.55,504.45L565.35,507.55L567.95,509.15L571.45,515.85L575.65,516.75L578.75,515.05L580.85,516.15L584.25,515.55L588.65,518.55L585.15,525.15L586.85,525.25L589.75,528.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1699.75,447.05L1700.65,451.35L1701.25,454.95L1699.65,460.75L1697.15,454.25L1694.75,457.55L1696.85,462.25L1695.45,465.25L1688.55,461.55L1686.65,456.85L1688.15,453.85L1684.35,450.75L1682.75,453.45L1680.15,453.15L1676.15,456.75L1675.15,454.85L1676.95,449.45L1680.35,447.65L1683.25,445.25L1685.45,448.15L1689.65,446.45L1690.35,443.55L1694.35,443.35L1693.55,438.45L1698.45,441.45L1699.15,444.65L1699.75,447.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1685.15,435.05L1683.35,437.15L1681.95,441.25L1680.35,443.15L1676.45,438.75L1677.45,436.95L1678.75,435.15L1678.95,431.25L1682.05,430.85L1681.55,435.15L1685.15,428.95L1685.15,435.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1654.85,441.25L1647.75,447.35L1650.15,442.85L1653.95,438.85L1656.95,434.45L1659.25,428.05L1660.85,433.35L1657.35,436.85L1654.85,441.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1672.35,424.75L1675.95,426.75L1679.45,426.75L1679.65,429.35L1677.35,432.15L1673.95,434.05L1673.45,431.05L1673.55,427.75L1672.35,424.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1692.45,422.95L1694.85,430.15L1690.35,428.45L1690.65,430.65L1692.45,434.55L1689.85,436.05L1689.25,431.45L1687.45,431.15L1686.25,427.25L1689.55,427.75L1689.25,425.35L1685.25,420.45L1690.65,420.55L1692.45,422.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1669.45,417.15L1668.55,422.75L1665.85,419.55L1662.35,414.65L1667.15,414.85L1669.45,417.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1662.95,382.25L1666.75,384.15L1668.15,382.45L1668.95,384.05L1668.55,386.75L1671.15,391.35L1670.55,396.65L1667.65,398.75L1667.55,403.95L1669.55,409.05L1672.55,409.75L1674.95,409.05L1682.45,412.55L1682.35,416.05L1684.45,417.65L1684.15,420.55L1679.45,417.45L1676.95,414.05L1675.75,416.45L1671.75,412.55L1666.75,413.55L1663.75,412.15L1663.65,409.45L1665.25,407.85L1663.35,406.35L1662.95,408.65L1659.65,404.95L1658.35,402.15L1657.25,396.05L1659.85,398.15L1658.75,388.05L1659.55,382.25L1662.95,382.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1867.35,544.85L1865.75,545.55L1863.45,543.05L1861.25,538.95L1860.45,534.05L1861.25,533.45L1861.75,535.35L1863.35,536.85L1865.75,540.85L1868.25,543.05L1867.35,544.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1845.95,536.25L1842.95,536.75L1841.95,538.55L1835.75,541.65L1832.65,541.65L1828.15,539.75L1825.05,537.95L1825.65,535.95L1830.65,536.95L1833.85,536.45L1834.85,533.35L1835.75,533.15L1836.05,536.55L1839.25,536.15L1841.05,533.95L1844.35,531.65L1843.95,527.85L1847.35,527.75L1848.45,528.75L1848.05,532.35L1845.95,536.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1782.15,559.65L1783.75,538.65L1784.75,517.75L1794.35,522.15L1804.65,525.85L1808.35,529.15L1811.35,532.35L1811.95,536.15L1821.15,540.15L1822.25,543.55L1817.05,544.25L1817.95,548.55L1822.65,552.75L1825.65,559.55L1828.95,559.35L1828.35,562.15L1832.65,563.25L1830.85,564.45L1836.55,567.15L1835.65,569.05L1831.85,569.45L1830.65,567.85L1825.95,567.05L1820.35,566.15L1816.35,562.05L1813.55,558.45L1811.05,552.85L1803.95,550.05L1799.05,551.85L1795.35,554.05L1795.65,558.75L1791.05,560.95L1787.95,559.85L1782.15,559.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1852.85,529.95L1851.05,531.65L1850.15,527.85L1849.05,525.45L1846.55,523.35L1843.45,520.55L1839.45,518.65L1841.05,517.15L1844.05,518.95L1845.95,520.35L1848.25,521.85L1850.35,524.55L1852.45,526.65L1852.85,529.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1079.15,154.05L1085.05,154.75L1093.85,154.65L1096.35,155.35L1097.75,157.25L1098.35,159.95L1100.05,162.25L1100.45,164.65L1097.65,165.95L1099.55,168.75L1100.05,171.55L1103.25,176.95L1102.95,178.65L1100.65,179.35L1096.85,184.55L1098.45,187.35L1097.35,186.95L1092.35,184.55L1088.85,185.45L1086.45,184.85L1083.65,186.15L1080.95,183.95L1079.05,184.85L1078.75,184.45L1076.15,181.35L1072.45,181.05L1071.75,179.05L1068.35,178.35L1067.75,179.95L1064.95,178.65L1065.15,176.95L1061.45,176.45L1058.95,174.45L1056.55,170.55L1056.75,168.35L1055.25,165.05L1053.35,162.95L1054.55,161.25L1053.15,158.15L1056.25,156.35L1063.35,153.55L1069.15,151.55L1073.95,152.55L1074.55,154.05L1079.15,154.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KP" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1659.55,229.15L1660.95,230.25L1658.75,229.85L1657.75,232.05L1657.45,234.15L1660.25,238.75L1658.35,240.15L1658.05,241.25L1657.15,243.15L1654.25,244.25L1652.85,245.95L1654.15,248.65L1653.85,249.35L1656.45,250.45L1660.85,253.25L1660.85,254.75L1658.85,255.15L1655.25,255.55L1654.65,258.35L1652.15,258.15L1652.15,258.75L1648.95,257.55L1648.85,258.75L1647.55,259.25L1646.85,258.05L1645.15,257.45L1643.25,256.45L1643.35,253.65L1644.25,252.85L1643.25,251.75L1642.85,248.25L1641.95,247.25L1638.55,246.55L1635.15,244.85L1637.25,240.75L1641.15,237.35L1642.25,232.75L1645.85,234.75L1650.45,235.05L1647.65,231.65L1654.05,228.95L1654.05,225.35L1659.55,229.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M661.75,630.65L663.75,634.15L664.15,642.85L670.05,644.15L672.25,642.85L676.15,644.65L677.35,646.55L678.45,652.45L679.25,654.85L681.35,655.15L683.35,654.15L685.45,655.25L685.75,658.85L685.45,662.65L684.75,666.35L684.45,671.95L680.15,676.95L675.95,677.95L669.65,676.95L663.85,675.25L668.05,665.45L666.95,662.65L661.05,660.15L653.75,655.35L649.15,654.35L637.85,643.95L639.35,636.25L639.15,632.75L641.25,627.15L650.85,625.25L656.05,625.35L661.45,628.65L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1177.55,293.05L1177.95,297.05L1177.35,298.95L1174.85,299.75L1174.95,298.05L1176.25,297.15L1174.75,296.45L1175.45,292.25L1177.55,293.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="QA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1269.35,342.95L1267.85,343.45L1266.05,342.15L1265.25,337.45L1266.35,334.15L1267.85,333.45L1269.65,335.45L1270.15,339.15L1269.35,342.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1118.15,192.35L1119.75,193.05L1121.55,194.85L1123.55,197.45L1126.95,201.25L1127.55,203.95L1127.35,206.65L1128.65,209.55L1131.05,210.75L1133.35,209.65L1135.75,210.75L1136.15,212.45L1133.85,213.75L1132.25,213.15L1131.85,220.85L1128.75,220.15L1124.75,217.85L1118.85,219.35L1116.55,220.95L1108.95,220.55L1104.95,219.65L1103.05,220.05L1101.25,217.45L1100.25,216.35L1101.25,215.25L1099.95,214.55L1098.45,215.95L1095.35,214.05L1094.65,211.45L1091.45,210.05L1090.65,207.95L1087.65,205.55L1091.55,204.35L1094.15,200.05L1096.05,195.85L1098.95,194.55L1100.95,193.15L1104.15,193.85L1107.35,193.85L1109.85,195.45L1111.45,194.45L1115.05,193.85L1116.05,192.35L1118.15,192.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1158.05,508.35L1160.25,511.95L1159.95,515.75L1158.35,516.55L1155.25,516.15L1153.55,519.85L1150.05,519.35L1150.65,515.75L1151.45,515.25L1151.65,511.45L1153.25,509.65L1154.65,510.35L1158.05,508.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M938.15,323.55L938.05,323.95L937.95,325.15L937.75,334.95L919.75,334.55L919.55,351.05L914.35,351.55L912.85,354.85L913.75,364.15L892.05,364.15L890.75,366.25L891.05,363.55L891.15,363.55L903.65,363.05L904.35,360.75L906.75,357.85L908.75,348.95L916.65,342.05L919.35,333.95L921.15,333.45L923.05,328.45L927.65,327.75L929.65,328.65L932.15,328.65L933.95,327.15L937.35,326.95L937.25,323.55L938.15,323.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1239.75,314.25L1244.75,314.85L1246.45,317.95L1250.35,317.75L1253.05,323.35L1255.95,324.75L1257.15,327.05L1261.15,329.75L1261.85,332.35L1261.45,334.55L1262.35,336.65L1264.15,338.45L1265.05,340.55L1266.05,342.15L1267.85,343.45L1269.35,342.95L1270.65,345.45L1270.95,346.85L1273.65,353.45L1290.55,356.65L1291.55,355.25L1294.55,359.85L1291.95,372.65L1275.65,379.05L1259.75,381.55L1254.75,384.45L1251.25,391.15L1248.65,392.25L1247.15,390.15L1245.05,390.45L1239.55,389.75L1238.45,389.15L1232.05,389.25L1230.55,389.85L1228.15,388.25L1226.85,391.35L1227.65,394.05L1225.25,396.15L1224.35,393.35L1222.55,391.45L1222.05,388.85L1218.95,386.55L1215.65,381.15L1213.75,375.95L1209.65,371.55L1207.15,370.45L1203.05,364.35L1202.15,359.95L1202.15,356.15L1198.55,348.95L1195.75,346.45L1192.75,345.15L1190.65,341.45L1190.85,340.05L1189.05,336.65L1187.35,335.25L1184.85,330.45L1181.05,325.35L1177.95,320.95L1175.25,320.95L1175.75,317.45L1175.85,315.15L1176.25,312.55L1182.45,313.65L1184.55,311.65L1185.65,309.35L1189.75,308.45L1190.45,306.25L1192.05,305.25L1186.05,298.75L1196.45,295.55L1197.35,294.55L1204.15,296.35L1212.75,300.85L1229.55,313.75L1239.75,314.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1190.25,408.45L1189.55,413.95L1187.55,420.35L1184.25,423.45L1181.95,428.45L1181.45,431.05L1178.85,432.85L1177.35,439.55L1177.35,440.35L1176.55,440.15L1176.65,436.95L1175.85,434.75L1172.95,432.25L1172.05,427.65L1172.65,422.85L1170.05,422.45L1169.65,423.85L1166.25,424.25L1167.75,426.05L1168.25,429.95L1165.25,433.45L1162.55,438.05L1159.65,438.75L1154.85,435.05L1152.75,436.35L1152.25,438.15L1149.35,439.45L1149.15,440.75L1143.55,440.75L1142.75,439.45L1138.65,439.15L1136.65,440.25L1135.05,439.75L1132.15,435.95L1131.15,434.25L1127.05,435.15L1125.55,438.05L1124.25,443.85L1122.25,445.05L1120.55,445.75L1120.05,445.45L1118.15,443.55L1117.75,441.55L1118.55,438.95L1118.55,436.25L1115.25,432.25L1114.55,429.55L1114.55,427.95L1112.45,426.05L1112.35,422.35L1111.05,419.85L1109.15,420.25L1109.65,417.85L1111.05,415.25L1110.35,412.55L1112.15,410.55L1110.95,409.05L1112.25,405.15L1114.75,400.35L1119.55,400.85L1118.45,375.35L1118.45,372.65L1124.85,372.65L1124.35,359.85L1190.25,359.85L1192.35,366.15L1191.15,367.25L1192.35,373.95L1194.85,381.55L1197.05,383.15L1200.25,385.55L1197.55,389.15L1193.55,390.25L1191.85,392.25L1191.55,396.45L1189.55,405.95L1190.25,408.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1177.35,440.35L1177.55,445.35L1176.75,447.25L1173.75,447.45L1171.85,451.05L1175.35,451.55L1178.35,454.65L1179.35,457.25L1181.95,458.75L1185.45,465.75L1181.65,469.95L1178.25,473.75L1174.75,476.75L1170.75,476.75L1166.25,478.25L1162.65,476.75L1160.35,478.55L1155.25,474.25L1153.85,471.55L1150.75,472.85L1148.15,472.45L1146.65,473.55L1144.05,472.75L1140.55,467.45L1139.65,465.45L1135.35,462.85L1133.95,459.05L1131.55,456.25L1127.65,452.95L1127.55,450.85L1124.45,448.25L1120.55,445.75L1122.25,445.05L1124.25,443.85L1125.55,438.05L1127.05,435.15L1131.15,434.25L1132.15,435.95L1135.05,439.75L1136.65,440.25L1138.65,439.15L1142.75,439.45L1143.55,440.75L1149.15,440.75L1149.35,439.45L1152.25,438.15L1152.75,436.35L1154.85,435.05L1159.65,438.75L1162.55,438.05L1165.25,433.45L1168.25,429.95L1167.75,426.05L1166.25,424.25L1169.65,423.85L1170.05,422.45L1172.65,422.85L1172.05,427.65L1172.95,432.25L1175.85,434.75L1176.65,436.95L1176.55,440.15L1177.35,440.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M917.25,407.25L917.45,411.25L918.55,414.95L920.55,416.75L921.05,419.15L920.75,421.15L919.95,421.55L916.85,421.05L916.45,421.75L915.25,421.85L911.15,420.35L908.45,420.25L898.05,419.95L896.55,420.75L894.65,420.55L891.65,421.55L890.85,416.65L895.95,416.75L897.35,415.85L898.35,415.85L900.45,414.35L902.85,415.65L905.25,415.85L907.75,414.35L906.65,412.55L904.75,413.55L903.05,413.55L900.85,411.95L899.05,412.05L897.75,413.65L891.65,413.75L889.35,408.75L886.65,406.55L889.15,405.25L891.95,400.75L893.35,397.45L895.35,395.45L898.05,395.95L900.85,394.55L903.95,394.55L906.65,396.35L910.25,398.05L913.65,402.85L917.25,407.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M927.75,447.15L925.15,450.15L922.55,453.55L922.25,455.45L920.85,457.55L919.35,457.05L915.35,454.45L912.35,451.05L911.45,448.65L910.75,443.95L913.85,441.05L914.45,439.35L915.45,437.95L917.05,437.75L918.35,436.55L922.85,436.55L924.45,438.85L925.65,441.55L925.45,443.45L926.35,445.15L926.25,447.45L927.75,447.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M491.75,415.15L491.05,416.65L487.75,416.55L485.75,415.95L483.55,414.65L480.55,414.25L479.05,412.85L479.35,411.95L481.35,410.35L482.55,409.65L482.25,408.85L483.65,408.45L485.25,409.05L486.35,410.25L487.95,411.35L488.05,412.15L490.55,411.45L491.75,411.85L492.45,412.55L491.75,415.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1101.25,217.45L1100.15,218.85L1100.85,221.25L1103.65,223.95L1101.85,225.95L1101.25,227.95L1101.85,228.75L1101.15,229.55L1098.75,229.75L1097.05,230.05L1096.75,229.55L1097.35,228.85L1097.75,227.25L1097.05,227.35L1095.95,226.15L1095.05,225.85L1094.25,224.85L1093.25,224.45L1092.45,223.55L1091.55,223.95L1091.05,226.05L1089.85,226.45L1090.25,225.95L1088.15,224.65L1086.45,223.95L1085.55,223.05L1084.15,221.95L1085.25,221.65L1085.75,218.75L1083.05,216.25L1084.15,213.45L1082.25,213.55L1083.95,211.15L1082.25,209.35L1080.75,206.85L1084.45,205.25L1087.65,205.55L1090.65,207.95L1091.45,210.05L1094.65,211.45L1095.35,214.05L1098.45,215.95L1099.95,214.55L1101.25,215.25L1100.25,216.35L1101.25,217.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M680.25,464.15L677.15,469.65L677.45,474.05L679.65,477.85L678.55,480.55L678.05,483.55L676.55,486.25L673.35,484.85L670.65,485.55L668.35,484.95L667.75,486.85L668.75,488.05L668.15,489.45L665.05,488.85L661.75,483.25L661.05,479.65L659.25,479.65L656.85,475.05L657.95,471.65L657.65,470.15L661.15,468.55L662.15,462.75L668.95,464.05L669.55,462.85L674.15,462.35L680.25,464.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1097.35,186.95L1096.15,188.65L1095.45,191.15L1094.45,191.75L1088.95,189.85L1087.35,190.25L1086.35,191.75L1084.05,192.55L1083.45,192.15L1081.15,193.05L1079.25,193.25L1078.95,194.55L1074.85,195.25L1072.95,194.65L1070.25,192.95L1069.55,190.85L1069.85,190.05L1070.45,188.65L1072.65,188.75L1074.25,188.15L1074.35,187.55L1075.25,187.25L1075.45,185.85L1076.55,185.55L1077.25,184.45L1078.75,184.45L1079.05,184.85L1080.95,183.95L1083.65,186.15L1086.45,184.85L1088.85,185.45L1092.35,184.55L1097.35,186.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1069.05,203.15L1065.15,204.85L1064.85,207.35L1063.15,208.05L1063.25,209.75L1061.25,209.65L1059.45,208.65L1058.65,209.65L1055.05,209.45L1056.15,208.95L1054.75,206.25L1055.15,203.15L1059.35,203.65L1061.75,202.15L1066.15,202.05L1067.05,200.95L1067.85,201.05L1069.05,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1087.45,86.25L1080.45,87.85L1076.95,91.75L1078.25,95.25L1072.05,99.75L1064.25,104.75L1062.15,112.85L1065.85,116.95L1070.65,120.25L1067.35,126.85L1062.75,128.25L1062.15,138.25L1060.05,143.95L1054.35,143.35L1052.15,148.15L1046.65,148.45L1044.75,142.75L1040.25,135.85L1036.05,127.45L1037.85,124.05L1041.25,120.05L1042.05,113.15L1038.95,110.25L1037.95,102.55L1040.35,97.15L1044.65,97.25L1045.95,95.05L1044.15,93.05L1049.85,85.15L1053.25,79.05L1055.55,75.15L1059.55,75.15L1060.15,72.05L1068.15,72.95L1068.05,69.35L1070.65,69.15L1076.65,71.85L1083.85,75.55L1085.65,84.05L1087.45,86.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1160.95,666.95L1161.55,669.85L1161.85,672.75L1160.45,675.55L1157.25,676.25L1154.15,672.75L1154.25,670.55L1155.95,668.15L1156.55,666.25L1158.25,665.85L1160.95,666.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1194.25,286.75L1184.55,293.65L1178.25,291.05L1178.15,291.05L1178.75,290.05L1178.35,287.45L1179.25,283.95L1181.95,281.45L1180.75,278.95L1178.25,278.65L1177.15,273.75L1178.15,271.05L1179.45,269.65L1180.65,268.25L1180.45,264.75L1182.35,265.95L1187.95,264.15L1190.95,265.35L1195.35,265.35L1201.05,262.95L1203.95,263.05L1209.85,262.05L1207.75,266.05L1205.05,267.65L1206.25,272.35L1205.25,280.05L1194.25,286.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1118.45,375.35L1119.55,400.85L1114.75,400.35L1112.25,405.15L1110.95,409.05L1112.15,410.55L1110.35,412.55L1111.05,415.25L1109.65,417.85L1109.15,420.25L1111.05,419.85L1112.35,422.35L1112.45,426.05L1114.55,427.95L1114.55,429.55L1110.95,430.65L1108.15,433.25L1104.15,440.25L1098.95,443.25L1093.45,442.85L1091.85,443.45L1092.45,445.65L1089.55,447.95L1087.15,450.45L1080.05,452.85L1078.65,451.45L1077.65,451.25L1076.65,452.95L1072.05,453.45L1072.85,451.65L1071.05,447.25L1070.25,444.65L1067.75,443.55L1064.35,439.75L1065.55,436.75L1068.15,437.35L1069.75,436.95L1072.95,436.95L1069.75,431.15L1069.95,426.85L1069.45,422.65L1067.15,418.55L1067.75,415.45L1064.05,415.35L1064.05,411.25L1061.65,408.85L1063.95,400.35L1070.95,394.35L1071.15,385.95L1072.95,372.95L1074.15,370.15L1071.75,367.95L1071.65,365.95L1069.45,364.25L1067.85,354.25L1073.35,350.75L1095.85,363.05L1118.45,375.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M990.65,430.45L989.95,433.85L991.65,435.75L993.65,437.95L993.85,441.15L995.05,442.45L994.75,457.25L996.15,461.65L991.65,463.05L990.35,460.75L988.85,456.65L988.35,453.45L989.65,447.75L988.25,445.35L987.65,440.35L987.65,435.65L985.35,432.35L985.75,430.35L990.65,430.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1576.75,409.45L1571.45,408.55L1564.35,409.75L1561.25,415.05L1563.35,422.85L1558.05,419.85L1553.25,420.05L1553.55,414.95L1548.65,414.95L1548.85,422.05L1546.65,431.45L1545.25,437.15L1545.95,441.75L1549.65,441.95L1552.35,447.85L1553.65,453.35L1557.05,457.05L1560.45,457.75L1563.55,461.15L1561.85,463.75L1558.15,464.55L1557.55,461.25L1552.75,458.45L1551.85,459.55L1549.55,457.15L1548.35,453.95L1545.15,450.35L1542.25,447.25L1541.55,451.05L1540.25,447.45L1540.65,443.45L1541.85,437.35L1544.05,430.75L1546.65,424.75L1543.95,418.85L1543.75,415.85L1542.75,412.25L1538.45,407.15L1536.65,403.95L1538.45,402.75L1539.85,397.25L1536.95,392.95L1532.85,388.25L1529.35,382.65L1531.55,381.45L1533.05,374.55L1536.95,374.25L1539.75,371.45L1542.75,369.95L1545.45,371.95L1546.35,375.85L1550.15,376.15L1549.75,382.85L1550.75,388.65L1556.05,384.85L1557.95,385.95L1561.15,385.75L1561.95,383.55L1566.25,383.95L1571.25,389.15L1572.55,395.55L1577.85,401.15L1578.25,406.55L1576.75,409.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TJ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1356.25,242.85L1354.85,244.75L1348.85,243.75L1349.45,247.35L1354.95,246.85L1362.05,248.95L1371.65,247.95L1374.75,253.95L1376.25,253.25L1379.95,254.75L1380.45,257.25L1382.25,260.85L1376.85,260.85L1373.05,260.35L1370.55,263.25L1368.35,263.85L1366.85,265.25L1364.15,263.15L1363.25,257.75L1361.55,257.45L1361.65,255.45L1358.35,254.05L1356.65,256.25L1356.85,258.85L1356.25,259.75L1353.05,259.65L1352.15,262.55L1350.05,261.35L1346.65,263.35L1344.85,262.65L1346.15,256.15L1343.75,251.35L1339.55,249.85L1340.15,247.05L1344.55,247.35L1346.05,243.85L1346.55,239.75L1353.05,238.25L1352.85,241.25L1354.15,242.95L1356.25,242.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1337.55,261.25L1335.95,261.05L1333.05,259.35L1332.75,261.55L1328.55,262.85L1328.75,267.95L1326.15,269.95L1322.15,270.85L1321.75,273.75L1317.85,274.65L1311.95,272.15L1310.25,266.85L1306.25,266.55L1298.95,260.95L1294.65,260.25L1288.05,256.95L1284.15,256.35L1282.15,257.55L1278.55,257.35L1275.55,261.05L1271.15,262.25L1269.25,257.75L1268.65,251.05L1264.05,248.85L1264.45,244.55L1260.95,244.15L1260.85,238.75L1266.15,240.35L1270.25,238.35L1265.55,234.45L1263.15,230.85L1259.35,232.45L1259.95,237.15L1257.35,233.05L1259.15,230.85L1264.75,229.55L1268.65,231.35L1273.45,236.35L1276.05,236.05L1281.95,235.95L1280.25,232.75L1284.05,230.55L1287.45,226.85L1295.35,230.25L1297.25,235.25L1299.55,236.55L1305.05,236.25L1307.15,237.45L1311.45,244.05L1318.55,248.45L1322.75,251.45L1329.05,254.55L1336.75,257.35L1337.55,261.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1691.95,561.35L1692.05,559.45L1691.55,558.15L1692.35,556.65L1697.25,555.25L1701.25,554.95L1703.05,554.15L1705.15,554.95L1702.95,556.75L1696.85,559.55L1691.95,561.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1047.45,288.35L1047.35,293.25L1044.75,295.05L1043.15,297.15L1039.55,299.65L1040.15,302.25L1039.75,305.05L1037.15,306.45L1034.55,294.95L1031.15,292.35L1031.05,290.85L1026.55,286.95L1025.95,282.15L1029.15,278.55L1030.25,273.25L1029.25,267.15L1030.25,263.85L1035.95,261.35L1039.65,262.05L1039.65,265.35L1044.05,262.95L1044.45,264.15L1041.95,267.35L1042.05,270.25L1043.95,271.85L1043.45,277.45L1039.95,280.65L1041.15,284.15L1043.95,284.25L1045.35,287.35L1047.45,288.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1200.95,234.55L1206.45,234.25L1212.05,237.45L1213.35,239.65L1213.45,242.75L1217.65,244.35L1220.05,246.15L1216.75,248.05L1219.65,255.35L1218.95,257.35L1222.75,262.45L1220.35,263.55L1218.25,261.95L1211.95,261.05L1209.85,262.05L1203.95,263.05L1201.05,262.95L1195.35,265.35L1190.95,265.35L1187.95,264.15L1182.35,265.95L1180.45,264.75L1180.65,268.25L1179.45,269.65L1178.15,271.05L1175.85,268.15L1177.55,265.75L1174.35,266.35L1169.75,264.85L1166.55,268.55L1158.55,269.25L1153.85,265.85L1148.15,265.65L1147.15,268.25L1143.55,269.05L1138.15,265.65L1132.35,265.75L1128.55,259.35L1124.35,255.85L1126.35,250.85L1122.75,247.75L1127.85,241.65L1135.85,241.45L1137.45,236.55L1147.45,237.45L1153.05,233.35L1158.85,231.55L1167.35,231.35L1177.15,235.85L1185.05,238.35L1190.85,237.35L1195.45,237.95L1200.95,234.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1121.15,239.15L1122.35,238.45L1123.45,234.45L1120.75,232.75L1125.75,230.75L1130.35,231.55L1131.25,234.05L1136.05,236.05L1135.35,237.65L1129.15,237.95L1127.15,239.95L1123.25,243.35L1121.25,240.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1657.15,354.75L1655.75,360.05L1651.75,354.55L1650.25,349.85L1652.15,343.55L1655.45,338.65L1658.45,340.55L1658.35,344.45L1657.15,354.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1166.25,507.65L1166.05,511.55L1164.95,516.05L1166.55,518.55L1169.05,517.05L1172.35,516.65L1173.05,517.45L1176.35,515.85L1174.05,513.65L1175.95,510.75L1178.75,507.85L1199.25,520.95L1199.55,524.65L1207.65,531.05L1204.85,539.05L1205.15,542.65L1208.65,544.95L1208.85,546.65L1207.15,550.55L1207.45,552.45L1207.05,555.55L1208.85,559.55L1211.05,565.95L1213.05,567.35L1208.45,571.05L1202.25,573.55L1198.85,573.45L1196.75,575.35L1192.85,575.55L1191.35,576.35L1184.65,574.55L1182.45,574.75L1182.55,574.65L1180.75,572.25L1180.45,565.45L1177.55,562.05L1177.15,563.25L1176.15,561.55L1170.65,560.35L1167.45,558.45L1163.85,557.35L1161.65,556.25L1161.35,556.05L1158.65,549.45L1158.25,545.55L1153.75,541.15L1155.15,538.75L1154.05,536.15L1154.25,533.45L1153.25,532.55L1153.55,529.75L1154.15,529.65L1156.15,527.35L1158.45,523.95L1159.85,522.65L1159.85,520.55L1158.65,519.05L1158.35,516.55L1159.95,515.75L1160.25,511.95L1158.05,508.35L1160.05,507.55L1166.25,507.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1178.25,473.75L1180.95,478.25L1181.65,481.45L1184.25,488.85L1182.15,493.55L1179.35,497.75L1177.75,500.35L1177.75,500.65L1177.55,500.25L1174.55,498.95L1172.15,500.55L1168.55,501.45L1165.95,505.15L1166.25,507.65L1160.05,507.55L1158.05,508.35L1154.65,510.35L1153.25,509.65L1153.35,504.85L1154.65,502.35L1154.95,497.25L1156.15,494.25L1158.35,490.95L1160.45,489.15L1162.35,486.95L1160.05,486.05L1160.35,478.55L1162.65,476.75L1166.25,478.25L1170.75,476.75L1174.75,476.75L1178.25,473.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1156.45,173.85L1158.75,176.55L1158.85,177.75L1165.55,179.95L1169.15,178.95L1172.75,181.85L1175.65,181.75L1183.35,183.75L1183.75,185.65L1182.45,188.85L1184.25,192.35L1183.95,194.45L1179.15,194.85L1176.95,196.65L1177.35,199.35L1173.45,199.85L1170.45,201.95L1165.85,202.25L1161.85,204.65L1162.85,208.55L1165.65,210.05L1170.75,209.65L1170.15,211.95L1164.75,213.05L1158.45,216.65L1155.35,215.35L1156.05,212.45L1150.15,210.55L1150.85,209.35L1155.45,207.25L1153.75,205.85L1145.65,204.25L1144.85,201.85L1140.35,202.65L1139.05,206.15L1135.75,210.75L1133.35,209.65L1131.05,210.75L1128.65,209.55L1129.85,208.85L1130.45,206.75L1131.55,204.65L1130.95,203.55L1131.95,203.05L1132.55,203.95L1135.55,204.15L1136.85,203.65L1135.85,203.05L1136.05,202.05L1134.05,200.45L1132.95,197.85L1130.95,196.85L1131.05,194.75L1128.45,193.05L1126.45,192.75L1122.45,190.85L1119.25,191.45L1118.15,192.35L1116.05,192.35L1115.05,193.85L1111.45,194.45L1109.85,195.45L1107.35,193.85L1104.15,193.85L1100.95,193.15L1098.95,194.55L1098.45,192.85L1095.45,191.15L1096.15,188.65L1097.35,186.95L1098.45,187.35L1096.85,184.55L1100.65,179.35L1102.95,178.65L1103.25,176.95L1100.05,171.55L1102.35,171.25L1104.75,169.65L1108.55,169.45L1113.45,169.95L1119.15,171.45L1123.05,171.55L1124.95,172.45L1126.65,171.35L1128.15,172.85L1132.45,172.55L1134.55,173.15L1134.25,170.05L1135.55,168.65L1139.65,168.35L1141.45,168.55L1142.45,167.15L1143.95,167.45L1148.85,166.85L1152.65,170.35L1151.75,171.65L1152.55,173.55L1156.45,173.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M698.95,717.85L697.35,721.95L691.95,725.45L687.75,724.15L684.95,724.85L679.45,722.15L675.85,722.35L671.95,718.75L671.55,714.65L672.45,713.25L671.25,706.85L671.65,700.25L672.15,695.05L675.55,694.35L681.85,699.35L683.75,699.15L690.05,703.25L694.85,706.85L698.65,711.15L696.85,714.25L698.95,717.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1351.95,229.95L1353.65,230.55L1350.65,234.65L1355.25,237.05L1358.45,235.45L1365.65,238.85L1360.35,243.45L1356.25,242.85L1354.15,242.95L1352.85,241.25L1353.05,238.25L1346.55,239.75L1346.05,243.85L1344.55,247.35L1340.15,247.05L1339.55,249.85L1343.75,251.35L1346.15,256.15L1344.85,262.65L1340.55,261.25L1337.55,261.25L1336.75,257.35L1329.05,254.55L1322.75,251.45L1318.55,248.45L1311.45,244.05L1307.15,237.45L1305.05,236.25L1299.55,236.55L1297.25,235.25L1295.35,230.25L1287.45,226.85L1284.05,230.55L1280.25,232.75L1281.95,235.95L1276.05,236.05L1269.85,212.65L1281.85,208.95L1282.95,209.45L1292.15,213.95L1296.95,216.35L1303.55,222.05L1309.25,221.15L1317.85,220.65L1325.45,225.25L1326.95,231.65L1329.55,231.75L1332.05,236.95L1338.75,237.15L1341.05,240.15L1343.05,240.15L1343.95,235.55L1349.35,231.15L1351.95,229.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M647.95,447.35L643.25,451.15L642.75,453.45L644.55,455.85L643.15,457.05L639.65,458.05L639.65,461.05L638.05,462.85L641.75,467.65L642.45,469.45L640.35,471.95L633.95,474.35L629.85,475.35L628.15,476.85L623.65,475.25L619.55,474.45L618.45,475.05L620.95,476.65L620.65,480.95L621.35,485.05L626.15,485.55L626.45,486.95L622.35,488.75L621.65,491.45L619.25,492.55L615.05,494.05L613.95,496.05L609.55,496.45L606.45,493.05L604.85,486.65L603.35,484.35L601.35,482.95L604.25,479.75L604.05,478.35L602.55,476.45L601.45,472.15L602.05,467.55L603.35,465.35L604.55,461.95L602.55,460.85L599.35,461.55L595.25,461.25L592.95,461.95L589.15,456.35L585.85,455.55L578.55,456.15L577.35,453.95L575.95,453.45L575.85,452.05L576.55,449.65L576.25,447.15L575.05,445.65L574.45,442.75L571.55,442.35L573.35,438.55L574.25,433.95L576.05,431.55L578.35,429.75L579.95,426.55L583.65,425.45L583.45,426.95L580.05,427.75L581.75,430.65L581.45,434.05L578.75,437.75L580.65,442.85L583.15,442.45L584.65,437.75L582.95,435.55L582.95,430.65L590.15,428.05L589.55,425.05L591.65,422.95L593.35,427.55L597.35,427.65L600.75,431.15L600.95,433.35L605.95,433.35L612.05,432.75L615.15,435.55L619.35,436.35L622.65,434.35L622.75,432.75L629.85,432.35L636.55,432.25L631.65,434.15L633.45,437.25L637.95,437.65L642.15,440.85L642.85,445.95L645.75,445.85L647.95,447.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1585.75,362.75L1579.25,368.15L1575.55,374.25L1574.95,378.75L1580.25,385.45L1586.75,393.85L1592.45,397.85L1596.55,402.95L1600.55,414.85L1600.95,426.15L1596.65,430.35L1590.55,434.55L1586.35,439.85L1579.75,445.85L1577.45,441.75L1578.65,437.35L1574.25,433.75L1578.85,431.15L1584.75,430.65L1581.95,426.85L1590.95,421.85L1590.85,414.15L1589.05,409.85L1589.25,403.45L1587.25,398.95L1582.35,394.45L1577.95,388.85L1572.25,381.25L1564.95,377.35L1566.15,375.05L1569.45,373.35L1566.45,367.75L1559.65,367.75L1556.15,361.95L1552.15,356.85L1554.85,355.25L1559.25,355.35L1564.55,354.55L1568.65,351.15L1571.75,353.55L1577.05,354.75L1576.75,358.45L1579.85,361.05L1585.75,362.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="YE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1283.05,394.15L1279.05,395.85L1278.15,398.75L1278.15,400.95L1272.75,403.65L1263.95,406.65L1259.25,411.15L1256.75,411.55L1255.05,411.15L1251.85,413.85L1248.35,415.05L1243.65,415.35L1242.25,415.75L1241.15,417.45L1239.65,417.95L1238.85,419.55L1236.05,419.35L1234.35,420.25L1230.35,419.95L1228.75,416.15L1228.75,412.65L1227.75,410.75L1226.45,406.05L1224.65,403.45L1225.75,403.05L1225.05,400.15L1225.65,398.95L1225.25,396.15L1227.65,394.05L1226.85,391.35L1228.15,388.25L1230.55,389.85L1232.05,389.25L1238.45,389.15L1239.55,389.75L1245.05,390.45L1247.15,390.15L1248.65,392.25L1251.25,391.15L1254.75,384.45L1259.75,381.55L1275.65,379.05L1280.85,389.65L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1161.35,556.05L1161.65,556.25L1163.85,557.35L1167.45,558.45L1170.65,560.35L1173.25,563.25L1174.55,568.65L1173.55,570.35L1172.25,575.55L1173.15,580.95L1171.35,583.15L1169.35,589.15L1172.25,590.75L1155.05,596.05L1155.45,600.65L1151.15,601.55L1147.85,604.05L1147.05,606.25L1145.05,606.85L1139.95,612.05L1136.75,616.25L1134.85,616.35L1133.05,615.65L1126.85,614.95L1125.85,614.45L1125.85,613.95L1123.65,612.45L1120.05,612.15L1115.45,613.55L1111.85,609.55L1108.25,604.35L1109.05,583.85L1120.75,583.95L1120.35,581.75L1121.25,579.35L1120.35,576.35L1121.05,573.25L1120.45,571.25L1122.35,571.35L1122.65,573.35L1125.35,573.25L1128.85,573.85L1130.75,576.75L1135.15,577.65L1138.65,575.65L1139.85,578.95L1144.15,579.85L1146.15,582.65L1148.35,586.15L1152.65,586.15L1152.45,579.25L1150.85,580.45L1146.95,577.95L1145.45,576.75L1146.35,570.35L1147.45,562.75L1146.25,559.95L1147.95,555.85L1149.45,555.05L1157.15,553.95L1158.05,554.25L1157.75,555.65L1159.65,556.15L1160.85,557.45L1161.85,557.15L1161.35,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1158.65,643.95L1155.75,643.25L1153.85,644.05L1151.15,642.95L1148.95,642.95L1145.55,640.05L1141.25,639.05L1139.75,634.95L1139.85,632.65L1137.55,631.95L1131.45,624.95L1129.85,621.25L1128.75,620.05L1126.85,614.95L1133.05,615.65L1134.85,616.35L1136.75,616.25L1139.95,612.05L1145.05,606.85L1147.05,606.25L1147.85,604.05L1151.15,601.55L1155.45,600.65L1155.65,603.05L1160.35,602.95L1162.95,604.25L1164.05,605.85L1166.75,606.35L1169.55,608.35L1169.15,616.55L1167.85,620.95L1167.45,625.75L1168.25,627.65L1167.35,631.45L1166.55,632.05L1164.85,636.65L1158.65,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1221.35,511.85L1218.05,506.55L1217.85,483.15L1222.75,475.95L1224.25,473.85L1227.85,473.75L1232.85,469.25L1240.15,468.95L1255.75,449.65L1250.95,449.75L1232.25,442.15L1230.05,439.85L1227.85,436.75L1225.65,433.15L1226.85,430.95L1228.75,427.45L1230.65,428.65L1231.85,431.35L1234.55,434.05L1237.35,434.05L1242.55,432.35L1248.65,431.65L1253.55,429.65L1256.35,429.25L1258.35,428.05L1261.55,427.85L1263.35,427.65L1265.85,426.75L1268.85,426.05L1271.35,423.85L1273.55,423.85L1273.75,425.65L1273.35,429.35L1273.55,432.75L1272.45,435.05L1271.05,442.05L1268.65,449.15L1265.35,457.35L1260.75,466.75L1256.05,473.95L1249.45,482.75L1243.85,487.95L1235.45,494.35L1230.15,499.15L1223.95,506.95L1222.65,510.35L1221.35,511.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="XK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1097.05,230.05L1095.85,230.35L1092.95,231.35L1092.85,232.65L1092.15,232.55L1091.55,230.25L1090.25,229.55L1089.05,227.85L1089.85,226.45L1091.05,226.05L1091.55,223.95L1092.45,223.55L1093.25,224.45L1094.25,224.85L1095.05,225.85L1095.95,226.15L1097.05,227.35L1097.75,227.25L1097.35,228.85L1096.75,229.55L1097.05,230.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1158.65,643.95L1160.85,652.95L1161.95,657.55L1160.55,664.65L1160.95,666.95L1158.25,665.85L1156.55,666.25L1155.95,668.15L1154.25,670.55L1154.15,672.75L1157.25,676.25L1160.45,675.55L1161.85,672.75L1165.95,672.75L1164.25,677.45L1163.25,682.75L1161.55,685.65L1157.55,688.95L1156.45,689.85L1153.85,693.15L1152.05,696.45L1148.55,701.05L1141.85,707.65L1137.75,711.45L1133.45,714.45L1127.55,716.85L1124.85,717.25L1123.95,719.05L1120.75,718.05L1118.05,719.25L1112.35,718.05L1109.05,718.85L1106.85,718.45L1101.05,721.05L1096.45,722.05L1092.95,724.45L1090.55,724.65L1088.45,722.35L1086.65,722.25L1084.45,719.35L1084.15,720.25L1083.55,718.55L1083.85,714.75L1082.35,710.45L1084.15,709.25L1084.25,704.35L1080.95,698.35L1078.55,692.95L1078.55,692.85L1074.95,684.55L1077.75,681.35L1079.75,683.15L1080.55,685.85L1083.05,686.35L1086.45,687.55L1089.35,687.05L1094.35,683.75L1095.45,660.05L1096.85,661.05L1099.85,667.15L1099.25,671.05L1100.35,673.35L1104.35,672.65L1107.15,669.75L1109.85,667.85L1111.35,664.75L1114.15,663.35L1116.45,664.05L1118.95,665.85L1123.45,666.15L1127.05,664.75L1127.65,662.75L1128.85,659.65L1131.85,659.15L1133.65,656.75L1135.65,652.45L1140.85,647.65L1148.95,642.95L1151.15,642.95L1153.85,644.05L1155.75,643.25L1158.65,643.95ZM1138.35,697.15L1139.45,695.15L1142.55,694.15L1143.65,692.05L1145.55,688.95L1143.85,686.95L1141.65,684.95L1138.95,686.35L1135.85,688.85L1132.65,692.85L1136.35,697.85L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1885.45,763.65L1884.65,766.25L1890.25,763.65L1889.75,766.35L1887.65,769.05L1883.45,771.95L1876.35,776.65L1871.65,779.25L1871.05,782.25L1867.05,782.35L1860.75,784.75L1856.05,788.85L1847.85,795.25L1841.55,798.05L1837.55,799.85L1832.95,799.75L1831.45,797.65L1826.35,797.25L1827.35,794.85L1833.85,790.25L1845.25,783.95L1849.55,782.75L1855.15,780.35L1862.15,777.05L1867.85,773.75L1873.85,769.05L1876.95,767.45L1880.45,763.85L1886.25,760.95L1885.45,763.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1914.45,733.15L1914.05,739.95L1916.95,735.55L1918.25,737.35L1915.85,742.15L1918.75,744.25L1921.95,744.75L1926.65,742.35L1928.85,743.05L1923.65,748.75L1919.45,752.45L1915.55,752.35L1912.75,754.25L1911.25,757.05L1909.65,758.15L1905.05,761.65L1899.15,765.95L1893.15,768.55L1893.65,766.85L1892.15,765.95L1899.05,760.75L1899.95,757.15L1896.15,754.65L1897.95,752.35L1903.25,750.15L1907.45,745.15L1909.95,741.05L1910.55,736.75L1911.35,735.65L1910.45,732.95L1909.75,727.35L1910.15,722.75L1912.35,722.25L1913.25,725.85L1916.45,727.45L1914.45,733.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M654.35,837.15L660.35,850.75L665.35,850.75L668.35,850.95L667.85,853.35L664.65,855.25L662.25,855.05L659.15,854.55L654.95,852.75L649.55,851.85L642.05,848.45L635.65,845.25L625.85,838.35L630.45,839.65L639.05,843.75L646.35,845.95L647.55,843.15L647.25,838.95L650.65,836.35L654.35,837.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M613.65,647.05L614.55,648.65L613.35,655.35L607.75,658.45L609.35,669.15L608.55,671.25L610.55,673.75L607.25,677.75L604.65,683.75L603.75,689.65L605.45,695.85L603.35,702.45L608.25,713.55L609.85,714.75L611.25,720.65L609.65,726.85L611.05,732.25L608.05,736.45L609.65,742.25L612.95,748.55L610.45,750.85L610.65,756.55L611.45,763.05L614.75,770.85L613.05,772.15L616.75,779.45L619.85,781.85L619.05,784.55L621.85,785.75L623.25,788.15L621.45,789.35L623.25,793.05L624.35,801.35L623.65,806.75L625.45,809.95L625.35,813.85L622.65,816.65L625.75,823.15L628.35,825.45L631.45,825.05L633.35,829.65L636.85,833.25L648.95,834.05L653.85,835.05L649.55,835.05L647.85,836.55L644.45,838.75L646.15,844.45L644.25,844.55L637.95,842.65L630.45,838.35L622.85,834.85L619.65,830.95L619.35,827.35L615.15,823.15L610.15,812.55L609.95,806.55L613.35,801.75L605.05,799.85L607.75,794.35L605.75,783.85L612.25,786.05L610.45,772.95L606.45,771.25L607.45,779.15L603.95,778.25L602.45,769.25L600.45,757.45L601.55,753.05L598.25,746.85L595.85,739.65L598.05,739.35L598.65,729.05L599.85,718.75L599.95,709.25L596.65,699.55L597.25,694.25L595.15,686.35L596.95,678.55L596.05,666.15L596.05,652.75L596.15,638.45L594.65,627.95L592.55,618.85L595.35,617.25L596.45,613.95L599.65,618.35L600.85,622.95L604.05,625.65L602.95,631.85L606.65,639.05L609.75,647.95L613.65,647.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1015.75,176.35L1012.95,174.85L1009.85,172.15L1005.35,173.45L1001.75,172.95L1004.25,171.25L1008.25,162.25L1014.75,159.65L1018.75,159.85L1019.65,161.95L1018.75,167.55L1017.55,169.85L1014.65,169.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M946.15,262.95L943.95,264.55L941.15,263.65L938.45,264.35L939.35,259.35L939.05,255.45L936.65,254.85L935.55,252.45L936.05,248.25L938.25,245.95L938.75,243.35L939.95,239.55L939.95,236.85L939.05,234.55L938.85,232.35L940.75,230.75L942.95,229.85L944.15,232.95L947.15,232.95L948.05,232.15L951.15,232.35L952.45,235.55L950.05,237.25L949.75,242.25L948.95,243.15L948.65,246.25L946.35,246.75L948.35,250.55L946.75,254.75L948.55,256.65L947.75,258.35L945.75,260.75L946.15,262.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1688.75,176.65L1702.45,187.65L1693.55,185.65L1697.25,194.65L1706.85,201.05L1709.85,205.45L1703.35,201.65L1703.45,206.55L1698.75,201.25L1694.95,195.15L1689.35,188.45L1686.95,183.65L1680.55,175.45L1672.55,169.35L1665.75,160.95L1667.65,158.15L1663.25,155.35L1664.55,154.45L1669.45,158.45L1676.35,164.35L1681.55,170.45L1688.75,176.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1093.85,154.65L1085.05,154.75L1079.15,154.05L1079.85,151.45L1086.15,149.45L1091.25,150.55L1093.45,151.45L1093.25,153.15L1093.85,154.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1547.65,47.45L1541.75,47.55L1532.85,46.95L1531.85,46.65L1532.55,44.65L1536.75,44.15L1545.15,46.15L1547.65,47.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1560.25,37.95L1559.15,39.95L1552.25,39.55L1541.95,37.55L1540.15,35.95L1548.45,36.65L1560.25,37.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1534.75,35.55L1537.85,39.35L1523.55,39.15L1518.95,40.35L1506.45,37.05L1503.05,33.65L1506.55,32.75L1516.75,32.95L1534.75,35.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1218.05,60.55L1215.85,60.95L1202.35,60.25L1200.05,57.95L1192.15,56.55L1190.15,53.65L1193.65,52.55L1192.05,49.75L1197.45,45.35L1193.45,44.75L1200.15,40.25L1197.65,37.95L1204.45,35.35L1214.75,32.15L1226.45,31.25L1231.45,29.45L1238.15,28.85L1242.35,30.75L1241.05,32.25L1229.65,34.75L1219.75,37.05L1211.05,41.85L1208.25,46.85L1204.95,51.85L1208.05,56.15L1218.05,60.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1660.95,230.25L1659.55,229.15L1657.65,225.85L1660.15,225.75L1656.25,218.25L1651.55,212.85L1654.45,210.65L1661.35,211.75L1660.75,205.55L1657.95,198.75L1658.25,196.45L1656.95,190.75L1650.05,192.65L1647.45,195.05L1639.85,195.05L1633.85,189.25L1624.85,184.75L1614.85,182.75L1608.65,176.75L1604.15,172.95L1600.35,170.25L1592.65,164.05L1586.65,161.85L1578.05,159.95L1571.85,160.15L1566.75,161.25L1565.05,164.35L1568.75,165.75L1571.25,169.15L1569.95,171.15L1570.15,177.65L1572.05,180.45L1567.65,184.35L1560.25,181.95L1554.65,182.55L1550.75,180.45L1547.35,179.75L1542.95,184.15L1537.05,185.15L1533.45,186.75L1526.65,185.75L1522.05,185.75L1517.15,182.55L1510.55,179.65L1505.15,178.75L1499.45,179.55L1495.45,180.75L1486.95,178.15L1483.35,173.55L1476.65,171.95L1471.85,171.15L1464.85,168.65L1463.55,175.05L1467.55,178.65L1465.15,183.05L1457.15,181.45L1452.15,181.25L1447.35,178.35L1442.15,178.25L1436.85,176.35L1430.95,179.25L1424.25,184.55L1419.55,185.65L1417.85,186.15L1413.45,182.35L1407.45,183.25L1404.15,180.55L1400.15,179.35L1396.05,175.75L1392.75,174.65L1386.55,176.25L1378.15,172.75L1377.05,175.95L1358.75,160.35L1350.35,155.65L1351.15,153.65L1341.95,159.45L1337.55,159.75L1336.45,156.45L1329.35,154.35L1325.05,155.85L1320.65,149.55L1311.55,148.25L1308.45,150.75L1297.55,153.05L1295.85,154.55L1278.85,156.65L1277.45,158.75L1282.55,162.95L1278.55,164.55L1280.05,166.15L1276.55,169.15L1285.95,173.45L1285.75,176.35L1278.75,176.05L1277.95,177.95L1270.65,174.75L1262.95,174.85L1258.55,177.45L1251.95,174.95L1239.95,170.65L1232.35,170.85L1224.25,177.55L1224.85,182.05L1218.85,178.45L1216.65,185.35L1218.45,186.55L1216.75,191.35L1222.05,195.55L1225.65,195.35L1229.95,199.55L1230.15,202.75L1232.95,203.85L1231.55,207.55L1226.95,208.55L1223.35,215.05L1229.35,221.15L1229.75,225.35L1237.05,232.85L1234.55,235.45L1233.95,237.05L1231.55,236.55L1227.25,232.75L1225.75,232.55L1222.15,231.05L1220.05,228.45L1214.95,227.15L1212.05,228.15L1210.85,226.95L1203.25,223.85L1195.55,222.85L1190.95,221.75L1190.55,222.55L1182.95,217.15L1176.75,214.75L1171.65,211.05L1175.25,210.05L1178.45,204.85L1175.15,202.35L1182.05,199.75L1181.65,198.35L1177.35,199.35L1176.95,196.65L1179.15,194.85L1183.95,194.45L1184.25,192.35L1182.45,188.85L1183.75,185.65L1183.35,183.75L1175.65,181.75L1172.75,181.85L1169.15,178.95L1165.55,179.95L1158.85,177.75L1158.75,176.55L1156.45,173.85L1152.55,173.55L1151.75,171.65L1152.65,170.35L1148.85,166.85L1143.95,167.45L1142.45,167.15L1141.45,168.55L1139.65,168.35L1137.65,164.35L1136.15,162.35L1136.95,161.75L1140.85,161.95L1142.45,160.65L1140.75,159.05L1137.35,157.95L1137.35,156.85L1135.25,155.75L1131.45,151.75L1132.15,150.15L1131.05,147.25L1126.25,145.85L1123.85,146.55L1122.95,145.05L1117.65,143.55L1115.55,139.95L1114.55,137.05L1112.05,135.75L1113.65,133.85L1111.25,128.25L1113.85,124.85L1112.95,123.85L1117.45,120.55L1112.05,117.75L1120.05,110.35L1123.45,106.95L1124.35,104.05L1116.95,100.15L1117.85,96.35L1112.95,92.15L1114.65,87.35L1108.15,81.05L1111.05,76.85L1103.75,73.15L1103.35,69.35L1106.55,68.85L1112.95,66.75L1116.65,64.85L1124.35,68.05L1136.05,69.35L1153.75,75.55L1157.85,78.15L1159.35,81.85L1155.65,84.75L1149.15,86.25L1128.95,82.05L1126.05,82.75L1134.15,86.85L1135.15,89.45L1137.05,95.25L1143.15,96.95L1146.95,98.45L1146.75,95.65L1143.35,93.25L1145.45,91.05L1157.05,94.65L1160.25,93.25L1155.95,89.05L1164.05,83.65L1168.15,83.95L1172.75,85.85L1173.85,82.05L1169.15,78.75L1169.95,75.45L1165.65,72.05L1177.95,73.85L1181.55,76.85L1176.45,77.55L1177.65,80.65L1181.75,82.55L1187.75,81.35L1187.35,77.85L1195.05,75.15L1207.45,70.55L1210.65,70.75L1208.15,74.05L1213.55,74.65L1215.65,72.75L1223.35,72.65L1228.35,70.35L1234.75,73.65L1237.55,70.05L1231.55,66.95L1232.75,65.15L1245.75,66.75L1252.35,68.45L1270.95,74.65L1272.05,71.85L1266.15,68.95L1265.35,67.85L1260.05,67.25L1259.85,64.75L1255.15,60.55L1254.05,58.85L1258.35,54.15L1257.75,49.35L1259.95,48.35L1271.35,49.75L1274.25,52.65L1273.35,56.85L1277.05,58.55L1280.85,62.25L1284.65,69.65L1291.35,72.95L1291.85,76.65L1288.35,84.45L1293.65,85.25L1294.15,83.25L1297.95,81.85L1297.45,79.15L1299.35,76.45L1294.95,73.35L1294.55,69.75L1289.75,69.35L1286.85,66.35L1286.45,60.95L1278.25,56.65L1282.95,53.15L1279.25,49.45L1281.15,49.35L1285.35,52.15L1287.45,57.25L1292.45,58.25L1287.85,54.45L1292.95,52.35L1301.05,52.05L1310.65,55.05L1303.75,50.75L1298.85,45.25L1304.75,44.25L1314.25,44.45L1322.05,43.75L1316.45,41.15L1317.75,37.85L1321.95,37.65L1326.85,35.25L1336.15,34.55L1335.95,33.15L1345.25,32.75L1349.55,33.85L1354.95,31.25L1361.95,31.35L1360.45,29.15L1361.35,27.15L1367.55,25.15L1375.85,26.75L1372.35,27.95L1381.75,28.65L1385.85,31.05L1387.75,29.85L1398.65,29.95L1410.25,32.35L1415.75,34.15L1418.25,36.75L1415.85,38.25L1409.25,41.05L1408.15,42.55L1413.75,43.25L1420.95,44.55L1423.35,43.55L1429.15,46.85L1429.35,45.55L1434.55,44.75L1448.15,45.55L1451.95,47.95L1469.35,48.75L1464.55,44.85L1474.05,45.75L1480.15,45.65L1490.05,48.35L1496.05,51.65L1496.45,53.85L1506.55,58.05L1515.55,60.15L1512.55,54.65L1521.95,56.95L1526.95,55.55L1536.75,57.15L1537.75,55.75L1545.35,56.45L1535.95,51.55L1538.05,49.35L1578.45,52.75L1586.35,55.85L1602.65,59.85L1617.45,58.85L1626.75,59.75L1633.35,61.95L1638.45,65.85L1645.75,67.35L1649.65,66.25L1656.65,66.15L1665.95,67.15L1672.85,66.55L1687.15,71.35L1689.65,69.65L1681.15,66.25L1679.35,63.85L1694.65,65.35L1702.65,65.05L1718.45,67.55L1727.95,69.95L1761.15,92.05L1759.15,94.55L1752.95,94.15L1761.15,97.15L1770.25,101.85L1774.45,103.35L1778.25,105.75L1779.25,107.25L1769.25,106.05L1762.65,110.35L1759.65,111.05L1758.05,115.15L1756.05,118.75L1757.75,121.45L1746.25,117.35L1740.15,121.95L1735.45,119.75L1734.05,122.35L1727.05,121.45L1730.15,125.35L1731.25,131.15L1734.15,133.55L1740.95,134.85L1750.05,143.55L1745.95,143.85L1749.35,148.85L1754.05,151.45L1749.05,154.55L1754.45,161.55L1748.75,163.05L1753.25,169.25L1751.55,175.05L1745.85,170.75L1735.35,161.85L1719.15,148.25L1712.65,139.95L1712.75,136.35L1709.95,133.55L1715.65,132.25L1715.45,124.75L1716.15,118.75L1718.65,114.05L1712.05,105.85L1707.35,106.35L1710.55,111.15L1706.95,117.55L1694.65,110.35L1685.55,112.35L1685.55,122.15L1693.25,125.75L1684.75,127.35L1678.35,127.95L1674.05,123.65L1666.05,122.75L1663.55,125.65L1648.45,124.65L1635.25,126.35L1631.75,138.05L1626.75,152.25L1634.95,153.05L1640.65,156.85L1646.45,158.15L1646.85,155.15L1652.45,155.55L1665.25,162.25L1669.95,167.45L1671.35,173.65L1676.85,181.05L1682.15,190.95L1681.15,200.05L1682.45,204.35L1680.45,211.75L1678.35,219.05L1677.45,222.75L1672.85,226.45L1669.75,226.55L1664.55,223.45L1660.45,228.15L1660.95,230.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1366.35,22.35L1348.25,24.15L1346.95,18.05L1349.15,17.55L1352.25,17.85L1364.85,20.45L1366.35,22.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1164.05,12.35L1159.75,12.85L1156.85,13.25L1156.85,13.95L1153.25,14.65L1148.75,13.65L1149.85,12.25L1142.05,12.15L1148.35,11.35L1153.55,11.35L1155.05,12.45L1156.35,11.45L1159.15,10.75L1164.95,11.65L1164.05,12.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1344.35,19.65L1337.25,20.25L1325.55,18.95L1317.45,17.25L1310.85,14.05L1304.95,13.25L1310.35,10.35L1316.55,9.45L1326.15,11.45L1339.85,15.65L1344.35,19.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ES" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M975.85,222.65L977.85,225.05L987.35,227.95L989.25,226.55L995.05,229.45L1000.95,228.65L1001.35,232.35L996.45,236.55L989.85,237.95L989.35,240.05L986.15,243.55L984.15,248.75L986.15,252.45L983.15,255.25L981.95,259.45L977.95,260.75L974.25,265.65L967.45,265.75L962.45,265.65L959.05,267.85L956.95,270.25L954.35,269.75L952.45,267.55L951.05,263.95L946.15,262.95L945.75,260.75L947.75,258.35L948.55,256.65L946.75,254.75L948.35,250.55L946.35,246.75L948.65,246.25L948.95,243.15L949.75,242.25L950.05,237.25L952.45,235.55L951.15,232.35L948.05,232.15L947.15,232.95L944.15,232.95L942.95,229.85L940.75,230.75L938.85,232.35L939.35,227.85L937.35,225.15L944.75,220.55L950.95,221.65L957.85,221.65L963.25,222.75L967.55,222.35L975.85,222.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1034.95,230.65L1033.45,235.55L1031.05,234.25L1029.75,230.05L1030.65,227.65L1033.85,225.25L1034.95,230.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1013.65,184.25L1014.75,184.75L1016.15,184.65L1018.55,186.25L1025.75,187.45L1023.35,191.65L1022.95,196.15L1021.65,197.25L1019.35,196.65L1019.55,198.25L1015.95,201.75L1015.95,204.65L1018.35,203.65L1020.15,206.35L1020.05,208.15L1021.55,210.55L1019.85,212.45L1021.35,217.35L1024.15,218.15L1023.65,220.85L1019.15,224.45L1008.95,222.75L1001.55,224.85L1000.95,228.65L995.05,229.45L989.25,226.55L987.35,227.95L977.85,225.05L975.85,222.65L978.55,218.85L979.55,206.25L974.45,199.65L970.75,196.45L963.15,194.05L962.75,189.45L969.25,188.15L977.55,189.75L976.05,182.65L980.75,185.35L992.15,180.55L993.65,175.45L997.85,174.15L998.65,176.35L1000.85,176.45L1003.25,178.95L1006.75,181.85L1009.25,181.35L1013.65,184.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M538.75,193.75L532.65,195.75L527.95,198.25L523.35,200.95L522.85,201.85L528.55,200.55L530.65,202.65L535.25,201.15L540.15,199.05L545.55,196.95L542.45,200.25L544.95,201.05L547.45,203.45L552.55,202.05L557.65,201.55L557.95,203.35L559.45,203.55L560.65,203.75L562.15,206.25L557.45,206.85L557.35,206.85L553.65,206.15L549.15,207.35L545.45,207.95L540.75,212.05L537.75,214.35L538.15,215.05L543.65,210.95L544.35,210.95L539.65,215.85L536.75,220.25L534.25,223.85L533.65,226.95L532.85,228.45L532.25,230.15L532.35,233.45L532.65,233.95L534.45,233.85L536.05,233.15L537.45,232.35L540.75,229.25L542.55,225.05L542.45,221.15L543.85,218.45L546.45,215.35L548.55,213.15L551.25,211.65L550.85,213.75L553.05,210.65L554.35,210.05L556.05,207.65L559.85,208.95L562.65,211.35L561.85,214.25L560.25,217.15L556.45,219.65L556.05,221.25L557.05,221.25L561.35,218.55L562.95,219.15L562.45,222.85L561.75,225.45L558.05,228.95L556.05,231.15L553.35,233.55L556.05,234.85L558.55,235.25L562.55,234.35L566.25,232.65L569.25,231.75L573.85,229.95L579.65,226.15L579.75,225.55L580.05,223.65L582.75,222.85L586.65,223.15L590.65,223.65L595.25,221.55L595.85,219.05L595.65,218.15L602.45,213.75L605.15,212.65L612.95,212.55L622.25,212.55L623.35,211.05L625.05,210.75L627.55,209.75L630.35,206.85L633.55,201.95L639.05,197.25L640.15,198.85L643.85,197.85L645.45,199.65L642.55,208.15L644.75,211.75L644.95,213.85L638.55,216.85L632.55,219.05L626.55,220.95L622.55,224.75L621.25,226.15L620.05,229.55L620.75,232.85L622.85,233.05L623.05,230.75L624.15,232.15L623.15,233.95L619.35,234.95L616.85,234.85L612.65,235.95L610.35,236.25L607.25,236.55L602.25,238.45L610.35,237.25L611.45,238.45L603.55,240.35L600.25,240.35L600.65,239.55L598.55,241.35L599.95,241.65L597.45,246.25L592.15,251.15L592.25,249.45L591.15,249.15L589.95,247.55L589.95,251.05L590.95,252.15L590.35,254.55L587.95,257.05L583.45,262.15L583.05,261.95L585.95,257.55L583.95,255.15L584.95,249.75L583.05,252.55L583.05,256.65L579.85,255.65L582.85,257.65L581.35,263.75L582.75,264.25L582.75,266.45L581.75,272.85L577.15,277.55L571.05,279.45L566.65,283.25L563.85,283.65L560.45,286.05L559.15,288.15L552.25,292.35L548.45,295.45L544.95,299.25L543.05,303.75L543.05,308.25L543.65,313.75L545.15,318.25L544.65,321.05L545.95,328.45L544.95,332.85L544.35,335.35L542.35,339.25L540.55,340.05L537.95,339.25L537.55,336.45L535.75,334.95L533.75,329.45L532.15,324.55L531.75,322.05L533.75,317.75L532.95,314.25L529.85,308.85L527.95,307.85L521.85,310.85L520.95,310.45L518.95,307.45L515.95,305.85L509.55,306.75L504.95,305.95L500.65,306.45L498.15,307.45L498.75,309.15L498.05,311.75L498.85,313.05L497.65,313.85L495.85,312.95L493.55,314.15L489.65,313.95L486.35,310.55L481.45,311.35L477.85,309.85L474.35,310.35L469.35,311.85L463.25,316.55L457.15,319.35L453.45,322.35L451.55,325.25L450.55,329.75L450.15,332.75L450.75,334.95L448.55,335.15L444.95,333.75L441.05,331.75L440.15,328.75L439.95,324.25L437.55,320.65L436.65,316.85L435.05,312.45L431.85,309.85L427.35,310.05L422.55,315.05L418.55,313.15L416.25,311.25L415.85,307.65L415.05,304.35L412.65,301.55L410.55,299.45L409.25,297.15L399.85,297.15L399.05,299.85L383.95,299.85L373.05,295.35L366.05,292.25L366.95,290.95L359.85,291.65L353.55,292.15L353.85,288.95L351.75,285.25L349.55,284.45L349.65,282.65L346.75,282.25L345.55,280.55L340.75,279.95L339.85,278.85L340.65,275.35L338.15,268.95L337.65,260.05L338.55,258.55L337.25,256.45L335.75,251.05L337.55,245.85L336.65,242.35L340.55,237.05L343.35,231.65L344.45,226.75L349.95,220.75L357.95,209.35L362.25,200.85L364.05,195.55L364.45,192.65L365.85,191.35L371.65,193.55L370.65,199.45L372.85,197.75L375.35,192.65L376.95,187.55L514.05,187.55L515.35,185.15L517.05,185.15L516.15,188.55L517.15,189.55L520.45,189.95L525.05,190.95L528.95,192.85L533.35,192.05L538.75,193.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M274.25,137.85L267.25,140.15L266.45,138.55L268.75,135.75L275.15,133.65L278.65,132.75L281.25,133.15L281.25,135.05L274.25,137.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M235.25,121.25L231.35,122.15L229.65,121.05L228.85,119.45L234.55,118.45L237.55,119.05L235.25,121.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M236.45,98.85L237.65,99.85L241.15,99.35L242.75,100.85L246.05,101.55L244.85,102.25L239.95,103.45L238.25,102.15L237.95,101.15L233.65,101.45L233.35,100.95L236.45,98.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M409.25,65.85L384.65,86.25L349.05,118.95L353.25,119.15L356.05,120.75L356.55,123.35L356.85,127.15L364.45,123.85L370.95,121.95L370.35,125.05L371.15,127.45L372.75,130.15L371.65,134.35L370.25,141.25L374.85,145.05L371.65,148.85L366.55,151.75L365.95,149.55L363.45,147.55L366.75,142.35L365.15,137.45L367.85,131.85L363.75,131.45L356.65,131.35L352.85,129.55L349.55,123.45L346.25,122.35L340.55,120.25L333.75,120.75L327.75,118.05L325.05,115.55L318.75,116.75L315.25,120.85L312.35,121.25L305.75,122.45L299.55,124.45L293.15,125.75L296.35,122.25L304.75,116.45L311.55,114.65L311.95,113.25L302.55,116.45L295.15,120.35L283.95,124.55L284.15,127.45L275.15,131.65L267.45,134.15L260.85,136.05L256.85,138.65L246.25,141.75L241.75,144.55L233.55,147.15L230.85,146.75L224.65,148.35L217.65,150.45L211.55,152.45L201.55,154.25L201.95,153.15L210.15,150.35L216.75,148.45L225.35,145.15L231.85,144.55L236.85,142.05L247.25,138.45L249.55,137.25L255.25,135.15L261.05,130.65L267.25,127.15L259.95,128.95L259.65,127.85L254.75,130.05L255.15,127.05L251.55,129.15L253.15,126.25L245.85,128.55L243.05,128.55L246.75,125.05L250.05,122.85L249.65,120.75L242.45,121.95L241.85,119.15L240.55,117.75L244.55,114.45L244.15,111.95L250.05,108.65L257.75,105.35L263.05,102.45L267.15,102.05L268.95,102.95L276.05,100.15L278.55,100.65L284.15,98.85L286.65,96.25L285.55,95.25L291.55,93.05L288.75,93.15L282.55,94.35L279.65,95.65L277.85,94.35L270.95,95.05L266.35,93.65L267.55,91.35L266.55,88.15L275.75,85.75L288.95,83.05L292.45,83.05L288.15,85.85L297.35,85.65L298.55,82.15L296.25,80.05L297.05,77.25L296.35,74.95L293.05,73.25L299.55,70.35L307.05,70.15L315.85,67.75L320.65,65.15L328.55,62.55L333.35,61.95L344.55,59.55L347.65,59.95L358.05,57.15L362.45,58.25L361.95,60.65L365.25,59.65L371.55,59.95L369.65,61.15L374.55,62.05L379.45,61.55L385.65,63.15L392.85,63.75L395.05,64.35L401.65,63.55L405.75,65.15L409.25,65.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M676.55,486.25L678.05,483.45L678.55,480.55L679.55,477.85L677.45,474.05L677.15,469.65L680.25,464.15L682.15,464.85L686.25,466.35L692.15,471.75L692.95,474.35L689.55,480.25L687.75,484.95L685.55,487.45L682.85,487.85L682.05,486.05L680.75,485.85L679.05,487.55L676.55,486.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M592.15,421.25L591.65,421.05L591.15,420.55L591.25,419.95L591.45,420.25L591.85,420.65L592.15,421.15L592.15,421.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.45,384.15L633.25,384.15L633.55,383.75L633.85,383.75L633.65,384.05L633.45,384.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M639.95,391.15L640.55,391.45L640.35,391.75L640.15,391.75L639.45,391.85L639.25,391.75L639.25,391.25L639.55,391.15L639.65,390.85L639.85,390.85L639.95,391.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M639.95,387.45L640.15,387.45L640.35,387.65L640.45,388.05L640.35,388.35L640.15,388.45L640.05,388.25L639.75,388.05L639.75,387.55L639.95,387.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1263.35,332.55L1263.65,332.65L1263.85,332.55L1264.25,333.25L1264.15,333.45L1264.25,334.35L1264.25,335.05L1264.05,335.45L1263.95,335.05L1263.35,334.25L1263.45,333.85L1263.25,333.15L1263.25,332.75L1263.35,332.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M579.65,365.25L579.25,365.75L579.05,366.25L578.45,366.55L577.95,366.55L577.85,366.45L577.45,366.65L576.95,366.75L576.35,366.55L575.95,366.65L575.85,366.15L576.15,365.95L576.35,365.65L576.75,365.45L577.05,365.05L577.45,365.05L577.75,364.85L577.95,365.15L578.45,365.35L578.95,365.15L579.65,364.15L579.95,364.15L579.95,364.35L579.65,365.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M579.85,363.55L579.65,362.95L580.25,362.65L580.55,362.95L580.55,363.15L580.25,363.25L579.85,363.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M580.25,357.05L580.45,356.95L580.95,357.25L581.35,357.25L581.75,357.35L582.05,357.55L582.05,357.85L581.85,357.95L581.35,357.55L580.95,357.55L580.85,357.45L580.35,357.65L579.85,357.45L579.85,357.35L580.05,356.85L580.25,357.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M576.35,355.25L576.15,355.65L576.15,356.35L576.05,356.75L575.65,357.05L575.45,357.45L575.05,357.75L574.35,358.05L574.25,358.25L574.05,358.05L574.15,357.85L574.55,357.75L574.75,357.55L574.75,357.35L575.15,357.25L575.35,356.85L575.75,356.75L576.05,356.35L575.85,356.05L575.45,356.05L575.25,355.85L575.65,355.35L575.75,355.25L576.35,355.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M574.45,354.95L574.55,355.05L574.95,355.05L575.35,355.25L574.95,355.65L574.85,355.45L574.65,355.45L574.25,355.35L573.85,355.15L573.55,354.55L573.85,354.45L574.25,354.55L574.45,354.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M565.25,349.05L565.85,349.75L566.15,349.95L566.45,350.45L566.15,350.35L566.05,350.15L565.75,350.05L565.35,349.65L565.15,349.55L564.95,349.15L565.25,349.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M568.95,349.05L569.25,349.65L569.45,350.15L569.45,350.55L569.65,350.75L569.85,351.45L569.85,352.35L570.05,352.65L570.55,352.85L570.95,353.45L570.95,354.25L570.55,353.55L570.55,353.35L570.25,352.95L569.65,352.75L569.85,352.55L569.55,352.25L569.55,351.95L569.75,351.65L569.65,351.15L569.35,350.75L569.45,350.65L569.15,350.25L569.05,349.65L568.85,349.75L568.95,349.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M571.85,349.05L571.55,349.25L571.25,349.15L571.15,348.95L571.75,348.75L571.85,349.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M563.65,347.15L563.55,347.05L563.25,346.35L563.45,346.35L563.65,347.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M574.15,346.65L573.75,347.25L573.35,347.25L573.55,346.95L573.65,346.35L574.05,346.05L574.15,346.45L574.15,346.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M555.65,345.45L555.35,345.55L555.15,345.85L554.85,345.75L555.45,345.35L555.65,345.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M555.85,346.15L556.25,346.35L556.45,346.15L556.55,345.65L556.75,345.55L556.95,346.15L556.95,346.65L556.85,346.95L556.95,347.55L556.95,347.85L556.55,348.65L556.35,348.75L555.95,348.55L556.15,348.25L556.55,348.05L556.45,347.95L555.85,348.35L555.65,348.15L556.05,347.85L555.65,347.85L555.45,347.95L555.25,347.75L555.25,347.05L555.35,346.85L554.95,346.35L554.95,346.15L555.35,345.95L555.45,345.65L555.75,345.55L555.85,345.35L556.45,345.05L556.55,345.45L556.05,345.85L555.85,346.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M569.35,345.55L569.45,346.05L569.25,345.95L568.75,346.05L568.35,346.15L568.25,345.95L568.55,345.75L568.95,345.45L568.95,345.25L568.55,345.05L568.35,344.45L568.25,343.85L567.85,343.45L567.85,343.25L567.35,342.75L567.65,342.45L568.05,342.85L568.05,343.35L568.25,343.65L568.35,344.15L568.65,344.65L569.05,344.95L569.15,345.25L569.35,345.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M559.05,340.05L559.35,340.25L558.75,340.55L558.45,340.45L558.25,340.65L557.75,340.55L557.95,340.25L558.35,340.05L559.05,340.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M554.85,339.55L555.25,339.35L555.55,339.65L555.45,339.85L555.55,340.05L555.35,340.45L555.65,340.75L555.85,341.65L556.05,341.95L556.45,342.45L556.25,343.15L556.35,343.75L556.15,344.05L555.85,344.15L555.45,344.55L555.15,344.75L554.85,344.75L554.55,344.95L554.25,344.95L554.25,344.55L553.95,344.35L554.05,343.75L553.75,344.05L553.55,343.95L552.95,343.55L552.65,343.25L552.45,342.95L553.15,342.65L553.65,343.35L553.75,342.75L553.45,342.65L553.35,342.35L553.45,342.05L554.05,341.45L554.25,341.05L554.15,340.95L554.45,340.55L554.45,340.05L554.25,339.35L554.35,339.25L554.65,339.25L554.85,339.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M562.95,336.95L563.05,337.15L563.35,337.55L564.15,338.25L564.65,338.35L564.75,338.45L564.95,338.85L565.25,339.25L565.75,339.65L565.75,339.85L565.55,340.65L565.45,340.85L565.45,341.15L565.35,341.65L565.15,341.95L565.05,342.65L564.95,342.75L564.75,342.15L564.35,341.85L564.45,341.65L564.95,341.75L565.15,341.55L565.05,341.35L565.15,340.95L565.45,340.55L565.55,340.05L565.55,339.75L565.05,339.35L564.65,338.65L564.35,338.45L563.75,338.15L563.45,337.85L562.85,337.65L562.45,337.85L562.85,336.95L562.95,336.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M554.15,329.45L554.65,329.65L554.75,329.65L555.45,329.75L555.65,329.55L555.85,329.65L556.35,329.65L556.75,329.45L557.15,329.45L557.45,329.25L557.55,329.75L557.45,329.95L556.75,329.95L555.65,330.15L555.35,330.15L553.85,330.55L553.15,330.95L552.75,330.95L552.55,330.85L552.25,330.55L551.75,329.95L552.35,330.25L552.45,330.45L552.95,330.45L553.45,330.25L553.85,329.65L553.55,329.55L553.75,329.25L553.85,328.95L554.15,329.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M558.45,328.15L559.25,328.35L559.45,328.25L559.85,328.55L560.75,329.55L560.95,330.15L561.35,330.25L562.05,330.75L562.05,330.95L561.85,331.45L562.05,332.15L561.65,332.15L561.15,332.55L561.05,332.75L560.75,333.75L560.65,334.65L560.45,334.85L560.15,334.65L560.05,334.25L559.65,334.15L559.95,333.65L560.15,333.65L560.65,333.25L560.55,332.85L560.75,332.45L560.75,332.15L560.95,331.85L560.95,331.25L561.15,331.15L561.35,330.85L561.45,330.55L561.15,330.45L560.65,330.35L560.55,330.05L560.55,329.85L560.15,329.65L560.15,329.35L559.85,328.65L559.65,328.55L559.35,328.65L558.85,328.55L558.55,328.55L557.95,328.15L558.45,328.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M634.45,386.25L634.35,385.95L634.65,386.05L634.45,386.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M636.55,293.25L636.25,293.25L636.15,293.35L636.25,293.55L635.85,293.75L635.75,293.65L635.95,293.55L636.05,293.55L636.15,293.25L636.45,293.15L636.55,293.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BB" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M650.75,417.25L650.15,417.05L650.05,416.55L650.05,415.75L650.25,415.35L650.45,415.55L650.65,416.15L651.15,416.45L651.25,416.85L650.75,417.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1232.45,580.55L1231.55,580.45L1231.35,580.05L1231.35,579.75L1231.85,579.85L1232.55,580.35L1232.45,580.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1236.15,578.65L1236.35,579.65L1236.35,580.35L1236.25,580.55L1236.05,580.25L1235.65,579.95L1235.55,579.75L1235.25,579.65L1234.65,579.25L1234.75,579.15L1235.25,579.35L1235.55,579.25L1235.75,578.85L1235.75,578.65L1236.05,578.55L1236.15,578.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1230.45,577.65L1229.95,577.25L1229.65,577.15L1229.35,576.95L1229.15,576.35L1229.25,576.05L1229.25,575.85L1229.45,574.65L1229.35,574.55L1229.55,574.15L1230.05,574.05L1230.25,574.35L1230.05,575.55L1230.15,575.85L1230.35,576.25L1230.45,576.75L1230.65,577.35L1230.45,577.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M847.05,405.75L846.85,406.05L846.65,405.85L846.65,405.55L846.95,405.45L847.05,405.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M848.95,405.85L848.75,405.95L848.35,405.85L848.05,405.55L847.95,405.25L848.15,404.85L848.65,404.55L849.05,404.55L849.25,405.25L849.15,405.65L848.95,405.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M852.45,402.75L852.65,402.85L852.65,403.05L852.85,403.25L853.25,403.75L853.45,403.75L853.65,404.05L853.85,404.55L854.05,404.75L853.75,405.25L853.45,405.35L852.95,405.25L852.65,405.15L852.35,404.85L852.35,404.65L852.15,404.55L852.05,404.15L852.15,403.95L852.15,403.65L852.35,403.25L852.15,402.75L852.45,402.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M855.55,402.75L855.85,402.85L855.95,403.45L855.85,403.85L855.45,404.05L855.05,403.65L855.25,403.25L855.15,403.05L855.55,402.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M857.55,397.05L857.85,396.85L858.35,397.05L858.45,397.25L858.45,397.95L858.05,398.25L857.75,398.45L857.45,398.45L856.95,398.25L856.95,397.75L857.15,397.55L857.15,396.95L857.25,396.85L857.55,397.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M849.55,394.25L849.95,394.15L850.25,394.35L850.65,394.35L850.95,394.55L851.05,394.75L850.55,394.75L849.85,394.45L849.65,394.55L849.35,395.15L849.05,394.55L848.95,394.45L848.85,394.05L849.15,393.95L849.55,394.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M857.35,393.75L857.45,393.85L857.35,394.45L857.15,394.55L857.15,394.05L856.95,393.75L856.95,393.45L856.85,393.15L857.25,392.85L857.45,393.05L857.35,393.65L857.35,393.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M846.05,392.45L846.25,392.75L846.35,393.05L845.65,393.35L845.35,393.15L845.15,392.95L845.55,392.55L846.05,392.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M845.25,390.65L845.55,390.75L845.55,390.95L845.85,391.25L845.65,391.65L845.05,391.95L844.65,392.35L843.95,392.45L843.95,391.85L843.75,391.65L843.75,391.45L843.95,391.25L844.15,391.25L844.35,391.05L845.05,390.65L845.25,390.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M598.25,423.75L597.95,423.75L597.55,423.45L597.25,423.35L596.95,423.05L596.85,422.85L596.55,422.75L596.35,422.35L596.05,422.05L596.15,421.55L596.65,421.85L596.75,422.35L597.15,422.75L597.85,422.95L598.05,423.25L598.35,423.65L598.25,423.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M531.95,377.05L532.25,377.15L532.45,376.75L532.85,376.85L533.35,376.85L533.45,377.05L533.25,377.25L533.05,377.15L532.65,377.25L532.45,377.35L531.75,377.35L531.95,377.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M540.05,374.55L539.35,374.85L539.55,374.55L540.05,374.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M540.65,374.65L540.55,374.55L541.35,374.25L541.15,374.55L540.65,374.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1167.45,275.95L1167.55,276.15L1167.85,276.55L1167.45,276.45L1167.15,276.45L1166.75,276.65L1166.45,276.35L1166.45,276.05L1166.75,275.95L1166.95,276.05L1167.45,275.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1165.75,276.45L1165.75,276.55L1165.55,276.75L1165.45,277.35L1165.35,277.55L1165.05,277.55L1164.85,277.75L1164.35,277.95L1163.55,278.35L1163.15,278.25L1162.65,278.35L1162.35,278.75L1162.15,278.45L1161.85,278.55L1161.65,278.55L1161.35,278.25L1160.95,278.55L1160.45,278.55L1159.95,278.35L1159.45,278.25L1159.05,277.95L1158.75,277.35L1158.45,277.05L1158.25,276.35L1158.05,276.05L1158.15,275.75L1158.65,276.05L1159.05,275.95L1159.25,275.65L1159.35,275.35L1159.65,275.25L1159.85,275.35L1160.05,275.15L1160.25,275.15L1160.35,275.55L1160.85,275.75L1160.95,275.95L1161.55,275.95L1162.15,275.45L1162.55,275.55L1162.85,275.35L1163.15,275.45L1163.55,275.65L1163.75,275.35L1164.05,275.35L1164.35,275.75L1164.35,276.35L1164.65,276.15L1164.95,276.35L1165.05,276.25L1165.75,276.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.25,400.95L641.75,401.05L641.95,401.55L641.95,402.15L641.85,402.95L641.75,403.15L641.15,403.45L641.25,403.05L641.15,402.85L641.05,402.15L640.75,401.65L640.75,401.35L640.85,401.05L640.85,400.75L641.05,400.75L641.25,400.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M696.65,835.45L697.05,835.35L697.05,835.75L696.25,835.45L696.55,835.15L696.75,835.05L696.65,835.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M695.95,834.05L696.15,834.25L696.55,834.35L696.65,834.75L696.35,834.85L696.25,834.45L696.05,834.25L695.95,834.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M702.15,833.25L702.35,833.35L702.25,833.75L701.95,833.65L701.75,833.35L702.05,833.15L702.15,833.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M690.05,832.35L690.05,832.55L690.15,832.85L689.75,832.95L689.45,832.85L689.25,832.65L688.95,832.55L688.85,832.15L689.05,832.15L689.15,831.95L689.45,831.85L689.65,831.95L689.35,832.25L689.65,832.35L689.95,832.05L690.05,832.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M692.95,831.05L692.55,830.85L692.05,830.55L691.25,830.25L691.35,829.85L690.65,829.75L690.35,829.65L690.05,829.25L690.25,829.15L691.05,829.45L691.85,829.85L692.35,829.95L692.75,830.05L693.05,829.75L693.15,829.45L693.35,829.55L693.75,829.35L693.85,829.55L694.35,829.55L694.35,829.85L694.65,829.85L695.55,829.65L695.65,829.85L695.95,829.85L696.35,829.75L696.05,829.55L695.95,829.25L696.35,829.25L696.95,829.45L697.05,829.85L696.65,830.35L696.75,830.65L696.55,830.85L696.15,830.85L695.85,831.65L695.55,831.95L695.25,832.55L695.15,832.85L694.65,833.15L694.55,832.95L694.15,832.95L694.15,833.25L693.35,833.15L693.25,833.25L693.55,833.65L693.45,833.75L693.25,834.15L692.85,834.15L692.55,834.55L692.25,834.65L692.05,834.65L691.85,834.35L691.45,834.05L691.45,833.85L690.95,833.85L691.55,834.25L691.15,834.25L690.65,833.95L690.05,833.65L689.75,833.45L689.75,833.25L690.45,833.45L691.05,833.25L690.55,833.05L690.45,832.95L691.35,832.95L691.75,833.05L692.05,833.25L692.05,833.05L692.45,832.95L692.55,832.65L692.15,832.45L691.95,831.95L692.05,831.75L692.65,831.75L692.85,831.85L693.25,831.75L693.15,831.45L692.35,831.45L692.35,831.55L691.95,831.75L691.35,831.75L690.85,831.45L690.85,831.15L691.55,831.35L692.15,831.15L692.45,831.15L692.95,831.05L693.35,831.25L693.35,831.15L692.95,831.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M694.55,829.15L694.85,829.15L695.15,829.45L694.85,829.55L694.55,829.55L694.55,829.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M693.55,829.15L693.25,829.15L693.15,828.85L693.55,828.95L693.55,829.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M692.15,828.95L692.75,828.85L692.95,829.15L692.65,829.55L692.45,829.45L692.15,829.55L691.85,829.35L692.15,829.15L692.45,829.35L692.55,829.15L692.05,829.05L692.15,828.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M699.35,829.05L699.95,829.05L700.05,828.95L700.55,828.85L700.95,829.05L701.35,829.35L701.45,829.65L701.45,829.75L700.95,829.85L700.75,829.55L700.55,829.45L700.45,829.75L700.65,829.85L700.75,830.15L701.05,829.95L701.25,830.05L701.35,830.45L701.65,830.55L701.75,830.45L702.25,830.75L702.35,830.35L701.55,830.15L701.65,829.65L701.95,829.45L703.45,829.35L704.15,829.95L704.35,830.05L704.35,830.45L703.75,830.35L703.25,830.15L702.65,830.35L702.95,830.55L703.35,830.65L704.25,830.75L704.55,830.85L704.65,831.05L704.45,831.55L703.95,831.55L703.85,831.65L703.15,831.75L702.65,831.95L702.95,832.15L702.05,832.55L701.65,832.45L701.15,832.55L700.45,832.55L699.85,832.35L699.25,831.95L699.25,832.25L699.55,832.45L700.15,832.65L700.45,832.95L700.65,832.85L701.05,832.95L701.45,833.25L701.25,833.35L701.45,833.85L701.25,833.85L700.95,833.55L700.55,833.45L700.05,833.85L699.85,833.55L699.55,833.35L699.25,833.35L698.75,833.15L698.55,833.25L698.75,833.65L699.05,833.65L699.25,833.85L699.05,833.95L699.75,834.55L699.55,834.65L699.15,834.45L698.85,834.45L698.55,834.15L697.95,833.95L697.85,834.55L698.35,834.65L698.35,834.95L698.25,835.15L697.85,835.05L697.75,834.85L697.25,834.65L697.15,834.45L696.95,834.45L696.55,833.95L696.85,833.55L696.85,833.35L696.45,832.85L696.45,832.65L696.95,832.45L696.85,832.25L697.35,832.15L697.25,831.85L697.85,831.45L698.45,831.25L698.85,831.65L698.85,832.05L699.15,831.95L698.65,831.35L698.75,831.05L698.15,830.85L697.75,830.55L697.85,830.35L698.25,830.55L698.35,830.05L697.65,829.85L697.75,829.55L697.95,829.65L698.25,829.45L698.55,829.45L698.75,829.15L698.45,828.85L698.85,828.85L699.35,829.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M694.35,828.65L695.05,828.65L695.25,828.85L695.45,828.65L695.65,828.75L695.85,829.05L695.65,829.15L695.25,829.05L694.85,828.85L694.05,828.75L694.15,828.55L694.35,828.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M687.55,827.55L687.05,827.45L687.15,827.25L687.55,827.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M954.85,111.25L955.25,111.45L955.55,111.45L955.65,111.65L955.65,112.05L955.85,112.35L955.75,112.55L955.15,112.15L954.95,111.75L954.75,111.55L954.55,111.25L954.85,111.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.15,109.65L955.95,109.85L956.15,110.05L956.05,110.45L955.95,110.55L955.55,110.05L955.05,109.95L954.85,109.55L955.15,109.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M953.87,108.29L953.95,108.45L954.25,108.45L954.25,108.75L953.85,108.75L953.65,108.95L953.05,108.75L952.85,108.65L952.65,108.35L953.15,108.25L953.25,108.15L953.81,108.24L953.55,108.05L953.75,107.25L954.25,107.35L954.55,107.85L954.55,107.95L955.15,108.15L955.45,108.65L955.75,108.85L955.65,109.45L955.15,109.05L954.95,108.85L954.75,108.75L954.65,108.55L954.45,108.35L953.95,108.35L953.87,108.29Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M957.55,107.65L957.35,107.45L957.65,107.25L957.55,107.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.15,108.15L954.75,107.95L954.45,107.65L954.35,107.35L954.45,107.25L954.85,107.15L955.15,107.15L955.75,107.55L955.65,107.75L955.75,107.95L956.35,108.15L956.35,108.35L955.95,108.65L955.15,108.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M957.35,107.55L957.05,107.95L956.75,107.75L956.45,107.75L956.65,107.45L956.55,107.05L956.65,106.95L956.85,107.35L957.35,107.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M956.45,107.55L956.25,107.55L956.05,107.15L956.15,106.85L956.35,107.25L956.45,107.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1908.65,466.95L1908.45,467.25L1907.95,467.15L1907.95,466.95L1908.45,466.55L1908.65,466.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1880.45,456.35L1880.85,456.35L1881.15,456.55L1881.25,456.95L1881.05,457.05L1881.15,457.25L1881.05,457.45L1880.45,457.45L1880.25,457.25L1880.25,457.05L1880.05,456.75L1880.05,456.45L1880.45,456.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1765.75,439.75L1765.85,440.05L1765.55,440.05L1765.25,440.55L1765.15,440.45L1765.45,439.65L1765.85,439.55L1765.75,439.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M638.45,423.75L638.05,424.05L637.85,423.95L637.75,423.45L637.95,422.95L638.25,422.55L638.55,422.55L638.65,422.85L638.55,423.55L638.45,423.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1800.05,414.75L1799.95,415.15L1799.95,415.75L1799.85,416.05L1799.55,416.05L1799.35,415.75L1799.25,415.25L1799.25,414.75L1799.85,414.25L1799.95,414.05L1800.05,413.55L1800.25,413.45L1800.35,413.65L1800.75,413.75L1800.55,414.25L1800.05,414.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M635.55,391.25L635.25,391.25L635.15,391.05L635.35,390.65L635.55,390.65L635.65,390.85L635.55,391.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M634.85,389.75L634.75,390.05L634.55,390.05L634.15,389.85L633.95,389.65L634.25,389.25L634.75,389.65L634.85,389.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LC" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M642.95,413.05L642.75,412.85L642.35,412.65L642.25,412.45L642.25,411.85L642.35,411.65L643.05,410.55L643.35,410.75L643.35,411.45L643.25,412.25L643.15,412.65L642.95,413.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.45,385.25L633.05,385.15L633.25,384.85L633.55,384.75L633.45,385.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1402.15,473.95L1402.15,474.25L1401.95,474.15L1402.15,473.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1953.05,455.25L1954.05,455.65L1953.85,455.65L1953.05,455.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1063.15,270.95L1062.95,271.25L1062.45,271.05L1061.95,270.75L1061.95,270.25L1061.85,270.15L1062.45,270.15L1062.85,270.45L1063.05,270.65L1063.15,270.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1061.55,269.85L1061.05,269.75L1061.05,269.55L1061.45,269.45L1061.85,269.75L1061.55,269.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1801.75,410.35L1801.65,410.45L1801.45,410.35L1801.35,410.15L1801.85,409.95L1802.05,410.15L1801.75,410.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1803.25,405.25L1803.05,405.25L1802.75,404.65L1802.85,404.35L1803.15,404.35L1803.15,404.65L1803.35,404.85L1803.25,405.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1803.75,403.65L1803.55,403.85L1803.65,404.15L1803.25,404.15L1803.25,403.45L1803.35,403.25L1803.75,403.05L1803.65,403.55L1803.75,403.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1801.85,396.15L1801.55,396.15L1801.45,395.95L1801.85,395.95L1801.85,396.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1799.95,385.15L1799.85,384.95L1799.85,384.45L1800.15,384.35L1800.35,384.65L1799.95,385.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1798.75,380.85L1798.35,380.75L1798.35,380.45L1798.55,380.35L1798.75,380.55L1798.75,380.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M637.45,393.15L637.65,393.55L637.65,393.85L637.45,394.05L637.25,393.95L637.15,393.65L637.45,393.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1306.95,630.05L1307.35,630.95L1307.15,631.55L1306.75,631.95L1306.85,632.25L1306.55,632.55L1306.05,632.75L1305.55,632.75L1304.95,632.65L1304.85,632.75L1304.55,632.45L1304.75,632.25L1304.85,631.85L1304.95,631.15L1305.15,630.75L1305.65,630.35L1305.75,630.15L1305.95,629.65L1306.35,629.35L1306.75,629.45L1306.95,630.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1338.75,627.95L1338.45,627.65L1338.85,627.45L1339.15,627.35L1339.35,627.45L1339.25,627.65L1338.75,627.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1914.45,646.15L1914.25,646.25L1914.05,646.65L1913.65,646.45L1913.85,645.95L1913.95,645.75L1914.25,645.85L1914.45,646.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1918.85,638.35L1918.75,638.45L1918.95,638.85L1919.25,638.85L1919.65,638.65L1919.55,639.25L1919.35,639.45L1919.25,639.85L1918.75,640.15L1918.35,639.95L1918.35,639.85L1918.05,639.55L1918.15,639.35L1917.95,639.15L1918.05,638.75L1917.95,638.35L1918.05,638.35L1918.45,638.45L1918.85,638.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1916.15,634.05L1915.95,634.55L1915.95,634.95L1915.75,635.25L1916.05,635.45L1916.25,635.55L1916.35,635.75L1916.25,635.95L1916.55,636.35L1916.35,636.35L1916.15,636.85L1915.95,637.05L1915.65,636.95L1915.45,636.65L1915.35,636.45L1914.75,636.35L1914.45,635.85L1914.45,635.65L1914.35,635.35L1914.65,635.35L1914.95,635.15L1915.35,634.85L1915.45,634.55L1915.05,634.35L1914.65,634.45L1914.85,634.05L1915.15,633.95L1915.35,634.05L1915.75,633.75L1916.15,634.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1912.75,632.45L1912.45,633.05L1912.35,633.35L1912.65,633.35L1911.95,634.05L1911.85,633.85L1912.15,633.45L1912.35,632.95L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1912.75,632.45L1912.55,632.05L1912.95,632.05L1913.05,632.45L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1898.85,630.05L1899.05,630.15L1899.55,631.05L1899.85,631.35L1900.15,631.25L1900.35,630.95L1901.25,631.45L1901.55,631.95L1902.25,632.55L1902.55,632.95L1902.65,633.25L1903.05,633.65L1903.15,633.85L1903.35,633.85L1903.65,634.15L1904.55,634.35L1904.65,634.65L1904.65,635.05L1904.95,635.45L1905.35,635.55L1905.05,636.05L1905.15,636.25L1905.55,636.75L1905.65,636.75L1906.05,637.25L1905.95,637.65L1906.65,637.85L1907.05,638.35L1907.35,638.35L1907.65,638.55L1908.15,638.95L1908.05,639.25L1908.35,639.25L1908.75,639.75L1909.35,640.15L1909.35,640.35L1909.65,640.45L1909.95,640.75L1909.95,640.95L1910.25,641.55L1910.65,641.95L1910.75,641.85L1911.15,642.45L1911.65,642.55L1911.95,642.85L1911.95,643.25L1912.05,643.65L1912.15,643.75L1911.95,644.35L1911.25,644.75L1911.15,644.45L1910.85,644.55L1910.55,644.85L1909.95,644.05L1909.55,644.05L1909.45,643.85L1909.25,643.85L1909.05,644.15L1908.15,643.25L1907.95,643.25L1907.55,642.75L1907.65,641.95L1906.95,641.95L1906.65,641.75L1906.55,641.55L1906.35,641.45L1906.05,641.45L1906.05,641.15L1905.85,640.65L1905.45,640.75L1904.65,640.25L1904.55,640.05L1904.55,639.75L1904.25,639.95L1903.65,639.65L1903.55,639.25L1903.15,638.95L1902.95,638.45L1902.45,638.35L1902.65,638.15L1902.35,637.85L1902.05,637.75L1901.75,637.05L1901.75,636.65L1901.55,636.35L1901.25,636.35L1901.05,635.75L1901.15,635.55L1900.45,635.15L1900.15,634.95L1899.75,634.35L1900.05,634.15L1899.85,633.95L1899.65,633.65L1899.65,633.15L1899.15,632.85L1899.15,632.25L1898.95,631.95L1899.25,631.95L1899.35,631.65L1899.25,631.45L1898.65,631.45L1898.45,631.15L1898.95,630.45L1898.65,630.15L1898.85,630.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1899.95,630.35L1899.65,630.25L1899.75,629.85L1899.95,630.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1897.65,627.95L1897.45,628.15L1897.35,627.75L1897.55,627.55L1897.65,627.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1932.25,504.55L1932.05,504.55L1931.95,504.25L1932.25,504.25L1932.25,504.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1746.95,452.35L1746.75,452.75L1746.85,452.85L1746.65,453.45L1746.75,453.65L1746.25,453.85L1746.05,453.15L1746.35,452.95L1746.15,452.75L1746.45,452.15L1746.75,452.05L1746.95,452.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M606.35,385.15L606.05,384.95L606.15,384.75L606.45,384.75L606.55,384.85L606.35,385.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M620.95,384.65L620.75,384.65L619.85,384.95L619.25,384.95L619.45,384.75L619.85,384.55L620.25,384.45L620.85,384.55L620.95,384.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M611.45,382.25L612.05,382.35L612.65,382.35L612.95,382.45L613.55,382.35L613.85,382.45L614.25,382.35L614.45,382.45L614.95,382.35L615.35,382.45L615.65,382.45L616.45,382.65L616.45,382.45L617.05,382.65L617.15,382.55L617.95,382.65L618.15,382.85L618.35,382.85L618.95,383.15L619.15,383.05L619.05,383.75L619.25,384.05L618.35,384.35L618.05,384.75L617.75,385.35L617.45,385.55L617.15,385.65L616.75,385.65L616.15,385.75L615.85,385.95L615.15,385.85L614.95,385.65L614.45,385.85L614.15,385.55L613.45,385.75L612.55,385.65L612.25,385.75L611.65,385.85L611.45,385.95L611.25,385.75L610.85,385.65L610.55,385.85L609.95,385.75L610.25,385.05L610.25,384.65L610.45,384.25L610.25,383.65L610.05,383.55L609.95,383.15L610.55,382.85L610.55,382.35L610.95,382.15L611.45,382.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M194.55,678.55L194.45,678.45L194.25,678.15L194.35,677.95L194.65,678.15L194.55,678.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M204.85,640.45L204.75,640.55L204.45,640.35L204.65,640.15L204.85,640.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M198.65,615.75L198.45,615.65L198.65,615.05L199.15,614.65L199.45,614.65L199.45,614.85L199.25,615.25L198.65,615.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M150.95,614.75L151.65,614.95L151.95,615.35L151.95,615.65L151.75,615.75L151.25,615.65L150.85,615.05L150.75,614.85L150.15,615.05L149.95,615.05L149.35,614.95L149.15,614.55L148.85,614.05L148.85,613.75L148.95,613.55L149.45,613.45L149.95,613.45L150.45,613.65L150.65,614.05L150.75,614.65L150.95,614.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M147.95,613.25L147.75,613.85L147.25,613.65L147.35,613.35L147.85,613.15L147.95,613.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M165.55,604.65L165.25,604.75L165.35,604.45L165.55,604.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M203.55,568.75L203.25,568.75L203.25,568.35L203.05,568.05L203.45,568.15L203.55,568.55L203.55,568.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M200.45,565.25L200.25,565.25L200.25,564.85L200.45,564.55L200.75,564.75L200.55,564.95L200.45,565.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M201.65,563.65L201.65,563.95L201.25,564.05L200.65,564.05L200.65,564.35L200.25,564.25L200.05,564.05L199.95,563.75L200.65,563.35L200.95,563.35L201.15,563.55L201.65,563.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M194.75,561.05L194.75,561.65L194.45,561.65L194.15,561.25L194.45,560.95L194.75,561.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M197.15,558.05L197.45,558.15L197.55,558.25L196.95,558.45L196.85,558.15L197.15,558.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M193.45,557.45L194.35,557.55L194.65,557.85L194.65,558.05L194.25,558.35L193.45,558.35L193.35,557.85L193.25,557.45L193.45,557.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1926.05,575.45L1926.35,575.65L1926.25,576.05L1926.55,576.05L1926.55,576.25L1925.75,576.25L1925.45,575.75L1925.65,575.45L1926.05,575.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1887.75,574.85L1887.95,574.85L1888.95,575.65L1889.45,575.95L1890.35,576.65L1890.25,576.95L1890.05,576.95L1889.85,577.15L1889.65,576.85L1889.55,576.85L1889.35,576.65L1889.25,576.25L1888.85,576.15L1888.85,575.85L1888.55,575.75L1888.45,575.85L1888.25,575.85L1887.35,575.45L1887.15,575.05L1887.45,574.65L1887.75,574.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1924.65,573.35L1924.45,573.65L1924.15,573.45L1924.15,573.25L1924.45,573.05L1924.65,573.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.35,569.45L1922.45,569.55L1922.75,569.55L1922.65,569.95L1922.15,570.15L1921.85,570.15L1921.45,570.25L1921.05,570.85L1920.95,570.55L1920.65,570.65L1920.45,570.45L1920.45,570.15L1920.95,570.05L1920.95,569.85L1921.25,569.45L1921.95,569.55L1922.35,569.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1896.05,566.65L1896.35,566.55L1896.95,566.85L1897.75,567.65L1897.95,567.65L1898.15,567.85L1898.35,567.85L1898.65,568.15L1898.95,568.05L1899.35,568.15L1899.55,568.35L1899.95,568.35L1900.25,568.25L1900.45,568.55L1900.65,569.35L1900.95,569.65L1900.95,570.15L1900.75,570.35L1900.85,570.65L1900.45,570.45L1900.15,570.65L1899.85,570.55L1899.35,570.25L1899.15,570.25L1898.55,570.05L1898.15,569.95L1897.95,569.65L1897.65,569.45L1897.35,569.35L1897.15,569.05L1896.75,568.85L1896.95,568.45L1896.85,568.05L1896.85,567.65L1896.65,567.55L1896.05,567.35L1895.75,567.45L1895.65,567.25L1895.85,566.65L1896.05,566.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1900.05,563.25L1899.95,563.45L1899.95,564.15L1899.75,563.95L1899.75,563.45L1900.05,563.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1897.15,561.45L1897.45,562.35L1897.65,562.75L1897.65,563.15L1897.75,563.65L1897.55,563.95L1897.15,563.25L1897.05,563.55L1896.75,563.05L1896.85,562.05L1896.95,561.85L1896.95,561.55L1897.15,561.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1888.75,561.65L1889.05,561.65L1889.35,561.55L1889.75,561.65L1889.85,561.55L1891.15,561.55L1891.35,561.85L1891.65,561.95L1891.85,562.25L1892.05,562.25L1892.25,562.35L1892.65,562.75L1892.65,563.35L1892.85,563.35L1893.25,563.55L1893.35,563.85L1893.35,564.45L1893.25,564.55L1892.55,564.75L1892.35,564.85L1891.95,564.75L1891.55,564.55L1891.15,564.55L1891.05,564.35L1890.55,564.05L1889.95,564.05L1889.45,564.15L1888.95,564.15L1888.45,564.05L1888.15,563.85L1887.85,563.95L1887.55,563.55L1887.25,563.35L1886.95,562.55L1886.75,562.15L1886.95,561.95L1886.85,561.75L1886.85,561.05L1886.95,560.75L1887.55,560.45L1887.95,560.65L1888.35,561.15L1888.45,561.45L1888.75,561.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1891.05,559.25L1891.55,559.75L1891.25,560.05L1890.95,559.85L1890.95,559.75L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1891.05,559.25L1890.85,559.65L1890.75,559.65L1890.35,559.35L1890.05,559.45L1889.85,559.35L1889.75,559.15L1890.05,559.05L1890.25,558.85L1890.75,558.95L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1884.45,558.75L1884.55,558.95L1884.75,559.05L1884.55,559.45L1884.15,559.65L1883.85,559.25L1884.45,558.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1875.95,556.95L1876.15,557.25L1876.05,557.55L1875.25,557.15L1875.75,556.85L1875.95,556.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1879.35,557.75L1879.05,557.55L1879.15,557.25L1879.45,556.95L1879.45,557.45L1879.55,557.65L1879.35,557.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1878.45,555.95L1878.65,555.85L1879.05,555.85L1879.05,556.05L1878.65,556.35L1878.85,556.55L1878.85,556.85L1878.45,557.25L1878.25,557.35L1877.95,557.25L1877.55,556.85L1877.65,556.25L1877.95,556.15L1878.15,555.75L1878.45,555.65L1878.45,555.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1874.85,556.05L1874.65,556.15L1874.45,556.65L1874.85,557.15L1874.35,556.95L1874.35,556.75L1874.25,556.45L1873.85,556.05L1873.85,555.85L1874.25,555.65L1874.35,555.35L1874.75,555.05L1875.05,555.25L1875.05,555.65L1874.85,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1887.75,555.55L1887.95,555.75L1887.85,555.95L1887.65,555.85L1887.05,555.35L1887.25,554.95L1887.55,554.85L1887.75,555.05L1887.65,555.35L1887.75,555.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1894.25,554.75L1894.65,555.55L1895.25,556.35L1895.25,556.65L1894.85,556.85L1894.85,557.65L1894.95,557.85L1895.15,557.85L1895.35,558.15L1895.85,558.55L1895.95,559.05L1896.05,559.35L1896.25,559.55L1896.05,559.75L1896.35,560.05L1896.25,560.15L1896.35,560.65L1896.15,560.85L1896.45,561.15L1896.55,561.65L1896.75,562.15L1896.75,562.75L1896.65,562.85L1896.35,562.55L1896.05,562.05L1896.05,561.75L1895.75,561.35L1895.35,561.05L1895.05,560.75L1894.55,560.15L1894.15,559.85L1893.85,558.95L1893.65,557.95L1893.45,557.25L1893.45,556.75L1893.35,556.35L1893.75,555.95L1893.65,555.65L1893.15,554.95L1893.05,554.65L1893.15,554.55L1893.55,554.65L1893.75,554.75L1894.05,554.45L1894.25,554.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1873.55,554.45L1873.35,554.05L1873.05,553.75L1873.45,553.75L1873.55,554.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1873.45,553.45L1873.85,553.55L1873.95,553.65L1874.05,554.15L1873.85,554.15L1873.65,553.75L1873.45,553.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1876.55,553.65L1876.45,553.95L1877.15,553.95L1877.55,554.65L1877.55,554.85L1877.75,555.15L1877.85,555.65L1877.65,555.85L1877.65,556.15L1877.05,555.95L1876.85,555.75L1876.55,555.75L1876.15,555.45L1876.05,555.25L1875.95,554.95L1876.35,555.05L1876.05,554.25L1875.95,554.05L1875.45,554.15L1875.25,554.25L1874.85,554.25L1874.55,554.65L1874.15,554.45L1874.15,553.85L1874.35,553.65L1874.75,553.65L1874.75,553.25L1875.15,552.65L1875.55,552.35L1875.85,552.15L1876.25,552.45L1876.45,552.85L1876.35,553.55L1876.55,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1870.65,553.65L1870.55,553.65L1870.35,552.85L1870.45,552.55L1870.45,552.15L1870.65,552.25L1870.75,552.65L1870.75,553.35L1870.65,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1874.05,553.15L1873.75,553.35L1873.65,553.25L1873.25,553.25L1872.95,552.95L1872.75,552.35L1872.85,552.05L1873.15,551.65L1873.65,551.45L1873.85,551.65L1874.15,552.15L1874.15,552.75L1874.05,553.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1871.05,549.65L1871.45,550.15L1871.45,550.25L1872.15,550.65L1872.05,550.95L1871.45,551.65L1871.45,551.95L1871.15,552.05L1871.15,551.65L1870.95,551.65L1870.95,551.25L1870.75,550.85L1870.45,550.65L1870.35,550.35L1870.45,550.05L1870.85,549.65L1871.05,549.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1881.35,549.75L1881.65,549.95L1881.45,550.05L1880.95,550.15L1880.85,549.85L1881.05,549.65L1881.35,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1882.25,549.75L1882.45,549.65L1882.95,549.95L1883.25,550.05L1883.45,550.25L1883.75,550.75L1884.05,550.85L1884.35,551.15L1884.35,551.45L1884.85,551.55L1884.85,551.85L1885.15,551.95L1885.45,551.85L1885.55,551.95L1885.95,552.15L1886.05,552.35L1886.35,552.25L1886.65,552.35L1886.75,552.65L1887.15,552.95L1887.45,553.25L1887.85,553.55L1888.85,554.55L1888.55,554.95L1888.85,555.45L1888.95,556.05L1888.65,555.95L1888.35,555.55L1887.65,554.75L1887.25,554.65L1886.75,554.25L1886.15,554.15L1886.05,553.85L1885.45,553.65L1884.95,553.15L1884.75,553.15L1883.95,552.55L1883.45,552.25L1883.45,552.05L1883.05,551.85L1882.85,551.65L1882.65,551.25L1882.25,550.95L1882.15,550.75L1882.15,550.35L1881.75,549.85L1881.55,549.75L1881.55,549.45L1882.25,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1880.75,549.15L1880.95,549.35L1881.15,549.25L1881.45,549.45L1881.35,549.65L1881.05,549.55L1880.75,549.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1876.25,548.55L1876.75,548.55L1876.55,548.75L1876.25,548.65L1876.25,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1880.55,548.55L1880.35,549.05L1880.25,548.85L1880.55,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1877.85,548.95L1877.35,549.05L1877.15,548.85L1877.45,548.45L1877.75,548.55L1877.85,548.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1865.35,548.05L1865.55,548.35L1865.35,548.55L1865.05,548.45L1864.95,548.35L1865.35,548.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1866.85,546.15L1867.15,546.35L1867.05,546.65L1866.35,546.85L1866.05,546.55L1866.35,545.95L1866.55,545.85L1866.85,546.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1868.55,545.25L1868.55,545.75L1868.35,545.55L1868.35,545.35L1868.55,545.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1871.45,543.75L1871.75,543.85L1872.15,544.35L1872.45,544.55L1872.75,544.65L1873.05,544.95L1873.85,545.35L1874.25,545.85L1874.25,546.25L1874.35,546.85L1874.85,547.35L1875.05,547.35L1875.15,547.75L1875.85,548.05L1876.25,547.95L1876.35,548.05L1876.35,548.35L1876.05,548.45L1875.85,548.75L1875.35,548.55L1874.55,548.15L1874.05,548.15L1873.75,547.75L1873.05,547.35L1871.85,545.35L1871.35,545.05L1870.65,544.35L1870.65,543.65L1870.95,543.45L1871.25,543.55L1871.45,543.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1023.15,500.55L1022.95,500.55L1022.75,500.85L1022.55,500.85L1022.25,499.65L1022.25,499.35L1022.65,498.85L1022.95,498.75L1023.25,498.45L1023.65,498.55L1023.85,498.95L1023.95,499.25L1023.85,499.65L1023.65,499.95L1023.35,500.35L1023.15,500.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1027.75,490.75L1027.65,491.05L1027.45,491.15L1027.15,491.05L1027.15,490.75L1027.35,490.65L1027.35,490.35L1027.55,490.15L1027.85,490.25L1027.75,490.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SX" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.45,385.25L633.45,385.35L633.05,385.25L633.05,385.15L633.45,385.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1248.25,561.35L1247.95,561.55L1247.45,561.55L1247.05,561.75L1246.65,561.75L1246.65,561.55L1247.15,561.55L1247.55,561.45L1247.95,561.15L1248.15,561.15L1248.25,561.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1247.75,561.05L1247.55,561.15L1247.15,561.15L1247.15,560.95L1247.75,561.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1299.65,530.75L1300.05,531.15L1299.85,531.45L1299.65,531.15L1299.35,530.95L1299.55,530.45L1299.65,530.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M586.95,360.85L587.65,360.85L587.95,361.25L587.65,361.25L587.35,361.15L586.85,361.25L586.75,360.95L586.95,360.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M584.25,360.75L584.55,361.15L585.15,361.05L584.95,361.25L584.35,361.25L583.95,361.05L584.25,360.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M586.45,360.15L586.45,360.65L585.95,360.45L585.85,360.15L585.95,360.05L586.45,360.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M642.05,431.45L641.85,431.95L641.55,432.35L641.35,432.45L641.25,432.85L641.45,433.45L641.25,433.55L641.25,434.25L641.45,434.55L641.65,434.75L641.45,434.95L641.35,435.25L641.35,435.95L640.75,436.25L640.25,436.35L639.95,436.35L639.45,436.45L638.95,436.35L638.55,436.45L638.25,436.35L637.75,436.55L637.35,436.35L636.75,436.35L636.45,436.55L636.15,436.45L636.65,436.25L636.95,435.95L637.35,435.85L637.75,435.55L637.95,435.25L638.55,435.35L638.85,434.95L638.65,434.15L638.85,433.75L638.85,433.05L638.55,432.65L638.25,432.55L637.85,432.45L637.75,432.35L638.15,432.05L639.25,431.95L639.45,431.75L640.55,431.75L640.65,431.65L641.85,431.45L642.05,431.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M644.45,428.25L644.35,428.75L644.05,428.85L643.65,429.15L643.45,429.15L642.75,429.55L642.55,429.35L642.85,429.05L643.55,428.55L644.45,428.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1998.15,555.85L1998.15,555.65L1998.25,555.65L1998.25,555.75L1998.15,555.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VC" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.65,416.45L641.35,416.75L640.85,416.45L640.85,416.05L641.05,415.75L641.25,415.25L641.65,415.25L641.75,415.65L641.65,416.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M625.35,382.65L624.95,382.85L624.85,382.85L624.55,383.05L624.45,382.95L624.55,382.65L625.15,382.55L625.35,382.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M623.55,386.85L624.05,387.35L622.95,387.55L622.85,387.05L623.55,386.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M624.45,383.25L624.25,383.45L623.75,383.45L623.75,383.25L624.05,383.15L624.45,383.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M623.05,383.05L623.45,383.35L623.25,383.55L622.95,383.35L622.45,383.35L622.65,383.15L623.05,383.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1931.05,631.05L1930.55,630.85L1930.75,630.45L1931.25,630.35L1931.45,630.75L1931.35,630.95L1931.05,631.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.85,627.25L1929.65,627.25L1929.35,627.15L1928.95,626.65L1928.85,626.25L1928.85,625.85L1929.05,625.65L1929.15,625.25L1929.45,625.15L1929.85,625.15L1929.65,625.45L1929.65,625.95L1930.35,626.45L1930.05,626.75L1929.85,627.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.85,621.35L1930.15,621.35L1930.25,621.55L1929.75,621.65L1929.85,621.95L1930.25,622.15L1930.35,622.45L1930.25,622.85L1929.85,622.95L1929.45,622.65L1929.05,622.65L1928.85,622.45L1928.55,622.25L1928.65,621.85L1928.65,621.55L1928.85,621.05L1929.15,620.65L1929.65,620.65L1929.85,620.75L1929.75,621.15L1929.85,621.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1926.85,613.75L1927.45,613.65L1927.55,613.75L1927.75,614.35L1927.95,614.65L1928.05,614.75L1927.65,615.35L1926.85,615.55L1926.55,615.25L1926.45,614.75L1926.15,614.65L1925.75,614.95L1925.65,614.85L1925.85,614.45L1926.25,614.15L1926.65,613.65L1926.85,613.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.15,609.85L1929.05,609.55L1929.35,609.55L1929.15,609.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.55,607.45L1927.65,607.95L1927.65,608.15L1928.05,608.25L1928.25,608.75L1928.75,608.75L1928.75,609.15L1928.65,609.25L1928.35,608.95L1928.05,608.85L1927.45,609.05L1927.15,608.95L1927.05,608.75L1926.95,608.35L1927.15,607.85L1927.35,607.55L1927.55,607.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1928.45,607.25L1928.35,607.25L1928.25,606.95L1928.45,606.95L1928.45,607.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1928.65,605.85L1928.45,606.05L1927.85,606.05L1927.55,606.15L1927.35,605.95L1926.95,605.85L1926.45,605.45L1926.55,605.25L1927.05,605.05L1927.45,604.95L1927.85,604.65L1927.95,604.35L1928.15,604.35L1928.25,604.65L1928.25,605.25L1928.75,605.65L1928.65,605.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1923.95,604.55L1924.15,604.85L1924.75,605.25L1925.55,606.05L1925.55,606.45L1925.75,606.75L1925.45,606.95L1925.05,607.35L1925.05,607.15L1924.75,607.05L1924.35,607.05L1924.15,607.15L1924.15,607.35L1923.75,607.55L1923.45,607.45L1923.45,606.75L1923.35,606.15L1923.45,605.55L1923.55,605.05L1923.35,604.55L1922.75,604.85L1922.55,604.65L1922.45,604.35L1922.45,604.05L1922.75,603.75L1922.75,603.35L1922.85,603.05L1923.15,602.95L1923.75,603.25L1923.65,603.45L1923.85,603.95L1923.75,604.15L1923.95,604.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1923.35,602.15L1923.05,602.15L1922.55,601.85L1922.55,601.75L1922.75,601.45L1922.95,601.35L1923.45,601.45L1923.35,601.85L1923.35,602.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.85,601.15L1923.25,600.85L1923.35,600.95L1923.45,601.25L1922.95,601.25L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1928.55,603.75L1928.35,603.65L1928.45,602.45L1928.35,602.15L1928.45,601.65L1928.75,600.85L1928.85,600.35L1929.05,600.95L1928.95,601.25L1928.95,602.85L1928.85,603.45L1928.55,603.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.25,600.45L1926.55,600.45L1926.25,600.35L1926.25,600.15L1927.15,599.45L1927.65,599.25L1928.15,599.15L1928.15,599.35L1927.85,599.75L1927.65,600.05L1927.25,600.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.15,599.75L1929.15,599.95L1928.85,599.95L1928.95,599.65L1929.15,598.35L1929.15,598.25L1929.25,597.05L1929.45,597.15L1929.35,598.45L1929.45,598.75L1929.35,599.25L1929.15,599.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.85,601.15L1921.95,601.05L1921.35,601.35L1921.25,601.55L1921.05,601.55L1920.95,600.95L1920.75,600.85L1920.35,599.85L1920.75,599.05L1920.75,598.65L1920.65,598.45L1920.65,597.05L1920.55,596.75L1920.55,596.25L1920.75,595.95L1920.75,595.65L1920.95,595.35L1920.95,595.15L1921.25,595.05L1921.35,595.55L1921.55,595.95L1921.75,596.25L1921.85,597.55L1921.75,598.35L1921.75,598.45L1922.35,598.35L1922.65,598.05L1922.85,597.25L1922.85,597.05L1923.15,596.85L1923.45,596.95L1923.35,597.35L1923.35,598.25L1923.65,598.35L1923.65,598.85L1923.45,598.95L1923.75,599.35L1923.55,599.55L1923.55,600.05L1923.75,600.55L1923.65,600.75L1923.35,600.75L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.05,591.85L1927.45,592.15L1927.35,592.55L1926.85,593.05L1926.25,593.05L1926.25,592.65L1926.35,592.25L1926.55,591.95L1927.05,591.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.65,589.95L1927.35,590.15L1927.15,590.25L1927.15,590.45L1926.95,590.55L1926.95,590.25L1926.75,590.05L1926.65,589.75L1926.75,589.35L1927.35,589.05L1927.45,589.25L1927.55,589.65L1927.55,589.75L1927.65,589.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.65,585.75L1922.55,585.65L1922.65,585.15L1922.85,585.35L1922.65,585.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BQBO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M601.25,423.85L601.05,423.85L600.95,423.35L601.05,423.05L600.95,422.75L600.55,422.65L600.25,422.35L600.35,422.05L601.55,422.65L601.45,422.85L601.45,423.25L601.25,423.45L601.25,423.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BQSE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.55,388.85L633.35,388.95L633.35,388.75L633.45,388.65L633.55,388.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BQSA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M632.05,387.95L631.95,387.95L632.05,387.75L632.15,387.85L632.05,387.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MQ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M643.25,406.15L643.25,406.35L643.65,406.25L643.45,406.75L643.65,406.95L643.65,407.15L643.85,407.35L644.05,408.25L643.75,408.55L643.65,408.15L643.55,408.25L642.95,408.15L642.55,408.15L642.35,407.85L642.95,407.35L642.55,407.35L642.15,406.95L642.05,406.45L641.85,405.95L642.15,405.55L642.55,405.65L643.05,405.95L643.25,406.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M887.65,322.65L887.35,323.15L886.95,323.65L886.65,323.25L886.25,323.25L886.05,323.05L886.25,322.75L886.65,322.85L887.05,322.45L887.35,322.25L887.55,322.35L887.65,322.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M901.25,320.35L901.25,320.85L901.45,321.25L901.25,321.95L901.35,322.25L900.95,322.65L900.45,322.85L900.25,323.05L899.65,322.85L899.15,322.35L898.95,321.95L898.95,321.35L899.55,320.95L899.65,320.45L899.65,320.25L900.25,320.35L900.65,320.35L900.95,320.45L901.25,320.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M891.55,321.15L891.15,321.15L890.85,320.95L890.65,320.65L890.75,320.25L890.85,319.95L891.45,319.95L891.95,320.35L892.05,320.65L891.55,321.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M897.45,317.65L897.45,317.85L896.85,318.15L896.45,318.65L896.15,318.85L896.15,319.25L895.75,319.95L895.65,320.35L895.15,320.95L895.05,321.15L894.85,321.15L894.25,321.35L894.15,321.25L894.05,320.85L893.75,320.45L893.65,320.25L893.45,319.95L893.45,319.65L893.05,319.05L893.55,318.75L893.85,318.95L894.45,318.75L894.85,318.75L895.35,318.55L895.85,318.15L895.85,317.95L896.45,317.65L897.05,317.65L897.35,317.55L897.45,317.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M907.65,320.45L907.35,320.85L906.95,320.95L906.65,320.85L906.25,320.85L906.25,320.65L906.55,320.65L907.15,320.45L907.55,320.15L907.85,319.85L907.95,319.35L908.05,319.05L908.25,318.55L908.55,318.15L908.85,317.55L909.05,316.75L909.25,316.55L909.65,316.45L909.95,316.75L910.05,317.25L909.85,318.25L909.85,318.75L909.75,318.85L909.45,319.55L909.15,319.85L908.55,319.95L907.85,320.25L907.65,320.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M888.05,315.95L888.35,315.85L888.55,316.15L888.75,316.65L888.55,316.95L888.65,317.35L888.05,318.35L887.95,318.25L887.85,317.85L887.45,316.95L887.35,316.65L887.25,316.45L887.45,316.05L887.75,315.85L888.05,315.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M912.15,313.95L912.15,314.35L911.95,314.85L911.25,315.35L910.75,315.45L910.35,315.95L909.85,315.75L909.85,315.65L910.05,315.25L910.05,314.85L910.25,314.55L910.55,314.35L910.85,314.35L911.15,314.05L911.65,314.05L911.75,313.95L911.95,313.45L912.15,313.35L912.35,313.55L912.15,313.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="YT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1239.45,582.35L1239.65,582.65L1240.15,582.85L1240.15,583.15L1239.95,583.35L1240.05,583.55L1239.75,584.15L1239.85,584.35L1239.55,584.45L1239.35,584.15L1239.35,583.85L1239.55,583.65L1239.35,582.95L1239.25,582.85L1239.15,582.65L1239.45,582.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1293.75,635.05L1294.65,635.05L1295.05,635.25L1295.35,635.55L1295.35,635.85L1295.45,636.35L1295.75,636.55L1295.95,636.75L1296.05,636.95L1295.85,637.55L1295.75,637.95L1295.55,638.15L1295.15,638.25L1294.25,638.25L1294.05,638.05L1293.25,637.65L1292.95,637.15L1292.95,636.85L1292.65,636.25L1292.75,635.85L1292.95,635.65L1293.15,635.25L1293.25,635.25L1293.75,635.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M642.25,399.15L641.95,399.15L641.75,398.75L641.85,398.55L642.15,398.25L642.45,398.45L642.55,398.75L642.55,398.95L642.25,399.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M640.45,396.55L640.75,396.55L640.75,396.85L640.55,396.95L640.55,398.15L640.35,398.35L639.75,398.65L639.75,398.45L639.55,398.25L639.45,397.75L639.45,397.25L639.35,396.75L639.35,396.45L639.55,396.15L639.85,396.05L640.35,396.35L640.45,396.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.85,396.15L642.25,396.25L642.75,396.65L641.45,396.95L641.15,397.05L640.75,396.75L640.85,396.15L641.05,396.05L640.95,395.45L641.05,395.25L641.35,395.05L641.65,395.45L641.65,395.85L641.85,396.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1988.35,624.15L1988.05,624.25L1988.15,623.85L1988.35,624.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1980.85,622.55L1981.05,622.75L1981.35,622.85L1981.35,623.15L1980.85,623.35L1980.35,623.05L1979.85,623.35L1979.55,623.35L1979.35,623.65L1979.45,623.95L1979.05,623.85L1978.95,624.05L1978.55,623.95L1978.45,624.05L1978.05,623.85L1978.35,623.75L1978.55,623.65L1978.75,623.45L1979.15,623.55L1979.45,623.25L1979.65,622.95L1980.15,622.85L1980.65,622.55L1980.85,622.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1981.75,622.45L1981.55,622.55L1981.35,622.45L1981.55,622.25L1981.75,622.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1987.65,616.35L1987.75,616.85L1987.55,617.45L1987.45,617.25L1987.35,616.85L1987.15,616.85L1987.25,616.35L1987.45,616.25L1987.65,616.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1985.05,614.95L1984.95,614.95L1984.85,614.55L1985.05,614.35L1985.45,614.25L1985.45,614.65L1985.25,614.85L1985.05,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1982.85,612.45L1982.75,612.85L1983.05,613.05L1983.15,613.35L1983.45,613.75L1983.75,613.85L1983.85,614.15L1984.05,614.15L1984.15,614.55L1983.85,615.05L1983.95,615.25L1984.05,615.75L1983.75,615.95L1983.75,616.45L1983.95,616.45L1984.05,616.95L1983.75,617.25L1983.15,617.45L1983.05,617.25L1982.75,617.35L1982.65,617.55L1982.35,617.25L1981.55,617.55L1980.75,618.25L1980.45,618.15L1980.05,618.35L1979.75,618.25L1979.15,618.35L1978.85,618.15L1977.65,617.75L1977.05,617.65L1976.85,617.55L1976.35,617.35L1976.15,616.35L1976.45,615.65L1976.75,615.65L1977.05,615.55L1977.15,615.05L1977.45,614.95L1977.55,614.55L1977.35,614.35L1977.95,613.95L1978.35,613.45L1978.45,613.55L1979.05,613.05L1979.25,613.05L1980.15,612.65L1980.75,612.85L1981.05,612.75L1981.55,612.55L1982.15,612.45L1982.45,612.15L1982.85,612.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1989.15,612.65L1988.95,612.75L1989.15,611.85L1989.55,611.85L1989.45,612.25L1989.15,612.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1977.75,610.65L1977.55,610.95L1977.05,611.25L1977.05,610.95L1977.45,610.55L1977.75,610.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1992.65,610.25L1992.45,610.05L1992.55,609.85L1993.05,609.35L1993.35,608.85L1993.05,609.95L1992.65,610.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1993.65,605.25L1993.25,605.65L1992.45,606.75L1992.15,606.85L1991.45,607.25L1991.25,607.85L1990.85,608.05L1990.65,608.35L1990.55,608.55L1990.85,608.65L1991.45,608.35L1991.85,607.95L1992.05,607.65L1992.65,607.35L1992.95,607.05L1993.55,606.75L1993.55,607.05L1993.05,607.75L1992.85,607.85L1992.95,608.45L1992.65,608.75L1992.35,608.45L1991.95,608.45L1991.45,608.55L1991.05,608.85L1990.35,608.95L1989.35,608.95L1989.85,608.45L1989.45,608.25L1988.85,608.45L1988.45,608.65L1988.45,608.85L1988.15,608.95L1987.95,609.05L1987.85,609.45L1987.65,609.75L1987.35,609.65L1987.35,609.45L1986.95,609.35L1986.55,609.55L1986.35,610.05L1986.05,610.25L1985.75,610.25L1985.75,609.55L1985.55,609.15L1985.65,608.95L1985.55,608.85L1984.95,609.05L1984.95,608.65L1985.35,608.35L1985.45,608.35L1985.35,607.85L1985.65,607.75L1986.15,608.05L1986.75,607.65L1986.95,607.65L1987.25,607.35L1987.45,607.35L1987.75,607.05L1987.75,606.85L1988.55,606.75L1989.75,606.35L1990.15,606.45L1990.65,606.25L1990.85,605.85L1991.05,605.85L1991.25,605.45L1991.65,605.55L1991.75,605.35L1991.95,605.45L1992.95,604.95L1993.05,605.25L1993.25,605.15L1993.45,605.25L1993.75,604.95L1994.25,604.75L1994.35,604.85L1993.85,605.25L1993.65,605.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), B15 = [
  N15
];
function R15(t, e) {
  return G(), J("svg", Z15, B15);
}
const H15 = /* @__PURE__ */ U5($15, [["render", R15]]), L45 = /* @__PURE__ */ J5({
  __name: "IconWorldMaps",
  props: {
    region: { default: "All" }
  },
  setup(t) {
    const e = t, r = g5(() => {
      switch (e.region) {
        case "Caucasian":
          return c15;
        case "Latino/Hispanic":
          return E15;
        case "MENA":
          return m15;
        case "African":
          return X55;
        case "South Asian":
          return A15;
        case "East Asian":
          return i15;
        case "Pacific Islander":
          return k15;
        default:
          return H15;
      }
    });
    return (n, L) => (G(), sr(Tl(r.value), { class: "opacity-30 fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color" }));
  }
}), F15 = {}, j15 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, U15 = /* @__PURE__ */ w("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
}, null, -1), Y15 = [
  U15
];
function V15(t, e) {
  return G(), J("svg", j15, Y15);
}
const a45 = /* @__PURE__ */ U5(F15, [["render", V15]]), W15 = {}, G15 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, q15 = /* @__PURE__ */ w("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 224c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zm-96 32c0 53 43 96 96 96s96-43 96-96s-43-96-96-96s-96 43-96 96zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
}, null, -1), K15 = [
  q15
];
function J15(t, e) {
  return G(), J("svg", G15, K15);
}
const s45 = /* @__PURE__ */ U5(W15, [["render", J15]]), Q15 = {}, X15 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, ee5 = /* @__PURE__ */ w("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
}, null, -1), te5 = [
  ee5
];
function re5(t, e) {
  return G(), J("svg", X15, te5);
}
const l45 = /* @__PURE__ */ U5(Q15, [["render", re5]]), ne5 = /* @__PURE__ */ J5({
  __name: "IconLoad",
  props: {
    size: { default: 50 }
  },
  setup(t) {
    const e = t, r = g5(() => `height: ${e.size}px; width: ${e.size}px`);
    return (n, L) => (G(), J("span", {
      class: "loader",
      style: Xe(r.value)
    }, null, 4));
  }
}), oe5 = /* @__PURE__ */ U5(ne5, [["__scopeId", "data-v-b3f76107"]]), ie5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, u45 = /* @__PURE__ */ J5({
  __name: "IconMicrophone",
  props: {
    liveRecording: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, r) => (G(), J("svg", ie5, [
      w("path", {
        class: N5({
          "fill-bl-icon-default-color": !e.liveRecording,
          "dark:fill-bl-dk-icon-default-color": !e.liveRecording,
          "fill-bl-error-color": e.liveRecording,
          "dark:fill-bl-dk-error-color": e.liveRecording
        }),
        d: "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
      }, null, 2)
    ]));
  }
}), Le5 = {
  id: "profile",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384.07 383.9"
}, ae5 = { key: 0 }, se5 = {
  id: "gradient",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, le5 = { id: "Layer_1-2" }, ue5 = /* @__PURE__ */ J5({
  __name: "IconPerson",
  props: {
    color: { default: "#ff0000" },
    gradient: {}
  },
  setup(t) {
    return (e, r) => (G(), J("svg", Le5, [
      e.gradient ? (G(), J("defs", ae5, [
        w("linearGradient", se5, [
          w("stop", {
            offset: "0%",
            style: Xe({ stopColor: e.gradient.start, stopOpacity: 100 })
          }, null, 4),
          w("stop", {
            offset: "100%",
            style: Xe({ stopColor: e.gradient.stop, stopOpacity: 100 })
          }, null, 4)
        ])
      ])) : _1("", !0),
      w("g", le5, [
        w("path", {
          style: Xe({ background: e.color }),
          d: "M192,383.8c-62.29,0-124.58-.04-186.88,.1-4.12,0-5.31-.87-5.11-5.1,.5-10.14,1.04-20.27,1.71-30.41,.57-8.6,4.9-14.61,11.27-19.64,10.12-8,21.61-13.62,33.27-18.91,24.38-11.05,49.74-19.5,75.09-27.98,19.59-6.55,21.52-9.37,21.51-30.18,0-4-.04-7.99-.05-11.99-.02-8.09-2.28-15.2-7.63-21.58-9.43-11.23-12.33-25.2-14.96-39.12-1.37-7.24-3.39-14.02-7.03-20.57-5.29-9.53-7.39-20.23-8.67-31.01-.21-1.78,.17-7.72,.85-9.33,4.57-10.93,2.24-18.33,.22-29.06C97.52,46.15,131.26,5.3,177.85,.78c22.38-2.17,44.01-.22,63.67,11.44,21.92,13.01,34.91,32.36,37.91,57.86,1.07,9.13-1.09,18.24-1.82,27.35-.6,7.62-2.82,12.5,.22,20.03,1.19,2.94,1.98,8.84,1.38,10.47-2.38,10.01-5.36,26.87-11.05,35.78-3.55,5.56-3.64,12.38-4.9,18.7-2.85,14.36-7.13,27.99-16.98,39.33-2.77,3.18-4.01,7.21-4.39,11.47-.82,9.31-.51,18.62-.29,27.94,.22,9.36,5.07,14.75,13.41,17.66,11.59,4.05,23.24,7.94,34.81,12.04,23.16,8.22,46.21,16.72,67.71,28.84,3.76,2.12,7.34,4.56,10.94,6.94,9.22,6.11,14.39,14.39,14.43,25.78,.03,8.99,.48,17.98,1.14,26.94,.29,3.94-1.09,4.52-4.66,4.52-62.46-.11-124.92-.08-187.38-.08Z"
        }, null, 4)
      ])
    ]));
  }
}), c45 = /* @__PURE__ */ U5(ue5, [["__scopeId", "data-v-83e017f0"]]), ce5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, he5 = {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"
}, h45 = /* @__PURE__ */ J5({
  __name: "IconSignal",
  props: {
    connected: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, r) => (G(), J("svg", ce5, [
      ne(w("path", {
        class: N5({
          "fill-bl-icon-default-color": !e.connected,
          "dark:fill-bl-dk-icon-default-color": !e.connected,
          "fill-bl-success-color": e.connected,
          "dark:fill-bl-dk-success-color": e.connected
        }),
        d: "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
      }, null, 2), [
        [zt, !e.interactive || e.interactive && e.connected]
      ]),
      ne(w("path", he5, null, 512), [
        [zt, e.interactive && !e.connected]
      ])
    ]));
  }
}), de5 = {}, fe5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, pe5 = /* @__PURE__ */ w("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
}, null, -1), ge5 = [
  pe5
];
function me5(t, e) {
  return G(), J("svg", fe5, ge5);
}
const d45 = /* @__PURE__ */ U5(de5, [["render", me5]]), ve5 = ["id"], ye5 = {
  key: 0,
  class: "flex items-end relative input-container"
}, we5 = { class: "input-wrapper flex items-end relative mr-0.5" }, be5 = ["value", "placeholder"], xe5 = { class: "flex flex-col sm:flex-row justify-start datepicker-inputs-container" }, ke5 = { class: "input-wrapper flex items-end relative mr-0.5" }, Me5 = { class: "input-background" }, _e5 = ["value", "placeholder", "onChange", "onInput", "onKeyup", "onFocus", "onBlur"], Ce5 = {
  name: "MfxDatePicker",
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
  components: { IconCalendar: vL }
}, f45 = /* @__PURE__ */ J5({
  ...Ce5,
  props: {
    modelValue: {
      type: [Date, String],
      default: "",
      required: !0
    },
    localeOverride: {
      type: String,
      default: void 0,
      required: !1
    },
    // eslint-disable-next-line vue/require-default-prop -- Resolve the next time you touch this
    placeholder: {
      type: String,
      required: !1
    },
    hideSvg: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1,
      required: !1
    },
    showBlur: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !0
    },
    useModal: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    },
    teleportId: {
      type: String,
      default: "body"
    },
    modalId: {
      type: String,
      required: !0
    }
  },
  emits: [
    "update:modelValue",
    "datePickerOpen",
    "datePickerClose"
  ],
  setup(t, { emit: e }) {
    const r = t, n = u5(), L = u5(), i = u5(), { modelValue: l } = ht(r), { localValue: s } = Zn(l, e), c = u5(), h = u5(), f = g5(
      () => r.showBlur ? "backdrop-filter: blur(5px);" : "background-color: #0003;"
    ), g = g5(() => {
      if (s.value) {
        const B = new Date(s.value);
        return r.localeOverride && B ? new Intl.DateTimeFormat(r.localeOverride).format(B) : s.value;
      }
      return s.value;
    }), m = un({
      weekdays: "WWW"
    }), b = un({
      enUS: "en-US",
      deDE: "de-DE"
    }), k = u5(!1), x = u5(""), D = u5(""), M = g5(
      () => r.localeOverride ? r.localeOverride : b.deDE
    ), E = () => {
      k.value = !0, e("datePickerOpen"), A();
    }, S = () => {
      k.value = !1, e("datePickerClose"), P();
    }, C = (B = "", U) => {
      const K = (a5) => a5 instanceof KeyboardEvent;
      if (!c.value || !K(U))
        return;
      const r5 = U.keyCode;
      if (r5 === 13) {
        B.length < 10 && (c.value.value = "");
        return;
      }
      if (r5 > 31 && (r5 < 48 || r5 > 57) && r5 < 96 && r5 > 105 || r5 === 190)
        c.value.value = B.slice(0, B.length - 1);
      else if (B.length === 2 && B[1] !== "/" && B[1] !== "." && U.code !== "Backspace" && (x.value = +B > 31 ? "31" : B, c.value.value = x.value + "."), B.length === 5 && B[4] !== "/" && B[4] !== "." && U.code !== "Backspace") {
        const a5 = B.split(".")[1];
        D.value = +a5 > 12 ? "12" : a5, c.value.value = `${x.value}.${D.value}.`;
      }
    }, P = () => {
      var B;
      r.showBlur && ((B = n.value) == null || B.classList.toggle("portrait-mode"));
    }, A = () => {
      var B, U, K;
      (B = n.value) == null || B.classList.toggle("datepicker-open"), (U = n.value) != null && U.classList.contains("portrait-mode") && ((K = n.value) == null || K.classList.toggle("portrait-mode"));
    }, Z = () => {
      L.value.classList.toggle("show"), L.value.classList.toggle("noShow"), i.value.classList.toggle("show"), i.value.classList.toggle("noShow");
    };
    return J1(() => {
      window.addEventListener("click", (B) => {
        i.value && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        B.target.id === i.value.id && Z();
      });
    }), SL(() => {
      window.removeEventListener("click", () => {
      });
    }), g1(
      () => s.value,
      () => {
        L.value.classList.remove("show"), L.value.classList.add("noShow"), i.value.classList.remove("show"), i.value.classList.add("noShow");
      }
    ), (B, U) => (G(), J(Be, null, [
      (G(), sr(Hw, { to: t.teleportId }, [
        ne(w("div", {
          id: t.modalId,
          ref_key: "refBlocker",
          ref: i,
          class: "blocker noShow datepicker-wrapper",
          style: Xe(f.value)
        }, [
          ne(w("div", {
            id: "dateModal",
            ref_key: "refModal",
            ref: L,
            class: "flex items-center justify-center fixed noShow modalContainer"
          }, [
            s5(Z5(cl), {
              modelValue: Z5(s),
              "onUpdate:modelValue": U[0] || (U[0] = (K) => T0(s) ? s.value = K : null),
              style: { "z-index": "800" },
              locale: M.value,
              masks: m,
              "update-on-input": !0,
              "trim-weeks": ""
            }, null, 8, ["modelValue", "locale", "masks"])
          ], 512), [
            [zt, t.useModal]
          ])
        ], 12, ve5), [
          [zt, t.useModal]
        ])
      ], 8, ["to"])),
      t.useModal ? (G(), J("div", ye5, [
        w("div", we5, [
          w("input", {
            ref_key: "dateInput",
            ref: c,
            class: "outline-none w-[144px] font-bold text-sm date-picker-input bg-transparent",
            maxlength: "10",
            value: g.value,
            placeholder: t.placeholder,
            readonly: "",
            onClick: Z
          }, null, 8, be5),
          s5(Z5(vL), { hide: t.hideSvg }, null, 8, ["hide"])
        ])
      ])) : _1("", !0),
      t.useModal ? _1("", !0) : (G(), J("div", {
        key: 1,
        ref_key: "datepickerWrapper",
        ref: n,
        "test-name": "dp-name",
        class: "inline items-end justify-center datepicker-wrapper portrait-mode-focus date-picker"
      }, [
        s5(Z5(cl), {
          ref_key: "datepicker",
          ref: h,
          modelValue: Z5(s),
          "onUpdate:modelValue": U[2] || (U[2] = (K) => T0(s) ? s.value = K : null),
          "data-testid": "datePicker",
          locale: M.value,
          masks: m,
          "update-on-input": !0,
          "trim-weeks": "",
          onChange: U[3] || (U[3] = (K) => C(Z5(s).toString(), K)),
          onPopoverWillShow: E,
          onPopoverWillHide: S,
          onPopoverDidShow: P,
          onPopoverDidHide: A
        }, {
          default: Je(({
            inputValue: K,
            inputEvents: r5,
            togglePopover: a5,
            showPopover: V,
            hidePopover: l5
          }) => [
            w("div", xe5, [
              w("div", {
                class: N5(["flex items-end relative input-container", { "input-state": k.value }])
              }, [
                w("div", ke5, [
                  ne(w("div", Me5, null, 512), [
                    [zt, k.value]
                  ]),
                  w("input", {
                    ref_key: "dateInput",
                    ref: c,
                    class: "outline-none w-[144px] font-bold text-sm date-picker-input bg-transparent",
                    maxlength: "10",
                    value: K,
                    placeholder: t.placeholder,
                    readonly: "",
                    onChange: r5.change,
                    onInput: r5.input,
                    onKeyup: [
                      Ol(a5, ["enter"]),
                      U[1] || (U[1] = (d5) => {
                        var m5;
                        return C((m5 = c.value) == null ? void 0 : m5.value, d5);
                      })
                    ],
                    onFocus: V,
                    onBlur: l5
                  }, null, 40, _e5)
                ]),
                s5(Z5(vL))
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "locale", "masks"])
      ], 512))
    ], 64));
  }
}), Se5 = (t) => (V0("data-v-98f9a007"), t = t(), W0(), t), De5 = ["tab-index", "type", "name"], Ee5 = {
  key: 0,
  "data-test-id": "loading-spinner",
  class: "flex items-center justify-center absolute left-0 top-0 w-full h-full bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color"
}, Ie5 = /* @__PURE__ */ Se5(() => /* @__PURE__ */ w("svg", {
  class: "spinner text-black",
  viewBox: "0 0 50 50"
}, [
  /* @__PURE__ */ w("circle", {
    class: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    "stroke-width": "5",
    stroke: "currentColor"
  })
], -1)), Te5 = [
  Ie5
], Oe5 = {
  name: "MfxButton"
}, ze5 = /* @__PURE__ */ J5({
  ...Oe5,
  props: {
    name: { default: "" },
    type: {},
    content: { default: "" },
    tabIndex: { default: 0 },
    isCloseButton: { type: Boolean, default: !1 },
    classes: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const r = t, n = EL(), L = g5(() => !!(n != null && n.default)), i = g5(() => {
      const c = r.content;
      return !c && !(c && c.length) && !L.value;
    }), l = g5(() => {
      const c = {
        "bl-button--no-content": i.value,
        "modal-close-button": r.isCloseButton,
        "bl-button": !0,
        "text-bl-bold": !0,
        "font-bold": !0,
        flex: !0,
        "items-center": !0,
        "bg-bl-button-background-default-color": !0,
        "dark:bg-bl-dk-button-background-default-color": !0,
        "text-bl-text-color": !0,
        "dark:text-bl-dk-text-color": !0
      };
      let h = ge().toString(c);
      return r.classes && (h = Qe(
        h,
        ge().toString(r.classes)
      )), h;
    }), s = (c) => {
      e("click", c);
    };
    return (c, h) => (G(), J("button", {
      "tab-index": c.tabIndex,
      type: c.type,
      name: c.name,
      class: N5(["relative overflow-hidden", [l.value]]),
      onClick: s
    }, [
      c.$slots.default ? (G(), J("div", {
        key: 0,
        class: N5(["flex items-center justify-center h-full", { "mr-1": !!c.content }])
      }, [
        d1(c.$slots, "default", {}, void 0, !0)
      ], 2)) : _1("", !0),
      O0(" " + y5(c.content) + " ", 1),
      d1(c.$slots, "loader", {}, () => [
        c.loading ? (G(), J("div", Ee5, Te5)) : _1("", !0)
      ], !0)
    ], 10, De5));
  }
}), hl = /* @__PURE__ */ U5(ze5, [["__scopeId", "data-v-98f9a007"]]), Pe5 = { class: "w-full modal__header" }, Ae5 = {
  key: 0,
  class: "w-full flex justify-center items-center"
}, $e5 = { class: "w-full modal__body" }, Ze5 = {
  key: 0,
  class: "w-full flex justify-center items-center"
}, Ne5 = { class: "w-full modal__footer" }, Be5 = {
  key: 0,
  class: "w-full flex justify-center items-center"
}, Re5 = { class: "w-full modal__header" }, He5 = { class: "w-full modal__body" }, Fe5 = { class: "w-full modal__footer" }, je5 = {
  name: "MfxModal"
}, p45 = /* @__PURE__ */ J5({
  ...je5,
  props: {
    showModal: { type: Boolean, default: !1 },
    type: { default: "default" },
    autoCloseOnClick: { type: Boolean, default: !0 },
    confirmContent: { default: "" }
  },
  emits: ["onHide", "onCancel", "onConfirm"],
  setup(t, { emit: e }) {
    const r = t, n = u5(!1), L = () => {
      n.value = !1, e("onHide");
    }, i = () => {
      L(), e("onCancel");
    }, l = () => {
      L(), e("onConfirm");
    };
    return g1(
      () => r.showModal,
      (s) => {
        n.value = s;
      },
      {
        immediate: !0
      }
    ), (s, c) => (G(), sr(DL, { name: "fade" }, {
      default: Je(() => [
        n.value ? (G(), J("div", {
          key: 0,
          class: "backdrop flex items-center justify-center",
          onClick: c[1] || (c[1] = _4(() => s.autoCloseOnClick && L(), ["prevent", "stop"]))
        }, [
          w("div", {
            class: N5([{ "modal--confirm": s.type === "confirm" }, "modal flex flex-col rounded-panel shadow-md bg-bl-panel-color dark:bg-bl-dk-panel-color"]),
            onClick: c[0] || (c[0] = _4(() => {
            }, ["stop"]))
          }, [
            s.type === "confirm" ? (G(), J(Be, { key: 0 }, [
              w("div", Pe5, [
                d1(s.$slots, "header"),
                s.$slots.header ? _1("", !0) : (G(), J("div", Ae5, [
                  s5(cc, {
                    width: 12.7,
                    height: 15.9,
                    "view-box": "0 0 12.7 15.9"
                  }, {
                    default: Je(() => [
                      s5(QX)
                    ]),
                    _: 1
                  })
                ]))
              ]),
              w("div", $e5, [
                d1(s.$slots, "body"),
                s.$slots.body ? _1("", !0) : (G(), J("div", Ze5, [
                  w("p", null, y5(s.confirmContent), 1)
                ]))
              ]),
              w("div", Ne5, [
                d1(s.$slots, "footer"),
                s.$slots.footer ? _1("", !0) : (G(), J("div", Be5, [
                  s5(hl, { onClick: i }, {
                    default: Je(() => [
                      d1(s.$slots, "cancelIcon")
                    ]),
                    _: 3
                  }),
                  s5(hl, { onClick: l }, {
                    default: Je(() => [
                      d1(s.$slots, "confirmIcon")
                    ]),
                    _: 3
                  })
                ]))
              ])
            ], 64)) : (G(), J(Be, { key: 1 }, [
              w("div", Re5, [
                d1(s.$slots, "header")
              ]),
              w("div", He5, [
                d1(s.$slots, "body")
              ]),
              w("div", Fe5, [
                d1(s.$slots, "footer")
              ])
            ], 64))
          ], 2)
        ])) : _1("", !0)
      ]),
      _: 3
    }));
  }
}), Ue5 = { class: "numeric--stepper flex items-center rounded-full" }, Ye5 = ["readonly"], Ve5 = {
  id: "Layer_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  style: { "enable-background": "new 0 0 30 30" },
  "xml:space": "preserve",
  class: "[ w-8 cursor-pointer ]"
}, We5 = /* @__PURE__ */ w("g", {
  id: "Gruppe_4535",
  transform: "translate(17772 8414)"
}, [
  /* @__PURE__ */ w("circle", {
    id: "Ellipse_433",
    class: "svgCircle",
    cx: "-17757",
    cy: "-8399",
    r: "15"
  }),
  /* @__PURE__ */ w("g", {
    id: "Gruppe_4221",
    transform: "translate(-17762 -8404)"
  }, [
    /* @__PURE__ */ w("line", {
      id: "Linie_216",
      class: "svgLines",
      x1: "10",
      y1: "5",
      x2: "0",
      y2: "5"
    })
  ])
], -1), Ge5 = [
  We5
], qe5 = { class: "block relative mx-2.5 h-6 input-wrapper" }, Ke5 = ["id", "name", "min", "max", "step", "required", "readonly", "disabled", "placeholder"], Je5 = ["readonly"], Qe5 = {
  id: "Layer_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  style: { "enable-background": "new 0 0 30 30" },
  "xml:space": "preserve",
  class: "[ w-8 cursor-pointer ]"
}, Xe5 = /* @__PURE__ */ Le('<g id="Gruppe_4535" transform="translate(17772 8414)"><circle id="Ellipse_433" class="svgCircle" cx="-17757" cy="-8399" r="15"></circle><g id="Gruppe_4221" transform="translate(-17762 -8404)"><line id="Linie_215" class="svgLines" x1="5" y1="0" x2="5" y2="10"></line><line id="Linie_216" class="svgLines" x1="10" y1="5" x2="0" y2="5"></line></g></g>', 1), et5 = [
  Xe5
], tt5 = {
  name: "MfxNumericStepper"
}, g45 = /* @__PURE__ */ J5({
  ...tt5,
  props: {
    // eslint-disable-next-line vue/require-default-prop -- Resolve the next time you touch this
    attrs: {
      type: Object,
      required: !1
    },
    disabled: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    },
    inputtable: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !0
    },
    placeholder: {
      type: String,
      default: "N/A"
    },
    readonly: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    step: {
      type: Number,
      default: 1
    },
    // eslint-disable-next-line vue/require-default-prop -- Resolve the next time you touch this
    name: {
      type: String,
      required: !1
    },
    modelValue: {
      type: [String, Number],
      required: !0
    },
    maxCharacterWidth: {
      type: String,
      default: "10ch"
    },
    holdDetectionDelay: {
      type: Number,
      default: 250
    },
    increaseUpdateSpeedOnHold: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !0
    },
    updateOnHoldDelay: {
      type: Number,
      default: 200,
      validator: (t) => t >= 0
    },
    updateOnHoldFactor: {
      type: Number,
      default: 0.96,
      validator: (t) => t > 0
    },
    // eslint-disable-next-line vue/require-default-prop -- Resolve the next time you touch this
    instanceKey: {
      type: Number
    },
    enableScrollToQuestion: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    },
    required: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    }
  },
  emits: ["update:modelValue", "valueChanged"],
  setup(t, { expose: e, emit: r }) {
    const n = t, { modelValue: L } = ht(n), { localValue: i } = Zn(L, r);
    let l, s = 0;
    const c = u5(!1), h = u5(), f = u5("input-id"), g = u5(`ku-${s++}`), m = Number.isNaN || window.isNaN, b = /\.\d*(?:0|9){10}\d*$/, k = g5(() => m(i.value) || i.value >= n.min), x = g5(() => m(i.value) || i.value < n.max), D = g5(() => i.value || i.value === 0 ? `${i.value.toString().length + 4}ch` : "6ch"), M = (V, l5 = 1e11) => b.test(String(V)) ? Math.round(Number(V) * l5) / l5 : V, E = (V, l5 = !1) => {
      let d5 = typeof V != "number" ? Number(V) : V;
      if (d5 < n.min && l5 && !n.required) {
        i.value = null;
        return;
      }
      m(d5) || n.min <= n.max && (d5 = Math.min(n.max, Math.max(n.min, d5))), i.value = d5;
    };
    let S = 0;
    const C = (V) => {
      const l5 = Number(V.target.value);
      (!V.target.value || l5 < n.min || l5 > n.max) && h.value.reportValidity(), V.target.value && (E(l5, l5 <= S), S = l5);
    }, P = () => {
      k.value && (m(i.value) && (i.value = 0), E(
        M(Number(i.value) - n.step),
        !0
      ));
    }, A = () => {
      x.value && (m(i.value) && (i.value = 0), E(M(Number(i.value) + n.step)));
    }, Z = () => {
      clearTimeout(l), l = void 0, c.value = !1;
    }, B = (V) => {
      Z(), l = setTimeout(() => {
        c.value = !0;
        let l5 = n.updateOnHoldDelay, d5 = setTimeout(m5(V), l5);
        function m5(M5) {
          return () => {
            clearTimeout(d5), l5 >= 1 && n.increaseUpdateSpeedOnHold && (l5 = l5 * n.updateOnHoldFactor), M5(), c.value && (d5 = setTimeout(m5(M5), l5));
          };
        }
      }, n.holdDetectionDelay);
    }, U = () => {
      B(A);
    }, K = () => {
      B(P);
    };
    J1(() => {
      n.instanceKey && (f.value = `${f.value}-${n.instanceKey}`), n.required ? i.value = n.min : i.value = "";
    });
    const r5 = (V) => {
      const l5 = document.documentElement.getBoundingClientRect();
      if (n.enableScrollToQuestion && l5.y === 0) {
        let d5 = h.value;
        for (let m5 = 0; m5 < 10; m5++)
          if (d5)
            if (d5.className.includes("input-wrapper-label-group")) {
              const M5 = Array.from(d5.children);
              for (const _5 of M5) {
                const $5 = Array.from(_5.children);
                for (const E5 of $5)
                  E5.tagName.toLowerCase() === "label" && E5.scrollIntoView({ behavior: "smooth" });
              }
            } else
              d5 = d5 == null ? void 0 : d5.parentElement;
      }
    }, a5 = (V) => {
      n.required && !V.target.value && (i.value = n.min, g.value = `ku-${s++}`);
    };
    return e({
      props: ht(n),
      increase: A,
      decrease: P,
      change: C,
      setValue: E,
      localValue: i.value
    }), (V, l5) => (G(), J("div", Ue5, [
      w("button", {
        type: "button",
        tabindex: "-1",
        readonly: t.disabled || t.readonly || !k.value,
        class: "svg--container",
        onClick: P,
        onTouchstart: K,
        onMousedown: K,
        onMouseleave: Z,
        onMouseup: Z,
        onTouchend: Z
      }, [
        (G(), J("svg", Ve5, Ge5))
      ], 40, Ye5),
      w("span", qe5, [
        ne((G(), J("input", zl({
          id: f.value,
          key: g.value
        }, t.attrs, {
          ref_key: "inputRef",
          ref: h,
          "onUpdate:modelValue": l5[0] || (l5[0] = (d5) => T0(i) ? i.value = d5 : null),
          type: "number",
          name: t.name,
          min: t.min,
          max: t.max,
          step: t.step,
          required: t.required,
          readonly: t.readonly || !t.inputtable,
          disabled: t.disabled || !k.value && !x.value,
          placeholder: t.placeholder,
          autocomplete: "off",
          pattern: "[0-9]*",
          style: {
            width: D.value,
            maxWidth: t.maxCharacterWidth
          },
          class: "numeric--stepper__input border-0 h-5 p-0 font-sans font-bold bg-transparent placeholder-bl-text-placeholder-color dark:placeholder-bl-dk-text-placeholder-color",
          onChange: C,
          onFocusin: r5,
          onFocusout: a5,
          onInput: C
        }), null, 16, Ke5)), [
          [f4, Z5(i)]
        ])
      ]),
      w("button", {
        type: "button",
        tabindex: "-1",
        readonly: t.disabled || t.readonly || !x.value,
        class: "svg--container",
        onClick: A,
        onTouchstart: U,
        onMousedown: U,
        onMouseleave: Z,
        onMouseup: Z,
        onTouchend: Z
      }, [
        (G(), J("svg", Qe5, et5))
      ], 40, Je5)
    ]));
  }
});
function yL(t, e, r) {
  var n, L, i, l, s;
  e == null && (e = 100);
  function c() {
    var f = Date.now() - l;
    f < e && f >= 0 ? n = setTimeout(c, e - f) : (n = null, r || (s = t.apply(i, L), i = L = null));
  }
  var h = function() {
    i = this, L = arguments, l = Date.now();
    var f = r && !n;
    return n || (n = setTimeout(c, e)), f && (s = t.apply(i, L), i = L = null), s;
  };
  return h.clear = function() {
    n && (clearTimeout(n), n = null);
  }, h.flush = function() {
    n && (s = t.apply(i, L), i = L = null, clearTimeout(n), n = null);
  }, h;
}
yL.debounce = yL;
var Oi = yL;
function rt5(t, e, r) {
  T0(t) ? g1(t, (n, L) => {
    L == null || L.removeEventListener(e, r), n == null || n.addEventListener(e, r);
  }) : J1(() => {
    t.addEventListener(e, r);
  }), Dn(() => {
    var n;
    (n = Z5(t)) === null || n === void 0 || n.removeEventListener(e, r);
  });
}
function nt5(t, e) {
  return typeof window > "u" || !window ? void 0 : rt5(window, "pointerdown", (n) => {
    const L = Z5(t);
    L && (L === n.target || n.composedPath().includes(L) || e(n));
  });
}
function ot5(t, e, r) {
  let n = null;
  const L = u5(!1);
  J1(() => {
    (t.content !== void 0 || r.value) && (L.value = !0), n = new MutationObserver(i), n.observe(e.value, {
      childList: !0,
      subtree: !0
    });
  }), Dn(() => n.disconnect()), g1(r, (l) => {
    l ? L.value = !0 : L.value = !1;
  });
  const i = () => {
    t.content ? L.value = !0 : L.value = !1;
  };
  return {
    hasContent: L
  };
}
function bn(t, e) {
  var r = t.getBoundingClientRect(), n = 1, L = 1;
  return {
    width: r.width / n,
    height: r.height / L,
    top: r.top / L,
    right: r.right / n,
    bottom: r.bottom / L,
    left: r.left / n,
    x: r.left / n,
    y: r.top / L
  };
}
function Lt(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function z3(t) {
  var e = Lt(t), r = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function F0(t) {
  var e = Lt(t).Element;
  return t instanceof e || t instanceof Element;
}
function $e(t) {
  var e = Lt(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Dh(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Lt(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function it5(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Lt5(t) {
  return t === Lt(t) || !$e(t) ? z3(t) : it5(t);
}
function pt(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function cr(t) {
  return ((F0(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function P3(t) {
  return bn(cr(t)).left + z3(t).scrollLeft;
}
function At(t) {
  return Lt(t).getComputedStyle(t);
}
function A3(t) {
  var e = At(t), r = e.overflow, n = e.overflowX, L = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + L + n);
}
function at5(t) {
  var e = t.getBoundingClientRect(), r = e.width / t.offsetWidth || 1, n = e.height / t.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function st5(t, e, r) {
  r === void 0 && (r = !1);
  var n = $e(e);
  $e(e) && at5(e);
  var L = cr(e), i = bn(t), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((pt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  A3(L)) && (l = Lt5(e)), $e(e) ? (s = bn(e), s.x += e.clientLeft, s.y += e.clientTop) : L && (s.x = P3(L))), {
    x: i.left + l.scrollLeft - s.x,
    y: i.top + l.scrollTop - s.y,
    width: i.width,
    height: i.height
  };
}
function $3(t) {
  var e = bn(t), r = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: n
  };
}
function Eo(t) {
  return pt(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Dh(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    cr(t)
  );
}
function Eh(t) {
  return ["html", "body", "#document"].indexOf(pt(t)) >= 0 ? t.ownerDocument.body : $e(t) && A3(t) ? t : Eh(Eo(t));
}
function E0(t, e) {
  var r;
  e === void 0 && (e = []);
  var n = Eh(t), L = n === ((r = t.ownerDocument) == null ? void 0 : r.body), i = Lt(n), l = L ? [i].concat(i.visualViewport || [], A3(n) ? n : []) : n, s = e.concat(l);
  return L ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(E0(Eo(l)))
  );
}
function lt5(t) {
  return ["table", "td", "th"].indexOf(pt(t)) >= 0;
}
function dl(t) {
  return !$e(t) || // https://github.com/popperjs/popper-core/issues/837
  At(t).position === "fixed" ? null : t.offsetParent;
}
function ut5(t) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && $e(t)) {
    var n = At(t);
    if (n.position === "fixed")
      return null;
  }
  for (var L = Eo(t); $e(L) && ["html", "body"].indexOf(pt(L)) < 0; ) {
    var i = At(L);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return L;
    L = L.parentNode;
  }
  return null;
}
function i2(t) {
  for (var e = Lt(t), r = dl(t); r && lt5(r) && At(r).position === "static"; )
    r = dl(r);
  return r && (pt(r) === "html" || pt(r) === "body" && At(r).position === "static") ? e : r || ut5(t) || e;
}
var Ze = "top", nt = "bottom", ot = "right", Ne = "left", Z3 = "auto", L2 = [Ze, nt, ot, Ne], xn = "start", j0 = "end", ct5 = "clippingParents", Ih = "viewport", y0 = "popper", ht5 = "reference", fl = /* @__PURE__ */ L2.reduce(function(t, e) {
  return t.concat([e + "-" + xn, e + "-" + j0]);
}, []), Th = /* @__PURE__ */ [].concat(L2, [Z3]).reduce(function(t, e) {
  return t.concat([e, e + "-" + xn, e + "-" + j0]);
}, []), dt5 = "beforeRead", ft5 = "read", pt5 = "afterRead", gt5 = "beforeMain", mt5 = "main", vt5 = "afterMain", yt5 = "beforeWrite", wt5 = "write", bt5 = "afterWrite", xt5 = [dt5, ft5, pt5, gt5, mt5, vt5, yt5, wt5, bt5];
function kt5(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function L(i) {
    r.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(s) {
      if (!r.has(s)) {
        var c = e.get(s);
        c && L(c);
      }
    }), n.push(i);
  }
  return t.forEach(function(i) {
    r.has(i.name) || L(i);
  }), n;
}
function Mt5(t) {
  var e = kt5(t);
  return xt5.reduce(function(r, n) {
    return r.concat(e.filter(function(L) {
      return L.phase === n;
    }));
  }, []);
}
function _t5(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function ct(t) {
  return t.split("-")[0];
}
function Ct5(t) {
  var e = t.reduce(function(r, n) {
    var L = r[n.name];
    return r[n.name] = L ? Object.assign({}, L, n, {
      options: Object.assign({}, L.options, n.options),
      data: Object.assign({}, L.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
function St5(t) {
  var e = Lt(t), r = cr(t), n = e.visualViewport, L = r.clientWidth, i = r.clientHeight, l = 0, s = 0;
  return n && (L = n.width, i = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (l = n.offsetLeft, s = n.offsetTop)), {
    width: L,
    height: i,
    x: l + P3(t),
    y: s
  };
}
var ar = Math.max, U0 = Math.min, a4 = Math.round;
function Dt5(t) {
  var e, r = cr(t), n = z3(t), L = (e = t.ownerDocument) == null ? void 0 : e.body, i = ar(r.scrollWidth, r.clientWidth, L ? L.scrollWidth : 0, L ? L.clientWidth : 0), l = ar(r.scrollHeight, r.clientHeight, L ? L.scrollHeight : 0, L ? L.clientHeight : 0), s = -n.scrollLeft + P3(t), c = -n.scrollTop;
  return At(L || r).direction === "rtl" && (s += ar(r.clientWidth, L ? L.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function Oh(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && Dh(r)) {
    var n = e;
    do {
      if (n && t.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function wL(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Et5(t) {
  var e = bn(t);
  return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e;
}
function pl(t, e) {
  return e === Ih ? wL(St5(t)) : $e(e) ? Et5(e) : wL(Dt5(cr(t)));
}
function It5(t) {
  var e = E0(Eo(t)), r = ["absolute", "fixed"].indexOf(At(t).position) >= 0, n = r && $e(t) ? i2(t) : t;
  return F0(n) ? e.filter(function(L) {
    return F0(L) && Oh(L, n) && pt(L) !== "body";
  }) : [];
}
function Tt5(t, e, r) {
  var n = e === "clippingParents" ? It5(t) : [].concat(e), L = [].concat(n, [r]), i = L[0], l = L.reduce(function(s, c) {
    var h = pl(t, c);
    return s.top = ar(h.top, s.top), s.right = U0(h.right, s.right), s.bottom = U0(h.bottom, s.bottom), s.left = ar(h.left, s.left), s;
  }, pl(t, i));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function kn(t) {
  return t.split("-")[1];
}
function N3(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function zh(t) {
  var e = t.reference, r = t.element, n = t.placement, L = n ? ct(n) : null, i = n ? kn(n) : null, l = e.x + e.width / 2 - r.width / 2, s = e.y + e.height / 2 - r.height / 2, c;
  switch (L) {
    case Ze:
      c = {
        x: l,
        y: e.y - r.height
      };
      break;
    case nt:
      c = {
        x: l,
        y: e.y + e.height
      };
      break;
    case ot:
      c = {
        x: e.x + e.width,
        y: s
      };
      break;
    case Ne:
      c = {
        x: e.x - r.width,
        y: s
      };
      break;
    default:
      c = {
        x: e.x,
        y: e.y
      };
  }
  var h = L ? N3(L) : null;
  if (h != null) {
    var f = h === "y" ? "height" : "width";
    switch (i) {
      case xn:
        c[h] = c[h] - (e[f] / 2 - r[f] / 2);
        break;
      case j0:
        c[h] = c[h] + (e[f] / 2 - r[f] / 2);
        break;
    }
  }
  return c;
}
function Ph() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ah(t) {
  return Object.assign({}, Ph(), t);
}
function $h(t, e) {
  return e.reduce(function(r, n) {
    return r[n] = t, r;
  }, {});
}
function B3(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, L = n === void 0 ? t.placement : n, i = r.boundary, l = i === void 0 ? ct5 : i, s = r.rootBoundary, c = s === void 0 ? Ih : s, h = r.elementContext, f = h === void 0 ? y0 : h, g = r.altBoundary, m = g === void 0 ? !1 : g, b = r.padding, k = b === void 0 ? 0 : b, x = Ah(typeof k != "number" ? k : $h(k, L2)), D = f === y0 ? ht5 : y0, M = t.rects.popper, E = t.elements[m ? D : f], S = Tt5(F0(E) ? E : E.contextElement || cr(t.elements.popper), l, c), C = bn(t.elements.reference), P = zh({
    reference: C,
    element: M,
    strategy: "absolute",
    placement: L
  }), A = wL(Object.assign({}, M, P)), Z = f === y0 ? A : C, B = {
    top: S.top - Z.top + x.top,
    bottom: Z.bottom - S.bottom + x.bottom,
    left: S.left - Z.left + x.left,
    right: Z.right - S.right + x.right
  }, U = t.modifiersData.offset;
  if (f === y0 && U) {
    var K = U[L];
    Object.keys(B).forEach(function(r5) {
      var a5 = [ot, nt].indexOf(r5) >= 0 ? 1 : -1, V = [Ze, nt].indexOf(r5) >= 0 ? "y" : "x";
      B[r5] += K[V] * a5;
    });
  }
  return B;
}
var gl = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ml() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Ot5(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, n = r === void 0 ? [] : r, L = e.defaultOptions, i = L === void 0 ? gl : L;
  return function(l, s, c) {
    c === void 0 && (c = i);
    var h = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, gl, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], g = !1, m = {
      state: h,
      setOptions: function(x) {
        var D = typeof x == "function" ? x(h.options) : x;
        k(), h.options = Object.assign({}, i, h.options, D), h.scrollParents = {
          reference: F0(l) ? E0(l) : l.contextElement ? E0(l.contextElement) : [],
          popper: E0(s)
        };
        var M = Mt5(Ct5([].concat(n, h.options.modifiers)));
        return h.orderedModifiers = M.filter(function(E) {
          return E.enabled;
        }), b(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var x = h.elements, D = x.reference, M = x.popper;
          if (ml(D, M)) {
            h.rects = {
              reference: st5(D, i2(M), h.options.strategy === "fixed"),
              popper: $3(M)
            }, h.reset = !1, h.placement = h.options.placement, h.orderedModifiers.forEach(function(B) {
              return h.modifiersData[B.name] = Object.assign({}, B.data);
            });
            for (var E = 0; E < h.orderedModifiers.length; E++) {
              if (h.reset === !0) {
                h.reset = !1, E = -1;
                continue;
              }
              var S = h.orderedModifiers[E], C = S.fn, P = S.options, A = P === void 0 ? {} : P, Z = S.name;
              typeof C == "function" && (h = C({
                state: h,
                options: A,
                name: Z,
                instance: m
              }) || h);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: _t5(function() {
        return new Promise(function(x) {
          m.forceUpdate(), x(h);
        });
      }),
      destroy: function() {
        k(), g = !0;
      }
    };
    if (!ml(l, s))
      return m;
    m.setOptions(c).then(function(x) {
      !g && c.onFirstUpdate && c.onFirstUpdate(x);
    });
    function b() {
      h.orderedModifiers.forEach(function(x) {
        var D = x.name, M = x.options, E = M === void 0 ? {} : M, S = x.effect;
        if (typeof S == "function") {
          var C = S({
            state: h,
            name: D,
            instance: m,
            options: E
          }), P = function() {
          };
          f.push(C || P);
        }
      });
    }
    function k() {
      f.forEach(function(x) {
        return x();
      }), f = [];
    }
    return m;
  };
}
var s4 = {
  passive: !0
};
function zt5(t) {
  var e = t.state, r = t.instance, n = t.options, L = n.scroll, i = L === void 0 ? !0 : L, l = n.resize, s = l === void 0 ? !0 : l, c = Lt(e.elements.popper), h = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && h.forEach(function(f) {
    f.addEventListener("scroll", r.update, s4);
  }), s && c.addEventListener("resize", r.update, s4), function() {
    i && h.forEach(function(f) {
      f.removeEventListener("scroll", r.update, s4);
    }), s && c.removeEventListener("resize", r.update, s4);
  };
}
var Pt5 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: zt5,
  data: {}
};
function At5(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = zh({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
var $t5 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: At5,
  data: {}
}, Zt5 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Nt5(t) {
  var e = t.x, r = t.y, n = window, L = n.devicePixelRatio || 1;
  return {
    x: a4(a4(e * L) / L) || 0,
    y: a4(a4(r * L) / L) || 0
  };
}
function vl(t) {
  var e, r = t.popper, n = t.popperRect, L = t.placement, i = t.variation, l = t.offsets, s = t.position, c = t.gpuAcceleration, h = t.adaptive, f = t.roundOffsets, g = f === !0 ? Nt5(l) : typeof f == "function" ? f(l) : l, m = g.x, b = m === void 0 ? 0 : m, k = g.y, x = k === void 0 ? 0 : k, D = l.hasOwnProperty("x"), M = l.hasOwnProperty("y"), E = Ne, S = Ze, C = window;
  if (h) {
    var P = i2(r), A = "clientHeight", Z = "clientWidth";
    P === Lt(r) && (P = cr(r), At(P).position !== "static" && s === "absolute" && (A = "scrollHeight", Z = "scrollWidth")), P = P, (L === Ze || (L === Ne || L === ot) && i === j0) && (S = nt, x -= P[A] - n.height, x *= c ? 1 : -1), (L === Ne || (L === Ze || L === nt) && i === j0) && (E = ot, b -= P[Z] - n.width, b *= c ? 1 : -1);
  }
  var B = Object.assign({
    position: s
  }, h && Zt5);
  if (c) {
    var U;
    return Object.assign({}, B, (U = {}, U[S] = M ? "0" : "", U[E] = D ? "0" : "", U.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + x + "px)" : "translate3d(" + b + "px, " + x + "px, 0)", U));
  }
  return Object.assign({}, B, (e = {}, e[S] = M ? x + "px" : "", e[E] = D ? b + "px" : "", e.transform = "", e));
}
function Bt5(t) {
  var e = t.state, r = t.options, n = r.gpuAcceleration, L = n === void 0 ? !0 : n, i = r.adaptive, l = i === void 0 ? !0 : i, s = r.roundOffsets, c = s === void 0 ? !0 : s, h = {
    placement: ct(e.placement),
    variation: kn(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: L
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, vl(Object.assign({}, h, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: l,
    roundOffsets: c
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, vl(Object.assign({}, h, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
var Rt5 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Bt5,
  data: {}
};
function Ht5(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var n = e.styles[r] || {}, L = e.attributes[r] || {}, i = e.elements[r];
    !$e(i) || !pt(i) || (Object.assign(i.style, n), Object.keys(L).forEach(function(l) {
      var s = L[l];
      s === !1 ? i.removeAttribute(l) : i.setAttribute(l, s === !0 ? "" : s);
    }));
  });
}
function Ft5(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var L = e.elements[n], i = e.attributes[n] || {}, l = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : r[n]), s = l.reduce(function(c, h) {
        return c[h] = "", c;
      }, {});
      !$e(L) || !pt(L) || (Object.assign(L.style, s), Object.keys(i).forEach(function(c) {
        L.removeAttribute(c);
      }));
    });
  };
}
var jt5 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Ht5,
  effect: Ft5,
  requires: ["computeStyles"]
}, Ut5 = [Pt5, $t5, Rt5, jt5], Yt5 = /* @__PURE__ */ Ot5({
  defaultModifiers: Ut5
});
function Vt5(t) {
  return t === "x" ? "y" : "x";
}
function x4(t, e, r) {
  return ar(t, U0(e, r));
}
function Wt5(t) {
  var e = t.state, r = t.options, n = t.name, L = r.mainAxis, i = L === void 0 ? !0 : L, l = r.altAxis, s = l === void 0 ? !1 : l, c = r.boundary, h = r.rootBoundary, f = r.altBoundary, g = r.padding, m = r.tether, b = m === void 0 ? !0 : m, k = r.tetherOffset, x = k === void 0 ? 0 : k, D = B3(e, {
    boundary: c,
    rootBoundary: h,
    padding: g,
    altBoundary: f
  }), M = ct(e.placement), E = kn(e.placement), S = !E, C = N3(M), P = Vt5(C), A = e.modifiersData.popperOffsets, Z = e.rects.reference, B = e.rects.popper, U = typeof x == "function" ? x(Object.assign({}, e.rects, {
    placement: e.placement
  })) : x, K = {
    x: 0,
    y: 0
  };
  if (A) {
    if (i || s) {
      var r5 = C === "y" ? Ze : Ne, a5 = C === "y" ? nt : ot, V = C === "y" ? "height" : "width", l5 = A[C], d5 = A[C] + D[r5], m5 = A[C] - D[a5], M5 = b ? -B[V] / 2 : 0, _5 = E === xn ? Z[V] : B[V], $5 = E === xn ? -B[V] : -Z[V], E5 = e.elements.arrow, f5 = b && E5 ? $3(E5) : {
        width: 0,
        height: 0
      }, e1 = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Ph(), C1 = e1[r5], I5 = e1[a5], R5 = x4(0, Z[V], f5[V]), L1 = S ? Z[V] / 2 - M5 - R5 - C1 - U : _5 - R5 - C1 - U, f1 = S ? -Z[V] / 2 + M5 + R5 + I5 + U : $5 + R5 + I5 + U, t1 = e.elements.arrow && i2(e.elements.arrow), a1 = t1 ? C === "y" ? t1.clientTop || 0 : t1.clientLeft || 0 : 0, Ue = e.modifiersData.offset ? e.modifiersData.offset[e.placement][C] : 0, W = A[C] + L1 - Ue - a1, n5 = A[C] + f1 - Ue;
      if (i) {
        var e5 = x4(b ? U0(d5, W) : d5, l5, b ? ar(m5, n5) : m5);
        A[C] = e5, K[C] = e5 - l5;
      }
      if (s) {
        var o5 = C === "x" ? Ze : Ne, w5 = C === "x" ? nt : ot, P5 = A[P], r1 = P5 + D[o5], j1 = P5 - D[w5], S1 = x4(b ? U0(r1, W) : r1, P5, b ? ar(j1, n5) : j1);
        A[P] = S1, K[P] = S1 - P5;
      }
    }
    e.modifiersData[n] = K;
  }
}
var Gt5 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Wt5,
  requiresIfExists: ["offset"]
}, qt5 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function k4(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return qt5[e];
  });
}
var Kt5 = {
  start: "end",
  end: "start"
};
function yl(t) {
  return t.replace(/start|end/g, function(e) {
    return Kt5[e];
  });
}
function Jt5(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, L = r.boundary, i = r.rootBoundary, l = r.padding, s = r.flipVariations, c = r.allowedAutoPlacements, h = c === void 0 ? Th : c, f = kn(n), g = f ? s ? fl : fl.filter(function(k) {
    return kn(k) === f;
  }) : L2, m = g.filter(function(k) {
    return h.indexOf(k) >= 0;
  });
  m.length === 0 && (m = g);
  var b = m.reduce(function(k, x) {
    return k[x] = B3(t, {
      placement: x,
      boundary: L,
      rootBoundary: i,
      padding: l
    })[ct(x)], k;
  }, {});
  return Object.keys(b).sort(function(k, x) {
    return b[k] - b[x];
  });
}
function Qt5(t) {
  if (ct(t) === Z3)
    return [];
  var e = k4(t);
  return [yl(t), e, yl(e)];
}
function Xt5(t) {
  var e = t.state, r = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var L = r.mainAxis, i = L === void 0 ? !0 : L, l = r.altAxis, s = l === void 0 ? !0 : l, c = r.fallbackPlacements, h = r.padding, f = r.boundary, g = r.rootBoundary, m = r.altBoundary, b = r.flipVariations, k = b === void 0 ? !0 : b, x = r.allowedAutoPlacements, D = e.options.placement, M = ct(D), E = M === D, S = c || (E || !k ? [k4(D)] : Qt5(D)), C = [D].concat(S).reduce(function(I5, R5) {
      return I5.concat(ct(R5) === Z3 ? Jt5(e, {
        placement: R5,
        boundary: f,
        rootBoundary: g,
        padding: h,
        flipVariations: k,
        allowedAutoPlacements: x
      }) : R5);
    }, []), P = e.rects.reference, A = e.rects.popper, Z = /* @__PURE__ */ new Map(), B = !0, U = C[0], K = 0; K < C.length; K++) {
      var r5 = C[K], a5 = ct(r5), V = kn(r5) === xn, l5 = [Ze, nt].indexOf(a5) >= 0, d5 = l5 ? "width" : "height", m5 = B3(e, {
        placement: r5,
        boundary: f,
        rootBoundary: g,
        altBoundary: m,
        padding: h
      }), M5 = l5 ? V ? ot : Ne : V ? nt : Ze;
      P[d5] > A[d5] && (M5 = k4(M5));
      var _5 = k4(M5), $5 = [];
      if (i && $5.push(m5[a5] <= 0), s && $5.push(m5[M5] <= 0, m5[_5] <= 0), $5.every(function(I5) {
        return I5;
      })) {
        U = r5, B = !1;
        break;
      }
      Z.set(r5, $5);
    }
    if (B)
      for (var E5 = k ? 3 : 1, f5 = function(I5) {
        var R5 = C.find(function(L1) {
          var f1 = Z.get(L1);
          if (f1)
            return f1.slice(0, I5).every(function(t1) {
              return t1;
            });
        });
        if (R5)
          return U = R5, "break";
      }, e1 = E5; e1 > 0; e1--) {
        var C1 = f5(e1);
        if (C1 === "break")
          break;
      }
    e.placement !== U && (e.modifiersData[n]._skip = !0, e.placement = U, e.reset = !0);
  }
}
var er5 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Xt5,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function tr5(t, e, r) {
  var n = ct(t), L = [Ne, Ze].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, l = i[0], s = i[1];
  return l = l || 0, s = (s || 0) * L, [Ne, ot].indexOf(n) >= 0 ? {
    x: s,
    y: l
  } : {
    x: l,
    y: s
  };
}
function rr5(t) {
  var e = t.state, r = t.options, n = t.name, L = r.offset, i = L === void 0 ? [0, 0] : L, l = Th.reduce(function(f, g) {
    return f[g] = tr5(g, e.rects, i), f;
  }, {}), s = l[e.placement], c = s.x, h = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += c, e.modifiersData.popperOffsets.y += h), e.modifiersData[n] = l;
}
var nr5 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: rr5
}, or5 = function(t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, Ah(typeof t != "number" ? t : $h(t, L2));
};
function ir5(t) {
  var e, r = t.state, n = t.name, L = t.options, i = r.elements.arrow, l = r.modifiersData.popperOffsets, s = ct(r.placement), c = N3(s), h = [Ne, ot].indexOf(s) >= 0, f = h ? "height" : "width";
  if (!(!i || !l)) {
    var g = or5(L.padding, r), m = $3(i), b = c === "y" ? Ze : Ne, k = c === "y" ? nt : ot, x = r.rects.reference[f] + r.rects.reference[c] - l[c] - r.rects.popper[f], D = l[c] - r.rects.reference[c], M = i2(i), E = M ? c === "y" ? M.clientHeight || 0 : M.clientWidth || 0 : 0, S = x / 2 - D / 2, C = g[b], P = E - m[f] - g[k], A = E / 2 - m[f] / 2 + S, Z = x4(C, A, P), B = c;
    r.modifiersData[n] = (e = {}, e[B] = Z, e.centerOffset = Z - A, e);
  }
}
function Lr5(t) {
  var e = t.state, r = t.options, n = r.element, L = n === void 0 ? "[data-popper-arrow]" : n;
  L != null && (typeof L == "string" && (L = e.elements.popper.querySelector(L), !L) || Oh(e.elements.popper, L) && (e.elements.arrow = L));
}
var ar5 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ir5,
  effect: Lr5,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const zi = (t) => parseInt(t, 10);
function sr5({
  arrowPadding: t,
  emit: e,
  locked: r,
  offsetDistance: n,
  offsetSkid: L,
  placement: i,
  popperNode: l,
  triggerNode: s
}) {
  const c = un({
    isOpen: !1,
    popperInstance: null
  }), h = (x) => {
    var D;
    (D = c.popperInstance) === null || D === void 0 || D.setOptions((M) => ({
      ...M,
      modifiers: [...M.modifiers, {
        name: "eventListeners",
        enabled: x
      }]
    }));
  }, f = () => h(!0), g = () => h(!1), m = () => {
    c.isOpen && (c.isOpen = !1, e("close:popper"));
  }, b = () => {
    c.isOpen || (c.isOpen = !0, e("open:popper"));
  };
  g1([() => c.isOpen, i], async ([x]) => {
    x ? (await k(), f()) : g();
  });
  const k = async () => {
    await CL(), c.popperInstance = Yt5(s.value, l.value, {
      placement: i.value,
      modifiers: [Gt5, er5, {
        name: "flip",
        enabled: !r.value
      }, ar5, {
        name: "arrow",
        options: {
          padding: zi(t.value)
        }
      }, nr5, {
        name: "offset",
        options: {
          offset: [zi(L.value), zi(n.value)]
        }
      }]
    }), c.popperInstance.update();
  };
  return Dn(() => {
    var x;
    (x = c.popperInstance) === null || x === void 0 || x.destroy();
  }), {
    ...ht(c),
    open: b,
    close: m
  };
}
const lr5 = {
  id: "arrow",
  "data-popper-arrow": ""
};
function ur5(t, e) {
  return G(), J("div", lr5);
}
function Zh(t, e) {
  e === void 0 && (e = {});
  var r = e.insertAt;
  if (!(!t || typeof document > "u")) {
    var n = document.head || document.getElementsByTagName("head")[0], L = document.createElement("style");
    L.type = "text/css", r === "top" && n.firstChild ? n.insertBefore(L, n.firstChild) : n.appendChild(L), L.styleSheet ? L.styleSheet.cssText = t : L.appendChild(document.createTextNode(t));
  }
}
var cr5 = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
Zh(cr5);
const R3 = {};
R3.render = ur5;
R3.__scopeId = "data-v-20b7fd4a";
var hr5 = R3;
const dr5 = ["onKeyup"];
var Nh = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(t) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(t);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(t, {
    emit: e
  }) {
    const r = t;
    jw((_5) => ({
      c81fc0a4: t.zIndex
    }));
    const n = EL(), L = u5(null), i = u5(null), l = u5(null), s = u5(!1);
    J1(() => {
      const _5 = n.default();
      if (_5 && _5.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${_5.length} child nodes.`);
    });
    const {
      arrowPadding: c,
      closeDelay: h,
      content: f,
      disableClickAway: g,
      disabled: m,
      interactive: b,
      locked: k,
      offsetDistance: x,
      offsetSkid: D,
      openDelay: M,
      placement: E,
      show: S
    } = ht(r), {
      isOpen: C,
      open: P,
      close: A
    } = sr5({
      arrowPadding: c,
      emit: e,
      locked: k,
      offsetDistance: x,
      offsetSkid: D,
      placement: E,
      popperNode: i,
      triggerNode: l
    }), {
      hasContent: Z
    } = ot5(n, i, f), B = g5(() => S.value !== null), U = g5(() => m.value || !Z.value), K = g5(() => C.value && !U.value), r5 = g5(() => !g.value && !B.value), a5 = g5(() => b.value ? `border: ${x.value}px solid transparent; margin: -${x.value}px;` : null), V = Oi.debounce(P, M.value), l5 = Oi.debounce(A, h.value), d5 = async () => {
      U.value || B.value || (l5.clear(), V());
    }, m5 = async () => {
      B.value || (V.clear(), l5());
    }, M5 = () => {
      C.value ? m5() : d5();
    };
    return g1([Z, m], ([_5, $5]) => {
      C.value && (!_5 || $5) && A();
    }), g1(C, (_5) => {
      _5 ? s.value = !0 : Oi.debounce(() => {
        s.value = !1;
      }, 200);
    }), Ri(() => {
      B.value && (S.value ? V() : l5());
    }), Ri(() => {
      r5.value && nt5(L, m5);
    }), (_5, $5) => (G(), J("div", {
      class: "inline-block",
      style: Xe(Z5(a5)),
      onMouseleave: $5[2] || ($5[2] = (E5) => t.hover && m5()),
      ref: (E5, f5) => {
        f5.popperContainerNode = E5, L.value = E5;
      }
    }, [w("div", {
      ref: (E5, f5) => {
        f5.triggerNode = E5, l.value = E5;
      },
      onMouseover: $5[0] || ($5[0] = (E5) => t.hover && d5()),
      onClick: M5,
      onFocus: d5,
      onKeyup: Ol(m5, ["esc"])
    }, [d1(_5.$slots, "default")], 40, dr5), s5(DL, {
      name: "fade"
    }, {
      default: Je(() => [ne(w("div", {
        onClick: $5[1] || ($5[1] = (E5) => !Z5(b) && m5()),
        class: "popper",
        ref: (E5, f5) => {
          f5.popperNode = E5, i.value = E5;
        }
      }, [d1(_5.$slots, "content", {
        close: Z5(A),
        isOpen: s.value
      }, () => [O0(y5(Z5(f)), 1)]), t.arrow ? (G(), sr(hr5, {
        key: 0
      })) : _1("", !0)], 512), [[zt, Z5(K)]])]),
      _: 3
    })], 36));
  }
}, fr5 = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
Zh(fr5);
Nh.__scopeId = "data-v-5784ed69";
var pr5 = /* @__PURE__ */ (() => {
  const t = Nh;
  return t.install = (e) => {
    e.component("Popper", t);
  }, t;
})();
const gr5 = {
  class: "tooltip-wrapper",
  "data-testid": "tooltip"
}, mr5 = /* @__PURE__ */ w("button", { class: "tooltip__icon bg-bl-tooltip-icon-background-color dark:bg-bl-dk-tooltip-icon-background-color hover:bg-bl-tooltip-icon-background-hover-color dark:hover:bg-bl-dk-tooltip-icon-background-hover-color" }, [
  /* @__PURE__ */ w("span", { class: "text-bl-tooltip-icon-text-color dark:text-bl-dk-tooltip-icon-text-color" }, " ? ")
], -1), vr5 = { style: { "max-width": "400px" } }, yr5 = { key: 0 }, wr5 = {
  key: 2,
  class: "w-full"
}, br5 = {
  name: "MfxTooltip"
}, xr5 = /* @__PURE__ */ J5({
  ...br5,
  props: {
    title: {},
    offSetDistance: {}
  },
  setup(t) {
    return (e, r) => (G(), J("div", gr5, [
      s5(Z5(pr5), {
        trigger: "clickToOpen",
        placement: "bottom",
        arrow: "",
        "offset-distance": e.offSetDistance
      }, {
        content: Je(() => [
          w("div", vr5, [
            e.title ? (G(), J("p", yr5, y5(e.title), 1)) : e.$slots.default ? d1(e.$slots, "default", { key: 1 }) : _1("", !0),
            e.$slots.footer ? (G(), J("footer", wr5, [
              d1(e.$slots, "footer")
            ])) : _1("", !0)
          ])
        ]),
        default: Je(() => [
          mr5
        ]),
        _: 3
      }, 8, ["offset-distance"])
    ]));
  }
});
V0("data-v-b329ee4c");
W0();
var wl = !1;
if (typeof window < "u") {
  wl = !1;
  try {
    var kr5 = Object.defineProperty({}, "passive", {
      get: function() {
        wl = !0;
      }
    });
    window.addEventListener("test", null, kr5);
  } catch {
  }
}
function Mr5(t, e) {
  Dn(() => {
    window.removeEventListener(t, e);
  }), Uw(() => {
    window.addEventListener(t, e);
  });
}
const _r5 = ["onClick"], Cr5 = {
  key: 0,
  class: "grid grid-flow-col gap-x-2 items-center"
}, Sr5 = ["innerHTML"], Dr5 = {
  name: "MfxToggle"
}, Er5 = /* @__PURE__ */ J5({
  ...Dr5,
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsSpacing: {
      type: Number,
      default: 0
    },
    horizontal: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    },
    selectorClass: {
      type: String,
      default: ""
    },
    backgroundClass: {
      type: String,
      default: ""
    },
    activeToggleInnerTextClass: {
      type: String,
      default: ""
    },
    toggleOuterTextClass: {
      type: String,
      default: ""
    }
  },
  emits: ["valueSelected", "update:modelValue"],
  setup(t, { expose: e, emit: r }) {
    const n = t, L = u5(), i = u5([]), l = u5(null), s = u5(3), { localValue: c } = Zn(l, r);
    function h(M) {
      var E;
      return ((E = M && M.display && M.display[0]) == null ? void 0 : E.toLocaleUpperCase()) || "";
    }
    function f(M) {
      l.value = M;
    }
    function g() {
      if (n.horizontal) {
        const M = l.value;
        l.value = { display: "", value: "", id: "" }, l.value = M;
      }
    }
    const m = g5(() => {
      const M = "bg-bl-selected-color dark:bg-bl-dk-selected-color";
      return n.selectorClass ? Qe(M, ge().toString(n.selectorClass)) : M;
    }), b = g5(() => {
      const M = "bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color";
      return n.backgroundClass ? Qe(M, ge().toString(n.backgroundClass)) : M;
    }), k = g5(() => {
      const M = "";
      return n.backgroundClass ? Qe(M, ge().toString(n.backgroundClass)) : M;
    }), x = g5(() => {
      const M = "text-bl-icon-default-color dark:text-bl-dk-icon-default-color";
      return n.activeToggleInnerTextClass ? Qe(
        M,
        ge().toString(n.activeToggleInnerTextClass)
      ) : M;
    }), D = g5(() => {
      if (l.value && L.value && i.value) {
        const M = L.value.getBoundingClientRect(), E = i.value[n.items.findIndex((S) => {
          var C;
          return S.id === ((C = l.value) == null ? void 0 : C.id);
        })].getBoundingClientRect();
        if (n.horizontal) {
          const S = E.left - M.left;
          return S === 0 ? s.value : S + s.value;
        } else {
          const S = E.top - M.top;
          return S === 0 ? s.value : S + s.value;
        }
      }
      return 0;
    });
    return g1(l, (M) => {
      M && (c.value = M, r("valueSelected", M));
    }), J1(() => {
      if (c.value) {
        const M = n.items.find(
          (E) => {
            var S;
            return E.id === ((S = c.value) == null ? void 0 : S.id);
          }
        );
        M && f(M);
      }
      n.value.id && f(n.value);
    }), Mr5("resize", g), e({
      props: n,
      selectValue: f
    }), (M, E) => (G(), J("div", {
      ref_key: "container",
      ref: L,
      class: N5(["toggle-container flex", [
        t.horizontal ? "toggle-horizontal" : "toggle-vertical items-stretch flex-wrap"
      ]])
    }, [
      w("span", {
        class: N5(["background", [b.value]])
      }, null, 2),
      w("span", {
        class: N5(["toggle-container__pointer", [
          m.value,
          { "toggle-container__pointer--active": !!l.value }
        ]]),
        style: Xe([
          t.horizontal ? `left: ${D.value}px` : `top: ${D.value}px`,
          t.horizontal && `width: calc(100% / ${t.items.length} - 6px)`
        ])
      }, null, 6),
      (G(!0), J(Be, null, G0(t.items, (S, C) => (G(), J("div", {
        key: S.id,
        ref_for: !0,
        ref: (P) => P && i.value.push(P),
        class: N5(["toggle-label flex", [
          {
            "toggle-label--selected": l.value && l.value.id === S.id
          }
        ]]),
        style: Xe({
          paddingBottom: C !== t.items.length - 1 && !t.horizontal ? t.itemsSpacing + "px" : ""
        }),
        onClick: (P) => f(S)
      }, [
        w("i", {
          class: N5([
            l.value && l.value.id === S.id && x.value
          ])
        }, y5(t.horizontal ? S.display : h(S)), 3),
        t.horizontal ? _1("", !0) : (G(), J("div", Cr5, [
          w("span", {
            class: N5(["title", [k.value]])
          }, y5(S.display), 3),
          S.helpText ? (G(), sr(Z5(xr5), {
            key: 0,
            class: "flex toggle-tooltip",
            position: "top"
          }, {
            default: Je(() => [
              w("span", {
                innerHTML: S.helpText
              }, null, 8, Sr5)
            ]),
            _: 2
          }, 1024)) : _1("", !0)
        ]))
      ], 14, _r5))), 128))
    ], 2));
  }
}), m45 = /* @__PURE__ */ U5(Er5, [["__scopeId", "data-v-f054ebd7"]]), Ir5 = {
  name: "MfxDotify"
}, Tr5 = /* @__PURE__ */ J5({
  ...Ir5,
  props: {
    vertical: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    },
    radius: {
      type: Number,
      default: 1
    },
    offset: {
      type: Number,
      default: 5
    },
    rotate: {
      type: Number,
      default: null
    },
    size: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: "#000"
    },
    isDarkMode: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    }
  },
  setup(t) {
    const e = t, { vertical: r, radius: n, offset: L, rotate: i, size: l, color: s, isDarkMode: c } = ht(e), h = u5(null), f = u5(), g = u5(null), m = g5(
      () => g.value && g.value.getBoundingClientRect()
    ), b = g5(() => r.value && r.value ? {
      width: "100%",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- Resolve the next time you touch this
      height: l.value + "px"
    } : {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- Resolve the next time you touch this
      width: l.value + "px"
    }), k = () => {
      const M = m.value, E = window.devicePixelRatio || 1;
      h.value && r && M && f.value && (h.value.width = Math.ceil(
        r.value ? M.width * E : l.value * E
      ), h.value.height = Math.ceil(
        r.value ? l.value * E : M.height * E
      ), f.value.scale(E, E));
    }, x = () => {
      const M = m.value;
      if (n.value && n.value && M) {
        const E = n.value + L.value, S = Math.floor(l.value / E);
        if (f.value) {
          f.value.clearRect(0, 0, M.width, M.height);
          for (let C = 0; C < S; C++) {
            let P = 0, A = 0;
            r.value && r.value ? (P = M.width / 2, A = C * E + L.value) : (P = C * E + L.value, A = M.height / 2), f.value.beginPath(), f.value.arc(P, A, n.value, 0, 2 * Math.PI, !1), i.value && i.value && f.value.rotate(i.value * Math.PI / 180), f.value.fillStyle = e.isDarkMode ? getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-dk-text-color"
            ) : getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-text-color"
            ), f.value.strokeStyle = e.isDarkMode ? getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-dk-text-color"
            ) : getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-text-color"
            ), f.value.lineWidth = 0, f.value.fill(), f.value.stroke();
          }
        }
      }
    }, D = () => {
      k(), x();
    };
    return J1(() => {
      if (window.addEventListener("resize", D), h.value = g.value, h.value) {
        h.value.style.willChange = "transform";
        const M = h.value.getContext("2d");
        M && (f.value = M);
      }
      k(), x();
    }), SL(() => {
      window.removeEventListener("resize", D);
    }), g1(
      [r, n, L, i, l, s, c],
      () => {
        h.value && (k(), x());
      },
      { deep: !0, immediate: !0 }
    ), (M, E) => (G(), J("canvas", {
      ref_key: "canvas",
      ref: g,
      style: Xe(b.value)
    }, null, 4));
  }
}), v45 = /* @__PURE__ */ U5(Tr5, [["__scopeId", "data-v-2e0f693f"]]), Or5 = { class: "w-full rounded-full border-2 border-bl-panel-color dark:border-bl-dk-panel-color bg-bl-panel-color dark:bg-bl-dk-panel-color" }, zr5 = /* @__PURE__ */ J5({
  __name: "MfxProgressBar",
  props: {
    progress: { default: 0 },
    height: { default: 10 }
  },
  setup(t) {
    const e = t, r = u5(null);
    return J1(() => {
      r.value.style.width = `${e.progress}%`, r.value.style.height = `${e.height}px`;
    }), g1(
      () => e.progress,
      (n) => {
        r.value.style.width = `${n}%`;
      }
    ), (n, L) => (G(), J("div", Or5, [
      w("div", {
        id: "progressBar",
        ref_key: "refProgressBar",
        ref: r,
        class: N5(["rounded-full border-2", {
          "bg-bl-progress-bar dark:bg-bl-dk-progress-bar": e.progress > 0,
          "bg-transparent": e.progress < 1,
          "border-bl-progress-bar dark:border-bl-dk-progress-bar": e.progress > 0,
          "border-none": e.progress < 1
        }])
      }, "   ", 2)
    ]));
  }
}), y45 = /* @__PURE__ */ U5(zr5, [["__scopeId", "data-v-1915a9bf"]]), Pr5 = { class: "bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color border-2 border-bl-border-color dark:bl-dk-border-color pt-3 pb-3 pr-6 pl-6 rounded-md" }, w45 = /* @__PURE__ */ J5({
  __name: "MfxSelect",
  props: {
    items: {},
    initialValue: {},
    classes: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const r = t, n = u5(null), L = u5(null), i = u5(null), l = u5(!1), s = g5(() => {
      const g = "flex justify-between items-center columns-2 dropdownContainer cursor-pointer bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color pt-3 pb-3 pr-6 pl-6 rounded-full";
      return r.classes ? Qe(g, ge().toString(r.classes)) : g;
    }), c = u5(""), h = () => {
      const { width: g } = n.value.getBoundingClientRect();
      i.value.style.width = `${g}px`, l.value = !l.value, i.value.classList.toggle("show"), i.value.classList.toggle("noShow"), L.value.classList.toggle("show"), L.value.classList.toggle("noShow");
    }, f = (g) => {
      c.value = g.target.innerText, e("update:selection", g.target.innerText), i.value.classList.toggle("noShow"), L.value.classList.toggle("noShow"), l.value = !l.value;
    };
    return J1(() => {
      c.value = r.initialValue ? r.items.filter((g) => g === r.initialValue)[0] : r.items[0];
    }), (g, m) => (G(), J(Be, null, [
      w("div", {
        ref_key: "refDropdownContainer",
        ref: n,
        class: N5(s.value),
        onClick: h
      }, [
        w("div", null, y5(c.value), 1),
        w("div", null, [
          s5(Z5(a55), {
            class: "w-5 pb-1 inline-block",
            invert: l.value
          }, null, 8, ["invert"])
        ])
      ], 2),
      w("div", {
        ref_key: "refBlocker",
        ref: L,
        class: "blocker noShow",
        onClick: h
      }, null, 512),
      w("div", {
        ref_key: "refDropdownItemList",
        ref: i,
        class: "dropdownItemList showable noShow mt-1"
      }, [
        w("div", Pr5, [
          (G(!0), J(Be, null, G0(r.items, (b, k) => (G(), J("div", {
            key: k,
            class: "item py-2",
            onClick: f
          }, y5(b), 1))), 128))
        ])
      ], 512)
    ], 64));
  }
}), Ar5 = {
  // eslint-disable-next-line vue/multi-word-component-names -- Resolve the next time you touch this
  name: "Repeater",
  props: {
    content: {
      type: String,
      default: "."
    },
    width: {
      type: String,
      default: ""
    },
    spaceBetween: {
      type: String,
      default: "3px"
    },
    vertical: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Resolve the next time you touch this
      default: !1
    }
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  data() {
    return {
      canvas: void 0,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      contentWidth: this.width,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      contentSpacing: this.spaceBetween
    };
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  mounted() {
    this.render();
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  methods: {
    render() {
      if (isNaN(parseFloat(this.contentWidth)))
        return;
      this.$el.style.setProperty("--repeater-width", this.contentWidth);
      const t = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        style: getComputedStyle(this.$el),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        spaceBetween: parseFloat(this.spaceBetween),
        contentWidth: 0,
        unitWidth: 0
      }, e = (
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this */
        (this.canvas || (this.canvas = document.createElement("canvas"))).getContext("2d")
      );
      e.font = `${t.style.fontWeight} ${t.style.fontSize} ${t.style.fontFamily}`, t.contentWidth = e.measureText(this.content).width, t.unitWidth = t.contentWidth + t.spaceBetween;
      const r = parseFloat(t.style.width) - t.contentWidth, n = parseInt(r / t.unitWidth), L = r % t.unitWidth, i = (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        parseFloat(this.spaceBetween) + L / n
      );
      this.$el.style.setProperty("--repeater-spacing", `${i}px`), this.contentSpacing = i;
      let l = "";
      for (let s = 0; s < n + 1; s++)
        l += `${this.content}`;
      this.$el.innerText = l;
    }
  }
};
function $r5(t, e, r, n, L, i) {
  return G(), J("span", {
    class: N5(["repeater", { "repeater--vertical": r.vertical }])
  }, null, 2);
}
const Zr5 = /* @__PURE__ */ U5(Ar5, [["render", $r5]]);
class l4 {
  constructor() {
    this.startingColumn = 1, this.ranges = [];
  }
  get range() {
    return this.ranges;
  }
  set append(e) {
    this.ranges.push(e);
  }
  set prepend(e) {
    this.ranges.unshift(e);
  }
}
const Nr5 = {
  name: "MfxSpine",
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
  components: { Repeater: Zr5 },
  props: {
    name: {
      type: String,
      default: "spine"
    },
    unselectableSpineLocation: {
      type: Array,
      default() {
        return [];
      }
    },
    spineMap: {
      type: Object,
      default() {
        return {};
      }
    },
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  data() {
    return {
      selectedValues: [],
      procedureLayout: {
        c: "",
        t: "",
        l: "",
        s: ""
      },
      spineLocations: {
        c: ["C0", "C1", "C2", "C3", "C4", "C5", "C6", "C7"],
        t: [
          "T1",
          "T2",
          "T3",
          "T4",
          "T5",
          "T6",
          "T7",
          "T8",
          "T9",
          "T10",
          "T11",
          "T12"
        ],
        l: ["L1", "L2", "L3", "L4", "L5"],
        s: ["S1", "S2", "S3", "S4", "S5", "Becken"]
      },
      reverseSpineMap: {}
    };
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  watch: {
    selectedValues: {
      handler(t) {
        const e = [...t];
        this.$emit("update:modelValue", e);
      },
      deep: !0
    }
  },
  // eslint-disable-next-line no-dupe-keys, vue/component-api-style -- Resolve the next time you touch this
  watch: {
    selectedValues: {
      handler(t) {
        const e = [...t];
        this.$emit("update:modelValue", e);
      },
      deep: !0
    },
    modelValue: {
      handler(t) {
        this.refresh(t);
      }
    }
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  mounted() {
    for (const t of this.unselectableSpineLocation) {
      const e = `spine-${t}`, r = `spine-label-${t}`;
      e in this.$refs && r in this.$refs && (this.$refs[e].classList.add("unselectable"), this.$refs[r].classList.add("unselectable"));
    }
    for (const t in this.spineMap) {
      let e = t.charAt(0).toLowerCase();
      e = e === "b" ? "s" : e, this.spineLocations[e].splice(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.spineLocations[e].indexOf(t),
        1,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        this.spineMap[t]
      ), this.reverseSpineMap[this.spineMap[t]] = {
        originalValue: t,
        category: e
      };
    }
    this.refresh(this.modelValue);
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  created() {
    window.addEventListener("resize", this.reDraw);
  },
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  expose: ["clearSpine", "updateSpine"],
  // eslint-disable-next-line vue/component-api-style -- Resolve the next time you touch this
  methods: {
    reDraw() {
      this.$refs["spine-container"].style.setProperty(
        "--spine-height",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        getComputedStyle(this.$el).height
      );
    },
    refresh(t) {
      setTimeout(() => {
        this.updateSpine(t);
      }, 1), this.reDraw();
    },
    updateSpineMainDiagnoseIndicator(t) {
      for (const e in this.spineLocations)
        for (const r of this.spineLocations[e])
          this.$refs[`spine-main-diagnosis-${// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
          this.unconvertSpineLocation(r).originalValue}`].classList.toggle(
            "indicate",
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            t.length === 0 ? !1 : (
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
              t.includes(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
                this.unconvertSpineLocation(r).originalValue
              )
            )
          );
    },
    updateSpineStack(t, e, r) {
      const n = {};
      for (let l = e.length - 1; l >= 0; l--)
        if (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          !(!(t in e[l].raw) || // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          e[l].raw[t].length === 0)
        ) {
          n[e[l].id] = {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            action: e[l].id === r ? "prepend" : "append",
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            c: [...this.spineLocations.c],
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            t: [...this.spineLocations.t],
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            l: [...this.spineLocations.l],
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            s: [...this.spineLocations.s]
          };
          for (const s of e[l].raw[t]) {
            const c = this.unconvertSpineLocation(s).category;
            n[e[l].id][c].splice(
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
              n[e[l].id][c].indexOf(s),
              1,
              !0
            );
          }
        }
      function L(l, s, c) {
        const h = [];
        for (let f = 0; f < s[c].length; f++)
          if (s[c][f] === !0) {
            let g = f;
            for (; g < s[c].length && s[c][g] === !0; g++)
              ;
            h.push({
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
              title: l,
              start: f + 1,
              span: g - f,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
              state: s[c].map((m) => m === !0)
            }), f = g;
          }
        return h;
      }
      const i = {
        c: new l4(),
        t: new l4(),
        l: new l4(),
        s: new l4()
      };
      for (const l in n)
        i.c[n[l].action] = L(
          l,
          n[l],
          "c"
        ), i.t[n[l].action] = L(
          l,
          n[l],
          "t"
        ), i.l[n[l].action] = L(
          l,
          n[l],
          "l"
        ), i.s[n[l].action] = L(
          l,
          n[l],
          "s"
        );
      for (const l in i) {
        this.procedureLayout[l] = "";
        let s = "", c, h = 0;
        for (let f = 0; f < i[l].ranges.length; f++) {
          for (let g = 0; g < i[l].ranges[f].length; g++) {
            const m = i[l].ranges[f][g];
            if (h === 0 && (c = {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
              title: m.title,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
              state: [...m.state]
            }), h > 0 && c.title !== m.title) {
              for (let b = 0; b < c.state.length; b++)
                h !== 0 && c.state[b] === !0 && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
                m.state[b] === !0 && (i[l].startingColumn++, h = 0), c.state[b] = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
                c.state[b] || m.state[b];
              c.title = m.title;
            }
            h++, s += `
              <span class="spine-stack-item ${// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            m.title === r ? "selected-stack-item" : ""}" style="
                --grid-column-start: ${i[l].startingColumn};
                --grid-row-start: ${m.start};
                --grid-row-end: ${m.span}">
                  ${m.title}
              </span>`;
          }
          this.$refs[`spine-stack-${l}`].style.setProperty(
            "--grid-column-max",
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
            i[l].startingColumn
          ), this.procedureLayout[l] = s;
        }
      }
    },
    updateSpine(t) {
      if (t === void 0)
        return;
      const e = t.map(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        (r) => this.unconvertSpineLocation(r).originalValue
      );
      for (const r of e) {
        const n = `spine-${r}`;
        n in this.$refs && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        !this.selectedValues.includes(r) && this.$refs[n].dispatchEvent(new Event("click"));
      }
    },
    clearSpine() {
      this.selectedValues = [];
      for (const t in this.procedureLayout)
        this.procedureLayout[t] = "";
      for (const t in this.$refs)
        if (this.$refs[t].nodeName !== void 0)
          switch (this.$refs[t].nodeName.toLowerCase()) {
            case "path":
              this.$refs[t].classList.remove("selected");
              break;
            case "label":
              this.$refs[t].classList.remove(
                "selected",
                "sandwich-top",
                "sandwich-bottom"
              ), this.$refs[t].querySelector(
                'input[ type="checkbox" ]'
              ).checked = !1;
              break;
          }
    },
    spineGrouping(t) {
      const e = t.children;
      for (let r = 0; r < e.length; r++)
        if (e[r].classList.remove("sandwich-top", "sandwich-bottom"), e[r].classList.contains("selected")) {
          let n = r;
          for (; n < e.length && (e[n].classList.remove("sandwich-top", "sandwich-bottom"), !!e[n].classList.contains("selected")); ++n)
            ;
          e[r].classList.add("sandwich-top"), e[n - r === 1 ? r : n - 1].classList.add("sandwich-bottom"), r = n;
        }
    },
    unconvertSpineLocation(t) {
      return t in this.reverseSpineMap ? (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        this.reverseSpineMap[t]
      ) : (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        t.charAt(0) === "B" ? {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
          originalValue: t,
          category: "s"
        } : {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
          originalValue: t,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
          category: t.charAt(0).toLowerCase()
        }
      );
    },
    spineLabelSelected(t) {
      const e = t.target.getAttribute("value");
      if (this.unselectableSpineLocation.includes(e))
        return;
      const r = (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.unconvertSpineLocation(e).originalValue
      ), n = `spine-${r}`, L = `spine-label-${r}`, i = `spine-connector-from-label-${r}`, l = `spine-connector-from-spine-${r}`;
      t.target.checked ? this.selectedValues.push(e) : this.selectedValues.splice(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.selectedValues.indexOf(e),
        1
      ), this.$refs[L].classList.toggle(
        "selected",
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        t.target.checked
      ), n in this.$refs && (this.$refs[n].classList.toggle("selected", t.target.checked), this.spineGrouping(t.target.parentElement.parentElement));
      const s = this.$refs[n].getBoundingClientRect(), c = this.$refs[L].getBoundingClientRect(), h = {
        spine: {
          x: 1,
          // Start at end
          y: 0.5
          // Start at half
        },
        label: {
          x: 1,
          // Start at end
          y: 0.5
          // Start at half
        }
      };
      l in this.$refs && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
      (this.$refs[l].$el.hasAttribute(
        "data-anchor-x"
      ) && (h.spine.x = parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.$refs[l].$el.getAttribute(
          "data-anchor-x"
        )
      )), // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
      this.$refs[l].$el.hasAttribute(
        "data-anchor-y"
      ) && (h.spine.y = parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.$refs[l].$el.getAttribute(
          "data-anchor-y"
        )
      ))), i in this.$refs && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
      (this.$refs[i].$el.hasAttribute(
        "data-anchor-x"
      ) && (h.label.x = parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.$refs[i].$el.getAttribute(
          "data-anchor-x"
        )
      )), // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
      this.$refs[i].$el.hasAttribute(
        "data-anchor-y"
      ) && (h.label.y = parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        this.$refs[i].$el.getAttribute(
          "data-anchor-y"
        )
      )));
      const f = {
        spine: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          x: s.x + s.width * h.spine.x,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          y: s.y + s.height * h.spine.y
        },
        label: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          x: c.x * h.label.x,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          y: c.y + c.height * h.label.y
        }
      };
      let g = 0, m = 0;
      if (l in this.$refs && (m = // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      parseFloat(this.$refs[l].spaceBetween) || 0, this.$refs[l].$el.style.top = `${f.spine.y - f.label.y}px`, this.$refs[l].$el.style.left = `${f.spine.x - f.label.x + m}px`, this.$refs[l].render(), g = // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      parseFloat(this.$refs[l].width) + // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      parseFloat(this.$refs[l].contentSpacing) || 0), i in this.$refs) {
        const b = f.label.y - f.spine.y + m, k = f.label.x - f.spine.x - g - m, x = 180 + Math.atan2(b, k) * 180 / Math.PI, D = (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
          parseFloat(this.$refs[i].contentSpacing) * 2 - m
        ), M = Math.hypot(k, b) - D;
        this.$refs[i].contentWidth = `${M}px`, this.$refs[i].$el.style.transform = `rotate( ${x}deg )`, this.$refs[i].render();
      }
    },
    spineSelected(t) {
      const e = `spine-label-${t.target.getAttribute("id")}`;
      e in this.$refs && (this.$refs[e].firstElementChild.checked = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
      !this.$refs[e].firstElementChild.checked, this.spineLabelSelected({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
        target: this.$refs[e].firstElementChild
      }));
    },
    // Highlight label or spine when hovering over the other
    spineHover(t) {
      this.unselectableSpineLocation.includes(t.spineLocation) || t.ref in this.$refs && this.$refs[t.ref].classList.toggle("hover", t.toggle);
    },
    spineHoverIn(t) {
      const e = t.target.getAttribute("id");
      this.spineHover({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
        spineLocation: e,
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- Resolve the next time you touch this
        ref: `spine-label-${e}`,
        toggle: !0
      });
    },
    spineHoverOut(t) {
      const e = t.target.getAttribute("id");
      this.spineHover({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
        spineLocation: e,
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- Resolve the next time you touch this
        ref: `spine-label-${e}`,
        toggle: !1
      });
    },
    spineLabelHoverIn(t) {
      const e = this.unconvertSpineLocation(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        t.target.firstElementChild.getAttribute("value")
      ).originalValue;
      this.spineHover({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
        spineLocation: e,
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- Resolve the next time you touch this
        ref: `spine-${e}`,
        toggle: !0
      });
    },
    spineLabelHoverOut(t) {
      const e = this.unconvertSpineLocation(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- Resolve the next time you touch this
        t.target.firstElementChild.getAttribute("value")
      ).originalValue;
      this.spineHover({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Resolve the next time you touch this
        spineLocation: e,
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- Resolve the next time you touch this
        ref: `spine-${e}`,
        toggle: !1
      });
    }
  }
}, Br5 = { class: "flex overflow-x-auto" }, Rr5 = {
  ref: "spine-container",
  viewBox: "0 0 200 900",
  width: "200px",
  height: "900px",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  class: "spine flex-none"
}, Hr5 = {
  ref: "spine-main-diagnosis-Becken",
  x: "10",
  y: "848",
  class: "main-diagnosis"
}, Fr5 = /* @__PURE__ */ Le('<path id="head" class="spine-misc" d="M116.1 143.4 C121.3 145.9 140.6 145.4 161.5 136.8 182.4 128.2 204.4 86.8 182.6 46.6 160.8 6.4 111.7 0.1 75.2 11 38.7 21.9 12.5 35.5 10 67.6 7.5 99.7 0.2 107.1 0.9 111.9 1.6 116.7 17 117.4 10.9 132.6 4.8 147.8 5.9 147.6 5.9 152.8 5.9 158 10.4 169.2 10 176.6 9.6 184 6.4 201.1 34.3 195 62.2 188.9 84.3 178 84.9 165.7 85.2 159.5 88.6 145.6 96 141.4 103.3 137.2 114.5 142.6 116.1 143.4 Z"></path><path class="spine-between" d="M124.3 739.4 C124.3 739.4 126 748.7 123.6 749.9 121.2 751.1 88.6 756.2 88.6 756.2 88.6 756.2 79.2 750.8 79.1 745.2 79 739.5 96.4 740.8 96.7 740.8 97 740.8 124.3 739.4 124.3 739.4 Z"></path><path class="spine-between" d="M118.4 702.1 C118.4 702.1 122.2 710.6 121.2 712 120.2 713.3 77.2 719.4 77.2 719.4 77.2 719.4 73.2 709 74.5 704.7 75.8 700.4 91.4 699.5 91.4 699.5 Z"></path><path class="spine-between" d="M114.2 666.2 C114.2 666.2 117.8 674.6 116.3 675.5 114.8 676.4 72.7 678.4 72.7 678.4 72.7 678.4 70.3 667.4 71.2 664.7 72.1 662 114.2 666.2 114.2 666.2 Z"></path><path class="spine-between" d="M114.8 632.5 C114.8 632.5 115.8 638.6 114.9 640.4 113.9 642.2 74.5 641.1 74.5 641.1 74.5 641.1 73.2 629.2 75 627.3 76.8 625.4 114.8 632.5 114.8 632.5 Z"></path><path class="spine-between" d="M120 601.6 C120 601.6 120.8 605.7 117.2 608.1 113.6 610.5 80.2 605.5 80.2 605.5 80.2 605.5 78.9 596.2 81.8 593.6 84.7 591.2 120 601.6 120 601.6 Z"></path><path class="spine-between" d="M128.5 570.3 C128.5 570.3 127.5 576.5 125.3 577.4 123.1 578.4 87.5 571.9 87.5 571.9 87.5 571.9 90 561.6 92.7 560.7 95.5 559.9 128.5 570.3 128.5 570.3 Z"></path><path class="spine-between" d="M137.4 537.5 C137.4 537.5 137.5 545.7 133.8 546.9 130 548.1 98.5 540.3 98.5 540.3 98.5 540.3 98.4 531.4 100.4 530.7 102.5 530.1 137.4 537.5 137.4 537.5 Z"></path><path class="spine-between" d="M144.9 505.2 C144.9 505.4 143.9 513.5 142.5 514 141.2 514.5 107.1 508.6 107.1 508.6 107.1 508.6 108.2 499.5 109.9 498.3 111.6 497.1 144.9 505.2 144.9 505.2 Z"></path><path class="spine-between" d="M152.1 475.3 C152.1 475.3 150.8 483.1 148.7 483.5 146.6 483.9 117 478.4 117 478.4 117 478.4 117 471 118.1 469.9 119.2 468.8 152.1 475.3 152.1 475.3 Z"></path><path class="spine-between" d="M158 447.9 C158 447.9 156.9 453.7 155.3 454.5 153.7 455.2 124.2 450.9 124.2 450.9 124.2 450.9 124.3 444.9 126.1 444.3 127.9 443.8 158 447.9 158 447.9 Z"></path><path class="spine-between" d="M160.4 420.6 C160.4 420.6 161.7 426.4 159.7 428.2 157.6 430 129.4 426.2 129.4 426.2 129.4 426.2 128 420.9 128.9 418.5 129.8 416.2 160.4 420.6 160.4 420.6 Z"></path><path class="spine-between" d="M160.3 393.6 C160.3 393.6 162.8 397.6 160.8 400.4 158.8 403.2 130.3 401.2 130.3 401.2 130.3 401.2 129 396.3 129.3 394.4 129.7 392.5 160.3 393.6 160.3 393.6 Z"></path><path class="spine-between" d="M158.8 367.9 C158.8 367.9 161.2 372.7 159 375.4 156.8 378.1 130.1 378.1 130.1 378.1 130.1 378.1 128.2 373.4 128.2 371.2 128.2 369 158.8 367.9 158.8 367.9 Z"></path><path class="spine-between" d="M151.9 341.6 C151.9 341.6 156.8 345.2 156.6 348.5 156.4 351.8 127.6 355.6 127.6 355.6 127.6 355.6 124.9 350 124.4 348 123.9 346 151.9 341.6 151.9 341.6 Z"></path><path class="spine-between" d="M144.9 320.5 C145 320.7 148.2 321.4 148.9 324.1 149.6 326.8 122.2 333.2 122.2 333.2 122.2 333.2 119.5 329 119.8 325.2 120.1 321.4 144.9 320.5 144.9 320.5 Z"></path><path class="spine-between" d="M142.9 299.5 C142.9 299.5 144.7 303.1 144.2 304.8 143.6 306.5 117.8 311.1 117.8 311.1 117.8 311.1 115.6 306.7 115.8 303.7 116 300.7 142.9 299.5 142.9 299.5 Z"></path><path class="spine-between" d="M138.2 278.2 C138.2 278.2 140.8 281.3 139.7 283.9 138.7 286.5 114.6 289.2 114.6 289.2 114.6 289.2 112 286.3 112 282.4 112 278.5 138.2 278.2 138.2 278.2 Z"></path><path class="spine-between" d="M110.6 261.7 L134.5 258.3 C134.5 258.3 136.6 261 136 263 135.3 265.1 110 268.9 110 268.9 110 268.9 108.2 263.8 108.2 261.9 108.3 260 110.6 261.7 110.6 261.7 Z"></path><path class="spine-between" d="M105.5 243.5 C105.5 243.7 104.8 247 107.4 248.6 110 250.2 130.8 243.3 130.8 243.3 130.8 243.3 130.4 240.2 129.2 239.5 128 238.8 105.5 243.5 105.5 243.5 Z"></path><path class="spine-between" d="M127.9 223.5 C127.9 223.5 127.5 227.5 127 228.8 126.5 230.1 105.5 231.7 105.5 231.7 105.5 231.7 103.4 230.2 103.7 224.8 104 219.4 127.9 223.5 127.9 223.5 Z"></path><path class="spine-between" d="M124.4 206.7 C124.4 206.7 125.9 206.3 126.1 207.2 126.3 208.1 126.5 209.4 126.3 210 126.2 210.6 104.1 212.3 104.1 212.3 104.1 212.3 102 211 102.8 207.4 103.6 203.7 124.4 206.7 124.4 206.7 Z"></path><path class="spine-between" d="M116.7 190.5 L123.6 191.1 C123.6 191.1 124.8 193.7 124.3 194.6 123.9 195.6 104 196.1 104 196.1 104 196.1 102.3 191.5 102.7 190.5 103.1 189.5 116.7 190.5 116.7 190.5 Z"></path><path class="spine-between" d="M103.7 174.9 C103.7 174.9 121.9 175.3 122.5 176.4 123.2 177.5 123.5 179.8 122.4 181.1 121.3 182.4 104.7 182.6 103.8 181.2 102.9 179.8 102.7 176 103.7 174.9 Z"></path><path class="spine-between" d="M104.5 159.6 C104.5 159.6 122.1 159.8 122.9 160.8 123.7 161.8 124.1 164.8 123.3 165.7 122.6 166.6 106.1 166.2 104.7 165.3 103.3 164.3 103.7 160.4 104.5 159.6 Z"></path>', 25), jr5 = {
  ref: "spine-main-diagnosis-C0",
  x: "145",
  y: "115",
  class: "main-diagnosis"
}, Ur5 = {
  ref: "spine-main-diagnosis-C1",
  x: "92",
  y: "157",
  class: "main-diagnosis"
}, Yr5 = {
  ref: "spine-main-diagnosis-C2",
  x: "92",
  y: "172",
  class: "main-diagnosis"
}, Vr5 = {
  ref: "spine-main-diagnosis-C3",
  x: "92",
  y: "188",
  class: "main-diagnosis"
}, Wr5 = {
  ref: "spine-main-diagnosis-C4",
  x: "92",
  y: "203",
  class: "main-diagnosis"
}, Gr5 = {
  ref: "spine-main-diagnosis-C5",
  x: "92",
  y: "220",
  class: "main-diagnosis"
}, qr5 = {
  ref: "spine-main-diagnosis-C6",
  x: "93",
  y: "240",
  class: "main-diagnosis"
}, Kr5 = {
  ref: "spine-main-diagnosis-C7",
  x: "94",
  y: "259",
  class: "main-diagnosis"
}, Jr5 = {
  ref: "spine-main-diagnosis-T1",
  x: "97",
  y: "279",
  class: "main-diagnosis"
}, Qr5 = {
  ref: "spine-main-diagnosis-T2",
  x: "101",
  y: "300",
  class: "main-diagnosis"
}, Xr5 = {
  ref: "spine-main-diagnosis-T3",
  x: "104",
  y: "320",
  class: "main-diagnosis"
}, en5 = {
  ref: "spine-main-diagnosis-T4",
  x: "109",
  y: "343",
  class: "main-diagnosis"
}, tn5 = {
  ref: "spine-main-diagnosis-T5",
  x: "114",
  y: "365",
  class: "main-diagnosis"
}, rn5 = {
  ref: "spine-main-diagnosis-T6",
  x: "116",
  y: "389",
  class: "main-diagnosis"
}, nn5 = {
  ref: "spine-main-diagnosis-T7",
  x: "116",
  y: "412",
  class: "main-diagnosis"
}, on5 = {
  ref: "spine-main-diagnosis-T8",
  x: "114",
  y: "437",
  class: "main-diagnosis"
}, in5 = {
  ref: "spine-main-diagnosis-T9",
  x: "108",
  y: "463",
  class: "main-diagnosis"
}, Ln5 = {
  ref: "spine-main-diagnosis-T10",
  x: "100",
  y: "490",
  class: "main-diagnosis"
}, an5 = {
  ref: "spine-main-diagnosis-T11",
  x: "90",
  y: "521",
  class: "main-diagnosis"
}, sn5 = {
  ref: "spine-main-diagnosis-T12",
  x: "81",
  y: "553",
  class: "main-diagnosis"
}, ln5 = {
  ref: "spine-main-diagnosis-L1",
  x: "70",
  y: "583",
  class: "main-diagnosis"
}, un5 = {
  ref: "spine-main-diagnosis-L2",
  x: "63",
  y: "618",
  class: "main-diagnosis"
}, cn5 = {
  ref: "spine-main-diagnosis-L3",
  x: "60",
  y: "655",
  class: "main-diagnosis"
}, hn5 = {
  ref: "spine-main-diagnosis-L4",
  x: "60",
  y: "695",
  class: "main-diagnosis"
}, dn5 = {
  ref: "spine-main-diagnosis-L5",
  x: "63",
  y: "735",
  class: "main-diagnosis"
}, fn5 = {
  ref: "spine-main-diagnosis-S1",
  x: "91",
  y: "774",
  class: "main-diagnosis"
}, pn5 = {
  ref: "spine-main-diagnosis-S2",
  x: "112",
  y: "795",
  class: "main-diagnosis"
}, gn5 = {
  ref: "spine-main-diagnosis-S3",
  x: "135",
  y: "807",
  class: "main-diagnosis"
}, mn5 = {
  ref: "spine-main-diagnosis-S4",
  x: "143",
  y: "822",
  class: "main-diagnosis"
}, vn5 = {
  ref: "spine-main-diagnosis-S5",
  x: "143",
  y: "842",
  class: "main-diagnosis"
}, yn5 = { class: "flex-none flex flex-col justify-between leading-5 mr-4 ml-14" }, wn5 = { class: "spine-category" }, bn5 = { class: "spine-selector" }, xn5 = ["name", "value"], kn5 = ["name", "value"], Mn5 = ["name", "value"], _n5 = ["name", "value"], Cn5 = ["name", "value"], Sn5 = ["name", "value"], Dn5 = ["name", "value"], En5 = ["name", "value"], In5 = ["innerHTML"], Tn5 = { class: "spine-category" }, On5 = { class: "spine-selector" }, zn5 = ["name", "value"], Pn5 = ["name", "value"], An5 = ["name", "value"], $n5 = ["name", "value"], Zn5 = ["name", "value"], Nn5 = ["name", "value"], Bn5 = ["name", "value"], Rn5 = ["name", "value"], Hn5 = ["name", "value"], Fn5 = ["name", "value"], jn5 = ["name", "value"], Un5 = ["name", "value"], Yn5 = ["innerHTML"], Vn5 = { class: "spine-category" }, Wn5 = { class: "spine-selector" }, Gn5 = ["name", "value"], qn5 = ["name", "value"], Kn5 = ["name", "value"], Jn5 = ["name", "value"], Qn5 = ["name", "value"], Xn5 = ["innerHTML"], e05 = { class: "spine-category" }, t05 = { class: "spine-selector" }, r05 = ["name", "value"], n05 = ["name", "value"], o05 = ["name", "value"], i05 = ["name", "value"], L05 = ["name", "value"], a05 = ["name", "value"], s05 = ["innerHTML"];
function l05(t, e, r, n, L, i) {
  const l = IL("Repeater");
  return G(), J("div", Br5, [
    (G(), J("svg", Rr5, [
      w("path", {
        id: "Becken",
        ref: "spine-Becken",
        class: "spine-s",
        d: "M168.7 711.8 C163.8 695.7 144 670.6 125.1 664.1 106.3 657.6 83.9 678.5 81.8 681.8 79.7 685 48.2 711.8 35.3 720.7 22.3 729.5 15.6 748.1 27.1 756 38.6 764 41.8 772.8 46.5 785.7 51.2 798.7 58.9 806.9 54.5 810.4 50.1 813.9 52.4 817.5 51.8 825.4 51.2 833.4 28.5 841.3 21.8 849 15 856.7 25.9 870.8 39.5 879.9 53 889 69.8 899.9 103.4 892.6 137 885.2 134 862.9 130.8 855.5 127.6 848.1 122.8 843.4 132.3 832.2 141.8 821 134.1 821.9 121.7 811.9 109.3 801.9 112 786.9 114 777.4 116.1 768 121.4 764.4 147.3 771.8 173.1 779.2 172 755 172 755 172 755 173.7 727.8 168.7 711.8 Z M87.2 880.1 C70.6 879.4 67.3 877 62 870.4 56.7 863.8 54.9 860 51 855.4 47 850.8 50.8 841.9 57 841.3 63.2 840.6 69.6 841.7 69.6 841.7 69.6 841.7 91.7 847.9 97.2 859.4 102.7 870.8 103.8 880.7 87.2 880.1 Z",
        onClick: e[0] || (e[0] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[1] || (e[1] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[2] || (e[2] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Hr5, " . ", 512),
      Fr5,
      w("path", {
        id: "C0",
        ref: "spine-C0",
        class: "spine-c",
        d: "M191 90.6 C182.2 93.5 157.2 115.9 147.2 128.8 137.8 141 117.4 130.4 110.6 135.2 107.5 137.3 107.1 139.1 107.6 140.4 111.8 141.3 115.2 143 116 143.3 121.2 145.8 140.5 145.3 161.4 136.7 174.5 131.4 188 113.3 191 90.6 Z",
        onClick: e[3] || (e[3] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[4] || (e[4] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[5] || (e[5] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", jr5, " . ", 512),
      w("path", {
        id: "C1",
        ref: "spine-C1",
        class: "spine-c",
        d: "M124.4 148.4 C124.4 148.4 105 147.5 104.7 148.2 104.4 148.9 104 154.2 103.6 155.9 103.2 157.7 102.2 159.8 103.4 160.4 104.6 161 123.7 161.7 124.2 161.1 124.9 160.3 122.8 157.7 123.4 157.1 124.1 156.5 126.7 157.9 128.4 156.8 130.2 155.7 132.9 155 135.2 155.9 137.5 156.8 140.6 159.2 142.4 158.5 144.2 157.8 139.8 154.3 138.9 152.5 138 150.7 133.2 149.6 131.6 149.8 130 150 126.4 151.7 124.6 150.8 122.9 150 125.6 148.7 124.4 148.4 Z",
        onClick: e[6] || (e[6] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[7] || (e[7] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[8] || (e[8] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Ur5, " . ", 512),
      w("path", {
        id: "C2",
        ref: "spine-C2",
        class: "spine-c",
        d: "M105.5 164 C105.5 164 124.1 164 124.4 164.2 124.7 164.4 123.5 165.6 124.5 166.3 125.5 167 132.3 164.4 135.7 166.4 139.1 168.4 143.4 173.2 142.5 173.9 141.6 174.6 138.6 174.1 136 172.6 133.3 171.1 131.3 171.1 129.4 171.9 127.5 172.7 125.4 172.8 124.1 172.5 122.8 172.2 122 172.7 122.9 174.7 123.8 176.6 124.4 177.2 121.7 177.1 118.9 176.9 105 177.2 103.5 176.8 102 176.4 103.5 172.3 103.6 170.8 103.7 169.3 103.8 164.9 104.4 164.5 104.9 163.9 105.5 164 105.5 164 Z",
        onClick: e[9] || (e[9] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[10] || (e[10] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[11] || (e[11] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Yr5, " . ", 512),
      w("path", {
        id: "C3",
        ref: "spine-C3",
        class: "spine-c",
        d: "M118.4 178.7 C122.1 178.5 123.2 178.1 123.3 178.8 123.4 179.5 122.1 180.4 124.1 180.7 126.1 181 130.1 178.4 133.5 179.4 136.9 180.4 142.8 185.8 142.1 186.7 141.3 187.5 137.3 187 134.7 185.7 132.2 184.3 129.5 185.3 128 186.1 126.6 186.9 123.4 186.9 122.5 186.8 121.5 186.8 121.9 188.2 122.4 188.9 122.9 189.6 124.1 190.9 123.5 191.4 122.9 191.9 102.9 192.2 102.6 191.9 102.3 191.6 103.3 183.9 103.3 182.8 103.2 181.8 103 179.7 103.7 179.4 104.2 179.2 114.7 178.9 118.4 178.7 Z",
        onClick: e[12] || (e[12] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[13] || (e[13] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[14] || (e[14] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Vr5, " . ", 512),
      w("path", {
        id: "C4",
        ref: "spine-C4",
        class: "spine-c",
        d: "M104.6 194.1 C104.6 194.1 118.4 193.4 121.1 193.3 123.8 193.2 125.8 192.5 125.8 193.2 125.8 193.9 124.6 195.9 127.5 195.8 130.3 195.7 135.2 193.1 138.9 194.8 142.6 196.5 146.6 201.3 146.7 202 146.8 202.7 144.5 203.9 140.4 201.8 136.3 199.7 133.6 200.2 131.5 201.3 129.4 202.4 127.2 202.5 126.4 202.4 125.7 202.3 123.5 202.2 124.6 204.1 125.7 206 126.8 208 125.3 207.8 123.8 207.6 104 208.6 102.8 207.9 101.7 207.2 103.4 197.4 103.4 196.6 103.4 195.8 103 194.8 103.7 194.5 104.3 194.1 104.6 194.1 104.6 194.1 Z",
        onClick: e[15] || (e[15] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[16] || (e[16] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[17] || (e[17] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Wr5, " . ", 512),
      w("path", {
        id: "C5",
        ref: "spine-C5",
        class: "spine-c",
        d: "M104.6 211.4 C104.6 211.4 126.6 208.8 126.9 209.1 127.2 209.4 125.6 210.5 127.2 211.3 128.8 212.1 132.5 210.6 133.8 210.1 135.1 209.6 139.5 208.3 144.8 212.6 150.1 216.9 149.9 218.3 147.7 218.5 145.5 218.7 141.2 216.3 139.4 216.3 137.6 216.3 134.3 216.7 132.8 217.7 131.3 218.6 129.3 218.7 128 218.6 126.7 218.5 125.3 218.9 126.5 220.6 127.7 222.3 128.7 223.8 127.7 224.2 126.7 224.6 103.6 226.7 103.2 226.1 102.8 225.5 103.6 216.4 103.6 215.5 103.6 214.5 103.3 212.2 103.7 211.8 104.2 211.4 104.6 211.4 104.6 211.4 Z",
        onClick: e[18] || (e[18] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[19] || (e[19] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[20] || (e[20] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Gr5, " . ", 512),
      w("path", {
        id: "C6",
        ref: "spine-C6",
        class: "spine-c",
        d: "M105.3 229.6 C105.3 229.6 127.6 225.3 127.7 225.9 127.8 226.5 126.3 228.5 128.5 228.5 130.7 228.5 134.7 226.1 136.6 225.7 138.5 225.3 142.7 225.5 146.7 229 150.7 232.6 151.4 232.8 149.3 233.5 147.2 234.2 142.1 232 140 232 137.9 232 135.8 233 134 234.4 132.2 235.8 128.8 234.9 127.9 235.7 126.9 236.5 128.7 238.1 129.1 238.8 129.5 239.5 130.7 241 128.3 241.2 125.9 241.5 105.9 244.8 105.1 244.3 104.3 243.8 105 233.6 104.8 233 104.6 232.5 104.1 229.9 105.3 229.6 Z",
        onClick: e[21] || (e[21] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[22] || (e[22] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[23] || (e[23] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", qr5, " . ", 512),
      w("path", {
        id: "C7",
        ref: "spine-C7",
        class: "spine-c",
        d: "M108 246.8 C108 246.8 132.3 242.2 132.6 242.4 132.9 242.6 131.8 244.1 132.6 244.8 133.3 245.4 134.6 246.4 140.3 243.4 146 240.4 150.5 244.1 153.6 246.1 156.7 248.1 159.1 249.4 157.8 250.6 156.5 251.8 154.6 251.3 150.3 250.3 146 249.3 143.6 249.2 141.6 250.6 139.6 252 137.4 253.3 135.5 253.3 133.5 253.3 131.5 253.4 132.4 254.7 133.3 256 135.9 259 134.7 259.2 133.5 259.4 108.5 263.7 107.9 263 107.3 262.3 107.6 251 107.3 250.1 107.1 249.2 106.2 247.1 108 246.8 Z",
        onClick: e[24] || (e[24] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[25] || (e[25] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[26] || (e[26] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Kr5, " . ", 512),
      w("path", {
        id: "T1",
        ref: "spine-T1",
        class: "spine-t",
        d: "M112.1 266.1 C112.1 266.1 136.8 261.1 136.8 261.8 136.8 262.5 135.1 264.8 138.5 265.1 141.8 265.4 144.2 261.1 145.4 258.6 146.6 256.1 153.2 253.9 154.7 254.9 156.1 255.9 155.1 258.9 154.4 259.9 153.7 260.9 153.1 262.6 156.2 262.4 159.3 262.2 164.3 258.9 165.8 261.7 167.3 264.5 167.2 274.7 166.7 276.2 166.2 277.7 160.2 280.6 154.1 277.9 150.9 276.5 153.6 283.6 150.9 284.9 150 285.3 148.4 283.5 147.4 280.6 146.4 277.7 144.5 273.3 141.2 273.2 137.9 273.1 135.6 273.1 136.6 274.9 137.6 276.7 139.4 278.1 139.1 279 138.8 279.9 112.8 284.2 111.9 283.6 111 283 109.6 269.9 109.7 268.9 109.8 267.9 110.9 266.3 112.1 266.1 Z",
        onClick: e[27] || (e[27] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[28] || (e[28] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[29] || (e[29] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Jr5, " . ", 512),
      w("path", {
        id: "T2",
        ref: "spine-T2",
        class: "spine-t",
        d: "M115.4 286.3 C115.4 286.3 140.2 281.6 140.8 282 141.4 282.4 139.6 283.6 141 284.8 142.4 286 145.9 286 147.2 284 148.5 282.1 151.7 276.2 157.4 275.3 163.1 274.4 159.9 279.4 158.9 281 157.9 282.6 160.9 282.9 165.5 281.9 170.1 281 172.5 281.3 173 287.6 173.5 293.8 173.1 298.6 169.3 299.7 162.7 301.5 160.4 297.1 158.9 298.1 157.6 299 159.2 306.4 156.8 306 154.4 305.6 153.9 305.3 151.7 301 149.5 296.7 148.2 293.9 145.1 293.8 142 293.6 139.6 293.9 141.1 296.6 142.6 299.3 143.8 300.4 142.3 300.7 140.8 301 115.6 305.2 114.8 304.6 114 304 114.6 292.3 114.1 291.2 113.6 290.1 113 286.8 115.4 286.3 Z",
        onClick: e[30] || (e[30] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[31] || (e[31] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[32] || (e[32] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Qr5, " . ", 512),
      w("path", {
        id: "T3",
        ref: "spine-T3",
        class: "spine-t",
        d: "M118.9 307.9 C118.9 307.9 144.2 303.6 144.6 303.9 144.9 304.2 142.9 306.8 145.6 307.3 148.3 307.9 150.7 306.1 153.6 301.6 156.5 297.1 163.4 296.5 164.4 297.9 165.3 299.3 164.5 301.4 163.1 302.8 161.7 304.2 164 306.2 167.2 305.1 170.4 304 177 300.6 176.6 310.1 176.3 319.6 174.8 322.2 170.7 322.8 168.6 323.1 163.8 318.9 162.2 319.4 160.7 319.8 162.3 324.9 161.8 325.6 160.9 327.1 157.6 328.5 156.8 327.1 156 325.7 154.8 319.1 151.6 317.3 148.3 315.5 143.6 315.2 143.7 316.9 143.8 318.6 148.2 321.7 145.9 322.8 143.6 323.9 119.2 326.8 118.2 326.3 117.2 325.8 117.8 315.4 117.8 313.8 117.8 312.2 116.5 309.7 117.1 308.8 117.8 307.8 118.9 307.9 118.9 307.9 Z",
        onClick: e[33] || (e[33] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[34] || (e[34] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[35] || (e[35] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Xr5, " . ", 512),
      w("path", {
        id: "T4",
        ref: "spine-T4",
        class: "spine-t",
        d: "M123.4 329.6 C123.4 329.6 149.3 323 149.5 323.6 149.7 324.2 147.7 327.1 151.8 327.1 155.9 327.1 158.4 319.8 160 318.3 161.7 316.8 168.9 312.2 170.3 316.9 171.1 319.5 163.7 323.1 170.7 323.4 175 323.6 178.9 317.8 181.6 322.2 184.3 326.6 184.6 336.5 182.8 338.4 181 340.3 176.5 342.2 175.2 341.6 173.9 341 171.6 338.5 169.3 339.3 167 340.1 167.6 343.9 168.5 346.7 169.4 349.5 165.7 352.1 164.9 351 164.1 350 163.4 342.3 159.3 338.4 155.2 334.5 149.2 335.6 149.5 337 149.8 338.3 154.2 342.2 152.6 342.9 151.1 343.6 124.6 349.3 123.7 349 122.8 348.7 121.9 340 121.9 337.1 121.9 334.2 120.8 331 121.3 330.4 122.1 329.7 123.4 329.6 123.4 329.6 Z",
        onClick: e[36] || (e[36] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[37] || (e[37] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[38] || (e[38] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", en5, " . ", 512),
      w("path", {
        id: "T5",
        ref: "spine-T5",
        class: "spine-t",
        d: "M128.5 352 C128.5 352 156.4 346.8 156.8 347.8 157.2 348.8 155.3 350.5 158.6 351.4 162 352.4 163.5 349.3 166 346 168.5 342.7 173.7 340 176.5 340.1 179.3 340.3 179.9 342.9 178 345.1 176.1 347.3 176.8 349.7 179.6 349.2 182.4 348.7 189.5 344.1 191.4 349.5 193.3 354.9 192.2 364.8 190.2 366.2 188.2 367.6 184.2 369 180.6 366.9 177 364.8 173.9 365 173.9 368.7 174 372.5 174.3 376 172.5 376.4 170.7 376.8 169.2 370.8 168.4 368.2 167.6 365.6 163.7 360.7 161 360.3 158.3 359.9 154.4 360.5 156.4 363.4 158.4 366.3 159.9 367.7 158.2 368.3 156.5 368.9 127.9 372.4 127.3 371.9 126.6 371.3 127.1 358.1 127.1 356.8 127.1 355.5 126.4 352.9 126.9 352.4 127.6 352 128.5 352 128.5 352 Z",
        onClick: e[39] || (e[39] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[40] || (e[40] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[41] || (e[41] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", tn5, " . ", 512),
      w("path", {
        id: "T6",
        ref: "spine-T6",
        class: "spine-t",
        d: "M131 376.2 C131 376.2 159.3 373.1 159.9 373.8 160.5 374.5 158.3 376.2 160.6 377.4 162.9 378.6 166.3 378.2 167.6 375.5 168.9 372.8 174.2 367.5 180.1 367.8 186.1 368 180 373.5 179.7 374.8 179.4 376.1 181.1 377.3 185.3 376.8 189.4 376.4 193.6 373 194.6 379.5 195.6 386 193.8 394.1 190.8 395.6 187.8 397.1 183.8 396.4 182.3 395.2 180.8 394 179.4 392.2 177.2 393.6 175 395 175.5 398.8 175.5 399.8 175.5 400.8 172.7 406.5 171.7 403.2 170.8 399.9 170.9 392.5 166.8 389.4 162.7 386.3 157.5 386.7 158.3 388.7 159.1 390.7 162 393.9 160.2 394.6 158.4 395.3 130.1 397.1 128.7 396.2 127.4 395.3 129.8 380.7 129.6 379.9 129.6 379.1 129.1 376.6 131 376.2 Z",
        onClick: e[42] || (e[42] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[43] || (e[43] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[44] || (e[44] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", rn5, " . ", 512),
      w("path", {
        id: "T7",
        ref: "spine-T7",
        class: "spine-t",
        d: "M131.4 399.5 C131.4 399.5 161.4 398.9 161.8 399.7 162.2 400.5 159.5 402.1 163.1 403.9 166.7 405.7 170.1 401.6 172.1 399.2 174.1 396.8 182.4 393.4 185 394.9 187.6 396.4 184.2 400.8 183.3 401.9 182.4 403 183.2 405.5 189.9 404.8 196.6 404.1 198.1 404.7 198 410.3 197.9 415.8 196.8 423.5 192.6 424.8 188.5 426.1 186 425.5 183.4 423.4 180.7 421.2 178.3 421.2 177.2 422.8 176.1 424.4 177.5 428.4 176.8 429.6 176.1 430.8 171.9 431.1 171.4 427.3 170.9 423.5 169.5 416.9 166.2 415 162.9 413.1 158.4 412.9 158.9 414.6 159.3 416.3 161.7 420.1 160.8 421.1 159.9 422.1 128.6 421.2 127.5 420.4 126.3 419.6 129.5 405.3 129.5 404.3 129.7 403.3 129.2 399.5 131.4 399.5 Z",
        onClick: e[45] || (e[45] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[46] || (e[46] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[47] || (e[47] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", nn5, " . ", 512),
      w("path", {
        id: "T8",
        ref: "spine-T8",
        class: "spine-t",
        d: "M130.1 425.3 C130.1 425.3 160.9 426 160.9 427 161 427.9 158.9 429 161.2 430.8 163.6 432.6 167.2 431.7 169.7 428.2 172.2 424.7 179.5 422.6 183.8 423.4 188.1 424.2 182.8 429.4 181.5 430.5 180.2 431.6 182.3 434 185.6 433.4 188.9 432.8 193.8 431.2 195.6 436.1 197.5 441 193.1 451.8 192.2 452.7 191.4 453.6 183.4 455.2 181.9 453.5 180.4 451.8 178.8 449.9 176.8 449.9 174.8 449.9 173.9 452.4 173.9 454.7 173.9 457 168.5 458.7 168.5 454.3 168.5 449.9 166.2 444.2 164.9 442.7 163.5 441.2 157.9 440.3 156.9 441.3 156 442.2 158.9 445.8 158.8 447.4 158.7 449 157.3 448.5 155.7 448.5 154.1 448.5 125.6 447.2 124.8 445.8 124.1 444.4 128.1 429.7 128.1 428.7 128.1 427.7 128.5 425.3 130.1 425.3 Z",
        onClick: e[48] || (e[48] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[49] || (e[49] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[50] || (e[50] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", on5, " . ", 512),
      w("path", {
        id: "T9",
        ref: "spine-T9",
        class: "spine-t",
        d: "M124.3 450.1 C124.3 450.1 156.3 453 156.5 453.6 156.7 454.3 154.7 455 156 457 157.3 459 161.1 459.7 164.4 456.8 167.7 453.9 170 451.1 175.5 451 181 450.9 183.8 451.9 181.4 455.4 179 458.9 175.5 458.7 178.4 461 181.3 463.3 187 461.2 190.2 461.8 193.4 462.4 193.3 466.9 192.7 470.3 192.1 473.7 189.9 483 184.9 483.6 179.9 484.2 177.7 482.7 175.7 480.2 173.7 477.7 171.1 477.5 169.8 479.8 168.5 482 169.4 483.7 168.3 484.7 167.1 485.7 163.2 486 163.3 483.5 163.4 481 163.3 474.3 161.8 472.2 160.3 470 155.7 468.1 153.5 468.1 151.2 468.1 151.6 469.6 152.5 471.5 153.4 473.4 154.8 476.5 152 476.4 149.2 476.3 118.8 472.7 118.2 471.6 117.6 470.5 122.2 455.5 122.3 454.2 122.1 452.8 122.3 450.2 124.3 450.1 Z",
        onClick: e[51] || (e[51] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[52] || (e[52] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[53] || (e[53] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", in5, " . ", 512),
      w("path", {
        id: "T10",
        ref: "spine-T10",
        class: "spine-t",
        d: "M116.3 477.4 C116.3 477.4 149.6 481.9 150 482.6 150.4 483.3 148 483.5 148.8 485.5 149.6 487.5 154.6 490 157.5 487.2 160.4 484.4 164.6 481 169.1 481 173.6 481 177.9 481.1 176.8 484.8 175.7 488.4 169.8 489.2 172.9 491.4 176 493.7 184.8 492.1 186 493.2 187.3 494.3 189.4 495.1 187.5 501.8 185.6 508.5 183 515.1 179.8 515.7 176.5 516.3 173 516 170.7 513.4 168.4 510.8 167.2 509.8 164.9 509.9 162.6 510 161.9 515.6 161.4 517.2 160.9 518.9 156.2 519.4 156.2 515.2 156.2 511 155.6 504.1 154 501.6 152.4 499.1 146.4 497 145.1 497.6 143.8 498.2 145 501 145.4 502.4 145.8 503.8 146.4 506.9 144.2 506.3 141.9 505.7 109.3 500.8 108.9 499.4 108.5 498 114.3 482 114.3 481 114.1 480.1 114.6 477.5 116.3 477.4 Z",
        onClick: e[54] || (e[54] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[55] || (e[55] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[56] || (e[56] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", Ln5, " . ", 512),
      w("path", {
        id: "T11",
        ref: "spine-T11",
        class: "spine-t",
        d: "M107.9 508 C107.9 508 143.2 512.7 143.4 513.4 143.6 514.1 140 515.1 142.5 517.4 145 519.7 149.2 519.8 151.7 517.8 154.2 515.8 157.3 511.6 162.9 511.6 168.5 511.6 171.7 511 171.6 515.3 171.5 519.6 165.4 518.7 166.7 521.9 168 525.1 179.3 523 181.2 524.7 183.1 526.4 182.9 530.3 182.2 534.5 181.5 538.7 178.3 546.7 175 547.6 171.6 548.5 167.7 549.1 164 545.3 160.3 541.4 158.6 540.7 157.2 542.6 155.8 544.5 155.4 550.1 153.1 551.5 150.7 552.9 149 551.4 149.2 544.8 149.5 538.2 147 532.2 144.9 530.7 142.8 529.2 137 528.2 136.9 529.9 136.8 531.6 139.6 536.5 138.5 537.6 138 538.2 127.7 536.5 117.8 534.8 108.7 533.3 99.9 531.7 99.6 531.1 98.9 529.8 104.8 513.8 104.8 512.2 104.9 510.8 105.4 508 107.9 508 Z",
        onClick: e[57] || (e[57] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[58] || (e[58] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[59] || (e[59] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", an5, " . ", 512),
      w("path", {
        id: "T12",
        ref: "spine-T12",
        class: "spine-t",
        d: "M100 539.7 C100 539.7 134.9 545.7 135.3 546.5 135.7 547.3 132.6 548.1 133.9 549.9 135.2 551.7 139 554.5 142.5 551.7 146 548.9 150.6 545.3 156 545.5 161.5 545.7 164.8 546.3 163.3 549.9 161.8 553.5 156.6 552.2 158.1 555.5 159.6 558.8 167.2 558.3 169.1 558.3 171 558.3 175.2 558.3 174.2 565.9 173.2 573.5 168.8 581.3 165.8 582 162.8 582.7 158.6 582.8 156.2 580.8 153.8 578.9 149.5 575.1 148.4 576 147.3 576.9 147.8 583.8 145.3 584 142.8 584.2 140.3 581 139.8 574.6 139.2 568.1 137.3 564.9 134.3 563.6 131.3 562.3 128.1 561.4 128.1 563.2 128.1 565 130.9 570.2 129.1 571 128.3 571.4 119.8 569.5 111 567.6 101.3 565.6 91.2 563.6 90.8 562.7 90 561.2 96.8 546 96.8 544.4 96.8 542.8 97.3 539.7 100 539.7 Z",
        onClick: e[60] || (e[60] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[61] || (e[61] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[62] || (e[62] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", sn5, " . ", 512),
      w("path", {
        id: "L1",
        ref: "spine-L1",
        class: "spine-l",
        d: "M89.3 570.4 C89.3 570.4 125.2 575.9 126.1 576.6 127 577.3 124.7 577.7 125 579.6 125.3 581.5 130.5 584.3 133.7 582 137 579.7 140.5 575.2 146.7 575.1 152.9 575 156 574.5 155.9 578.9 155.8 583.3 150.4 581.2 150.4 584.2 150.4 587.2 154.6 588.1 159 588 163.4 587.9 167.9 587.3 167.8 593.7 167.6 600 163.2 611.1 160.2 612.6 157.2 614.1 150.9 613.7 148.9 611.9 147 610.1 144.6 605.1 142.8 605.6 141 606.1 140.5 611.6 138.7 612.8 136.9 614.1 132.9 613.2 132.6 609.2 132.3 605.2 131.5 599 129.7 596.8 127.9 594.6 122 592.9 120.5 593 119 593.1 119.9 595.7 120.4 598.4 120.9 601.1 121.1 602.4 119.1 602.3 117.1 602.2 80.6 595.5 80.2 594.6 79.8 593.7 80.3 591.7 81 589.3 81.7 586.9 86 576.1 86 574.2 86 572.3 86.7 570 89.3 570.4 Z",
        onClick: e[63] || (e[63] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[64] || (e[64] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[65] || (e[65] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", ln5, " . ", 512),
      w("path", {
        id: "L2",
        ref: "spine-L2",
        class: "spine-l",
        d: "M80.8 604 C80.8 604 117.7 605.9 118.7 607.1 119.6 608.4 116.7 608.7 117.8 610.5 119 612.3 124.3 615.2 128.4 610.6 132.5 606 138.2 602.9 142.6 603 147 603.1 149.1 603.1 149 606.6 148.9 610.1 143.2 611 143.9 613.8 144.6 616.6 152.8 616 154.6 615.8 156.3 615.6 161.8 614.5 162.2 620.3 162.6 626.2 159.1 639.6 155.1 640.9 151.1 642.2 147.5 642.3 145.3 641 143.1 639.7 138.5 637.3 136.7 639.7 134.9 642.1 134 647.8 130.7 647.2 127.3 646.5 127.6 636 126 630.7 124.3 625.4 117.5 623.9 115.6 623.9 113.7 624 113.2 624.8 114.5 627.9 115.8 631 116.8 634 113.9 633.8 112.5 633.7 103.4 632.5 94.3 631.6 84.5 630.6 74.6 630 74.3 629.3 73.7 628 78.4 610.6 78.4 608.8 78.4 607 78.3 604 80.8 604 Z",
        onClick: e[66] || (e[66] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[67] || (e[67] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[68] || (e[68] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", un5, " . ", 512),
      w("path", {
        id: "L3",
        ref: "spine-L3",
        class: "spine-l",
        d: "M76.8 638.6 C76.8 638.6 116.1 638 116.6 638.6 117 639.2 114.2 640.7 116.2 643.1 118.2 645.5 123.9 646 127.7 641.1 131.5 636.2 135.7 632.5 141.1 632.4 146.5 632.3 148.4 631.8 148.6 635.4 148.7 638.9 144.3 640.5 144 642.8 143.7 645.1 149.1 646.4 153.1 645.3 157.1 644.2 163.8 642.8 164.3 649.7 164.8 656.5 162.8 669.7 158 671.8 153.2 673.9 151.3 673.7 148 672.1 144.6 670.5 140.5 669.2 138.7 671.8 136.9 674.4 138.5 680 134.7 680.6 130.9 681.2 129.3 678.4 128.5 669.9 127.7 661.4 122.6 658.7 119.4 657.5 116.1 656.3 111.8 656.5 112.5 658.7 113.2 661 117.5 666.9 114.9 667.6 113.7 667.9 104.1 667.2 94.3 667 82.9 666.7 70.9 666.8 70.6 666.3 69.9 665.5 73.9 646.5 73.7 644.2 73.5 641.9 73.9 638.6 75.4 638.6 Z",
        onClick: e[69] || (e[69] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[70] || (e[70] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[71] || (e[71] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", cn5, " . ", 512),
      w("path", {
        id: "L4",
        ref: "spine-L4",
        class: "spine-l",
        d: "M74.4 675.9 C74.4 675.9 91.6 675.5 99.7 674.5 107.8 673.5 118.6 672 118.4 673.3 118.2 674.6 116 676.9 118.5 678 121 679.2 127 680.6 130.6 674 134.2 667.4 141.4 664.2 146.8 664.2 152.2 664.2 152.7 667.9 150.7 670.4 148.7 672.9 145.6 674.9 148.1 676.7 150.6 678.5 157.3 676.7 159.4 676.3 161.4 675.9 167.5 674.5 168.4 680.1 169.3 685.7 169.7 701.5 164.4 704.4 159.1 707.3 155.5 707 152.9 705.6 150.3 704.2 145.9 703.2 145.2 704.3 144.5 705.4 142.3 713.7 139.8 715.1 137.3 716.5 134.4 715.4 134.1 711.1 133.7 706.7 131.1 698.1 127.2 694.6 123.3 691.1 116.4 692.2 115.5 692.8 114.6 693.4 115.7 695.9 116.7 697.4 117.7 698.8 119.5 701.7 118.9 702.9 118.6 703.5 107.5 703.7 96.4 704.2 85 704.8 73.5 705.7 73.1 705.5 72.4 705.2 71.8 705.9 71.9 700 72 694.1 72 681.4 71.8 679.6 71.7 677.9 71.4 676 74.4 675.9 Z",
        onClick: e[72] || (e[72] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[73] || (e[73] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[74] || (e[74] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", hn5, " . ", 512),
      w("path", {
        id: "L5",
        ref: "spine-L5",
        class: "spine-l",
        d: "M79.3 716.5 C79.3 716.5 90.2 714.7 100.9 712.9 111.1 711.2 121.1 709.7 121.4 709.9 122 710.3 121.9 710.9 121.3 712.5 120.7 714.1 126.7 718.6 130.8 714.5 134.9 710.5 137.4 701.9 146.1 700.1 154.8 698.3 157.3 701.9 153.2 706.6 149.2 711.2 153.4 712.8 157.5 712 161.5 711.2 168.4 706.6 171.3 710.9 174.2 715.2 174.4 734.1 172.1 736.7 169.8 739.3 162.6 742.6 157.8 739.1 153 735.6 147.9 735.7 147.3 739.4 146.7 743.2 150.6 750.1 147.9 752.4 145.2 754.8 140.9 754.8 140.4 747.3 139.8 739.8 134.2 730.6 129.6 729.3 125 728 120.4 729 121 731.2 121.6 733.4 127.3 739.5 124.5 740.5 123.4 740.9 116.1 741.3 107.7 742.3 94.8 743.8 79.1 745.9 78.5 745.4 77.5 744.7 76.7 723 76.3 721.5 76 720.3 75.7 717 79.3 716.5 Z",
        onClick: e[75] || (e[75] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[76] || (e[76] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[77] || (e[77] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", dn5, " . ", 512),
      w("path", {
        id: "S1",
        ref: "spine-S1",
        class: "spine-s",
        d: "M109.8 782.1 C109.8 782.1 134.4 771.9 134.7 764.2 134.6 764.2 134.6 764.1 134.5 764.1 133 762.9 133 758 134.7 753.6 136.4 749.2 128.5 747.6 128.5 747.6 128.5 747.6 127.6 747.4 126 747.5 125.5 747.6 124.8 747.8 124 748.2 124.1 747.6 117.7 750 111.7 751.9 105.7 753.8 89.5 754.8 89.5 754.8 89.5 754.8 87 755.6 87.8 757.1 88.6 758.6 92.3 760.4 98.6 763.5 104.9 766.6 104.8 773.5 104.9 774.2 105.1 775 106.3 778.8 109.8 782.1 Z",
        onClick: e[78] || (e[78] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[79] || (e[79] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[80] || (e[80] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", fn5, " . ", 512),
      w("path", {
        id: "S2",
        ref: "spine-S2",
        class: "spine-s",
        d: "M154.5 771.3 C154.3 768.3 155.2 765.6 154.3 765.2 153.5 764.8 143.9 763.3 142.2 761.7 140.5 760.2 141 757.9 140.5 757.8 140.5 757.8 134.1 760.8 134.6 764.1 134.3 771.8 109.7 782 109.7 782 109.7 782 109.7 783.8 116.6 786.2 121.7 787.9 127.4 790.4 132.6 793.1 140.8 787.9 151.7 779 156.9 774.6 155.5 773.8 154.6 772.8 154.5 771.3 Z",
        onClick: e[81] || (e[81] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[82] || (e[82] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[83] || (e[83] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", pn5, " . ", 512),
      w("path", {
        id: "S3",
        ref: "spine-S3",
        class: "spine-s",
        d: "M175.7 786.2 C172.7 780.2 168.5 779.9 163.2 777.5 160.6 776.4 158.5 775.6 157 774.7 151.8 779 140.9 788 132.7 793.2 136.6 795.3 140.2 797.6 143 799.8 146.4 802.5 149.4 805.5 151.5 808.8 158.9 805.1 168.9 798.5 174.1 794.9 174.2 792.3 178.1 791.1 175.7 786.2 Z",
        onClick: e[84] || (e[84] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[85] || (e[85] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[86] || (e[86] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", gn5, " . ", 512),
      w("path", {
        id: "S4",
        ref: "spine-S4",
        class: "spine-s",
        d: "M156.3 827.1 L171.9 823.2 C173 821.7 176 816.3 176.1 810.6 176.3 804 177.8 801.6 174.9 797.1 174.3 796.2 174.1 795.5 174.2 794.9 169 798.5 159 805.2 151.6 808.8 153.6 811.8 154.8 815.1 154.8 818.6 154.7 822.2 155.4 825 156.3 827.1 Z",
        onClick: e[87] || (e[87] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[88] || (e[88] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[89] || (e[89] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", mn5, " . ", 512),
      w("path", {
        id: "S5",
        ref: "spine-S5",
        class: "spine-s",
        d: "M156.3 827.1 C156.3 827.1 158.3 830.5 159.3 831.4 160.8 832.7 159.5 833.7 159.5 834.5 158.7 835.5 157.1 837.6 155.8 838.1 154 838.9 149.2 855.3 150.4 856.8 151.6 858.3 158.3 857.3 162.6 850.3 166.9 843.3 168.7 838.9 169.1 836.3 169.3 834.8 169.5 833.4 169.7 832.4 170.8 830.7 171.6 825.6 171.9 823.2 Z",
        onClick: e[90] || (e[90] = (...s) => i.spineSelected && i.spineSelected(...s)),
        onMouseenter: e[91] || (e[91] = (...s) => i.spineHoverIn && i.spineHoverIn(...s)),
        onMouseleave: e[92] || (e[92] = (...s) => i.spineHoverOut && i.spineHoverOut(...s))
      }, null, 544),
      w("text", vn5, " . ", 512)
    ], 512)),
    w("div", yn5, [
      w("div", wn5, [
        w("div", bn5, [
          w("label", {
            ref: "spine-label-C0",
            onMouseenter: e[94] || (e[94] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[95] || (e[95] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[0],
              onChange: e[93] || (e[93] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, xn5),
            w("span", null, y5(L.spineLocations.c[0]), 1),
            s5(l, {
              ref: "spine-connector-from-label-C0",
              class: "connector label",
              "data-anchor-y": "0.8"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C1",
            onMouseenter: e[97] || (e[97] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[98] || (e[98] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[1],
              onChange: e[96] || (e[96] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, kn5),
            w("span", null, y5(L.spineLocations.c[1]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C1",
              class: "connector spine",
              width: "30px"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C1",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C2",
            onMouseenter: e[100] || (e[100] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[101] || (e[101] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[2],
              onChange: e[99] || (e[99] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Mn5),
            w("span", null, y5(L.spineLocations.c[2]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C2",
              class: "connector spine",
              width: "40px"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C2",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C3",
            onMouseenter: e[103] || (e[103] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[104] || (e[104] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[3],
              onChange: e[102] || (e[102] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, _n5),
            w("span", null, y5(L.spineLocations.c[3]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C3",
              class: "connector spine",
              width: "50px"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C3",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C4",
            onMouseenter: e[106] || (e[106] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[107] || (e[107] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[4],
              onChange: e[105] || (e[105] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Cn5),
            w("span", null, y5(L.spineLocations.c[4]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C4",
              class: "connector spine",
              width: "55px"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C4",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C5",
            onMouseenter: e[109] || (e[109] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[110] || (e[110] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[5],
              onChange: e[108] || (e[108] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Sn5),
            w("span", null, y5(L.spineLocations.c[5]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C5",
              class: "connector spine",
              width: "60px",
              "data-anchor-y": "0.2"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C5",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C6",
            onMouseenter: e[112] || (e[112] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[113] || (e[113] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[6],
              onChange: e[111] || (e[111] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Dn5),
            w("span", null, y5(L.spineLocations.c[6]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C6",
              class: "connector spine",
              width: "65px",
              "data-anchor-y": "0.2"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C6",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-C7",
            onMouseenter: e[115] || (e[115] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[116] || (e[116] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.c[7],
              onChange: e[114] || (e[114] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, En5),
            w("span", null, y5(L.spineLocations.c[7]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-C7",
              class: "connector spine",
              width: "65px",
              "data-anchor-y": "0.2"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-C7",
              class: "connector label"
            }, null, 512)
          ], 544)
        ]),
        w("div", {
          ref: "spine-stack-c",
          class: "spine-stack",
          "data-procedure-category": "c",
          innerHTML: L.procedureLayout.c
        }, null, 8, In5)
      ]),
      w("div", Tn5, [
        w("div", On5, [
          w("label", {
            ref: "spine-label-T1",
            onMouseenter: e[118] || (e[118] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[119] || (e[119] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[0],
              onChange: e[117] || (e[117] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, zn5),
            w("span", null, y5(L.spineLocations.t[0]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T1",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T2",
            onMouseenter: e[121] || (e[121] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[122] || (e[122] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[1],
              onChange: e[120] || (e[120] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Pn5),
            w("span", null, y5(L.spineLocations.t[1]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T2",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T3",
            onMouseenter: e[124] || (e[124] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[125] || (e[125] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[2],
              onChange: e[123] || (e[123] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, An5),
            w("span", null, y5(L.spineLocations.t[2]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T3",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T4",
            onMouseenter: e[127] || (e[127] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[128] || (e[128] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[3],
              onChange: e[126] || (e[126] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, $n5),
            w("span", null, y5(L.spineLocations.t[3]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T4",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T5",
            onMouseenter: e[130] || (e[130] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[131] || (e[131] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[4],
              onChange: e[129] || (e[129] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Zn5),
            w("span", null, y5(L.spineLocations.t[4]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T5",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T6",
            onMouseenter: e[133] || (e[133] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[134] || (e[134] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[5],
              onChange: e[132] || (e[132] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Nn5),
            w("span", null, y5(L.spineLocations.t[5]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T6",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T7",
            onMouseenter: e[136] || (e[136] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[137] || (e[137] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[6],
              onChange: e[135] || (e[135] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Bn5),
            w("span", null, y5(L.spineLocations.t[6]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T7",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T8",
            onMouseenter: e[139] || (e[139] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[140] || (e[140] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[7],
              onChange: e[138] || (e[138] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Rn5),
            w("span", null, y5(L.spineLocations.t[7]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T8",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T9",
            onMouseenter: e[142] || (e[142] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[143] || (e[143] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[8],
              onChange: e[141] || (e[141] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Hn5),
            w("span", null, y5(L.spineLocations.t[8]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T9",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T10",
            onMouseenter: e[145] || (e[145] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[146] || (e[146] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[9],
              onChange: e[144] || (e[144] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Fn5),
            w("span", null, y5(L.spineLocations.t[9]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T10",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T11",
            onMouseenter: e[148] || (e[148] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[149] || (e[149] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[10],
              onChange: e[147] || (e[147] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, jn5),
            w("span", null, y5(L.spineLocations.t[10]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T11",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-T12",
            onMouseenter: e[151] || (e[151] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[152] || (e[152] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.t[11],
              onChange: e[150] || (e[150] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Un5),
            w("span", null, y5(L.spineLocations.t[11]), 1),
            s5(l, {
              ref: "spine-connector-from-label-T12",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544)
        ]),
        w("div", {
          ref: "spine-stack-t",
          class: "spine-stack",
          "data-procedure-category": "t",
          innerHTML: L.procedureLayout.t
        }, null, 8, Yn5)
      ]),
      w("div", Vn5, [
        w("div", Wn5, [
          w("label", {
            ref: "spine-label-L1",
            onMouseenter: e[154] || (e[154] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[155] || (e[155] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.l[0],
              onChange: e[153] || (e[153] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Gn5),
            w("span", null, y5(L.spineLocations.l[0]), 1),
            s5(l, {
              ref: "spine-connector-from-label-L1",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-L2",
            onMouseenter: e[157] || (e[157] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[158] || (e[158] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.l[1],
              onChange: e[156] || (e[156] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, qn5),
            w("span", null, y5(L.spineLocations.l[1]), 1),
            s5(l, {
              ref: "spine-connector-from-label-L2",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-L3",
            onMouseenter: e[160] || (e[160] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[161] || (e[161] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.l[2],
              onChange: e[159] || (e[159] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Kn5),
            w("span", null, y5(L.spineLocations.l[2]), 1),
            s5(l, {
              ref: "spine-connector-from-label-L3",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-L4",
            onMouseenter: e[163] || (e[163] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[164] || (e[164] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.l[3],
              onChange: e[162] || (e[162] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Jn5),
            w("span", null, y5(L.spineLocations.l[3]), 1),
            s5(l, {
              ref: "spine-connector-from-label-L4",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-L5",
            onMouseenter: e[166] || (e[166] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[167] || (e[167] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.l[4],
              onChange: e[165] || (e[165] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, Qn5),
            w("span", null, y5(L.spineLocations.l[4]), 1),
            s5(l, {
              ref: "spine-connector-from-label-L5",
              class: "connector label"
            }, null, 512)
          ], 544)
        ]),
        w("div", {
          ref: "spine-stack-l",
          class: "spine-stack",
          "data-procedure-category": "l",
          innerHTML: L.procedureLayout.l
        }, null, 8, Xn5)
      ]),
      w("div", e05, [
        w("div", t05, [
          w("label", {
            ref: "spine-label-S1",
            onMouseenter: e[169] || (e[169] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[170] || (e[170] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.s[0],
              onChange: e[168] || (e[168] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, r05),
            w("span", null, y5(L.spineLocations.s[0]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-S1",
              class: "connector spine",
              width: "20px",
              "space-between": "2px",
              "data-anchor-y": "0.2"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-S1",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-S2",
            onMouseenter: e[172] || (e[172] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[173] || (e[173] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.s[1],
              onChange: e[171] || (e[171] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, n05),
            w("span", null, y5(L.spineLocations.s[1]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-S2",
              class: "connector spine",
              width: "20px",
              "space-between": "2px",
              "data-anchor-y": "0.3"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-S2",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-S3",
            onMouseenter: e[175] || (e[175] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[176] || (e[176] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.s[2],
              onChange: e[174] || (e[174] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, o05),
            w("span", null, y5(L.spineLocations.s[2]), 1),
            s5(l, {
              ref: "spine-connector-from-label-S3",
              class: "connector label",
              "data-anchor-y": "0.8"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-S4",
            onMouseenter: e[178] || (e[178] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[179] || (e[179] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.s[3],
              onChange: e[177] || (e[177] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, i05),
            w("span", null, y5(L.spineLocations.s[3]), 1),
            s5(l, {
              ref: "spine-connector-from-label-S4",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-S5",
            onMouseenter: e[181] || (e[181] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[182] || (e[182] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.s[4],
              onChange: e[180] || (e[180] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, L05),
            w("span", null, y5(L.spineLocations.s[4]), 1),
            s5(l, {
              ref: "spine-connector-from-label-S5",
              class: "connector label"
            }, null, 512)
          ], 544),
          w("label", {
            ref: "spine-label-Becken",
            onMouseenter: e[184] || (e[184] = (...s) => i.spineLabelHoverIn && i.spineLabelHoverIn(...s)),
            onMouseleave: e[185] || (e[185] = (...s) => i.spineLabelHoverOut && i.spineLabelHoverOut(...s))
          }, [
            w("input", {
              type: "checkbox",
              name: r.name,
              value: L.spineLocations.s[5],
              onChange: e[183] || (e[183] = (...s) => i.spineLabelSelected && i.spineLabelSelected(...s))
            }, null, 40, a05),
            w("span", null, y5(L.spineLocations.s[5]), 1),
            s5(l, {
              ref: "spine-connector-from-spine-Becken",
              class: "connector spine",
              width: "35px",
              "data-anchor-x": "0.77",
              "data-anchor-y": "0.9"
            }, null, 512),
            s5(l, {
              ref: "spine-connector-from-label-Becken",
              class: "connector label"
            }, null, 512)
          ], 544)
        ]),
        w("div", {
          ref: "spine-stack-s",
          class: "spine-stack",
          "data-procedure-category": "s",
          innerHTML: L.procedureLayout.s
        }, null, 8, s05)
      ])
    ])
  ]);
}
const b45 = /* @__PURE__ */ U5(Nr5, [["render", l05]]);
var bl;
const u05 = typeof window < "u";
u05 && (bl = window == null ? void 0 : window.navigator) != null && bl.userAgent && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function c05(t) {
  return t;
}
const xl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, kl = "__vueuse_ssr_handlers__";
xl[kl] = xl[kl] || {};
var Ml;
(function(t) {
  t.UP = "UP", t.RIGHT = "RIGHT", t.DOWN = "DOWN", t.LEFT = "LEFT", t.NONE = "NONE";
})(Ml || (Ml = {}));
var h05 = Object.defineProperty, _l = Object.getOwnPropertySymbols, d05 = Object.prototype.hasOwnProperty, f05 = Object.prototype.propertyIsEnumerable, Cl = (t, e, r) => e in t ? h05(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, p05 = (t, e) => {
  for (var r in e || (e = {}))
    d05.call(e, r) && Cl(t, r, e[r]);
  if (_l)
    for (var r of _l(e))
      f05.call(e, r) && Cl(t, r, e[r]);
  return t;
};
const g05 = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
p05({
  linear: c05
}, g05);
const m05 = { class: "flex-1" }, v05 = { class: "flex gap-4" }, y05 = { class: "flex-1" }, w05 = { class: "" }, b05 = { class: "flex-1 mt-[50px] mb-[50px]" }, x05 = { class: "flex gap-4" }, k05 = { class: "flex-1" }, M05 = { class: "" }, _05 = { class: "flex-1" }, C05 = { class: "flex gap-4" }, S05 = { class: "flex-1" }, D05 = { class: "" }, x45 = /* @__PURE__ */ J5({
  __name: "MfxLineSpacingSelector",
  props: {
    vertical: { type: Boolean, default: !0 }
  },
  emits: ["update:linespacing"],
  setup(t, { emit: e }) {
    const r = t, n = u5("Default"), L = (i) => {
      e("update:linespacing", i);
    };
    return (i, l) => (G(), J("div", {
      class: N5(["flex justify-between", {
        "flex-col": r.vertical
      }])
    }, [
      w("div", m05, [
        w("div", v05, [
          w("div", y05, [
            s5(Z5(bi), {
              modelValue: n.value,
              "onUpdate:modelValue": [
                l[0] || (l[0] = (s) => n.value = s),
                L
              ],
              name: "spacing",
              text: "Default",
              value: "Default"
            }, null, 8, ["modelValue"])
          ]),
          w("div", w05, [
            s5(Z5(Z55))
          ])
        ])
      ]),
      w("div", b05, [
        w("div", x05, [
          w("div", k05, [
            s5(Z5(bi), {
              modelValue: n.value,
              "onUpdate:modelValue": [
                l[1] || (l[1] = (s) => n.value = s),
                L
              ],
              name: "spacing",
              text: "Comfortable",
              value: "Comfortable"
            }, null, 8, ["modelValue"])
          ]),
          w("div", M05, [
            s5(Z5(_55))
          ])
        ])
      ]),
      w("div", _05, [
        w("div", C05, [
          w("div", S05, [
            s5(Z5(bi), {
              modelValue: n.value,
              "onUpdate:modelValue": [
                l[2] || (l[2] = (s) => n.value = s),
                L
              ],
              name: "spacing",
              text: "Compact",
              value: "Compact"
            }, null, 8, ["modelValue"])
          ]),
          w("div", D05, [
            s5(Z5(T55))
          ])
        ])
      ])
    ], 2));
  }
}), E05 = { class: "flex-1 text-center" }, I05 = /* @__PURE__ */ w("div", null, "Default", -1), T05 = { class: "flex-1 text-center" }, O05 = /* @__PURE__ */ w("div", null, "Large", -1), z05 = { class: "flex-1 text-center" }, P05 = /* @__PURE__ */ w("div", null, "Extra Large", -1), Ln = "selected", k45 = /* @__PURE__ */ J5({
  __name: "MfxFontSizeSelector",
  props: {
    vertical: { type: Boolean, default: !1 }
  },
  emits: ["update:fontsize"],
  setup(t, { emit: e }) {
    const r = t, n = u5(null), L = u5(null), i = u5(null), l = (s) => {
      switch (L.value.classList.remove(Ln), i.value.classList.remove(Ln), n.value.classList.remove(Ln), s) {
        case "LG":
          L.value.classList.add(Ln);
          break;
        case "XL":
          i.value.classList.add(Ln);
          break;
        default:
          n.value.classList.add(Ln);
          break;
      }
      e("update:fontsize", s);
    };
    return (s, c) => (G(), J("div", {
      class: N5(["flex", {
        "flex-col": r.vertical
      }])
    }, [
      w("div", E05, [
        w("div", {
          class: "mb-2 h-6 leading-38px",
          onClick: c[0] || (c[0] = (h) => l("D"))
        }, [
          w("span", {
            ref_key: "refDefault",
            ref: n,
            class: "selected cursor-pointer"
          }, "Aa", 512)
        ]),
        I05
      ]),
      w("div", T05, [
        w("div", {
          class: "mb-2 h-6 leading-38px",
          onClick: c[1] || (c[1] = (h) => l("LG"))
        }, [
          w("span", {
            ref_key: "refLg",
            ref: L,
            class: "text-xl cursor-pointer"
          }, "Aa", 512)
        ]),
        O05
      ]),
      w("div", z05, [
        w("div", {
          class: "mb-2 h-6",
          onClick: c[2] || (c[2] = (h) => l("XL"))
        }, [
          w("span", {
            ref_key: "refXL",
            ref: i,
            class: "text-2xl cursor-pointer"
          }, "Aa", 512)
        ]),
        P05
      ])
    ], 2));
  }
});
var A05 = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, Bh = {}, ke = {};
let H3;
const $05 = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
ke.getSymbolSize = function(t) {
  if (!t)
    throw new Error('"version" cannot be null or undefined');
  if (t < 1 || t > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return t * 4 + 17;
};
ke.getSymbolTotalCodewords = function(t) {
  return $05[t];
};
ke.getBCHDigit = function(t) {
  let e = 0;
  for (; t !== 0; )
    e++, t >>>= 1;
  return e;
};
ke.setToSJISFunction = function(t) {
  if (typeof t != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  H3 = t;
};
ke.isKanjiModeEnabled = function() {
  return typeof H3 < "u";
};
ke.toSJIS = function(t) {
  return H3(t);
};
var Io = {};
(function(t) {
  t.L = { bit: 1 }, t.M = { bit: 0 }, t.Q = { bit: 3 }, t.H = { bit: 2 };
  function e(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "l":
      case "low":
        return t.L;
      case "m":
      case "medium":
        return t.M;
      case "q":
      case "quartile":
        return t.Q;
      case "h":
      case "high":
        return t.H;
      default:
        throw new Error("Unknown EC Level: " + r);
    }
  }
  t.isValid = function(r) {
    return r && typeof r.bit < "u" && r.bit >= 0 && r.bit < 4;
  }, t.from = function(r, n) {
    if (t.isValid(r))
      return r;
    try {
      return e(r);
    } catch {
      return n;
    }
  };
})(Io);
function Rh() {
  this.buffer = [], this.length = 0;
}
Rh.prototype = {
  get: function(t) {
    const e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) === 1;
  },
  put: function(t, e) {
    for (let r = 0; r < e; r++)
      this.putBit((t >>> e - r - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(t) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var Z05 = Rh;
function a2(t) {
  if (!t || t < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
}
a2.prototype.set = function(t, e, r, n) {
  const L = t * this.size + e;
  this.data[L] = r, n && (this.reservedBit[L] = !0);
};
a2.prototype.get = function(t, e) {
  return this.data[t * this.size + e];
};
a2.prototype.xor = function(t, e, r) {
  this.data[t * this.size + e] ^= r;
};
a2.prototype.isReserved = function(t, e) {
  return this.reservedBit[t * this.size + e];
};
var N05 = a2, Hh = {};
(function(t) {
  const e = ke.getSymbolSize;
  t.getRowColCoords = function(r) {
    if (r === 1)
      return [];
    const n = Math.floor(r / 7) + 2, L = e(r), i = L === 145 ? 26 : Math.ceil((L - 13) / (2 * n - 2)) * 2, l = [L - 7];
    for (let s = 1; s < n - 1; s++)
      l[s] = l[s - 1] - i;
    return l.push(6), l.reverse();
  }, t.getPositions = function(r) {
    const n = [], L = t.getRowColCoords(r), i = L.length;
    for (let l = 0; l < i; l++)
      for (let s = 0; s < i; s++)
        l === 0 && s === 0 || // top-left
        l === 0 && s === i - 1 || // bottom-left
        l === i - 1 && s === 0 || n.push([L[l], L[s]]);
    return n;
  };
})(Hh);
var Fh = {};
const B05 = ke.getSymbolSize, Sl = 7;
Fh.getPositions = function(t) {
  const e = B05(t);
  return [
    // top-left
    [0, 0],
    // top-right
    [e - Sl, 0],
    // bottom-left
    [0, e - Sl]
  ];
};
var jh = {};
(function(t) {
  t.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  t.isValid = function(n) {
    return n != null && n !== "" && !isNaN(n) && n >= 0 && n <= 7;
  }, t.from = function(n) {
    return t.isValid(n) ? parseInt(n, 10) : void 0;
  }, t.getPenaltyN1 = function(n) {
    const L = n.size;
    let i = 0, l = 0, s = 0, c = null, h = null;
    for (let f = 0; f < L; f++) {
      l = s = 0, c = h = null;
      for (let g = 0; g < L; g++) {
        let m = n.get(f, g);
        m === c ? l++ : (l >= 5 && (i += e.N1 + (l - 5)), c = m, l = 1), m = n.get(g, f), m === h ? s++ : (s >= 5 && (i += e.N1 + (s - 5)), h = m, s = 1);
      }
      l >= 5 && (i += e.N1 + (l - 5)), s >= 5 && (i += e.N1 + (s - 5));
    }
    return i;
  }, t.getPenaltyN2 = function(n) {
    const L = n.size;
    let i = 0;
    for (let l = 0; l < L - 1; l++)
      for (let s = 0; s < L - 1; s++) {
        const c = n.get(l, s) + n.get(l, s + 1) + n.get(l + 1, s) + n.get(l + 1, s + 1);
        (c === 4 || c === 0) && i++;
      }
    return i * e.N2;
  }, t.getPenaltyN3 = function(n) {
    const L = n.size;
    let i = 0, l = 0, s = 0;
    for (let c = 0; c < L; c++) {
      l = s = 0;
      for (let h = 0; h < L; h++)
        l = l << 1 & 2047 | n.get(c, h), h >= 10 && (l === 1488 || l === 93) && i++, s = s << 1 & 2047 | n.get(h, c), h >= 10 && (s === 1488 || s === 93) && i++;
    }
    return i * e.N3;
  }, t.getPenaltyN4 = function(n) {
    let L = 0;
    const i = n.data.length;
    for (let l = 0; l < i; l++)
      L += n.data[l];
    return Math.abs(Math.ceil(L * 100 / i / 5) - 10) * e.N4;
  };
  function r(n, L, i) {
    switch (n) {
      case t.Patterns.PATTERN000:
        return (L + i) % 2 === 0;
      case t.Patterns.PATTERN001:
        return L % 2 === 0;
      case t.Patterns.PATTERN010:
        return i % 3 === 0;
      case t.Patterns.PATTERN011:
        return (L + i) % 3 === 0;
      case t.Patterns.PATTERN100:
        return (Math.floor(L / 2) + Math.floor(i / 3)) % 2 === 0;
      case t.Patterns.PATTERN101:
        return L * i % 2 + L * i % 3 === 0;
      case t.Patterns.PATTERN110:
        return (L * i % 2 + L * i % 3) % 2 === 0;
      case t.Patterns.PATTERN111:
        return (L * i % 3 + (L + i) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + n);
    }
  }
  t.applyMask = function(n, L) {
    const i = L.size;
    for (let l = 0; l < i; l++)
      for (let s = 0; s < i; s++)
        L.isReserved(s, l) || L.xor(s, l, r(n, s, l));
  }, t.getBestMask = function(n, L) {
    const i = Object.keys(t.Patterns).length;
    let l = 0, s = 1 / 0;
    for (let c = 0; c < i; c++) {
      L(c), t.applyMask(c, n);
      const h = t.getPenaltyN1(n) + t.getPenaltyN2(n) + t.getPenaltyN3(n) + t.getPenaltyN4(n);
      t.applyMask(c, n), h < s && (s = h, l = c);
    }
    return l;
  };
})(jh);
var To = {};
const or = Io, u4 = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], c4 = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
To.getBlocksCount = function(t, e) {
  switch (e) {
    case or.L:
      return u4[(t - 1) * 4 + 0];
    case or.M:
      return u4[(t - 1) * 4 + 1];
    case or.Q:
      return u4[(t - 1) * 4 + 2];
    case or.H:
      return u4[(t - 1) * 4 + 3];
    default:
      return;
  }
};
To.getTotalCodewordsCount = function(t, e) {
  switch (e) {
    case or.L:
      return c4[(t - 1) * 4 + 0];
    case or.M:
      return c4[(t - 1) * 4 + 1];
    case or.Q:
      return c4[(t - 1) * 4 + 2];
    case or.H:
      return c4[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var Uh = {}, Oo = {};
const I0 = new Uint8Array(512), U4 = new Uint8Array(256);
(function() {
  let t = 1;
  for (let e = 0; e < 255; e++)
    I0[e] = t, U4[t] = e, t <<= 1, t & 256 && (t ^= 285);
  for (let e = 255; e < 512; e++)
    I0[e] = I0[e - 255];
})();
Oo.log = function(t) {
  if (t < 1)
    throw new Error("log(" + t + ")");
  return U4[t];
};
Oo.exp = function(t) {
  return I0[t];
};
Oo.mul = function(t, e) {
  return t === 0 || e === 0 ? 0 : I0[U4[t] + U4[e]];
};
(function(t) {
  const e = Oo;
  t.mul = function(r, n) {
    const L = new Uint8Array(r.length + n.length - 1);
    for (let i = 0; i < r.length; i++)
      for (let l = 0; l < n.length; l++)
        L[i + l] ^= e.mul(r[i], n[l]);
    return L;
  }, t.mod = function(r, n) {
    let L = new Uint8Array(r);
    for (; L.length - n.length >= 0; ) {
      const i = L[0];
      for (let s = 0; s < n.length; s++)
        L[s] ^= e.mul(n[s], i);
      let l = 0;
      for (; l < L.length && L[l] === 0; )
        l++;
      L = L.slice(l);
    }
    return L;
  }, t.generateECPolynomial = function(r) {
    let n = new Uint8Array([1]);
    for (let L = 0; L < r; L++)
      n = t.mul(n, new Uint8Array([1, e.exp(L)]));
    return n;
  };
})(Uh);
const Yh = Uh;
function F3(t) {
  this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
}
F3.prototype.initialize = function(t) {
  this.degree = t, this.genPoly = Yh.generateECPolynomial(this.degree);
};
F3.prototype.encode = function(t) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const e = new Uint8Array(t.length + this.degree);
  e.set(t);
  const r = Yh.mod(e, this.genPoly), n = this.degree - r.length;
  if (n > 0) {
    const L = new Uint8Array(this.degree);
    return L.set(r, n), L;
  }
  return r;
};
var R05 = F3, Vh = {}, hr = {}, j3 = {};
j3.isValid = function(t) {
  return !isNaN(t) && t >= 1 && t <= 40;
};
var yt = {};
const Wh = "[0-9]+", H05 = "[A-Z $%*+\\-./:]+";
let Y0 = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
Y0 = Y0.replace(/u/g, "\\u");
const F05 = "(?:(?![A-Z0-9 $%*+\\-./:]|" + Y0 + `)(?:.|[\r
]))+`;
yt.KANJI = new RegExp(Y0, "g");
yt.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
yt.BYTE = new RegExp(F05, "g");
yt.NUMERIC = new RegExp(Wh, "g");
yt.ALPHANUMERIC = new RegExp(H05, "g");
const j05 = new RegExp("^" + Y0 + "$"), U05 = new RegExp("^" + Wh + "$"), Y05 = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
yt.testKanji = function(t) {
  return j05.test(t);
};
yt.testNumeric = function(t) {
  return U05.test(t);
};
yt.testAlphanumeric = function(t) {
  return Y05.test(t);
};
(function(t) {
  const e = j3, r = yt;
  t.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, t.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, t.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, t.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, t.MIXED = {
    bit: -1
  }, t.getCharCountIndicator = function(L, i) {
    if (!L.ccBits)
      throw new Error("Invalid mode: " + L);
    if (!e.isValid(i))
      throw new Error("Invalid version: " + i);
    return i >= 1 && i < 10 ? L.ccBits[0] : i < 27 ? L.ccBits[1] : L.ccBits[2];
  }, t.getBestModeForData = function(L) {
    return r.testNumeric(L) ? t.NUMERIC : r.testAlphanumeric(L) ? t.ALPHANUMERIC : r.testKanji(L) ? t.KANJI : t.BYTE;
  }, t.toString = function(L) {
    if (L && L.id)
      return L.id;
    throw new Error("Invalid mode");
  }, t.isValid = function(L) {
    return L && L.bit && L.ccBits;
  };
  function n(L) {
    if (typeof L != "string")
      throw new Error("Param is not a string");
    switch (L.toLowerCase()) {
      case "numeric":
        return t.NUMERIC;
      case "alphanumeric":
        return t.ALPHANUMERIC;
      case "kanji":
        return t.KANJI;
      case "byte":
        return t.BYTE;
      default:
        throw new Error("Unknown mode: " + L);
    }
  }
  t.from = function(L, i) {
    if (t.isValid(L))
      return L;
    try {
      return n(L);
    } catch {
      return i;
    }
  };
})(hr);
(function(t) {
  const e = ke, r = To, n = Io, L = hr, i = j3, l = 7973, s = e.getBCHDigit(l);
  function c(m, b, k) {
    for (let x = 1; x <= 40; x++)
      if (b <= t.getCapacity(x, k, m))
        return x;
  }
  function h(m, b) {
    return L.getCharCountIndicator(m, b) + 4;
  }
  function f(m, b) {
    let k = 0;
    return m.forEach(function(x) {
      const D = h(x.mode, b);
      k += D + x.getBitsLength();
    }), k;
  }
  function g(m, b) {
    for (let k = 1; k <= 40; k++)
      if (f(m, k) <= t.getCapacity(k, b, L.MIXED))
        return k;
  }
  t.from = function(m, b) {
    return i.isValid(m) ? parseInt(m, 10) : b;
  }, t.getCapacity = function(m, b, k) {
    if (!i.isValid(m))
      throw new Error("Invalid QR Code version");
    typeof k > "u" && (k = L.BYTE);
    const x = e.getSymbolTotalCodewords(m), D = r.getTotalCodewordsCount(m, b), M = (x - D) * 8;
    if (k === L.MIXED)
      return M;
    const E = M - h(k, m);
    switch (k) {
      case L.NUMERIC:
        return Math.floor(E / 10 * 3);
      case L.ALPHANUMERIC:
        return Math.floor(E / 11 * 2);
      case L.KANJI:
        return Math.floor(E / 13);
      case L.BYTE:
      default:
        return Math.floor(E / 8);
    }
  }, t.getBestVersionForData = function(m, b) {
    let k;
    const x = n.from(b, n.M);
    if (Array.isArray(m)) {
      if (m.length > 1)
        return g(m, x);
      if (m.length === 0)
        return 1;
      k = m[0];
    } else
      k = m;
    return c(k.mode, k.getLength(), x);
  }, t.getEncodedBits = function(m) {
    if (!i.isValid(m) || m < 7)
      throw new Error("Invalid QR Code version");
    let b = m << 12;
    for (; e.getBCHDigit(b) - s >= 0; )
      b ^= l << e.getBCHDigit(b) - s;
    return m << 12 | b;
  };
})(Vh);
var Gh = {};
const bL = ke, qh = 1335, V05 = 21522, Dl = bL.getBCHDigit(qh);
Gh.getEncodedBits = function(t, e) {
  const r = t.bit << 3 | e;
  let n = r << 10;
  for (; bL.getBCHDigit(n) - Dl >= 0; )
    n ^= qh << bL.getBCHDigit(n) - Dl;
  return (r << 10 | n) ^ V05;
};
var Kh = {};
const W05 = hr;
function Mn(t) {
  this.mode = W05.NUMERIC, this.data = t.toString();
}
Mn.getBitsLength = function(t) {
  return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
Mn.prototype.getLength = function() {
  return this.data.length;
};
Mn.prototype.getBitsLength = function() {
  return Mn.getBitsLength(this.data.length);
};
Mn.prototype.write = function(t) {
  let e, r, n;
  for (e = 0; e + 3 <= this.data.length; e += 3)
    r = this.data.substr(e, 3), n = parseInt(r, 10), t.put(n, 10);
  const L = this.data.length - e;
  L > 0 && (r = this.data.substr(e), n = parseInt(r, 10), t.put(n, L * 3 + 1));
};
var G05 = Mn;
const q05 = hr, Pi = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function _n(t) {
  this.mode = q05.ALPHANUMERIC, this.data = t;
}
_n.getBitsLength = function(t) {
  return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
_n.prototype.getLength = function() {
  return this.data.length;
};
_n.prototype.getBitsLength = function() {
  return _n.getBitsLength(this.data.length);
};
_n.prototype.write = function(t) {
  let e;
  for (e = 0; e + 2 <= this.data.length; e += 2) {
    let r = Pi.indexOf(this.data[e]) * 45;
    r += Pi.indexOf(this.data[e + 1]), t.put(r, 11);
  }
  this.data.length % 2 && t.put(Pi.indexOf(this.data[e]), 6);
};
var K05 = _n, J05 = function(t) {
  for (var e = [], r = t.length, n = 0; n < r; n++) {
    var L = t.charCodeAt(n);
    if (L >= 55296 && L <= 56319 && r > n + 1) {
      var i = t.charCodeAt(n + 1);
      i >= 56320 && i <= 57343 && (L = (L - 55296) * 1024 + i - 56320 + 65536, n += 1);
    }
    if (L < 128) {
      e.push(L);
      continue;
    }
    if (L < 2048) {
      e.push(L >> 6 | 192), e.push(L & 63 | 128);
      continue;
    }
    if (L < 55296 || L >= 57344 && L < 65536) {
      e.push(L >> 12 | 224), e.push(L >> 6 & 63 | 128), e.push(L & 63 | 128);
      continue;
    }
    if (L >= 65536 && L <= 1114111) {
      e.push(L >> 18 | 240), e.push(L >> 12 & 63 | 128), e.push(L >> 6 & 63 | 128), e.push(L & 63 | 128);
      continue;
    }
    e.push(239, 191, 189);
  }
  return new Uint8Array(e).buffer;
};
const Q05 = J05, X05 = hr;
function Cn(t) {
  this.mode = X05.BYTE, typeof t == "string" && (t = Q05(t)), this.data = new Uint8Array(t);
}
Cn.getBitsLength = function(t) {
  return t * 8;
};
Cn.prototype.getLength = function() {
  return this.data.length;
};
Cn.prototype.getBitsLength = function() {
  return Cn.getBitsLength(this.data.length);
};
Cn.prototype.write = function(t) {
  for (let e = 0, r = this.data.length; e < r; e++)
    t.put(this.data[e], 8);
};
var e25 = Cn;
const t25 = hr, r25 = ke;
function Sn(t) {
  this.mode = t25.KANJI, this.data = t;
}
Sn.getBitsLength = function(t) {
  return t * 13;
};
Sn.prototype.getLength = function() {
  return this.data.length;
};
Sn.prototype.getBitsLength = function() {
  return Sn.getBitsLength(this.data.length);
};
Sn.prototype.write = function(t) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let r = r25.toSJIS(this.data[e]);
    if (r >= 33088 && r <= 40956)
      r -= 33088;
    else if (r >= 57408 && r <= 60351)
      r -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    r = (r >>> 8 & 255) * 192 + (r & 255), t.put(r, 13);
  }
};
var n25 = Sn, Jh = { exports: {} };
(function(t) {
  var e = {
    single_source_shortest_paths: function(r, n, L) {
      var i = {}, l = {};
      l[n] = 0;
      var s = e.PriorityQueue.make();
      s.push(n, 0);
      for (var c, h, f, g, m, b, k, x, D; !s.empty(); ) {
        c = s.pop(), h = c.value, g = c.cost, m = r[h] || {};
        for (f in m)
          m.hasOwnProperty(f) && (b = m[f], k = g + b, x = l[f], D = typeof l[f] > "u", (D || x > k) && (l[f] = k, s.push(f, k), i[f] = h));
      }
      if (typeof L < "u" && typeof l[L] > "u") {
        var M = ["Could not find a path from ", n, " to ", L, "."].join("");
        throw new Error(M);
      }
      return i;
    },
    extract_shortest_path_from_predecessor_list: function(r, n) {
      for (var L = [], i = n; i; )
        L.push(i), r[i], i = r[i];
      return L.reverse(), L;
    },
    find_path: function(r, n, L) {
      var i = e.single_source_shortest_paths(r, n, L);
      return e.extract_shortest_path_from_predecessor_list(
        i,
        L
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(r) {
        var n = e.PriorityQueue, L = {}, i;
        r = r || {};
        for (i in n)
          n.hasOwnProperty(i) && (L[i] = n[i]);
        return L.queue = [], L.sorter = r.sorter || n.default_sorter, L;
      },
      default_sorter: function(r, n) {
        return r.cost - n.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(r, n) {
        var L = { value: r, cost: n };
        this.queue.push(L), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  t.exports = e;
})(Jh);
var o25 = Jh.exports;
(function(t) {
  const e = hr, r = G05, n = K05, L = e25, i = n25, l = yt, s = ke, c = o25;
  function h(M) {
    return unescape(encodeURIComponent(M)).length;
  }
  function f(M, E, S) {
    const C = [];
    let P;
    for (; (P = M.exec(S)) !== null; )
      C.push({
        data: P[0],
        index: P.index,
        mode: E,
        length: P[0].length
      });
    return C;
  }
  function g(M) {
    const E = f(l.NUMERIC, e.NUMERIC, M), S = f(l.ALPHANUMERIC, e.ALPHANUMERIC, M);
    let C, P;
    return s.isKanjiModeEnabled() ? (C = f(l.BYTE, e.BYTE, M), P = f(l.KANJI, e.KANJI, M)) : (C = f(l.BYTE_KANJI, e.BYTE, M), P = []), E.concat(S, C, P).sort(function(A, Z) {
      return A.index - Z.index;
    }).map(function(A) {
      return {
        data: A.data,
        mode: A.mode,
        length: A.length
      };
    });
  }
  function m(M, E) {
    switch (E) {
      case e.NUMERIC:
        return r.getBitsLength(M);
      case e.ALPHANUMERIC:
        return n.getBitsLength(M);
      case e.KANJI:
        return i.getBitsLength(M);
      case e.BYTE:
        return L.getBitsLength(M);
    }
  }
  function b(M) {
    return M.reduce(function(E, S) {
      const C = E.length - 1 >= 0 ? E[E.length - 1] : null;
      return C && C.mode === S.mode ? (E[E.length - 1].data += S.data, E) : (E.push(S), E);
    }, []);
  }
  function k(M) {
    const E = [];
    for (let S = 0; S < M.length; S++) {
      const C = M[S];
      switch (C.mode) {
        case e.NUMERIC:
          E.push([
            C,
            { data: C.data, mode: e.ALPHANUMERIC, length: C.length },
            { data: C.data, mode: e.BYTE, length: C.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          E.push([
            C,
            { data: C.data, mode: e.BYTE, length: C.length }
          ]);
          break;
        case e.KANJI:
          E.push([
            C,
            { data: C.data, mode: e.BYTE, length: h(C.data) }
          ]);
          break;
        case e.BYTE:
          E.push([
            { data: C.data, mode: e.BYTE, length: h(C.data) }
          ]);
      }
    }
    return E;
  }
  function x(M, E) {
    const S = {}, C = { start: {} };
    let P = ["start"];
    for (let A = 0; A < M.length; A++) {
      const Z = M[A], B = [];
      for (let U = 0; U < Z.length; U++) {
        const K = Z[U], r5 = "" + A + U;
        B.push(r5), S[r5] = { node: K, lastCount: 0 }, C[r5] = {};
        for (let a5 = 0; a5 < P.length; a5++) {
          const V = P[a5];
          S[V] && S[V].node.mode === K.mode ? (C[V][r5] = m(S[V].lastCount + K.length, K.mode) - m(S[V].lastCount, K.mode), S[V].lastCount += K.length) : (S[V] && (S[V].lastCount = K.length), C[V][r5] = m(K.length, K.mode) + 4 + e.getCharCountIndicator(K.mode, E));
        }
      }
      P = B;
    }
    for (let A = 0; A < P.length; A++)
      C[P[A]].end = 0;
    return { map: C, table: S };
  }
  function D(M, E) {
    let S;
    const C = e.getBestModeForData(M);
    if (S = e.from(E, C), S !== e.BYTE && S.bit < C.bit)
      throw new Error('"' + M + '" cannot be encoded with mode ' + e.toString(S) + `.
 Suggested mode is: ` + e.toString(C));
    switch (S === e.KANJI && !s.isKanjiModeEnabled() && (S = e.BYTE), S) {
      case e.NUMERIC:
        return new r(M);
      case e.ALPHANUMERIC:
        return new n(M);
      case e.KANJI:
        return new i(M);
      case e.BYTE:
        return new L(M);
    }
  }
  t.fromArray = function(M) {
    return M.reduce(function(E, S) {
      return typeof S == "string" ? E.push(D(S, null)) : S.data && E.push(D(S.data, S.mode)), E;
    }, []);
  }, t.fromString = function(M, E) {
    const S = g(M, s.isKanjiModeEnabled()), C = k(S), P = x(C, E), A = c.find_path(P.map, "start", "end"), Z = [];
    for (let B = 1; B < A.length - 1; B++)
      Z.push(P.table[A[B]].node);
    return t.fromArray(b(Z));
  }, t.rawSplit = function(M) {
    return t.fromArray(
      g(M, s.isKanjiModeEnabled())
    );
  };
})(Kh);
const zo = ke, Ai = Io, i25 = Z05, L25 = N05, a25 = Hh, s25 = Fh, xL = jh, kL = To, l25 = R05, Y4 = Vh, u25 = Gh, c25 = hr, $i = Kh;
function h25(t, e) {
  const r = t.size, n = s25.getPositions(e);
  for (let L = 0; L < n.length; L++) {
    const i = n[L][0], l = n[L][1];
    for (let s = -1; s <= 7; s++)
      if (!(i + s <= -1 || r <= i + s))
        for (let c = -1; c <= 7; c++)
          l + c <= -1 || r <= l + c || (s >= 0 && s <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (s === 0 || s === 6) || s >= 2 && s <= 4 && c >= 2 && c <= 4 ? t.set(i + s, l + c, !0, !0) : t.set(i + s, l + c, !1, !0));
  }
}
function d25(t) {
  const e = t.size;
  for (let r = 8; r < e - 8; r++) {
    const n = r % 2 === 0;
    t.set(r, 6, n, !0), t.set(6, r, n, !0);
  }
}
function f25(t, e) {
  const r = a25.getPositions(e);
  for (let n = 0; n < r.length; n++) {
    const L = r[n][0], i = r[n][1];
    for (let l = -2; l <= 2; l++)
      for (let s = -2; s <= 2; s++)
        l === -2 || l === 2 || s === -2 || s === 2 || l === 0 && s === 0 ? t.set(L + l, i + s, !0, !0) : t.set(L + l, i + s, !1, !0);
  }
}
function p25(t, e) {
  const r = t.size, n = Y4.getEncodedBits(e);
  let L, i, l;
  for (let s = 0; s < 18; s++)
    L = Math.floor(s / 3), i = s % 3 + r - 8 - 3, l = (n >> s & 1) === 1, t.set(L, i, l, !0), t.set(i, L, l, !0);
}
function Zi(t, e, r) {
  const n = t.size, L = u25.getEncodedBits(e, r);
  let i, l;
  for (i = 0; i < 15; i++)
    l = (L >> i & 1) === 1, i < 6 ? t.set(i, 8, l, !0) : i < 8 ? t.set(i + 1, 8, l, !0) : t.set(n - 15 + i, 8, l, !0), i < 8 ? t.set(8, n - i - 1, l, !0) : i < 9 ? t.set(8, 15 - i - 1 + 1, l, !0) : t.set(8, 15 - i - 1, l, !0);
  t.set(n - 8, 8, 1, !0);
}
function g25(t, e) {
  const r = t.size;
  let n = -1, L = r - 1, i = 7, l = 0;
  for (let s = r - 1; s > 0; s -= 2)
    for (s === 6 && s--; ; ) {
      for (let c = 0; c < 2; c++)
        if (!t.isReserved(L, s - c)) {
          let h = !1;
          l < e.length && (h = (e[l] >>> i & 1) === 1), t.set(L, s - c, h), i--, i === -1 && (l++, i = 7);
        }
      if (L += n, L < 0 || r <= L) {
        L -= n, n = -n;
        break;
      }
    }
}
function m25(t, e, r) {
  const n = new i25();
  r.forEach(function(c) {
    n.put(c.mode.bit, 4), n.put(c.getLength(), c25.getCharCountIndicator(c.mode, t)), c.write(n);
  });
  const L = zo.getSymbolTotalCodewords(t), i = kL.getTotalCodewordsCount(t, e), l = (L - i) * 8;
  for (n.getLengthInBits() + 4 <= l && n.put(0, 4); n.getLengthInBits() % 8 !== 0; )
    n.putBit(0);
  const s = (l - n.getLengthInBits()) / 8;
  for (let c = 0; c < s; c++)
    n.put(c % 2 ? 17 : 236, 8);
  return v25(n, t, e);
}
function v25(t, e, r) {
  const n = zo.getSymbolTotalCodewords(e), L = kL.getTotalCodewordsCount(e, r), i = n - L, l = kL.getBlocksCount(e, r), s = n % l, c = l - s, h = Math.floor(n / l), f = Math.floor(i / l), g = f + 1, m = h - f, b = new l25(m);
  let k = 0;
  const x = new Array(l), D = new Array(l);
  let M = 0;
  const E = new Uint8Array(t.buffer);
  for (let Z = 0; Z < l; Z++) {
    const B = Z < c ? f : g;
    x[Z] = E.slice(k, k + B), D[Z] = b.encode(x[Z]), k += B, M = Math.max(M, B);
  }
  const S = new Uint8Array(n);
  let C = 0, P, A;
  for (P = 0; P < M; P++)
    for (A = 0; A < l; A++)
      P < x[A].length && (S[C++] = x[A][P]);
  for (P = 0; P < m; P++)
    for (A = 0; A < l; A++)
      S[C++] = D[A][P];
  return S;
}
function y25(t, e, r, n) {
  let L;
  if (Array.isArray(t))
    L = $i.fromArray(t);
  else if (typeof t == "string") {
    let h = e;
    if (!h) {
      const f = $i.rawSplit(t);
      h = Y4.getBestVersionForData(f, r);
    }
    L = $i.fromString(t, h || 40);
  } else
    throw new Error("Invalid data");
  const i = Y4.getBestVersionForData(L, r);
  if (!i)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = i;
  else if (e < i)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + i + `.
`
    );
  const l = m25(e, r, L), s = zo.getSymbolSize(e), c = new L25(s);
  return h25(c, e), d25(c), f25(c, e), Zi(c, r, 0), e >= 7 && p25(c, e), g25(c, l), isNaN(n) && (n = xL.getBestMask(
    c,
    Zi.bind(null, c, r)
  )), xL.applyMask(n, c), Zi(c, r, n), {
    modules: c,
    version: e,
    errorCorrectionLevel: r,
    maskPattern: n,
    segments: L
  };
}
Bh.create = function(t, e) {
  if (typeof t > "u" || t === "")
    throw new Error("No input text");
  let r = Ai.M, n, L;
  return typeof e < "u" && (r = Ai.from(e.errorCorrectionLevel, Ai.M), n = Y4.from(e.version), L = xL.from(e.maskPattern), e.toSJISFunc && zo.setToSJISFunction(e.toSJISFunc)), y25(t, n, r, L);
};
var Qh = {}, U3 = {};
(function(t) {
  function e(r) {
    if (typeof r == "number" && (r = r.toString()), typeof r != "string")
      throw new Error("Color should be defined as hex string");
    let n = r.slice().replace("#", "").split("");
    if (n.length < 3 || n.length === 5 || n.length > 8)
      throw new Error("Invalid hex color: " + r);
    (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(i) {
      return [i, i];
    }))), n.length === 6 && n.push("F", "F");
    const L = parseInt(n.join(""), 16);
    return {
      r: L >> 24 & 255,
      g: L >> 16 & 255,
      b: L >> 8 & 255,
      a: L & 255,
      hex: "#" + n.slice(0, 6).join("")
    };
  }
  t.getOptions = function(r) {
    r || (r = {}), r.color || (r.color = {});
    const n = typeof r.margin > "u" || r.margin === null || r.margin < 0 ? 4 : r.margin, L = r.width && r.width >= 21 ? r.width : void 0, i = r.scale || 4;
    return {
      width: L,
      scale: L ? 4 : i,
      margin: n,
      color: {
        dark: e(r.color.dark || "#000000ff"),
        light: e(r.color.light || "#ffffffff")
      },
      type: r.type,
      rendererOpts: r.rendererOpts || {}
    };
  }, t.getScale = function(r, n) {
    return n.width && n.width >= r + n.margin * 2 ? n.width / (r + n.margin * 2) : n.scale;
  }, t.getImageWidth = function(r, n) {
    const L = t.getScale(r, n);
    return Math.floor((r + n.margin * 2) * L);
  }, t.qrToImageData = function(r, n, L) {
    const i = n.modules.size, l = n.modules.data, s = t.getScale(i, L), c = Math.floor((i + L.margin * 2) * s), h = L.margin * s, f = [L.color.light, L.color.dark];
    for (let g = 0; g < c; g++)
      for (let m = 0; m < c; m++) {
        let b = (g * c + m) * 4, k = L.color.light;
        if (g >= h && m >= h && g < c - h && m < c - h) {
          const x = Math.floor((g - h) / s), D = Math.floor((m - h) / s);
          k = f[l[x * i + D] ? 1 : 0];
        }
        r[b++] = k.r, r[b++] = k.g, r[b++] = k.b, r[b] = k.a;
      }
  };
})(U3);
(function(t) {
  const e = U3;
  function r(L, i, l) {
    L.clearRect(0, 0, i.width, i.height), i.style || (i.style = {}), i.height = l, i.width = l, i.style.height = l + "px", i.style.width = l + "px";
  }
  function n() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  t.render = function(L, i, l) {
    let s = l, c = i;
    typeof s > "u" && (!i || !i.getContext) && (s = i, i = void 0), i || (c = n()), s = e.getOptions(s);
    const h = e.getImageWidth(L.modules.size, s), f = c.getContext("2d"), g = f.createImageData(h, h);
    return e.qrToImageData(g.data, L, s), r(f, c, h), f.putImageData(g, 0, 0), c;
  }, t.renderToDataURL = function(L, i, l) {
    let s = l;
    typeof s > "u" && (!i || !i.getContext) && (s = i, i = void 0), s || (s = {});
    const c = t.render(L, i, s), h = s.type || "image/png", f = s.rendererOpts || {};
    return c.toDataURL(h, f.quality);
  };
})(Qh);
var Xh = {};
const w25 = U3;
function El(t, e) {
  const r = t.a / 255, n = e + '="' + t.hex + '"';
  return r < 1 ? n + " " + e + '-opacity="' + r.toFixed(2).slice(1) + '"' : n;
}
function Ni(t, e, r) {
  let n = t + e;
  return typeof r < "u" && (n += " " + r), n;
}
function b25(t, e, r) {
  let n = "", L = 0, i = !1, l = 0;
  for (let s = 0; s < t.length; s++) {
    const c = Math.floor(s % e), h = Math.floor(s / e);
    !c && !i && (i = !0), t[s] ? (l++, s > 0 && c > 0 && t[s - 1] || (n += i ? Ni("M", c + r, 0.5 + h + r) : Ni("m", L, 0), L = 0, i = !1), c + 1 < e && t[s + 1] || (n += Ni("h", l), l = 0)) : L++;
  }
  return n;
}
Xh.render = function(t, e, r) {
  const n = w25.getOptions(e), L = t.modules.size, i = t.modules.data, l = L + n.margin * 2, s = n.color.light.a ? "<path " + El(n.color.light, "fill") + ' d="M0 0h' + l + "v" + l + 'H0z"/>' : "", c = "<path " + El(n.color.dark, "stroke") + ' d="' + b25(i, L, n.margin) + '"/>', h = 'viewBox="0 0 ' + l + " " + l + '"', f = '<svg xmlns="http://www.w3.org/2000/svg" ' + (n.width ? 'width="' + n.width + '" height="' + n.width + '" ' : "") + h + ' shape-rendering="crispEdges">' + s + c + `</svg>
`;
  return typeof r == "function" && r(null, f), f;
};
const x25 = A05, ML = Bh, ed = Qh, k25 = Xh;
function Y3(t, e, r, n, L) {
  const i = [].slice.call(arguments, 1), l = i.length, s = typeof i[l - 1] == "function";
  if (!s && !x25())
    throw new Error("Callback required as last argument");
  if (s) {
    if (l < 2)
      throw new Error("Too few arguments provided");
    l === 2 ? (L = r, r = e, e = n = void 0) : l === 3 && (e.getContext && typeof L > "u" ? (L = n, n = void 0) : (L = n, n = r, r = e, e = void 0));
  } else {
    if (l < 1)
      throw new Error("Too few arguments provided");
    return l === 1 ? (r = e, e = n = void 0) : l === 2 && !e.getContext && (n = r, r = e, e = void 0), new Promise(function(c, h) {
      try {
        const f = ML.create(r, n);
        c(t(f, e, n));
      } catch (f) {
        h(f);
      }
    });
  }
  try {
    const c = ML.create(r, n);
    L(null, t(c, e, n));
  } catch (c) {
    L(c);
  }
}
ML.create;
Y3.bind(null, ed.render);
Y3.bind(null, ed.renderToDataURL);
Y3.bind(null, function(t, e, r) {
  return k25.render(t, r);
});
const M25 = { class: "durationContainer" }, _25 = /* @__PURE__ */ J5({
  __name: "MfxTime",
  props: ["hours", "minutes", "seconds", "showSeconds"],
  emits: ["update:hours", "update:minutes", "update:seconds"],
  setup(t, { emit: e }) {
    const r = t, n = u5(""), L = u5(""), i = u5("");
    return g1(n, (l, s) => {
      /^\d+$/.test(l) ? (Number(l) < 0 ? n.value = "0" : Number(l) > 23 && (n.value = "23", L.value = "59"), /^0{3,}/.test(l) && (n.value = l.slice(1)), /^0{2,}\d+|^0\d{2,}/.test(l) && (n.value = l.slice(1)), !/^0\d/.test(l) && Number(l) < 10 && (n.value = "0" + l)) : n.value = /\d+/.test(l) ? s : "", e("update:hours", n.value);
    }), g1(L, (l, s) => {
      /^\d+$/.test(l) ? (Number(l) < 0 ? L.value = "0" : Number(l) >= 60 && (L.value = "59"), /^0{3,}/.test(l) && (L.value = l.slice(1)), /^0{2,}\d+|^0\d{2,}/.test(l) && (L.value = l.slice(1)), !/^0\d/.test(l) && Number(l) < 10 && (L.value = "0" + l)) : L.value = /\d+/.test(l) ? s : "", e("update:minutes", L.value);
    }), g1(i, (l, s) => {
      /^\d+$/.test(l) ? (Number(l) < 0 ? i.value = "0" : Number(l) > 60 && (i.value = "60"), /^0{3,}/.test(l) && (i.value = l.slice(1)), /^0{2,}\d+|^0\d{2,}/.test(l) && (i.value = l.slice(1)), !/^0\d/.test(l) && Number(l) < 10 && (i.value = "0" + l)) : i.value = /\d+/.test(l) ? s : "", e("update:seconds", i.value);
    }), J1(() => {
      n.value = r.hours, L.value = r.minutes, i.value = r.seconds;
    }), (l, s) => (G(), J("div", M25, [
      ne(w("input", {
        "onUpdate:modelValue": s[0] || (s[0] = (c) => n.value = c),
        type: "tel",
        pattern: "[0-9]*",
        inputmode: "numeric",
        novalidate: "",
        placeholder: "hh"
      }, null, 512), [
        [f4, n.value]
      ]),
      O0(" : "),
      ne(w("input", {
        "onUpdate:modelValue": s[1] || (s[1] = (c) => L.value = c),
        type: "tel",
        pattern: "[0-9]*",
        inputmode: "numeric",
        novalidate: "",
        placeholder: "mm"
      }, null, 512), [
        [f4, L.value]
      ]),
      ne(w("span", null, [
        O0(" : "),
        ne(w("input", {
          "onUpdate:modelValue": s[2] || (s[2] = (c) => i.value = c),
          type: "tel",
          pattern: "[0-9]*",
          inputmode: "numeric",
          novalidate: "",
          placeholder: "ss"
        }, null, 512), [
          [f4, i.value]
        ])
      ], 512), [
        [zt, t.showSeconds]
      ])
    ]));
  }
}), M45 = /* @__PURE__ */ U5(_25, [["__scopeId", "data-v-4d0def54"]]), C25 = { class: "backdrop w-full h-full flex justify-center items-center absolute top-0 left-0 -z-1 cy-loading" }, S25 = { class: "flex items-center justify-center bg-bl-panel-color dark:bg-bl-dk-panel-color rounded-panel shadow-md w-96 h-52" }, D25 = /* @__PURE__ */ J5({
  __name: "Loading",
  setup(t) {
    return (e, r) => (G(), J("div", C25, [
      w("div", S25, [
        s5(Z5(oe5), { size: 48 })
      ])
    ]));
  }
}), _L = Er.get(Z0), fe = un({
  theme: A0,
  themeMode: ln,
  screenOrientation: ic,
  isMobile: !1,
  isTablet: !1,
  implantateResponsive: !1,
  saveAttempted: !1,
  saveSuccess: !1,
  saveFailed: !1,
  saveTime: ""
}), E25 = {
  config: g5(() => _L.config.value),
  engineStatus: g5(() => _L.status.value)
}, td = {
  setTheme(t) {
    const e = t.preferDarkMode ? Ui : ln;
    fe.theme = t, fe.themeMode = e, VT(fe.theme, fe.themeMode);
  },
  setThemeMode(t) {
    fe.themeMode = t, Yi(fe.themeMode);
  },
  toggleTheme() {
    fe.themeMode = fe.themeMode === ln ? Ui : ln, Yi(fe.themeMode);
  },
  setIsMobile(t) {
    fe.isMobile = t;
  },
  setIsTablet(t) {
    fe.isTablet = t;
  },
  setImplantateResponsive(t) {
    fe.implantateResponsive = t;
  }
};
g1(
  _L.config,
  (t) => {
    t && t.ui && t.ui && t.ui.theme && td.setTheme(t.ui.theme);
  },
  {
    immediate: !0
  }
);
const Et = () => ({
  state: fe,
  ...E25,
  ...td
}), tr = Er.get(Z0), M1 = un({
  saveCount: 0,
  savedForms: [],
  saving: !1,
  savingDone: !1,
  savingResult: !1,
  showSaving: !1,
  activeIndex: 0,
  activeLanguage: void 0
}), M4 = {
  activeForm: g5(() => tr.forms[M1.activeIndex]),
  forms: g5(() => tr.forms),
  nextForm: g5(
    () => M1.activeIndex + 1 <= tr.forms.length - 1 ? tr.forms[M1.activeIndex + 1] : null
  ),
  previousForm: g5(
    () => M1.activeIndex - 1 >= 0 ? tr.forms[M1.activeIndex - 1] : null
  ),
  languages: g5(
    () => tr.forms[M1.activeIndex].languageCodes ? m4().getAvailableTranslations(
      tr.forms[M1.activeIndex].languageCodes
    ) : []
  ),
  i18n: g5(
    () => M1.activeLanguage ? m4().setTranslation(M1.activeLanguage.value) : m4().defaultLanguage()
  )
};
function I25(t) {
  if (typeof t == "string") {
    let e;
    e = d4().languages.value.filter(
      (r) => r.value.toLowerCase() === t.toLowerCase()
    )[0], e = e || // eslint-disable-next-line no-use-before-define -- Resolve the next time you touch this
    d4().languages.value.filter(
      (r) => r.text.toLowerCase() === t.toLowerCase()
    )[0], e = e || // eslint-disable-next-line no-use-before-define -- Resolve the next time you touch this
    d4().languages.value.filter(
      (r) => r.value.toLowerCase().includes(t.split("-")[0].toLowerCase())
    )[0], e = e || // eslint-disable-next-line no-use-before-define -- Resolve the next time you touch this
    d4().languages.value[0], M1.activeLanguage = e;
  } else
    typeof t == "object" && (M1.activeLanguage = t);
}
let h4;
const rd = {
  setActiveIndex(t) {
    M1.activeIndex = t;
  },
  async save(t = !1) {
    clearTimeout(h4), M1.savedForms.push(M4.activeForm.value.key), M1.saving = !0, t && (M1.showSaving = !0);
    const e = await tr.save(M4.activeForm.value.key, t);
    M1.saveCount++, M1.saving = !1, M1.savingDone = !0, M1.savingResult = e;
  },
  startWatcher() {
    g1(
      () => M4.activeForm.value.response,
      () => {
        h4 && clearTimeout(h4), h4 = setTimeout(rd.save, 300);
      },
      {
        deep: !0
      }
    );
  },
  setActiveLanguage: I25
}, d4 = () => ({
  state: M1,
  ...M4,
  ...rd
}), T25 = { class: "flex h-full max-h-screen overflow-hidden" }, O25 = /* @__PURE__ */ J5({
  __name: "Renderer",
  setup(t) {
    const { smallerOrEqual: e, between: r } = Tz(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Resolve the next time you touch this
      Et().state.theme.breakpoints
    ), { config: n, engineStatus: L } = Et();
    g1(
      e("sm"),
      (s) => {
        Et().setIsMobile(s);
      },
      {
        immediate: !0
      }
    ), g1(
      r("sm", "lg"),
      (s) => {
        Et().setIsTablet(s);
      },
      {
        immediate: !0
      }
    ), g1(
      e("xl"),
      (s) => {
        Et().setImplantateResponsive(s);
      },
      {
        immediate: !0
      }
    );
    const i = () => {
      setTimeout(() => {
        var c;
        const s = document.documentElement.clientWidth < document.documentElement.clientHeight ? ic : z7;
        Et().state.screenOrientation = s, s === z7 && window.innerHeight <= Number((c = Et().state.theme) == null ? void 0 : c.breakpoints.sm.replace("px", "")) && (Et().setIsMobile(!0), Et().setIsTablet(!1));
      });
    };
    J1(() => {
      i(), window.addEventListener("resize", i);
    }), Dn(() => {
      window.removeEventListener("resize", i);
    });
    const l = g5(() => Yw(
      () => {
        var s, c;
        return vz(/* @__PURE__ */ Object.assign({ "./components/layouts/clinical/MainLayout.vue": () => import("./MainLayout-6cb4079a.mjs"), "./components/layouts/proms/MainLayout.vue": () => import("./MainLayout-f4c9df6d.mjs") }), `./components/layouts/${((c = (s = n.value) == null ? void 0 : s.ui) == null ? void 0 : c.layout) || "standard"}/MainLayout.vue`);
      }
    ));
    return (s, c) => (G(), J("div", T25, [
      Z5(L) === "ready" ? (G(), sr(Tl(l.value), { key: 0 })) : (G(), sr(D25, { key: 1 }))
    ]));
  }
});
const _45 = () => Vw(O25);
class V3 {
  constructor(e) {
    q(this, "id");
    this.id = e || this.constructor.name;
  }
}
class C45 extends V3 {
  constructor(r) {
    super("AddItemExtensions");
    q(this, "_list", []);
    this._list = r || [];
  }
  // eslint-disable-next-line @typescript-eslint/require-await -- Resolve the next time you touch this
  async setup(r) {
    this._list.forEach((n) => {
      const L = r.itemMap.get(n.linkId);
      L && (L.extension ? L.extension.push({ ...n }) : L.extension = [{ ...n }]);
    });
  }
}
const z25 = "fhir-questionnaire-response";
class S45 extends V3 {
  constructor(r) {
    super(z25);
    q(this, "_options");
    this._options = r;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Resolve the next time you touch this
  async init(r) {
    const n = `/${this._options.tenantId}/Patient/${this._options.patientId}`, L = await Tu.get(
      `${this._options.fhirUrl}/${this._options.tenantId}/QuestionnaireResponse/?subject=${n}`,
      {
        headers: {
          Authorization: `Bearer ${this._options.accessToken}`
        }
      }
    );
    if (console.log(L.data), L.data && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
    L.data.entry && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Resolve the next time you touch this
    L.data.entry.length > 0) {
      const i = L.data.entry;
      r.responses.push(i[i.length - 1].resource);
    }
  }
}
class D45 extends V3 {
  /**
   * @param delay time in milliseconds
   */
  constructor(r) {
    super("sleep");
    q(this, "_delay");
    this._delay = r || 1e3;
  }
  async init() {
    await new Promise((r) => setTimeout(r, this._delay));
  }
}
const P25 = 1, A25 = P25, E45 = "https://visiontree.com/fhir/questionnaire/layout#column-size", $25 = "https://visiontree.com/fhir/questionnaire/layout#column-position", Z25 = "https://visiontree.com/fhir/questionnaire/layout#repeats-add", N25 = "https://visiontree.com/fhir/questionnaire/layout#repeats-delete";
class I45 {
  constructor(e, r) {
    q(this, "url", "https://visiontree.com/fhir/questionnaire/plugin/enableTree");
    q(this, "valueBoolean");
    q(this, "extension");
    q(this, "linkId");
    this.linkId = e, r ? this.extension = [
      {
        url: "https://visiontree.com/fhir/questionnaire/plugin/enableTree#root",
        valueString: r.root
      },
      {
        url: "https://visiontree.com/fhir/questionnaire/plugin/enableTree#rootValue",
        valueString: r.value
      }
    ] : this.valueBoolean = !0;
  }
}
class T45 {
  constructor(e) {
    q(this, "url", "https://visiontree.com/fhir/form-controls/spine");
    q(this, "valueBoolean", !0);
    q(this, "linkId");
    this.linkId = e;
  }
}
class O45 {
  constructor(e) {
    q(this, "url", "https://visiontree.com/fhir/form-controls/implant");
    q(this, "valueBoolean", !0);
    q(this, "linkId");
    this.linkId = e;
  }
}
class z45 {
  constructor(e, r) {
    q(this, "url", "http://hl7.org/fhir/StructureDefinition/questionnaire-optionExclusive");
    q(this, "valueBoolean", !0);
    q(this, "linkId");
    q(this, "options");
    this.linkId = e, this.options = r;
  }
}
class P45 {
  constructor(e, r) {
    q(this, "url", $25);
    q(this, "valueUnsignedInt", A25);
    q(this, "linkId");
    q(this, "options");
    this.linkId = e, this.options = r, this.valueUnsignedInt = r.columnPosition;
  }
}
class A45 {
  constructor(e) {
    q(this, "url", Z25);
    q(this, "valueBoolean", !0);
    q(this, "linkId");
    this.linkId = e;
  }
}
class $45 {
  constructor(e) {
    q(this, "url", N25);
    q(this, "valueBoolean", !0);
    q(this, "linkId");
    this.linkId = e;
  }
}
const Z45 = Er.get(tL);
export {
  C45 as $,
  K25 as A,
  d45 as B,
  L45 as C,
  a45 as D,
  h45 as E,
  o3 as F,
  V25 as G,
  p45 as H,
  e45 as I,
  a55 as J,
  W25 as K,
  z7 as L,
  U25 as M,
  f45 as N,
  oe5 as O,
  u45 as P,
  b45 as Q,
  m45 as R,
  bi as S,
  X25 as T,
  M45 as U,
  Z45 as V,
  _45 as W,
  k45 as X,
  y45 as Y,
  c45 as Z,
  O25 as _,
  m4 as a,
  z25 as a0,
  S45 as a1,
  D45 as a2,
  P25 as a3,
  A25 as a4,
  E45 as a5,
  $25 as a6,
  Z25 as a7,
  N25 as a8,
  I45 as a9,
  T45 as aa,
  O45 as ab,
  z45 as ac,
  P45 as ad,
  A45 as ae,
  $45 as af,
  i45 as b,
  cc as c,
  Et as d,
  o45 as e,
  J25 as f,
  v45 as g,
  QX as h,
  w45 as i,
  Tz as j,
  n45 as k,
  $O as l,
  t45 as m,
  q25 as n,
  xr5 as o,
  Q25 as p,
  x45 as q,
  hl as r,
  ic as s,
  G25 as t,
  d4 as u,
  Y25 as v,
  r45 as w,
  l45 as x,
  g45 as y,
  s45 as z
};
